function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _to_array(arr) {
    return _array_with_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function _ts_values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  margin-bottom: 0.5rem;\n\n  label {\n    padding-right: 1rem;\n    font-size: 0.875rem;\n    font-weight: 500;\n  }\n\n  .error-message {\n    padding: 0.5rem 0.75rem;\n    margin-top: 0.25rem;\n    font-size: 0.8125rem;\n    color: #d13438;\n    background-color: #fdf3f4;\n    border: 1px solid #f1bbbd;\n    border-radius: 4px;\n  }\n\n  .input-container {\n    position: relative;\n    display: flex;\n    align-items: center;\n  }\n\n  input {\n    height: 40px;\n    padding: 0.5rem;\n    font-size: 0.875rem;\n    font-family: inherit;\n    outline: none;\n    border: 2px solid #d9d9d9;\n    border-radius: 8px;\n    background-color: #ffffff;\n    color: #333;\n    box-sizing: border-box;\n  }\n\n  input[type='password'] {\n    padding-right: 2.5rem;\n  }\n\n  input:focus {\n    border-color: #00bbcc;\n    outline: none;\n  }\n\n  .password-toggle {\n    position: absolute;\n    right: 0.5rem;\n    background: none;\n    border: none;\n    cursor: pointer;\n    padding: 0.25rem;\n    color: #666;\n    border-radius: 4px;\n    margin: 0;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n\n  .password-toggle:hover {\n    color: #00bbcc;\n  }\n\n  p {\n    display: block;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    font-size: 1.125rem;\n  }\n\n  button {\n    padding: 0.25rem;\n    border-radius: 8px;\n    margin-left: auto;\n  }\n\n  button:hover,\n  button.edit-mode {\n    color: #00bbcc;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  margin-bottom: 0.5rem;\n\n  &.stacked {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  label {\n    padding-right: 1rem;\n    font-size: 0.875rem;\n    font-weight: 500;\n  }\n\n  .error-message {\n    padding: 0.5rem 0.75rem;\n    margin-top: 0.25rem;\n    font-size: 0.8125rem;\n    color: #d13438;\n    background-color: #fdf3f4;\n    border: 1px solid #f1bbbd;\n    border-radius: 4px;\n  }\n\n  select {\n    height: 40px;\n    padding: 0.5rem;\n    font-size: 0.875rem;\n    font-family: inherit;\n    outline: none;\n    border: 2px solid #d9d9d9;\n    border-radius: 8px;\n    background-color: #ffffff;\n    color: #333;\n    box-sizing: border-box;\n    appearance: none;\n    -webkit-appearance: none;\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23666' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\");\n    background-repeat: no-repeat;\n    background-position: right 0.5rem center;\n    padding-right: 2rem;\n    cursor: pointer;\n  }\n\n  select:focus {\n    border-color: #00bbcc;\n    outline: none;\n  }\n\n  p {\n    height: 40px;\n    display: flex;\n    align-items: center;\n    font-size: 0.875rem;\n  }\n\n  button {\n    padding: 0.25rem;\n    border-radius: 8px;\n    margin-left: auto;\n    background: none;\n    border: none;\n    cursor: pointer;\n  }\n\n  button:hover,\n  button.edit-mode {\n    color: #00bbcc;\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n\n  label {\n    width: 180px;\n    padding-right: 1rem;\n  }\n\n  p {\n    font-size: 1.125rem;\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  flex: 1;\n  height: 2.25rem;\n  margin-bottom: 1rem;\n  border-radius: 0.5rem;\n  border: 0.125rem solid ",
        ";\n  background: rgba(255, 255, 255, 0.4);\n\n  .search-bar-icon {\n    width: 2.25rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    color: #6b7280;\n  }\n\n  & input {\n    width: 100%;\n    height: 100%;\n    background: none;\n    outline: none;\n    font-size: 0.75rem;\n    font-family: inherit;\n    color: #333;\n    border: none;\n    padding: 0.25rem 0.75rem 0.25rem 0;\n    margin: 0;\n    box-sizing: border-box;\n  }\n\n  & input::placeholder {\n    color: #9ca3af;\n    font-size: 0.75rem;\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  /* Default card */\n  position: relative;\n  padding: 8px;\n  background-color: rgba(255, 255, 255, 0.15) !important;\n  backdrop-filter: blur(12px) saturate(90%);\n  -webkit-backdrop-filter: blur(12px) saturate(90%);\n  border-width: 2px;\n  border-radius: 12px !important;\n  border-style: solid;\n  border-color: rgba(217, 217, 217, 0);\n\n  /* TODO / IMPORTANT: QUESTION THIS WITH ANNA */\n  box-shadow:\n    inset 0 1px 3px rgba(255, 255, 255, 0.3),\n    inset 0 -3px 8px rgba(0, 0, 0, 0.1),\n    0 8px 16px rgba(0, 0, 0, 0.05);\n\n  /* Mirror gloss highlight overlay */\n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border-radius: inherit;\n    background: linear-gradient(\n      135deg,\n      rgba(255, 255, 255, 0) 0%,\n      rgba(255, 255, 255, 0.3) 40%,\n      rgba(255, 255, 255, 0) 70%\n    );\n    opacity: 1;\n    pointer-events: none;\n  }\n\n  /* Outer glow on selection + black shadow */\n  &.selected {\n    border-color: rgba(228, 255, 254, 1);\n    box-shadow:\n      0px 0px 12px 2px rgba(228, 255, 254, 1),\n      0px 2px 5px rgba(0, 0, 0, 0.9);\n    background-color: rgba(255, 255, 255, 0.4) !important;\n  }\n\n  /* Outer glow on hover + dashed border - HIGHEST PRIORITY */\n  &.hovered,\n  &.selected.hovered {\n    /* This is critical - covers hover over selected */\n    border-style: dashed;\n    border-color: rgba(228, 255, 254, 1);\n    background-image: linear-gradient(\n      145deg,\n      rgba(255, 255, 255, 0.15) 0%,\n      rgba(255, 255, 255, 0.1) 50%,\n      rgba(255, 255, 255, 0.05) 100%\n    );\n    box-shadow:\n      0px 0px 12px 3px rgba(228, 255, 254, 1),\n      0px 2px 5px rgba(0, 0, 0, 0.7) !important;\n    transition: all 0.3s ease;\n  }\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  button {\n    flex: 1;\n  }\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex;\n  padding: 0;\n  border: none;\n  border-radius: 50%;\n  background: transparent;\n  cursor: pointer;\n\n  .tl-avatar {\n    box-shadow: ",
        ";\n    transition:\n      box-shadow ",
        " ",
        ",\n      background ",
        " ",
        ";\n  }\n  &:hover .tl-avatar:not(.has-img) {\n    background: ",
        ";\n  }\n  &:hover .tl-avatar {\n    box-shadow: ",
        ";\n  }\n  &:focus-visible {\n    outline: none;\n    box-shadow: ",
        ";\n  }\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  z-index: 99999;\n  width: 100%;\n\n  .custom-dropdown {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex: 1;\n    padding: 8px 16px;\n    border: none;\n    border-radius: 8px;\n    background:\n      linear-gradient(\n        104deg,\n        rgba(255, 255, 255, 0.18) -84.77%,\n        rgba(255, 255, 255, 0) 42.42%,\n        rgba(0, 187, 204, 0.3) 87.58%\n      ),\n      rgba(255, 255, 255, 0.6);\n    cursor: pointer;\n    transition: all 0.2s ease;\n    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);\n    z-index: 999999;\n\n    &:hover {\n      background:\n        linear-gradient(\n          104deg,\n          rgba(255, 255, 255, 0.25) -84.77%,\n          rgba(255, 255, 255, 0) 42.42%,\n          rgba(0, 187, 204, 0.4) 87.58%\n        ),\n        rgba(255, 255, 255, 0.7);\n    }\n  }\n\n  .dropdown-content {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex: 1;\n  }\n\n  .dropdown-icon {\n    width: 24px;\n    height: 24px;\n    color: #242424;\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    svg {\n      width: 24px;\n      height: 24px;\n    }\n  }\n\n  .dropdown-text {\n    flex: 1;\n    font-size: 16px;\n    font-family: 'Segoe UI', Arial, sans-serif;\n    color: #242424;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px;\n  }\n\n  .dropdown-arrow {\n    width: 16px;\n    height: 16px;\n    color: #242424;\n    transition: transform 0.2s ease;\n\n    &.open {\n      transform: rotate(180deg);\n    }\n  }\n\n  /* Default direction (down) */\n  .dropdown-options {\n    position: absolute;\n    top: calc(100% + 4px);\n    left: 0;\n    right: 0;\n    background: #fff;\n    border: 1px solid #e5e7eb;\n    border-radius: 8px;\n    box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.15);\n    z-index: 999999;\n    overflow: hidden;\n    min-width: 100%;\n    max-height: 400px;\n    overflow-y: auto;\n  }\n\n  /* Direction up */\n  &[data-direction='up'] {\n    .dropdown-arrow {\n      &.open {\n        transform: rotate(0deg);\n      }\n\n      &:not(.open) {\n        transform: rotate(180deg);\n      }\n    }\n\n    .dropdown-options {\n      top: auto;\n      bottom: calc(100% + 4px);\n    }\n  }\n\n  .dropdown-option {\n    padding: 12px 16px;\n    cursor: pointer;\n    font-size: 16px;\n    font-family: 'Segoe UI', Arial, sans-serif;\n    color: #242424;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px;\n    transition: background-color 0.2s ease;\n    border-bottom: 1px solid #f3f4f6;\n\n    &:last-child {\n      border-bottom: none;\n    }\n\n    &:hover:not(.disabled) {\n      background-color: #f9fafb;\n    }\n\n    &.disabled {\n      color: #9ca3af;\n      cursor: not-allowed;\n      font-style: italic;\n    }\n  }\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  .field-row {\n    height: 26px;\n    margin: 16px 0;\n    display: flex;\n    align-items: center;\n    font-size: 16px;\n    font-family: 'Segoe UI', Arial, sans-serif;\n    color: #242424;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px;\n    border-bottom: none;\n    position: relative;\n  }\n\n  .field-label {\n    flex: 0 0 180px;\n    font-weight: 400;\n    font-size: 16px;\n    color: #242424;\n    font-family: 'Segoe UI', Arial, sans-serif;\n    font-style: normal;\n    line-height: 20px;\n    flex-shrink: 0;\n  }\n\n  .field-value-container {\n    flex: 1 1 auto;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding-left: 16px;\n    min-width: 0;\n  }\n\n  .field-value {\n    flex: 1 1 auto;\n    font-size: 16px;\n    color: #242424;\n    font-family: 'Segoe UI', Arial, sans-serif;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px;\n    min-width: 0;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .field-input-container {\n    flex: 1 1 auto;\n    display: flex;\n    flex-direction: column;\n    margin-right: 8px;\n    padding-left: 16px;\n  }\n\n  .input-with-icon {\n    position: relative;\n    display: flex;\n    align-items: center;\n    width: 100%;\n  }\n\n  .field-input {\n    flex: 1 1 auto;\n    font-size: 16px;\n    font-family: 'Segoe UI', Arial, sans-serif;\n    color: #242424;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px;\n    padding: 4px 12px;\n    border: 1px solid #ccc;\n    border-radius: 8px;\n    background: #fff;\n    outline: none;\n    min-width: 120px;\n    max-width: 100%;\n    box-sizing: border-box;\n    transition: border-color 0.2s ease;\n\n    &:focus {\n      border-color: #00bbcc;\n      border-width: 2px;\n    }\n\n    &.error {\n      border-color: #d13438;\n      box-shadow: 0 0 0 1px #d13438;\n    }\n  }\n\n  .field-error {\n    font-size: 11px;\n    color: #d13438;\n    margin-top: 1px;\n    font-family: 'Segoe UI', Arial, sans-serif;\n    position: relative;\n    z-index: 10;\n    line-height: 14px;\n  }\n\n  .password-toggle-btn {\n    position: absolute;\n    right: 8px;\n    background: transparent;\n    border: none;\n    color: #242424;\n    cursor: pointer;\n    padding: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 4px;\n    transition: color 0.2s ease;\n\n    &:hover {\n      color: #00bbcc;\n    }\n\n    svg {\n      width: 20px;\n      height: 20px;\n    }\n  }\n\n  .field-value-container .password-toggle-btn {\n    position: static;\n    flex-shrink: 0;\n  }\n\n  .action-btn {\n    background: transparent;\n    border: none;\n    color: #242424;\n    cursor: pointer;\n    padding: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 4px;\n    transition: color 0.2s ease;\n    margin-left: 4px;\n\n    &:hover {\n      color: #00bbcc;\n    }\n\n    svg {\n      width: 20px;\n      height: 20px;\n    }\n  }\n\n  .edit-btn {\n    padding: 0 8px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.6);\n  box-shadow:\n    0px 16px 40px 0px rgba(0, 0, 0, 0.15),\n    0px 4px 16px 0px rgba(0, 0, 0, 0.08);\n  backdrop-filter: blur(50px);\n  overflow: visible;\n  transition: all 0.3s ease;\n  margin-bottom: 12px;\n  padding: ",
        ";\n\n  /* Hover effects */\n  &.hovered {\n    border-color: ",
        ";\n    box-shadow:\n      0 0 12px 3px rgba(0, 187, 204, 0.2),\n      0 2px 12px rgba(0, 0, 0, 0.08);\n    transform: translateY(-1px);\n  }\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  margin: 0;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: ",
        ";\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n"
    ]);
    _templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n\n  .register-head {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: ",
        ";\n  }\n\n  .register-head-actions {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-end;\n    gap: ",
        ";\n  }\n\n  .counts p {\n    margin: 0;\n  }\n\n  .count-primary {\n    font-family: ",
        ";\n    font-size: ",
        ";\n    line-height: ",
        ";\n    color: ",
        ";\n  }\n\n  .count-secondary {\n    margin-top: ",
        ";\n    font-family: ",
        ";\n    font-size: ",
        ";\n    line-height: ",
        ";\n    color: ",
        ";\n  }\n\n  /*\n   * One row: search grows, the two filters take a fixed share.\n   *\n   * Explicit bases on ALL THREE children, which is what this needed. The Select trigger is\n   * full-width, so with only the search box given a basis the selects each claimed the whole line\n   * and the row wrapped into three stacked full-width controls — caught in the Playwright run,\n   * not by any test, because it is purely visual.\n   *\n   * NB no backticks in this comment: it lives inside a styled-components template literal, where\n   * one would terminate the literal. The build catches it; tsc alone does not if it ran earlier.\n   */\n  .register-filters {\n    display: flex;\n    gap: ",
        ";\n    flex-wrap: wrap;\n    align-items: center;\n  }\n\n  .register-filters > *:first-child {\n    flex: 1 1 18rem;\n    min-width: 12rem;\n  }\n\n  .register-filters > *:not(:first-child) {\n    flex: 0 1 13rem;\n  }\n\n  .filter-note {\n    margin: 0;\n    color: ",
        ";\n    font-size: ",
        ";\n    line-height: ",
        ";\n  }\n\n  .asset-name {\n    font-weight: ",
        ";\n  }\n\n  .identifier {\n    font-variant-numeric: tabular-nums;\n  }\n\n  .muted {\n    color: ",
        ";\n  }\n\n  .row-actions {\n    display: inline-flex;\n    gap: ",
        ";\n    justify-content: flex-end;\n  }\n\n  .register-paging {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: ",
        ";\n    font-family: ",
        ";\n    font-size: ",
        ";\n    color: ",
        ";\n    flex-wrap: wrap;\n  }\n\n  /* Why Show all is unavailable, beside the control it explains. No tone of its own — it is an\n     explanation, not a warning: nothing has gone wrong and nothing is at risk. */\n  .show-all-refusal {\n    color: ",
        ";\n  }\n\n  /*\n   * Where the read's own state goes while kept rows hold the table body. Centred like the\n   * Try again button it sits above, so the two read as one answer to one failure.\n   */\n  .register-read-state {\n    margin: 0;\n    padding-top: ",
        ";\n    text-align: center;\n    font-family: ",
        ";\n    font-size: ",
        ";\n    line-height: ",
        ";\n    color: ",
        ";\n  }\n\n  /* Under whichever sentence it answers: the table's own error row when no rows are kept, or\n     the banner above when they are. Token-sourced spacing; no colour of its own — the Button carries\n     the ink.\n\n     NB no backticks in this comment: it lives inside a styled-components template literal, where\n     one would terminate the literal. A comment above says the same thing, and writing this one\n     with them is how it got said a third time. */\n  .register-read-retry {\n    display: flex;\n    justify-content: center;\n    padding-top: ",
        ";\n  }\n"
    ]);
    _templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        "\n  .remove-all {\n    display: flex;\n    flex-direction: column;\n    gap: ",
        ";\n  }\n\n  .choice {\n    display: flex;\n    flex-direction: column;\n    gap: ",
        ";\n  }\n\n  .choice h3 {\n    margin: 0;\n    font-family: ",
        ";\n    font-size: ",
        ";\n    line-height: ",
        ";\n    font-weight: ",
        ";\n    color: ",
        ";\n  }\n\n  .choice p,\n  .footnote {\n    margin: 0;\n    font-family: ",
        ";\n    font-size: ",
        ";\n    line-height: ",
        ";\n    color: ",
        ";\n  }\n\n  .choice-action {\n    display: flex;\n  }\n"
    ]);
    _templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n\n  .asset-form {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(16rem, 1fr));\n    gap: ",
        ";\n    /* The form is long (17 fields); cap it so the dialog's actions stay reachable. Component\n       layout geometry, not a brand value — ratchet rule 8's exemption. */\n    max-height: 60vh;\n    overflow-y: auto;\n  }\n\n  /*\n   * The *Product* group (`register-row-form` R6.2). The same treatment as the composite-measure\n   * editor's *Adds up* group (`CompositeMeasureEditor.tsx`, `.members`): a borderless\n   * `fieldset`, its `legend` in caption-1-strong and secondary ink, `space` tokens between\n   * fields. Built ahead of design by Rob's ruling of 2026-09-28 and owed ratification (design-system\n   * epic \xa76B): the second instance of the treatment, not a new look. Deliberately NOT a shared\n   * fragment — that would edit the composite editor, another surface; when the design project draws\n   * a field group, both instances converge onto it together.\n   *\n   * It spans the form's grid and lays its own fields out on the same grid and tokens, so the fields\n   * inside line up with the ones outside.\n   */\n  .product {\n    grid-column: 1 / -1;\n    margin: 0;\n    padding: 0;\n    border: 0;\n    min-width: 0;\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(16rem, 1fr));\n    gap: ",
        ";\n\n    legend {\n      padding: 0;\n      margin-bottom: ",
        ";\n      color: ",
        ";\n      font: ",
        " ",
        " /\n        ",
        " ",
        ";\n    }\n  }\n\n  /*\n   * NO `.asset-form label` block here, deliberately.\n   *\n   * It used to re-declare the label's font-family and ink from outside the primitive, and won on\n   * specificity — so these 18 labels rendered a different ink from every other `Field` on the\n   * platform. That is the fork pattern ratchet rule 12 exists to stop (multi-agent review,\n   * design-system reviewer). `Field` owns its label typography; if the ink is wrong it is wrong\n   * everywhere, and the fix is a card-02 refresh in `fieldChassis.ts`, not a per-consumer override.\n   * (The font-family half was a no-op anyway — it was already the same token.)\n   */\n"
    ], [
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n\n  .asset-form {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(16rem, 1fr));\n    gap: ",
        ";\n    /* The form is long (17 fields); cap it so the dialog's actions stay reachable. Component\n       layout geometry, not a brand value — ratchet rule 8's exemption. */\n    max-height: 60vh;\n    overflow-y: auto;\n  }\n\n  /*\n   * The *Product* group (\\`register-row-form\\` R6.2). The same treatment as the composite-measure\n   * editor's *Adds up* group (\\`CompositeMeasureEditor.tsx\\`, \\`.members\\`): a borderless\n   * \\`fieldset\\`, its \\`legend\\` in caption-1-strong and secondary ink, \\`space\\` tokens between\n   * fields. Built ahead of design by Rob's ruling of 2026-09-28 and owed ratification (design-system\n   * epic \xa76B): the second instance of the treatment, not a new look. Deliberately NOT a shared\n   * fragment — that would edit the composite editor, another surface; when the design project draws\n   * a field group, both instances converge onto it together.\n   *\n   * It spans the form's grid and lays its own fields out on the same grid and tokens, so the fields\n   * inside line up with the ones outside.\n   */\n  .product {\n    grid-column: 1 / -1;\n    margin: 0;\n    padding: 0;\n    border: 0;\n    min-width: 0;\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(16rem, 1fr));\n    gap: ",
        ";\n\n    legend {\n      padding: 0;\n      margin-bottom: ",
        ";\n      color: ",
        ";\n      font: ",
        " ",
        " /\n        ",
        " ",
        ";\n    }\n  }\n\n  /*\n   * NO \\`.asset-form label\\` block here, deliberately.\n   *\n   * It used to re-declare the label's font-family and ink from outside the primitive, and won on\n   * specificity — so these 18 labels rendered a different ink from every other \\`Field\\` on the\n   * platform. That is the fork pattern ratchet rule 12 exists to stop (multi-agent review,\n   * design-system reviewer). \\`Field\\` owns its label typography; if the ink is wrong it is wrong\n   * everywhere, and the fix is a card-02 refresh in \\`fieldChassis.ts\\`, not a per-consumer override.\n   * (The font-family half was a no-op anyway — it was already the same token.)\n   */\n"
    ]);
    _templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _tagged_template_literal([
        "\n  visibility: hidden;\n  width: auto;\n  background-color: ",
        ";\n  color: ",
        ";\n  text-align: center;\n  border-radius: 6px;\n  padding: 5px 8px;\n  position: absolute;\n  z-index: 100;\n  bottom: calc(100% + 6px);\n  left: 50%;\n  transform: translateX(-50%);\n  opacity: 0;\n  transition:\n    opacity 0.1s,\n    visibility 0.1s;\n  font-size: 12px;\n  ",
        "\n  pointer-events: none;\n  margin-bottom: 4px;\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    margin-left: -6px;\n    border-width: 6px;\n    border-style: solid;\n    border-color: ",
        " transparent transparent transparent;\n  }\n"
    ]);
    _templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  display: ",
        ";\n\n  &:hover > ",
        ", &:focus-within > ",
        " {\n    visibility: visible;\n    opacity: 1;\n  }\n"
    ]);
    _templateObject17 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  padding: 0px 16px 0px 12px;\n  align-items: center;\n  gap: 10px;\n  align-self: stretch;\n  border-radius: 8px 8px 0px 0px;\n  height: 40px;\n  background: transparent;\n\n  &.with-gradient {\n    background: linear-gradient(\n      104deg,\n      rgba(255, 255, 255, 0.18) -84.77%,\n      rgba(255, 255, 255, 0) 42.42%,\n      rgba(0, 187, 204, 0.3) 87.58%\n    );\n  }\n\n  .header-left {\n    display: flex;\n    height: 40px;\n    padding: 9px 2px 11px 2px;\n    align-items: flex-start;\n    flex: 1 0 0;\n    gap: 12px;\n  }\n\n  .header-icon {\n    color: #6b7280;\n    display: flex;\n    align-items: center;\n\n    svg {\n      width: 24px;\n      height: 24px;\n    }\n  }\n\n  .header-title {\n    color: #242424;\n    font-family: 'Segoe UI', Arial, sans-serif;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 22px;\n  }\n\n  .header-close {\n    background: transparent;\n    border: none;\n    color: #6b7280;\n    cursor: pointer;\n    padding: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 20px;\n    height: 20px;\n    transition: color 0.2s ease;\n\n    &:hover {\n      color: #242424;\n    }\n\n    svg {\n      width: 20px;\n      height: 20px;\n      stroke-width: 2px;\n    }\n  }\n"
    ]);
    _templateObject18 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  width: 100%;\n\n  .field-label {\n    font-size: 14px;\n    font-weight: 500;\n    color: #242424;\n    margin: 0;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n\n    .required-indicator {\n      color: #d13438;\n      font-weight: bold;\n    }\n  }\n\n  .field-input-wrapper {\n    position: relative;\n  }\n\n  input,\n  select,\n  textarea {\n    width: 100%;\n    padding: 8px 12px;\n    border: 1px solid #e1e1e1;\n    border-radius: 8px;\n    font-size: 14px;\n    font-family: 'Segoe UI', Arial, sans-serif;\n    background: rgba(255, 255, 255, 0.8);\n    color: #242424;\n    transition: all 0.2s ease;\n    box-sizing: border-box;\n\n    &::placeholder {\n      color: #8a8a8a;\n    }\n\n    &:focus {\n      outline: none;\n      border-color: #00bbcc;\n      background: rgba(255, 255, 255, 0.95);\n      box-shadow: 0 0 0 3px rgba(0, 187, 204, 0.1);\n    }\n\n    &:disabled {\n      background: #f5f5f5;\n      color: #8a8a8a;\n      cursor: not-allowed;\n      opacity: 0.7;\n    }\n\n    &.error {\n      border-color: #d13438;\n      background: rgba(209, 52, 56, 0.05);\n\n      &:focus {\n        border-color: #d13438;\n        box-shadow: 0 0 0 3px rgba(209, 52, 56, 0.1);\n      }\n    }\n  }\n\n  textarea {\n    resize: vertical;\n    min-height: 60px;\n    line-height: 1.4;\n  }\n\n  select {\n    cursor: pointer;\n    appearance: none;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e\");\n    background-position: right 8px center;\n    background-repeat: no-repeat;\n    background-size: 16px;\n    padding-right: 32px;\n  }\n\n  .field-description {\n    font-size: 12px;\n    color: #8a8a8a;\n    margin: 0;\n    line-height: 1.4;\n  }\n\n  .field-error {\n    font-size: 12px;\n    color: #d13438;\n    margin: 0;\n    font-weight: 500;\n    line-height: 1.4;\n  }\n\n  &.has-error {\n    .field-label {\n      color: #d13438;\n    }\n  }\n"
    ]);
    _templateObject19 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _tagged_template_literal([
        "\n  cursor: ",
        ";\n  opacity: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: none;\n  padding: 4px;\n  border-radius: 4px;\n  transition: opacity 0.2s;\n\n  &:hover {\n    opacity: ",
        ";\n  }\n"
    ]);
    _templateObject20 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  margin-bottom: 2rem;\n  /* border: 1px solid red; */\n\n  & .label {\n    margin-right: 0.5rem;\n    /* border: 1px solid blue; */\n  }\n\n  & .content {\n    flex: 1;\n    /* border: 1px solid green; */\n  }\n"
    ]);
    _templateObject21 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  padding: 8px;\n  align-items: center;\n  justify-content: center;\n  white-space: nowrap;\n  border-radius: 16px;\n  border: 1px solid #fff;\n  background: rgba(255, 255, 255, 0.4);\n  box-shadow: 0px 3px 11px 0px rgba(0, 0, 0, 0.05);\n  backdrop-filter: blur(50px);\n  height: 28px;\n  gap: 4px;\n  transition:\n    transform 0.4s ease,\n    background 0.4s ease;\n  flex-shrink: 0;\n  z-index: 1;\n\n  &:hover {\n    cursor: pointer;\n    background: rgba(255, 255, 255, 0.6);\n    transform: scale(1.1);\n    z-index: 10;\n  }\n"
    ]);
    _templateObject22 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _tagged_template_literal([
        "\n  cursor: pointer;\n  color: #c50f1f;\n  font-size: 0.875rem;\n  border-radius: 9999px;\n  padding: 0.5rem;\n  margin-right: 0.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 76px;\n\n  /* Was Tailwind mr-2 on the label. */\n  p {\n    margin-right: 0.5rem;\n  }\n\n  &:hover {\n    color: #d64545;\n  }\n"
    ]);
    _templateObject23 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n"
    ]);
    _templateObject24 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  position: relative;\n  align-items: center;\n  justify-content: center;\n  height: 48px; /* Increased height to allow for zoomed pills */\n  overflow: hidden;\n  flex-wrap: nowrap;\n  white-space: nowrap;\n\n  .filter-pills {\n    display: flex;\n    position: relative;\n    max-width: 600px;\n    overflow-x: auto;\n    gap: 10px;\n    padding: 10px 20px;\n    height: 44px;\n    flex-wrap: nowrap;\n    white-space: nowrap;\n  }\n\n  /* For Chrome, Safari, and Opera */\n  .filter-pills::-webkit-scrollbar {\n    display: none; /* Hide scrollbar for WebKit browsers */\n  }\n\n  /* For Firefox */\n  .filter-pills {\n    scrollbar-width: none; /* Hide scrollbar for Firefox */\n  }\n\n  /* For Internet Explorer 10+ and Edge */\n  .filter-pills {\n    -ms-overflow-style: none; /* Hide scrollbar for Internet Explorer 10+ and Edge */\n  }\n\n  .arrow {\n    padding: 0 10px;\n    transition:\n      transform 0.4s ease,\n      background 0.4s ease;\n  }\n\n  .arrow:hover {\n    transform: scale(1.2);\n  }\n\n  .dots {\n    margin-top: 12px;\n  }\n\n  .dots.right {\n    margin-left: 8px;\n  }\n\n  .dots.left {\n    margin-right: 8px;\n  }\n"
    ]);
    _templateObject25 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _tagged_template_literal([
        "\n  .content {\n    padding: 16px;\n  }\n\n  .rules-section {\n    margin-top: 24px;\n    padding-top: 16px;\n    border-top: 1px solid rgba(255, 255, 255, 0.1);\n  }\n\n  .rules-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 16px;\n  }\n\n  .rules-title {\n    margin: 0;\n    font-size: 16px;\n    font-weight: 600;\n    color: rgba(36, 36, 36, 1);\n  }\n\n  .btn-add-rule {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    width: 100%;\n    margin-top: 16px;\n    padding: 8px 20px;\n    height: 48px;\n    border-radius: 8px;\n    border: 1px solid #fff;\n    background: rgba(255, 255, 255, 0.6);\n    box-shadow:\n      0px 16px 40px 0px rgba(0, 0, 0, 0.15),\n      0px 4px 16px 0px rgba(0, 0, 0, 0.08);\n    backdrop-filter: blur(50px);\n    font-family: 'Segoe UI', Arial, sans-serif;\n    font-size: 16px;\n    color: #242424;\n    font-weight: 400;\n    cursor: pointer;\n    transition: box-shadow 0.2s;\n  }\n\n  .btn-add-rule:hover {\n    box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08);\n  }\n\n  .add-rule-icon-left {\n    display: flex;\n    align-items: center;\n    margin-right: 8px;\n  }\n\n  .add-rule-label {\n    flex: 1;\n    text-align: left;\n  }\n\n  .add-rule-icon-right {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 24px;\n    height: 24px;\n    border: 1.5px solid #242424;\n    border-radius: 50%;\n    margin-left: 8px;\n    font-size: 16px;\n    font-weight: 400;\n  }\n\n  .no-rules-message {\n    text-align: center;\n    padding: 32px;\n    color: rgba(36, 36, 36, 0.6);\n    font-style: italic;\n  }\n\n  .rules-list {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  .rule-row {\n    display: flex;\n    flex-direction: column;\n    border: 1px solid rgba(0, 0, 0, 0.1);\n    border-radius: 12px;\n    background: rgba(255, 255, 255, 0.9);\n    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);\n    margin-bottom: 12px;\n    overflow: hidden;\n  }\n\n  .rule-header {\n    background: rgba(255, 255, 255, 0.95);\n    border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n  }\n\n  .rule-fields {\n    display: flex;\n    flex-direction: column;\n    gap: 0px;\n    padding: 12px 24px 0 24px;\n    border-radius: 0px 0px 8px 8px;\n    background: transparent;\n  }\n"
    ]);
    _templateObject26 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = _tagged_template_literal([
        "\n  margin-bottom: 1rem;\n  background-color: #ebf6f5;\n  padding: 1rem 1rem;\n  border-left: 5px solid #00bbcc;\n\n  p {\n    width: auto;\n    margin-bottom: 0.5rem;\n    text-align: left;\n    font-size: 0.75rem;\n  }\n\n  ul {\n    margin-top: 0.5rem;\n    font-size: 0.75rem;\n  }\n"
    ]);
    _templateObject27 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 1rem;\n  padding: 0.625rem 0.875rem;\n  background-color: rgba(255, 255, 255, 0.4);\n  backdrop-filter: blur(6px);\n  border: 2px solid rgba(255, 255, 255, 0);\n  border-radius: 12px;\n  box-shadow:\n    0px 0px 11px 1px rgba(228, 255, 254, 0.55),\n    0px 3px 11px 0px rgba(0, 0, 0, 0.05);\n  font-size: 0.8125rem;\n  color: #424242;\n\n  .pagination-rows {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n  }\n\n  .pagination-rows label {\n    white-space: nowrap;\n  }\n\n  .pagination-rows select {\n    appearance: none;\n    -webkit-appearance: none;\n    background: rgba(255, 255, 255, 0.6);\n    backdrop-filter: blur(4px);\n    outline: none;\n    border: 1.5px solid rgba(0, 0, 0, 0.08);\n    border-radius: 6px;\n    padding: 0.25rem 1.5rem 0.25rem 0.5rem;\n    font-size: 0.8125rem;\n    color: #242424;\n    cursor: pointer;\n    background-image: url(\"data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1l4 4 4-4' stroke='%23616161' stroke-width='1.5' fill='none' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n    background-repeat: no-repeat;\n    background-position: right 0.4rem center;\n    transition: all 0.15s ease;\n\n    &:hover {\n      background-color: rgba(255, 255, 255, 0.9);\n      border-color: rgba(0, 187, 204, 0.3);\n    }\n\n    &:focus {\n      border-color: #00bccb;\n      box-shadow: 0 0 0 0.125rem rgba(0, 187, 204, 0.2);\n    }\n  }\n\n  .pagination-stepper {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    margin-left: auto;\n  }\n\n  .pagination-stepper label {\n    white-space: nowrap;\n  }\n\n  .pagination-stepper #stepper {\n    display: flex;\n    align-items: center;\n    gap: 0.25rem;\n  }\n\n  .pagination-stepper button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 32px;\n    height: 32px;\n    border: 1.5px solid rgba(0, 0, 0, 0.08);\n    background: rgba(255, 255, 255, 0.6);\n    backdrop-filter: blur(4px);\n    border-radius: 8px;\n    cursor: pointer;\n    color: #424242;\n    transition: all 0.15s ease;\n\n    &:hover:not(.disabled) {\n      background-color: rgba(255, 255, 255, 0.9);\n      border-color: rgba(0, 187, 204, 0.3);\n      color: #00bccb;\n    }\n\n    &:focus-visible {\n      outline: none;\n      border-color: #00bccb;\n      box-shadow: 0 0 0 0.125rem rgba(0, 187, 204, 0.2);\n    }\n\n    &.disabled {\n      color: #c0c0c0;\n      cursor: default;\n      background: rgba(255, 255, 255, 0.25);\n      border-color: rgba(0, 0, 0, 0.04);\n    }\n\n    &.disabled svg {\n      fill: #c0c0c0 !important;\n      color: #c0c0c0 !important;\n    }\n  }\n"
    ]);
    _templateObject28 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = _tagged_template_literal([
        "\n  .image-icon {\n    display: flex;\n    justify-content: center;\n    margin-bottom: 1.5rem;\n  }\n\n  /* Override any parent component icon styles */\n  .image-icon .icon {\n    width: 96px !important;\n    height: 96px !important;\n    margin-right: 0 !important;\n  }\n\n  .image-icon .icon svg {\n    width: 96px !important;\n    height: 96px !important;\n    color: #00bbcc;\n  }\n\n  /* Fallback for direct svg children */\n  .icon svg {\n    width: 96px !important;\n    height: 96px !important;\n    color: #00bbcc;\n  }\n\n  .loading {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .message-bar {\n    margin-bottom: 2rem;\n  }\n\n  h2 {\n    color: #424242;\n    text-align: center;\n    font-size: 1.75rem;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 100%;\n    letter-spacing: -0.308px;\n    margin-bottom: 1rem;\n  }\n\n  p {\n    color: #424242;\n    text-align: center;\n    font-size: 0.875rem;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 150%;\n    letter-spacing: -0.154px;\n    margin-bottom: 2rem;\n  }\n\n  .form-container {\n    width: ",
        ";\n    margin: 0 auto;\n  }\n\n  label {\n    margin-right: auto;\n  }\n\n  input,\n  select {\n    width: 220px;\n  }\n\n  .field {\n    margin-bottom: 2rem;\n  }\n\n  .field label {\n    font-size: 1rem;\n  }\n\n  & button:first-of-type {\n    margin-bottom: 1rem;\n  }\n"
    ]);
    _templateObject29 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  width: 100%;\n  align-items: center;\n\n  .label {\n    color: var(--Neutral-Foreground-1-Rest, #242424);\n    font-family: ",
        ";\n    font-style: normal;\n    font-weight: 350;\n    line-height: 100%;\n  }\n\n  .label small {\n    margin-left: 5px;\n  }\n\n  .indicator {\n    margin-left: auto;\n  }\n"
    ]);
    _templateObject30 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = _tagged_template_literal([
        "\n  .form-container {\n    margin: 0 auto;\n    padding: 1rem;\n  }\n\n  .field-wrapper {\n    padding: 0.5rem;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .field {\n    display: flex;\n    align-items: center;\n    gap: 2px;\n    flex-wrap: wrap;\n  }\n\n  .field > div:not(.inline-buttons):not(.inline-feedback) {\n    flex: 1;\n    min-width: 0;\n  }\n\n  .field .inline-feedback {\n    flex-basis: 100%;\n    width: 100%;\n    margin-top: 0.5rem;\n    order: 10;\n\n    div.fui-MessageBar {\n      margin-bottom: 0.5rem;\n      word-break: break-all;\n      overflow-wrap: break-word;\n    }\n\n    div.fui-MessageBar:last-of-type {\n      margin-bottom: 0;\n    }\n  }\n\n  label {\n    width: 220px;\n    font-weight: bold;\n    flex-shrink: 0;\n  }\n\n  input,\n  select {\n    flex: 1;\n    width: auto;\n    min-width: 254px;\n    height: 36px;\n    padding: 0.5rem;\n    border-radius: 8px;\n    border: 2px solid #d9d9d9;\n    background: #ffffff;\n    outline: none;\n  }\n\n  input:focus,\n  select:focus {\n    border-color: #00bbcc;\n    border-width: 2px;\n  }\n\n  .error-message {\n    margin: 1rem 0;\n  }\n\n  button:not(.inline-buttons button):not(.option-buttons button) {\n    height: 60px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    border-radius: 8px;\n    padding: 0 0.5rem;\n    font-size: 0.75rem;\n    background-color: #ffffff;\n    cursor: pointer;\n\n    .icon {\n      margin-right: 0.5rem;\n    }\n  }\n\n  .inline-buttons,\n  .option-buttons {\n    display: flex;\n    align-items: center;\n    flex-shrink: 0;\n    gap: 8px;\n\n    button {\n      background: none;\n      border: none;\n      width: auto;\n      height: auto;\n      padding: 6px;\n      min-width: 32px;\n      min-height: 32px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n  }\n\n  .option-buttons {\n    width: 40%;\n    display: flex;\n    justify-content: space-between;\n    margin: 0 auto;\n  }\n\n  .form-buttons {\n    margin-top: 2rem;\n    display: flex;\n    justify-content: space-between;\n    button {\n      flex: 1;\n      margin-right: 1rem;\n    }\n    button:last-of-type {\n      margin: 0 0 0 1rem;\n    }\n  }\n\n  &:not(.no-hover) button:hover {\n    color: #00bbcc;\n  }\n  /* &.no-hover button {\n        color: #00bbcc;\n    } */\n\n  .group-inputs {\n    margin: 1rem 0;\n\n    .child-input:first-of-type {\n      margin-bottom: 1rem;\n    }\n\n    .child-input label {\n      display: inline-block;\n    }\n  }\n\n  .group-display {\n    .read-only-label {\n      width: 80px;\n      display: inline-block;\n      font-weight: bold;\n    }\n  }\n"
    ]);
    _templateObject31 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 29px;\n  margin-bottom: 9px;\n\n  .divider-line-left {\n    width: 11.6px;\n    height: 1.45px;\n    background: #e0e0e0;\n    flex-shrink: 0;\n  }\n\n  .divider-line-right {\n    flex: 1;\n    height: 1.45px;\n    background: #e0e0e0;\n  }\n\n  .divider-text {\n    padding: 0 17.4px;\n    color: #242424;\n    font-family: 'Segoe UI', Arial, sans-serif;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 23.2px;\n    white-space: nowrap;\n  }\n"
    ]);
    _templateObject32 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = _tagged_template_literal([
        "\n  .calendar-stepper {\n    width: 311px;\n    margin: 8px 0 0 38px;\n    display: flex;\n  }\n\n  .calendar-stepper p {\n    flex-grow: 1;\n    font-weight: 600;\n    text-align: center;\n  }\n"
    ]);
    _templateObject33 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = _tagged_template_literal([
        "\n  margin-bottom: 1rem;\n\n  .icon {\n    color: #707070;\n    margin-right: 1.5px;\n\n    svg {\n      width: 10px;\n      height: 10px;\n    }\n  }\n"
    ]);
    _templateObject34 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = _tagged_template_literal([
        "\n  p {\n    text-align: left;\n    font-size: 0.875rem;\n    width: auto;\n    margin-bottom: 1rem;\n  }\n\n  & button:first-of-type {\n    margin: 1rem 0;\n  }\n"
    ]);
    _templateObject35 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = _tagged_template_literal([
        "\n  .notifications-header .close-button {\n    padding-bottom: 3px;\n    background-color: #ffffff66;\n    width: 20px;\n    height: 20px;\n    border-radius: 4px;\n  }\n\n  .notifications-header .close-button svg {\n    color: #424242;\n    margin-bottom: 3px;\n  }\n\n  .notifications-header .close-button:hover {\n    background-color: #ffffffcc;\n  }\n\n  .notifications-header .close-button:active svg {\n    background-color: #ffffff;\n  }\n\n  .notifications-header .close-button:active path {\n    stroke: #424242;\n    stroke-width: 1px;\n  }\n\n  .notifications-header {\n    display: flex;\n    padding: 12px;\n    justify-content: space-between;\n    position: relative;\n  }\n\n  .notifications-header:hover {\n    cursor: move;\n  }\n\n  .notifications-header-title {\n    display: flex;\n    gap: 3px;\n  }\n\n  .notifications-header .avatar {\n    width: 20px;\n    height: 20px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n"
    ]);
    _templateObject36 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  width: 244px;\n  box-sizing: border-box;\n  padding: var(--tl-space-4, 16px);\n  gap: var(--tl-space-4, 16px);\n  color: var(--tl-ink-2, #565c66);\n\n  background: linear-gradient(158deg, rgba(255, 255, 255, 0.84), rgba(237, 231, 247, 0.64));\n  backdrop-filter: blur(28px) saturate(120%);\n  -webkit-backdrop-filter: blur(28px) saturate(120%);\n  border: 1px solid rgba(255, 255, 255, 0.72);\n  border-radius: 18px;\n  box-shadow:\n    0 0 12px 1px rgba(228, 255, 254, 0.5),\n    0 14px 34px rgba(0, 0, 0, 0.1);\n\n  .sidebar-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: var(--tl-space-2, 8px);\n  }\n\n  .brand {\n    display: flex;\n    align-items: center;\n    gap: var(--tl-space-3, 12px);\n    min-width: 0;\n  }\n\n  .brand-logo {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 32px;\n    height: 32px;\n    flex: 0 0 auto;\n  }\n\n  .brand-logo img,\n  .brand-logo svg {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n  }\n\n  .brand-text {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n  }\n\n  .brand-title {\n    color: var(--tl-ink, #3f454e);\n  }\n\n  .brand-subtitle {\n    color: var(--tl-ink-4, #7f8691);\n  }\n\n  .collapse-toggle {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 32px;\n    height: 32px;\n    flex: 0 0 auto;\n    border: none;\n    border-radius: var(--tl-radius-md, 8px);\n    background: transparent;\n    color: var(--tl-ink-3, #6d737e);\n    cursor: pointer;\n    transition: background 0.2s ease;\n  }\n\n  .collapse-toggle:hover {\n    background: rgba(255, 255, 255, 0.6);\n  }\n\n  .sidebar-nav {\n    display: flex;\n    flex-direction: column;\n    gap: var(--tl-space-5, 20px);\n    flex: 1 1 auto;\n    overflow-y: auto;\n  }\n\n  .nav-section {\n    display: flex;\n    flex-direction: column;\n    gap: var(--tl-space-1, 4px);\n  }\n\n  .nav-section-label {\n    margin: 0 0 var(--tl-space-1, 4px);\n    padding: 0 var(--tl-space-2, 8px);\n    text-transform: uppercase;\n    letter-spacing: 0.08em;\n    color: var(--tl-ink-4, #7f8691);\n  }\n\n  ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    gap: var(--tl-space-1, 4px);\n  }\n\n  .nav-entry,\n  .cta-entry,\n  .footer-link {\n    display: flex;\n    align-items: center;\n    gap: var(--tl-space-3, 12px);\n    width: 100%;\n    padding: var(--tl-space-2, 8px) var(--tl-space-3, 12px);\n    border: none;\n    border-radius: var(--tl-radius-lg, 12px);\n    background: transparent;\n    color: var(--tl-ink-2, #565c66);\n    font-family: var(--tl-font-sans, inherit);\n    font-size: var(--tl-fs-body1, 14px);\n    font-weight: var(--tl-fw-medium, 500);\n    line-height: var(--tl-lh-body1, 20px);\n    text-align: left;\n    text-decoration: none;\n    cursor: pointer;\n    transition:\n      background 0.2s ease,\n      color 0.2s ease,\n      box-shadow 0.2s ease;\n  }\n\n  .nav-entry:hover,\n  .cta-entry:hover,\n  .footer-link:hover {\n    background: rgba(255, 255, 255, 0.55);\n  }\n\n  .nav-entry:focus-visible,\n  .cta-entry:focus-visible,\n  .footer-link:focus-visible,\n  .collapse-toggle:focus-visible {\n    outline: 2px solid var(--tl-ink, #3f454e);\n    outline-offset: 2px;\n  }\n\n  .nav-icon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 20px;\n    height: 20px;\n    flex: 0 0 auto;\n  }\n\n  .nav-icon svg {\n    width: 20px;\n    height: 20px;\n  }\n\n  .nav-label {\n    flex: 1 1 auto;\n    min-width: 0;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .nav-entry.active,\n  .cta-entry.active {\n    background: var(--tl-brand-gel-idle, linear-gradient(175deg, #6fdbd2, #29c3d8));\n    color: #ffffff;\n    font-weight: var(--tl-fw-semibold, 600);\n    box-shadow: 0 5px 14px rgba(27, 182, 217, 0.32);\n  }\n\n  .nav-entry.active:hover,\n  .cta-entry.active:hover {\n    background: var(--tl-brand-gel-hover, linear-gradient(175deg, #a1e7e0, #29c3d8));\n  }\n\n  /* The CTA entry is always presented as a filled brand action. */\n  .cta-entry {\n    background: var(--tl-brand-gel-idle, linear-gradient(175deg, #6fdbd2, #29c3d8));\n    color: #ffffff;\n    font-weight: var(--tl-fw-semibold, 600);\n    box-shadow: 0 5px 14px rgba(27, 182, 217, 0.32);\n  }\n\n  .cta-entry:hover {\n    background: var(--tl-brand-gel-hover, linear-gradient(175deg, #a1e7e0, #29c3d8));\n  }\n\n  .nav-count {\n    flex: 0 0 auto;\n    min-width: 22px;\n    padding: 0 var(--tl-space-2, 8px);\n    border-radius: var(--tl-radius-pill, 999px);\n    background: var(--tl-surface-2, #edf3fa);\n    color: var(--tl-ink-3, #6d737e);\n    font-size: var(--tl-fs-caption1, 12px);\n    font-weight: var(--tl-fw-semibold, 600);\n    line-height: 20px;\n    text-align: center;\n  }\n\n  .nav-entry.active .nav-count {\n    background: rgba(255, 255, 255, 0.28);\n    color: #ffffff;\n  }\n\n  .nav-count.danger {\n    background: rgba(241, 93, 93, 0.15);\n    color: var(--tl-error-strong, #c50f1f);\n  }\n\n  .sidebar-footer {\n    display: flex;\n    flex-direction: column;\n    gap: var(--tl-space-2, 8px);\n    padding-top: var(--tl-space-3, 12px);\n    border-top: 1px solid rgba(255, 255, 255, 0.6);\n  }\n\n  .footer-links {\n    gap: var(--tl-space-1, 4px);\n  }\n\n  .footer-link {\n    color: var(--tl-ink-3, #6d737e);\n  }\n\n  .user-card {\n    display: flex;\n    align-items: center;\n    gap: var(--tl-space-3, 12px);\n    padding: var(--tl-space-2, 8px);\n  }\n\n  .user-avatar {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 34px;\n    height: 34px;\n    flex: 0 0 auto;\n    border-radius: 50%;\n    background: var(--tl-brand-gel-idle, linear-gradient(175deg, #6fdbd2, #29c3d8));\n    color: #ffffff;\n    font-size: var(--tl-fs-caption1, 12px);\n    font-weight: var(--tl-fw-semibold, 600);\n    overflow: hidden;\n  }\n\n  .user-text {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n  }\n\n  .user-name {\n    color: var(--tl-ink, #3f454e);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .user-role {\n    color: var(--tl-ink-4, #7f8691);\n  }\n\n  /* ---- Collapsed / icon-rail state -------------------------------------\n     Driven entirely by the .collapsed class (JS toggles it via the breakpoint\n     matchMedia listener + the toggle button), so there is a single source of\n     truth — no CSS-only media-query duplicate that could desync from state.\n     Labels, section headings, count pills and user text collapse away; icons\n     stay. */\n  &.collapsed {\n    width: 72px;\n    padding-left: var(--tl-space-2, 8px);\n    padding-right: var(--tl-space-2, 8px);\n  }\n\n  &.collapsed .brand-text,\n  &.collapsed .nav-label,\n  &.collapsed .nav-section-label,\n  &.collapsed .user-text,\n  &.collapsed .nav-count {\n    display: none;\n  }\n\n  &.collapsed .sidebar-header {\n    flex-direction: column;\n    gap: var(--tl-space-2, 8px);\n    align-items: center;\n  }\n\n  &.collapsed .nav-entry,\n  &.collapsed .cta-entry,\n  &.collapsed .footer-link,\n  &.collapsed .user-card {\n    justify-content: center;\n    padding-left: var(--tl-space-2, 8px);\n    padding-right: var(--tl-space-2, 8px);\n  }\n"
    ]);
    _templateObject37 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = _tagged_template_literal([
        "\n  from { opacity: 0; }\n  to { opacity: 1; }\n"
    ]);
    _templateObject38 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = _tagged_template_literal([
        "\n  from { opacity: 1; }\n  to { opacity: 0; }\n"
    ]);
    _templateObject39 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  display: inline-block;\n  color: #aaa;\n\n  .spacer {\n    visibility: hidden;\n    white-space: nowrap;\n  }\n\n  .word {\n    position: absolute;\n    top: 0;\n    left: 0;\n    white-space: nowrap;\n    animation-timing-function: ease-out;\n    animation-fill-mode: forwards;\n  }\n\n  .word.entering {\n    animation-name: ",
        ";\n  }\n\n  .word.exiting {\n    animation-name: ",
        ";\n  }\n"
    ]);
    _templateObject40 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = _tagged_template_literal([
        "\n  .conversation {\n    width: 100%;\n    height: calc(100vh - 210px);\n    overflow: visible;\n    pointer-events: all;\n    margin-right: 30px;\n    min-height: 270px;\n    height: auto;\n    max-height: calc(100vh - 210px);\n  }\n\n  p {\n    margin-bottom: 1rem;\n    color: #424242;\n  }\n\n  .message {\n    max-width: 880px;\n    padding: 0 0 0.25rem 0;\n    margin-bottom: 0.5rem;\n    display: flex;\n  }\n\n  .message .prompt {\n    margin-top: 10px;\n  }\n\n  .message .avatar {\n    width: 20px;\n    height: 20px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    /* Was Tailwind mr-2 on the user avatar. */\n    margin-right: 0.5rem;\n  }\n\n  .message .maria {\n    background: #ffffff;\n    border: 2px solid white;\n    border-radius: 4px;\n    /* Was Tailwind ml-2 on the Maria avatar (overrides the .avatar mr-2 above). */\n    margin-left: 0.5rem;\n    margin-right: 0;\n  }\n\n  .message.no-message {\n    justify-content: flex-end !important;\n  }\n\n  .chat-bubble {\n    font-size: 12px;\n    /* Was Tailwind text-left (default text alignment for bubbles + prompt buttons). */\n    text-align: left;\n  }\n\n  .chat-bubble.error {\n    background-color: rgba(253, 125, 125, 0.4);\n  }\n\n  /* Was Tailwind text-right ml-auto on assistant/loading bubbles. */\n  .chat-bubble.align-right {\n    text-align: right;\n    margin-left: auto;\n  }\n\n  .response {\n    max-width: 640px;\n    padding: 0.5rem;\n    background-color: rgba(255, 255, 255, 0.4);\n    border-radius: 8px;\n    border: 1px solid;\n    border-image-source: linear-gradient(\n      95.98deg,\n      #ffffff 0%,\n      rgba(255, 255, 255, 0.1) 53.32%,\n      rgba(255, 255, 255, 0.5) 100%\n    );\n    white-space: pre-wrap;\n  }\n\n  /* Maria's response words (AITypingMessage). Always visible, never animated.\n     The spans are injected via dangerouslySetInnerHTML and get re-committed on\n     interaction-driven re-renders, so ANY entrance animation here re-triggers\n     on every mouse-move, and any default-hidden state can strand the text\n     invisible. Keep this a plain visibility guard — do NOT add an animation or\n     a hidden resting state (see AITypingMessage / buildChunkedHtml). */\n  .ai-chunk-word {\n    opacity: 1;\n  }\n\n  .ai-entity-link {\n    text-decoration: underline;\n    text-underline-offset: 2px;\n    cursor: pointer;\n    color: inherit;\n  }\n\n  .ai-entity-link:hover {\n    color: var(--main-color, #00bccb);\n  }\n\n  .ai-entity-link:focus-visible {\n    outline: 2px solid var(--main-color, #00bccb);\n    outline-offset: 2px;\n    border-radius: 2px;\n  }\n\n  button.chat-bubble:hover {\n    background-color: #ffffff;\n    cursor: pointer;\n  }\n\n  .feedback {\n    margin-top: 0.5rem;\n    display: flex;\n\n    button {\n      transform: scale(1);\n      transition: transform 0.3s ease;\n    }\n\n    button:focus {\n      outline: none;\n    }\n\n    button:hover .icon svg,\n    button:hover .icon svg path,\n    button:hover .icon svg * {\n      fill: #00bbcc;\n    }\n\n    button:first-of-type {\n      margin-left: auto;\n    }\n\n    button:hover {\n      transform: scale(1.25);\n      animation: bounce 0.4s;\n    }\n\n    @keyframes bounce {\n      0%,\n      20%,\n      50%,\n      80%,\n      100% {\n        transform: scale(1.25);\n      }\n      40% {\n        transform: scale(1.3);\n      }\n      60% {\n        transform: scale(1.2);\n      }\n    }\n  }\n"
    ]);
    _templateObject41 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n"
    ]);
    _templateObject42 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = _tagged_template_literal([
        "\n  flex: 1 1 0%;\n"
    ]);
    _templateObject43 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = _tagged_template_literal([
        "\n  flex-grow: 1;\n  text-align: center;\n  font-weight: 600;\n"
    ]);
    _templateObject44 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject45() {
    var data = _tagged_template_literal([
        "\n  background-color: rgb(255, 255, 255, 0.4);\n  backdrop-filter: blur(6px);\n  border-color: rgb(255, 255, 255, 0);\n  box-shadow:\n    0px 0px 11px 1px rgba(228, 255, 254, 0.55),\n    0px 3px 11px 0px rgba(0, 0, 0, 0.05);\n  position: absolute;\n  width: 100%;\n  height: 100vh;\n  top: 0;\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n\n  .spinner-container {\n    display: flex;\n    justify-content: center;\n  }\n\n  .spinner-title {\n    text-align: center;\n    font-size: 1.25rem;\n    color: #333;\n  }\n\n  .spinner-message {\n    text-align: center;\n    font-size: 0.875rem;\n    margin-top: 1.25rem;\n    color: #666;\n  }\n"
    ]);
    _templateObject45 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject46() {
    var data = _tagged_template_literal([
        "\n  .image-icon {\n    display: flex;\n    justify-content: center;\n    margin-bottom: 1.5rem;\n  }\n\n  .icon svg {\n    width: 72px;\n    height: 72px;\n    color: #00bbcc;\n  }\n\n  h1 {\n    text-align: center;\n    font-size: 1.75rem;\n    font-weight: 500;\n    color: #424242;\n    line-height: 1.3;\n    margin: 0;\n  }\n\n  .copy {\n    text-align: center;\n    color: #424242;\n    font-size: 0.875rem;\n    margin-top: 2rem;\n  }\n\n  a:link,\n  a:visited {\n    color: #00bbcc;\n    text-decoration: underline;\n  }\n\n  button {\n    width: 100%;\n    font-size: 0.875rem !important;\n    height: 58px !important;\n    margin-top: 1rem;\n  }\n\n  .secondary-button {\n    border: 2px solid #d9d9d9;\n    border-radius: 8px;\n    color: #424242;\n  }\n"
    ]);
    _templateObject46 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject47() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  border-radius: 0.5rem;\n\n  th,\n  td {\n    padding: 0.75rem 1rem;\n    text-align: left;\n  }\n\n  th {\n    font-size: 0.875rem;\n  }\n\n  td {\n    font-size: 0.75rem;\n  }\n"
    ]);
    _templateObject47 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject48() {
    var data = _tagged_template_literal([
        "\n  th {\n    background: rgba(255, 255, 255, 0.4);\n    backdrop-filter: blur(6px);\n    box-shadow: 0 0 0.7rem 0.0625rem rgba(228, 255, 254, 0.55);\n    font-size: 0.75rem;\n    font-weight: 600;\n    color: #333;\n    white-space: nowrap;\n  }\n\n  tr:first-child th:first-child {\n    border-top-left-radius: 0.5rem;\n  }\n\n  tr:first-child th:last-child {\n    border-top-right-radius: 0.5rem;\n  }\n"
    ]);
    _templateObject48 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject49() {
    var data = _tagged_template_literal([
        "\n  cursor: pointer;\n  user-select: none;\n  transition: background-color 0.2s ease;\n\n  &:hover {\n    background: rgba(255, 255, 255, 0.6) !important;\n  }\n\n  &:active {\n    background: rgba(255, 255, 255, 0.7) !important;\n  }\n"
    ]);
    _templateObject49 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject50() {
    var data = _tagged_template_literal([
        "\n  tr:last-child td:first-child {\n    border-bottom-left-radius: 0.5rem;\n  }\n\n  tr:last-child td:last-child {\n    border-bottom-right-radius: 0.5rem;\n  }\n"
    ]);
    _templateObject50 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject51() {
    var data = _tagged_template_literal([
        "\n      cursor: pointer;\n    "
    ]);
    _templateObject51 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject52() {
    var data = _tagged_template_literal([
        "\n  background: rgba(255, 255, 255, 0.6);\n  border-bottom: 0.0625rem solid rgba(0, 0, 0, 0.06);\n  transition: background-color 0.15s ease;\n\n  ",
        "\n\n  &:hover {\n    background: rgba(255, 255, 255, 0.8);\n  }\n\n  td {\n    vertical-align: middle;\n  }\n\n  a {\n    color: #242424;\n    text-decoration: underline;\n    transition: color 0.15s ease;\n\n    &:hover {\n      color: #00bbcc;\n    }\n  }\n"
    ]);
    _templateObject52 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject53() {
    var data = _tagged_template_literal([
        "\n  td {\n    text-align: center;\n    padding: 2rem 1rem;\n    color: #666;\n    font-style: italic;\n    background: rgba(255, 255, 255, 0.6);\n  }\n"
    ]);
    _templateObject53 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject54() {
    var data = _tagged_template_literal([
        "\n  color: #dc2626;\n  font-style: normal;\n"
    ]);
    _templateObject54 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject55() {
    var data = _tagged_template_literal([
        "\n  width: 1rem;\n  height: 1rem;\n  cursor: pointer;\n  accent-color: #00bbcc;\n"
    ]);
    _templateObject55 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject56() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.25rem;\n  height: 1.25rem;\n  padding: 0;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  color: #333;\n  font-size: 0.7rem;\n  line-height: 1;\n  transition: transform 0.15s ease;\n  transform: rotate(",
        ");\n\n  &:hover {\n    color: #00bbcc;\n  }\n"
    ]);
    _templateObject56 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject57() {
    var data = _tagged_template_literal([
        "\n  td {\n    background: rgba(255, 255, 255, 0.45);\n    border-bottom: 0.0625rem solid rgba(0, 0, 0, 0.06);\n    padding: 0.5rem 1rem 0.75rem;\n    font-size: 0.75rem;\n    color: #333;\n  }\n"
    ]);
    _templateObject57 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject58() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: 0.375rem;\n"
    ]);
    _templateObject58 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject59() {
    var data = _tagged_template_literal([
        "\n  min-width: 0;\n"
    ]);
    _templateObject59 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject60() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #999;\n  padding: 0.125rem;\n  border-radius: 0.25rem;\n  transition: color 0.2s;\n\n  &:hover {\n    color: #00bbcc;\n  }\n"
    ]);
    _templateObject60 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject61() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  left: calc(100% + 0.375rem);\n  top: 50%;\n  transform: translateY(-50%);\n  background: #00bbcc;\n  color: #fff;\n  font-size: 0.75rem;\n  font-weight: 500;\n  padding: 0.125rem 0.5rem;\n  border-radius: 0.75rem;\n  white-space: nowrap;\n  pointer-events: none;\n  animation: fadeInOut 1.5s ease forwards;\n\n  @keyframes fadeInOut {\n    0% {\n      opacity: 0;\n      transform: translateY(-50%) scale(0.9);\n    }\n    15% {\n      opacity: 1;\n      transform: translateY(-50%) scale(1);\n    }\n    70% {\n      opacity: 1;\n    }\n    100% {\n      opacity: 0;\n    }\n  }\n"
    ]);
    _templateObject61 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject62() {
    var data = _tagged_template_literal([
        "\n  display: inline-block;\n  padding: 0.25rem 0.625rem;\n  border-radius: 0.75rem;\n  font-size: 0.75rem;\n  font-weight: 500;\n  white-space: nowrap;\n  text-transform: uppercase;\n"
    ]);
    _templateObject62 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject63() {
    var data = _tagged_template_literal([
        "\n  .thead {\n    display: flex;\n    background-color: #d9d9d9;\n    border-top-left-radius: 8px;\n    border-top-right-radius: 8px;\n    padding: 0.25rem 0;\n  }\n\n  .thead div {\n    font-weight: 600;\n  }\n\n  .thead div,\n  table tbody td {\n    font-size: 0.875rem;\n    padding: 0.25rem 0.5rem;\n    word-wrap: break-word;\n    overflow-wrap: break-word;\n    white-space: normal;\n  }\n\n  /* 1st column */\n  .thead div:nth-child(1),\n  table tbody td:nth-child(1) {\n    width: 200px;\n  }\n\n  /* 2nd column */\n  .thead div:nth-child(2),\n  table tbody td:nth-child(2) {\n    width: 250px;\n  }\n\n  /* 3rd column */\n  .thead div:nth-child(3),\n  table tbody td:nth-child(3) {\n    width: 150px;\n  }\n\n  /* 4th column */\n  .thead div:nth-child(4),\n  table tbody td:nth-child(4) {\n    width: 150px;\n  }\n\n  /* 5th column */\n  .thead div:nth-child(5),\n  table tbody td:nth-child(5) {\n    width: 150px;\n  }\n\n  table tbody td:nth-child(6) {\n    text-align: right;\n  }\n\n  table tbody td button {\n    margin-right: 2rem;\n  }\n\n  table tbody td a {\n    margin: 0 1rem;\n  }\n\n  table {\n    width: 100%;\n    background-color: #d9d9d9;\n    border-top-left-radius: 8px;\n    border-top-right-radius: 8px;\n  }\n\n  tbody tr {\n    background-color: #ffffff;\n    border-bottom: 2px #f8f7f6 solid;\n  }\n\n  tbody td a:link,\n  tbody td a:visited {\n    color: #424242;\n    margin: 0;\n  }\n\n  tbody td a:hover,\n  tbody td a:active,\n  tbody td a:focus,\n  tbody td button:hover,\n  tbody td button:active,\n  tbody td button:focus {\n    color: #00bbcc;\n  }\n\n  table tbody td:last-of-type a:last-of-type {\n    margin-right: 2rem;\n  }\n\n  tbody td.no-records {\n    text-align: center;\n  }\n"
    ]);
    _templateObject63 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject64() {
    var data = _tagged_template_literal([
        "\n  .legal-header {\n    margin: 0 auto 0.5rem auto;\n    width: 60%;\n  }\n\n  .legal-header .btn-back {\n    background: #ffffff;\n    border: 1px #cccccc solid;\n    color: #2d2d2d;\n    width: 120px;\n    padding: 0.25rem;\n  }\n\n  .legal-layout {\n    display: flex;\n    flex-direction: column;\n    height: 100vh;\n    padding: 2rem;\n  }\n\n  .legal-panel {\n    margin: 0 auto;\n    width: 60%;\n    background: #fcfcfb;\n    border: 1px #cccccc solid;\n    border-radius: 18px; /* Standard */\n    -webkit-border-radius: 18px; /* For older Safari and Chrome */\n    -moz-border-radius: 18px; /* For older Firefox */\n    padding: 4rem;\n    height: 90vh;\n    overflow-y: scroll;\n  }\n"
    ]);
    _templateObject64 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject65() {
    var data = _tagged_template_literal([
        "\n  & h1,\n  & h2,\n  & h3 {\n    line-height: 1.3;\n    margin: 1.75rem 0 0.75rem;\n  }\n  & h1 {\n    font-size: 1.5rem;\n  }\n  & h2 {\n    font-size: 1.25rem;\n  }\n  & h3 {\n    font-size: 1.1rem;\n  }\n  & p {\n    margin: 0 0 1rem;\n  }\n  & ul,\n  & ol {\n    margin: 0 0 1rem;\n    padding-left: 1.5rem;\n  }\n  & li {\n    margin: 0 0 0.35rem;\n  }\n  & a {\n    color: #00838f;\n    text-decoration: underline;\n  }\n  & table {\n    width: 100%;\n    border-collapse: collapse;\n    margin: 0 0 1.25rem;\n    font-size: 0.9rem;\n  }\n  & th,\n  & td {\n    border: 1px solid #d0d0d0;\n    padding: 0.5rem 0.65rem;\n    text-align: left;\n    vertical-align: top;\n  }\n  & th {\n    background: #f6f6f6;\n  }\n"
    ]);
    _templateObject65 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject66() {
    var data = _tagged_template_literal([
        "\n  color: #6b6b6b;\n  font-size: 0.9rem;\n"
    ]);
    _templateObject66 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject67() {
    var data = _tagged_template_literal([
        "\n  min-height: 100vh;\n  background: #ffffff;\n  color: #1a1a1a;\n  overflow-y: auto;\n\n  .legal-doc {\n    max-width: 48rem;\n    margin: 0 auto;\n    padding: 2.5rem 1.5rem 4rem;\n    font-size: 1rem;\n    line-height: 1.6;\n  }\n\n  .legal-doc__head {\n    border-bottom: 1px solid #e5e5e5;\n    padding-bottom: 1.25rem;\n    margin-bottom: 1.75rem;\n  }\n\n  .legal-doc__title {\n    font-size: 1.75rem;\n    font-weight: 700;\n    margin: 0 0 0.5rem;\n  }\n\n  .legal-doc__meta {\n    color: #6b6b6b;\n    font-size: 0.875rem;\n    margin: 0;\n  }\n\n  .legal-doc__banner {\n    margin-top: 1rem;\n    padding: 0.75rem 1rem;\n    background: #fff4e5;\n    border: 1px solid #f0c58a;\n    border-radius: 8px;\n    font-size: 0.9rem;\n    color: #7a4b00;\n  }\n\n  .legal-doc__banner a {\n    color: #7a4b00;\n    text-decoration: underline;\n  }\n\n  .legal-doc__print {\n    margin-top: 1.25rem;\n    padding: 0.5rem 1rem;\n    font-size: 0.875rem;\n    color: #00838f;\n    background: #ffffff;\n    border: 1.5px solid #00bbcc;\n    border-radius: 8px;\n    cursor: pointer;\n  }\n\n  .legal-doc__print:hover:not(:disabled) {\n    background: #e6fbfd;\n  }\n\n  .legal-doc__print:disabled {\n    opacity: 0.5;\n    cursor: default;\n  }\n\n  /* Screen typography for the document body lives in the shared @repo/ui LegalDocumentBody; only\n     the print overrides (which target the same .legal-doc__body classes it renders) remain here. */\n\n  /* First print stylesheet in the repo: a clean, complete black-on-white document. */\n  @media print {\n    min-height: 0;\n\n    .legal-doc {\n      max-width: none;\n      padding: 0;\n      font-size: 11pt;\n      color: #000;\n    }\n    .legal-doc__print,\n    .legal-doc__banner {\n      display: none;\n    }\n    .legal-doc__body table,\n    .legal-doc__body li {\n      break-inside: avoid;\n    }\n    .legal-doc__body h1,\n    .legal-doc__body h2,\n    .legal-doc__body h3 {\n      break-after: avoid;\n    }\n    a {\n      color: #000;\n      text-decoration: underline;\n    }\n  }\n\n  @page {\n    margin: 20mm;\n  }\n"
    ]);
    _templateObject67 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject68() {
    var data = _tagged_template_literal([
        "\n  .panel-layout {\n    min-height: 100vh;\n    padding: 5rem 0;\n  }\n\n  .panel {\n    margin: 0 auto;\n    width: 506px;\n    background: #fcfcfb;\n    border: 1px #cccccc solid;\n    border-radius: 18px; /* Standard */\n    -webkit-border-radius: 18px; /* For older Safari and Chrome */\n    -moz-border-radius: 18px; /* For older Firefox */\n    padding: 4rem;\n  }\n\n  .panel h1 {\n    font-size: 1.65rem;\n    text-align: center;\n    line-height: 120%;\n  }\n"
    ]);
    _templateObject68 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject69() {
    var data = _tagged_template_literal([
        "\n  .image-icon {\n    display: flex;\n    justify-content: center;\n    margin-bottom: 1.5rem;\n  }\n\n  h2 {\n    color: #424242;\n    text-align: center;\n    font-size: 1.75rem;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 100%;\n    letter-spacing: -0.308px;\n    margin-bottom: 1rem;\n  }\n\n  p {\n    color: #424242;\n    text-align: center;\n    font-size: 0.875rem;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 150%;\n    letter-spacing: -0.154px;\n    margin-bottom: 2rem;\n  }\n"
    ]);
    _templateObject69 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject70() {
    var data = _tagged_template_literal([
        "\n  fieldset {\n    border: none;\n    margin: 0;\n    padding: 0;\n  }\n\n  .field {\n    margin-bottom: 1rem;\n  }\n\n  .field label {\n    font-size: 0.875rem;\n  }\n\n  label {\n    width: 220px;\n    flex-shrink: 0;\n  }\n\n  p,\n  input:not([type='checkbox']),\n  select {\n    width: 220px;\n  }\n\n  p {\n    color: #424242;\n    text-align: center;\n    font-size: 1rem;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 100%;\n    letter-spacing: -0.154px;\n    margin-bottom: 0;\n  }\n\n  .link-field {\n    display: flex;\n    align-items: center;\n    margin-bottom: 2rem;\n  }\n\n  .link-field label {\n    width: 180px;\n    padding-right: 1rem;\n  }\n\n  .link-field p {\n    font-weight: bold;\n  }\n\n  .link-field a:link,\n  .link-field a:visited {\n    padding: 0.25rem;\n    border-radius: 8px;\n    margin-left: auto;\n  }\n\n  .link-field a:hover {\n    color: #00bbcc;\n  }\n\n  .admin-form-buttons {\n    display: flex;\n    gap: 1rem;\n    justify-content: flex-end;\n  }\n"
    ]);
    _templateObject70 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject71() {
    var data = _tagged_template_literal([
        "\n  .error {\n    color: #ff000d;\n    text-align: center;\n    margin-top: 1rem;\n  }\n"
    ]);
    _templateObject71 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject72() {
    var data = _tagged_template_literal([
        "\n  // Nothing here atm\n"
    ]);
    _templateObject72 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject73() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject73 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject74() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject74 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject75() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject75 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject76() {
    var data = _tagged_template_literal([
        "\n  .header {\n    margin-bottom: 1rem;\n  }\n\n  .header h2 {\n    margin: 0;\n    font-size: 1.5rem;\n    font-weight: 600;\n  }\n\n  .controls {\n    display: flex;\n    gap: 1rem;\n  }\n\n  .button {\n    order: 2;\n    display: flex;\n    align-items: center;\n    height: 54px;\n    padding: 0 1rem;\n    background-color: #00bbcc;\n    color: #ffffff;\n    border-radius: 8px;\n    text-decoration: none;\n    font-size: 0.875rem;\n    font-weight: 500;\n    white-space: nowrap;\n\n    &:hover {\n      background-color: #009daa;\n    }\n\n    .icon {\n      display: flex;\n      margin-right: 0.5rem;\n    }\n  }\n\n  .users-table {\n    margin-bottom: 2rem;\n  }\n"
    ]);
    _templateObject76 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject77() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  pointer-events: all;\n  border-radius: 6px;\n  border: 1px solid var(--Neutral-Stroke-1-Glass2, #fff);\n  background: var(--Neutral-Background-Transparent-Rest, rgba(255, 255, 255, 0));\n\n  .copilot-bubbles {\n    color: var(--main-color); /* #00BCCB; */\n    margin-right: 0.5rem;\n  }\n\n  form {\n    display: flex;\n    flex-grow: 1;\n    align-items: center;\n    border-radius: 6px;\n    padding: 6px;\n  }\n\n  input[type='text'] {\n    width: 100%;\n    margin-left: 0.5rem;\n    font-size: 14px;\n    background: none;\n    border: none;\n    outline: none;\n  }\n\n  input[type='submit'] {\n    cursor: pointer;\n  }\n\n  .submit-button,\n  .cancel-button {\n    background-color: rgba(255, 255, 255, 0.4);\n    width: 20px;\n    height: 20px;\n    border-radius: 4px;\n    cursor: pointer;\n  }\n\n  .submit-button svg {\n    color: rgba(36, 36, 36, 1);\n    width: 20px;\n    height: 18px;\n  }\n\n  .submit-button:disabled {\n    background-color: rgba(255, 255, 255, 0.4);\n  }\n\n  .submit-button:disabled path {\n    fill: rgba(36, 36, 36, 0.5);\n  }\n\n  .submit-button:not([disabled]):hover {\n    background-color: rgba(255, 255, 255, 0.8);\n  }\n\n  .submit-button:not([disabled]):hover svg {\n    color: rgba(36, 36, 36, 0.8);\n  }\n\n  .submit-button:not([disabled]):active {\n    background-color: rgba(255, 255, 255, 1);\n  }\n\n  .submit-button:not([disabled]):active svg {\n    color: rgba(36, 36, 36, 1);\n    stroke: #424242;\n    stroke-width: 1px;\n  }\n\n  .submit-button:not([disabled]):active path {\n    stroke: #424242;\n    stroke-width: 0.5px;\n  }\n\n  .cancel-button svg {\n    margin-left: 3px;\n    width: 12px;\n    height: 12px;\n  }\n\n  .cancel-button:active {\n    background-color: rgba(255, 255, 255, 1) !important;\n  }\n\n  .cancel-button:hover {\n    background-color: rgba(255, 255, 255, 0.8) !important;\n  }\n\n  .cancel-button:active svg {\n    color: rgba(36, 36, 36, 1);\n    border-radius: 4px;\n    width: 14px;\n    height: 14px;\n    margin-left: 2px;\n  }\n"
    ]);
    _templateObject77 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject78() {
    var data = _tagged_template_literal([
        "\n  padding: 0 12px 12px 12px;\n  width: 880px;\n  pointer-events: all;\n\n  .ai-disclaimer {\n    margin: 6px 0 0;\n    text-align: center;\n    font-size: 11px;\n    color: rgba(36, 36, 36, 0.6);\n  }\n"
    ]);
    _templateObject78 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject79() {
    var data = _tagged_template_literal([
        "\n  .maria-header .close-button {\n    padding-bottom: 3px;\n    background-color: #ffffff66;\n    width: 20px;\n    height: 20px;\n    border-radius: 4px;\n  }\n\n  .maria-header .close-button svg {\n    color: #424242;\n    margin-bottom: 3px;\n  }\n\n  .maria-header .close-button:hover {\n    background-color: #ffffffcc;\n  }\n\n  .maria-header .close-button:active svg {\n    background-color: #ffffff;\n  }\n\n  .maria-header .close-button:active path {\n    stroke: #424242;\n    stroke-width: 1px;\n  }\n\n  .maria-header {\n    display: flex;\n    padding: 12px;\n    justify-content: space-between;\n    position: relative;\n  }\n\n  .maria-header:hover {\n    cursor: move;\n  }\n\n  .maria-header-title {\n    display: flex;\n    gap: 3px;\n  }\n\n  .maria-header .avatar {\n    width: 20px;\n    height: 20px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n"
    ]);
    _templateObject79 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject80() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  z-index: 99999;\n  opacity: 1;\n  transition: opacity 0.25s ease-in-out;\n  width: 364px;\n  pointer-events: auto;\n\n  &.fade-in {\n    opacity: 1;\n  }\n\n  &.fade-out {\n    opacity: 0;\n  }\n\n  .back-panel {\n    position: absolute;\n    z-index: -9999;\n    width: 364px;\n    height: 580px;\n    margin-top: -20px;\n\n    border-radius: 30px;\n    background: rgba(255, 255, 255, 0.7);\n    box-shadow:\n      0.804px 0.804px 6.432px 0px rgba(255, 255, 255, 0.08),\n      1.608px 1.608px 46.632px 0px rgba(228, 255, 255, 0.15) inset;\n    filter: blur(100px);\n  }\n\n  .pointer-wrapper {\n    position: relative;\n    padding: ",
        ";\n  }\n\n  .pointer-wrapper {\n    .glass-pin {\n      width: 26px;\n      display: block;\n      position: absolute;\n    }\n\n    .glass-pin svg {\n      width: 100%;\n      height: 100%;\n    }\n\n    .pos-1 {\n      top: 0;\n      left: 50%;\n      transform: translate(-50%, 0);\n    }\n\n    .pos-2 {\n      top: 0;\n      left: 75%;\n      transform: translate(75, 0);\n    }\n\n    .pos-3 {\n      top: 0;\n      right: 0;\n      rotate: 45deg;\n    }\n\n    .pos-4 {\n      top: 25%;\n      right: 0;\n      transform: translateY(-25%) rotate(90deg);\n    }\n\n    .pos-5 {\n      top: 50%;\n      right: 0;\n      transform: translateY(-50%) rotate(90deg);\n    }\n\n    .pos-6 {\n      top: 75%;\n      right: 0;\n      transform: translateY(-75%) rotate(90deg);\n    }\n\n    .pos-7 {\n      bottom: 0;\n      right: 0;\n      rotate: 135deg;\n    }\n\n    .pos-8 {\n      bottom: 0;\n      right: 25%;\n      transform: translateX(-25%) rotate(180deg);\n    }\n\n    .pos-9 {\n      bottom: 0;\n      left: 50%;\n      transform: translate(50%, 0);\n      rotate: 180deg;\n    }\n\n    .pos-10 {\n      bottom: 0;\n      left: 25%;\n      transform: translate(25%, 0);\n      rotate: 180deg;\n    }\n\n    .pos-11 {\n      bottom: 0;\n      left: 0;\n      rotate: 225deg;\n    }\n\n    .pos-12 {\n      top: 75%;\n      left: 0;\n      transform: translateY(-75%) rotate(270deg);\n    }\n\n    .pos-13 {\n      top: 50%;\n      left: 0;\n      transform: translateY(-50%) rotate(270deg);\n    }\n\n    .pos-14 {\n      top: 25%;\n      left: 0;\n      transform: translateY(-25%) rotate(270deg);\n    }\n\n    .pos-15 {\n      top: 0;\n      left: 0;\n      rotate: 315deg;\n    }\n\n    .pos-16 {\n      top: 0;\n      left: 25%;\n    }\n  }\n\n  .card {\n    width: 280px;\n    margin: 0 auto;\n    padding: 1rem;\n    border-radius: 12px;\n    background: rgba(255, 255, 255, 0.16);\n    box-shadow:\n      0.852px 0.852px 6.816px 0px rgba(255, 255, 255, 0.08) inset,\n      1.704px 1.704px 49.413px 0px rgba(228, 255, 255, 0.15);\n    backdrop-filter: blur(17.8px);\n    transition: opacity 0.5s ease-in-out;\n  }\n\n  .card-header {\n    display: flex;\n    justify-content: center;\n    align-items: flex-start;\n  }\n\n  .header {\n    margin-bottom: 1rem;\n    font-size: 1rem;\n    font-style: normal;\n    font-weight: 350;\n    line-height: 150%;\n    color: #242424;\n  }\n\n  .close-tutorial {\n    padding: 0.125rem;\n    margin-left: auto;\n  }\n\n  .copy p {\n    margin-bottom: 1rem;\n    font-size: 0.75rem;\n    font-style: normal;\n    font-weight: 350;\n    line-height: 150%;\n    color: #242424;\n  }\n\n  .controls {\n    display: flex;\n    justify-content: space-between;\n\n    button {\n      padding: 0.5rem;\n      width: 45%;\n      border-radius: 8px;\n    }\n\n    button.primary {\n      margin-left: auto;\n      background-color: #00bbcc;\n      color: #ffffff;\n      cursor: pointer;\n    }\n\n    button.primary.disabled {\n      background: #cccccc;\n      color: #242424;\n    }\n\n    button.secondary {\n      border: 2px #bfbfbf solid;\n      background-color: rgba(255, 255, 255, 0.5);\n    }\n\n    button.secondary:hover {\n      background-color: rgba(255, 255, 255, 0.8);\n    }\n  }\n"
    ]);
    _templateObject80 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject81() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  z-index: 9999;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100vh;\n  pointer-events: none;\n"
    ]);
    _templateObject81 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject82() {
    var data = _tagged_template_literal([
        "\n  padding: 0;\n  width: 100%;\n  max-height: 600px;\n  display: flex;\n  flex-direction: column;\n\n  .detail-header {\n    padding: 16px;\n    border-bottom: 1px solid #eee;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n  }\n\n  .detail-header-info {\n    flex: 1;\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n  }\n\n  .header-text {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .detail-title {\n    margin: 0;\n    font-size: 16px;\n    font-weight: 600;\n    color: #333;\n  }\n\n  .detail-time {\n    font-size: 12px;\n    color: #666;\n    margin-top: 2px;\n    display: block;\n  }\n\n  .detail-content {\n    padding: 16px;\n    flex: 1;\n    overflow-y: auto;\n  }\n\n  .twin-chip {\n    display: inline-block;\n    font-size: 11px;\n    color: #00838f;\n    background-color: #e0f7fa;\n    border-radius: 10px;\n    padding: 1px 8px;\n    margin-bottom: 12px;\n  }\n\n  .scenario-findings {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n\n    .finding-row {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      gap: 8px;\n      width: 100%;\n      text-align: left;\n      padding: 8px 10px;\n      border: 1px solid #e0e0e0;\n      border-radius: 4px;\n      background-color: #fafafa;\n      cursor: pointer;\n      font-size: 13px;\n      transition: all 0.15s ease;\n\n      &:hover {\n        border-color: #00bbcc;\n        background-color: #f0feff;\n      }\n    }\n\n    .finding-label {\n      color: #333;\n      font-weight: 500;\n    }\n\n    .finding-util {\n      color: #666;\n      white-space: nowrap;\n    }\n  }\n\n  .detail-summary,\n  .detail-message {\n    margin-bottom: 20px;\n  }\n\n  .detail-summary h4,\n  .detail-message h4 {\n    margin: 0 0 8px 0;\n    font-size: 14px;\n    font-weight: 600;\n    color: #333;\n  }\n\n  .detail-summary p,\n  .detail-message p {\n    margin: 0;\n    font-size: 14px;\n    color: #555;\n    line-height: 1.4;\n  }\n\n  .detail-meta {\n    border-top: 1px solid #eee;\n    padding-top: 16px;\n  }\n\n  .meta-item {\n    display: flex;\n    align-items: center;\n    margin-bottom: 8px;\n    font-size: 13px;\n\n    strong {\n      color: #333;\n      margin-right: 8px;\n      min-width: 80px;\n    }\n  }\n\n  .type-badge {\n    padding: 0.25rem 0.625rem;\n    border-radius: 0.75rem;\n    font-size: 0.75rem;\n    text-transform: uppercase;\n    font-weight: 500;\n  }\n\n  .action-button {\n    padding: 4px 8px;\n    border: 1px solid #ddd;\n    background-color: #fff;\n    color: #555;\n    font-size: 11px;\n    border-radius: 3px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    white-space: nowrap;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n\n    &:hover {\n      color: #00bbcc;\n      font-weight: 500;\n      background-color: #ffffff;\n      border-color: #00bbcc;\n    }\n  }\n"
    ]);
    _templateObject82 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject83() {
    var data = _tagged_template_literal([
        "\n  padding: 0;\n  width: 100%;\n  max-height: 600px;\n  display: flex;\n  flex-direction: column;\n\n  .tab-container {\n    display: flex;\n    border-bottom: 1px solid #eee;\n  }\n\n  .tab {\n    flex: 1;\n    padding: 12px 0;\n    border: none;\n    background: none;\n    cursor: pointer;\n    font-size: 14px;\n    color: #666;\n    transition: all 0.2s ease;\n    border-bottom: 2px solid transparent;\n    text-align: center;\n\n    &:hover {\n      border-bottom-color: #cccccc;\n    }\n\n    &.active {\n      color: #00bbcc;\n      border-bottom-color: #00bbcc;\n    }\n  }\n\n  .bulk-actions {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 8px;\n    padding: 8px 16px;\n    border-bottom: 1px solid #eee;\n  }\n\n  .mark-all-confirmation {\n    font-size: 12px;\n    color: #2e7d32;\n    margin-right: auto;\n  }\n\n  .mark-all-error {\n    font-size: 12px;\n    color: #c0392b;\n    margin-right: auto;\n  }\n\n  .action-button.mark-all-read {\n    &:disabled {\n      opacity: 0.5;\n      cursor: default;\n    }\n  }\n\n  .notifications-list {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    overflow-y: auto;\n  }\n\n  /* Twin chip (org-wide bell): attributes each alert to its twin at a glance. */\n  .twin-chip {\n    display: inline-block;\n    font-size: 11px;\n    color: #00838f;\n    background-color: #e0f7fa;\n    border-radius: 10px;\n    padding: 1px 8px;\n    margin-bottom: 6px;\n  }\n\n  /* Structured, clickable equipment list for scenario notifications (FR5). */\n  .scenario-findings {\n    list-style: none;\n    margin: 0 0 6px 0;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n\n    .finding-row {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      gap: 8px;\n      width: 100%;\n      text-align: left;\n      padding: 6px 8px;\n      border: 1px solid #e0e0e0;\n      border-radius: 4px;\n      background-color: #fafafa;\n      cursor: pointer;\n      font-size: 12px;\n      transition: all 0.15s ease;\n\n      &:hover {\n        border-color: #00bbcc;\n        background-color: #f0feff;\n      }\n    }\n\n    .finding-label {\n      color: #333;\n      font-weight: 500;\n    }\n\n    .finding-util {\n      color: #666;\n      white-space: nowrap;\n    }\n  }\n\n  .loading-state,\n  .empty-state {\n    color: #666;\n    text-align: center;\n    padding: 40px 16px;\n    font-style: italic;\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .notification-item {\n    padding: 12px 16px;\n    border-bottom: 1px solid #eee;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n\n    &:hover {\n      background-color: #f5f5f5;\n    }\n\n    &:last-child {\n      border-bottom: none;\n    }\n  }\n\n  .notification-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    margin-bottom: 4px;\n  }\n\n  .notification-header-text {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n  }\n\n  .notification-title {\n    font-weight: 600;\n    font-size: 14px;\n    color: #333;\n  }\n\n  .notification-time {\n    font-size: 12px;\n    color: #666;\n  }\n\n  /* Re-consent notices (FR7): pinned, action-required styling; distinct from twin notifications\n     and not clickable-into-detail (they have no detail view). */\n  .notification-item.legal-notice {\n    cursor: default;\n    background-color: #fff8ec;\n    border-left: 3px solid #f0a500;\n\n    &:hover {\n      background-color: #fff3dd;\n    }\n\n    .notification-type.action-required {\n      background-color: #f0a500;\n      color: #fff;\n    }\n\n    /* Show the full message — it is the call to action (no 2-line clamp). */\n    .notification-description {\n      display: block;\n      -webkit-line-clamp: none;\n      overflow: visible;\n    }\n\n    .action-button.accept-notice {\n      color: #fff;\n      background-color: #00bbcc;\n      border-color: #00bbcc;\n      font-weight: 500;\n\n      &:hover:not(:disabled) {\n        background-color: #00a5b4;\n      }\n\n      &:disabled {\n        opacity: 0.6;\n        cursor: default;\n      }\n    }\n  }\n\n  .notice-error {\n    color: #c0392b;\n    font-size: 12px;\n    padding: 8px 16px;\n  }\n\n  .notification-description {\n    font-size: 13px;\n    color: #555;\n    margin-bottom: 6px;\n    line-height: 1.3;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n  }\n\n  .notification-type {\n    font-size: 11px;\n    text-transform: uppercase;\n    padding: 4px 8px;\n    border-radius: 4px;\n    font-weight: bold;\n  }\n\n  .notification-actions {\n    display: flex;\n    gap: 6px;\n    margin-top: 8px;\n    justify-content: flex-end;\n  }\n\n  .action-button {\n    padding: 4px 8px;\n    border: 1px solid #ddd;\n    background-color: #fff;\n    color: #555;\n    font-size: 11px;\n    border-radius: 3px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    white-space: nowrap;\n\n    &:hover {\n      background-color: #f8f8f8;\n      border-color: #ccc;\n    }\n\n    &.mark-read {\n      &:hover {\n        color: #00bbcc;\n        font-weight: 500;\n        background-color: #ffffff;\n        border-color: #00bbcc;\n      }\n    }\n\n    &.mark-unread {\n      &:hover {\n        color: #00bbcc;\n        font-weight: 500;\n        background-color: #ffffff;\n        border-color: #00bbcc;\n      }\n    }\n  }\n"
    ]);
    _templateObject83 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject84() {
    var data = _tagged_template_literal([
        "\n  .loading-state {\n    padding: 0.75rem 1rem;\n    background: rgba(255, 255, 255, 0.9);\n    border: 1px solid rgba(0, 0, 0, 0.1);\n    border-radius: 8px;\n    color: #666;\n    font-size: 0.875rem;\n    text-align: center;\n  }\n"
    ]);
    _templateObject84 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject85() {
    var data = _tagged_template_literal([
        "\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: ",
        ";\n  box-sizing: border-box;\n"
    ]);
    _templateObject85 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject86() {
    var data = _tagged_template_literal([
        "\n  pointer-events: auto;\n"
    ]);
    _templateObject86 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject87() {
    var data = _tagged_template_literal([
        "\n  .scrollable-container {\n    padding-right: 20px;\n  }\n\n  .dashboard-header {\n    display: flex;\n    align-items: center;\n    margin-bottom: 0.5rem;\n  }\n\n  /*\n   * FR2 'sceneOverlay' — click-through in the gaps, clickable on the content.\n   *\n   * TWO rules, and BOTH are load-bearing in opposite directions: without the first the\n   * scene cannot be orbited at all, and without the second the dashboard cannot be clicked\n   * at all. BIDashboard.surface.test.tsx kills each one separately for that reason.\n   *\n   * The cell rule reaches through the renderer's own grid container by its\n   * data-dashboard-slug attribute rather than by a class this file owns. That is\n   * deliberate: giving each cell pointer-events auto is a HOST CHROME decision about the\n   * scene behind it, and routing it through the renderer would mean the renderer growing a\n   * surface mode — the layout capability this row exists to not build.\n   *\n   * A FRAMELESS cell (chrome \"none\", ops-clear-selection FR3) is excluded from the second rule\n   * and stays click-through: it has no card for the pointer to land on, so the scene beside a\n   * floating control must keep taking clicks and drags. The component inside opts its own\n   * controls back in (ShowWholeTwin does, on its button). No backticks in here: this comment\n   * sits inside the styled-components template literal.\n   */\n  .scene-overlay {\n    pointer-events: none;\n  }\n\n  .scene-overlay > .dashboard-header,\n  .scene-overlay [data-dashboard-slug] > *:not([data-chrome='none']) {\n    pointer-events: auto;\n  }\n"
    ]);
    _templateObject87 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject88() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  height: ",
        ";\n  border-radius: 3px;\n  background-image: ",
        ";\n"
    ]);
    _templateObject88 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject89() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject89 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject90() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 0.75rem;\n\n  input,\n  select {\n    font-family: ",
        ";\n    font-size: 13px;\n    padding: 5px 8px;\n    border: 1px solid ",
        ";\n    border-radius: 8px;\n    background: ",
        ";\n    color: ",
        ";\n  }\n  input {\n    min-width: 12rem;\n  }\n"
    ]);
    _templateObject90 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject91() {
    var data = _tagged_template_literal([
        "\n  background: ",
        ";\n  backdrop-filter: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 12px;\n  box-shadow: ",
        ";\n  padding: 16px 16px 12px;\n"
    ]);
    _templateObject91 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject92() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n"
    ]);
    _templateObject92 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject93() {
    var data = _tagged_template_literal([
        "\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  color: ",
        ";\n"
    ]);
    _templateObject93 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject94() {
    var data = _tagged_template_literal([
        "\n  font-size: 12px;\n  line-height: 16px;\n  color: ",
        ";\n"
    ]);
    _templateObject94 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject95() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex: 0 0 auto;\n"
    ]);
    _templateObject95 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject96() {
    var data = _tagged_template_literal([
        "\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 16px;\n  border-radius: 16px;\n  padding: 3px 10px;\n  background: ",
        ";\n  color: ",
        ";\n  white-space: nowrap;\n"
    ]);
    _templateObject96 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject97() {
    var data = _tagged_template_literal([
        "\n  font-size: 12px;\n  line-height: 16px;\n  color: ",
        ";\n  padding-left: 4px;\n  white-space: nowrap;\n"
    ]);
    _templateObject97 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject98() {
    var data = _tagged_template_literal([
        "\n  font-size: 12px;\n  line-height: 16px;\n  color: ",
        ";\n  margin-left: 8px;\n  align-self: center;\n  white-space: nowrap;\n"
    ]);
    _templateObject98 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject99() {
    var data = _tagged_template_literal([
        "\n  display: grid;\n  grid-template-columns: ",
        ";\n  gap: 8px;\n  padding: 0 8px 6px;\n  border-bottom: 1px solid ",
        ";\n  font-size: 10px;\n  font-weight: 500;\n  letter-spacing: 0.06em;\n  color: ",
        ";\n"
    ]);
    _templateObject99 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject100() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    _templateObject100 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject101() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject101 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject102() {
    var data = _tagged_template_literal([
        "\n  color: ",
        ";\n  font-size: 13px;\n  padding: 12px 8px;\n"
    ]);
    _templateObject102 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject103() {
    var data = _tagged_template_literal([
        "\n  display: grid;\n  grid-template-columns: ",
        ";\n  gap: 8px;\n  align-items: center;\n  padding: 0 8px;\n  border-radius: 6px;\n  border-bottom: 1px solid ",
        ";\n  min-height: 30px;\n\n  &:hover {\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject103 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject104() {
    var data = _tagged_template_literal([
        "\n  min-width: 0;\n"
    ]);
    _templateObject104 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject105() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-top: 14px;\n  padding-top: 12px;\n  border-top: 1px solid ",
        ";\n  font-size: 11px;\n  color: ",
        ";\n"
    ]);
    _templateObject105 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject106() {
    var data = _tagged_template_literal([
        "\n  font-size: 10px;\n  font-weight: 500;\n  letter-spacing: 0.06em;\n"
    ]);
    _templateObject106 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject107() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n"
    ]);
    _templateObject107 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject108() {
    var data = _tagged_template_literal([
        "\n  width: 12px;\n  height: 12px;\n  border-radius: 3px;\n  background: ",
        ";\n"
    ]);
    _templateObject108 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject109() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex;\n  margin-left: auto;\n  border: 1px solid ",
        ";\n  border-radius: 8px;\n  overflow: hidden;\n"
    ]);
    _templateObject109 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject110() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  font-size: 13px;\n  font-weight: 500;\n  padding: 5px 12px;\n  border: none;\n  cursor: pointer;\n  color: ",
        ";\n  background: ",
        ";\n\n  & + & {\n    border-left: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject110 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject111() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n"
    ]);
    _templateObject111 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject112() {
    var data = _tagged_template_literal([
        "\n  flex: 0 0 14px;\n  align-self: stretch;\n  border-left: 1px solid ",
        ";\n"
    ]);
    _templateObject112 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject113() {
    var data = _tagged_template_literal([
        "\n  flex: 0 0 auto;\n  width: 14px;\n  height: 14px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  margin: 0;\n  border: none;\n  background: none;\n  cursor: pointer;\n  color: ",
        ";\n\n  svg {\n    width: 12px;\n    height: 12px;\n  }\n"
    ]);
    _templateObject113 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject114() {
    var data = _tagged_template_literal([
        "\n  flex: 0 0 auto;\n  width: 14px;\n"
    ]);
    _templateObject114 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject115() {
    var data = _tagged_template_literal([
        "\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: ",
        ";\n\n  svg {\n    width: 15px;\n    height: 15px;\n  }\n"
    ]);
    _templateObject115 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject116() {
    var data = _tagged_template_literal([
        "\n  font-size: 13px;\n  font-weight: ",
        ";\n  color: ",
        ";\n  white-space: nowrap;\n"
    ]);
    _templateObject116 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject117() {
    var data = _tagged_template_literal([
        "\n  font-size: 11px;\n  line-height: 14px;\n  color: ",
        ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"
    ]);
    _templateObject117 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject118() {
    var data = _tagged_template_literal([
        "\n  font-size: 11px;\n  white-space: nowrap;\n\n  a {\n    color: ",
        ";\n    text-decoration: none;\n  }\n  a:hover {\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject118 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject119() {
    var data = _tagged_template_literal([
        "\n  min-width: 0;\n"
    ]);
    _templateObject119 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject120() {
    var data = _tagged_template_literal([
        "\n  display: inline-block;\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 14px;\n  border-radius: 16px;\n  padding: 2px 7px;\n  border: 1px solid ",
        ";\n  color: ",
        ";\n  background: ",
        ";\n"
    ]);
    _templateObject120 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject121() {
    var data = _tagged_template_literal([
        "\n  min-width: 0;\n  font-size: 11px;\n  line-height: 14px;\n  color: ",
        ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding-right: 8px;\n"
    ]);
    _templateObject121 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject122() {
    var data = _tagged_template_literal([
        "\n  color: ",
        ";\n  margin: 0 5px;\n"
    ]);
    _templateObject122 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject123() {
    var data = _tagged_template_literal([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject123 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject124() {
    var data = _tagged_template_literal([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject124 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject125() {
    var data = _tagged_template_literal([
        "\n  position: fixed;\n  z-index: ",
        ";\n  pointer-events: none;\n  opacity: ",
        ";\n  transition: opacity ",
        "ms ",
        ";\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n  }\n"
    ]);
    _templateObject125 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject126() {
    var data = _tagged_template_literal([
        "\n  position: fixed;\n  z-index: ",
        ";\n  box-sizing: border-box;\n  pointer-events: none;\n  transform-origin: top left;\n  /* Its own compositing layer: the grow and shrink are transform-only, so the frame is rasterised\n     once rather than repainted every animation frame at up to 1500 px wide. */\n  will-change: transform;\n  /* The tile's own outer radius — the zoom is the same object, bigger. */\n  border-radius: ",
        ";\n  box-shadow: ",
        ";\n"
    ]);
    _templateObject126 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject127() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  inset: 0;\n  z-index: 1;\n  padding: 0;\n  border: none;\n  background: transparent;\n  cursor: zoom-in;\n  border-radius: ",
        ";\n\n  /* The ring is drawn on the picture's Feed — see its :has(...) rule — because Inner clips this box. */\n  &:focus-visible {\n    outline: none;\n  }\n"
    ]);
    _templateObject127 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject128() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  inset: 0;\n  z-index: ",
        ";\n  cursor: grab;\n\n  &:active {\n    cursor: grabbing;\n  }\n"
    ]);
    _templateObject128 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject129() {
    var data = _tagged_template_literal([
        "\n  position: fixed;\n  top: 0;\n  left: -10000px;\n  width: 1px;\n  height: 1px;\n  pointer-events: none;\n"
    ]);
    _templateObject129 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject130() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  inset: 0;\n  z-index: 3;\n  padding: 0;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  border-radius: ",
        ";\n\n  /* The ring is drawn on the picture's Feed — see its :has(...) rule — because Inner clips this box. */\n  &:focus-visible {\n    outline: none;\n  }\n"
    ]);
    _templateObject130 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject131() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  min-width: 0;\n"
    ]);
    _templateObject131 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject132() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject132 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject133() {
    var data = _tagged_template_literal([
        "\n    background: ",
        ";\n    border-color: #fff;\n    box-shadow: ",
        ";\n  "
    ]);
    _templateObject133 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject134() {
    var data = _tagged_template_literal([
        '\n    background: rgba(255, 255, 255, 0.7);\n    border-color: rgba(255, 255, 255, 0.95);\n    /* The status page\'s fading "just arrived" glow, in the just-changed colour. */\n    box-shadow: ',
        ";\n  "
    ]);
    _templateObject134 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject135() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  padding: 5px 5px 0;\n  border-radius: ",
        ";\n  background: rgba(255, 255, 255, 0.55);\n  border: 1.5px solid rgba(255, 255, 255, 0.85);\n  box-shadow: 0 1px 2px rgba(",
        ", 0.06);\n  cursor: grab;\n  transition:\n    background ",
        " ",
        ",\n    box-shadow ",
        " ",
        ",\n    opacity ",
        " ",
        ",\n    border-color ",
        " ",
        ";\n\n  /* Hover is the IDLE tile's look only: selected and arrived win over it (arrived over selected too,\n     for its 1.2 s — see `look` below), and dragging wins over everything (spec R3). So it is scoped\n     by the look rather than left to out-rank them on specificity, which a bare :hover (0,2,0) would\n     against the look's own class (0,1,0). It is the status page's dashed frost line\n     (`semantic.status.hover`): an outline laid over the 1.5px border by its negative offset, so it\n     takes no layout space and neither this tile nor its neighbours move. */\n  &[data-look='idle']:hover {\n    background: rgba(255, 255, 255, 0.8);\n    border-color: rgba(255, 255, 255, 0.95);\n    outline: ",
        " ",
        " ",
        ";\n    outline-offset: -",
        ";\n  }\n  &:not([data-look='dragging']):hover [data-placement-hint] {\n    opacity: 1;\n  }\n\n  ",
        "\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n  }\n"
    ], [
        "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  padding: 5px 5px 0;\n  border-radius: ",
        ";\n  background: rgba(255, 255, 255, 0.55);\n  border: 1.5px solid rgba(255, 255, 255, 0.85);\n  box-shadow: 0 1px 2px rgba(",
        ", 0.06);\n  cursor: grab;\n  transition:\n    background ",
        " ",
        ",\n    box-shadow ",
        " ",
        ",\n    opacity ",
        " ",
        ",\n    border-color ",
        " ",
        ";\n\n  /* Hover is the IDLE tile's look only: selected and arrived win over it (arrived over selected too,\n     for its 1.2 s — see \\`look\\` below), and dragging wins over everything (spec R3). So it is scoped\n     by the look rather than left to out-rank them on specificity, which a bare :hover (0,2,0) would\n     against the look's own class (0,1,0). It is the status page's dashed frost line\n     (\\`semantic.status.hover\\`): an outline laid over the 1.5px border by its negative offset, so it\n     takes no layout space and neither this tile nor its neighbours move. */\n  &[data-look='idle']:hover {\n    background: rgba(255, 255, 255, 0.8);\n    border-color: rgba(255, 255, 255, 0.95);\n    outline: ",
        " ",
        " ",
        ";\n    outline-offset: -",
        ";\n  }\n  &:not([data-look='dragging']):hover [data-placement-hint] {\n    opacity: 1;\n  }\n\n  ",
        "\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n  }\n"
    ]);
    _templateObject135 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject136() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  inset: 0;\n  z-index: 4;\n"
    ]);
    _templateObject136 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject137() {
    var data = _tagged_template_literal([
        "\n  from { opacity: 0; transform: scale(0.96); }\n  to   { opacity: 1; transform: scale(1); }\n"
    ]);
    _templateObject137 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject138() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  cursor: zoom-out;\n  /* In the styled template, not an inline `style`: an inline `zoomIn.getName()` names keyframes\n     styled-components never injects (it emits a keyframes block only when one is interpolated into\n     a template). */\n  animation: ",
        " ",
        "ms ",
        " both;\n\n  /* The panel is ALREADY at the feed's native ratio (see expandedRectFor), so the picture inside\n     must fill it — letterboxing it a second time would shrink a 4:3 camera to a small island.\n     Scoped by attribute so it cannot catch the absolutely positioned actions overlay. */\n  > [data-camera-wall-expanded-tile] {\n    width: 100%;\n    height: 100%;\n  }\n\n  @media (prefers-reduced-motion: reduce) {\n    animation: none !important;\n  }\n"
    ], [
        "\n  position: absolute;\n  cursor: zoom-out;\n  /* In the styled template, not an inline \\`style\\`: an inline \\`zoomIn.getName()\\` names keyframes\n     styled-components never injects (it emits a keyframes block only when one is interpolated into\n     a template). */\n  animation: ",
        " ",
        "ms ",
        " both;\n\n  /* The panel is ALREADY at the feed's native ratio (see expandedRectFor), so the picture inside\n     must fill it — letterboxing it a second time would shrink a 4:3 camera to a small island.\n     Scoped by attribute so it cannot catch the absolutely positioned actions overlay. */\n  > [data-camera-wall-expanded-tile] {\n    width: 100%;\n    height: 100%;\n  }\n\n  @media (prefers-reduced-motion: reduce) {\n    animation: none !important;\n  }\n"
    ]);
    _templateObject138 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject139() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  top: ",
        ";\n  right: ",
        ";\n  z-index: 1;\n  display: flex;\n  gap: ",
        ";\n"
    ]);
    _templateObject139 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject140() {
    var data = _tagged_template_literal([
        "\n  width: 32px;\n  height: 32px;\n  border: none;\n  border-radius: ",
        ";\n  background: rgba(255, 255, 255, 0.72);\n  backdrop-filter: ",
        ";\n  -webkit-backdrop-filter: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: ",
        ";\n  color: ",
        ";\n  cursor: pointer;\n  transition: all ",
        " ",
        ";\n\n  &:hover {\n    background: rgba(255, 255, 255, 0.92);\n    box-shadow: ",
        ";\n  }\n  &:focus-visible {\n    outline: none;\n    box-shadow: var(--tl-focus-tight);\n  }\n"
    ]);
    _templateObject140 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject141() {
    var data = _tagged_template_literal([
        "\n  border-radius: ",
        ";\n  background: ",
        ";\n  backdrop-filter: ",
        ";\n  -webkit-backdrop-filter: ",
        ";\n  border: 1px solid ",
        ";\n  box-shadow: ",
        ";\n  padding: ",
        ";\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  /* border-box is the preflight's default, restated so 'fill' does not depend on a host importing it:\n     without it the padding and border would push the card past its host. */\n  ",
        "\n"
    ]);
    _templateObject141 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject142() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  padding: 0 ",
        ";\n  flex-wrap: wrap;\n"
    ]);
    _templateObject142 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject143() {
    var data = _tagged_template_literal([
        "\n  font-size: ",
        ";\n  line-height: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject143 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject144() {
    var data = _tagged_template_literal([
        "\n  font-size: ",
        ";\n  line-height: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject144 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject145() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex;\n  align-items: center;\n  height: 20px;\n  padding: 0 ",
        ";\n  border-radius: ",
        ";\n  background: rgba(228, 255, 254, 0.75);\n  border: 1px solid rgba(255, 255, 255, 0.9);\n  color: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    _templateObject145 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject146() {
    var data = _tagged_template_literal([
        "\n  flex: 1;\n"
    ]);
    _templateObject146 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject147() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  padding: 0 ",
        ";\n  flex-wrap: wrap;\n"
    ]);
    _templateObject147 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject148() {
    var data = _tagged_template_literal([
        "\n  width: 1px;\n  height: 20px;\n  background: ",
        ";\n  margin: 0 ",
        ";\n"
    ]);
    _templateObject148 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject149() {
    var data = _tagged_template_literal([
        "\n  height: 1px;\n  background: ",
        ";\n  margin: 0 ",
        ";\n"
    ]);
    _templateObject149 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject150() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  ",
        "\n\n  /* In the list panel the body fills the panel under its header, inset like the header. */\n  &.is-list-panel {\n    padding: ",
        " 0 ",
        " ",
        ";\n  }\n"
    ]);
    _templateObject150 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject151() {
    var data = _tagged_template_literal([
        "\n  height: 100%;\n\n  /* `useRowMotion` places the gap a moved tile leaves in this element's CONTENT coordinates, so the\n     element it measures and scrolls must be the positioned one (`camera-feeds-page-wall`). */\n  .scroll-content {\n    position: relative;\n  }\n  ",
        "\n"
    ], [
        "\n  height: 100%;\n\n  /* \\`useRowMotion\\` places the gap a moved tile leaves in this element's CONTENT coordinates, so the\n     element it measures and scrolls must be the positioned one (\\`camera-feeds-page-wall\\`). */\n  .scroll-content {\n    position: relative;\n  }\n  ",
        "\n"
    ]);
    _templateObject151 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject152() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  min-width: 0;\n"
    ]);
    _templateObject152 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject153() {
    var data = _tagged_template_literal([
        "\n  font-size: ",
        ";\n  line-height: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject153 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject154() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject154 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject155() {
    var data = _tagged_template_literal([
        "\n  grid-column: 1 / -1;\n  display: flex;\n  align-items: center;\n  padding: ",
        " ",
        " ",
        ";\n\n  &:first-child {\n    padding-top: 0;\n  }\n"
    ]);
    _templateObject155 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject156() {
    var data = _tagged_template_literal([
        "\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n"
    ]);
    _templateObject156 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject157() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    _templateObject157 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject158() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n"
    ]);
    _templateObject158 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject159() {
    var data = _tagged_template_literal([
        "\n  min-width: 0;\n"
    ]);
    _templateObject159 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject160() {
    var data = _tagged_template_literal([
        "\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(",
        ", 1fr));\n  gap: ",
        ";\n"
    ]);
    _templateObject160 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject161() {
    var data = _tagged_template_literal([
        "\n  position: fixed;\n  inset: 0;\n  z-index: ",
        ";\n"
    ]);
    _templateObject161 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject162() {
    var data = _tagged_template_literal([
        "\n  position: fixed;\n  cursor: zoom-out;\n"
    ]);
    _templateObject162 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject163() {
    var data = _tagged_template_literal([
        "\n  position: fixed;\n  box-sizing: border-box;\n  transform-origin: top left;\n  will-change: transform;\n  border-radius: ",
        ";\n  box-shadow: ",
        ";\n\n  > :first-child {\n    width: 100%;\n    height: 100%;\n  }\n"
    ]);
    _templateObject163 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject164() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  top: ",
        ";\n  right: ",
        ";\n  z-index: 5;\n  display: flex;\n  flex-direction: row-reverse;\n  align-items: center;\n  gap: ",
        ";\n"
    ]);
    _templateObject164 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject165() {
    var data = _tagged_template_literal([
        "\n  width: 32px;\n  height: 32px;\n  border: none;\n  border-radius: ",
        ";\n  background: ",
        ";\n  backdrop-filter: ",
        ";\n  -webkit-backdrop-filter: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: ",
        ";\n  color: ",
        ";\n  cursor: pointer;\n  transition: all ",
        " ",
        ";\n\n  &:hover {\n    box-shadow: ",
        ";\n  }\n  &:focus-visible {\n    outline: none;\n    box-shadow: var(--tl-focus-tight);\n  }\n"
    ]);
    _templateObject165 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject166() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  box-sizing: border-box;\n  width: 100%;\n  padding: ",
        ";\n  border-radius: ",
        ";\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  box-shadow: 0 1px 2px ",
        ";\n  transition:\n    background-color ",
        " ",
        ",\n    box-shadow ",
        " ",
        ",\n    border-color ",
        " ",
        ";\n\n  &[data-open] {\n    background: ",
        ";\n    border-color: ",
        ";\n    box-shadow:\n      0 1px 2px ",
        ",\n      0 0 0 3px ",
        ",\n      0 10px 28px ",
        ";\n  }\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none;\n  }\n\n  .tl-cc-head {\n    display: flex;\n    align-items: center;\n    gap: ",
        ";\n    min-width: 0;\n  }\n\n  .tl-cc-sticker {\n    flex: none;\n    width: ",
        ";\n    height: ",
        ";\n    box-sizing: border-box;\n    border-radius: ",
        ";\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    border: ",
        " solid ",
        ";\n    box-shadow: 0 2px 8px ",
        ";\n  }\n  &[data-tone='error'] .tl-cc-sticker {\n    background: ",
        ";\n    color: ",
        ";\n  }\n  &[data-tone='fixed'] .tl-cc-sticker {\n    background: ",
        ";\n    color: ",
        ";\n  }\n  &[data-tone='info'] .tl-cc-sticker {\n    background: ",
        ";\n    color: ",
        ";\n    box-shadow:\n      0 0 0 1px ",
        ",\n      0 2px 8px ",
        ";\n  }\n\n  .tl-cc-text {\n    flex: 1 1 auto;\n    min-width: 0;\n  }\n\n  .tl-cc-title {\n    margin: 0;\n    font: ",
        ";\n    color: ",
        ";\n  }\n\n  .tl-cc-where {\n    margin: 2px 0 0;\n    font: ",
        ";\n    color: ",
        ";\n  }\n\n  .tl-cc-pair {\n    flex: none;\n    display: inline-flex;\n    align-items: center;\n    gap: ",
        ";\n    color: ",
        ";\n    font: ",
        ";\n    white-space: nowrap;\n  }\n\n  .tl-cc-value {\n    display: inline-flex;\n    align-items: center;\n    height: ",
        ";\n    padding: ",
        ";\n    border-radius: ",
        ";\n    font: ",
        ";\n  }\n  .tl-cc-value[data-kind='found'] {\n    background: ",
        ";\n    color: ",
        ";\n  }\n  .tl-cc-value[data-kind='use'] {\n    background: ",
        ";\n    color: ",
        ";\n  }\n\n  .tl-cc-arrow {\n    display: inline-flex;\n    color: ",
        ";\n  }\n\n  .tl-cc-actions {\n    flex: none;\n    display: flex;\n    align-items: center;\n    gap: ",
        ";\n  }\n\n  /* The line table is plain: no row colour (frame 03), only the page's toned columns. */\n  .tl-cc-lines {\n    margin-left: calc(",
        " + ",
        ");\n    min-width: 0;\n  }\n"
    ]);
    _templateObject166 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject167() {
    var data = _tagged_template_literal([
        "\n  display: grid;\n  grid-template-columns: ",
        ";\n  gap: ",
        ";\n  align-items: center;\n  padding: ",
        " ",
        ";\n  border-radius: ",
        ";\n  border: 1.5px solid transparent;\n  background: ",
        ";\n\n  &.is-close {\n    background: ",
        ";\n  }\n  &.is-decide {\n    background: ",
        ";\n    border-color: ",
        ";\n    box-shadow: ",
        ";\n  }\n  &.is-out {\n    background: ",
        ";\n  }\n\n  .cm-header {\n    min-width: 0;\n    font-size: ",
        ";\n    line-height: ",
        ";\n    font-weight: ",
        ";\n    color: ",
        ";\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n  &.is-out .cm-header {\n    color: ",
        ";\n  }\n\n  .cm-arrow {\n    display: flex;\n    color: ",
        ";\n  }\n\n  .cm-select {\n    min-width: 0;\n  }\n  /* A column's technical name reads in mono, as the design draws the chosen value. */\n  .cm-select .sel-value {\n    font-family: ",
        ";\n  }\n  &.is-decide .cm-select .sel-value,\n  &.is-out .cm-select .sel-value {\n    font-family: inherit;\n    color: ",
        ";\n  }\n\n  .cm-tag {\n    color: var(--cm-tag-ink);\n  }\n\n  /*\n   * An option may say one thing in the list and another once chosen (frame 02): the list reads\n   * *customer_asset_identifier Asset Identifier* and *Leave out*; the closed select reads\n   * *customer_asset_identifier* and *Left out*. The page marks the parts `cm-in-list` and\n   * `cm-in-trigger`.\n   */\n  .cm-select .sel-value .cm-in-list,\n  .cm-select [role='listbox'] .cm-in-trigger {\n    display: none;\n  }\n  .cm-select [role='listbox'] .cm-in-list {\n    margin-left: ",
        ";\n    font-family: inherit;\n    color: ",
        ";\n  }\n\n  .cm-first {\n    min-width: 0;\n    font-family: ",
        ";\n    font-size: ",
        ";\n    line-height: ",
        ";\n    font-weight: ",
        ";\n    color: ",
        ";\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n  &.is-close .cm-first {\n    color: ",
        ";\n  }\n  &.is-decide .cm-first {\n    color: ",
        ";\n  }\n  .cm-first.is-empty {\n    font-family: inherit;\n    color: ",
        ";\n  }\n"
    ], [
        "\n  display: grid;\n  grid-template-columns: ",
        ";\n  gap: ",
        ";\n  align-items: center;\n  padding: ",
        " ",
        ";\n  border-radius: ",
        ";\n  border: 1.5px solid transparent;\n  background: ",
        ";\n\n  &.is-close {\n    background: ",
        ";\n  }\n  &.is-decide {\n    background: ",
        ";\n    border-color: ",
        ";\n    box-shadow: ",
        ";\n  }\n  &.is-out {\n    background: ",
        ";\n  }\n\n  .cm-header {\n    min-width: 0;\n    font-size: ",
        ";\n    line-height: ",
        ";\n    font-weight: ",
        ";\n    color: ",
        ";\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n  &.is-out .cm-header {\n    color: ",
        ";\n  }\n\n  .cm-arrow {\n    display: flex;\n    color: ",
        ";\n  }\n\n  .cm-select {\n    min-width: 0;\n  }\n  /* A column's technical name reads in mono, as the design draws the chosen value. */\n  .cm-select .sel-value {\n    font-family: ",
        ";\n  }\n  &.is-decide .cm-select .sel-value,\n  &.is-out .cm-select .sel-value {\n    font-family: inherit;\n    color: ",
        ";\n  }\n\n  .cm-tag {\n    color: var(--cm-tag-ink);\n  }\n\n  /*\n   * An option may say one thing in the list and another once chosen (frame 02): the list reads\n   * *customer_asset_identifier Asset Identifier* and *Leave out*; the closed select reads\n   * *customer_asset_identifier* and *Left out*. The page marks the parts \\`cm-in-list\\` and\n   * \\`cm-in-trigger\\`.\n   */\n  .cm-select .sel-value .cm-in-list,\n  .cm-select [role='listbox'] .cm-in-trigger {\n    display: none;\n  }\n  .cm-select [role='listbox'] .cm-in-list {\n    margin-left: ",
        ";\n    font-family: inherit;\n    color: ",
        ";\n  }\n\n  .cm-first {\n    min-width: 0;\n    font-family: ",
        ";\n    font-size: ",
        ";\n    line-height: ",
        ";\n    font-weight: ",
        ";\n    color: ",
        ";\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n  &.is-close .cm-first {\n    color: ",
        ";\n  }\n  &.is-decide .cm-first {\n    color: ",
        ";\n  }\n  .cm-first.is-empty {\n    font-family: inherit;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject167 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject168() {
    var data = _tagged_template_literal([
        "\n  display: grid;\n  grid-template-columns: ",
        ";\n  gap: ",
        ";\n  padding: 0 ",
        " ",
        ";\n  font: ",
        " ",
        " / ",
        "\n    ",
        ";\n  letter-spacing: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject168 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject169() {
    var data = _tagged_template_literal([
        "\n  min-width: 0;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: ",
        ";\n  margin: 0;\n  padding: 0;\n  list-style: none;\n"
    ]);
    _templateObject169 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject170() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  border-radius: ",
        ";\n  ",
        ";\n  background: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject170 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject171() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex;\n  align-items: center;\n  gap: ",
        ";\n  padding: ",
        " ",
        " ",
        " ",
        ";\n  border-radius: ",
        ";\n  background: ",
        ";\n  ",
        ";\n  color: ",
        ";\n\n  &.is-done {\n    background: ",
        ";\n    color: ",
        ";\n    ",
        " {\n      color: ",
        ";\n    }\n  }\n\n  &.is-current {\n    ",
        ";\n    color: ",
        ";\n    background: ",
        ";\n    box-shadow: ",
        ";\n    ",
        " {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject171 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject172() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  min-width: 0;\n  margin: 0;\n  ",
        ";\n  color: ",
        ";\n\n  .hint-icon {\n    flex: none;\n    color: ",
        ";\n  }\n\n  /* A text block of its own, so it can shrink and end in an ellipsis on one line (Copilot, #1988:\n     text-overflow does nothing on the flex container itself). */\n  .hint-text {\n    min-width: 0;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n"
    ]);
    _templateObject172 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject173() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    _templateObject173 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject174() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: baseline;\n  flex-wrap: wrap;\n  column-gap: ",
        ";\n"
    ]);
    _templateObject174 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject175() {
    var data = _tagged_template_literal([
        "\n  margin: 0;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject175 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject176() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject176 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject177() {
    var data = _tagged_template_literal([
        "\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    _templateObject177 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject178() {
    var data = _tagged_template_literal([
        "\n  display: grid;\n  grid-template-columns: 96px minmax(0, 1fr) 34px;\n  align-items: center;\n  gap: ",
        ";\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n\n  &.other {\n    color: ",
        ";\n  }\n\n  .name {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .share {\n    font-family: ",
        ";\n    font-size: ",
        ";\n    font-weight: ",
        ";\n    color: ",
        ";\n    text-align: right;\n    white-space: nowrap;\n  }\n"
    ]);
    _templateObject178 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject179() {
    var data = _tagged_template_literal([
        "\n  display: block;\n  height: 6px;\n  border-radius: ",
        ";\n  background: ",
        ";\n  overflow: hidden;\n\n  &::after {\n    content: '';\n    display: block;\n    height: 100%;\n    /* A non-zero share always shows a sliver, as the frame's 6 % row does. */\n    width: ",
        ";\n    border-radius: ",
        ";\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject179 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject180() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: ",
        " ",
        ";\n  padding-top: ",
        ";\n  border-top: 1px solid ",
        ";\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject180 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject181() {
    var data = _tagged_template_literal([
        "\n  margin: 0;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject181 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject182() {
    var data = _tagged_template_literal([
        "\n  display: grid;\n  grid-template-columns: max-content 1fr;\n  column-gap: ",
        ";\n  row-gap: ",
        ";\n  margin: 0;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n\n  dt {\n    color: ",
        ";\n  }\n  dd {\n    margin: 0;\n    color: ",
        ";\n    min-width: 0;\n    overflow-wrap: anywhere;\n  }\n  .identify-none,\n  dd[data-none='true'] {\n    color: ",
        ";\n  }\n  dd[data-error='true'] {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject182 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject183() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: baseline;\n  gap: ",
        ";\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n  margin: 0;\n\n  .identify-aside {\n    margin-left: auto;\n    font-weight: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject183 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject184() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    _templateObject184 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject185() {
    var data = _tagged_template_literal([
        "\n  display: contents;\n"
    ]);
    _templateObject185 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject186() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  gap: ",
        ";\n"
    ]);
    _templateObject186 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject187() {
    var data = _tagged_template_literal([
        "\n    background-color: #d4edda;\n    border-color: #c3e6cb;\n    color: #155724;\n  "
    ]);
    _templateObject187 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject188() {
    var data = _tagged_template_literal([
        "\n    background-color: #f8d7da;\n    border-color: #f5c6cb;\n    color: #721c24;\n  "
    ]);
    _templateObject188 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject189() {
    var data = _tagged_template_literal([
        "\n    background-color: #fff3cd;\n    border-color: #ffeeba;\n    color: #856404;\n  "
    ]);
    _templateObject189 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject190() {
    var data = _tagged_template_literal([
        "\n    background-color: #d1ecf1;\n    border-color: #bee5eb;\n    color: #0c5460;\n  "
    ]);
    _templateObject190 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject191() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  padding: 0.75rem 1rem;\n  border: 1px solid;\n  border-radius: 0.5rem;\n  font-size: 0.875rem;\n  line-height: 1.4;\n\n  ",
        "\n"
    ]);
    _templateObject191 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject192() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  height: 100%;\n\n  .list-card {\n    flex: 1;\n    min-height: 0;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .top-strip {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: ",
        ";\n  }\n\n  .summary {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    font-size: ",
        ";\n    line-height: ",
        ";\n  }\n\n  .summary-line {\n    display: flex;\n    align-items: center;\n    gap: 7px;\n  }\n\n  .summary-dot {\n    display: inline-flex;\n    width: 6px;\n    flex: none;\n  }\n\n  /* The live regions stay in the DOM and in the accessibility tree while empty: display none\n     would take them out of it, and a region that reappears with its message is not announced.\n     An empty one has no height; the negative margin gives back the card's flex gap (md 12 px). */\n  .region:empty {\n    margin-top: -",
        ";\n  }\n\n  .column-header {\n    display: grid;\n    grid-template-columns: ",
        ";\n    gap: ",
        ";\n    padding: ",
        " ",
        " ",
        ";\n    border-bottom: 1px solid ",
        ";\n    color: ",
        ";\n    font-size: ",
        ";\n    line-height: ",
        ";\n    font-weight: ",
        ";\n  }\n\n  .col-target {\n    color: ",
        ";\n    font-weight: ",
        ";\n  }\n\n  .list-body {\n    /* Positioned: the row motion draws the moved row's placeholder inside it (spec R1). */\n    position: relative;\n    flex: 1;\n    min-height: 0;\n    overflow-y: auto;\n\n    /* Board v2's ghost, lined up with the row content. */\n    ",
        "\n  }\n\n  .rows {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n  }\n\n  .row {\n    display: grid;\n    grid-template-columns: ",
        ";\n    gap: ",
        ";\n    align-items: start;\n    padding: ",
        ";\n    margin: 1px 0;\n    /* radius.md, as the Observers rows that share these looks (board v2 draws 10 px, which has no\n       token — recorded for Rob). */\n    border-radius: ",
        ";\n    border: 1.5px solid transparent;\n    ",
        "\n  }\n\n  .kind {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 26px;\n    height: 26px;\n    margin-top: 2px;\n    border-radius: ",
        ";\n    background: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  }\n\n  .name-cell {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    min-width: 0;\n  }\n\n  .name {\n    font-size: ",
        ";\n    line-height: ",
        ";\n    font-weight: ",
        ";\n    color: ",
        ";\n  }\n\n  .automatic .name {\n    font-weight: ",
        ";\n    color: ",
        ";\n  }\n\n  .automatic .kind {\n    color: ",
        ";\n    background: ",
        ';\n  }\n\n  /* Colour is never the only cue: the words "no longer on the plan" follow the name. */\n  .name.unresolved {\n    color: ',
        ";\n  }\n\n  .gone {\n    font-size: ",
        ";\n    font-weight: ",
        ";\n  }\n\n  .under {\n    display: flex;\n    align-items: center;\n    gap: ",
        ";\n    white-space: nowrap;\n  }\n\n  .code {\n    font: ",
        " ",
        " / ",
        "\n      ",
        ";\n    color: ",
        ";\n  }\n\n  .adds-up {\n    display: flex;\n    flex-direction: column;\n    gap: ",
        ";\n    padding-top: 2px;\n    min-width: 0;\n  }\n\n  .chips {\n    display: flex;\n    flex-wrap: wrap;\n    gap: ",
        ";\n  }\n\n  .reasons {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n  }\n\n  .state {\n    padding-top: 2px;\n  }\n\n  .editing .column-header,\n  .editing .row {\n    grid-template-columns: ",
        ";\n  }\n\n  .row-actions button,\n  .source-state button {\n    white-space: nowrap;\n  }\n\n  .source-state.reveal {\n    opacity: 0;\n  }\n\n  .row:hover .source-state.reveal,\n  .row:focus-within .source-state.reveal,\n  .row.selected .source-state.reveal {\n    opacity: 1;\n  }\n\n  .row-actions {\n    grid-column: 5;\n    grid-row: 1;\n    display: flex;\n    justify-content: flex-end;\n    gap: ",
        ";\n    opacity: 0;\n  }\n\n  /* Over the actions column, always shown: *Added* and *In total* are state (spec R17). */\n  .source-state {\n    grid-column: 5;\n    grid-row: 1;\n    display: flex;\n    justify-content: flex-end;\n  }\n\n  /* The name opens the row (spec R18): a real button, drawn as the name it was. */\n  .name-button {\n    margin: 0;\n    padding: 0;\n    border: 0;\n    background: none;\n    font-family: inherit;\n    cursor: pointer;\n    border-radius: ",
        ";\n    text-align: left;\n  }\n\n  /* The board's link idiom (as SourceChip draws it): cyan-press ink and an underline. */\n  .name-button:hover,\n  .name-button:focus-visible {\n    color: ",
        ";\n    text-decoration: underline;\n  }\n\n  .name-button:focus-visible {\n    box-shadow: ",
        ";\n  }\n\n  .row:hover .row-actions,\n  .row:focus-within .row-actions,\n  .row.selected .row-actions {\n    opacity: 1;\n  }\n\n  .empty {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: ",
        ";\n    flex: 1;\n    text-align: center;\n  }\n\n  .empty-disc {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 48px;\n    height: 48px;\n    border-radius: ",
        ";\n    background: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  }\n\n  .empty-text {\n    margin: 0;\n    max-width: 420px;\n    font-size: ",
        ";\n    line-height: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject192 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject193() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: ",
        ";\n  padding-top: ",
        ";\n  border-top: 1px solid ",
        ";\n\n  .more-body {\n    align-self: stretch;\n  }\n"
    ]);
    _templateObject193 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject194() {
    var data = _tagged_template_literal([
        "\n  border-radius: ",
        ";\n\n  &.locked,\n  &.removable {\n    background: ",
        ";\n    border: 1.5px solid ",
        ";\n  }\n\n  /*\n   * Required and not counted: a problem (OWN_CAMERAS_REQUIRED_LOOK). Met, it is done, so it is\n   * unmarked: the resting card above, with no wash.\n   */\n  &.required {\n    background: ",
        ";\n    border: 1.5px solid ",
        ";\n  }\n\n  /* Both lines sit on the wash, so both take the role's ink (ink-3 there is under 4.5:1). */\n  &.required .own-label,\n  &.required .own-sub {\n    color: ",
        ";\n  }\n\n  &.none,\n  &.available {\n    display: flex;\n    align-items: center;\n    gap: ",
        ";\n    border: 1.5px dashed ",
        ";\n    padding: ",
        " ",
        ";\n  }\n\n  &.none {\n    padding: ",
        " ",
        " ",
        " ",
        ";\n    color: ",
        ";\n  }\n\n  &.available {\n    border-color: ",
        ";\n  }\n\n  .own-grid {\n    display: grid;\n    grid-template-columns: 26px minmax(0, 1fr) auto;\n    gap: ",
        ";\n    align-items: center;\n    padding: ",
        " ",
        " ",
        " ",
        ";\n  }\n\n  .own-disc {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 26px;\n    height: 26px;\n    flex: none;\n    border-radius: ",
        ";\n    background: ",
        ";\n    color: ",
        ";\n  }\n\n  .own-text {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n  }\n\n  .own-label {\n    font-size: ",
        ";\n    line-height: ",
        ";\n    font-weight: ",
        ";\n    color: ",
        ";\n  }\n\n  .own-sub {\n    font-size: ",
        ";\n    line-height: ",
        ";\n    font-weight: ",
        ";\n    color: ",
        ";\n  }\n\n  &.none .own-sub {\n    color: ",
        ";\n  }\n\n  .own-lock {\n    color: ",
        ";\n    padding-right: ",
        ";\n  }\n\n  /* Indented to the label column, as a source card's notes are. */\n  .own-reason {\n    margin: 0;\n    padding: 0 ",
        " ",
        " 46px;\n    font-size: ",
        ";\n    line-height: ",
        ";\n    font-weight: ",
        ";\n    color: ",
        ";\n  }\n\n  .own-note {\n    padding: 0 ",
        " ",
        " 46px;\n  }\n"
    ]);
    _templateObject194 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject195() {
    var data = _tagged_template_literal([
        "\n  height: 100%;\n\n  /* Focused only by script (Edit opens it; it is not a Tab stop): no ring round the whole panel. */\n  &:focus {\n    outline: none;\n  }\n\n  .footer {\n    display: flex;\n    align-items: center;\n    gap: ",
        ";\n    width: 100%;\n  }\n\n  .footer-gap {\n    flex: 1;\n  }\n\n  .body {\n    display: flex;\n    flex-direction: column;\n    gap: ",
        ";\n  }\n\n  .notes {\n    display: flex;\n    flex-direction: column;\n    gap: ",
        ";\n  }\n\n  .target-field,\n  .adds-up {\n    display: flex;\n    flex-direction: column;\n    gap: ",
        ";\n  }\n\n  .adds-up-head {\n    display: flex;\n    align-items: baseline;\n    gap: ",
        ";\n  }\n\n  .adds-up-label {\n    margin: 0;\n    font-size: ",
        ";\n    line-height: ",
        ";\n    font-weight: ",
        ";\n    color: ",
        ";\n  }\n\n  .adds-up-count {\n    font: ",
        " ",
        " / ",
        "\n      ",
        ";\n    color: ",
        ";\n  }\n\n  .adds-up-hint {\n    margin-left: auto;\n    font-size: ",
        ";\n    line-height: ",
        ";\n    color: ",
        ";\n  }\n\n  /* The empty slot (board v2 `ed.empty`): where the cards would be, said once a target exists. */\n  .empty-box {\n    margin: 0;\n    padding: ",
        " ",
        ";\n    border: 1.5px dashed ",
        ";\n    border-radius: ",
        ";\n    color: ",
        ";\n    text-align: center;\n    font-size: ",
        ";\n    line-height: ",
        ";\n  }\n\n  .cards {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    display: flex;\n    flex-direction: column;\n    gap: ",
        ";\n  }\n\n  /* radius.md: board v2 draws 10 px, which has no token (recorded for Rob by the list feature). */\n  .card {\n    border-radius: ",
        ";\n    background: ",
        ";\n    border: 1.5px solid ",
        ";\n    box-shadow: 0 1px 2px rgba(",
        ", 0.06);\n    transition: box-shadow ",
        " ",
        ";\n  }\n\n  .reduced .card {\n    transition: none;\n  }\n\n  /* Just added: the fading glow (linkedRing), for LINK_FLASH_MS. */\n  .card.arriving {\n    box-shadow: ",
        ";\n  }\n\n  .card-grid {\n    display: grid;\n    grid-template-columns: 26px minmax(0, 1fr) auto 24px;\n    gap: ",
        ";\n    align-items: center;\n    padding: ",
        " ",
        " ",
        " ",
        ";\n  }\n\n  .disc {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 26px;\n    height: 26px;\n    border-radius: ",
        ";\n    background: ",
        ";\n    color: ",
        ";\n  }\n\n  .card-text {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n  }\n\n  .card-name {\n    font-size: ",
        ";\n    line-height: ",
        ";\n    font-weight: ",
        ";\n    color: ",
        ";\n  }\n\n  .card-sub {\n    display: inline-flex;\n    align-items: center;\n    gap: ",
        ";\n    font-size: ",
        ";\n    line-height: ",
        ";\n    font-weight: ",
        ";\n  }\n\n  /* A picker option's state, drawn as the source card's sub-line is (board v2 frames 06 and 09). */\n  .picker-state {\n    display: inline-flex;\n    align-items: center;\n    gap: ",
        ";\n  }\n\n  .sub-dot {\n    width: 6px;\n    height: 6px;\n    border-radius: ",
        ";\n    flex: none;\n  }\n\n  /* Indented to the name column (board v2: 46 px = card padding + disc + gap). */\n  .card-notes {\n    padding: 0 ",
        " ",
        " 46px;\n  }\n\n  .add-source {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: ",
        ";\n  }\n\n  .add-source-help {\n    margin: 0;\n    font-size: ",
        ";\n    line-height: ",
        ";\n    color: ",
        ";\n  }\n\n  .source-picker {\n    align-self: stretch;\n  }\n"
    ], [
        "\n  height: 100%;\n\n  /* Focused only by script (Edit opens it; it is not a Tab stop): no ring round the whole panel. */\n  &:focus {\n    outline: none;\n  }\n\n  .footer {\n    display: flex;\n    align-items: center;\n    gap: ",
        ";\n    width: 100%;\n  }\n\n  .footer-gap {\n    flex: 1;\n  }\n\n  .body {\n    display: flex;\n    flex-direction: column;\n    gap: ",
        ";\n  }\n\n  .notes {\n    display: flex;\n    flex-direction: column;\n    gap: ",
        ";\n  }\n\n  .target-field,\n  .adds-up {\n    display: flex;\n    flex-direction: column;\n    gap: ",
        ";\n  }\n\n  .adds-up-head {\n    display: flex;\n    align-items: baseline;\n    gap: ",
        ";\n  }\n\n  .adds-up-label {\n    margin: 0;\n    font-size: ",
        ";\n    line-height: ",
        ";\n    font-weight: ",
        ";\n    color: ",
        ";\n  }\n\n  .adds-up-count {\n    font: ",
        " ",
        " / ",
        "\n      ",
        ";\n    color: ",
        ";\n  }\n\n  .adds-up-hint {\n    margin-left: auto;\n    font-size: ",
        ";\n    line-height: ",
        ";\n    color: ",
        ";\n  }\n\n  /* The empty slot (board v2 \\`ed.empty\\`): where the cards would be, said once a target exists. */\n  .empty-box {\n    margin: 0;\n    padding: ",
        " ",
        ";\n    border: 1.5px dashed ",
        ";\n    border-radius: ",
        ";\n    color: ",
        ";\n    text-align: center;\n    font-size: ",
        ";\n    line-height: ",
        ";\n  }\n\n  .cards {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    display: flex;\n    flex-direction: column;\n    gap: ",
        ";\n  }\n\n  /* radius.md: board v2 draws 10 px, which has no token (recorded for Rob by the list feature). */\n  .card {\n    border-radius: ",
        ";\n    background: ",
        ";\n    border: 1.5px solid ",
        ";\n    box-shadow: 0 1px 2px rgba(",
        ", 0.06);\n    transition: box-shadow ",
        " ",
        ";\n  }\n\n  .reduced .card {\n    transition: none;\n  }\n\n  /* Just added: the fading glow (linkedRing), for LINK_FLASH_MS. */\n  .card.arriving {\n    box-shadow: ",
        ";\n  }\n\n  .card-grid {\n    display: grid;\n    grid-template-columns: 26px minmax(0, 1fr) auto 24px;\n    gap: ",
        ";\n    align-items: center;\n    padding: ",
        " ",
        " ",
        " ",
        ";\n  }\n\n  .disc {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 26px;\n    height: 26px;\n    border-radius: ",
        ";\n    background: ",
        ";\n    color: ",
        ";\n  }\n\n  .card-text {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n  }\n\n  .card-name {\n    font-size: ",
        ";\n    line-height: ",
        ";\n    font-weight: ",
        ";\n    color: ",
        ";\n  }\n\n  .card-sub {\n    display: inline-flex;\n    align-items: center;\n    gap: ",
        ";\n    font-size: ",
        ";\n    line-height: ",
        ";\n    font-weight: ",
        ";\n  }\n\n  /* A picker option's state, drawn as the source card's sub-line is (board v2 frames 06 and 09). */\n  .picker-state {\n    display: inline-flex;\n    align-items: center;\n    gap: ",
        ";\n  }\n\n  .sub-dot {\n    width: 6px;\n    height: 6px;\n    border-radius: ",
        ";\n    flex: none;\n  }\n\n  /* Indented to the name column (board v2: 46 px = card padding + disc + gap). */\n  .card-notes {\n    padding: 0 ",
        " ",
        " 46px;\n  }\n\n  .add-source {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: ",
        ";\n  }\n\n  .add-source-help {\n    margin: 0;\n    font-size: ",
        ";\n    line-height: ",
        ";\n    color: ",
        ";\n  }\n\n  .source-picker {\n    align-self: stretch;\n  }\n"
    ]);
    _templateObject195 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject196() {
    var data = _tagged_template_literal([
        "\n  display: inline-block;\n  padding: 0.25rem 0.625rem;\n  border-radius: 0.75rem;\n  font-size: 0.75rem;\n  font-weight: 500;\n  white-space: nowrap;\n  text-transform: uppercase;\n  background-color: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject196 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject197() {
    var data = _tagged_template_literal([
        "\n  0% { opacity: 1; }\n  50% { opacity: 0.35; }\n  100% { opacity: 1; }\n"
    ]);
    _templateObject197 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject198() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: ",
        ";\n  gap: ",
        ";\n  /* Reset list chrome for the labelled (rendered-as-ol) variant; harmless for the div variant. */\n  list-style: none;\n  margin: 0;\n  padding: 0;\n"
    ]);
    _templateObject198 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject199() {
    var data = _tagged_template_literal([
        "\n      flex: ",
        ";\n      min-width: 0;\n      flex-direction: column;\n    "
    ]);
    _templateObject199 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject200() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  ",
        "\n"
    ]);
    _templateObject200 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject201() {
    var data = _tagged_template_literal([
        "\n      justify-content: center;\n      position: relative;\n    "
    ]);
    _templateObject201 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject202() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  width: 100%;\n  ",
        "\n"
    ]);
    _templateObject202 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject203() {
    var data = _tagged_template_literal([
        "\n      animation: ",
        " 1.2s ease-in-out infinite;\n    "
    ]);
    _templateObject203 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject204() {
    var data = _tagged_template_literal([
        "\n  flex: 0 0 auto;\n  width: ",
        ";\n  height: ",
        ";\n  border-radius: 50%;\n  background: ",
        ";\n  border: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject204 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject205() {
    var data = _tagged_template_literal([
        "\n  flex: 1 1 0;\n  height: 2px;\n  background: ",
        ";\n"
    ]);
    _templateObject205 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject206() {
    var data = _tagged_template_literal([
        "\n  margin-top: 0.35rem;\n  font-size: var(--tl-fs-caption2, 11px);\n  text-align: center;\n  color: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    _templateObject206 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject207() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n"
    ]);
    _templateObject207 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject208() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n"
    ]);
    _templateObject208 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject209() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #666;\n  padding: 0.25rem;\n  border-radius: 0.25rem;\n  transition: color 0.2s;\n\n  &:hover,\n  &:focus {\n    color: #00bbcc;\n    outline: none;\n  }\n"
    ]);
    _templateObject209 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject210() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  display: inline-block;\n"
    ]);
    _templateObject210 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject211() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 2rem;\n  height: 2rem;\n  border: none;\n  border-radius: 0.375rem;\n  background-color: rgba(255, 255, 255, 0.4);\n  color: #6b7280;\n  cursor: pointer;\n  transition: all 0.2s ease;\n\n  &:hover {\n    background-color: rgba(255, 255, 255, 0.7);\n    color: #374151;\n  }\n\n  &:focus {\n    outline: none;\n    box-shadow: 0 0 0 0.125rem rgba(0, 187, 204, 0.3);\n  }\n"
    ]);
    _templateObject211 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject212() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  top: 100%;\n  right: 0;\n  z-index: 1000;\n  min-width: 10rem;\n  margin-top: 0.25rem;\n  padding: 0.25rem 0;\n  border-radius: 0.5rem;\n  background: rgba(255, 255, 255, 0.16);\n  backdrop-filter: blur(17.8px);\n  box-shadow:\n    0.852px 0.852px 6.816px 0px rgba(255, 255, 255, 0.08) inset,\n    1.704px 1.704px 49.413px 0px rgba(228, 255, 255, 0.15),\n    0 4px 6px -1px rgba(0, 0, 0, 0.1),\n    0 2px 4px -1px rgba(0, 0, 0, 0.06);\n"
    ]);
    _templateObject212 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject213() {
    var data = _tagged_template_literal([
        "\n  display: block;\n  width: 100%;\n  padding: 0.5rem 0.75rem;\n  text-align: left;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 0.875rem;\n  color: ",
        ";\n  transition: background-color 0.15s ease;\n\n  &:hover {\n    background-color: ",
        ";\n  }\n\n  &:focus {\n    outline: none;\n    background-color: rgba(255, 255, 255, 0.3);\n  }\n"
    ]);
    _templateObject213 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject214() {
    var data = _tagged_template_literal([
        "\n  margin: 2rem 0 0.5rem 0;\n  list-style: none;\n  font-size: 12px;\n  font-family: ",
        ";\n\n  li {\n    color: #242424;\n    display: flex;\n    line-height: 100%;\n    font-size: inherit;\n    font-weight: bold;\n    margin-bottom: 8px;\n  }\n\n  /* An untracked entity's rows are not measurements of that entity — they are what the twin knows\n     about a thing it is not counting. Italic carries that on its own; the grey is a second signal\n     rather than the only one. It was the only one until label-management-cleanup gave this\n     component a single render path and made the fix a two-line change (backlog, Low, raised by\n     label-management-viewer's accessibility review). */\n  li.untracked {\n    color: #636363;\n    font-style: italic;\n  }\n\n  li span {\n    flex: 1;\n    font-weight: normal;\n    color: #242424;\n  }\n"
    ]);
    _templateObject214 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject215() {
    var data = _tagged_template_literal([
        "\n  min-width: 70px;\n  display: flex;\n  align-items: center;\n  margin-left: auto;\n\n  .indicator {\n    margin-top: -2px;\n    margin-left: auto;\n  }\n\n  .over-capacity-indicator {\n    color: #da3b01;\n  }\n\n  .na-indicator {\n    color: #cccccc;\n  }\n\n  .indicator-badge {\n    width: 8px;\n    height: 8px;\n    margin-left: 8px;\n    border-radius: 8px;\n    display: inline-block;\n  }\n\n  .na-indicator-badge {\n    background-image: repeating-linear-gradient(\n      45deg,\n      #707070,\n      #707070 2px,\n      #cccccc 2px,\n      #cccccc 4px\n    );\n  }\n\n  .indicator-label {\n    color: var(--Neutral-Foreground-1-Rest, #242424);\n    text-align: right;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 20px;\n  }\n\n  .untracked-label {\n    font-weight: 400;\n    color: #636363;\n  }\n\n  /* Muted like the Untracked label, but its own class so the two can diverge. */\n  .no-data-label {\n    font-weight: 400;\n    color: #636363;\n  }\n"
    ]);
    _templateObject215 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject216() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 28px;\n  margin-bottom: 0.25rem;\n  padding: 0.25rem;\n  border-radius: 8px;\n\n  /* Outer glow on selection + black shadow */\n  &.selected {\n    border-width: 2px;\n    border-style: solid;\n    border-radius: 8px;\n    border-color: rgba(228, 255, 254, 1);\n    box-shadow:\n      0px 0px 12px 2px rgba(228, 255, 254, 1),\n      0px 2px 5px rgba(0, 0, 0, 0.9);\n    background-color: rgba(255, 255, 255, 0.15) !important;\n  }\n\n  /* Outer glow on hover + dashed border - HIGHEST PRIORITY */\n  /* It is critical that the hover effect works with selected asset items */\n  &.hovered,\n  &.selected.hovered {\n    cursor: pointer;\n    border-width: 2px;\n    border-style: dashed;\n    border-radius: 8px;\n    border-color: rgba(228, 255, 254, 1);\n    background-image: linear-gradient(\n      145deg,\n      rgba(255, 255, 255, 0.15) 0%,\n      rgba(255, 255, 255, 0.1) 50%,\n      rgba(255, 255, 255, 0.05) 100%\n    );\n    box-shadow:\n      0px 0px 12px 3px rgba(228, 255, 254, 1),\n      0px 2px 5px rgba(0, 0, 0, 0.7) !important;\n    transition: all 0.3s ease;\n  }\n"
    ]);
    _templateObject216 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject217() {
    var data = _tagged_template_literal([
        "\n  /* Was Tailwind w-full on the accordion header content. */\n  .header-content {\n    width: 100%;\n  }\n\n  .accordion-item {\n    margin-bottom: 12px;\n  }\n\n  .accordion-button {\n    min-height: 32px;\n    display: flex;\n    justify-content: center;\n  }\n\n  .accordion-item button {\n    padding: 0 !important; /* Override Fluent2 the padding on the accordion buttons */\n    border: none !important;\n  }\n"
    ]);
    _templateObject217 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject218() {
    var data = _tagged_template_literal([
        "\n  .header {\n    max-width: calc(100% - 20px);\n    height: 64px;\n    position: sticky;\n    top: 0;\n  }\n\n  .scrollable-container {\n    width: 308px;\n    padding-right: 20px;\n  }\n"
    ]);
    _templateObject218 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject219() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: stretch;\n  gap: 2px;\n  padding-bottom: 6px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.7);\n\n  .sort-toggle {\n    display: inline-flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 6px;\n    height: 26px;\n    padding: 0 8px;\n    border: 0;\n    border-radius: 6px;\n    cursor: pointer;\n    font-family: ",
        ";\n    font-size: 11.5px;\n    font-weight: 500;\n    letter-spacing: -0.05px;\n    background: rgba(255, 255, 255, 0.18);\n    color: var(--Neutral-Foreground-3-Rest, #6d737e);\n    transition: all 0.15s ease;\n  }\n\n  .sort-toggle.name {\n    flex: 1 1 auto;\n    min-width: 0;\n  }\n\n  .sort-toggle.value {\n    flex: 0 0 auto;\n  }\n\n  .sort-label {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .sort-toggle.active {\n    background: #ffffff;\n    color: var(--Neutral-Foreground-1-Rest, #3f454e);\n    font-weight: 600;\n    box-shadow:\n      inset 0 0 0 1px rgba(27, 182, 217, 0.28),\n      0 1px 2px rgba(40, 30, 80, 0.1);\n  }\n\n  .sort-glyph {\n    width: 10px;\n    height: 12px;\n    flex: none;\n  }\n\n  .sort-glyph.idle {\n    fill: rgba(127, 134, 145, 0.55);\n  }\n\n  .sort-glyph.active {\n    fill: #008c99;\n  }\n"
    ]);
    _templateObject219 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject220() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  font-family: ",
        ";\n\n  .group-heading {\n    margin: 16px 0 6px;\n    font-size: 11px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n    color: var(--Neutral-Foreground-3-Rest, #6d737e);\n  }\n\n  .group:first-child .group-heading {\n    margin-top: 2px;\n  }\n\n  .node-row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    min-height: 28px;\n    border-radius: 6px;\n  }\n\n  .chevron,\n  .chevron-spacer {\n    width: 16px;\n    height: 16px;\n    flex: none;\n  }\n\n  .chevron {\n    border: 0;\n    background: none;\n    padding: 0;\n    cursor: pointer;\n    color: var(--Neutral-Foreground-4-Rest, #7f8691);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .chevron svg {\n    width: 12px;\n    height: 12px;\n    transition: transform 0.15s ease;\n  }\n\n  .node-label {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex: 1;\n    min-width: 0;\n    border: 0;\n    background: none;\n    padding: 0;\n    cursor: pointer;\n    text-align: left;\n  }\n\n  .label-text {\n    flex: 1;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-size: 13px;\n    line-height: 1.3;\n    font-weight: 400;\n    color: var(--Neutral-Foreground-2-Rest, #565c66);\n  }\n\n  .node-label.state-on .label-text,\n  .node-label.state-mixed .label-text {\n    font-weight: 600;\n    color: var(--Neutral-Foreground-1-Rest, #3f454e);\n  }\n\n  .count-badge {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 22px;\n    height: 18px;\n    padding: 0 6px;\n    flex: none;\n    border-radius: 999px;\n    background: rgba(255, 255, 255, 0.7);\n    border: 1px solid rgba(255, 255, 255, 0.95);\n    font-size: 10.5px;\n    font-weight: 500;\n    color: var(--Neutral-Foreground-3-Rest, #6d737e);\n  }\n\n  .checkbox {\n    position: relative;\n    width: 18px;\n    height: 18px;\n    flex: none;\n    border-radius: 5px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-sizing: border-box;\n  }\n\n  .checkbox.off {\n    background: linear-gradient(180deg, rgba(27, 182, 217, 0.1) 0%, rgba(199, 247, 247, 0.16) 100%);\n    border: 1px solid transparent;\n    border-top-color: rgba(27, 182, 217, 0.55);\n    border-left-color: rgba(27, 182, 217, 0.5);\n    border-bottom-color: rgba(27, 182, 217, 0.28);\n    border-right-color: rgba(27, 182, 217, 0.3);\n    box-shadow:\n      inset 1px 1px 0 rgba(255, 255, 255, 0.55),\n      1px 2px 4px -2px rgba(27, 182, 217, 0.3);\n  }\n\n  .checkbox.on,\n  .checkbox.mixed {\n    background: linear-gradient(180deg, rgba(27, 182, 217, 0.95) 0%, rgba(27, 182, 217, 0.75) 100%);\n    border: 1px solid rgba(27, 182, 217, 0.85);\n    box-shadow:\n      inset 1px 1px 0 rgba(255, 255, 255, 0.45),\n      1px 2px 5px -1px rgba(27, 182, 217, 0.5);\n  }\n\n  .checkbox svg {\n    width: 12px;\n    height: 12px;\n  }\n\n  .checkbox .dash {\n    display: block;\n    width: 10px;\n    height: 2px;\n    border-radius: 1px;\n    background: #fff;\n  }\n"
    ]);
    _templateObject220 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject221() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  font-family: ",
        ";\n\n  .state {\n    padding: 12px 8px;\n    font-size: 12px;\n    color: var(--Neutral-Foreground-3-Rest, #6d737e);\n  }\n\n  .state.error p {\n    margin: 0 0 8px;\n  }\n\n  .state.error button {\n    height: 26px;\n    padding: 0 12px;\n    border: 1px solid #008c99;\n    border-radius: 6px;\n    background: rgba(0, 140, 153, 0.06);\n    color: #008c99;\n    font-family: ",
        ";\n    font-size: 11px;\n    font-weight: 600;\n    cursor: pointer;\n  }\n"
    ]);
    _templateObject221 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject222() {
    var data = _tagged_template_literal([
        "\n  /* equipment-panel-design FR1: one frosted-glass card over the 3D scene, matching Rob's design\n     (fill 0.62, blur 50, frost border + frost-glow + drop shadow). The left column is flex:0 0 auto,\n     so this width defines the column. */\n  width: 360px;\n  display: flex;\n  flex-direction: column;\n  max-height: calc(100vh - 24px);\n  overflow: hidden;\n  border-radius: 12px;\n  background-color: rgba(255, 255, 255, 0.62);\n  backdrop-filter: blur(50px);\n  -webkit-backdrop-filter: blur(50px);\n  border: 1px solid rgba(255, 255, 255, 0.6);\n  box-shadow:\n    0 0 11px 1px rgba(228, 255, 254, 0.55),\n    0 3px 11px 0 rgba(0, 0, 0, 0.05);\n  font-family: ",
        ";\n  color: var(--Neutral-Foreground-1-Rest, #3f454e);\n\n  .tab-strip {\n    display: flex;\n    align-items: flex-end;\n    gap: 2px;\n    padding: 5px 4px 0;\n    flex: none;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.65);\n  }\n\n  .tab {\n    position: relative;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 7px;\n    flex: 1;\n    height: 32px;\n    padding: 0 12px;\n    border: none;\n    cursor: pointer;\n    border-radius: 8px 8px 0 0;\n    margin-bottom: -1px;\n    font-family: ",
        ";\n    font-size: 13px;\n    font-weight: 500;\n    line-height: 1;\n    letter-spacing: -0.154px;\n  }\n\n  .tab-icon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 15px;\n  }\n\n  .tab-icon svg {\n    width: 15px;\n    height: 15px;\n  }\n\n  .tab.idle {\n    background: transparent;\n    color: var(--Neutral-Foreground-2-Rest, #565c66);\n  }\n\n  .tab.idle .tab-icon {\n    color: var(--Neutral-Foreground-3-Rest, #6d737e);\n  }\n\n  .tab.active {\n    color: var(--Neutral-Foreground-1-Rest, #3f454e);\n    background: linear-gradient(\n      180deg,\n      rgba(228, 255, 254, 0.45) 0%,\n      rgba(228, 255, 254, 0.78) 100%\n    );\n    box-shadow:\n      inset 1px 0 0 rgba(228, 255, 254, 1),\n      inset -1px 0 0 rgba(228, 255, 254, 1),\n      inset 0 1px 0 rgba(228, 255, 254, 1);\n  }\n\n  .tab-underline {\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    height: 2px;\n    background: linear-gradient(\n      90deg,\n      rgba(228, 255, 254, 0.6) 0%,\n      #e4fffe 50%,\n      rgba(228, 255, 254, 0.6) 100%\n    );\n    box-shadow:\n      0 0 10px #e4fffe,\n      0 0 18px rgba(228, 255, 254, 0.6);\n  }\n\n  .tab-badge {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 18px;\n    height: 18px;\n    padding: 0 6px;\n    border-radius: 999px;\n    background: rgba(255, 255, 255, 0.85);\n    border: 1px solid rgba(255, 255, 255, 0.95);\n    font-size: 10.5px;\n    font-weight: 600;\n    color: var(--Neutral-Foreground-1-Rest, #3f454e);\n  }\n\n  .tab.idle .tab-badge {\n    background: rgba(255, 255, 255, 0.7);\n    border-color: rgba(255, 255, 255, 0.9);\n    color: var(--Neutral-Foreground-2-Rest, #565c66);\n  }\n\n  .equipment-tab {\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n  }\n\n  .summary-header {\n    flex: none;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 12px 14px 10px;\n  }\n\n  .summary-text {\n    min-width: 0;\n    flex: 1;\n  }\n\n  .summary-title {\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 1.2;\n    color: var(--Neutral-Foreground-1-Rest, #3f454e);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .summary-sub {\n    margin-top: 3px;\n    font-size: 11px;\n    font-weight: 400;\n    line-height: 1.3;\n    color: var(--Neutral-Foreground-4-Rest, #7f8691);\n  }\n\n  .summary-value {\n    flex: none;\n    text-align: right;\n    font-size: 20px;\n    font-weight: 600;\n    line-height: 1;\n    letter-spacing: -0.3px;\n    color: var(--Neutral-Foreground-1-Rest, #3f454e);\n    font-variant-numeric: tabular-nums;\n  }\n\n  .sort-row {\n    flex: none;\n    margin: 0 10px;\n  }\n\n  .scrollable-container {\n    width: 360px;\n    padding: 8px 10px 12px;\n    box-sizing: border-box;\n  }\n\n  .filters-tab {\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n  }\n\n  .filters-tab .scrollable-container {\n    padding: 10px 12px 8px;\n  }\n\n  .filters-footer {\n    flex: none;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 10px 14px;\n    border-top: 1px solid rgba(255, 255, 255, 0.7);\n    background: rgba(255, 255, 255, 0.35);\n  }\n\n  .filters-summary {\n    flex: 1;\n    min-width: 0;\n    font-size: 12px;\n    line-height: 1.3;\n    color: var(--Neutral-Foreground-2-Rest, #565c66);\n  }\n\n  .clear-all {\n    border: 0;\n    background: none;\n    padding: 4px 6px;\n    margin: -4px -6px;\n    cursor: pointer;\n    font-family: ",
        ";\n    font-size: 12px;\n    font-weight: 500;\n    color: #008c99;\n  }\n"
    ]);
    _templateObject222 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject223() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n"
    ]);
    _templateObject223 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject224() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: flex-end;\n"
    ]);
    _templateObject224 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject225() {
    var data = _tagged_template_literal([
        "\n  font-size: 0.75rem;\n  line-height: 1rem;\n  font-weight: 600;\n  text-align: center;\n"
    ]);
    _templateObject225 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject226() {
    var data = _tagged_template_literal([
        "\n  margin-left: 14px;\n"
    ]);
    _templateObject226 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject227() {
    var data = _tagged_template_literal([
        "\n  .selection-overlay {\n    background: #333333;\n    color: #ffffff;\n    width: 62px;\n    height: 28px;\n    position: relative;\n    z-index: 99;\n    top: -18px;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 3px;\n    border: var(--None, 0.706px) solid\n      var(--Neutral-Stroke-Transparent-Rest, rgba(255, 255, 255, 0));\n    box-shadow:\n      0px 2.824px 5.647px 0px rgba(0, 0, 0, 0.14),\n      0px 0px 1.412px 0px rgba(0, 0, 0, 0.12);\n  }\n\n  .selection-overlay-value {\n    line-height: 100%;\n    margin-top: -2px;\n  }\n\n  .selection-overlay-value .value {\n    font-size: 9px;\n    line-height: 100%;\n    position: relative;\n    top: -1px;\n  }\n\n  .selection-overlay-arrow {\n    width: 0;\n    height: 0;\n    border-left: 6px solid transparent;\n    border-right: 6px solid transparent;\n    border-top: 6px solid #333333;\n    position: absolute;\n    bottom: -8px;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n"
    ]);
    _templateObject227 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject228() {
    var data = _tagged_template_literal([
        "\n  .calendar-stepper {\n    width: 311px;\n    margin: 8px 0 0 38px;\n    display: flex;\n  }\n\n  .calendar-stepper p {\n    flex-grow: 1;\n    font-weight: 600;\n    text-align: center;\n  }\n"
    ]);
    _templateObject228 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject229() {
    var data = _tagged_template_literal([
        "\n  .header {\n    height: 64px;\n    position: sticky;\n    top: 0;\n    max-width: calc(100% - 20px);\n  }\n\n  .right-scrollable-container {\n    max-width: calc(100% - 20px);\n  }\n\n  /* Calendar Table */\n  #duration {\n    border-collapse: collapse;\n    margin-bottom: 1rem;\n  }\n\n  #duration th,\n  #duration td {\n    padding: 0;\n    border: 1px solid rgba(255, 255, 255, 1);\n    box-sizing: border-box;\n    /* Ensure border is included in the element's dimensions */\n    text-align: center;\n    user-select: none;\n  }\n\n  #duration td {\n    color: var(--Neutral-Foreground-1-Rest, #242424);\n    text-align: center;\n    font-size: 11px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 16px;\n    position: relative;\n  }\n\n  #duration .month-date {\n    color: var(--Colors-Grey-28, #474747);\n    font-size: 8px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 14px;\n    position: absolute;\n    left: 1px;\n    top: -2px;\n  }\n\n  #duration td::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(255, 255, 255, 0);\n    border: 2px solid transparent;\n    z-index: 1;\n    pointer-events: none;\n  }\n\n  #duration th {\n    line-height: 0%;\n    padding: 0;\n    margin: 0;\n    border: none;\n  }\n\n  .cell-date {\n    font-size: 7px;\n    position: absolute !important;\n    top: -3px;\n    left: 1px;\n  }\n\n  .selection-box {\n    position: absolute;\n    border-radius: var(--Medium, 4px);\n    border: var(--Small, 2px) solid #e4fffe;\n    box-shadow: 0 0 2px 2px rgba(255, 255, 255, 0.4);\n    /* Above the cells (which carry z-index: 2) — without this the selection ring is painted behind\n       the opaque cells and is invisible (pre-existing regression, restored here). */\n    z-index: 3;\n  }\n\n  /* Main diagonal lines class */\n  .diagonal-overlay {\n    position: absolute;\n    top: 32px;\n    left: 42px;\n    right: 0;\n    bottom: 0;\n    background-image: repeating-linear-gradient(\n      -45deg,\n      transparent,\n      transparent 2px,\n      #999 2px,\n      #999 3px\n    );\n    pointer-events: none; /* Allow clicks through */\n    z-index: -1;\n  }\n"
    ]);
    _templateObject229 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject230() {
    var data = _tagged_template_literal([
        "\n  .loading {\n    margin: 2rem 0;\n  }\n\n  .header {\n    max-width: calc(100% - 20px);\n    height: 64px;\n    position: sticky;\n    top: 0;\n  }\n\n  .add-twin {\n    width: calc(100% - 20px);\n    margin: 1rem 0;\n    height: 48px;\n    padding: 0 1rem;\n  }\n\n  .scrollable-container {\n    width: 308px;\n    padding-right: 20px;\n  }\n\n  .accordion-header {\n    width: 100%;\n    display: flex;\n    .title {\n      font-size: 14px;\n    }\n    .count {\n      margin-left: auto;\n    }\n  }\n\n  .accordion-item {\n    margin-bottom: 12px;\n  }\n\n  .accordion-button {\n    min-height: 32px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n  }\n\n  /* Spanner: opens the onboarding/setup flow for this twin. */\n  .setup-twin {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    margin-left: auto;\n    padding: 4px !important;\n    border: none !important;\n    border-radius: 4px;\n    background: transparent;\n    color: #707070;\n    cursor: pointer;\n\n    &:hover {\n      background: rgba(0, 187, 204, 0.12);\n      color: #00bbcc;\n    }\n  }\n\n  .accordion-item button {\n    padding: 0 !important; /* Override Fluent2 the padding on the accordion buttons */\n    border: none !important;\n  }\n"
    ]);
    _templateObject230 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject231() {
    var data = _tagged_template_literal([
        "\n  .marker {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.2));\n\n    &:hover {\n      transform: translateY(-2px);\n      filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.3));\n    }\n\n    &.selected {\n      transform: scale(1.1);\n      filter: drop-shadow(0px 4px 12px rgba(0, 187, 204, 0.6));\n    }\n  }\n\n  .marker-icon {\n    width: 24px;\n    height: 24px;\n    color: #00bbcc;\n    background: white;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 2px solid #00bbcc;\n    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.15);\n\n    svg {\n      width: 16px;\n      height: 16px;\n    }\n\n    .marker.selected & {\n      background: #00bbcc;\n      color: white;\n      border-color: white;\n    }\n  }\n\n  .marker-label {\n    margin-top: 4px;\n    padding: 2px 6px;\n    background: rgba(255, 255, 255, 0.9);\n    backdrop-filter: blur(4px);\n    border-radius: 4px;\n    font-size: 11px;\n    font-weight: 500;\n    color: #242424;\n    white-space: nowrap;\n    border: 1px solid rgba(0, 187, 204, 0.3);\n    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1);\n\n    .marker.selected & {\n      background: rgba(0, 187, 204, 0.1);\n      border-color: #00bbcc;\n      color: #00bbcc;\n      font-weight: 600;\n    }\n\n    .marker:hover & {\n      background: rgba(255, 255, 255, 1);\n      border-color: rgba(0, 187, 204, 0.5);\n    }\n  }\n"
    ]);
    _templateObject231 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject232() {
    var data = _tagged_template_literal([
        "\n  /* Backstop against a stray horizontal scrollbar on the dialog (spec FR3). Scoped to THIS\n     panel only — never touches the shared DialogForm, so other dialogs are unaffected. */\n  overflow-x: hidden;\n\n  .intro {\n    text-align: center;\n  }\n\n  .scenario {\n    margin-bottom: 1.5rem;\n    padding-bottom: 1rem;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n  }\n\n  .scenario-header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 1rem;\n  }\n\n  /* Let the text column shrink inside the flex row: without min-width:0 a long, unbreakable\n     word keeps its intrinsic width and pushes the fixed-width toggle past the dialog edge. */\n  .scenario-copy {\n    min-width: 0;\n    overflow-wrap: anywhere;\n  }\n\n  .scenario-copy h3 {\n    margin: 0 0 0.25rem;\n    font-size: 1rem;\n    font-weight: 600;\n  }\n\n  .scenario-copy p {\n    margin: 0;\n    font-size: 0.8125rem;\n    text-align: left;\n  }\n\n  .scenario-email {\n    margin-top: 0.75rem;\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n"
    ]);
    _templateObject232 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject233() {
    var data = _tagged_template_literal([
        "\n  display: grid;\n  grid-template-columns: auto 1fr;\n  align-items: center;\n  gap: 10px;\n  padding: ",
        " 10px;\n  cursor: default;\n\n  .who-name {\n    font-weight: ",
        ";\n    color: ",
        ";\n  }\n  /* Card 10 configuration 7's email line: 400 11px/1.3 mono, ink-3. */\n  .who-email {\n    font: ",
        " ",
        " / 1.3 ",
        ";\n    color: ",
        ";\n  }\n  .who-text {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n    overflow-wrap: anywhere;\n  }\n"
    ]);
    _templateObject233 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject234() {
    var data = _tagged_template_literal([
        "\n  /* The bar floats 8 px in from the top and both sides, over the scene. */\n  position: fixed;\n  top: 8px;\n  left: 0;\n  right: 0;\n  padding: 0 0.5rem;\n  z-index: 9;\n"
    ]);
    _templateObject234 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject235() {
    var data = _tagged_template_literal([
        "\n  .right-scrollable-container {\n    max-width: calc(100% - 20px);\n  }\n\n  /* Peak Hours toggle (peak-hours-filter-mvp) — lives in the panel header (via Panel headerActions),\n     a compact switch with its label to the right, sized to match docs/specs/peak hours calendar.png. */\n  .peak-hours-control {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n  }\n\n  /* Shrink the design-system Switch (card 03 draws one size, 50\xd726) to fit this compact header\n     row. A recorded built-vs-card difference, kept at Rob's ruling (2026-10-03). */\n  .peak-hours-control .altsw {\n    transform: scale(0.8);\n    transform-origin: right center;\n  }\n\n  .peak-hours-control .peak-hours-label {\n    font-size: 13px;\n    font-weight: 400;\n    line-height: 1;\n    color: #424242;\n    white-space: nowrap;\n  }\n\n  /* \"No peak hours\" notice — now renders at the top of the calendar body (the toggle moved up). */\n  .peak-hours-notice {\n    margin: 0 0 8px;\n    font-size: 12px;\n    color: #616161;\n  }\n\n  /* Calendar Table */\n  #duration {\n    border-collapse: collapse;\n    margin-bottom: 1rem;\n  }\n\n  #duration th,\n  #duration td {\n    padding: 0;\n    border: 1px solid rgba(255, 255, 255, 1);\n    box-sizing: border-box;\n    text-align: center;\n    user-select: none;\n  }\n\n  #duration td {\n    color: var(--Neutral-Foreground-1-Rest, #242424);\n    text-align: center;\n    font-size: 11px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 16px;\n    position: relative;\n  }\n\n  #duration td::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(255, 255, 255, 0);\n    border: 2px solid transparent;\n    z-index: 1;\n    pointer-events: none;\n  }\n\n  #duration th {\n    line-height: 0%;\n    padding: 0;\n    margin: 0;\n    border: none;\n  }\n\n  .selection-box {\n    position: absolute;\n    border-radius: var(--Medium, 4px);\n    border: var(--Small, 2px) solid #e4fffe;\n    box-shadow: 0 0 2px 2px rgba(255, 255, 255, 0.4);\n    /* Above the cells (which carry z-index: 2) — without this the selection ring is painted behind\n       the opaque cells and is invisible (pre-existing regression, restored here). */\n    z-index: 3;\n  }\n\n  /* Peak-hours block rings: the SVG analogue of .selection-box's frost ring — one stroked path per\n     contiguous peak block. Rounded joins approximate the box's 4px corner radius; the drop-shadow\n     is the SVG analogue of its glow. Non-interactive (the overlay sets pointer-events:none). */\n  .selection-outline-svg {\n    filter: drop-shadow(0 0 2px rgba(255, 255, 255, 0.4));\n  }\n\n  .selection-outline-path {\n    fill: none;\n    stroke: #e4fffe;\n    stroke-width: 2;\n    stroke-linejoin: round;\n    stroke-linecap: round;\n  }\n\n  /* Main diagonal lines class — closed-hour hatching (week-grid core) */\n  .diagonal-overlay {\n    position: absolute;\n    top: 32px;\n    left: 42px;\n    right: 0;\n    bottom: 0;\n    background-image: repeating-linear-gradient(\n      -45deg,\n      transparent,\n      transparent 2px,\n      #999 2px,\n      #999 3px\n    );\n    pointer-events: none;\n    z-index: -1;\n  }\n"
    ]);
    _templateObject235 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject236() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  padding: 0 0.5rem;\n  margin-left: auto;\n  margin-right: auto;\n\n  .loading {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .dashboard-overlay {\n    position: absolute;\n    top: 70px;\n    left: 0.5rem;\n    right: 0.5rem;\n    z-index: 5;\n  }\n\n  /* FR2 'sceneOverlay': the overlay BOX stops swallowing the mouse, so a drag that starts\n     in the empty centre band reaches the always-mounted 3D scene beneath. What is inside it\n     takes the pointer back per element — see BIDashboard's own two rules. Same idiom as\n     the .frame rule below, one level out. */\n  .dashboard-overlay.scene-overlay {\n    pointer-events: none;\n  }\n\n  .frame {\n    display: flex;\n    height: calc(100vh - 120px);\n    margin-top: 42px;\n    align-items: start;\n    pointer-events: none;\n    overflow: hidden;\n  }\n\n  .left-column {\n    flex: 0 0 auto;\n    display: block;\n    overflow: visible;\n    transition: height 0.3s ease;\n  }\n\n  .left-column,\n  .right-column {\n    position: relative;\n    padding-right: 8px;\n    box-sizing: content-box;\n    pointer-events: auto;\n  }\n\n  .right-column {\n    max-width: calc(100% - 20px);\n    width: auto;\n    margin-left: auto;\n    display: flex;\n    overflow: hidden;\n  }\n\n  .calendar {\n    min-width: 400px;\n    margin-left: 20px;\n  }\n\n  .centre-column {\n    display: flex;\n    justify-content: center;\n    flex: 1;\n    position: relative;\n    pointer-events: all;\n  }\n"
    ]);
    _templateObject236 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject237() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  display: inline-block;\n  margin-top: -30px;\n  margin-left: -30px;\n  margin-bottom: 0;\n  margin-right: 0;\n  width: 110px;\n  height: 110px;\n  flex: 0 0 auto;\n\n  &.undonut {\n    visibility: hidden;\n  }\n"
    ]);
    _templateObject237 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject238() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject238 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject239() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject239 = function _templateObject() {
        return data;
    };
    return data;
}
import { BaseDropdown_default, TLSpinner_default, useClickOutside } from "./chunk-VQB55EFK.mjs";
import { CURRENT_MANIFEST_VERSION, DASHBOARD_PANEL_MANIFEST } from "./chunk-VWVZR32R.mjs";
import "./chunk-L6FNNBQC.mjs";
import { ALL_LINES, ALL_MANUFACTURERS, ARRIVED_MS, ASSET_VIRTUAL_SIZE_M, BEST_GUESS, BEST_MATCH, CAMERA_WALL_FILTER_LABELS, CAMERA_WALL_PLACEMENT_STATUS_ORDER, CAMERA_WALL_STATES, CAMERA_WALL_STATE_ORDER, CAMERA_WALL_STATE_ROLE, CameraPicture, CameraWallSurround, CapacityTag, CollapseIcon, ConfirmDialog, DraggablePanel_default, EQUIPMENT_SUGGESTION_LIMIT, EXPAND_EASE, EXPAND_MS, FEED_OUTER_RADIUS, FILL_INFLATION, FLIGHT_DEFAULT_START_SLOPE, FRAME_ZOOM_INSET_PX, FRAME_ZOOM_LAYER, FRAME_ZOOM_REST_MS, FeedDragCard, FlightInterrupted, HierarchyEntityRow, HierarchyTreeRows, IDENTIFIED_SCORE_FOOTNOTE, IDENTIFIED_SCORE_NOTHING, IconDisc, IdentifiedScoreCard, IdentifyPlanCard, IdentifyPlanPicker, IdentifyProductField, IncompleteTargetData, KIND_ICON, KindGlyph, LIST_ROW_STATUS_LOOK, LOCAL_FLIGHT_DURATION, ListGroup_default, MAKERS_IN_TWIN, MAKER_VALUE_PREFIX, MAPBOX_FLIGHT_DURATION, MATCHES, MAX_ZOOM, MIN_ZOOM, MODEL_PICKER_EXACT_MATCH, MODEL_PICKER_FILTER, ModelSquare, NOT_TRACKED_OPTION_LABEL, NOT_TRACKED_VALUE, NO_CAPACITY, NO_SUGGESTIONS, NoOrgContext, ORG_POSE_DEFAULTS, PHASE_2_START_SLOPE_HERMITE, PITCH_AREA, PITCH_DEFAULT, PLACEMENT_TONE, PlacementDot, PlacementFoot, REGISTER_LINK_BUTTON_LABEL, ROW_MOTION_ARRIVED_ATTR, ROW_MOTION_ARRIVED_MS, ROW_MOTION_GAP_CLASS, ROW_MOTION_KEY_ATTR, ROW_STATE_LOOK, RefreshIcon, RowGrip, RowNote, STREAM_DRAG_TYPE, THRESHOLD_KM, TLDialog_default, TYPE_A_MANUFACTURER, TagSwitcher_default, UnknownBid, UnknownTargetKind, VideoIcon, animateSinglePhase, animateTwoPhase, buildHierarchyTree, createEdgeScroller, draggedLook, dropTargetLook, expandedRectFor, groupCaption, groupedOptions, guessedMaker, haversineKm, hermiteEase, identifiedScoreLine, layoutBoxWithin, legacyRankedOptions, linkedRing, listRowLook, makerOptions, makersOnOtherTwinsCaption, modelPickerEmptyText, otherTwinsCaption, pictureAvailable, placementKey, placementSummary, planIdentifyNote, planIdentifyProducts, planIdentifySub, planIdentifyTitle, planIdentifyToastSub, planProductMeta, prefersReducedMotion, productLinesOf, rankManufacturers, rowArrivedLook, rowMotionGapLook, rowPropsEqual, rowStateLookOf, scrollWithin, seedText, toCatalogueQuery, useConfirm, useDragPosition, useIdentifyCardFocus, useIdentifyPicker, useModelPickerOptions, usePlanIdentifyPicker, useRowMotion, useRowProductChange, withArticle } from "./chunk-4ZRWSSCT.mjs";
import { visuallyHidden } from "./chunk-MLHALTYO.mjs";
// src/components/elements/TLInput.tsx
import { forwardRef } from "react";
import { makeStyles, shorthands, useId, Input, Label, MessageBar } from "@fluentui/react-components";
import { jsx, jsxs } from "react/jsx-runtime";
var useStyles = makeStyles({
    root: _object_spread({
        display: "flex",
        flexDirection: "column"
    }, shorthands.gap("2px")),
    desc: {
        fontSize: "12px",
        color: "#00000085"
    }
});
var TLInput = forwardRef(function(param, ref3) {
    var className = param.className, id = param.id, label = param.label, description = param.description, errorMessage = param.errorMessage, props = param.props;
    var inputId = useId(id);
    var styles = useStyles();
    return /* @__PURE__ */ jsx("div", {
        className: className,
        children: /* @__PURE__ */ jsxs("div", {
            className: styles.root,
            children: [
                /* @__PURE__ */ jsx(Label, {
                    htmlFor: inputId,
                    size: props.size,
                    disabled: props.disabled,
                    children: label
                }),
                description ? /* @__PURE__ */ jsx("p", {
                    className: styles.desc,
                    children: description
                }) : null,
                /* @__PURE__ */ jsx(Input, _object_spread({
                    ref: ref3,
                    id: inputId
                }, props)),
                errorMessage ? /* @__PURE__ */ jsx(MessageBar, {
                    id: "".concat(id, "-error"),
                    intent: "error",
                    children: errorMessage
                }) : null
            ]
        })
    });
});
var TLInput_default = TLInput;
// src/components/elements/Buttons/PrimaryButton.tsx
import { Button } from "@repo/design-system";
import { Align } from "@repo/frontend-types";
import { jsx as jsx2 } from "react/jsx-runtime";
var PrimaryButton = function(param) {
    var className = param.className, icon = param.icon, children = param.children, align = param.align, disabled = param.disabled, onClick = param.onClick, _param_type = param.type, type = _param_type === void 0 ? "button" : _param_type;
    var justifyContent = align === Align.LEFT ? "flex-start" : align === Align.RIGHT ? "flex-end" : void 0;
    return /* @__PURE__ */ jsx2(Button, {
        variant: "primary",
        size: "full",
        type: type,
        className: className,
        disabled: disabled,
        onClick: onClick,
        iconLeft: icon,
        style: justifyContent ? {
            justifyContent: justifyContent
        } : void 0,
        children: children
    });
};
var PrimaryButton_default = PrimaryButton;
// src/components/elements/Buttons/SecondaryButton.tsx
import { Button as Button2 } from "@repo/design-system";
import { jsx as jsx3 } from "react/jsx-runtime";
var SecondaryButton = function(_param) {
    var children = _param.children, _param_type = _param.type, type = _param_type === void 0 ? "button" : _param_type, rest = _object_without_properties(_param, [
        "children",
        "type"
    ]);
    return /* @__PURE__ */ jsx3(Button2, _object_spread_props(_object_spread({
        variant: "frosted",
        size: "full",
        type: type
    }, rest), {
        children: children
    }));
};
var SecondaryButton_default = SecondaryButton;
// src/components/elements/TLAdminInput/TLAdminInput.tsx
import { forwardRef as forwardRef2, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { FieldMode } from "@repo/frontend-types";
import { Pen20Filled, Pen20Regular, Eye20Regular, EyeOff20Regular } from "@fluentui/react-icons";
import { Fragment, jsx as jsx4, jsxs as jsxs2 } from "react/jsx-runtime";
var TLAdminInput = forwardRef2(function(_param, ref3) {
    var id = _param.id, className = _param.className, label = _param.label, _param_type = _param.type, type = _param_type === void 0 ? "text" : _param_type, currentValue = _param.currentValue, description = _param.description, errorMessage = _param.errorMessage, enableModes = _param.enableModes, discard = _param.discard, autoFocus = _param.autoFocus, resetForm = _param.resetForm, placeholder = _param.placeholder, props = _object_without_properties(_param, [
        "id",
        "className",
        "label",
        "type",
        "currentValue",
        "description",
        "errorMessage",
        "enableModes",
        "discard",
        "autoFocus",
        "resetForm",
        "placeholder"
    ]);
    var _useState = _sliced_to_array(useState(FieldMode.READ), 2), fieldMode = _useState[0], setFieldMode = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), showPassword = _useState1[0], setShowPassword = _useState1[1];
    var localRef = useRef(null);
    useEffect(function() {
        setFieldMode(FieldMode.READ);
    }, [
        discard
    ]);
    useEffect(function() {
        if (fieldMode === FieldMode.EDIT && localRef.current) {
            localRef.current.focus();
            var supportedTypes = [
                "text",
                "search",
                "tel",
                "password",
                "url"
            ];
            if (supportedTypes.includes(type)) {
                var length = localRef.current.value.length;
                localRef.current.setSelectionRange(length, length);
            }
        }
    }, [
        fieldMode,
        type
    ]);
    var labelElement = typeof label === "function" ? label() : label;
    var isPasswordField = type === "password";
    var inputType = isPasswordField && showPassword ? "text" : type;
    return /* @__PURE__ */ jsxs2(Fragment, {
        children: [
            /* @__PURE__ */ jsxs2("div", {
                className: className,
                children: [
                    /* @__PURE__ */ jsx4("label", {
                        htmlFor: id,
                        children: labelElement
                    }),
                    !enableModes || fieldMode === FieldMode.EDIT ? /* @__PURE__ */ jsxs2("div", {
                        className: "input-container",
                        children: [
                            /* @__PURE__ */ jsx4("input", _object_spread({
                                ref: function(node) {
                                    if (typeof ref3 === "function") ref3(node);
                                    localRef.current = node;
                                },
                                id: id,
                                type: inputType ? inputType : "text",
                                placeholder: placeholder ? placeholder : "Type here",
                                defaultValue: currentValue,
                                autoFocus: enableModes && fieldMode === FieldMode.EDIT ? true : autoFocus ? true : false
                            }, props)),
                            isPasswordField && /* @__PURE__ */ jsx4("button", {
                                type: "button",
                                className: "password-toggle",
                                onClick: function() {
                                    return setShowPassword(!showPassword);
                                },
                                "aria-label": showPassword ? "Hide password" : "Show password",
                                children: showPassword ? /* @__PURE__ */ jsx4(EyeOff20Regular, {}) : /* @__PURE__ */ jsx4(Eye20Regular, {})
                            })
                        ]
                    }) : /* @__PURE__ */ jsx4("p", {
                        children: currentValue
                    }),
                    enableModes && /* @__PURE__ */ jsx4("button", {
                        type: "button",
                        className: fieldMode === FieldMode.EDIT ? "edit-mode" : "",
                        onClick: function() {
                            setFieldMode(fieldMode === FieldMode.EDIT ? FieldMode.READ : FieldMode.EDIT);
                        },
                        children: fieldMode === FieldMode.EDIT ? /* @__PURE__ */ jsx4(Pen20Filled, {}) : /* @__PURE__ */ jsx4(Pen20Regular, {})
                    })
                ]
            }),
            errorMessage ? /* @__PURE__ */ jsx4("div", {
                id: "".concat(id, "-error"),
                className: "error-message",
                children: errorMessage
            }) : null
        ]
    });
});
var TLAdminInput_default = styled(TLAdminInput)(_templateObject());
// src/components/elements/TLAdminSelect/TLAdminSelect.tsx
import { useEffect as useEffect2, useState as useState2 } from "react";
import styled2 from "styled-components";
import { FieldMode as FieldMode2 } from "@repo/frontend-types";
import { Pen20Filled as Pen20Filled2, Pen20Regular as Pen20Regular2 } from "@fluentui/react-icons";
import { Fragment as Fragment2, jsx as jsx5, jsxs as jsxs3 } from "react/jsx-runtime";
var TLAdminSelect = function(param) {
    var className = param.className, stacked = param.stacked, currentValue = param.currentValue, discard = param.discard, errorMessage = param.errorMessage, enableModes = param.enableModes, id = param.id, label = param.label, options = param.options, props = param.props;
    var _useState2 = _sliced_to_array(useState2(FieldMode2.READ), 2), fieldMode = _useState2[0], setFieldMode = _useState2[1];
    useEffect2(function() {
        setFieldMode(FieldMode2.READ);
    }, [
        discard
    ]);
    return /* @__PURE__ */ jsxs3(Fragment2, {
        children: [
            /* @__PURE__ */ jsxs3("div", {
                className: "".concat(className, " ").concat(stacked ? "stacked" : ""),
                children: [
                    /* @__PURE__ */ jsx5("label", {
                        htmlFor: id,
                        children: label
                    }),
                    !enableModes || fieldMode === FieldMode2.EDIT ? /* @__PURE__ */ jsx5("select", _object_spread_props(_object_spread({
                        id: id
                    }, props), {
                        children: options && options.map(function(opt, i) {
                            return /* @__PURE__ */ jsx5("option", {
                                value: opt.value,
                                children: opt.text
                            }, i);
                        })
                    })) : /* @__PURE__ */ jsx5("p", {
                        children: currentValue
                    }),
                    enableModes && /* @__PURE__ */ jsx5("button", {
                        type: "button",
                        className: fieldMode === FieldMode2.EDIT ? "edit-mode" : "",
                        onClick: function() {
                            setFieldMode(fieldMode === FieldMode2.EDIT ? FieldMode2.READ : FieldMode2.EDIT);
                        },
                        children: fieldMode === FieldMode2.EDIT ? /* @__PURE__ */ jsx5(Pen20Filled2, {}) : /* @__PURE__ */ jsx5(Pen20Regular2, {})
                    })
                ]
            }),
            (!enableModes || fieldMode === FieldMode2.EDIT) && errorMessage ? /* @__PURE__ */ jsx5("div", {
                id: "".concat(id, "-error"),
                className: "error-message",
                children: errorMessage
            }) : null
        ]
    });
};
var TLAdminSelect_default = styled2(TLAdminSelect)(_templateObject1());
// src/components/elements/TLAdminData/TLAdminData.tsx
import styled3 from "styled-components";
import { Label as Label2 } from "@fluentui/react-components";
import { Fragment as Fragment3, jsx as jsx6, jsxs as jsxs4 } from "react/jsx-runtime";
var TLAdminData = function(param) {
    var className = param.className, id = param.id, label = param.label, value = param.value;
    return /* @__PURE__ */ jsx6(Fragment3, {
        children: /* @__PURE__ */ jsxs4("div", {
            className: className,
            children: [
                /* @__PURE__ */ jsx6(Label2, {
                    htmlFor: id,
                    children: label
                }),
                /* @__PURE__ */ jsx6("p", {
                    id: id,
                    children: /* @__PURE__ */ jsx6("strong", {
                        children: value ? value : "NA"
                    })
                })
            ]
        })
    });
};
var TLAdminData_default = styled3(TLAdminData)(_templateObject2());
// src/components/elements/TLSearch/TLSearch.tsx
import styled4 from "styled-components";
import { Search20Regular } from "@fluentui/react-icons";
import { jsx as jsx7, jsxs as jsxs5 } from "react/jsx-runtime";
var TLSearch = function(param) {
    var className = param.className, dataTestId = param.dataTestId, placeholder = param.placeholder, isLoading = param.isLoading, setSearchQuery = param.setSearchQuery;
    var handleInputChange = function(e) {
        var value = e.target.value;
        if (/^[a-zA-Z0-9@'-]*$/.test(value)) {
            setSearchQuery(value);
        }
    };
    return /* @__PURE__ */ jsxs5("div", {
        className: className,
        children: [
            /* @__PURE__ */ jsx7("div", {
                className: "search-bar-icon",
                children: /* @__PURE__ */ jsx7(Search20Regular, {})
            }),
            /* @__PURE__ */ jsx7("input", {
                "data-testid": dataTestId,
                disabled: isLoading,
                placeholder: placeholder ? placeholder : "Type to search",
                onChange: handleInputChange
            })
        ]
    });
};
var TLSearch_default = styled4(TLSearch)(_templateObject3(), function(props) {
    return props.borderColor || "#d9d9d9";
});
// src/components/elements/TLCard/TLCard.tsx
import styled5 from "styled-components";
import { Card } from "@fluentui/react-components";
import { jsx as jsx8 } from "react/jsx-runtime";
var TLCard = function(param) {
    var className = param.className, children = param.children, padding = param.padding, size2 = param.size, selected = param.selected, hovered = param.hovered;
    return /* @__PURE__ */ jsx8(Card, {
        className: "".concat(className, " ").concat(selected ? "selected" : "", " ").concat(hovered ? "hovered" : ""),
        style: {
            padding: padding || "8px"
        },
        size: size2,
        children: children
    });
};
var TLCard_default = styled5(TLCard)(_templateObject4());
// src/components/elements/TLSwitcher/TLSwitcher.tsx
import { useEffect as useEffect3, useState as useState3 } from "react";
import styled6 from "styled-components";
import { Tab, TabList } from "@fluentui/react-components";
import { jsx as jsx9 } from "react/jsx-runtime";
var TLSwitcher = function(param) {
    var className = param.className, selectedValue = param.selectedValue, tmp = param.size, size2 = tmp === void 0 ? "medium" : tmp, options = param.options, setValue = param.setValue;
    useEffect3(function() {
        setValue === null || setValue === void 0 ? void 0 : setValue(selectedValue);
    }, [
        selectedValue,
        setValue
    ]);
    var _useState3 = _sliced_to_array(useState3(selectedValue ? selectedValue : ""), 2), selectedTab = _useState3[0], setSelectedTab = _useState3[1];
    var handleTabSelect = function(_event, data) {
        setSelectedTab(String(data.value));
    };
    useEffect3(function() {
        if (selectedValue) {
            setSelectedTab(selectedValue);
        }
    }, [
        selectedValue
    ]);
    return /* @__PURE__ */ jsx9(TabList, {
        className: className,
        size: size2,
        selectedValue: selectedTab,
        onTabSelect: handleTabSelect,
        children: options.map(function(opt, i) {
            return /* @__PURE__ */ jsx9(Tab, {
                icon: opt.activeIcon && opt.value === selectedTab ? opt.activeIcon : opt.inactiveIcon,
                value: opt.value,
                onClick: setValue ? function() {
                    return setValue(opt.value);
                } : function() {},
                children: opt.text
            }, i);
        })
    });
};
var TLSwitcher_default = styled6(TLSwitcher)(_templateObject5());
// src/components/elements/TLAvatar/TLAvatar.tsx
import styled7 from "styled-components";
import { Avatar, NAV_AVATAR, accountMenuLabel } from "@repo/design-system";
import { brand, motion } from "@repo/design-tokens";
import { jsx as jsx10 } from "react/jsx-runtime";
var TLAvatar = function(param) {
    var src = param.src, name = param.name, onClick = param.onClick, className = param.className;
    return /* @__PURE__ */ jsx10("button", {
        type: "button",
        className: className,
        onClick: onClick,
        "aria-label": accountMenuLabel(name),
        children: /* @__PURE__ */ jsx10(Avatar, {
            name: name,
            src: src,
            size: "md"
        })
    });
};
var TLAvatar_default = styled7(TLAvatar)(_templateObject6(), NAV_AVATAR.glass.rest, motion.durFast, motion.easeUi, motion.durFast, motion.easeUi, NAV_AVATAR.glass.hoverFill, NAV_AVATAR.glass.hover, brand.focusRing);
// src/components/elements/CustomDropdown/CustomDropdown.tsx
import { useState as useState4, useEffect as useEffect4, useRef as useRef2, useCallback } from "react";
import { createPortal } from "react-dom";
import styled8 from "styled-components";
import { Fragment as Fragment4, jsx as jsx11, jsxs as jsxs6 } from "react/jsx-runtime";
var CustomDropdown = function(param) {
    var options = param.options, placeholder = param.placeholder, selectedValue = param.selectedValue, onSelect = param.onSelect, icon = param.icon, className = param.className, _param_direction = param.direction, direction = _param_direction === void 0 ? "down" : _param_direction;
    var _useState4 = _sliced_to_array(useState4(false), 2), isOpen = _useState4[0], setIsOpen = _useState4[1];
    var dropdownRef = useRef2(null);
    var _useState41 = _sliced_to_array(useState4({
        top: 0,
        left: 0,
        width: 0
    }), 2), dropdownPosition = _useState41[0], setDropdownPosition = _useState41[1];
    var updateDropdownPosition = useCallback(function() {
        if (dropdownRef.current) {
            var rect = dropdownRef.current.getBoundingClientRect();
            setDropdownPosition({
                top: rect.bottom + 4,
                left: rect.left,
                width: rect.width
            });
        }
    }, []);
    useEffect4(function() {
        var handleClickOutside = function(event) {
            if (isOpen) {
                var target = event.target;
                if (!target.closest(".custom-dropdown") && !target.closest(".dropdown-options-portal")) {
                    setIsOpen(false);
                }
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        isOpen
    ]);
    useEffect4(function() {
        if (isOpen) {
            var handlePositionUpdate = function() {
                updateDropdownPosition();
            };
            window.addEventListener("scroll", handlePositionUpdate, true);
            window.addEventListener("resize", handlePositionUpdate);
            return function() {
                window.removeEventListener("scroll", handlePositionUpdate, true);
                window.removeEventListener("resize", handlePositionUpdate);
            };
        }
    }, [
        isOpen,
        updateDropdownPosition
    ]);
    var selectedOption = options.find(function(option) {
        return option.value === selectedValue;
    });
    var displayText = selectedOption ? selectedOption.label : placeholder;
    var handleToggleDropdown = function() {
        if (!isOpen) {
            updateDropdownPosition();
        }
        setIsOpen(!isOpen);
    };
    var dropdownOptions = isOpen ? createPortal(/* @__PURE__ */ jsx11("div", {
        className: "dropdown-options-portal",
        style: {
            position: "fixed",
            top: dropdownPosition.top,
            left: dropdownPosition.left,
            width: dropdownPosition.width,
            zIndex: 999999,
            background: "#fff",
            border: "1px solid #e5e7eb",
            borderRadius: "8px",
            boxShadow: "0px 4px 16px 0px rgba(0, 0, 0, 0.15)",
            overflow: "hidden",
            minWidth: "100%",
            maxHeight: "400px",
            overflowY: "auto"
        },
        children: options.map(function(option) {
            return /* @__PURE__ */ jsx11("div", {
                className: "dropdown-option ".concat(option.disabled ? "disabled" : ""),
                style: {
                    padding: "12px 16px",
                    cursor: option.disabled ? "default" : "pointer",
                    fontSize: "16px",
                    fontFamily: "'Segoe UI', Arial, sans-serif",
                    color: option.disabled ? "#9ca3af" : "#242424",
                    fontWeight: 400,
                    lineHeight: "20px",
                    transition: "background-color 0.2s ease",
                    borderBottom: "1px solid #f3f4f6"
                },
                onMouseEnter: function(e) {
                    if (!option.disabled) {
                        e.target.style.backgroundColor = "#f3f4f6";
                    }
                },
                onMouseLeave: function(e) {
                    e.target.style.backgroundColor = "transparent";
                },
                onClick: function(e) {
                    e.stopPropagation();
                    if (!option.disabled) {
                        onSelect(option.value);
                        setIsOpen(false);
                    }
                },
                children: option.label
            }, option.value);
        })
    }), document.body) : null;
    return /* @__PURE__ */ jsxs6(Fragment4, {
        children: [
            /* @__PURE__ */ jsx11("div", {
                className: className,
                "data-direction": direction,
                children: /* @__PURE__ */ jsxs6("div", {
                    className: "custom-dropdown",
                    ref: dropdownRef,
                    onClick: handleToggleDropdown,
                    children: [
                        /* @__PURE__ */ jsxs6("div", {
                            className: "dropdown-content",
                            children: [
                                icon && /* @__PURE__ */ jsx11("div", {
                                    className: "dropdown-icon",
                                    children: icon
                                }),
                                /* @__PURE__ */ jsx11("span", {
                                    className: "dropdown-text",
                                    children: displayText
                                })
                            ]
                        }),
                        /* @__PURE__ */ jsx11("svg", {
                            className: "dropdown-arrow ".concat(isOpen ? "open" : ""),
                            width: "16",
                            height: "16",
                            viewBox: "0 0 16 16",
                            fill: "none",
                            children: /* @__PURE__ */ jsx11("path", {
                                d: "M4 6L8 10L12 6",
                                stroke: "currentColor",
                                strokeWidth: "1.5",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            })
                        })
                    ]
                })
            }),
            dropdownOptions
        ]
    });
};
var CustomDropdown_default = styled8(CustomDropdown)(_templateObject7());
// src/components/elements/EditableFieldRow/EditableFieldRow.tsx
import React6, { useState as useState5 } from "react";
import styled9 from "styled-components";
import { Pen24Regular, Save24Regular, Delete24Regular, Eye24Regular, EyeOff24Regular } from "@fluentui/react-icons";
import { Fragment as Fragment5, jsx as jsx12, jsxs as jsxs7 } from "react/jsx-runtime";
var EditableFieldRow = function(param) {
    var className = param.className, label = param.label, _param_value = param.value, value = _param_value === void 0 ? "" : _param_value, _param_type = param.type, type = _param_type === void 0 ? "text" : _param_type, _param_placeholder = param.placeholder, placeholder = _param_placeholder === void 0 ? "" : _param_placeholder, _param_isEditing = param.isEditing, isEditing = _param_isEditing === void 0 ? false : _param_isEditing, _param_isPassword = param.isPassword, isPassword = _param_isPassword === void 0 ? false : _param_isPassword, onEdit = param.onEdit, onSave = param.onSave, onCancel = param.onCancel, onDelete = param.onDelete, errorMessage = param.errorMessage, validator = param.validator, _param_showPasswordToggle = param.showPasswordToggle, showPasswordToggle = _param_showPasswordToggle === void 0 ? false : _param_showPasswordToggle, _param_selectOptions = param.selectOptions, selectOptions = _param_selectOptions === void 0 ? [] : _param_selectOptions, _param_useSimpleSelect = param.useSimpleSelect, useSimpleSelect = _param_useSimpleSelect === void 0 ? false : _param_useSimpleSelect;
    var _useState5 = _sliced_to_array(useState5(value), 2), editingValue = _useState5[0], setEditingValue = _useState5[1];
    var _useState51 = _sliced_to_array(useState5(false), 2), showPassword = _useState51[0], setShowPassword = _useState51[1];
    var _useState52 = _sliced_to_array(useState5(""), 2), localError = _useState52[0], setLocalError = _useState52[1];
    var _useState53 = _sliced_to_array(useState5(true), 2), inputReadOnly = _useState53[0], setInputReadOnly = _useState53[1];
    React6.useEffect(function() {
        setEditingValue(value);
    }, [
        value
    ]);
    React6.useEffect(function() {
        if (isEditing) {
            setInputReadOnly(true);
            var timer = setTimeout(function() {
                setInputReadOnly(false);
            }, 100);
            return function() {
                return clearTimeout(timer);
            };
        }
    }, [
        isEditing
    ]);
    var getDisplayValue = function() {
        if (type === "select") {
            var selectedOption = selectOptions.find(function(option) {
                return option.value === value;
            });
            return selectedOption ? selectedOption.label : value || "Please select";
        }
        return isPassword && value ? showPassword ? value : "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022" : value || "Not set";
    };
    var displayValue = getDisplayValue();
    var inputType = isPassword ? showPassword ? "text" : "password" : type;
    var handleEdit = function() {
        setEditingValue(value);
        setLocalError("");
        onEdit === null || onEdit === void 0 ? void 0 : onEdit(value);
    };
    var handleSave = function() {
        if (validator) {
            var validationResult = validator(editingValue);
            if (typeof validationResult === "string") {
                setLocalError(validationResult);
                return;
            }
            if (!validationResult) {
                setLocalError("Invalid value");
                return;
            }
        }
        setLocalError("");
        onSave === null || onSave === void 0 ? void 0 : onSave(editingValue);
    };
    var handleCancel = function() {
        setEditingValue(value);
        setLocalError("");
        onCancel === null || onCancel === void 0 ? void 0 : onCancel();
    };
    var hasError = !!(errorMessage || localError);
    var fieldName = "field_".concat(Math.random().toString(36).slice(2, 11), "_").concat(Date.now());
    var getAutocompleteValue = function() {
        if (isPassword || label.toLowerCase().includes("password")) {
            return "one-time-code";
        }
        if (label.toLowerCase().includes("username") || label.toLowerCase().includes("user")) {
            return "one-time-code";
        }
        return "one-time-code";
    };
    var handleInputFocus = function() {
        setInputReadOnly(false);
    };
    return /* @__PURE__ */ jsx12("div", {
        className: className,
        children: /* @__PURE__ */ jsxs7("div", {
            className: "field-row",
            children: [
                /* @__PURE__ */ jsxs7("span", {
                    className: "field-label",
                    children: [
                        label,
                        ":"
                    ]
                }),
                isEditing ? /* @__PURE__ */ jsxs7(Fragment5, {
                    children: [
                        /* @__PURE__ */ jsxs7("div", {
                            className: "field-input-container",
                            children: [
                                /* @__PURE__ */ jsxs7("div", {
                                    className: "input-with-icon",
                                    children: [
                                        type === "select" ? useSimpleSelect ? /* @__PURE__ */ jsxs7("select", {
                                            className: "field-input ".concat(hasError ? "error" : ""),
                                            value: editingValue,
                                            onChange: function(e) {
                                                setEditingValue(e.target.value);
                                                setLocalError("");
                                            },
                                            children: [
                                                /* @__PURE__ */ jsx12("option", {
                                                    value: ""
                                                }),
                                                selectOptions.map(function(option) {
                                                    return /* @__PURE__ */ jsx12("option", {
                                                        value: option.value,
                                                        children: option.label
                                                    }, option.value);
                                                })
                                            ]
                                        }) : /* @__PURE__ */ jsx12(CustomDropdown_default, {
                                            options: selectOptions.map(function(option) {
                                                return {
                                                    value: option.value,
                                                    label: option.label
                                                };
                                            }),
                                            placeholder: placeholder,
                                            selectedValue: editingValue,
                                            onSelect: function(value2) {
                                                setEditingValue(value2);
                                                setLocalError("");
                                            }
                                        }) : /* @__PURE__ */ jsx12("input", {
                                            className: "field-input ".concat(hasError ? "error" : ""),
                                            type: inputType,
                                            name: fieldName,
                                            value: editingValue,
                                            placeholder: placeholder,
                                            readOnly: inputReadOnly,
                                            autoComplete: getAutocompleteValue(),
                                            autoCorrect: "off",
                                            autoCapitalize: "off",
                                            spellCheck: "false",
                                            "data-lpignore": "true",
                                            "data-bw-ignore": "true",
                                            "data-1p-ignore": "true",
                                            "data-dashlane-ignore": "true",
                                            "data-form-type": "other",
                                            role: "presentation",
                                            onChange: function(e) {
                                                setEditingValue(e.target.value);
                                                setLocalError("");
                                            },
                                            onFocus: handleInputFocus,
                                            autoFocus: true
                                        }),
                                        (isPassword || showPasswordToggle) && type !== "select" && /* @__PURE__ */ jsx12("button", {
                                            type: "button",
                                            className: "password-toggle-btn",
                                            onClick: function() {
                                                return setShowPassword(!showPassword);
                                            },
                                            "aria-label": showPassword ? "Hide password" : "Show password",
                                            children: showPassword ? /* @__PURE__ */ jsx12(EyeOff24Regular, {}) : /* @__PURE__ */ jsx12(Eye24Regular, {})
                                        })
                                    ]
                                }),
                                hasError && /* @__PURE__ */ jsx12("div", {
                                    className: "field-error",
                                    children: errorMessage || localError
                                })
                            ]
                        }),
                        /* @__PURE__ */ jsx12("button", {
                            type: "button",
                            className: "action-btn save-btn",
                            onClick: handleSave,
                            "aria-label": "Save ".concat(label),
                            children: /* @__PURE__ */ jsx12(Save24Regular, {})
                        }),
                        /* @__PURE__ */ jsx12("button", {
                            type: "button",
                            className: "action-btn cancel-btn",
                            onClick: handleCancel,
                            "aria-label": "Cancel ".concat(label),
                            children: /* @__PURE__ */ jsx12(Delete24Regular, {})
                        })
                    ]
                }) : /* @__PURE__ */ jsxs7(Fragment5, {
                    children: [
                        /* @__PURE__ */ jsxs7("div", {
                            className: "field-value-container",
                            children: [
                                /* @__PURE__ */ jsx12("span", {
                                    className: "field-value",
                                    children: displayValue
                                }),
                                (isPassword || showPasswordToggle) && value && /* @__PURE__ */ jsx12("button", {
                                    type: "button",
                                    className: "password-toggle-btn",
                                    onClick: function() {
                                        return setShowPassword(!showPassword);
                                    },
                                    "aria-label": showPassword ? "Hide password" : "Show password",
                                    children: showPassword ? /* @__PURE__ */ jsx12(EyeOff24Regular, {}) : /* @__PURE__ */ jsx12(Eye24Regular, {})
                                })
                            ]
                        }),
                        /* @__PURE__ */ jsx12("button", {
                            type: "button",
                            className: "action-btn edit-btn",
                            onClick: handleEdit,
                            "aria-label": "Edit ".concat(label),
                            children: /* @__PURE__ */ jsx12(Pen24Regular, {})
                        }),
                        onDelete && /* @__PURE__ */ jsx12("button", {
                            type: "button",
                            className: "action-btn delete-btn",
                            onClick: onDelete,
                            "aria-label": "Delete ".concat(label),
                            children: /* @__PURE__ */ jsx12(Delete24Regular, {})
                        })
                    ]
                })
            ]
        })
    });
};
var EditableFieldRow_default = styled9(EditableFieldRow)(_templateObject8());
// src/components/elements/PanelCard/PanelCard.tsx
import styled10 from "styled-components";
import { jsx as jsx13 } from "react/jsx-runtime";
var PanelCard = function(param) {
    var className = param.className, children = param.children, _param_isHovered = param.isHovered, isHovered = _param_isHovered === void 0 ? false : _param_isHovered, _param_padding = param.padding, padding = _param_padding === void 0 ? "0" : _param_padding;
    return /* @__PURE__ */ jsx13("div", {
        className: "".concat(className, " ").concat(isHovered ? "hovered" : ""),
        children: children
    });
};
var PanelCard_default = styled10(PanelCard)(_templateObject9(), function(props) {
    return props.padding || "0";
}, function(props) {
    var _props_theme_colors_brand, _props_theme_colors, _props_theme;
    return ((_props_theme = props.theme) === null || _props_theme === void 0 ? void 0 : (_props_theme_colors = _props_theme.colors) === null || _props_theme_colors === void 0 ? void 0 : (_props_theme_colors_brand = _props_theme_colors.brand) === null || _props_theme_colors_brand === void 0 ? void 0 : _props_theme_colors_brand[80]) || "#00bbcc";
});
// src/components/elements/TLAccordion/TLAccordion.tsx
import { Accordion } from "@fluentui/react-components";
import { jsx as jsx14 } from "react/jsx-runtime";
var TLAccordion = function(param) {
    var className = param.className, _param_collapsible = param.collapsible, collapsible = _param_collapsible === void 0 ? true : _param_collapsible, children = param.children, props = param.props;
    return /* @__PURE__ */ jsx14(Accordion, _object_spread_props(_object_spread({
        className: className,
        collapsible: collapsible
    }, props), {
        children: children
    }));
};
var TLAccordion_default = TLAccordion;
// src/components/elements/TLAdminSwitch/TLAdminSwitch.tsx
import { forwardRef as forwardRef3 } from "react";
import { Switch } from "@repo/design-system";
import { jsx as jsx15 } from "react/jsx-runtime";
var TLAdminSwitch = forwardRef3(function(_param, ref3) {
    var className = _param.className, id = _param.id, label = _param.label, ariaLabel = _param.ariaLabel, currentValue = _param.currentValue, errorMessage = _param.errorMessage, tmp = _param.surface, surface12 = tmp === void 0 ? "on-solid" : tmp, props = _object_without_properties(_param, [
        "className",
        "id",
        "label",
        "ariaLabel",
        "currentValue",
        "errorMessage",
        "surface"
    ]);
    return /* @__PURE__ */ jsx15(Switch, _object_spread_props(_object_spread({
        ref: ref3,
        id: id,
        surface: surface12,
        className: className,
        "aria-label": ariaLabel,
        error: Boolean(errorMessage),
        description: errorMessage
    }, props), {
        children: label
    }));
});
TLAdminSwitch.displayName = "TLAdminSwitch";
var TLAdminSwitch_default = TLAdminSwitch;
// src/components/elements/TLTabList/TLTabList.tsx
import { Tab as Tab2, TabList as TabList2 } from "@fluentui/react-components";
import { jsx as jsx16 } from "react/jsx-runtime";
var TLTabList = function(param) {
    var className = param.className, props = param.props, selectedValue = param.selectedValue, options = param.options, setValue = param.setValue;
    return /* @__PURE__ */ jsx16("div", {
        className: className,
        children: /* @__PURE__ */ jsx16(TabList2, {
            defaultSelectedValue: selectedValue,
            children: options.map(function(opt, i) {
                return /* @__PURE__ */ jsx16(Tab2, {
                    icon: opt.activeIcon ? opt.activeIcon : null,
                    value: opt.value,
                    onClick: setValue ? function() {
                        return setValue(opt.value);
                    } : function() {},
                    children: opt.text
                }, i);
            })
        })
    });
};
var TLTabList_default = TLTabList;
// src/components/elements/GlassButton/GlassButton.tsx
import { Button as Button3 } from "@repo/design-system";
import { jsx as jsx17 } from "react/jsx-runtime";
var GlassButton = function(_param) {
    var children = _param.children, rest = _object_without_properties(_param, [
        "children"
    ]);
    return /* @__PURE__ */ jsx17(Button3, _object_spread_props(_object_spread({
        variant: "frosted",
        size: "inline"
    }, rest), {
        children: /* @__PURE__ */ jsx17("span", {
            style: {
                display: "inline-flex",
                alignItems: "center",
                gap: "0.5rem"
            },
            children: children
        })
    }));
};
var GlassButton_default = GlassButton;
// src/components/elements/TLLink/TLLink.tsx
import { Link as RRDLink } from "react-router-dom";
import { Link } from "@fluentui/react-components";
import { jsx as jsx18 } from "react/jsx-runtime";
var TLLink = function(param) {
    var href = param.href, text = param.text, props = param.props;
    return /* @__PURE__ */ jsx18(RRDLink, {
        to: href,
        children: /* @__PURE__ */ jsx18(Link, _object_spread_props(_object_spread({}, props), {
            children: text
        }))
    });
};
var TLLink_default = TLLink;
// src/components/DialogRenderer/DialogRenderer.tsx
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useDialogContext } from "@repo/front-end-state";
import { jsx as jsx19 } from "react/jsx-runtime";
var queryClient = new QueryClient();
var DialogRenderer = function() {
    var _useDialogContext = useDialogContext(), dialogProps = _useDialogContext.dialogProps, hideDialog = _useDialogContext.hideDialog;
    if (!dialogProps) return null;
    return /* @__PURE__ */ jsx19(QueryClientProvider, {
        client: queryClient,
        children: /* @__PURE__ */ jsx19(TLDialog_default, {
            defaultOpen: true,
            title: dialogProps.title,
            dialogContent: dialogProps.content,
            width: dialogProps.width,
            onClose: hideDialog
        })
    });
};
var DialogRenderer_default = DialogRenderer;
// src/components/AssetRegister/AssetRegisterList.tsx
import { useEffect as useEffect5, useMemo, useRef as useRef3, useState as useState6 } from "react";
import styled12 from "styled-components";
import { semantic as semantic2, space as space2, typeRole as typeRole2 } from "@repo/design-tokens";
import { Banner as Banner2, Button as Button5, Input as Input2, Select, Table, Tag } from "@repo/design-system";
import { ASSET_COVERAGE_LABEL, buildAssetCoverageIndex, isGenericCatalogueManufacturer, catalogueMatchText, isUncatalogued, nextSort, NO_CATALOGUE_MATCH_GROUP, NOT_IN_CATALOGUE_LABEL, registerRowName, sortRows } from "@repo/front-end-utils";
import { useUserStore } from "@repo/front-end-state";
import { Roles } from "@repo/frontend-types";
// src/components/AssetRegister/RegisterNotices.tsx
import styled11 from "styled-components";
import { semantic, space, typeRole } from "@repo/design-tokens";
import { Banner, Button as Button4 } from "@repo/design-system";
import { Fragment as Fragment6, jsx as jsx20, jsxs as jsxs8 } from "react/jsx-runtime";
var RegisterWriteBanners = function(param) {
    var actionError = param.actionError, actionErrorKey = param.actionErrorKey, actionNotice = param.actionNotice;
    if (!actionError && !actionNotice) return null;
    return /* @__PURE__ */ jsxs8(Fragment6, {
        children: [
            actionError && /* @__PURE__ */ jsx20(Banner, {
                surface: "on-solid",
                tone: "error",
                title: "That change was not made.",
                children: actionError
            }, actionErrorKey),
            actionNotice && /* @__PURE__ */ jsx20(Banner, {
                surface: "on-solid",
                tone: "success",
                title: "Register updated.",
                children: actionNotice
            })
        ]
    });
};
var RemoveAllButton = function(param) {
    var planKnown = param.planKnown, onClick = param.onClick;
    return /* @__PURE__ */ jsx20(Button4, {
        variant: "frosted",
        size: "default",
        "aria-disabled": !planKnown,
        "aria-label": planKnown ? void 0 : "Remove all \u2014 unavailable until the plan has loaded",
        onClick: onClick,
        "data-register-remove-all": "",
        children: "Remove all"
    });
};
var removeAllReturnFocus = function() {
    return {
        get current () {
            if (typeof document === "undefined") return null;
            var _document_querySelector;
            return (_document_querySelector = document.querySelector("[data-register-remove-all]")) !== null && _document_querySelector !== void 0 ? _document_querySelector : document.querySelector("[data-register-add]");
        }
    };
};
var plural = function(count, singular) {
    var pluralForm = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "".concat(singular, "s");
    return "".concat(count, " ").concat(count === 1 ? singular : pluralForm);
};
var DriftSentence = styled11.p(_templateObject10(), typeRole.caption1.fontFamily, typeRole.caption1.fontSize, typeRole.caption1.lineHeight, semantic.text.secondary);
var DriftMissing = styled11(DriftSentence)(_templateObject11(), space[2]);
var DriftProgress = styled11.span(_templateObject12());
var RegisterDriftLines = function(param) {
    var orphanPlacementCount = param.orphanPlacementCount, drift = param.drift, onAddMissingToRegister = param.onAddMissingToRegister, addingProgress = param.addingProgress;
    return /* @__PURE__ */ jsxs8(Fragment6, {
        children: [
            orphanPlacementCount > 0 && /* @__PURE__ */ jsxs8(DriftSentence, {
                className: "count-secondary",
                children: [
                    plural(orphanPlacementCount, "item"),
                    " on the plan",
                    " ",
                    orphanPlacementCount === 1 ? "does" : "do",
                    " not trace back to a register row."
                ]
            }),
            drift && drift.missingCount > 0 && /* @__PURE__ */ jsxs8(DriftMissing, {
                className: "count-secondary drift-missing",
                children: [
                    /* @__PURE__ */ jsxs8("span", {
                        children: [
                            drift.missingCount,
                            " of these ",
                            drift.missingCount === 1 ? "is" : "are",
                            " not in the register at all."
                        ]
                    }),
                    onAddMissingToRegister && /* @__PURE__ */ jsx20(Button4, {
                        variant: "frosted",
                        size: "xs",
                        loading: addingProgress != null,
                        onClick: function() {
                            return onAddMissingToRegister(drift.missing);
                        },
                        children: addingProgress ? "Adding ".concat(addingProgress.done, " of ").concat(addingProgress.total, "…") : "Add ".concat(drift.missing.length, " to the register")
                    }),
                    /* @__PURE__ */ jsx20(DriftProgress, {
                        role: "status",
                        "aria-live": "polite",
                        className: "drift-progress",
                        children: addingProgress ? "Adding ".concat(addingProgress.done, " of ").concat(addingProgress.total, " to the register") : ""
                    })
                ]
            }),
            drift && drift.contestedInRegister > 0 && /* @__PURE__ */ jsxs8(DriftSentence, {
                className: "count-secondary",
                children: [
                    drift.contestedInRegister,
                    " ",
                    drift.contestedInRegister === 1 ? "matches" : "match",
                    " more than one register row, so ",
                    drift.contestedInRegister === 1 ? "it cannot" : "they cannot",
                    " be linked. Merge the duplicate rows."
                ]
            }),
            drift && drift.contestedOnPlan > 0 && /* @__PURE__ */ jsxs8(DriftSentence, {
                className: "count-secondary",
                children: [
                    drift.contestedOnPlan,
                    " ",
                    drift.contestedOnPlan === 1 ? "shares" : "share",
                    " an equipment identity with another item on the plan, which blocks saving and going live until it is fixed."
                ]
            }),
            drift && drift.rowAlreadyPlaced > 0 && /* @__PURE__ */ jsxs8(DriftSentence, {
                className: "count-secondary",
                children: [
                    drift.rowAlreadyPlaced,
                    " ",
                    drift.rowAlreadyPlaced === 1 ? "matches a register row that is" : "match register rows that are",
                    " ",
                    "already placed somewhere else on the plan."
                ]
            }),
            drift && drift.staleLink - drift.staleLinkNoIdentity > 0 && /* @__PURE__ */ jsxs8(DriftSentence, {
                className: "count-secondary",
                children: [
                    drift.staleLink - drift.staleLinkNoIdentity,
                    " ",
                    drift.staleLink - drift.staleLinkNoIdentity === 1 ? "points" : "point",
                    " at a register row that no longer exists. Select",
                    " ",
                    drift.staleLink - drift.staleLinkNoIdentity === 1 ? "it" : "each of them",
                    " on the plan and use Unlink, then add ",
                    drift.staleLink - drift.staleLinkNoIdentity === 1 ? "it" : "them",
                    " ",
                    "back here."
                ]
            }),
            drift && drift.staleLinkNoIdentity > 0 && /* @__PURE__ */ jsxs8(DriftSentence, {
                className: "count-secondary",
                children: [
                    drift.staleLinkNoIdentity,
                    " ",
                    drift.staleLinkNoIdentity === 1 ? "also has" : "also have",
                    " no equipment identity. Select ",
                    drift.staleLinkNoIdentity === 1 ? "it" : "each of them",
                    " on the plan and use ",
                    REGISTER_LINK_BUTTON_LABEL,
                    " to choose the right one."
                ]
            }),
            drift && drift.unaccountable > 0 && /* @__PURE__ */ jsxs8(DriftSentence, {
                className: "count-secondary",
                children: [
                    drift.unaccountable,
                    " ",
                    drift.unaccountable === 1 ? "has" : "have",
                    " no equipment identity, or no name. Give ",
                    drift.unaccountable === 1 ? "it a name" : "them names",
                    ", or use",
                    " ",
                    REGISTER_LINK_BUTTON_LABEL,
                    " on the plan."
                ]
            })
        ]
    });
};
// src/components/AssetRegister/AssetRegisterList.tsx
import { Fragment as Fragment7, jsx as jsx21, jsxs as jsxs9 } from "react/jsx-runtime";
var PAGE_SIZE = 50;
var SHOW_ALL_LIMIT = 1e3;
var COVERAGE_RANK = {
    "not-on-plan": 0,
    "on-plan-untracked": 1,
    "on-plan-tracked": 2
};
var STATUS_TONE = {
    // NEUTRAL, deliberately — not `warn`. Per the epic's BI ruling "not on plan" is a legitimate
    // permanent end state: a customer's register may list assets they will never install. Styling
    // it as a warning would nag about a state that is frequently correct forever.
    "not-on-plan": "neutral",
    "on-plan-untracked": "info",
    "on-plan-tracked": "success"
};
var buildStatusOptions = function() {
    return [
        {
            value: "all",
            label: "All coverage"
        },
        {
            value: "on-plan-tracked",
            label: ASSET_COVERAGE_LABEL["on-plan-tracked"]
        },
        {
            value: "on-plan-untracked",
            label: ASSET_COVERAGE_LABEL["on-plan-untracked"]
        },
        {
            value: "not-on-plan",
            label: ASSET_COVERAGE_LABEL["not-on-plan"]
        }
    ];
};
var MATCH_OPTIONS = [
    {
        value: "all",
        label: "All assets"
    },
    {
        value: "matched",
        label: "Matched to a brand"
    },
    {
        value: "generic",
        label: "Generic \u2014 no brand"
    },
    /*
   * ⚠ The VALUE is the `match_status` predicate; the LABEL is copy. They are deliberately not the
   * same string (`plan-register-reconciliation`, FR6; epic ledger row 101). Rob's ruling of
   * 2026-09-19: *No catalogue match* wins on both screens because it is the more accurate of the
   * two — the asset is not unmatched in general, it has no product in our catalogue — and the
   * planner sidebar has read it that way since 2026-09-17. Sourcing the constant rather than
   * re-typing the phrase is what stops the two screens drifting apart again.
   */ {
        value: "unmatched",
        label: NO_CATALOGUE_MATCH_GROUP
    },
    /*
   * Rows a person DECIDED have no catalogue product (`uncatalogued-terminal-state`, ledger row
   * 119). Its own arm rather than folded into *No catalogue match*: that option is the operator's
   * to-do list — rows still awaiting a decision — and a decided row does not belong on it.
   */ {
        value: "uncatalogued",
        label: NOT_IN_CATALOGUE_LABEL
    }
];
var GENERIC_FILTER_NOTE = "Equipment matched to an unbranded catalogue product \u2014 no manufacturer.";
var GENERIC_FILTER_NOTE_ID = "register-generic-filter-note";
var isUnmatched = function(asset) {
    return asset.match_status === "unmatched";
};
var isGenericEquipment = function(asset) {
    return !isUnmatched(asset) && isGenericCatalogueManufacturer(asset.manufacturer);
};
var plural2 = function(count, singular) {
    var pluralForm = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "".concat(singular, "s");
    return "".concat(count, " ").concat(count === 1 ? singular : pluralForm);
};
var AssetRegisterList = function(param) {
    var assets = param.assets, layout = param.layout, planAbsent = param.planAbsent, loading = param.loading, error = param.error, onRetryRead = param.onRetryRead, actionError = param.actionError, actionErrorKey = param.actionErrorKey, actionNotice = param.actionNotice, onAdd = param.onAdd, onRemove = param.onRemove, onRemoveAll = param.onRemoveAll, drift = param.drift, onAddMissingToRegister = param.onAddMissingToRegister, addingProgress = param.addingProgress, visibleIds = param.visibleIds, filterKey = param.filterKey, _param_hideFilters = param.hideFilters, hideFilters = _param_hideFilters === void 0 ? false : _param_hideFilters, className = param.className;
    var _useState6 = _sliced_to_array(useState6(""), 2), query = _useState6[0], setQuery = _useState6[1];
    var _useState61 = _sliced_to_array(useState6("all"), 2), statusFilter = _useState61[0], setStatusFilter = _useState61[1];
    var _useState62 = _sliced_to_array(useState6("all"), 2), matchFilter = _useState62[0], setMatchFilter = _useState62[1];
    var _useState63 = _sliced_to_array(useState6(0), 2), page = _useState63[0], setPage = _useState63[1];
    var _useState64 = _sliced_to_array(useState6(false), 2), showAll = _useState64[0], setShowAll = _useState64[1];
    var _useState65 = _sliced_to_array(useState6({
        field: null,
        direction: "asc"
    }), 2), sort = _useState65[0], setSort = _useState65[1];
    var isStaff = useUserStore(function(state) {
        var _state_authMetadata_roles, _state_authMetadata;
        return !!((_state_authMetadata = state.authMetadata) === null || _state_authMetadata === void 0 ? void 0 : (_state_authMetadata_roles = _state_authMetadata.roles) === null || _state_authMetadata_roles === void 0 ? void 0 : _state_authMetadata_roles.includes(Roles.TL_ADMIN));
    });
    var statusOptions = useMemo(buildStatusOptions, []);
    var coverage = useMemo(function() {
        return buildAssetCoverageIndex(layout, assets, {
            planAbsent: planAbsent
        });
    }, [
        layout,
        assets,
        planAbsent
    ]);
    var notOnPlanCount = assets.length - coverage.onPlanCount;
    var filtered = useMemo(function() {
        if (visibleIds) return assets.filter(function(asset) {
            return visibleIds.has(asset.id);
        });
        var q = query.trim().toLowerCase();
        return assets.filter(function(asset) {
            if (statusFilter !== "all" && coverage.statusFor(asset.id) !== statusFilter) return false;
            if (matchFilter === "matched" && (isUnmatched(asset) || isGenericEquipment(asset) || isUncatalogued(asset))) return false;
            if (matchFilter === "unmatched" && !isUnmatched(asset)) return false;
            if (matchFilter === "uncatalogued" && !isUncatalogued(asset)) return false;
            if (matchFilter === "generic" && !isGenericEquipment(asset)) return false;
            if (q) {
                var _asset_customer_asset_identifier;
                var haystack = "".concat(registerRowName(asset), " ").concat(asset.name, " ").concat((_asset_customer_asset_identifier = asset.customer_asset_identifier) !== null && _asset_customer_asset_identifier !== void 0 ? _asset_customer_asset_identifier : "").toLowerCase();
                if (!haystack.includes(q)) return false;
            }
            return true;
        });
    }, [
        assets,
        coverage,
        matchFilter,
        query,
        statusFilter,
        visibleIds
    ]);
    var filterKeyRef = useRef3(filterKey);
    useEffect5(function() {
        if (filterKeyRef.current === filterKey) return;
        filterKeyRef.current = filterKey;
        setPage(0);
    }, [
        filterKey
    ]);
    var sortAccessors = useMemo(function() {
        return {
            // NULL, not '' — `compareValues` files nulls last in both directions, which is what keeps
            // uncoded rows at the end when the direction flips. 236 of 700 production rows are null here.
            // `||`, not `??`, and the difference is the whole point: the CELLS decide emptiness by
            // truthiness, so a blank-but-non-null string renders as "No BID" / "No Asset Identifier" while
            // `?? null` would let it through as an ordinary string that sorts FIRST ascending — two
            // visually identical empty rows at opposite ends of one sort. Not reachable through today's
            // write paths (the importer and the PATCH route both map blank to NULL), which is why this
            // is cheap insurance rather than a fix.
            bid: function(asset) {
                return asset.entity_code || null;
            },
            name: function(asset) {
                return registerRowName(asset);
            },
            identifier: function(asset) {
                return asset.customer_asset_identifier || null;
            },
            product: function(asset) {
                return catalogueMatchText(asset);
            },
            coverage: function(asset) {
                return COVERAGE_RANK[coverage.statusFor(asset.id)];
            }
        };
    }, [
        coverage
    ]);
    var sorted = useMemo(function() {
        return sortRows(filtered, sort.field, sort.direction, sortAccessors);
    }, [
        filtered,
        sort.field,
        sort.direction,
        sortAccessors
    ]);
    var pageCount = Math.max(1, Math.ceil(sorted.length / PAGE_SIZE));
    var safePage = Math.min(page, pageCount - 1);
    var showAllPermitted = filtered.length <= SHOW_ALL_LIMIT;
    var showingAll = showAll && showAllPermitted;
    var pageRows = useMemo(function() {
        return showingAll ? sorted : sorted.slice(safePage * PAGE_SIZE, safePage * PAGE_SIZE + PAGE_SIZE);
    }, [
        sorted,
        safePage,
        showingAll
    ]);
    var rowsWorthKeeping = pageRows.length > 0;
    var columns = useMemo(function() {
        var base = [
            {
                key: "name",
                header: "Asset",
                width: "2fr",
                sortable: true,
                // The name ALLOCATED, which is the name the register holds, not the one a file asked for.
                render: function(row) {
                    return /* @__PURE__ */ jsx21("strong", {
                        className: "asset-name",
                        children: registerRowName(row)
                    });
                }
            },
            {
                key: "identifier",
                header: "Asset Identifier",
                width: "1.2fr",
                sortable: true,
                render: function(asset) {
                    return asset.customer_asset_identifier ? /* @__PURE__ */ jsx21("span", {
                        className: "identifier",
                        children: asset.customer_asset_identifier
                    }) : // Said in words, because a row with no identifier is the quiet trap in the whole
                    // feature: a re-upload cannot match it, so it inserts a second copy.
                    /* @__PURE__ */ jsx21("span", {
                        className: "muted",
                        children: "No Asset Identifier"
                    });
                }
            },
            {
                key: "product",
                header: "Catalogue match",
                width: "1.6fr",
                sortable: true,
                render: function(asset) {
                    return(/*
           * A bare `Generic` chip was painted here first, for a row whose `match_status` was
           * `generic` — a `twin_generic_asset` placement, which had no `product` to print.
           * `generic-source-retirement` (ledger row 85) retired that status, so the branch is
           * gone and unbranded equipment falls to the `span.product` branch below, where it
           * prints `Generic · Abdominal` — the product name the operator came to this column to
           * read.
           *
           * ⚠ That is the RIGHT outcome and was already the outcome for the 169 catalogue rows,
           * but it is a visible change for the two retired ones. It is also why the narrow
           * predicate could not simply be widened to `isGenericEquipment` when this branch
           * existed: doing so replaced every `Generic · Abdominal` with a bare chip and threw the
           * product name away. Removing the branch achieves what widening it could not.
           */ /*
           * An `uncatalogued` row says what a person DECIDED, not what the matcher failed to do
           * (`uncatalogued-terminal-state`). Checked first: `catalogueMatchText` is null for it too,
           * and the sort accessor reads that null — so it sorts with the no-match rows, which is
           * where a row with no product belongs, while the tag tells the two apart.
           */ isUncatalogued(asset) ? /* @__PURE__ */ jsx21(Tag, {
                        surface: "on-solid",
                        tone: "neutral",
                        size: "dense",
                        children: NOT_IN_CATALOGUE_LABEL
                    }) : catalogueMatchText(asset) === null ? /* @__PURE__ */ jsx21(Tag, {
                        surface: "on-solid",
                        tone: "neutral",
                        size: "dense",
                        children: NO_CATALOGUE_MATCH_GROUP
                    }) : /* @__PURE__ */ jsx21("span", {
                        className: "product",
                        children: catalogueMatchText(asset)
                    }));
                }
            },
            {
                key: "coverage",
                header: "Coverage",
                width: "1.4fr",
                sortable: true,
                render: function(asset) {
                    var status = coverage.statusFor(asset.id);
                    return(// `dot` gives tone a second channel, and the LABEL carries the meaning in words —
                    // colour alone would fail WCAG 1.4.1, the obligation `Banner` documents.
                    /* @__PURE__ */ jsx21(Tag, {
                        surface: "on-solid",
                        tone: STATUS_TONE[status],
                        size: "dense",
                        dot: true,
                        children: ASSET_COVERAGE_LABEL[status]
                    }));
                }
            }
        ];
        var withBid = isStaff ? [
            {
                key: "bid",
                header: "BID",
                // Narrower and near-fixed: a BID is a fixed-shape string of about twelve characters
                // (`NPL-STN-E001`), so it does not want a share of the flexible space the text columns
                // divide between them.
                width: "1.1fr",
                sortable: true,
                render: function(asset) {
                    return asset.entity_code ? /* @__PURE__ */ jsx21("span", {
                        className: "identifier",
                        children: asset.entity_code
                    }) : // Said in words, and it is the COMMON case rather than a rarity: 236 of 700
                    // production rows carry no entity code, and one whole twin has none at all. A
                    // dash would read as a failed lookup; this reads as "not minted yet", which is
                    // what it is.
                    /* @__PURE__ */ jsx21("span", {
                        className: "muted",
                        children: "No BID"
                    });
                }
            }
        ].concat(_to_consumable_array(base)) : base;
        if (!onRemove) return withBid;
        return _to_consumable_array(withBid).concat([
            {
                key: "actions",
                header: "Actions",
                width: "260px",
                align: "right",
                resizable: false,
                // Explicit, not merely omitted: every OTHER column sorts, so a reader needs to see that
                // this one's exclusion was decided. It holds buttons, not data — there is nothing to
                // order by. Same call the setup-app streams table makes.
                sortable: false,
                render: function(asset) {
                    var placements = coverage.placementsFor(asset.id);
                    var placementUnknown = !coverage.isPlacementKnown(asset.id);
                    var placed = placements.length > 0;
                    var refuseRemoval = placed || placementUnknown;
                    return /* @__PURE__ */ jsx21("span", {
                        className: "row-actions",
                        children: onRemove && /*
           * Refused while placed, and it says why (§4.4). Deleting a placed row would
           * leave the plan item with a dangling `assetUid` — which the type treats as
           * benign "not traceable to a register row", so it would be indistinguishable
           * from a Library placement. The refusal lives here because the CLIENT is the
           * side that can see the plan; the server has no plan context on this route.
           */ /* @__PURE__ */ jsx21(Button5, {
                            variant: "ghost",
                            size: "xs",
                            "aria-disabled": refuseRemoval,
                            onClick: function() {
                                return onRemove(asset, placements);
                            },
                            "aria-label": placed ? "Remove ".concat(registerRowName(asset), " from the register — unavailable, it is still on the plan") : placementUnknown ? "Remove ".concat(registerRowName(asset), " from the register — unavailable until the plan has loaded") : "Remove ".concat(registerRowName(asset), " from the register"),
                            children: "Remove"
                        })
                    });
                }
            }
        ]);
    }, [
        coverage,
        isStaff,
        onRemove
    ]);
    var _sort_field;
    return /* @__PURE__ */ jsxs9("div", {
        className: className,
        children: [
            /* @__PURE__ */ jsx21(RegisterWriteBanners, {
                actionError: actionError,
                actionErrorKey: actionErrorKey,
                actionNotice: actionNotice
            }),
            /* @__PURE__ */ jsxs9("div", {
                className: "register-head",
                children: [
                    /* @__PURE__ */ jsx21("div", {
                        className: "counts",
                        children: !loading && !error && /* @__PURE__ */ jsxs9(Fragment7, {
                            children: [
                                /* @__PURE__ */ jsxs9("p", {
                                    className: "count-primary",
                                    children: [
                                        /* @__PURE__ */ jsx21("strong", {
                                            children: plural2(coverage.trackedCount, "asset")
                                        }),
                                        " of ",
                                        assets.length,
                                        " on the register ",
                                        coverage.trackedCount === 1 ? "is" : "are",
                                        " tracked"
                                    ]
                                }),
                                /* @__PURE__ */ jsx21(RegisterDriftLines, {
                                    orphanPlacementCount: coverage.orphanPlacementCount,
                                    drift: drift,
                                    onAddMissingToRegister: onAddMissingToRegister,
                                    addingProgress: addingProgress
                                }),
                                coverage.planKnown && notOnPlanCount > 0 && /* @__PURE__ */ jsxs9("p", {
                                    className: "count-secondary",
                                    children: [
                                        plural2(notOnPlanCount, "asset"),
                                        " ",
                                        notOnPlanCount === 1 ? "is" : "are",
                                        " not on the plan."
                                    ]
                                })
                            ]
                        })
                    }),
                    (onRemoveAll || onAdd) && /* @__PURE__ */ jsxs9("div", {
                        className: "register-head-actions",
                        children: [
                            onRemoveAll && assets.length > 0 && /* @__PURE__ */ jsx21(RemoveAllButton, {
                                planKnown: coverage.planKnown,
                                onClick: onRemoveAll
                            }),
                            onAdd && /* @__PURE__ */ jsx21(Button5, {
                                variant: "frosted",
                                size: "default",
                                onClick: onAdd,
                                "data-register-add": "",
                                children: "Add an asset"
                            })
                        ]
                    })
                ]
            }),
            !hideFilters && /* @__PURE__ */ jsxs9("div", {
                className: "register-filters",
                children: [
                    /* @__PURE__ */ jsx21(Input2, {
                        type: "search",
                        value: query,
                        placeholder: "Search by name or Asset Identifier",
                        "aria-label": "Search the register by name or Asset Identifier",
                        onChange: function(event) {
                            setQuery(event.target.value);
                            setPage(0);
                        }
                    }),
                    /* @__PURE__ */ jsx21(Select, {
                        options: statusOptions,
                        value: statusFilter,
                        ariaLabel: "Filter by coverage",
                        onChange: function(value) {
                            setStatusFilter(value);
                            setPage(0);
                        }
                    }),
                    /* @__PURE__ */ jsx21(Select, {
                        options: MATCH_OPTIONS,
                        value: matchFilter,
                        ariaLabel: "Filter by catalogue match",
                        ariaDescribedBy: matchFilter === "generic" ? GENERIC_FILTER_NOTE_ID : void 0,
                        onChange: function(value) {
                            setMatchFilter(value);
                            setPage(0);
                        }
                    })
                ]
            }),
            !hideFilters && matchFilter === "generic" && /* @__PURE__ */ jsx21("p", {
                className: "filter-note",
                id: GENERIC_FILTER_NOTE_ID,
                children: GENERIC_FILTER_NOTE
            }),
            /* @__PURE__ */ jsx21(Table, {
                columns: columns,
                data: pageRows,
                keyExtractor: function(row) {
                    return row.id;
                },
                loading: rowsWorthKeeping ? false : loading,
                error: rowsWorthKeeping ? null : error !== null && error !== void 0 ? error : null,
                emptyMessage: assets.length === 0 ? "No assets on the register yet. Upload a CSV, or add one by hand." : "No assets match these filters.",
                "aria-label": "Asset register",
                sortField: (_sort_field = sort.field) !== null && _sort_field !== void 0 ? _sort_field : void 0,
                sortDirection: sort.direction,
                onSort: function(key) {
                    setSort(function(current) {
                        return nextSort(current, key);
                    });
                    setPage(0);
                },
                tableId: isStaff ? "asset-register-staff" : "asset-register"
            }),
            rowsWorthKeeping && error && /*
     * The read failure `Table` is no longer being given — see the `error` prop above.
     *
     * Through `Banner`, not a hand-typed paragraph. An earlier draft rendered it as
     * `typeRole.caption1` in `semantic.text.secondary`, which forked a treatment two
     * primitives already own AND quietly demoted it: the most severe state on this surface
     * read as small grey text, quieter than the write-refusal `Banner` a few lines above and
     * quieter than the same message on every other mount of this table. Moving where the
     * state renders was the ruling; making it look less serious was not.
     *
     * `Banner` carries its own `role="alert"`, so the announcement survives the move.
     */ /* @__PURE__ */ jsx21(Banner2, {
                surface: "on-solid",
                tone: "error",
                title: "The register could not be read.",
                children: error
            }),
            rowsWorthKeeping && !error && loading && /*
     * And the in-flight state, which `Table` is no longer announcing either.
     *
     * `role="status"` is the half an earlier draft lost: withholding `loading` from `Table`
     * also drops `aria-busy` from the table element, so a screen-reader user went from being
     * told the rows were incomplete to being told nothing at all — and nothing when the read
     * settled. Polite, not assertive: a read in flight is not worth interrupting for, and the
     * upload's own outcome is announced by the Equipment step's import summary
     * (`EquipmentLandedSummary`) rather than competing here.
     */ /* @__PURE__ */ jsx21("p", {
                className: "register-read-state",
                children: /* @__PURE__ */ jsx21("span", {
                    role: "status",
                    children: "Loading\u2026"
                })
            }),
            error && onRetryRead && /* @__PURE__ */ jsx21("div", {
                className: "register-read-retry",
                children: /* @__PURE__ */ jsx21(Button5, {
                    variant: "ghost",
                    size: "xs",
                    onClick: onRetryRead,
                    "aria-label": "Try reading the register again",
                    children: "Try again"
                })
            }),
            filtered.length > PAGE_SIZE && /* @__PURE__ */ jsxs9("div", {
                className: "register-paging",
                children: [
                    !showingAll && /* @__PURE__ */ jsx21(Button5, {
                        variant: "ghost",
                        size: "xs",
                        disabled: safePage === 0,
                        onClick: function() {
                            return setPage(function(p) {
                                return Math.max(0, p - 1);
                            });
                        },
                        children: "Previous"
                    }),
                    /* @__PURE__ */ jsxs9("span", {
                        "aria-live": "polite",
                        children: [
                            showingAll ? 1 : safePage * PAGE_SIZE + 1,
                            "-",
                            showingAll ? filtered.length : Math.min(filtered.length, (safePage + 1) * PAGE_SIZE),
                            " ",
                            "of ",
                            filtered.length
                        ]
                    }),
                    !showingAll && /* @__PURE__ */ jsx21(Button5, {
                        variant: "ghost",
                        size: "xs",
                        disabled: safePage >= pageCount - 1,
                        onClick: function() {
                            return setPage(function(p) {
                                return Math.min(pageCount - 1, p + 1);
                            });
                        },
                        children: "Next"
                    }),
                    showingAll ? /* @__PURE__ */ jsx21(Button5, {
                        variant: "ghost",
                        size: "xs",
                        onClick: function() {
                            setShowAll(false);
                            setPage(0);
                        },
                        children: "Show 50 per page"
                    }) : /* @__PURE__ */ jsxs9(Fragment7, {
                        children: [
                            /* @__PURE__ */ jsxs9(Button5, {
                                variant: "ghost",
                                size: "xs",
                                disabled: !showAllPermitted,
                                "aria-describedby": !showAllPermitted ? "register-show-all-refusal" : void 0,
                                onClick: function() {
                                    return setShowAll(true);
                                },
                                children: [
                                    "Show all (",
                                    filtered.length,
                                    ")"
                                ]
                            }),
                            !showAllPermitted && /* Said out loud rather than left as a dead control: a disabled button with no
           reason reads as a bug, and the reason here is a real one the operator can act
           on by filtering. */ /* @__PURE__ */ jsx21("span", {
                                className: "show-all-refusal",
                                id: "register-show-all-refusal",
                                children: "This register is too large to show in one list \u2014 narrow it with the filters first."
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var AssetRegisterList_default = styled12(AssetRegisterList)(_templateObject13(), space2[3], space2[3], space2[2], typeRole2.body1.fontFamily, typeRole2.body1.fontSize, typeRole2.body1.lineHeight, semantic2.text.primary, space2[1], typeRole2.caption1.fontFamily, typeRole2.caption1.fontSize, typeRole2.caption1.lineHeight, semantic2.text.secondary, space2[2], semantic2.text.secondary, typeRole2.caption1.fontSize, typeRole2.caption1.lineHeight, typeRole2.body1Strong.fontWeight, semantic2.text.secondary, space2[1], space2[2], typeRole2.caption1.fontFamily, typeRole2.caption1.fontSize, semantic2.text.secondary, semantic2.text.muted, space2[2], typeRole2.caption1.fontFamily, typeRole2.caption1.fontSize, typeRole2.caption1.lineHeight, semantic2.text.secondary, space2[2]);
// src/components/AssetRegister/RemoveAllAssetsDialog.tsx
import { useId as useId2 } from "react";
import styled13 from "styled-components";
import { semantic as semantic3, space as space3, typeRole as typeRole3 } from "@repo/design-tokens";
import { Banner as Banner3, Button as Button6, Modal } from "@repo/design-system";
import { Fragment as Fragment8, jsx as jsx22, jsxs as jsxs10 } from "react/jsx-runtime";
var plural3 = function(n, one, many) {
    return "".concat(n, " ").concat(n === 1 ? one : many);
};
var listOf = function(parts) {
    return parts.length <= 1 ? parts.join("") : // Indexed, not `.at(-1)`: the viewer's browserslist reaches Safari 15, which lacks it.
    "".concat(parts.slice(0, -1).join(", "), " and ").concat(parts[parts.length - 1]);
};
var SAVES_EDITS = " This also saves your unsaved changes to the plan.";
var removeAllExplanation = function(param) {
    var total = param.total, placed = param.placed, observers = param.observers, compositesAmended = param.compositesAmended, compositesRemoved = param.compositesRemoved;
    var assets = total === 1 ? "the 1 asset" : "all ".concat(total, " assets");
    if (placed === 0) {
        return "Deletes ".concat(assets, ". None of them is on the floor plan, so the plan does not change.");
    }
    var onPlan = "".concat(placed === total ? total === 1 ? "It is" : "All of them are" : "".concat(placed, " of them ").concat(placed === 1 ? "is" : "are"), " on the floor plan");
    var cascade = listOf([
        "".concat(placed === 1 ? "its" : "their", " equipment is removed from the plan")
    ].concat(_to_consumable_array(observers > 0 ? [
        "".concat(plural3(observers, "observer", "observers"), " drawn on ").concat(placed === 1 ? "it" : "them", " ").concat(observers === 1 ? "is" : "are", " removed")
    ] : [])));
    var composites = _to_consumable_array(compositesAmended > 0 ? [
        "".concat(plural3(compositesAmended, "composite measure stops", "composite measures stop"), " adding that equipment up")
    ] : []).concat(_to_consumable_array(compositesRemoved > 0 ? [
        // Neutral on purpose: a composite is removed when its TARGET went as well as when it was
        // left adding up nothing, and "with nothing else in it" is false for the first.
        "".concat(plural3(compositesRemoved, "composite measure is", "composite measures are"), " removed")
    ] : []));
    var compositeSentence = listOf(composites);
    return "Deletes ".concat(assets, ". ").concat(onPlan, ", so ").concat(cascade, ".") + (compositeSentence ? " ".concat(compositeSentence, ".") : "");
};
var RemoveAllAssetsDialog = function(param) {
    var counts = param.counts, planDirty = param.planDirty, busy = param.busy, error = param.error, onRemoveUnplaced = param.onRemoveUnplaced, onRemoveAll = param.onRemoveAll, onCancel = param.onCancel, returnFocusTo = param.returnFocusTo, className = param.className;
    var unplacedHeading = useId2();
    var allHeading = useId2();
    var running = busy !== null;
    return /* @__PURE__ */ jsx22(Modal, {
        open: true,
        onClose: onCancel,
        title: "Remove assets from the register",
        tone: "coral",
        width: "lg",
        dismissible: !running,
        className: className,
        returnFocusTo: returnFocusTo,
        actions: /* @__PURE__ */ jsx22(Button6, {
            variant: "frosted",
            size: "inline",
            autoFocus: true,
            "aria-disabled": running || void 0,
            onClick: function() {
                if (!running) onCancel();
            },
            children: "Cancel"
        }),
        children: /* @__PURE__ */ jsxs10("div", {
            className: "remove-all",
            children: [
                error && /* @__PURE__ */ jsx22(Banner3, {
                    surface: "on-solid",
                    tone: "error",
                    title: error.title,
                    children: error.message
                }),
                /* @__PURE__ */ jsxs10("section", {
                    className: "choice",
                    "aria-labelledby": unplacedHeading,
                    children: [
                        /* @__PURE__ */ jsx22("h3", {
                            id: unplacedHeading,
                            children: "Remove the unplaced assets"
                        }),
                        counts.unplaced > 0 ? /* @__PURE__ */ jsxs10(Fragment8, {
                            children: [
                                /* @__PURE__ */ jsxs10("p", {
                                    children: [
                                        "Deletes the ",
                                        plural3(counts.unplaced, "asset", "assets"),
                                        " that",
                                        " ",
                                        counts.unplaced === 1 ? "is" : "are",
                                        " not on the floor plan. The plan does not change.",
                                        planDirty ? SAVES_EDITS : ""
                                    ]
                                }),
                                /* @__PURE__ */ jsx22("div", {
                                    className: "choice-action",
                                    children: /* @__PURE__ */ jsx22(Button6, {
                                        variant: "frosted",
                                        size: "inline",
                                        loading: busy === "unplaced",
                                        "aria-disabled": running && busy !== "unplaced" || void 0,
                                        onClick: function() {
                                            if (!running) onRemoveUnplaced();
                                        },
                                        children: busy === "unplaced" ? "Removing\u2026" : "Remove ".concat(plural3(counts.unplaced, "unplaced asset", "unplaced assets"))
                                    })
                                })
                            ]
                        }) : /* @__PURE__ */ jsx22("p", {
                            children: "Every asset is on the floor plan, so there is nothing to remove here."
                        })
                    ]
                }),
                /* @__PURE__ */ jsxs10("section", {
                    className: "choice",
                    "aria-labelledby": allHeading,
                    children: [
                        /* @__PURE__ */ jsx22("h3", {
                            id: allHeading,
                            children: "Remove all assets"
                        }),
                        /* @__PURE__ */ jsxs10("p", {
                            children: [
                                removeAllExplanation(counts),
                                planDirty ? SAVES_EDITS : ""
                            ]
                        }),
                        /* @__PURE__ */ jsx22("div", {
                            className: "choice-action",
                            children: /* @__PURE__ */ jsx22(Button6, {
                                variant: "destructive",
                                size: "inline",
                                loading: busy === "all",
                                "aria-disabled": running && busy !== "all" || void 0,
                                onClick: function() {
                                    if (!running) onRemoveAll();
                                },
                                children: busy === "all" ? "Removing\u2026" : "Remove ".concat(counts.total === 1 ? "the 1 asset" : "all ".concat(counts.total, " assets"))
                            })
                        })
                    ]
                }),
                /* @__PURE__ */ jsx22("p", {
                    className: "footnote",
                    children: "The live twin does not change until you press Go Live."
                }),
                /* @__PURE__ */ jsx22("p", {
                    role: "status",
                    "aria-live": "polite",
                    style: visuallyHidden,
                    children: running ? "Removing\u2026" : ""
                })
            ]
        })
    });
};
var RemoveAllAssetsDialog_default = styled13(RemoveAllAssetsDialog)(_templateObject14(), space3[4], space3[2], typeRole3.body1Stronger.fontFamily, typeRole3.body1Stronger.fontSize, typeRole3.body1Stronger.lineHeight, typeRole3.body1Stronger.fontWeight, semantic3.text.primary, typeRole3.body1.fontFamily, typeRole3.body1.fontSize, typeRole3.body1.lineHeight, semantic3.text.secondary);
// src/components/AssetRegister/AssetEditDialog.tsx
import { useMemo as useMemo2, useState as useState7 } from "react";
import styled14 from "styled-components";
import { semantic as semantic4, space as space4, typeRole as typeRole4 } from "@repo/design-tokens";
import { Banner as Banner4, Button as Button7, Field, Input as Input3 } from "@repo/design-system";
import { REPLY_UNREADABLE } from "@repo/front-end-services";
import { ASSET_CSV_COLUMNS } from "@repo/front-end-utils";
import { Fragment as Fragment9, jsx as jsx23, jsxs as jsxs11 } from "react/jsx-runtime";
var FIELD_WORDS = {
    customer_asset_identifier: {
        label: "Asset Identifier"
    },
    source_asset_id: {
        label: "Source system id"
    },
    manufacturer_raw: {
        label: "Manufacturer"
    },
    product_line_raw: {
        label: "Product line"
    },
    model_raw: {
        label: "Model"
    },
    manufacturer_sku_raw: {
        label: "Manufacturer SKU"
    },
    category_raw: {
        label: "Category"
    },
    unit_cost: {
        label: "Unit cost"
    },
    residual_value: {
        label: "Residual value"
    },
    currency: {
        label: "Currency",
        placeholder: "GBP"
    },
    install_date: {
        label: "Installed",
        placeholder: "YYYY-MM-DD"
    },
    manufacture_date: {
        label: "Manufactured",
        placeholder: "YYYY-MM-DD or YYYY"
    },
    warranty_end_date: {
        label: "Warranty ends",
        placeholder: "YYYY-MM-DD"
    },
    contract_end_date: {
        label: "Contract ends",
        placeholder: "YYYY-MM-DD"
    },
    condition: {
        label: "Condition"
    },
    customer_notes: {
        label: "Notes"
    }
};
var PRODUCT_KEYS = /* @__PURE__ */ new Set([
    "manufacturer_raw",
    "product_line_raw",
    "model_raw",
    "manufacturer_sku_raw"
]);
var buildFormFields = function() {
    var customer = ASSET_CSV_COLUMNS.filter(function(column) {
        return column.header !== "name";
    }).map(function(column) {
        var key = column.header;
        var words = FIELD_WORDS[key];
        if (!words) throw new Error('AssetEditDialog has no label for the CSV column "'.concat(column.header, '".'));
        return _object_spread_props(_object_spread({
            key: key
        }, words), {
            helper: column.notes
        });
    });
    var nameColumn = ASSET_CSV_COLUMNS.find(function(column) {
        return column.header === "name";
    });
    if (!nameColumn) throw new Error('AssetEditDialog: the shared CSV list has no "name" column.');
    var firstProduct = customer.findIndex(function(field) {
        return PRODUCT_KEYS.has(field.key);
    });
    return {
        customer: customer,
        leading: customer.filter(function(field, i) {
            return !PRODUCT_KEYS.has(field.key) && i < firstProduct;
        }),
        product: customer.filter(function(field) {
            return PRODUCT_KEYS.has(field.key);
        }),
        trailing: customer.filter(function(field, i) {
            return !PRODUCT_KEYS.has(field.key) && i > firstProduct;
        }),
        nameNote: nameColumn.notes
    };
};
var nameField = function(nameNote) {
    return {
        key: "name",
        label: "Name",
        helper: "".concat(nameNote, " If another asset on this twin already has this name, TwinLabs adds a number to keep it unique.")
    };
};
var UPDATE_ONLY_FIELDS = /* @__PURE__ */ new Set([
    "asset_name",
    "model_3d"
]);
var REFUSED_SAVE_TITLE = "This asset was not saved.";
var UNCONFIRMED_SAVE_TITLE = "We could not confirm this save.";
var NUMERIC_KEYS = /* @__PURE__ */ new Set([
    "unit_cost",
    "residual_value"
]);
var AssetEditDialog = function(param) {
    var onCancel = param.onCancel, onSubmit = param.onSubmit, className = param.className;
    var formFields = useMemo2(buildFormFields, []);
    var nameEntry = useMemo2(function() {
        return nameField(formFields.nameNote);
    }, [
        formFields
    ]);
    var _useState7 = _sliced_to_array(useState7({}), 2), values = _useState7[0], setValues = _useState7[1];
    var _useState71 = _sliced_to_array(useState7(false), 2), saving = _useState71[0], setSaving = _useState71[1];
    var _useState72 = _sliced_to_array(useState7(null), 2), failure = _useState72[0], setFailure = _useState72[1];
    var setField = function(key, value) {
        setValues(function(previous) {
            return _object_spread_props(_object_spread({}, previous), _define_property({}, key, value));
        });
    };
    var handleSubmit = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var submitError;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setFailure(null);
                        setSaving(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            onSubmit(buildPatch(values))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 3:
                        submitError = _state.sent();
                        setFailure({
                            message: _instanceof(submitError, Error) ? submitError.message : "The asset could not be saved.",
                            /*
         * The TRANSPORT's own vocabulary, not a second rule invented here.
         *
         * It used to test only for `TimeoutError`, which was right for the timeout and wrong for
         * the other ways a write can fail AFTER the server answered — a dropped body stream, an
         * unreadable reply. Those all describe a request that reached the middleware, so a create
         * may have committed, and titling them "This asset was not saved" is the precise untrue
         * claim this pair exists to delete. The store's retry decision recognises the same names.
         * Raised by two reviewers.
         */ unconfirmed: _instanceof(submitError, Error) && (submitError.name === "TimeoutError" || submitError.name === REPLY_UNREADABLE)
                        });
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setSaving(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var renderField = function(field) {
        var key = field.key;
        return /* @__PURE__ */ jsx23(Field, {
            label: field.label,
            helper: field.helper,
            required: key === nameEntry.key,
            size: "md",
            children: function(wiring) {
                var _values_key;
                return /* @__PURE__ */ jsx23(Input3, _object_spread_props(_object_spread({}, wiring), {
                    value: (_values_key = values[key]) !== null && _values_key !== void 0 ? _values_key : "",
                    placeholder: field.placeholder,
                    inputMode: NUMERIC_KEYS.has(key) ? "decimal" : void 0,
                    onChange: function(event) {
                        return setField(key, event.target.value);
                    }
                }));
            }
        }, key);
    };
    var content = /* @__PURE__ */ jsxs11("div", {
        className: className,
        children: [
            failure && /* @__PURE__ */ jsx23(Banner4, {
                surface: "on-solid",
                tone: "error",
                title: failure.unconfirmed ? UNCONFIRMED_SAVE_TITLE : REFUSED_SAVE_TITLE,
                children: failure.message
            }),
            /* @__PURE__ */ jsxs11("div", {
                className: "asset-form",
                children: [
                    [
                        nameEntry
                    ].concat(_to_consumable_array(formFields.leading)).map(renderField),
                    /* @__PURE__ */ jsxs11("fieldset", {
                        className: "product",
                        children: [
                            /* @__PURE__ */ jsx23("legend", {
                                children: "Product"
                            }),
                            formFields.product.map(renderField)
                        ]
                    }),
                    formFields.trailing.map(renderField)
                ]
            })
        ]
    });
    var actions = /* @__PURE__ */ jsxs11(Fragment9, {
        children: [
            /* @__PURE__ */ jsx23(Button7, {
                variant: "ghost",
                size: "default",
                onClick: onCancel,
                disabled: saving,
                children: "Cancel"
            }),
            /* @__PURE__ */ jsx23(Button7, {
                variant: "frosted",
                size: "default",
                onClick: function() {
                    return void handleSubmit();
                },
                disabled: saving,
                children: saving ? "Saving\u2026" : "Add asset"
            })
        ]
    });
    return /* @__PURE__ */ jsx23(TLDialog_default, {
        title: "Add an asset",
        dialogContent: content,
        dialogActions: actions,
        defaultOpen: true,
        width: "44rem",
        onClose: onCancel
    });
};
var buildPatch = function(values) {
    var patch = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(values)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _sliced_to_array(_step.value, 2), key = _step_value[0], raw = _step_value[1];
            if (UPDATE_ONLY_FIELDS.has(key)) continue;
            var trimmed = (raw !== null && raw !== void 0 ? raw : "").trim();
            if (trimmed !== "") patch[key] = coerce(key, trimmed);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _values_name;
    patch.name = ((_values_name = values.name) !== null && _values_name !== void 0 ? _values_name : "").trim();
    return patch;
};
var coerce = function(key, value) {
    if (!NUMERIC_KEYS.has(key)) return value;
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : value;
};
var AssetEditDialog_default = styled14(AssetEditDialog)(_templateObject15(), space4[3], space4[3], space4[3], space4[2], semantic4.text.secondary, typeRole4.caption1Strong.fontWeight, typeRole4.caption1Strong.fontSize, typeRole4.caption1Strong.lineHeight, typeRole4.caption1Strong.fontFamily);
// src/components/elements/Tooltip/Tooltip.tsx
import styled15 from "styled-components";
import { ink, surface } from "@repo/design-tokens";
import { jsx as jsx24 } from "react/jsx-runtime";
var Tooltip_ = function(param) {
    var text = param.text, className = param.className, id = param.id, role = param.role;
    return /* @__PURE__ */ jsx24("span", {
        className: className,
        id: id,
        role: role,
        children: text
    });
};
var Tooltip = styled15(Tooltip_)(_templateObject16(), function(props) {
    return props.backgroundColor || ink[1];
}, function(props) {
    return props.textColor || surface[0];
}, function(props) {
    return props.maxWidth ? "max-width: ".concat(props.maxWidth, "px; white-space: normal; overflow-wrap: anywhere; word-break: break-word;") : "white-space: nowrap;";
}, function(props) {
    return props.borderColor || ink[1];
});
// src/components/elements/Tooltip/HoverTip.tsx
import React11, { useId as useId3 } from "react";
import styled16 from "styled-components";
import { jsx as jsx25, jsxs as jsxs12 } from "react/jsx-runtime";
var Wrapper = styled16.span(_templateObject17(), function(props) {
    return props.$display;
}, Tooltip, Tooltip);
var HoverTip = function(param) {
    var text = param.text, children = param.children, _param_display = param.display, display = _param_display === void 0 ? "inline-flex" : _param_display, maxWidth = param.maxWidth, className = param.className;
    var tooltipId = useId3();
    var describedChild = React11.isValidElement(children) ? React11.cloneElement(children, {
        "aria-describedby": [
            children.props["aria-describedby"],
            tooltipId
        ].filter(Boolean).join(" ")
    }) : children;
    return /* @__PURE__ */ jsxs12(Wrapper, {
        $display: display,
        className: className,
        children: [
            describedChild,
            /* @__PURE__ */ jsx25(Tooltip, {
                id: tooltipId,
                role: "tooltip",
                text: text,
                maxWidth: maxWidth
            })
        ]
    });
};
// src/components/elements/CardHeader/CardHeader.tsx
import styled17 from "styled-components";
import { DismissCircle24Regular } from "@fluentui/react-icons";
import { jsx as jsx26, jsxs as jsxs13 } from "react/jsx-runtime";
var CardHeader = function(param) {
    var className = param.className, title = param.title, icon = param.icon, onClose = param.onClose, _param_closeAriaLabel = param.closeAriaLabel, closeAriaLabel = _param_closeAriaLabel === void 0 ? "Close" : _param_closeAriaLabel, _param_showGradient = param.showGradient, showGradient = _param_showGradient === void 0 ? true : _param_showGradient;
    return /* @__PURE__ */ jsxs13("div", {
        className: "".concat(className, " ").concat(showGradient ? "with-gradient" : "no-gradient"),
        children: [
            /* @__PURE__ */ jsxs13("div", {
                className: "header-left",
                children: [
                    icon && /* @__PURE__ */ jsx26("div", {
                        className: "header-icon",
                        children: icon
                    }),
                    /* @__PURE__ */ jsx26("span", {
                        className: "header-title",
                        children: title
                    })
                ]
            }),
            onClose && /* @__PURE__ */ jsx26("button", {
                className: "header-close",
                "aria-label": closeAriaLabel,
                onClick: onClose,
                children: /* @__PURE__ */ jsx26(DismissCircle24Regular, {})
            })
        ]
    });
};
var CardHeader_default = styled17(CardHeader)(_templateObject18());
// src/components/elements/FormField/FormField.tsx
import styled18 from "styled-components";
import { jsx as jsx27, jsxs as jsxs14 } from "react/jsx-runtime";
var FormField = function(_param) {
    var className = _param.className, type = _param.type, label = _param.label, value = _param.value, onChange = _param.onChange, placeholder = _param.placeholder, _param_disabled = _param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, _param_required = _param.required, required = _param_required === void 0 ? false : _param_required, error = _param.error, description = _param.description, _param_options = _param.options, options = _param_options === void 0 ? [] : _param_options, _param_rows = _param.rows, rows = _param_rows === void 0 ? 3 : _param_rows, autoComplete = _param.autoComplete, id = _param.id, name = _param.name, maxLength = _param.maxLength, min = _param.min, max = _param.max, step = _param.step, props = _object_without_properties(_param, [
        "className",
        "type",
        "label",
        "value",
        "onChange",
        "placeholder",
        "disabled",
        "required",
        "error",
        "description",
        "options",
        "rows",
        "autoComplete",
        "id",
        "name",
        "maxLength",
        "min",
        "max",
        "step"
    ]);
    var fieldId = id || "field-".concat(Math.random().toString(36).substr(2, 9));
    var hasError = Boolean(error);
    var renderInput = function() {
        var commonProps = _object_spread({
            id: fieldId,
            name: name || fieldId,
            value: value,
            onChange: function(e) {
                return onChange(e.target.value);
            },
            placeholder: placeholder,
            disabled: disabled,
            required: required,
            autoComplete: autoComplete,
            maxLength: maxLength,
            className: hasError ? "error" : "",
            "aria-describedby": description ? "".concat(fieldId, "-desc") : void 0,
            "aria-invalid": hasError
        }, props);
        switch(type){
            case "select":
                return /* @__PURE__ */ jsxs14("select", _object_spread_props(_object_spread({}, commonProps), {
                    children: [
                        placeholder && /* @__PURE__ */ jsx27("option", {
                            value: "",
                            disabled: true,
                            children: placeholder
                        }),
                        options.map(function(option) {
                            return /* @__PURE__ */ jsx27("option", {
                                value: option.value,
                                disabled: option.disabled,
                                children: option.label
                            }, option.value);
                        })
                    ]
                }));
            case "textarea":
                return /* @__PURE__ */ jsx27("textarea", _object_spread_props(_object_spread({}, commonProps), {
                    rows: rows
                }));
            case "number":
                return /* @__PURE__ */ jsx27("input", _object_spread_props(_object_spread({}, commonProps), {
                    type: "number",
                    min: min,
                    max: max,
                    step: step
                }));
            default:
                return /* @__PURE__ */ jsx27("input", _object_spread_props(_object_spread({}, commonProps), {
                    type: type
                }));
        }
    };
    return /* @__PURE__ */ jsxs14("div", {
        className: "".concat(className, " form-field ").concat(hasError ? "has-error" : ""),
        children: [
            label && /* @__PURE__ */ jsxs14("label", {
                htmlFor: fieldId,
                className: "field-label",
                children: [
                    label,
                    required && /* @__PURE__ */ jsx27("span", {
                        className: "required-indicator",
                        children: "*"
                    })
                ]
            }),
            /* @__PURE__ */ jsx27("div", {
                className: "field-input-wrapper",
                children: renderInput()
            }),
            description && /* @__PURE__ */ jsx27("p", {
                id: "".concat(fieldId, "-desc"),
                className: "field-description",
                children: description
            }),
            error && /* @__PURE__ */ jsx27("p", {
                className: "field-error",
                role: "alert",
                children: error
            })
        ]
    });
};
var FormField_default = styled18(FormField)(_templateObject19());
// src/components/elements/GenerateButton/GenerateButton.tsx
import { useState as useState8 } from "react";
import styled19 from "styled-components";
import { TableAdd20Regular } from "@fluentui/react-icons";
import { jsx as jsx28 } from "react/jsx-runtime";
var ButtonContainer = styled19.div(_templateObject20(), function(props) {
    return props.$enabled ? "pointer" : "not-allowed";
}, function(props) {
    return props.$enabled ? 1 : 0.5;
}, function(props) {
    return props.$enabled ? 0.8 : 0.5;
});
var GenerateButton = function(param) {
    var enabled = param.enabled, reason = param.reason, onClick = param.onClick, _param_enabledTooltipText = param.enabledTooltipText, enabledTooltipText = _param_enabledTooltipText === void 0 ? "Generate Twin metadata file" : _param_enabledTooltipText, disabledTooltipText = param.disabledTooltipText, tmp = param.size, size2 = tmp === void 0 ? "medium" : tmp;
    var _useState8 = _sliced_to_array(useState8(false), 2), isHovered = _useState8[0], setIsHovered = _useState8[1];
    var tooltipText = enabled ? enabledTooltipText : disabledTooltipText || reason;
    return /* @__PURE__ */ jsx28(HoverTip, {
        text: tooltipText,
        children: /* @__PURE__ */ jsx28(ButtonContainer, {
            $enabled: enabled,
            $size: size2,
            onMouseEnter: function() {
                setIsHovered(true);
            },
            onMouseLeave: function() {
                setIsHovered(false);
            },
            onClick: function() {
                if (enabled) {
                    onClick();
                }
            },
            children: /* @__PURE__ */ jsx28(TableAdd20Regular, {
                style: {
                    color: !enabled ? "#888" : isHovered ? "#00bbcc" : "#242424",
                    width: 20,
                    height: 20,
                    transition: "color 0.2s"
                }
            })
        })
    });
};
// src/components/elements/LabeledThing/LabeledThing.tsx
import { Label as Label3 } from "@fluentui/react-components";
import styled20 from "styled-components";
import { jsx as jsx29, jsxs as jsxs15 } from "react/jsx-runtime";
var LabeledThing_ = function(param) {
    var className = param.className, label = param.label, htmlFor = param.htmlFor, children = param.children, style = param.style;
    return /* @__PURE__ */ jsxs15("div", {
        className: className,
        style: style,
        children: [
            /* @__PURE__ */ jsxs15(Label3, {
                htmlFor: htmlFor,
                className: "label",
                children: [
                    label,
                    ":"
                ]
            }),
            /* @__PURE__ */ jsx29("div", {
                className: "content",
                children: children
            })
        ]
    });
};
var LabeledThing = styled20(LabeledThing_)(_templateObject21());
// src/components/elements/TimelineIndicator/TimelineIndicator.tsx
import { Fragment as Fragment10, jsx as jsx30 } from "react/jsx-runtime";
var TimelineIndicator = function(param) {
    var _param_show = param.show, show = _param_show === void 0 ? false : _param_show;
    return /* @__PURE__ */ jsx30(Fragment10, {
        children: show ? /* @__PURE__ */ jsx30("div", {
            className: "line",
            style: {
                position: "absolute",
                bottom: "5px",
                left: "0px",
                width: "2px",
                height: "60px",
                backgroundColor: "#242424"
            },
            children: /* @__PURE__ */ jsx30("div", {
                className: "line-bullet",
                style: {
                    position: "absolute",
                    top: "0px",
                    left: "-3px",
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    backgroundColor: "#242424"
                }
            })
        }) : null
    });
};
var TimelineIndicator_default = TimelineIndicator;
// src/components/elements/TLFilter/TLFilter.tsx
import React13, { useEffect as useEffect6, useRef as useRef4, useState as useState9 } from "react";
import styled23 from "styled-components";
import { ChevronLeft16Filled, ChevronRight16Filled } from "@fluentui/react-icons";
// src/components/elements/TLFilter/icons.tsx
import { jsx as jsx31 } from "react/jsx-runtime";
var DotsIcon = function(props) {
    return /* @__PURE__ */ jsx31("svg", _object_spread_props(_object_spread({
        width: "14",
        height: "6",
        viewBox: "0 0 8 3",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /* @__PURE__ */ jsx31("path", {
            d: "M1.4043 2.12891C1.22461 2.12891 1.07031 2.06445 0.941406 1.93555C0.816406 1.80664 0.753906 1.65234 0.753906 1.47266C0.753906 1.29297 0.816406 1.13867 0.941406 1.00977C1.07031 0.876953 1.22461 0.810547 1.4043 0.810547C1.58789 0.810547 1.74414 0.876953 1.87305 1.00977C2.00195 1.13867 2.06641 1.29297 2.06641 1.47266C2.06641 1.65234 2.00195 1.80664 1.87305 1.93555C1.74414 2.06445 1.58789 2.12891 1.4043 2.12891ZM4.00586 2.12891C3.82617 2.12891 3.67188 2.06445 3.54297 1.93555C3.41797 1.80664 3.35547 1.65234 3.35547 1.47266C3.35547 1.29297 3.41797 1.13867 3.54297 1.00977C3.67188 0.876953 3.82617 0.810547 4.00586 0.810547C4.18945 0.810547 4.3457 0.876953 4.47461 1.00977C4.60352 1.13867 4.66797 1.29297 4.66797 1.47266C4.66797 1.65234 4.60352 1.80664 4.47461 1.93555C4.3457 2.06445 4.18945 2.12891 4.00586 2.12891ZM6.60742 2.12891C6.42773 2.12891 6.27344 2.06445 6.14453 1.93555C6.01953 1.80664 5.95703 1.65234 5.95703 1.47266C5.95703 1.29297 6.01953 1.13867 6.14453 1.00977C6.27344 0.876953 6.42773 0.810547 6.60742 0.810547C6.79102 0.810547 6.94727 0.876953 7.07617 1.00977C7.20508 1.13867 7.26953 1.29297 7.26953 1.47266C7.26953 1.65234 7.20508 1.80664 7.07617 1.93555C6.94727 2.06445 6.79102 2.12891 6.60742 2.12891Z",
            fill: "black"
        })
    }));
};
// src/components/elements/TLFilterPill/TLFilterPill.tsx
import styled21 from "styled-components";
import { Dismiss12Regular } from "@fluentui/react-icons";
import { jsx as jsx32, jsxs as jsxs16 } from "react/jsx-runtime";
var TLFilterPill = function(param) {
    var className = param.className, label = param.label, onClick = param.onClick;
    return /* @__PURE__ */ jsxs16("span", {
        className: className,
        onClick: onClick,
        children: [
            /* @__PURE__ */ jsx32("p", {
                children: label
            }),
            /* @__PURE__ */ jsx32(Dismiss12Regular, {})
        ]
    });
};
var TLFilterPill_default = styled21(TLFilterPill)(_templateObject22());
// src/components/elements/TLFilterClearPill/TLFilterClearPill.tsx
import styled22 from "styled-components";
import { jsx as jsx33 } from "react/jsx-runtime";
var TLFilterClearPill = function(param) {
    var className = param.className, label = param.label, onClick = param.onClick;
    return /* @__PURE__ */ jsx33("span", {
        className: className,
        onClick: onClick,
        children: /* @__PURE__ */ jsx33("p", {
            children: label
        })
    });
};
var TLFilterClearPill_default = styled22(TLFilterClearPill)(_templateObject23());
// src/components/elements/TLFilter/TLFilter.tsx
import { Fragment as Fragment11, jsx as jsx34, jsxs as jsxs17 } from "react/jsx-runtime";
var ArrowGroup = styled23.div(_templateObject24());
var TLFilter = function(param) {
    var className = param.className, filter = param.filter, removeFilter = param.removeFilter, clearFilter = param.clearFilter, rootEntityId = param.rootEntityId;
    var containerRef = useRef4(null);
    var _useState9 = _sliced_to_array(useState9(false), 2), isOverflowing = _useState9[0], setIsOverflowing = _useState9[1];
    var _useState91 = _sliced_to_array(useState9(false), 2), showLeftArrow = _useState91[0], setShowLeftArrow = _useState91[1];
    var _useState92 = _sliced_to_array(useState9(false), 2), showRightArrow = _useState92[0], setShowRightArrow = _useState92[1];
    var checkOverflowAndScrollPosition = function() {
        var container = containerRef.current;
        if (container) {
            var scrollWidth = container.scrollWidth;
            var clientWidth = container.clientWidth;
            var scrollLeft = container.scrollLeft;
            setIsOverflowing(scrollWidth > clientWidth);
            setShowLeftArrow(scrollLeft > 0);
            var buffer = 5;
            setShowRightArrow(scrollLeft + clientWidth < scrollWidth - buffer);
        }
    };
    var scrollContainer = function(direction) {
        var container = containerRef.current;
        if (container) {
            var scrollAmount = 300;
            var firstPill = container.querySelector(".filter-pill");
            var firstPillWidth = firstPill ? firstPill.offsetWidth : 0;
            var newScrollPosition;
            if (direction === "left") {
                if (container.scrollLeft <= firstPillWidth) {
                    newScrollPosition = 0;
                } else {
                    newScrollPosition = container.scrollLeft - scrollAmount;
                }
                container.scrollTo({
                    left: newScrollPosition,
                    behavior: "smooth"
                });
            } else {
                newScrollPosition = Math.min(container.scrollWidth - container.clientWidth, container.scrollLeft + scrollAmount);
                container.scrollTo({
                    left: newScrollPosition,
                    behavior: "smooth"
                });
            }
            setTimeout(function() {
                checkOverflowAndScrollPosition();
            }, 400);
        }
    };
    useEffect6(function() {
        checkOverflowAndScrollPosition();
        window.addEventListener("resize", checkOverflowAndScrollPosition);
        return function() {
            window.removeEventListener("resize", checkOverflowAndScrollPosition);
        };
    }, []);
    useEffect6(function() {
        checkOverflowAndScrollPosition();
    }, [
        filter
    ]);
    return /* @__PURE__ */ jsxs17("div", {
        className: className,
        children: [
            showLeftArrow && /* @__PURE__ */ jsxs17(ArrowGroup, {
                children: [
                    /* @__PURE__ */ jsx34("button", {
                        className: "arrow left",
                        onClick: function() {
                            return scrollContainer("left");
                        },
                        children: /* @__PURE__ */ jsx34(ChevronLeft16Filled, {})
                    }),
                    /* @__PURE__ */ jsx34(DotsIcon, {
                        className: "dots left"
                    })
                ]
            }),
            /* @__PURE__ */ jsx34("div", {
                className: "filter-pills",
                ref: containerRef,
                children: filter.map(function(f, i) {
                    return /* @__PURE__ */ jsx34(React13.Fragment, {
                        children: rootEntityId !== f.id ? /* @__PURE__ */ jsx34(Fragment11, {
                            children: f.display && /* @__PURE__ */ jsx34("div", {
                                className: "filter-pill-wrapper",
                                children: /* @__PURE__ */ jsx34(TLFilterPill_default, {
                                    onClick: function() {
                                        removeFilter(i);
                                    },
                                    label: f.label
                                })
                            })
                        }) : /* @__PURE__ */ jsx34(Fragment11, {})
                    }, i);
                })
            }),
            showRightArrow && /* @__PURE__ */ jsxs17(ArrowGroup, {
                children: [
                    /* @__PURE__ */ jsx34(DotsIcon, {
                        className: "dots right"
                    }),
                    /* @__PURE__ */ jsx34("button", {
                        className: "arrow right",
                        onClick: function() {
                            return scrollContainer("right");
                        },
                        children: /* @__PURE__ */ jsx34(ChevronRight16Filled, {})
                    })
                ]
            }),
            filter.length > 1 && /* @__PURE__ */ jsx34(TLFilterClearPill_default, {
                onClick: function() {
                    clearFilter();
                },
                label: "Clear all"
            })
        ]
    });
};
var TLFilter_default = styled23(TLFilter)(_templateObject25());
// src/components/elements/TLPromptInput/TLPromptInput.tsx
import { forwardRef as forwardRef4 } from "react";
import { jsx as jsx35 } from "react/jsx-runtime";
var TLPromptInput = forwardRef4(function(param, ref3) {
    var props = param.props;
    return /* @__PURE__ */ jsx35("input", _object_spread({
        ref: ref3
    }, props));
});
var TLPromptInput_default = TLPromptInput;
// src/components/elements/ThresholdAlertIndividualView/ThresholdAlertIndividualView.tsx
import { useState as useState10 } from "react";
import styled24 from "styled-components";
import { Alert24Regular, Add24Regular, TextGrammarCheckmark24Regular } from "@fluentui/react-icons";
import { jsx as jsx36, jsxs as jsxs18 } from "react/jsx-runtime";
var ThresholdAlertIndividualView = function(param) {
    var className = param.className, ruleset = param.ruleset, onDelete = param.onDelete, onFieldSave = param.onFieldSave, index = param.index, _param_startInEditMode = param.startInEditMode, startInEditMode = _param_startInEditMode === void 0 ? false : _param_startInEditMode, _param_assetOptions = param.assetOptions, assetOptions = _param_assetOptions === void 0 ? [] : _param_assetOptions, _param_metrics = param.metrics, metrics = _param_metrics === void 0 ? [] : _param_metrics;
    var _useState10 = _sliced_to_array(useState10({}), 2), validationErrors = _useState10[0], setValidationErrors = _useState10[1];
    var _useState101 = _sliced_to_array(useState10(ruleset.rules || []), 2), rules = _useState101[0], setRules = _useState101[1];
    var _useState102 = _sliced_to_array(useState10(/* @__PURE__ */ new Set()), 2), editingFields = _useState102[0], setEditingFields = _useState102[1];
    var shouldShowAssetField = function(monitored_bids) {
        if (!monitored_bids || monitored_bids.trim() === "") {
            return true;
        }
        return !monitored_bids.includes(",");
    };
    var getMonitoringScopeValue = function(monitored_bids) {
        if (!monitored_bids || monitored_bids.trim() === "") {
            return "specific";
        }
        return monitored_bids.includes(",") ? "allEquipment" : "specific";
    };
    var formatMetricDisplayName = function(metricName) {
        if (!metricName) return metricName;
        var spacedName = metricName.replace(/([a-z])([A-Z])/g, "$1 $2");
        return spacedName.charAt(0).toUpperCase() + spacedName.slice(1);
    };
    var handleEdit = function(fieldName, _value) {
        setEditingFields(function(prev) {
            return /* @__PURE__ */ new Set(_to_consumable_array(Array.from(prev)).concat([
                fieldName
            ]));
        });
    };
    var handleSave = function(fieldName, value) {
        if (fieldName === "name" && !value.trim()) {
            setValidationErrors(function(prev) {
                return _object_spread_props(_object_spread({}, prev), _define_property({}, fieldName, "Ruleset name is required"));
            });
            return false;
        }
        if (fieldName === "notificationMethod" && !value) {
            setValidationErrors(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    notificationMethod: "Please select a notification method"
                });
            });
            return false;
        }
        setValidationErrors(function(prev) {
            var newErrors = _object_spread({}, prev);
            delete newErrors[fieldName];
            return newErrors;
        });
        setEditingFields(function(prev) {
            var newSet = new Set(prev);
            newSet.delete(fieldName);
            return newSet;
        });
        if (onFieldSave) {
            onFieldSave(ruleset.id, fieldName, value);
        }
        return true;
    };
    var handleCancel = function(fieldName) {
        setValidationErrors({});
        if (fieldName) {
            setEditingFields(function(prev) {
                var newSet = new Set(prev);
                newSet.delete(fieldName);
                return newSet;
            });
        }
    };
    var sanitizeAssetName = function(name) {
        return name.replace(/^(-\s*)+/, "").replace(/\s*\(A\)$/, "").replace(/,/g, ";").replace(/[\r\n\t]/g, " ").trim();
    };
    var getAllAssetData = function(assetOptions2) {
        var assets = assetOptions2.filter(function(option) {
            return option.isAsset;
        });
        return {
            bids: assets.map(function(option) {
                return option.value;
            }).join(","),
            names: assets.map(function(option) {
                return sanitizeAssetName(option.label);
            }).join(",")
        };
    };
    var handleAddRule = function() {
        var newRule = {
            metric: "",
            operator: "EQUAL_TO",
            value: 0,
            monitoringMode: "allEquipment",
            // Default to all equipment monitoring
            monitored_bids: getAllAssetData(assetOptions).bids,
            // Set to comma-separated asset BIDs
            monitored_names: getAllAssetData(assetOptions).names
        };
        var updatedRules = _to_consumable_array(rules).concat([
            newRule
        ]);
        var newRuleIndex = updatedRules.length - 1;
        setRules(updatedRules);
        var fieldsToEdit = [
            "monitoringMode",
            "metric",
            "operator",
            "value",
            "duration-days",
            "duration-hours",
            "duration-minutes"
        ];
        setEditingFields(function(prev) {
            var newSet = new Set(prev);
            fieldsToEdit.forEach(function(field) {
                newSet.add(getFieldKey(newRuleIndex, field));
            });
            return newSet;
        });
        if (onFieldSave) {
            onFieldSave(ruleset.id, "rules", updatedRules);
        }
    };
    var handleRemoveRule = function(ruleIndex) {
        var updatedRules = rules.filter(function(_, index2) {
            return index2 !== ruleIndex;
        });
        setRules(updatedRules);
        setEditingFields(function(prev) {
            var newSet = /* @__PURE__ */ new Set();
            Array.from(prev).forEach(function(fieldKey) {
                var match = fieldKey.match(/^rule-(\d+)-(.+)$/);
                if (match) {
                    var ruleIdx = parseInt(match[1]);
                    var field = match[2];
                    if (ruleIdx < ruleIndex) {
                        newSet.add(fieldKey);
                    } else if (ruleIdx > ruleIndex) {
                        newSet.add(getFieldKey(ruleIdx - 1, field));
                    }
                }
            });
            return newSet;
        });
        if (onFieldSave) {
            onFieldSave(ruleset.id, "rules", updatedRules);
        }
    };
    var getFieldKey = function(ruleIndex, field) {
        return "rule-".concat(ruleIndex, "-").concat(field);
    };
    var isFieldEditing = function(ruleIndex, field) {
        return editingFields.has(getFieldKey(ruleIndex, field));
    };
    var handleRuleFieldEdit = function(ruleIndex, field) {
        var fieldKey = getFieldKey(ruleIndex, field);
        setEditingFields(function(prev) {
            return /* @__PURE__ */ new Set(_to_consumable_array(Array.from(prev)).concat([
                fieldKey
            ]));
        });
    };
    var handleRuleFieldCancel = function(ruleIndex, field) {
        var fieldKey = getFieldKey(ruleIndex, field);
        setEditingFields(function(prev) {
            var newSet = new Set(prev);
            newSet.delete(fieldKey);
            return newSet;
        });
    };
    var handleAssetSelectionSave = function(ruleIndex, value) {
        var updatedRules = _to_consumable_array(rules);
        var rule = updatedRules[ruleIndex];
        if (value) {
            var selectedAsset = assetOptions.find(function(option) {
                return option.value === value;
            });
            if (selectedAsset) {
                rule.monitored_bids = selectedAsset.value;
                rule.monitored_names = sanitizeAssetName(selectedAsset.label);
            }
        } else {
            rule.monitored_bids = "";
            rule.monitored_names = void 0;
        }
        setRules(updatedRules);
        var fieldKey = getFieldKey(ruleIndex, "asset");
        setEditingFields(function(prev) {
            var newSet = new Set(prev);
            newSet.delete(fieldKey);
            return newSet;
        });
        if (onFieldSave) {
            onFieldSave(ruleset.id, "rules", updatedRules);
        }
    };
    var handleRuleFieldSave = function(ruleIndex, field, value) {
        var updatedRules = _to_consumable_array(rules);
        var rule = updatedRules[ruleIndex];
        if (field === "value") {
            rule[field] = parseFloat(value) || 0;
        } else if (field === "duration") {
            return;
        } else if (field === "monitoringMode") {
            rule[field] = value;
            if (value === "allEquipment") {
                var assetData = getAllAssetData(assetOptions);
                rule.monitored_bids = assetData.bids;
                rule.monitored_names = assetData.names;
            } else {
                rule.monitored_bids = "";
                rule.monitored_names = void 0;
            }
        } else {
            rule[field] = value;
        }
        setRules(updatedRules);
        var fieldKey = getFieldKey(ruleIndex, field);
        setEditingFields(function(prev) {
            var newSet = new Set(prev);
            newSet.delete(fieldKey);
            return newSet;
        });
        if (onFieldSave) {
            onFieldSave(ruleset.id, "rules", updatedRules);
        }
    };
    var handleDurationFieldSave = function(ruleIndex, durationType, value) {
        var updatedRules = _to_consumable_array(rules);
        var rule = updatedRules[ruleIndex];
        if (!rule.duration) {
            rule.duration = {};
        }
        var numValue = value ? parseInt(value) : void 0;
        rule.duration[durationType] = numValue;
        if (!rule.duration.days && !rule.duration.hours && !rule.duration.minutes) {
            rule.duration = void 0;
        }
        setRules(updatedRules);
        var fieldKey = getFieldKey(ruleIndex, "duration-".concat(durationType));
        setEditingFields(function(prev) {
            var newSet = new Set(prev);
            newSet.delete(fieldKey);
            return newSet;
        });
        if (onFieldSave) {
            onFieldSave(ruleset.id, "rules", updatedRules);
        }
    };
    return /* @__PURE__ */ jsx36("div", {
        className: className,
        children: /* @__PURE__ */ jsxs18(PanelCard_default, {
            children: [
                /* @__PURE__ */ jsx36(CardHeader_default, {
                    title: "Threshold Alert Ruleset ".concat(index),
                    icon: /* @__PURE__ */ jsx36(Alert24Regular, {}),
                    onClose: function() {
                        return onDelete && onDelete(ruleset.id);
                    },
                    closeAriaLabel: "Delete Threshold Alert Ruleset"
                }),
                /* @__PURE__ */ jsxs18("div", {
                    className: "content",
                    children: [
                        /* @__PURE__ */ jsx36(EditableFieldRow_default, {
                            label: "Name",
                            value: ruleset.name,
                            isEditing: startInEditMode || editingFields.has("name"),
                            onEdit: function(value) {
                                return handleEdit("name", value);
                            },
                            onSave: function(value) {
                                return handleSave("name", value);
                            },
                            onCancel: function() {
                                return handleCancel("name");
                            },
                            errorMessage: validationErrors.name
                        }),
                        /* @__PURE__ */ jsx36(EditableFieldRow_default, {
                            label: "Description",
                            value: ruleset.description || "",
                            isEditing: startInEditMode || editingFields.has("description"),
                            onEdit: function(value) {
                                return handleEdit("description", value);
                            },
                            onSave: function(value) {
                                return handleSave("description", value);
                            },
                            onCancel: function() {
                                return handleCancel("description");
                            },
                            errorMessage: validationErrors.description
                        }),
                        /* @__PURE__ */ jsx36(EditableFieldRow_default, {
                            label: "Notification Method",
                            value: ruleset.notificationMethod || "",
                            type: "select",
                            isEditing: startInEditMode || editingFields.has("notificationMethod"),
                            onEdit: function(value) {
                                return handleEdit("notificationMethod", value);
                            },
                            onSave: function(value) {
                                return handleSave("notificationMethod", value);
                            },
                            onCancel: function() {
                                return handleCancel("notificationMethod");
                            },
                            errorMessage: validationErrors.notificationMethod,
                            useSimpleSelect: true,
                            selectOptions: [
                                {
                                    value: "both",
                                    label: "Both SMS and Email"
                                },
                                {
                                    value: "sms",
                                    label: "SMS Only"
                                },
                                {
                                    value: "email",
                                    label: "Email Only"
                                }
                            ]
                        }),
                        /* @__PURE__ */ jsxs18("div", {
                            className: "rules-section",
                            children: [
                                /* @__PURE__ */ jsx36("div", {
                                    className: "rules-header",
                                    children: /* @__PURE__ */ jsxs18("h3", {
                                        className: "rules-title",
                                        children: [
                                            "Rules (",
                                            rules.length,
                                            ")"
                                        ]
                                    })
                                }),
                                rules.length === 0 ? /* @__PURE__ */ jsx36("div", {
                                    className: "no-rules-message",
                                    children: 'No rules defined. Click "Add Rule" to create your first rule.'
                                }) : /* @__PURE__ */ jsx36("div", {
                                    className: "rules-list",
                                    children: rules.map(function(rule, ruleIndex) {
                                        var getDurationDisplayValue = function(durationType) {
                                            var _rule_duration;
                                            var value = (_rule_duration = rule.duration) === null || _rule_duration === void 0 ? void 0 : _rule_duration[durationType];
                                            return (value === null || value === void 0 ? void 0 : value.toString()) || "";
                                        };
                                        return /* @__PURE__ */ jsxs18("div", {
                                            className: "rule-row",
                                            children: [
                                                /* @__PURE__ */ jsx36("div", {
                                                    className: "rule-header",
                                                    children: /* @__PURE__ */ jsx36(CardHeader_default, {
                                                        title: "Rule ".concat(ruleIndex + 1),
                                                        icon: /* @__PURE__ */ jsx36(TextGrammarCheckmark24Regular, {}),
                                                        onClose: function() {
                                                            return handleRemoveRule(ruleIndex);
                                                        },
                                                        closeAriaLabel: "Delete Rule"
                                                    })
                                                }),
                                                /* @__PURE__ */ jsxs18("div", {
                                                    className: "rule-fields",
                                                    children: [
                                                        /* @__PURE__ */ jsx36(EditableFieldRow_default, {
                                                            label: "Monitoring Scope",
                                                            value: getMonitoringScopeValue(rule.monitored_bids || ""),
                                                            type: "select",
                                                            isEditing: isFieldEditing(ruleIndex, "monitoringMode"),
                                                            onEdit: function() {
                                                                return handleRuleFieldEdit(ruleIndex, "monitoringMode");
                                                            },
                                                            onSave: function(value) {
                                                                return handleRuleFieldSave(ruleIndex, "monitoringMode", value);
                                                            },
                                                            onCancel: function() {
                                                                return handleRuleFieldCancel(ruleIndex, "monitoringMode");
                                                            },
                                                            useSimpleSelect: true,
                                                            selectOptions: [
                                                                {
                                                                    value: "allEquipment",
                                                                    label: "All Equipment"
                                                                },
                                                                {
                                                                    value: "specific",
                                                                    label: "Specific Area/Equipment"
                                                                }
                                                            ]
                                                        }),
                                                        shouldShowAssetField(rule.monitored_bids || "") && /* @__PURE__ */ jsx36(EditableFieldRow_default, {
                                                            label: "Asset",
                                                            value: rule.monitored_bids || "",
                                                            type: "select",
                                                            isEditing: isFieldEditing(ruleIndex, "asset"),
                                                            onEdit: function() {
                                                                return handleRuleFieldEdit(ruleIndex, "asset");
                                                            },
                                                            onSave: function(value) {
                                                                return handleAssetSelectionSave(ruleIndex, value);
                                                            },
                                                            onCancel: function() {
                                                                return handleRuleFieldCancel(ruleIndex, "asset");
                                                            },
                                                            useSimpleSelect: true,
                                                            selectOptions: [
                                                                {
                                                                    value: "",
                                                                    label: "Please select"
                                                                }
                                                            ].concat(_to_consumable_array(assetOptions.map(function(option) {
                                                                return {
                                                                    value: option.value,
                                                                    label: option.label
                                                                };
                                                            })))
                                                        }),
                                                        /* @__PURE__ */ jsx36(EditableFieldRow_default, {
                                                            label: "Metric",
                                                            value: rule.metric,
                                                            type: "select",
                                                            isEditing: isFieldEditing(ruleIndex, "metric"),
                                                            onEdit: function() {
                                                                return handleRuleFieldEdit(ruleIndex, "metric");
                                                            },
                                                            onSave: function(value) {
                                                                return handleRuleFieldSave(ruleIndex, "metric", value);
                                                            },
                                                            onCancel: function() {
                                                                return handleRuleFieldCancel(ruleIndex, "metric");
                                                            },
                                                            useSimpleSelect: true,
                                                            selectOptions: [
                                                                {
                                                                    value: "",
                                                                    label: "Please select"
                                                                }
                                                            ].concat(_to_consumable_array(metrics.map(function(metric) {
                                                                return {
                                                                    value: metric.id,
                                                                    label: formatMetricDisplayName(metric.name)
                                                                };
                                                            })))
                                                        }),
                                                        /* @__PURE__ */ jsx36(EditableFieldRow_default, {
                                                            label: "Operator",
                                                            value: rule.operator,
                                                            type: "select",
                                                            isEditing: isFieldEditing(ruleIndex, "operator"),
                                                            onEdit: function() {
                                                                return handleRuleFieldEdit(ruleIndex, "operator");
                                                            },
                                                            onSave: function(value) {
                                                                return handleRuleFieldSave(ruleIndex, "operator", value);
                                                            },
                                                            onCancel: function() {
                                                                return handleRuleFieldCancel(ruleIndex, "operator");
                                                            },
                                                            useSimpleSelect: true,
                                                            selectOptions: [
                                                                {
                                                                    value: "EQUAL_TO",
                                                                    label: "Equal To"
                                                                },
                                                                {
                                                                    value: "GREATER_THAN",
                                                                    label: "Greater Than"
                                                                },
                                                                {
                                                                    value: "LESS_THAN",
                                                                    label: "Less Than"
                                                                },
                                                                {
                                                                    value: "GREATER_THAN_OR_EQUAL_TO",
                                                                    label: "Greater Than or Equal To"
                                                                },
                                                                {
                                                                    value: "LESS_THAN_OR_EQUAL_TO",
                                                                    label: "Less Than or Equal To"
                                                                }
                                                            ]
                                                        }),
                                                        /* @__PURE__ */ jsx36(EditableFieldRow_default, {
                                                            label: "Value",
                                                            value: rule.value.toString(),
                                                            type: "text",
                                                            isEditing: isFieldEditing(ruleIndex, "value"),
                                                            onEdit: function() {
                                                                return handleRuleFieldEdit(ruleIndex, "value");
                                                            },
                                                            onSave: function(value) {
                                                                return handleRuleFieldSave(ruleIndex, "value", value);
                                                            },
                                                            onCancel: function() {
                                                                return handleRuleFieldCancel(ruleIndex, "value");
                                                            }
                                                        }),
                                                        /* @__PURE__ */ jsx36(EditableFieldRow_default, {
                                                            label: "Duration (Days)",
                                                            value: getDurationDisplayValue("days"),
                                                            type: "text",
                                                            isEditing: isFieldEditing(ruleIndex, "duration-days"),
                                                            onEdit: function() {
                                                                return handleRuleFieldEdit(ruleIndex, "duration-days");
                                                            },
                                                            onSave: function(value) {
                                                                return handleDurationFieldSave(ruleIndex, "days", value);
                                                            },
                                                            onCancel: function() {
                                                                return handleRuleFieldCancel(ruleIndex, "duration-days");
                                                            }
                                                        }),
                                                        /* @__PURE__ */ jsx36(EditableFieldRow_default, {
                                                            label: "Duration (Hours)",
                                                            value: getDurationDisplayValue("hours"),
                                                            type: "text",
                                                            isEditing: isFieldEditing(ruleIndex, "duration-hours"),
                                                            onEdit: function() {
                                                                return handleRuleFieldEdit(ruleIndex, "duration-hours");
                                                            },
                                                            onSave: function(value) {
                                                                return handleDurationFieldSave(ruleIndex, "hours", value);
                                                            },
                                                            onCancel: function() {
                                                                return handleRuleFieldCancel(ruleIndex, "duration-hours");
                                                            }
                                                        }),
                                                        /* @__PURE__ */ jsx36(EditableFieldRow_default, {
                                                            label: "Duration (Minutes)",
                                                            value: getDurationDisplayValue("minutes"),
                                                            type: "text",
                                                            isEditing: isFieldEditing(ruleIndex, "duration-minutes"),
                                                            onEdit: function() {
                                                                return handleRuleFieldEdit(ruleIndex, "duration-minutes");
                                                            },
                                                            onSave: function(value) {
                                                                return handleDurationFieldSave(ruleIndex, "minutes", value);
                                                            },
                                                            onCancel: function() {
                                                                return handleRuleFieldCancel(ruleIndex, "duration-minutes");
                                                            }
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, ruleIndex);
                                    })
                                }),
                                /* @__PURE__ */ jsxs18("button", {
                                    className: "btn-add-rule",
                                    type: "button",
                                    onClick: handleAddRule,
                                    children: [
                                        /* @__PURE__ */ jsx36("span", {
                                            className: "add-rule-icon-left",
                                            children: /* @__PURE__ */ jsx36(TextGrammarCheckmark24Regular, {})
                                        }),
                                        /* @__PURE__ */ jsx36("span", {
                                            className: "add-rule-label",
                                            children: "Add Rule"
                                        }),
                                        /* @__PURE__ */ jsx36("span", {
                                            className: "add-rule-icon-right",
                                            children: /* @__PURE__ */ jsx36(Add24Regular, {})
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var ThresholdAlertIndividualView_default = styled24(ThresholdAlertIndividualView)(_templateObject26());
// src/components/elements/LookupSheetButton/LookupSheetButton.tsx
import { useState as useState11 } from "react";
import { Search20Regular as Search20Regular2 } from "@fluentui/react-icons";
import { jsx as jsx37, jsxs as jsxs19 } from "react/jsx-runtime";
var LookupSheetButton = function(param) {
    var sheetId = param.sheetId, baseUrl = param.baseUrl, accessToken = param.accessToken, onSync = param.onSync;
    var _useState11 = _sliced_to_array(useState11(false), 2), loading = _useState11[0], setLoading = _useState11[1];
    var _useState111 = _sliced_to_array(useState11(null), 2), success = _useState111[0], setSuccess = _useState111[1];
    var _useState112 = _sliced_to_array(useState11(null), 2), error = _useState112[0], setError = _useState112[1];
    var _useState113 = _sliced_to_array(useState11(false), 2), hovered = _useState113[0], setHovered = _useState113[1];
    var handleClick = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var resp, data, e;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!sheetId) return [
                            2
                        ];
                        setLoading(true);
                        setSuccess(null);
                        setError(null);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            5,
                            6
                        ]);
                        return [
                            4,
                            fetch("".concat(baseUrl, "api/google-sheets/sync-sheet"), {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                    Authorization: "Bearer ".concat(accessToken)
                                },
                                body: JSON.stringify({
                                    sheetId: sheetId
                                })
                            })
                        ];
                    case 2:
                        resp = _state.sent();
                        if (!resp.ok) throw new Error("Sync failed");
                        return [
                            4,
                            resp.json()
                        ];
                    case 3:
                        data = _state.sent();
                        setSuccess(data.updated);
                        if (onSync) onSync(data.updated);
                        return [
                            3,
                            6
                        ];
                    case 4:
                        e = _state.sent();
                        setError(e.message || "Sync failed");
                        return [
                            3,
                            6
                        ];
                    case 5:
                        setLoading(false);
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleClick() {
            return _ref.apply(this, arguments);
        };
    }();
    return /* @__PURE__ */ jsx37(HoverTip, {
        text: error ? "Sync failed: ".concat(error) : success !== null ? "Sheet updated! ".concat(success, " row(s) refreshed.") : "Lookup and update file rows by ID or Floorplanner ID",
        children: /* @__PURE__ */ jsxs19("span", {
            style: {
                display: "inline-flex",
                alignItems: "center",
                cursor: !sheetId || loading ? "not-allowed" : "pointer",
                opacity: !sheetId || loading ? 0.5 : 1,
                borderRadius: 4,
                padding: 4,
                transition: "background 0.2s"
            },
            tabIndex: 0,
            role: "button",
            "aria-disabled": !sheetId || loading,
            onClick: function(e) {
                if (!sheetId || loading) return;
                handleClick();
            },
            onKeyDown: function(e) {
                if ((e.key === "Enter" || e.key === " ") && sheetId && !loading) {
                    handleClick();
                }
            },
            onMouseEnter: function() {
                return setHovered(true);
            },
            onMouseLeave: function() {
                return setHovered(false);
            },
            onFocus: function() {
                return setHovered(true);
            },
            onBlur: function() {
                return setHovered(false);
            },
            title: "Lookup and update file rows",
            children: [
                /* @__PURE__ */ jsx37(Search20Regular2, {
                    style: {
                        color: !sheetId || loading ? "#888" : hovered ? "#00bbcc" : "#242424",
                        width: 20,
                        height: 20,
                        transition: "color 0.2s"
                    }
                }),
                loading && /* @__PURE__ */ jsx37(TLSpinner_default, {
                    props: {
                        size: "tiny",
                        style: {
                            marginLeft: 4,
                            verticalAlign: "middle"
                        }
                    }
                })
            ]
        })
    });
};
// src/components/elements/LookupSheetButton/AutoLookupSheetButton.tsx
import { useState as useState12 } from "react";
import { ArrowSync20Regular } from "@fluentui/react-icons";
import { jsx as jsx38, jsxs as jsxs20 } from "react/jsx-runtime";
var AutoLookupSheetButton = function(param) {
    var sheetId = param.sheetId, baseUrl = param.baseUrl, accessToken = param.accessToken, onSync = param.onSync, onStart = param.onStart, onComplete = param.onComplete, onProgress = param.onProgress;
    var _useState12 = _sliced_to_array(useState12(false), 2), loading = _useState12[0], setLoading = _useState12[1];
    var _useState121 = _sliced_to_array(useState12(null), 2), success = _useState121[0], setSuccess = _useState121[1];
    var _useState122 = _sliced_to_array(useState12(null), 2), error = _useState122[0], setError = _useState122[1];
    var _useState123 = _sliced_to_array(useState12(false), 2), hovered = _useState123[0], setHovered = _useState123[1];
    var handleClick = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var poll, poller, resp, data, e;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        poll = false;
                        if (!sheetId) return [
                            2
                        ];
                        setLoading(true);
                        setSuccess(null);
                        setError(null);
                        if (onStart) onStart();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            5,
                            6
                        ]);
                        poll = true;
                        poller = /*#__PURE__*/ function() {
                            var _ref = _async_to_generator(function() {
                                var resp2, p, _p_current, cur, _p_total, tot, e;
                                return _ts_generator(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (!poll) return [
                                                3,
                                                8
                                            ];
                                            _state.label = 1;
                                        case 1:
                                            _state.trys.push([
                                                1,
                                                5,
                                                ,
                                                6
                                            ]);
                                            return [
                                                4,
                                                fetch("".concat(baseUrl, "api/google-sheets/auto-lookup-progress/").concat(sheetId), {
                                                    headers: {
                                                        Authorization: "Bearer ".concat(accessToken)
                                                    }
                                                })
                                            ];
                                        case 2:
                                            resp2 = _state.sent();
                                            if (!resp2.ok) return [
                                                3,
                                                4
                                            ];
                                            return [
                                                4,
                                                resp2.json()
                                            ];
                                        case 3:
                                            p = _state.sent();
                                            if (p && typeof p.current === "number" && typeof p.total === "number") {
                                                setSuccess(null);
                                                setError(null);
                                                ;
                                                cur = (_p_current = p.current) !== null && _p_current !== void 0 ? _p_current : 0;
                                                ;
                                                tot = (_p_total = p.total) !== null && _p_total !== void 0 ? _p_total : 0;
                                                if (onProgress) onProgress(cur, tot);
                                            }
                                            if ((p === null || p === void 0 ? void 0 : p.status) === "completed") return [
                                                3,
                                                8
                                            ];
                                            _state.label = 4;
                                        case 4:
                                            return [
                                                3,
                                                6
                                            ];
                                        case 5:
                                            e = _state.sent();
                                            return [
                                                3,
                                                6
                                            ];
                                        case 6:
                                            return [
                                                4,
                                                new Promise(function(r) {
                                                    return setTimeout(r, 1e3);
                                                })
                                            ];
                                        case 7:
                                            _state.sent();
                                            return [
                                                3,
                                                0
                                            ];
                                        case 8:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function poller() {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        poller();
                        return [
                            4,
                            fetch("".concat(baseUrl, "api/google-sheets/auto-lookup-sheet"), {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                    Authorization: "Bearer ".concat(accessToken)
                                },
                                body: JSON.stringify({
                                    sheetId: sheetId
                                })
                            })
                        ];
                    case 2:
                        resp = _state.sent();
                        if (!resp.ok) throw new Error("Auto lookup failed");
                        return [
                            4,
                            resp.json()
                        ];
                    case 3:
                        data = _state.sent();
                        setSuccess(data.updated);
                        if (onSync) onSync(data.updated);
                        if (onComplete) onComplete(data.updated);
                        return [
                            3,
                            6
                        ];
                    case 4:
                        e = _state.sent();
                        setError(e.message || "Auto lookup failed");
                        return [
                            3,
                            6
                        ];
                    case 5:
                        poll = false;
                        setLoading(false);
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleClick() {
            return _ref.apply(this, arguments);
        };
    }();
    return /* @__PURE__ */ jsx38(HoverTip, {
        text: error ? "Auto lookup failed: ".concat(error) : success !== null ? "Auto lookup complete! ".concat(success, " row(s) updated.") : "Auto-lookup Reference IDs by API Name/Brand",
        children: /* @__PURE__ */ jsxs20("span", {
            style: {
                display: "inline-flex",
                alignItems: "center",
                cursor: !sheetId || loading ? "not-allowed" : "pointer",
                opacity: !sheetId || loading ? 0.5 : 1,
                borderRadius: 4,
                padding: 4,
                transition: "background 0.2s"
            },
            tabIndex: 0,
            role: "button",
            "aria-disabled": !sheetId || loading,
            onClick: function() {
                if (!sheetId || loading) return;
                handleClick();
            },
            onKeyDown: function(e) {
                if ((e.key === "Enter" || e.key === " ") && sheetId && !loading) {
                    handleClick();
                }
            },
            onMouseEnter: function() {
                return setHovered(true);
            },
            onMouseLeave: function() {
                return setHovered(false);
            },
            onFocus: function() {
                return setHovered(true);
            },
            onBlur: function() {
                return setHovered(false);
            },
            title: "Auto-lookup by API fields",
            children: [
                /* @__PURE__ */ jsx38(ArrowSync20Regular, {
                    style: {
                        color: !sheetId || loading ? "#888" : hovered ? "#00bbcc" : "#242424",
                        width: 20,
                        height: 20,
                        transition: "color 0.2s"
                    }
                }),
                loading && /* @__PURE__ */ jsx38(TLSpinner_default, {
                    props: {
                        size: "tiny",
                        style: {
                            marginLeft: 4,
                            verticalAlign: "middle"
                        }
                    }
                })
            ]
        })
    });
};
// src/components/Subtitle/Subtitle.tsx
import { jsx as jsx39 } from "react/jsx-runtime";
var Subtitle = function(param) {
    var children = param.children, _param_className = param.className, className = _param_className === void 0 ? "" : _param_className, m = param.m;
    var subtitleStyle = {
        color: "var(--Neutral-Foreground-1-Rest, #242424)",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 600,
        lineHeight: "22px",
        // 137.5%
        margin: m
    };
    return /* @__PURE__ */ jsx39("p", {
        className: className,
        style: subtitleStyle,
        children: children
    });
};
var Subtitle_default = Subtitle;
// src/components/PasswordRequirements/PasswordRequirements.tsx
import styled25 from "styled-components";
import { jsx as jsx40, jsxs as jsxs21 } from "react/jsx-runtime";
var PasswordRequirements = function(param) {
    var className = param.className;
    return /* @__PURE__ */ jsxs21("div", {
        className: className,
        children: [
            /* @__PURE__ */ jsx40("p", {
                children: /* @__PURE__ */ jsx40("strong", {
                    children: "Password Requirements"
                })
            }),
            /* @__PURE__ */ jsx40("p", {
                children: "At least 8 characters in length"
            }),
            /* @__PURE__ */ jsx40("p", {
                children: "Contain at least 3 of the following 4 types of characters:"
            }),
            /* @__PURE__ */ jsxs21("ul", {
                children: [
                    /* @__PURE__ */ jsx40("li", {
                        children: "Lower case letters (a-z)"
                    }),
                    /* @__PURE__ */ jsx40("li", {
                        children: "Upper case letters (A-Z)"
                    }),
                    /* @__PURE__ */ jsx40("li", {
                        children: "Numbers (i.e. 0-9)"
                    }),
                    /* @__PURE__ */ jsx40("li", {
                        children: "Special characters (e.g. @#$%^&*)"
                    })
                ]
            })
        ]
    });
};
var PasswordRequirements_default = styled25(PasswordRequirements)(_templateObject27());
// src/components/Pagination/Pagination.tsx
import styled26 from "styled-components";
import { ChevronLeft20Filled, ChevronRight20Filled } from "@fluentui/react-icons";
import { jsx as jsx41, jsxs as jsxs22 } from "react/jsx-runtime";
var Pagination = function(param) {
    var className = param.className, limit = param.limit, currentPage = param.currentPage, totalPages = param.totalPages, noMoreRecords = param.noMoreRecords, _param_enableChangeLimit = param.enableChangeLimit, enableChangeLimit = _param_enableChangeLimit === void 0 ? true : _param_enableChangeLimit, changeLimit = param.changeLimit, switchPage = param.switchPage;
    return /* @__PURE__ */ jsxs22("div", {
        className: className,
        children: [
            enableChangeLimit && /* @__PURE__ */ jsxs22("div", {
                className: "pagination-rows",
                children: [
                    /* @__PURE__ */ jsx41("label", {
                        htmlFor: "ddlLimit",
                        children: "Rows per page:"
                    }),
                    /* @__PURE__ */ jsxs22("select", {
                        id: "ddlLimit",
                        value: limit,
                        onChange: function(e) {
                            changeLimit(Number(e.target.value));
                        },
                        children: [
                            /* @__PURE__ */ jsx41("option", {
                                value: "10",
                                children: "10"
                            }),
                            /* @__PURE__ */ jsx41("option", {
                                value: "20",
                                children: "20"
                            }),
                            /* @__PURE__ */ jsx41("option", {
                                value: "50",
                                children: "50"
                            }),
                            /* @__PURE__ */ jsx41("option", {
                                value: "100",
                                children: "100"
                            })
                        ]
                    })
                ]
            }),
            /* @__PURE__ */ jsxs22("div", {
                className: "pagination-stepper",
                children: [
                    /* @__PURE__ */ jsxs22("label", {
                        htmlFor: "stepper",
                        children: [
                            "Page ",
                            currentPage + 1,
                            " ",
                            totalPages ? "of ".concat(totalPages) : null
                        ]
                    }),
                    /* @__PURE__ */ jsxs22("div", {
                        id: "stepper",
                        children: [
                            /* @__PURE__ */ jsx41("button", {
                                className: currentPage === 0 ? "disabled" : "",
                                disabled: currentPage === 0,
                                onClick: function() {
                                    return switchPage(currentPage - 1);
                                },
                                children: /* @__PURE__ */ jsx41("span", {
                                    className: "icon",
                                    children: /* @__PURE__ */ jsx41(ChevronLeft20Filled, {})
                                })
                            }),
                            /* @__PURE__ */ jsx41("button", {
                                className: noMoreRecords ? "disabled" : "",
                                disabled: noMoreRecords,
                                onClick: function() {
                                    return switchPage(currentPage + 1);
                                },
                                children: /* @__PURE__ */ jsx41("span", {
                                    className: "icon",
                                    children: /* @__PURE__ */ jsx41(ChevronRight20Filled, {})
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var Pagination_default = styled26(Pagination)(_templateObject28());
// src/motion/useRowMotionAnnouncement.ts
import { useEffect as useEffect7, useRef as useRef5, useState as useState13 } from "react";
var SAID_MS = 3e3;
var useRowMotionAnnouncement = function(moved, describe2) {
    var _useState13 = _sliced_to_array(useState13(""), 2), text = _useState13[0], setText = _useState13[1];
    var describeRef = useRef5(describe2);
    describeRef.current = describe2;
    useEffect7(function() {
        if (moved.length === 0) return;
        var said = moved.map(function(key) {
            return describeRef.current(key);
        }).filter(Boolean).join(". ");
        setText(said);
        var t = window.setTimeout(function() {
            return setText("");
        }, SAID_MS);
        return function() {
            return window.clearTimeout(t);
        };
    }, [
        moved
    ]);
    return text;
};
// src/motion/useKeepFocusAcrossMove.ts
import { useLayoutEffect, useRef as useRef6 } from "react";
var FOCUSABLE = "button, a[href], input, select, textarea, [tabindex]";
var useKeepFocusAcrossMove = function(containerRef) {
    var held = useRef6(null);
    var container = containerRef.current;
    var active = typeof document !== "undefined" ? document.activeElement : null;
    var row = container && _instanceof(active, HTMLElement) && container.contains(active) ? active.closest("[".concat(ROW_MOTION_KEY_ATTR, "]")) : null;
    var key = row === null || row === void 0 ? void 0 : row.getAttribute(ROW_MOTION_KEY_ATTR);
    held.current = row && key && _instanceof(active, HTMLElement) ? {
        key: key,
        label: active.getAttribute("aria-label"),
        index: Array.from(row.querySelectorAll(FOCUSABLE)).indexOf(active)
    } : null;
    useLayoutEffect(function() {
        var was = held.current;
        held.current = null;
        var box = containerRef.current;
        if (!was || !box) return;
        var now = document.activeElement;
        if (_instanceof(now, HTMLElement) && now !== document.body && document.contains(now)) return;
        var row2 = Array.from(box.querySelectorAll("[".concat(ROW_MOTION_KEY_ATTR, "]"))).find(function(el) {
            return el.getAttribute(ROW_MOTION_KEY_ATTR) === was.key;
        });
        if (!row2) return;
        var controls = Array.from(row2.querySelectorAll(FOCUSABLE));
        var _ref;
        var control = (_ref = was.label !== null ? controls.find(function(el) {
            return el.getAttribute("aria-label") === was.label;
        }) : void 0) !== null && _ref !== void 0 ? _ref : was.index >= 0 ? controls[was.index] : void 0;
        control === null || control === void 0 ? void 0 : control.focus({
            preventScroll: true
        });
    });
};
// src/motion/usePresence.ts
import { useCallback as useCallback2, useEffect as useEffect8, useLayoutEffect as useLayoutEffect2, useRef as useRef7, useState as useState14 } from "react";
import { motion as motion2 } from "@repo/design-tokens";
var DURATION_MS = parseFloat(motion2.durFast) * 1e3;
var EASE = motion2.easeUi;
var GUARD_MS = DURATION_MS + 100;
var canAnimate = function(element) {
    return !!element && typeof element.animate === "function";
};
var drawnOpacity = function(element) {
    var value = parseFloat(window.getComputedStyle(element).opacity);
    return Number.isFinite(value) ? value : 1;
};
var usePresence = function(shown) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_animate = _ref.animate, animate = _ref_animate === void 0 ? true : _ref_animate, exitKey = _ref.exitKey;
    var _useState14 = _sliced_to_array(useState14(shown), 2), mounted = _useState14[0], setMounted = _useState14[1];
    var _useState141 = _sliced_to_array(useState14(false), 2), exiting = _useState141[0], setExiting = _useState141[1];
    var _useState142 = _sliced_to_array(useState14(shown), 2), lastShown = _useState142[0], setLastShown = _useState142[1];
    var _useState143 = _sliced_to_array(useState14(function() {
        return exitKey;
    }), 2), lastExitKey = _useState143[0], setLastExitKey = _useState143[1];
    var element = useRef7(null);
    var pending = useRef7(null);
    var running = useRef7(null);
    var held = useRef7(null);
    var guard = useRef7(null);
    var run = useRef7(0);
    var alive = useRef7(true);
    if (!Object.is(exitKey, lastExitKey)) {
        setLastExitKey(function() {
            return exitKey;
        });
        if (exiting && shown === lastShown) {
            setMounted(false);
            setExiting(false);
            pending.current = "stop";
        }
    }
    if (shown !== lastShown) {
        setLastShown(shown);
        var fades = animate && !prefersReducedMotion();
        if (!shown) {
            if (mounted && fades && canAnimate(element.current)) {
                setExiting(true);
                pending.current = "out";
            } else {
                setMounted(false);
                setExiting(false);
                pending.current = "stop";
            }
        } else {
            setMounted(true);
            setExiting(false);
            pending.current = fades ? "in" : "stop";
        }
    }
    var stop = useCallback2(function() {
        var _running_current, _held_current;
        run.current += 1;
        (_running_current = running.current) === null || _running_current === void 0 ? void 0 : _running_current.cancel();
        running.current = null;
        (_held_current = held.current) === null || _held_current === void 0 ? void 0 : _held_current.cancel();
        held.current = null;
        if (guard.current !== null) window.clearTimeout(guard.current);
        guard.current = null;
    }, []);
    useLayoutEffect2(function() {
        var _anim_finished;
        var what = pending.current;
        pending.current = null;
        if (!what) return;
        var node = element.current;
        if (what === "stop" || !canAnimate(node)) {
            stop();
            if (what === "out" && alive.current) {
                setMounted(false);
                setExiting(false);
            }
            return;
        }
        var onNode = [
            running.current,
            held.current
        ].some(function(fade) {
            var _fade_effect;
            return (fade === null || fade === void 0 ? void 0 : (_fade_effect = fade.effect) === null || _fade_effect === void 0 ? void 0 : _fade_effect.target) === node;
        });
        var from = onNode ? drawnOpacity(node) : what === "in" ? 0 : 1;
        stop();
        var to = what === "in" ? 1 : 0;
        var anim = node.animate([
            {
                opacity: from
            },
            {
                opacity: to
            }
        ], {
            duration: DURATION_MS,
            easing: EASE,
            fill: "forwards"
        });
        running.current = anim;
        var mine = run.current;
        var done = function() {
            if (!alive.current || run.current !== mine) return;
            if (what === "in") {
                stop();
                return;
            }
            run.current += 1;
            held.current = anim;
            running.current = null;
            if (guard.current !== null) window.clearTimeout(guard.current);
            guard.current = null;
            setMounted(false);
            setExiting(false);
        };
        (_anim_finished = anim.finished) === null || _anim_finished === void 0 ? void 0 : _anim_finished.then(done, function() {
            return void 0;
        });
        if (what === "out") guard.current = window.setTimeout(done, GUARD_MS);
    });
    useLayoutEffect2(function() {
        if (mounted || !held.current) return;
        held.current.cancel();
        held.current = null;
    }, [
        mounted
    ]);
    useEffect8(function() {
        alive.current = true;
        return function() {
            alive.current = false;
            stop();
        };
    }, [
        stop
    ]);
    var ref3 = useCallback2(function(node) {
        element.current = node;
    }, []);
    return {
        mounted: mounted,
        exiting: exiting,
        ref: ref3
    };
};
// src/components/DialogForm/DialogForm.tsx
import { useEffect as useEffect9, useState as useState15 } from "react";
import styled27 from "styled-components";
import loadingGif from "@repo/assets/loading.gif";
import { jsx as jsx42, jsxs as jsxs23 } from "react/jsx-runtime";
var DialogForm = function(param) {
    var className = param.className, isLoading = param.isLoading, icon = param.icon, header = param.header, content = param.content, contentRole = param.contentRole, children = param.children;
    var _useState15 = _sliced_to_array(useState15(false), 2), loading = _useState15[0], setLoading = _useState15[1];
    useEffect9(function() {
        setLoading(isLoading ? isLoading : false);
    }, [
        isLoading
    ]);
    return /* @__PURE__ */ jsxs23("div", {
        className: className,
        children: [
            /* @__PURE__ */ jsx42("div", {
                className: "image-icon",
                children: /* @__PURE__ */ jsx42("span", {
                    className: "icon",
                    children: icon
                })
            }),
            /* @__PURE__ */ jsx42("h2", {
                children: header
            }),
            /* @__PURE__ */ jsx42("p", {
                role: contentRole,
                children: content
            }),
            loading ? /* @__PURE__ */ jsx42("div", {
                className: "loading",
                children: /* @__PURE__ */ jsx42(TLSpinner_default, {
                    custom: /* @__PURE__ */ jsx42("img", {
                        src: typeof loadingGif === "string" ? loadingGif : loadingGif.src,
                        width: 200,
                        height: 200,
                        alt: "Loading..."
                    })
                })
            }) : /* @__PURE__ */ jsx42("div", {
                className: "form-container",
                children: children
            })
        ]
    });
};
var DialogForm_default = styled27(DialogForm)(_templateObject29(), function(props) {
    return props.adminForm ? "90%" : "350px";
});
// src/components/LabelHeader/LabelHeader.tsx
import styled28 from "styled-components";
// src/components/3D/theme.ts
import { Color } from "three";
var ASSET_COLOR = 16777215;
var INTER_FONT_FAMILY = '"Inter", sans-serif';
var FROSTED_CRYSTAL_GLOW = new Color(0.8, 2, 1.8);
var defaultColours = {
    hoverBlack: 3158064,
    staticGray: 15592941,
    assetStates: {
        default: {
            bounds: {
                color: 16777215,
                opacity: 0.4
            },
            outline: {
                color: 16777215,
                opacity: 0.7
            }
        },
        least: {
            bounds: {
                color: 12514546,
                // 0xa5ebff
                opacity: 0.35
            },
            outline: {
                color: 6281439,
                opacity: 0.7
            }
        },
        average: {
            bounds: {
                color: 9430760,
                opacity: 0.35
            },
            outline: {
                color: 6281439,
                opacity: 0.7
            }
        },
        most: {
            bounds: {
                color: 48076,
                // 0x5FD8DF
                opacity: 0.35
            },
            outline: {
                color: 6281439,
                opacity: 0.7
            }
        },
        overused: {
            bounds: {
                color: 12914463,
                opacity: 0.35
            },
            outline: {
                color: 13637376,
                opacity: 0.7
            }
        }
    }
};
// src/components/LabelHeader/LabelHeader.tsx
import { jsx as jsx43, jsxs as jsxs24 } from "react/jsx-runtime";
var LabelHeader = function(param) {
    var className = param.className, id = param.id, indicator = param.indicator, title = param.title, fontSize = param.fontSize, showId = param.showId;
    return /* @__PURE__ */ jsxs24("div", {
        className: className,
        children: [
            title && /* @__PURE__ */ jsxs24("div", {
                className: "label",
                style: {
                    fontSize: fontSize ? fontSize : "12px"
                },
                children: [
                    title,
                    showId ? /* @__PURE__ */ jsxs24("small", {
                        children: [
                            "(",
                            id,
                            ")"
                        ]
                    }) : null
                ]
            }),
            /* @__PURE__ */ jsx43("span", {
                className: "indicator",
                children: indicator
            })
        ]
    });
};
var LabelHeader_default = styled28(LabelHeader)(_templateObject30(), INTER_FONT_FAMILY);
// src/components/EditorForm/EditorForm.tsx
import styled29 from "styled-components";
import { jsx as jsx44 } from "react/jsx-runtime";
var EditorForm = function(param) {
    var className = param.className, children = param.children;
    return /* @__PURE__ */ jsx44("div", {
        className: className,
        children: /* @__PURE__ */ jsx44("div", {
            className: "form-container",
            children: children
        })
    });
};
var EditorForm_default = styled29(EditorForm)(_templateObject31());
// src/components/SectionHeader/SectionHeader.tsx
import styled30 from "styled-components";
import { jsx as jsx45, jsxs as jsxs25 } from "react/jsx-runtime";
var SectionHeader = function(param) {
    var title = param.title, className = param.className;
    return /* @__PURE__ */ jsxs25("div", {
        className: className,
        children: [
            /* @__PURE__ */ jsx45("div", {
                className: "divider-line-left"
            }),
            /* @__PURE__ */ jsx45("span", {
                className: "divider-text",
                children: title
            }),
            /* @__PURE__ */ jsx45("div", {
                className: "divider-line-right"
            })
        ]
    });
};
var SectionHeader_default = styled30(SectionHeader)(_templateObject32());
// src/components/Indicator/Indicator.tsx
import { jsx as jsx46, jsxs as jsxs26 } from "react/jsx-runtime";
var Indicator = function(param) {
    var className = param.className, backgroundColor = param.backgroundColor, value = param.value, _param_px = param.px, px = _param_px === void 0 ? 8 : _param_px, _param_marginRight = param.marginRight, marginRight = _param_marginRight === void 0 ? 5 : _param_marginRight;
    return /* @__PURE__ */ jsxs26("div", {
        className: className,
        children: [
            /* @__PURE__ */ jsx46("span", {
                style: {
                    width: "".concat(px, "px"),
                    height: "".concat(px, "px"),
                    borderRadius: "".concat(px, "px"),
                    display: "inline-block",
                    marginRight: "".concat(marginRight, "px"),
                    backgroundColor: backgroundColor
                }
            }),
            /* @__PURE__ */ jsx46("span", {
                className: "value",
                children: value
            })
        ]
    });
};
var Indicator_default = Indicator;
// src/components/MonthStepper/MonthStepper.tsx
import { useState as useState16 } from "react";
import styled31 from "styled-components";
import { ChevronLeft16Filled as ChevronLeft16Filled2, ChevronRight16Filled as ChevronRight16Filled2 } from "@fluentui/react-icons";
import { jsx as jsx47, jsxs as jsxs27 } from "react/jsx-runtime";
var MonthStepper = function(param) {
    var className = param.className, monthViewDateTime = param.monthViewDateTime, setMonth = param.setMonth;
    var _useState16 = _sliced_to_array(useState16(monthViewDateTime), 2), currentMonth = _useState16[0], setCurrentMonth = _useState16[1];
    var goBackOneMonth = function() {
        var newDate = new Date(currentMonth);
        newDate.setMonth(currentMonth.getMonth() - 1);
        setMonth(newDate);
        setCurrentMonth(newDate);
    };
    var goForwardOneMonth = function() {
        var newDate = new Date(currentMonth);
        newDate.setMonth(currentMonth.getMonth() + 1);
        setMonth(newDate);
        setCurrentMonth(newDate);
    };
    var formatMonthString = function(date) {
        var options = {
            year: "numeric",
            month: "long"
        };
        return date.toLocaleDateString(void 0, options);
    };
    return /* @__PURE__ */ jsx47("div", {
        className: className,
        children: /* @__PURE__ */ jsxs27("div", {
            className: "calendar-stepper",
            children: [
                /* @__PURE__ */ jsx47("button", {
                    onClick: goBackOneMonth,
                    children: /* @__PURE__ */ jsx47(ChevronLeft16Filled2, {})
                }),
                /* @__PURE__ */ jsx47("p", {
                    children: formatMonthString(currentMonth)
                }),
                /* @__PURE__ */ jsx47("button", {
                    onClick: goForwardOneMonth,
                    children: /* @__PURE__ */ jsx47(ChevronRight16Filled2, {})
                })
            ]
        })
    });
};
var MonthStepper_default = styled31(MonthStepper)(_templateObject33());
// src/components/Steps/Steps.tsx
import styled32 from "styled-components";
import { Circle12Regular, Circle12Filled } from "@fluentui/react-icons";
import { jsx as jsx48 } from "react/jsx-runtime";
var Steps = function(param) {
    var className = param.className, current = param.current, total = param.total;
    var renderSteps = function() {
        var renderedItems = [];
        for(var i = 0; i < total; i++){
            renderedItems.push(/* @__PURE__ */ jsx48("span", {
                className: "icon",
                children: current === i ? /* @__PURE__ */ jsx48(Circle12Filled, {}) : /* @__PURE__ */ jsx48(Circle12Regular, {})
            }, i));
        }
        return renderedItems;
    };
    return /* @__PURE__ */ jsx48("div", {
        className: className,
        children: renderSteps()
    });
};
var Steps_default = styled32(Steps)(_templateObject34());
// src/components/AITypingMessage/AITypingMessage.tsx
import { useEffect as useEffect10, useMemo as useMemo3, useRef as useRef8 } from "react";
import { useSpotlightStore } from "@repo/front-end-state";
// src/components/AITypingMessage/matchEntities.ts
function matchEntities(tokens, entities) {
    if (entities.length === 0 || tokens.length === 0) return [];
    var sortedEntities = _to_consumable_array(entities).sort(function(a, b) {
        return b.name.length - a.name.length;
    });
    var matches = [];
    var i = 0;
    while(i < tokens.length){
        if (tokens[i].type !== "word") {
            i++;
            continue;
        }
        var matched = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = sortedEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entity = _step.value;
                var result = tryMatchAt(tokens, i, entity.name);
                if (result !== null) {
                    matches.push({
                        bid: entity.bid,
                        spanIndices: result.spanIndices
                    });
                    i = result.endExclusive;
                    matched = true;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (!matched) i++;
    }
    return matches;
}
var TRAILING_PUNCT_RE = /[.,;:!?)\]"»]+$/;
function tryMatchAt(tokens, startIdx, name) {
    var nameWords = name.split(/\s+/).filter(function(w) {
        return w.length > 0;
    });
    if (nameWords.length === 0) return null;
    var spanIndices = [];
    var tokenIdx = startIdx;
    var wordIdx = 0;
    while(wordIdx < nameWords.length){
        if (tokenIdx >= tokens.length) return null;
        var tok = tokens[tokenIdx];
        if (tok.type !== "word") return null;
        var isLastWord = wordIdx === nameWords.length - 1;
        var wantedWord = nameWords[wordIdx];
        if (tok.text === wantedWord) {} else if (isLastWord) {
            var stripped = tok.text.replace(TRAILING_PUNCT_RE, "");
            if (stripped !== wantedWord) return null;
        } else {
            return null;
        }
        spanIndices.push(tok.index);
        tokenIdx++;
        wordIdx++;
        if (wordIdx < nameWords.length) {
            if (tokenIdx >= tokens.length) return null;
            var next = tokens[tokenIdx];
            if (next.type !== "space") return null;
            spanIndices.push(next.index);
            tokenIdx++;
        }
    }
    return {
        spanIndices: spanIndices,
        endExclusive: tokenIdx
    };
}
// src/components/AITypingMessage/buildChunkedHtml.ts
var MAX_CHUNK_LENGTH = 80;
var MIN_CLAUSE_LENGTH = 30;
function splitIntoChunks(text) {
    if (!text) return [];
    var sentences = [];
    var buf = "";
    for(var i = 0; i < text.length; i++){
        buf += text[i];
        if (/[.!?]/.test(text[i])) {
            while(i + 1 < text.length && /\s/.test(text[i + 1])){
                buf += text[i + 1];
                i++;
            }
            sentences.push(buf);
            buf = "";
        }
    }
    if (buf) sentences.push(buf);
    var chunks = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = sentences[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var sentence = _step.value;
            if (sentence.length <= MAX_CHUNK_LENGTH) {
                chunks.push(sentence);
                continue;
            }
            var cbuf = "";
            for(var i1 = 0; i1 < sentence.length; i1++){
                cbuf += sentence[i1];
                if (/[,;:—]/.test(sentence[i1])) {
                    while(i1 + 1 < sentence.length && /\s/.test(sentence[i1 + 1])){
                        cbuf += sentence[i1 + 1];
                        i1++;
                    }
                    if (cbuf.length >= MIN_CLAUSE_LENGTH) {
                        chunks.push(cbuf);
                        cbuf = "";
                    }
                }
            }
            if (cbuf) {
                if (chunks.length > 0 && cbuf.length < MIN_CLAUSE_LENGTH) {
                    chunks[chunks.length - 1] += cbuf;
                } else {
                    chunks.push(cbuf);
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return chunks;
}
function tokenize(text) {
    if (!text) return [];
    var tokens = [];
    var buf = "";
    var mode = /^\s/.test(text) ? "space" : "word";
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = text[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var ch = _step.value;
            var chMode = /\s/.test(ch) ? "space" : "word";
            if (chMode !== mode) {
                tokens.push({
                    type: mode,
                    text: buf
                });
                buf = ch;
                mode = chMode;
            } else {
                buf += ch;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (buf) tokens.push({
        type: mode,
        text: buf
    });
    return tokens;
}
var ALLOWED_TAGS = /* @__PURE__ */ new Set([
    "STRONG",
    "B",
    "EM",
    "I",
    "CODE",
    "BR"
]);
function buildChunkedHtml(rawHtml, entities) {
    if (!rawHtml) return {
        html: "",
        chunkCount: 0
    };
    if (typeof document === "undefined") return {
        html: rawHtml,
        chunkCount: 0
    };
    var wrap = document.createElement("div");
    wrap.innerHTML = rawHtml;
    var chunkIdx = 0;
    var walk = function(node) {
        if (node.nodeType === Node.TEXT_NODE) {
            var _node_parentNode;
            var text = node.textContent || "";
            if (!text) return;
            var chunks = splitIntoChunks(text);
            if (chunks.length === 0) return;
            var flatTokens = [];
            var chunkOf = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = chunks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var chunk = _step.value;
                    var id = chunkIdx++;
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = tokenize(chunk)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var tok = _step1.value;
                            flatTokens.push({
                                type: tok.type,
                                text: tok.text,
                                index: flatTokens.length
                            });
                            chunkOf.push(id);
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            var bidByIndex = /* @__PURE__ */ new Map();
            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
            try {
                for(var _iterator2 = matchEntities(flatTokens, entities)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                    var match = _step2.value;
                    var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                    try {
                        for(var _iterator3 = match.spanIndices[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                            var idx = _step3.value;
                            bidByIndex.set(idx, match.bid);
                        }
                    } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                                _iterator3.return();
                            }
                        } finally{
                            if (_didIteratorError3) {
                                throw _iteratorError3;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                        _iterator2.return();
                    }
                } finally{
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
            var frag = document.createDocumentFragment();
            for(var i = 0; i < flatTokens.length; i++){
                var tok1 = flatTokens[i];
                var chunkId = chunkOf[i];
                var bid = bidByIndex.get(i);
                if (tok1.type === "word") {
                    var span = document.createElement("span");
                    span.className = bid ? "ai-chunk-word ai-entity-link" : "ai-chunk-word";
                    span.dataset.chunk = String(chunkId);
                    span.textContent = tok1.text;
                    if (bid) {
                        span.dataset.bid = bid;
                        span.setAttribute("role", "button");
                        span.setAttribute("tabindex", "0");
                    }
                    frag.appendChild(span);
                } else if (bid) {
                    var span1 = document.createElement("span");
                    span1.className = "ai-entity-link";
                    span1.dataset.bid = bid;
                    span1.textContent = tok1.text;
                    frag.appendChild(span1);
                } else {
                    frag.appendChild(document.createTextNode(tok1.text));
                }
            }
            (_node_parentNode = node.parentNode) === null || _node_parentNode === void 0 ? void 0 : _node_parentNode.replaceChild(frag, node);
        } else if (node.nodeType === Node.ELEMENT_NODE) {
            var el = node;
            if (!ALLOWED_TAGS.has(el.tagName)) {
                var _el_parentNode;
                var textNode = document.createTextNode(el.textContent || "");
                (_el_parentNode = el.parentNode) === null || _el_parentNode === void 0 ? void 0 : _el_parentNode.replaceChild(textNode, el);
                walk(textNode);
                return;
            }
            Array.from(el.attributes).forEach(function(attr) {
                return el.removeAttribute(attr.name);
            });
            Array.from(el.childNodes).forEach(walk);
        }
    };
    Array.from(wrap.childNodes).forEach(walk);
    return {
        html: wrap.innerHTML,
        chunkCount: chunkIdx
    };
}
// src/components/AITypingMessage/handleEntityClick.ts
function handleEntityClick(e, fire) {
    if (e.type === "keydown") {
        var key = e.key;
        if (key !== "Enter" && key !== " ") return;
    }
    var targetNode = e.target;
    var targetElement = _instanceof(targetNode, Element) ? targetNode : _instanceof(targetNode, Node) ? targetNode.parentElement : null;
    var _targetElement_closest;
    var link = (_targetElement_closest = targetElement === null || targetElement === void 0 ? void 0 : targetElement.closest(".ai-entity-link")) !== null && _targetElement_closest !== void 0 ? _targetElement_closest : null;
    if (!link) return;
    var bid = link.dataset.bid;
    if (!bid) return;
    e.preventDefault();
    fire(bid);
}
// src/components/AITypingMessage/AITypingMessage.tsx
import { jsx as jsx49, jsxs as jsxs28 } from "react/jsx-runtime";
var EMPTY_ENTITIES = [];
var TypingMessage = function(param) {
    var fullMessage = param.fullMessage, _param_entities = param.entities, entities = _param_entities === void 0 ? EMPTY_ENTITIES : _param_entities, children = param.children;
    var containerRef = useRef8(null);
    var _useMemo3 = useMemo3(function() {
        return buildChunkedHtml(fullMessage, entities);
    }, [
        fullMessage,
        entities
    ]), chunkedHtml = _useMemo3.html;
    useEffect10(function() {
        var el = containerRef.current;
        if (!el) return;
        var fire = function(bid) {
            return useSpotlightStore.getState().fireSpotlight(bid);
        };
        var onEvent = function(e) {
            return handleEntityClick(e, fire);
        };
        el.addEventListener("click", onEvent);
        el.addEventListener("keydown", onEvent);
        return function() {
            el.removeEventListener("click", onEvent);
            el.removeEventListener("keydown", onEvent);
        };
    }, []);
    return /* @__PURE__ */ jsxs28("div", {
        className: "response",
        ref: containerRef,
        children: [
            /* @__PURE__ */ jsx49("span", {
                dangerouslySetInnerHTML: {
                    __html: chunkedHtml
                }
            }),
            children
        ]
    });
};
var AITypingMessage_default = TypingMessage;
// src/components/LogOut/LogOut.tsx
import { useAuth0 } from "@auth0/auth0-react";
import styled33 from "styled-components";
import { jsx as jsx50, jsxs as jsxs29 } from "react/jsx-runtime";
var LogOut = function(param) {
    var className = param.className, onClose = param.onClose;
    var logout = useAuth0().logout;
    var handleLogout = function() {
        logout({
            logoutParams: {
                returnTo: window.location.origin
            }
        });
    };
    return /* @__PURE__ */ jsxs29("div", {
        className: className,
        children: [
            /* @__PURE__ */ jsx50(PrimaryButton_default, {
                onClick: handleLogout,
                children: "Yes"
            }),
            /* @__PURE__ */ jsx50(SecondaryButton_default, {
                onClick: onClose,
                children: "No"
            })
        ]
    });
};
var LogOut_default = styled33(LogOut)(_templateObject35());
// src/components/NotificationsHeader/NotificationsHeader.tsx
import styled34 from "styled-components";
import { Dismiss16Regular, Alert20Regular } from "@fluentui/react-icons";
import { jsx as jsx51, jsxs as jsxs30 } from "react/jsx-runtime";
var NotificationsHeader = function(param) {
    var className = param.className, setIsHeaderHovered = param.setIsHeaderHovered, setNotificationsVisible = param.setNotificationsVisible, onMouseDown = param.onMouseDown, onPointerDown = param.onPointerDown;
    return /* @__PURE__ */ jsx51("div", {
        className: className,
        children: /* @__PURE__ */ jsxs30("div", {
            className: "notifications-header",
            onMouseEnter: function() {
                return setIsHeaderHovered(true);
            },
            onMouseLeave: function() {
                return setIsHeaderHovered(false);
            },
            onMouseDown: onMouseDown,
            onPointerDown: onPointerDown,
            children: [
                /* @__PURE__ */ jsxs30("div", {
                    className: "notifications-header-title",
                    children: [
                        /* @__PURE__ */ jsx51("div", {
                            className: "avatar",
                            children: /* @__PURE__ */ jsx51(Alert20Regular, {})
                        }),
                        /* @__PURE__ */ jsx51(Subtitle_default, {
                            m: "auto",
                            children: "Notifications"
                        })
                    ]
                }),
                /* @__PURE__ */ jsx51("button", {
                    className: "close-button",
                    onClick: function() {
                        return setNotificationsVisible(false);
                    },
                    children: /* @__PURE__ */ jsx51(Dismiss16Regular, {})
                })
            ]
        })
    });
};
var NotificationsHeader_default = styled34(NotificationsHeader)(_templateObject36());
// src/components/Sidebar/Sidebar.tsx
import { useEffect as useEffect11, useId as useId4, useState as useState17 } from "react";
import styled35 from "styled-components";
import { PanelLeftContract20Regular, PanelLeftExpand20Regular } from "@fluentui/react-icons";
import { Fragment as Fragment12, jsx as jsx52, jsxs as jsxs31 } from "react/jsx-runtime";
var COLLAPSE_QUERY = "(max-width: 900px)";
var deriveInitials = function(user) {
    if (user.initials) return user.initials.slice(0, 2).toUpperCase();
    if (typeof user.name === "string" && user.name.trim()) {
        var parts = user.name.trim().split(/\s+/);
        if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
        return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    return "?";
};
var countText = function(item) {
    if (item.countLabel != null) return item.countLabel;
    if (item.count != null) return String(item.count);
    return null;
};
var accessibleName = function(label, count) {
    if (typeof label !== "string") return void 0;
    return count ? "".concat(label, ", ").concat(count) : label;
};
var isExternalHref = function(href) {
    return /^(https?:|mailto:|tel:)/i.test(href);
};
var Entry = function(param) {
    var baseClass = param.baseClass, active = param.active, href = param.href, onClick = param.onClick, ariaLabel = param.ariaLabel, title = param.title, linkComponent = param.linkComponent, children = param.children;
    var common = {
        className: "".concat(baseClass).concat(active ? " active" : ""),
        "aria-current": active ? "page" : void 0,
        "aria-label": ariaLabel,
        title: title
    };
    if (href) {
        if (linkComponent && !isExternalHref(href)) {
            var LinkComponent = linkComponent;
            return /* @__PURE__ */ jsx52(LinkComponent, _object_spread_props(_object_spread({
                href: href
            }, common), {
                children: children
            }));
        }
        return /* @__PURE__ */ jsx52("a", _object_spread_props(_object_spread({
            href: href
        }, common), {
            children: children
        }));
    }
    return /* @__PURE__ */ jsx52("button", _object_spread_props(_object_spread({
        type: "button",
        onClick: onClick
    }, common), {
        children: children
    }));
};
var EntryInner = function(param) {
    var icon = param.icon, label = param.label, item = param.item;
    return /* @__PURE__ */ jsxs31(Fragment12, {
        children: [
            icon != null && /* @__PURE__ */ jsx52("span", {
                className: "nav-icon",
                "aria-hidden": "true",
                children: icon
            }),
            /* @__PURE__ */ jsx52("span", {
                className: "nav-label",
                children: label
            }),
            item && item.count != null && /* @__PURE__ */ jsx52("span", {
                className: "nav-count".concat(item.countVariant === "danger" ? " danger" : ""),
                "aria-hidden": "true",
                children: item.count
            })
        ]
    });
};
var SidebarBase = function(param) {
    var className = param.className, brand6 = param.brand, cta = param.cta, sections = param.sections, footer = param.footer, linkComponent = param.linkComponent, collapsed = param.collapsed, onToggleCollapse = param.onToggleCollapse, _param_navLabel = param.navLabel, navLabel = _param_navLabel === void 0 ? "Primary" : _param_navLabel;
    var isControlled = collapsed !== void 0;
    var _useState17 = _sliced_to_array(useState17(false), 2), internalCollapsed = _useState17[0], setInternalCollapsed = _useState17[1];
    var navId = useId4();
    useEffect11(function() {
        if (isControlled) return;
        if (typeof window === "undefined" || typeof window.matchMedia !== "function") return;
        var mq = window.matchMedia(COLLAPSE_QUERY);
        var sync = function() {
            return setInternalCollapsed(mq.matches);
        };
        sync();
        mq.addEventListener("change", sync);
        return function() {
            return mq.removeEventListener("change", sync);
        };
    }, [
        isControlled
    ]);
    var isCollapsed = isControlled ? !!collapsed : internalCollapsed;
    var toggle = function() {
        var next = !isCollapsed;
        if (!isControlled) setInternalCollapsed(next);
        onToggleCollapse === null || onToggleCollapse === void 0 ? void 0 : onToggleCollapse(next);
    };
    return /* @__PURE__ */ jsxs31("aside", {
        className: "".concat(className !== null && className !== void 0 ? className : "").concat(isCollapsed ? " collapsed" : ""),
        "data-collapsed": isCollapsed,
        children: [
            /* @__PURE__ */ jsxs31("div", {
                className: "sidebar-header",
                children: [
                    /* @__PURE__ */ jsxs31("div", {
                        className: "brand",
                        children: [
                            brand6.logo != null && /* @__PURE__ */ jsx52("span", {
                                className: "brand-logo",
                                "aria-hidden": "true",
                                children: brand6.logo
                            }),
                            /* @__PURE__ */ jsxs31("span", {
                                className: "brand-text",
                                children: [
                                    /* @__PURE__ */ jsx52("span", {
                                        className: "brand-title tl-body1-strong",
                                        children: brand6.title
                                    }),
                                    brand6.subtitle != null && /* @__PURE__ */ jsx52("span", {
                                        className: "brand-subtitle tl-caption1",
                                        children: brand6.subtitle
                                    })
                                ]
                            })
                        ]
                    }),
                    /* @__PURE__ */ jsx52("button", {
                        type: "button",
                        className: "collapse-toggle",
                        onClick: toggle,
                        "aria-expanded": !isCollapsed,
                        "aria-controls": navId,
                        "aria-label": isCollapsed ? "Expand sidebar" : "Collapse sidebar",
                        children: isCollapsed ? /* @__PURE__ */ jsx52(PanelLeftExpand20Regular, {}) : /* @__PURE__ */ jsx52(PanelLeftContract20Regular, {})
                    })
                ]
            }),
            cta && /* @__PURE__ */ jsx52("div", {
                className: "sidebar-cta",
                children: /* @__PURE__ */ jsx52(Entry, {
                    baseClass: "cta-entry",
                    active: cta.active,
                    href: cta.href,
                    onClick: cta.onClick,
                    ariaLabel: accessibleName(cta.label),
                    title: typeof cta.label === "string" ? cta.label : void 0,
                    linkComponent: linkComponent,
                    children: /* @__PURE__ */ jsx52(EntryInner, {
                        icon: cta.icon,
                        label: cta.label
                    })
                })
            }),
            /* @__PURE__ */ jsx52("nav", {
                id: navId,
                className: "sidebar-nav",
                "aria-label": navLabel,
                children: sections.map(function(section, si) {
                    return /* @__PURE__ */ jsxs31("div", {
                        className: "nav-section",
                        children: [
                            section.label && /* @__PURE__ */ jsx52("p", {
                                className: "nav-section-label tl-caption2",
                                children: section.label
                            }),
                            /* @__PURE__ */ jsx52("ul", {
                                children: section.items.map(function(item) {
                                    return /* @__PURE__ */ jsx52("li", {
                                        children: /* @__PURE__ */ jsx52(Entry, {
                                            baseClass: "nav-entry",
                                            active: item.active,
                                            href: item.href,
                                            onClick: item.onClick,
                                            ariaLabel: accessibleName(item.label, countText(item)),
                                            title: typeof item.label === "string" ? item.label : void 0,
                                            linkComponent: linkComponent,
                                            children: /* @__PURE__ */ jsx52(EntryInner, {
                                                icon: item.icon,
                                                label: item.label,
                                                item: item
                                            })
                                        })
                                    }, item.id);
                                })
                            })
                        ]
                    }, "section-".concat(si));
                })
            }),
            footer && /* @__PURE__ */ jsxs31("div", {
                className: "sidebar-footer",
                children: [
                    footer.links && footer.links.length > 0 && /* @__PURE__ */ jsx52("ul", {
                        className: "footer-links",
                        children: footer.links.map(function(link) {
                            return /* @__PURE__ */ jsx52("li", {
                                children: /* @__PURE__ */ jsx52(Entry, {
                                    baseClass: "footer-link",
                                    href: link.href,
                                    onClick: link.onClick,
                                    ariaLabel: accessibleName(link.label),
                                    title: typeof link.label === "string" ? link.label : void 0,
                                    linkComponent: linkComponent,
                                    children: /* @__PURE__ */ jsx52(EntryInner, {
                                        icon: link.icon,
                                        label: link.label
                                    })
                                })
                            }, link.id);
                        })
                    }),
                    footer.user && /* @__PURE__ */ jsxs31("div", {
                        className: "user-card",
                        children: [
                            /* @__PURE__ */ jsx52("span", {
                                className: "user-avatar",
                                "aria-hidden": "true",
                                children: deriveInitials(footer.user)
                            }),
                            /* @__PURE__ */ jsxs31("span", {
                                className: "user-text",
                                children: [
                                    /* @__PURE__ */ jsx52("span", {
                                        className: "user-name tl-body1-strong",
                                        children: footer.user.name
                                    }),
                                    footer.user.role != null && /* @__PURE__ */ jsx52("span", {
                                        className: "user-role tl-caption1",
                                        children: footer.user.role
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var Sidebar = styled35(SidebarBase)(_templateObject37());
var Sidebar_default = Sidebar;
// src/components/ModeDropdown/ModeDropdown.tsx
import { jsx as jsx53 } from "react/jsx-runtime";
var ModeDropdown = function(param) {
    var className = param.className, currentMode = param.currentMode, availableModes = param.availableModes, onChange = param.onChange;
    var handleModeSelect = function(modeValue) {
        var modeNumber = parseInt(modeValue, 10);
        onChange(modeNumber);
    };
    return /* @__PURE__ */ jsx53(BaseDropdown_default, {
        className: className,
        currentValue: currentMode.toString(),
        options: availableModes.map(function(mode) {
            return {
                value: mode.value.toString(),
                label: mode.label,
                icon: mode.icon
            };
        }),
        onOptionChange: handleModeSelect,
        maxHeight: 300,
        width: "auto",
        minWidth: "260px"
    });
};
var ModeDropdown_default = ModeDropdown;
// src/components/HeroMetricDropdown/HeroMetricDropdown.tsx
import { jsx as jsx54 } from "react/jsx-runtime";
var HeroMetricDropdown = function(param) {
    var className = param.className, currentMetric = param.currentMetric, availableMetrics = param.availableMetrics, onChange = param.onChange;
    var handleOptionChange = function(value) {
        var selectedOption = availableMetrics.find(function(option) {
            return option.value === value;
        });
        if (selectedOption) {
            onChange(selectedOption.heroMetric);
        }
    };
    return /* @__PURE__ */ jsx54(BaseDropdown_default, {
        className: className,
        currentValue: currentMetric,
        options: availableMetrics,
        onOptionChange: handleOptionChange,
        maxHeight: 300,
        width: "auto",
        minWidth: "280px"
    });
};
var HeroMetricDropdown_default = HeroMetricDropdown;
// src/components/AIConversation/AIConversation.tsx
import { useAuth0 as useAuth02 } from "@auth0/auth0-react";
import { Avatar as Avatar2 } from "@fluentui/react-components";
import { useEffect as useEffect13, useRef as useRef9, useState as useState19 } from "react";
import styled37 from "styled-components";
import { Feedback } from "@repo/frontend-types";
import { formatCopilotMessage } from "@repo/front-end-utils";
// src/components/AIConversation/icons.tsx
import { jsx as jsx55, jsxs as jsxs32 } from "react/jsx-runtime";
var MariaIcon = function(props) {
    return /* @__PURE__ */ jsxs32("svg", _object_spread_props(_object_spread({
        width: "18",
        height: "22",
        viewBox: "0 0 18 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /* @__PURE__ */ jsx55("path", {
                d: "M8.84897 8.88721C9.01546 9.42225 8.99281 9.73606 8.98162 9.98766C8.97515 10.134 8.87934 10.6777 8.67129 11.3108C8.50455 11.7672 8.98311 11.7585 9.20833 11.6799",
                stroke: "#242424",
                strokeWidth: "0.29863",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M9.75586 11.6353C9.84147 11.6353 9.95022 11.6089 10.0358 11.6089",
                stroke: "#242424",
                strokeWidth: "0.29863",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M7.20508 12.3643C7.33896 12.4282 7.47882 12.4877 7.6254 12.5412C9.19943 13.1173 10.6851 12.7094 11.194 12.5631C11.3496 12.5183 11.4727 12.4765 11.5407 12.4529",
                stroke: "#242424",
                strokeWidth: "0.373287",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M7.43164 12.5566C7.55059 12.7936 7.80617 13.2096 8.29443 13.4941C9.01139 13.9117 9.99189 13.9069 10.6835 13.3945C11.0565 13.1183 11.2469 12.7672 11.3387 12.5566",
                stroke: "#242424",
                strokeWidth: "0.373287",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M10.2183 4.8537C9.68128 4.79223 8.49223 4.72205 8.06146 4.74321C5.64729 4.86092 3.84605 8.39221 3.55563 8.0351C3.21594 7.61727 3.77985 5.33599 4.10859 4.91616C4.2482 4.73773 2.63336 6.52553 2.64854 6.2814C2.66372 6.03976 2.71524 4.95026 3.43394 3.98717C4.0312 3.1866 5.69955 2.92281 5.40813 2.86308C4.86064 2.7511 4.00482 2.38005 4.18599 2.32804C4.38781 2.27005 5.24637 2.29071 6.53073 1.78602C7.39775 1.44534 7.3216 1.47221 8.02388 1.22186C8.55196 1.03373 9.7736 0.778895 10.9549 1.3545C11.2812 1.51352 12.0248 1.87586 12.3376 2.70381C12.6019 3.4036 12.5521 4.41919 12.0059 4.80517C11.6089 5.08564 11.6749 5.02019 10.2183 4.85345V4.8537Z",
                stroke: "#242424",
                strokeWidth: "0.721689",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M10.172 4.83233C10.1874 4.67953 10.2267 4.28558 10.0615 3.96132C9.76785 3.38472 9.2649 3.23391 9.04939 3.18165C8.05296 2.93926 7.09212 3.57485 6.95898 3.67937",
                stroke: "#242424",
                strokeWidth: "0.721689",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M11.2046 4.92846C11.2653 4.74729 11.4114 4.35534 11.3816 3.97906C11.3629 3.74265 11.2698 3.23423 10.8423 2.8271C10.3147 2.3249 9.59874 2.40653 9.49023 2.42071",
                stroke: "#242424",
                strokeWidth: "0.721689",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M12.5628 3.31787C12.7711 3.32783 13.2885 3.30767 13.7768 3.64412C13.9395 3.75636 14.5007 4.17295 14.598 4.83168C14.6629 5.27141 14.6288 5.53794 14.4098 6.69114C14.1682 7.9643 14.0684 8.7706 14.0338 8.60461C14.0099 8.48964 14.1023 7.55468 13.6147 6.5473C13.233 5.75842 12.5608 5.22786 12.3284 5.07954C12.1711 4.979 12.0308 4.90832 11.9277 4.86079",
                stroke: "#242424",
                strokeWidth: "0.721689",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M12.4297 5.02674C12.6143 4.87916 12.9122 4.67634 13.3213 4.53325C13.726 4.39165 14.0816 4.36353 14.3168 4.36328",
                stroke: "#242424",
                strokeWidth: "0.721689",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M5.30844 6.30273C5.19645 6.60261 5.01802 7.24317 4.94336 7.77523C4.86945 8.30131 4.82864 8.76792 4.88115 9.41346C5.0001 10.8735 5.1646 11.6206 5.55729 12.7108C5.9368 13.7643 6.60051 14.3083 7.01784 14.6878C7.65094 15.2634 8.1606 15.6777 9.07018 15.8977C9.48254 15.9975 9.84487 15.895 9.98697 15.8616C10.1661 15.8193 10.8301 15.45 11.6916 14.7557C12.0946 14.4307 12.7605 13.8342 13.2331 12.7427C13.4819 12.1683 13.6464 11.638 13.84 10.4505C13.957 9.73275 14.0132 8.94586 14.0531 8.52952",
                stroke: "#242424",
                strokeWidth: "0.721689",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M14.0423 8.64393C14.0711 8.56504 14.2819 8.33211 14.4696 8.2796C14.7627 8.19748 14.9902 8.32166 15.1084 8.6275C15.4608 9.53907 15.2507 10.6428 14.6687 11.3654C14.3402 11.7733 13.8636 11.8758 13.6152 11.9378",
                stroke: "#242424",
                strokeWidth: "0.721689",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M14.6889 9.30078C14.5903 9.55163 14.0906 9.48195 14.0543 9.72185C14.0237 9.92392 14.4587 10.2216 14.382 10.4206",
                stroke: "#242424",
                strokeWidth: "0.323516",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M4.84297 8.59764C4.8141 8.51875 4.54334 8.33211 4.3557 8.2796C4.06255 8.19748 3.83509 8.32166 3.71689 8.6275C3.3645 9.53907 3.57454 10.6428 4.15662 11.3654C4.48511 11.7733 4.96167 11.8758 5.21003 11.9378",
                stroke: "#242424",
                strokeWidth: "0.721689",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M4.13281 9.30078C4.23136 9.55163 4.73107 9.48195 4.7674 9.72185C4.79801 9.92392 4.36301 10.2216 4.43965 10.4206",
                stroke: "#242424",
                strokeWidth: "0.323516",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M4.02384 7.70215C3.93674 7.83479 4.19108 8.1267 4.25205 8.22624",
                stroke: "#242424",
                strokeWidth: "0.248858",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M12.0173 14.4951C11.9931 14.9 11.9864 15.4798 12.0499 16.0139C12.0952 16.3954 12.1639 16.7398 12.2408 17.0424",
                stroke: "#242424",
                strokeWidth: "0.721689",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M6.77426 14.5605C6.7984 14.9654 6.80511 15.5453 6.74166 16.0793C6.69636 16.4608 6.62768 16.8052 6.55078 17.1079",
                stroke: "#242424",
                strokeWidth: "0.721689",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M12.7353 9.09684C12.6345 9.02542 12.2107 8.79771 11.7929 8.81165C11.2143 8.83106 10.8644 9.22998 10.8066 9.29792",
                stroke: "#666666",
                strokeWidth: "0.149315",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M12.0742 14.7358C12.2419 14.7764 12.5453 14.82 12.8138 15.0054C12.9778 15.1186 13.3621 15.3839 13.5106 15.8336C13.6871 16.3679 13.3611 16.6483 13.5659 17.0425C13.7142 17.3279 14.0136 17.428 14.2985 17.5355C14.802 17.7251 17.3408 19.651 17.457 20.9615",
                stroke: "#242424",
                strokeWidth: "0.721689",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M6.79392 14.7358C6.62619 14.7764 6.32283 14.82 6.05431 15.0054C5.89031 15.1186 5.50607 15.3839 5.35751 15.8336C5.18107 16.3679 5.50707 16.6483 5.30226 17.0425C5.15394 17.3279 4.85456 17.428 4.56962 17.5355C4.06618 17.7251 1 19.7175 1 20.9615",
                stroke: "#242424",
                strokeWidth: "0.721689",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M12.0458 15.3672C12.4751 15.686 12.6314 15.9309 12.6237 16.0971C12.6155 16.2765 12.505 16.3509 12.4826 16.6749C12.4701 16.8569 12.4975 16.9412 12.4328 17.042C12.3422 17.1829 12.1762 17.1931 12.0762 17.2334C11.6728 17.3969 11.6705 18.3284 11.6531 18.8925C11.6379 19.3887 11.5956 20.1035 11.4707 20.9996",
                stroke: "#242424",
                strokeWidth: "0.721689",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M13.7594 17.4082C13.7241 17.5729 13.6594 17.8143 13.5355 18.0883C13.4068 18.3725 13.2351 18.752 12.8469 19.0589C12.7048 19.1711 12.4263 19.3585 12 19.4488",
                stroke: "#242424",
                strokeWidth: "0.721689",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M11.7444 18.9844C11.8629 19.0752 11.9978 19.2223 11.996 19.3258C11.9856 19.9743 11.6496 20.9613 11.4707 21.0001",
                stroke: "#242424",
                strokeWidth: "0.721689",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M13.1523 18.8843C13.4868 19.2907 14.089 20.48 14.2687 20.9608",
                stroke: "#242424",
                strokeWidth: "0.721689",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M6.70522 15.2881C6.27594 15.6069 6.04325 15.8933 6.05097 16.0595C6.05918 16.239 6.16967 16.3134 6.19207 16.6374C6.20451 16.8193 6.17714 16.9037 6.24184 17.0045C6.33243 17.1453 6.49841 17.1555 6.59846 17.1958C7.00185 17.3593 7.00409 18.2908 7.02151 18.855C7.03669 19.3512 7.079 20.0659 7.20393 20.9621",
                stroke: "#242424",
                strokeWidth: "0.721689",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M6.01367 9.06657C6.11446 8.99514 6.53826 8.76744 6.9561 8.78137C7.53469 8.80079 7.88459 9.1997 7.94207 9.26764",
                stroke: "#666666",
                strokeWidth: "0.149315",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M4.92188 17.418C4.95721 17.5827 5.01097 17.7751 5.1349 18.0493C5.26356 18.3335 5.43527 18.713 5.82349 19.0199C5.96559 19.1321 6.24406 19.3195 6.67035 19.4098",
                stroke: "#242424",
                strokeWidth: "0.721689",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M6.93192 18.9448C6.81346 19.0357 6.68256 19.1827 6.68032 19.2863C6.66638 19.934 6.88413 20.8608 7.20566 20.9991",
                stroke: "#242424",
                strokeWidth: "0.721689",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M5.51875 18.8452C5.18428 19.2516 4.50639 20.5295 4.28516 20.9993",
                stroke: "#242424",
                strokeWidth: "0.721689",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M11.6095 18.7197C11.3614 18.8658 10.9142 19.1007 10.422 19.1968C9.61467 19.3543 9.27448 19.3752 8.62322 19.2508C7.97196 19.1264 7.41874 18.8063 7.04297 18.5913",
                stroke: "#242424",
                strokeWidth: "0.721689",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M10.6074 9.42385C10.6679 9.26707 10.7968 9.00851 11.0636 8.81838C11.5419 8.4772 12.1586 8.48939 12.6232 8.82933C12.8123 8.96769 12.9201 9.20212 12.9385 9.35741",
                stroke: "#242424",
                strokeWidth: "0.348401",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M13.2745 8.74316C13.225 8.9858 13.0356 9.23541 12.9473 9.36531",
                stroke: "#242424",
                strokeWidth: "0.348401",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M12.8555 8.97199C12.9488 8.95805 13.1148 8.82218 13.2599 8.74951",
                stroke: "#242424",
                strokeWidth: "0.348401",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M8.15918 9.39993C8.09871 9.24315 7.9698 8.98458 7.70302 8.79445C7.22472 8.45327 6.60805 8.46546 6.14343 8.8054C5.9543 8.94377 5.84654 9.17819 5.82812 9.33348",
                stroke: "#242424",
                strokeWidth: "0.348401",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M5.48828 8.71875C5.5378 8.96139 5.72719 9.21099 5.81553 9.3409",
                stroke: "#242424",
                strokeWidth: "0.348401",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M5.91221 8.94695C5.81889 8.93302 5.6529 8.79167 5.50781 8.71875",
                stroke: "#242424",
                strokeWidth: "0.348401",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M7.14536 9.9504C7.46835 9.9504 7.73018 9.68856 7.73018 9.36558C7.73018 9.04259 7.46835 8.78076 7.14536 8.78076C6.82238 8.78076 6.56055 9.04259 6.56055 9.36558C6.56055 9.68856 6.82238 9.9504 7.14536 9.9504Z",
                fill: "#242424",
                stroke: "#242424",
                strokeWidth: "0.348401",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M11.7079 9.91768C12.0308 9.91768 12.2927 9.65585 12.2927 9.33286C12.2927 9.00988 12.0308 8.74805 11.7079 8.74805C11.3849 8.74805 11.123 9.00988 11.123 9.33286C11.123 9.65585 11.3849 9.91768 11.7079 9.91768Z",
                fill: "#242424",
                stroke: "#242424",
                strokeWidth: "0.348401",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M11.6295 9.91715C11.838 9.91715 12.007 9.74812 12.007 9.53963C12.007 9.33113 11.838 9.16211 11.6295 9.16211C11.421 9.16211 11.252 9.33113 11.252 9.53963C11.252 9.74812 11.421 9.91715 11.6295 9.91715Z",
                stroke: "#47008B",
                strokeWidth: "0.248858",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M7.20369 9.91715C7.41219 9.91715 7.58121 9.74812 7.58121 9.53963C7.58121 9.33113 7.41219 9.16211 7.20369 9.16211C6.99519 9.16211 6.82617 9.33113 6.82617 9.53963C6.82617 9.74812 6.99519 9.91715 7.20369 9.91715Z",
                stroke: "#47008B",
                strokeWidth: "0.248858",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M6.76325 9.23143C6.79455 9.20012 6.78637 9.14118 6.74497 9.09978C6.70357 9.05838 6.64463 9.0502 6.61332 9.0815C6.58202 9.11281 6.5902 9.17175 6.6316 9.21315C6.673 9.25455 6.73194 9.26273 6.76325 9.23143Z",
                fill: "white",
                stroke: "white",
                strokeWidth: "0.273744",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M12.1474 9.21377C12.1888 9.17237 12.197 9.11342 12.1656 9.08209C12.1343 9.05076 12.0753 9.05893 12.0339 9.10033C11.9925 9.14173 11.9844 9.20069 12.0157 9.23202C12.047 9.26334 12.106 9.25518 12.1474 9.21377Z",
                fill: "white",
                stroke: "white",
                strokeWidth: "0.273744",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M10.4551 8.01607C10.5589 7.88616 10.8948 7.43473 11.8156 7.24809C12.1406 7.18214 12.494 7.19682 12.8775 7.47131C13.0497 7.59475 13.2047 7.79682 13.2605 7.90682",
                stroke: "#242424",
                strokeWidth: "0.273744",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M10.4551 8.01675C10.8279 7.88262 11.0108 7.80796 11.4174 7.72509C11.9642 7.6136 12.1866 7.61957 12.3506 7.61634C12.6418 7.61061 13.1325 7.79975 13.2463 7.89655",
                stroke: "#242424",
                strokeWidth: "0.273744",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M10.9199 7.69911C11.5378 7.48758 12.0087 7.40048 12.6204 7.45847",
                stroke: "#242424",
                strokeWidth: "0.398173",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M8.36202 8.10005C8.25824 7.97014 7.92229 7.51872 7.00151 7.33207C6.6765 7.26613 6.32312 7.28081 5.93963 7.5553C5.76742 7.67873 5.61238 7.88081 5.55664 7.9908",
                stroke: "#242424",
                strokeWidth: "0.273744",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M8.35739 8.09971C7.9846 7.96558 7.80169 7.89092 7.39505 7.80805C6.84831 7.69656 6.62583 7.70204 6.46184 7.6993C6.17192 7.69457 5.6309 7.8964 5.56445 7.97927",
                stroke: "#242424",
                strokeWidth: "0.273744",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M7.89185 7.7831C7.27394 7.57157 6.8031 7.48447 6.19141 7.54245",
                stroke: "#242424",
                strokeWidth: "0.398173",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M8.79883 14.2064C8.8374 14.2462 8.93545 14.2748 9.0992 14.3012C9.34209 14.3403 9.64495 14.335 9.87614 14.2845C10.0031 14.2566 10.0899 14.2255 10.1198 14.1899",
                stroke: "#242424",
                strokeWidth: "0.174201",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M7.69195 9.48236C7.71977 9.48147 7.74169 9.46061 7.74089 9.43578C7.74009 9.41094 7.71689 9.39153 7.68906 9.39243C7.66123 9.39332 7.63932 9.41418 7.64012 9.43901C7.64091 9.46385 7.66412 9.48325 7.69195 9.48236Z",
                fill: "white",
                stroke: "white",
                strokeWidth: "0.174201",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx55("path", {
                d: "M11.1431 9.44183C11.1709 9.44094 11.1929 9.42008 11.1921 9.39525C11.1913 9.37041 11.1681 9.35101 11.1402 9.3519C11.1124 9.35279 11.0905 9.37365 11.0913 9.39848C11.0921 9.42332 11.1153 9.44273 11.1431 9.44183Z",
                fill: "white",
                stroke: "white",
                strokeWidth: "0.174201",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};
var ThumbUpSolid = function(props) {
    return /* @__PURE__ */ jsx55("svg", _object_spread_props(_object_spread({
        width: "21",
        height: "21",
        viewBox: "0 0 21 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /* @__PURE__ */ jsx55("path", {
            d: "M11.6219 1.87015C10.8518 1.65611 10.2505 2.23019 10.0359 2.76463C9.78876 3.37999 9.57156 3.8119 9.31193 4.32815C9.15131 4.64754 8.97446 4.99921 8.76424 5.44657C8.27763 6.48213 7.7914 7.14624 7.43836 7.54444C7.26165 7.74376 7.11764 7.87721 7.02265 7.95776C6.97513 7.99805 6.9398 8.02517 6.91869 8.04072L6.90212 8.05266L4.98137 9.18584C4.12297 9.69226 3.75252 10.7422 4.10307 11.6752L4.63663 13.0953C4.85869 13.6862 5.34041 14.1421 5.94273 14.3313L11.4384 16.0576C12.808 16.4878 14.264 15.7103 14.6685 14.3329L16.0683 9.56558C16.4542 8.25138 15.4689 6.9352 14.0992 6.9352H12.6781C12.7457 6.70265 12.815 6.44396 12.8779 6.17559C13.0128 5.59984 13.1274 4.94152 13.1168 4.3928C13.107 3.88268 13.0556 3.34739 12.846 2.89263C12.6211 2.40473 12.2276 2.03849 11.6219 1.87015ZM6.89791 8.05559L6.89598 8.0569Z",
            fill: "#00BBCC"
        })
    }));
};
var ThumbUpRegular = function(props) {
    return /* @__PURE__ */ jsx55("svg", _object_spread_props(_object_spread({
        width: "21",
        height: "21",
        viewBox: "0 0 21 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /* @__PURE__ */ jsx55("path", {
            d: "M10.0359 2.76463C10.2505 2.23019 10.8518 1.65611 11.6219 1.87015C12.2276 2.03849 12.6211 2.40473 12.846 2.89263C13.0556 3.34739 13.107 3.88268 13.1168 4.3928C13.1274 4.94152 13.0128 5.59984 12.8779 6.17559C12.815 6.44396 12.7457 6.70265 12.6781 6.9352H14.0992C15.4689 6.9352 16.4542 8.25138 16.0683 9.56558L14.6685 14.3329C14.264 15.7103 12.808 16.4878 11.4384 16.0576L5.94273 14.3313C5.34041 14.1421 4.85869 13.6862 4.63663 13.0953L4.10307 11.6752C3.75252 10.7422 4.12297 9.69226 4.98137 9.18584L6.90212 8.05266C6.90594 8.04998 6.91149 8.04602 6.91869 8.04072C6.9398 8.02517 6.97513 7.99805 7.02265 7.95776C7.11764 7.87721 7.26165 7.74376 7.43836 7.54444C7.7914 7.14624 8.27763 6.48213 8.76424 5.44657C8.97446 4.9992 9.15131 4.64754 9.31193 4.32815C9.57156 3.8119 9.78876 3.37999 10.0359 2.76463ZM7.45474 8.91751C7.44892 8.92126 7.44303 8.92491 7.43707 8.92842L5.50276 10.0696C5.07356 10.3228 4.88833 10.8478 5.06361 11.3143L5.59717 12.7343C5.7082 13.0298 5.94906 13.2578 6.25022 13.3524L11.7459 15.0786C12.5677 15.3367 13.4413 14.8703 13.6839 14.0438L15.0838 9.27649C15.2767 8.61939 14.7841 7.9613 14.0992 7.9613H11.9762C11.8095 7.9613 11.6533 7.88038 11.5572 7.74429C11.461 7.60821 11.4369 7.43391 11.4926 7.27685C11.5952 6.98741 11.7513 6.48595 11.8789 5.94152C12.0082 5.38933 12.099 4.83096 12.0909 4.41253C12.0817 3.932 12.0308 3.57528 11.9141 3.32215C11.8127 3.10216 11.656 2.94462 11.3471 2.85878C11.3029 2.84649 11.2513 2.85007 11.1837 2.8945C11.1097 2.94303 11.0341 3.03229 10.9881 3.14702C10.7278 3.79524 10.4787 4.29172 10.2031 4.84124C10.0443 5.15782 9.87663 5.49201 9.69292 5.88296C9.16562 7.00512 8.62574 7.75189 8.20616 8.22516C7.99656 8.46157 7.81763 8.62899 7.68626 8.74038C7.6206 8.79606 7.56689 8.83768 7.52726 8.86687C7.50744 8.88147 7.49115 8.89295 7.47866 8.90153L7.46279 8.91225L7.45705 8.91602L7.45474 8.91751ZM6.89722 8.05609L6.89598 8.0569L6.89722 8.05609Z",
            fill: "#242424"
        })
    }));
};
var ThumbDownSolid = function(props) {
    return /* @__PURE__ */ jsx55("svg", _object_spread_props(_object_spread({
        width: "21",
        height: "21",
        viewBox: "0 0 21 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /* @__PURE__ */ jsx55("path", {
            d: "M15.227 5.53131C14.8391 3.46276 12.7637 2.16953 10.7359 2.73281L5.65665 4.14373C4.90236 4.35325 4.33297 4.97366 4.1888 5.74312L3.95898 6.96971C3.78991 7.87206 4.43173 8.66036 5.14649 8.95676C5.40806 9.06522 5.70714 9.21632 6.02209 9.42628C7.74485 10.5748 8.56721 12.1317 9.11614 13.4543C9.21488 13.6922 9.30957 13.9359 9.40098 14.1711C9.55099 14.5572 9.69218 14.9206 9.82797 15.1984C9.94196 15.4316 10.0789 15.6656 10.2581 15.8455C10.4492 16.0372 10.7048 16.1819 11.0263 16.1819C11.3928 16.1819 11.7093 16.0555 11.9616 15.8337C12.2034 15.6211 12.3654 15.34 12.4767 15.0526C12.6968 14.4845 12.7656 13.769 12.7739 13.11C12.7823 12.4396 12.7279 11.7753 12.6725 11.2826C12.6633 11.2008 12.654 11.1235 12.645 11.0514H13.171C14.7773 11.0514 15.9884 9.59209 15.6924 8.0134L15.227 5.53131Z",
            fill: "#00BBCC"
        })
    }));
};
var ThumbDownRegular = function(props) {
    return /* @__PURE__ */ jsx55("svg", _object_spread_props(_object_spread({
        width: "21",
        height: "21",
        viewBox: "0 0 21 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /* @__PURE__ */ jsx55("path", {
            d: "M12.645 11.0514C12.6622 11.1883 12.6801 11.3441 12.697 11.5137C12.7725 12.2722 12.8313 13.3532 12.6829 14.2609C12.6092 14.7115 12.4768 15.1708 12.2295 15.5294C11.9662 15.9112 11.5659 16.1819 11.0263 16.1819C10.4963 16.1819 10.1736 15.8025 9.97561 15.4727C9.77827 15.1439 9.6053 14.6976 9.42823 14.2408L9.41477 14.206C8.85378 12.759 8.08661 10.8026 6.02208 9.42628C5.70714 9.21632 5.40806 9.06522 5.14649 8.95676C4.43173 8.66036 3.78991 7.87206 3.95898 6.96971L4.1888 5.74312C4.33297 4.97366 4.90236 4.35325 5.65665 4.14373L10.7359 2.73281C12.7637 2.16953 14.8391 3.46276 15.227 5.53131L15.6924 8.0134C15.9884 9.59209 14.7773 11.0514 13.171 11.0514H12.645ZM14.2184 5.72041C13.9414 4.24287 12.459 3.31914 11.0106 3.72148L5.93128 5.13239C5.55413 5.23716 5.26944 5.54736 5.19735 5.93209L4.96753 7.15868C4.91302 7.44961 5.13286 7.84028 5.53954 8.00892C5.8569 8.14052 6.21579 8.3222 6.59126 8.57252C8.93785 10.1369 9.8015 12.3648 10.3632 13.8137L10.3715 13.8351C10.566 14.3368 10.7088 14.7003 10.8554 14.9447C10.9264 15.0629 10.9794 15.1198 11.011 15.1446C11.0193 15.1512 11.0248 15.1544 11.0274 15.1558C11.173 15.1555 11.279 15.1002 11.3848 14.9468C11.5069 14.7698 11.6067 14.4837 11.6702 14.0953C11.7962 13.3251 11.7494 12.3539 11.6759 11.6152C11.6468 11.3224 11.6143 11.0734 11.5891 10.8982C11.5765 10.8106 11.5658 10.7417 11.5584 10.6952L11.5498 10.6427L11.5476 10.63L11.5471 10.6272C11.521 10.4779 11.5622 10.3243 11.6596 10.2083C11.7125 10.1454 11.7789 10.097 11.8528 10.0657C11.9153 10.0394 11.983 10.0253 12.0524 10.0253H13.171C14.1348 10.0253 14.8614 9.14972 14.6838 8.2025L14.2184 5.72041Z",
            fill: "#242424"
        })
    }));
};
// src/components/AIThinkingCycle/AIThinkingCycle.tsx
import { useEffect as useEffect12, useState as useState18 } from "react";
import styled36, { keyframes } from "styled-components";
import { jsx as jsx56, jsxs as jsxs33 } from "react/jsx-runtime";
var PROMPT_WORDS = [
    "thinking",
    "considering",
    "researching",
    "reflecting",
    "pondering",
    "querying",
    "analysing",
    "planning",
    "reviewing",
    "mulling over",
    "more querying",
    "comparing",
    "studying",
    "evaluating",
    "inspecting",
    "exploring",
    "searching",
    "preparing",
    "charting",
    "revising",
    "questioning"
];
var FADE_MS_MIN = 400;
var FADE_MS_MAX = 600;
var CYCLE_MS_MIN = 1e3;
var CYCLE_MS_MAX = 4500;
var longestWord = PROMPT_WORDS.reduce(function(a, b) {
    return b.length > a.length ? b : a;
}, "");
function jitter(min, max) {
    return Math.round(min + Math.random() * (max - min));
}
var fadeIn = keyframes(_templateObject38());
var fadeOut = keyframes(_templateObject39());
var AIThinkingCycle = function(param) {
    var className = param.className;
    var _useState18 = _sliced_to_array(useState18(function() {
        return [
            {
                id: 0,
                word: PROMPT_WORDS[0],
                fadeMs: jitter(FADE_MS_MIN, FADE_MS_MAX),
                exiting: false
            }
        ];
    }), 2), entries = _useState18[0], setEntries = _useState18[1];
    useEffect12(function() {
        var cancelled = false;
        var nextId = 1;
        var wordIdx = 0;
        var timeouts = [];
        var tick = function() {
            if (cancelled) return;
            wordIdx = (wordIdx + 1) % PROMPT_WORDS.length;
            var id = nextId++;
            var fadeMs = jitter(FADE_MS_MIN, FADE_MS_MAX);
            var cycleMs = jitter(CYCLE_MS_MIN, CYCLE_MS_MAX);
            setEntries(function(prev) {
                return _to_consumable_array(prev.map(function(e) {
                    return _object_spread_props(_object_spread({}, e), {
                        exiting: true
                    });
                })).concat([
                    {
                        id: id,
                        word: PROMPT_WORDS[wordIdx],
                        fadeMs: fadeMs,
                        exiting: false
                    }
                ]);
            });
            var cleanup = setTimeout(function() {
                if (cancelled) return;
                setEntries(function(prev) {
                    return prev.filter(function(e) {
                        return e.id === id;
                    });
                });
            }, fadeMs + 60);
            timeouts.push(cleanup);
            var next = setTimeout(tick, cycleMs);
            timeouts.push(next);
        };
        var start = setTimeout(tick, jitter(CYCLE_MS_MIN, CYCLE_MS_MAX));
        timeouts.push(start);
        return function() {
            cancelled = true;
            timeouts.forEach(clearTimeout);
        };
    }, []);
    return /* @__PURE__ */ jsxs33("span", {
        className: className,
        children: [
            /* @__PURE__ */ jsx56("span", {
                className: "spacer",
                "aria-hidden": "true",
                children: "".concat(longestWord, "...")
            }),
            entries.map(function(e) {
                return /* @__PURE__ */ jsx56("span", {
                    className: "word ".concat(e.exiting ? "exiting" : "entering"),
                    style: {
                        animationDuration: "".concat(e.fadeMs, "ms")
                    },
                    children: "".concat(e.word, "...")
                }, e.id);
            })
        ]
    });
};
var AIThinkingCycle_default = styled36(AIThinkingCycle)(_templateObject40(), fadeIn, fadeOut);
// src/components/AIConversation/AIConversation.tsx
import { jsx as jsx57, jsxs as jsxs34 } from "react/jsx-runtime";
var EMPTY_ENTITIES2 = [];
var AIConversation = function(param) {
    var className = param.className, conversation = param.conversation, awaitingMessage = param.awaitingMessage, addMessage = param.addMessage, addFeedback = param.addFeedback, clearMessages = param.clearMessages, _param_typingSpeed = param.typingSpeed, typingSpeed = _param_typingSpeed === void 0 ? 50 : _param_typingSpeed;
    var _useState19 = _sliced_to_array(useState19(false), 2), loading = _useState19[0], setLoading = _useState19[1];
    var user = useAuth02().user;
    var copilotConversationRef = useRef9(null);
    var dummyRef = useRef9(null);
    var _useState191 = _sliced_to_array(useState19([]), 2), messages = _useState191[0], setMessages = _useState191[1];
    useEffect13(function() {
        setMessages(conversation);
    }, [
        conversation
    ]);
    useEffect13(function() {
        setLoading(awaitingMessage);
    }, [
        awaitingMessage
    ]);
    var scrollToBottom = function() {
        var _dummyRef_current;
        (_dummyRef_current = dummyRef.current) === null || _dummyRef_current === void 0 ? void 0 : _dummyRef_current.scrollIntoView({
            behavior: "smooth",
            block: "end"
        });
    };
    useEffect13(function() {
        scrollToBottom();
        var container = copilotConversationRef.current;
        if (!container) return;
        var cleanups = [];
        container.querySelectorAll(".response img").forEach(function(img) {
            if (img.complete) return;
            var handler = function() {
                return scrollToBottom();
            };
            img.addEventListener("load", handler, {
                once: true
            });
            img.addEventListener("error", handler, {
                once: true
            });
            cleanups.push(function() {
                img.removeEventListener("load", handler);
                img.removeEventListener("error", handler);
            });
        });
        return function() {
            return cleanups.forEach(function(fn) {
                return fn();
            });
        };
    }, [
        loading,
        messages
    ]);
    var handleFeedback = function(index, feedback) {
        if (!messages) return;
        var newMessages = _to_consumable_array(messages);
        newMessages[index] = _object_spread_props(_object_spread({}, newMessages[index]), {
            feedback: feedback
        });
        setMessages(newMessages);
        addFeedback(index, feedback);
    };
    return /* @__PURE__ */ jsx57("div", {
        className: className,
        children: messages && messages.length > 0 && /* @__PURE__ */ jsxs34("div", {
            className: "conversation",
            ref: copilotConversationRef,
            children: [
                messages.map(function(msg, i) {
                    var _msg_prompts;
                    var _user_picture, _msg_entities;
                    return /* @__PURE__ */ jsxs34("div", {
                        className: "message ".concat(msg.content ? "" : "no-message"),
                        children: [
                            !msg.response && /* @__PURE__ */ jsx57("div", {
                                className: "avatar",
                                children: /* @__PURE__ */ jsx57(Avatar2, {
                                    size: 20,
                                    image: {
                                        src: (_user_picture = user === null || user === void 0 ? void 0 : user.picture) !== null && _user_picture !== void 0 ? _user_picture : void 0
                                    },
                                    name: user === null || user === void 0 ? void 0 : user.name,
                                    "aria-label": user === null || user === void 0 ? void 0 : user.name
                                })
                            }),
                            msg.content && /* @__PURE__ */ jsxs34("div", {
                                className: "chat-bubble ".concat(msg.response === false ? "" : "align-right", " ").concat(msg.error ? "error" : ""),
                                children: [
                                    msg.response ? /* @__PURE__ */ jsx57(AITypingMessage_default, {
                                        fullMessage: formatCopilotMessage(msg.content),
                                        entities: (_msg_entities = msg.entities) !== null && _msg_entities !== void 0 ? _msg_entities : EMPTY_ENTITIES2,
                                        speed: typingSpeed,
                                        children: msg.chart
                                    }) : // User-authored messages render here — `entities` is
                                    // only ever populated on assistant responses (response:
                                    // true), which always route through AITypingMessage
                                    // above. If that invariant ever changes, this branch
                                    // will need the same entity-marking transform.
                                    /* @__PURE__ */ jsx57("div", {
                                        className: "response",
                                        dangerouslySetInnerHTML: {
                                            __html: formatCopilotMessage(msg.content)
                                        }
                                    }),
                                    msg.prompts && ((_msg_prompts = msg.prompts) === null || _msg_prompts === void 0 ? void 0 : _msg_prompts.length) > 0 && msg.prompts.map(function(p, i2) {
                                        return /* @__PURE__ */ jsx57("div", {
                                            className: "prompt",
                                            children: /* @__PURE__ */ jsx57("button", {
                                                onClick: function() {
                                                    setLoading(true);
                                                    addMessage({
                                                        content: p.title,
                                                        response: false,
                                                        prompts: [],
                                                        triggerPrompt: true
                                                    });
                                                },
                                                className: "chat-bubble",
                                                dangerouslySetInnerHTML: {
                                                    __html: p.title
                                                }
                                            })
                                        }, i2);
                                    }),
                                    msg.response && /* @__PURE__ */ jsxs34("div", {
                                        className: "feedback",
                                        children: [
                                            /* @__PURE__ */ jsx57("button", {
                                                onClick: function() {
                                                    var newFeedback = msg.feedback === Feedback.POSITIVE ? Feedback.NONE : Feedback.POSITIVE;
                                                    handleFeedback(i, newFeedback);
                                                },
                                                children: /* @__PURE__ */ jsx57("span", {
                                                    className: "icon",
                                                    children: msg.feedback === Feedback.POSITIVE ? /* @__PURE__ */ jsx57(ThumbUpSolid, {}) : /* @__PURE__ */ jsx57(ThumbUpRegular, {})
                                                })
                                            }),
                                            /* @__PURE__ */ jsx57("button", {
                                                onClick: function() {
                                                    var newFeedback = msg.feedback === Feedback.NEGATIVE ? Feedback.NONE : Feedback.NEGATIVE;
                                                    handleFeedback(i, newFeedback);
                                                },
                                                children: /* @__PURE__ */ jsx57("span", {
                                                    className: "icon",
                                                    children: msg.feedback === Feedback.NEGATIVE ? /* @__PURE__ */ jsx57(ThumbDownSolid, {}) : /* @__PURE__ */ jsx57(ThumbDownRegular, {})
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            msg.response && /* @__PURE__ */ jsx57("div", {
                                className: "maria avatar",
                                children: /* @__PURE__ */ jsx57(MariaIcon, {})
                            })
                        ]
                    }, i);
                }),
                loading && /* @__PURE__ */ jsxs34("div", {
                    className: "message",
                    children: [
                        /* @__PURE__ */ jsx57("div", {
                            className: "chat-bubble align-right",
                            children: /* @__PURE__ */ jsx57(AIThinkingCycle_default, {})
                        }),
                        /* @__PURE__ */ jsx57("div", {
                            className: "maria avatar",
                            children: /* @__PURE__ */ jsx57(MariaIcon, {})
                        })
                    ]
                }),
                /* @__PURE__ */ jsx57("div", {
                    ref: dummyRef
                })
            ]
        })
    });
};
var AIConversation_default = styled37(AIConversation)(_templateObject41());
// src/components/DayStepper/DayStepper.tsx
import { useEffect as useEffect14, useState as useState20 } from "react";
import styled38 from "styled-components";
import { DateTime } from "luxon";
import { useTimelineCalendarSyncStore } from "@repo/front-end-state";
import { getOrdinalSuffix } from "@repo/front-end-utils";
import { ChevronLeft16Filled as ChevronLeft16Filled3, ChevronRight16Filled as ChevronRight16Filled3 } from "@fluentui/react-icons";
import { Fragment as Fragment13, jsx as jsx58, jsxs as jsxs35 } from "react/jsx-runtime";
var Row = styled38.div(_templateObject42());
var StepButton = styled38.button(_templateObject43());
var DayLabel = styled38.p(_templateObject44());
var DayStepper = function(param) {
    var className = param.className, currentDateTimeISO = param.currentDateTimeISO, setTimelineDate = param.setTimelineDate;
    var calendarDateTimeRange = useTimelineCalendarSyncStore().calendarDateTimeRange;
    var _useState20 = _sliced_to_array(useState20(currentDateTimeISO), 2), currentDate = _useState20[0], setCurrentDate = _useState20[1];
    useEffect14(function() {
        if (calendarDateTimeRange) {
            setCurrentDate(calendarDateTimeRange.startDateTime);
        }
    }, [
        calendarDateTimeRange
    ]);
    var goBackOneDay = function() {
        var prevDate = DateTime.fromISO(currentDateTimeISO);
        prevDate = prevDate.minus({
            days: 1
        });
        var startDate;
        if (calendarDateTimeRange) {
            startDate = DateTime.fromISO(calendarDateTimeRange.startDateTime);
        }
        if (!startDate || prevDate >= startDate) {
            var selectedDate = prevDate.toISO({
                includeOffset: true
            });
            if (selectedDate !== null) {
                setCurrentDate(selectedDate);
            } else {
                throw new Error("DayStepper is unable to go back and set selectedDate");
            }
            if (selectedDate) {
                setStartFinishDateTime(selectedDate);
            }
        }
    };
    var goForwardOneDay = function() {
        var finalDate;
        if (calendarDateTimeRange === null || calendarDateTimeRange === void 0 ? void 0 : calendarDateTimeRange.finishDateTime) {
            finalDate = DateTime.fromISO(calendarDateTimeRange === null || calendarDateTimeRange === void 0 ? void 0 : calendarDateTimeRange.finishDateTime);
        }
        var nextDate = DateTime.fromISO(currentDateTimeISO);
        nextDate = nextDate.plus({
            days: 1
        });
        if (nextDate <= DateTime.now() && (!finalDate || nextDate <= finalDate)) {
            var selectedDate = nextDate.toISO({
                includeOffset: true
            });
            if (selectedDate !== null) {
                setCurrentDate(selectedDate);
            } else {
                throw new Error("DayStepper is unable to go forward and set selectedDate");
            }
            if (selectedDate) {
                setStartFinishDateTime(selectedDate);
            }
        }
    };
    var setStartFinishDateTime = function(currentDateTimeISO2) {
        var selectedDate = DateTime.fromISO(currentDateTimeISO2);
        var startDateTime = selectedDate.startOf("day");
        var finishDateTime = selectedDate.endOf("day");
        var startDateTimeISO = startDateTime.toISO({
            includeOffset: true
        });
        var finishDateTimeISO = finishDateTime.toISO({
            includeOffset: true
        });
        if (startDateTimeISO !== null && finishDateTimeISO !== null) {
            setTimelineDate({
                startDateTime: startDateTimeISO,
                finishDateTime: finishDateTimeISO
            });
        } else {
            throw new Error("Unable to setStartFinishDateTime within DayStepper");
        }
    };
    var formatDay = function(dateTimeISO) {
        var currentDay = DateTime.fromISO(dateTimeISO);
        return "".concat(currentDay.day).concat(getOrdinalSuffix(currentDay.day), " ").concat(currentDay.monthLong, " ").concat(currentDay.year);
    };
    return /* @__PURE__ */ jsx58(Fragment13, {
        children: currentDate ? /* @__PURE__ */ jsx58("div", {
            className: className,
            children: /* @__PURE__ */ jsxs35(Row, {
                children: [
                    /* @__PURE__ */ jsx58(StepButton, {
                        onClick: goBackOneDay,
                        children: /* @__PURE__ */ jsx58(ChevronLeft16Filled3, {})
                    }),
                    /* @__PURE__ */ jsx58(DayLabel, {
                        children: formatDay(currentDate)
                    }),
                    /* @__PURE__ */ jsx58(StepButton, {
                        onClick: goForwardOneDay,
                        children: /* @__PURE__ */ jsx58(ChevronRight16Filled3, {})
                    })
                ]
            })
        }) : null
    });
};
var DayStepper_default = DayStepper;
// src/components/TLSpinnerPage/TLSpinnerPage.tsx
import { useEffect as useEffect15, useState as useState21 } from "react";
import styled39 from "styled-components";
import loadingGif2 from "@repo/assets/loading.gif";
import { useSettingsStore } from "@repo/front-end-state";
import { loadingMessageData } from "@repo/front-end-data";
import { shuffleArray } from "@repo/front-end-utils";
import { jsx as jsx59, jsxs as jsxs36 } from "react/jsx-runtime";
var TLSpinnerPage = function(param) {
    var className = param.className, props = param.props, loadingMessages = param.loadingMessages;
    var settings = useSettingsStore().settings;
    var leftFieldMessages = [];
    if (settings && settings.leftFieldMessages) {
        leftFieldMessages = shuffleArray(settings.leftFieldMessages)[0];
    }
    var messages = loadingMessages ? loadingMessages : settings ? loadingMessageData.concat(leftFieldMessages) : loadingMessageData;
    var _useState21 = _sliced_to_array(useState21(messages[0]), 2), currentMessage = _useState21[0], setCurrentMessage = _useState21[1];
    var _useState211 = _sliced_to_array(useState21(0), 2), index = _useState211[0], setIndex = _useState211[1];
    useEffect15(function() {
        var intervalId;
        intervalId = setInterval(function() {
            setIndex(function(prevIndex) {
                var newIndex = prevIndex + 1;
                if (newIndex === messages.length) {
                    clearInterval(intervalId);
                    return prevIndex;
                }
                return newIndex;
            });
        }, 1250);
        return function() {
            return clearInterval(intervalId);
        };
    }, [
        messages.length
    ]);
    useEffect15(function() {
        setCurrentMessage(messages[index]);
    }, [
        index,
        messages
    ]);
    var gifSrc = typeof loadingGif2 === "string" ? loadingGif2 : loadingGif2.src;
    return /* @__PURE__ */ jsxs36("div", {
        className: className,
        children: [
            /* @__PURE__ */ jsx59("div", {
                className: "spinner-container",
                children: /* @__PURE__ */ jsx59(TLSpinner_default, _object_spread_props(_object_spread({}, props), {
                    custom: /* @__PURE__ */ jsx59("img", {
                        src: gifSrc,
                        width: 200,
                        height: 200,
                        alt: "Loading..."
                    })
                }))
            }),
            /* @__PURE__ */ jsx59("p", {
                className: "spinner-title",
                children: "Working, please wait..."
            }),
            /* @__PURE__ */ jsx59("p", {
                className: "spinner-message",
                children: currentMessage
            })
        ]
    });
};
var TLSpinnerPage_default = styled39(TLSpinnerPage)(_templateObject45());
// src/components/Permissioned/Permissioned.tsx
import { useUserStore as useUserStore2 } from "@repo/front-end-state";
var Permissioned = function(param) {
    var necessaryPermissions = param.necessaryPermissions, children = param.children;
    var authMetadata = useUserStore2().authMetadata;
    var hasAllPermissions = true;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = necessaryPermissions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var permission = _step.value;
            var _authMetadata_permissions;
            if (!(authMetadata === null || authMetadata === void 0 ? void 0 : (_authMetadata_permissions = authMetadata.permissions) === null || _authMetadata_permissions === void 0 ? void 0 : _authMetadata_permissions.has(permission))) {
                hasAllPermissions = false;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (hasAllPermissions) {
        return children;
    } else {
        return null;
    }
};
var Permissioned_default = Permissioned;
// src/components/Panel/Panel.tsx
import { Accordion as Accordion2, AccordionHeader, AccordionItem, AccordionPanel } from "@fluentui/react-components";
import { Fragment as Fragment14, jsx as jsx60, jsxs as jsxs37 } from "react/jsx-runtime";
var HEADER_ACTIONS_CHEVRON_CLEARANCE_PX = 36;
var Panel = function(param) {
    var className = param.className, id = param.id, _param_showId = param.showId, showId = _param_showId === void 0 ? false : _param_showId, size2 = param.size, icon = param.icon, title = param.title, defaultOpenItems = param.defaultOpenItems, children = param.children, _param_showHeader = param.showHeader, showHeader = _param_showHeader === void 0 ? true : _param_showHeader, headerActions = param.headerActions;
    var header = showHeader ? /* @__PURE__ */ jsx60(AccordionHeader, {
        icon: icon,
        size: size2 ? size2 : "small",
        expandIconPosition: "end",
        children: /* @__PURE__ */ jsx60("div", {
            style: {
                width: "100%"
            },
            children: /* @__PURE__ */ jsx60(LabelHeader_default, {
                id: id,
                fontSize: "14px",
                title: "".concat(title)
            })
        })
    }) : null;
    return /* @__PURE__ */ jsx60("div", {
        className: className,
        children: /* @__PURE__ */ jsx60(Accordion2, {
            multiple: false,
            collapsible: true,
            defaultOpenItems: defaultOpenItems,
            children: /* @__PURE__ */ jsx60(AccordionItem, {
                value: id,
                children: /* @__PURE__ */ jsx60(TLCard_default, {
                    className: "accordion-item",
                    children: /* @__PURE__ */ jsxs37(Fragment14, {
                        children: [
                            header && headerActions ? // position:relative wrapper sized to the header; the actions span its full height so
                            // they vertically centre on the header regardless of its height. stopPropagation keeps
                            // interacting with the actions from toggling the accordion.
                            /* @__PURE__ */ jsxs37("div", {
                                className: "panel-header",
                                style: {
                                    position: "relative"
                                },
                                children: [
                                    header,
                                    /* @__PURE__ */ jsx60("div", {
                                        className: "panel-header-actions",
                                        onClick: function(e) {
                                            return e.stopPropagation();
                                        },
                                        style: {
                                            position: "absolute",
                                            top: 0,
                                            bottom: 0,
                                            insetInlineEnd: HEADER_ACTIONS_CHEVRON_CLEARANCE_PX,
                                            display: "flex",
                                            alignItems: "center",
                                            zIndex: 2
                                        },
                                        children: headerActions
                                    })
                                ]
                            }) : header,
                            /* @__PURE__ */ jsx60(AccordionPanel, {
                                children: children
                            })
                        ]
                    })
                })
            })
        })
    });
};
var Panel_default = Panel;
// src/components/NotificationPanel/NotificationPanel.tsx
import styled40 from "styled-components";
import { jsx as jsx61, jsxs as jsxs38 } from "react/jsx-runtime";
var NotificationPanel = function(param) {
    var className = param.className, imgSrc = param.imgSrc, imgAlt = param.imgAlt, icon = param.icon, header = param.header, copy = param.copy, primaryButton = param.primaryButton, backRoute = param.backRoute, onBack = param.onBack, _param_buttonTopMargin = param.buttonTopMargin, buttonTopMargin = _param_buttonTopMargin === void 0 ? "10rem" : _param_buttonTopMargin;
    return /* @__PURE__ */ jsxs38("div", {
        className: className,
        children: [
            /* @__PURE__ */ jsxs38("div", {
                className: "image-icon",
                children: [
                    /* @__PURE__ */ jsx61("img", {
                        src: imgSrc,
                        alt: imgAlt
                    }),
                    /* @__PURE__ */ jsx61("span", {
                        className: "icon",
                        children: icon
                    })
                ]
            }),
            header && /* @__PURE__ */ jsx61("h1", {
                dangerouslySetInnerHTML: {
                    __html: header
                }
            }),
            copy && /* @__PURE__ */ jsx61("div", {
                className: "copy",
                dangerouslySetInnerHTML: {
                    __html: copy
                }
            }),
            /* @__PURE__ */ jsxs38("div", {
                style: {
                    marginTop: buttonTopMargin
                },
                children: [
                    primaryButton,
                    !primaryButton && backRoute ? /* @__PURE__ */ jsx61("a", {
                        href: backRoute,
                        children: /* @__PURE__ */ jsx61(PrimaryButton_default, {
                            children: "Continue"
                        })
                    }) : null,
                    primaryButton && onBack ? /* @__PURE__ */ jsx61("button", {
                        className: "secondary-button",
                        onClick: onBack,
                        children: "Back"
                    }) : primaryButton && backRoute ? /* @__PURE__ */ jsx61("a", {
                        href: backRoute,
                        children: /* @__PURE__ */ jsx61("button", {
                            className: "secondary-button",
                            children: "Back"
                        })
                    }) : null
                ]
            })
        ]
    });
};
var NotificationPanel_default = styled40(NotificationPanel)(_templateObject46());
// src/components/NotificationsTable/NotificationsTable.tsx
import styled43 from "styled-components";
import { formatDateToDateTimeString, getNotificationTypeColors } from "@repo/front-end-utils";
// src/components/DataTable/DataTable.tsx
import React23 from "react";
import styled41, { css } from "styled-components";
import { jsx as jsx62, jsxs as jsxs39 } from "react/jsx-runtime";
var Table2 = styled41.table(_templateObject47());
var Thead = styled41.thead(_templateObject48());
var SortableHeader = styled41.th(_templateObject49());
var Tbody = styled41.tbody(_templateObject50());
var Row2 = styled41.tr(_templateObject52(), function(param) {
    var $clickable = param.$clickable;
    return $clickable && css(_templateObject51());
});
var StateRow = styled41.tr(_templateObject53());
var ErrorText = styled41.span(_templateObject54());
var Checkbox = styled41.input.attrs({
    type: "checkbox"
})(_templateObject55());
var ExpanderButton = styled41.button(_templateObject56(), function(param) {
    var $expanded = param.$expanded;
    return $expanded ? "90deg" : "0deg";
});
var DetailRow = styled41.tr(_templateObject57());
var srOnly = {
    position: "absolute",
    width: "1px",
    height: "1px",
    padding: 0,
    margin: "-1px",
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    border: 0
};
var ExpanderHeaderCell = function() {
    return /* @__PURE__ */ jsx62("th", {
        style: {
            width: "2.5rem"
        },
        scope: "col",
        children: /* @__PURE__ */ jsx62("span", {
            style: srOnly,
            children: "Details"
        })
    });
};
function DataTableInner(param, _ref) {
    var className = param.className, columns = param.columns, data = param.data, keyExtractor = param.keyExtractor, loading = param.loading, loadingMessage = param.loadingMessage, error = param.error, emptyMessage = param.emptyMessage, sortField = param.sortField, sortDirection = param.sortDirection, onSort = param.onSort, onRowClick = param.onRowClick, selectable = param.selectable, _param_selectedKeys = param.selectedKeys, selectedKeys = _param_selectedKeys === void 0 ? [] : _param_selectedKeys, onSelectionChange = param.onSelectionChange, renderExpanded = param.renderExpanded;
    var hasExpansion = !!renderExpanded;
    var totalCols = columns.length + (selectable ? 1 : 0) + (hasExpansion ? 1 : 0);
    var _React23_useState = _sliced_to_array(React23.useState(function() {
        return /* @__PURE__ */ new Set();
    }), 2), expandedKeys = _React23_useState[0], setExpandedKeys = _React23_useState[1];
    var toggleExpanded = function(key) {
        setExpandedKeys(function(prev) {
            var next = new Set(prev);
            if (next.has(key)) {
                next.delete(key);
            } else {
                next.add(key);
            }
            return next;
        });
    };
    var allKeys = data.map(function(row, i) {
        return keyExtractor(row, i);
    });
    var allSelected = allKeys.length > 0 && allKeys.every(function(k) {
        return selectedKeys.includes(k);
    });
    var handleSelectAll = function() {
        if (!onSelectionChange) return;
        onSelectionChange(allSelected ? [] : allKeys);
    };
    var handleSelectRow = function(key) {
        if (!onSelectionChange) return;
        onSelectionChange(selectedKeys.includes(key) ? selectedKeys.filter(function(k) {
            return k !== key;
        }) : _to_consumable_array(selectedKeys).concat([
            key
        ]));
    };
    var renderSortIndicator = function(columnKey) {
        if (sortField !== columnKey) return null;
        return sortDirection === "asc" ? " \u2191" : " \u2193";
    };
    var renderHeader = function(col) {
        var alignStyle = col.align ? {
            textAlign: col.align
        } : void 0;
        var widthStyle = col.width ? {
            width: col.width
        } : void 0;
        var style = _object_spread({}, alignStyle, widthStyle);
        if (col.sortable && onSort) {
            return /* @__PURE__ */ jsxs39(SortableHeader, {
                $active: sortField === col.key,
                onClick: function() {
                    return onSort(col.key);
                },
                style: style,
                children: [
                    col.header,
                    renderSortIndicator(col.key)
                ]
            }, col.key);
        }
        return /* @__PURE__ */ jsx62("th", {
            style: style,
            children: col.header
        }, col.key);
    };
    if (loading) {
        return /* @__PURE__ */ jsx62("div", {
            className: className,
            children: /* @__PURE__ */ jsxs39(Table2, {
                children: [
                    /* @__PURE__ */ jsx62(Thead, {
                        children: /* @__PURE__ */ jsxs39("tr", {
                            children: [
                                hasExpansion && /* @__PURE__ */ jsx62(ExpanderHeaderCell, {}),
                                selectable && /* @__PURE__ */ jsx62("th", {
                                    style: {
                                        width: "2.5rem"
                                    }
                                }),
                                columns.map(renderHeader)
                            ]
                        })
                    }),
                    /* @__PURE__ */ jsx62(Tbody, {
                        children: /* @__PURE__ */ jsx62(StateRow, {
                            children: /* @__PURE__ */ jsx62("td", {
                                colSpan: totalCols,
                                children: loadingMessage || "Loading..."
                            })
                        })
                    })
                ]
            })
        });
    }
    if (error) {
        return /* @__PURE__ */ jsx62("div", {
            className: className,
            children: /* @__PURE__ */ jsxs39(Table2, {
                children: [
                    /* @__PURE__ */ jsx62(Thead, {
                        children: /* @__PURE__ */ jsxs39("tr", {
                            children: [
                                hasExpansion && /* @__PURE__ */ jsx62(ExpanderHeaderCell, {}),
                                selectable && /* @__PURE__ */ jsx62("th", {
                                    style: {
                                        width: "2.5rem"
                                    }
                                }),
                                columns.map(renderHeader)
                            ]
                        })
                    }),
                    /* @__PURE__ */ jsx62(Tbody, {
                        children: /* @__PURE__ */ jsx62(StateRow, {
                            children: /* @__PURE__ */ jsx62("td", {
                                colSpan: totalCols,
                                children: /* @__PURE__ */ jsxs39(ErrorText, {
                                    children: [
                                        "Error: ",
                                        error
                                    ]
                                })
                            })
                        })
                    })
                ]
            })
        });
    }
    return /* @__PURE__ */ jsx62("div", {
        className: className,
        children: /* @__PURE__ */ jsxs39(Table2, {
            children: [
                /* @__PURE__ */ jsx62(Thead, {
                    children: /* @__PURE__ */ jsxs39("tr", {
                        children: [
                            hasExpansion && /* @__PURE__ */ jsx62(ExpanderHeaderCell, {}),
                            selectable && /* @__PURE__ */ jsx62("th", {
                                style: {
                                    width: "2.5rem"
                                },
                                children: /* @__PURE__ */ jsx62(Checkbox, {
                                    checked: allSelected,
                                    onChange: handleSelectAll
                                })
                            }),
                            columns.map(renderHeader)
                        ]
                    })
                }),
                /* @__PURE__ */ jsx62(Tbody, {
                    children: data.length > 0 ? data.map(function(row, index) {
                        var key = keyExtractor(row, index);
                        var _renderExpanded;
                        var expandedContent = (_renderExpanded = renderExpanded === null || renderExpanded === void 0 ? void 0 : renderExpanded(row, index)) !== null && _renderExpanded !== void 0 ? _renderExpanded : null;
                        var canExpand = !!expandedContent;
                        var isExpanded = canExpand && expandedKeys.has(key);
                        return /* @__PURE__ */ jsxs39(React23.Fragment, {
                            children: [
                                /* @__PURE__ */ jsxs39(Row2, {
                                    $clickable: !!onRowClick,
                                    onClick: onRowClick ? function() {
                                        return onRowClick(row);
                                    } : void 0,
                                    children: [
                                        hasExpansion && /* @__PURE__ */ jsx62("td", {
                                            children: canExpand && /* @__PURE__ */ jsx62(ExpanderButton, {
                                                type: "button",
                                                $expanded: isExpanded,
                                                "aria-expanded": isExpanded,
                                                "aria-label": isExpanded ? "Hide details" : "Show details",
                                                onClick: function(e) {
                                                    e.stopPropagation();
                                                    toggleExpanded(key);
                                                },
                                                children: /* @__PURE__ */ jsx62("span", {
                                                    "aria-hidden": "true",
                                                    children: "\u25B6"
                                                })
                                            })
                                        }),
                                        selectable && /* @__PURE__ */ jsx62("td", {
                                            children: /* @__PURE__ */ jsx62(Checkbox, {
                                                checked: selectedKeys.includes(key),
                                                onChange: function(e) {
                                                    e.stopPropagation();
                                                    handleSelectRow(key);
                                                },
                                                onClick: function(e) {
                                                    return e.stopPropagation();
                                                }
                                            })
                                        }),
                                        columns.map(function(col) {
                                            return /* @__PURE__ */ jsx62("td", {
                                                style: {
                                                    textAlign: col.align,
                                                    width: col.width
                                                },
                                                children: col.render(row, index)
                                            }, col.key);
                                        })
                                    ]
                                }),
                                isExpanded && /* @__PURE__ */ jsx62(DetailRow, {
                                    children: /* @__PURE__ */ jsx62("td", {
                                        colSpan: totalCols,
                                        children: expandedContent
                                    })
                                })
                            ]
                        }, key);
                    }) : /* @__PURE__ */ jsx62(StateRow, {
                        children: /* @__PURE__ */ jsx62("td", {
                            colSpan: totalCols,
                            children: emptyMessage || "No records found"
                        })
                    })
                })
            ]
        })
    });
}
var DataTable = React23.forwardRef(DataTableInner);
var DataTable_default = DataTable;
// src/components/CopyToClipboard/CopyToClipboard.tsx
import { useState as useState22, useCallback as useCallback3 } from "react";
import styled42 from "styled-components";
import { Copy16Regular } from "@fluentui/react-icons";
import { jsx as jsx63, jsxs as jsxs40 } from "react/jsx-runtime";
var CopyToClipboard = function(param) {
    var className = param.className, value = param.value, children = param.children;
    var _useState22 = _sliced_to_array(useState22(false), 2), showCopied = _useState22[0], setShowCopied = _useState22[1];
    var handleCopy = useCallback3(/*#__PURE__*/ _async_to_generator(function() {
        var err;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        navigator.clipboard.writeText(value)
                    ];
                case 1:
                    _state.sent();
                    setShowCopied(true);
                    setTimeout(function() {
                        return setShowCopied(false);
                    }, 1500);
                    return [
                        3,
                        3
                    ];
                case 2:
                    err = _state.sent();
                    console.error("Failed to copy to clipboard:", err);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), [
        value
    ]);
    return /* @__PURE__ */ jsxs40(Wrapper2, {
        className: className,
        children: [
            /* @__PURE__ */ jsx63(Content, {
                children: children
            }),
            /* @__PURE__ */ jsxs40(CopyButton, {
                onClick: function(e) {
                    e.stopPropagation();
                    handleCopy();
                },
                title: "Copy to clipboard",
                children: [
                    /* @__PURE__ */ jsx63(Copy16Regular, {}),
                    showCopied && /* @__PURE__ */ jsx63(CopiedBadge, {
                        children: "Copied"
                    })
                ]
            })
        ]
    });
};
var Wrapper2 = styled42.div(_templateObject58());
var Content = styled42.span(_templateObject59());
var CopyButton = styled42.button(_templateObject60());
var CopiedBadge = styled42.span(_templateObject61());
var CopyToClipboard_default = CopyToClipboard;
// src/components/NotificationsTable/NotificationsTable.tsx
import { jsx as jsx64 } from "react/jsx-runtime";
var NotificationsTable = function(param) {
    var className = param.className, data = param.data, onViewDetails = param.onViewDetails;
    var columns = [
        {
            key: "id",
            header: "ID",
            render: function(row) {
                return /* @__PURE__ */ jsx64(CopyToClipboard_default, {
                    value: String(row.id),
                    children: row.id
                });
            }
        },
        {
            key: "twin_bid",
            header: "Twin BID",
            render: function(row) {
                return /* @__PURE__ */ jsx64(CopyToClipboard_default, {
                    value: row.twin_bid,
                    children: row.twin_bid
                });
            }
        },
        {
            key: "title",
            header: "Title",
            render: function(row) {
                return row.title;
            }
        },
        {
            key: "type",
            header: "Type",
            render: function(row) {
                var colors = getNotificationTypeColors(row.type);
                return /* @__PURE__ */ jsx64(TypeBadge, {
                    style: {
                        backgroundColor: colors.background,
                        color: colors.color
                    },
                    children: row.type
                });
            }
        },
        {
            key: "created_at",
            header: "Created at",
            render: function(row) {
                return formatDateToDateTimeString(new Date(row.created_at));
            }
        },
        {
            key: "actions",
            header: "",
            render: function(row) {
                return onViewDetails ? /* @__PURE__ */ jsx64("a", {
                    href: "#",
                    onClick: function(e) {
                        e.preventDefault();
                        e.stopPropagation();
                        onViewDetails(String(row.id));
                    },
                    children: "View Details"
                }) : null;
            }
        }
    ];
    return /* @__PURE__ */ jsx64("div", {
        className: className,
        children: /* @__PURE__ */ jsx64(DataTable_default, {
            columns: columns,
            data: data !== null && data !== void 0 ? data : [],
            keyExtractor: function(row, i) {
                var _row_id;
                return (_row_id = row.id) !== null && _row_id !== void 0 ? _row_id : i;
            },
            emptyMessage: "No notification records available"
        })
    });
};
var TypeBadge = styled43.span(_templateObject62());
var NotificationsTable_default = NotificationsTable;
// src/components/UsersTable/UsersTable.tsx
import styled44 from "styled-components";
import { Link as Link2, useNavigate } from "react-router-dom";
import { Delete24Regular as Delete24Regular2, Pen24Regular as Pen24Regular2 } from "@fluentui/react-icons";
import { Scrollbar } from "@repo/design-system";
import { formatRoles } from "@repo/front-end-utils";
import { formatDateToDayMonthYear } from "@repo/front-end-utils";
import { truncateString } from "@repo/front-end-utils";
import { jsx as jsx65, jsxs as jsxs41 } from "react/jsx-runtime";
var UsersTable = function(param) {
    var className = param.className, data = param.data, onEditUser = param.onEditUser, onDeleteUser = param.onDeleteUser;
    var navigate = useNavigate();
    return /* @__PURE__ */ jsxs41("div", {
        className: className,
        children: [
            /* @__PURE__ */ jsxs41("div", {
                className: "thead",
                children: [
                    /* @__PURE__ */ jsx65("div", {
                        children: "Name"
                    }),
                    /* @__PURE__ */ jsx65("div", {
                        children: "Email"
                    }),
                    /* @__PURE__ */ jsx65("div", {
                        children: "Role(s)"
                    }),
                    /* @__PURE__ */ jsx65("div", {
                        children: "Sign up date"
                    }),
                    /* @__PURE__ */ jsx65("div", {
                        children: "Last seen at"
                    })
                ]
            }),
            /* @__PURE__ */ jsx65(Scrollbar, {
                maxHeight: 630,
                children: /* @__PURE__ */ jsx65("table", {
                    children: /* @__PURE__ */ jsx65("tbody", {
                        children: data && data.length > 0 ? data.map(function(r, i) {
                            var roles4 = formatRoles(r.roles).join(", ");
                            var signedUpDate = r.created_at ? formatDateToDayMonthYear(new Date(r.created_at)) : "N/A";
                            var lastSeenDate = r.last_login ? formatDateToDayMonthYear(new Date(r.last_login)) : "N/A";
                            return /* @__PURE__ */ jsxs41("tr", {
                                children: [
                                    /* @__PURE__ */ jsx65("td", {
                                        children: r.name
                                    }),
                                    /* @__PURE__ */ jsx65("td", {
                                        children: /* @__PURE__ */ jsx65(Link2, {
                                            to: "mailto:".concat(r.email),
                                            children: truncateString(r.email, 28)
                                        })
                                    }),
                                    /* @__PURE__ */ jsx65("td", {
                                        children: roles4
                                    }),
                                    /* @__PURE__ */ jsx65("td", {
                                        children: signedUpDate
                                    }),
                                    /* @__PURE__ */ jsx65("td", {
                                        children: lastSeenDate
                                    }),
                                    /* @__PURE__ */ jsxs41("td", {
                                        children: [
                                            /* @__PURE__ */ jsx65("button", {
                                                className: "edit-button",
                                                onClick: function() {
                                                    if (onEditUser) {
                                                        onEditUser(r.user_id);
                                                    } else {
                                                        navigate("/account/users/edit-user", {
                                                            state: {
                                                                userId: r.user_id
                                                            }
                                                        });
                                                    }
                                                },
                                                children: /* @__PURE__ */ jsx65(Pen24Regular2, {})
                                            }),
                                            /* @__PURE__ */ jsx65("button", {
                                                onClick: function() {
                                                    if (onDeleteUser) {
                                                        onDeleteUser(r.user_id, r.name);
                                                    } else {
                                                        navigate("/account/users/delete", {
                                                            state: {
                                                                userId: r.user_id
                                                            }
                                                        });
                                                    }
                                                },
                                                children: /* @__PURE__ */ jsx65(Delete24Regular2, {})
                                            })
                                        ]
                                    })
                                ]
                            }, i);
                        }) : /* @__PURE__ */ jsx65("tr", {
                            children: /* @__PURE__ */ jsx65("td", {
                                className: "no-records",
                                colSpan: 7,
                                children: "No user records available"
                            })
                        })
                    })
                })
            })
        ]
    });
};
var UsersTable_default = styled44(UsersTable)(_templateObject63());
// src/components/LegalLayout/LegalLayout.tsx
import styled45 from "styled-components";
import atomBg from "@repo/assets/atom-bg.png";
import { Outlet } from "react-router-dom";
import { jsx as jsx66, jsxs as jsxs42 } from "react/jsx-runtime";
var LegalLayout = function(param) {
    var className = param.className;
    return /* @__PURE__ */ jsx66("div", {
        className: className,
        style: {
            backgroundImage: "url(".concat(atomBg, ")"),
            backgroundSize: "cover"
        },
        children: /* @__PURE__ */ jsxs42("main", {
            className: "legal-layout",
            children: [
                /* @__PURE__ */ jsx66("div", {
                    className: "legal-header",
                    children: /* @__PURE__ */ jsx66("button", {
                        className: "btn-back",
                        children: "Go back"
                    })
                }),
                /* @__PURE__ */ jsx66("div", {
                    className: "legal-panel",
                    children: /* @__PURE__ */ jsx66(Outlet, {})
                })
            ]
        })
    });
};
var LegalLayout_default = styled45(LegalLayout)(_templateObject64());
// src/components/LegalDocumentView/LegalDocumentView.tsx
import { useEffect as useEffect17, useState as useState24 } from "react";
import styled47 from "styled-components";
import { formatPublishedDate } from "@repo/front-end-utils";
// src/components/LegalDocumentBody/LegalDocumentBody.tsx
import { useEffect as useEffect16, useRef as useRef10, useState as useState23 } from "react";
import styled46 from "styled-components";
import { sanitizeLegalHtml } from "@repo/front-end-utils";
import { jsx as jsx67 } from "react/jsx-runtime";
var LegalDocumentBody = function(param) {
    var contentHtml = param.contentHtml, onReadyChange = param.onReadyChange, _param_emptyLabel = param.emptyLabel, emptyLabel = _param_emptyLabel === void 0 ? "Nothing to preview." : _param_emptyLabel, className = param.className;
    var _useState23 = _sliced_to_array(useState23(null), 2), cleanHtml = _useState23[0], setCleanHtml = _useState23[1];
    useEffect16(function() {
        setCleanHtml(sanitizeLegalHtml(contentHtml));
    }, [
        contentHtml
    ]);
    var ready = cleanHtml !== null && cleanHtml !== "";
    var onReadyChangeRef = useRef10(onReadyChange);
    useEffect16(function() {
        onReadyChangeRef.current = onReadyChange;
    }, [
        onReadyChange
    ]);
    useEffect16(function() {
        var _onReadyChangeRef_current;
        (_onReadyChangeRef_current = onReadyChangeRef.current) === null || _onReadyChangeRef_current === void 0 ? void 0 : _onReadyChangeRef_current.call(onReadyChangeRef, ready);
    }, [
        ready
    ]);
    if (cleanHtml === null) {
        return /* @__PURE__ */ jsx67(PlaceholderText, {
            className: className,
            children: "Loading\u2026"
        });
    }
    if (cleanHtml === "") {
        return /* @__PURE__ */ jsx67(PlaceholderText, {
            className: className,
            children: emptyLabel
        });
    }
    return /* @__PURE__ */ jsx67(Body, {
        className: "legal-doc__body".concat(className ? " ".concat(className) : ""),
        dangerouslySetInnerHTML: {
            __html: cleanHtml
        }
    });
};
var Body = styled46.div(_templateObject65());
var PlaceholderText = styled46.p(_templateObject66());
var LegalDocumentBody_default = LegalDocumentBody;
// src/components/LegalDocumentView/LegalDocumentView.tsx
import { jsx as jsx68, jsxs as jsxs43 } from "react/jsx-runtime";
var LegalDocumentView = function(param) {
    var doc = param.doc, slug = param.slug, className = param.className;
    useEffect17(function() {
        var body = document.body;
        var prevOverflow = body.style.overflow;
        body.style.overflow = "auto";
        return function() {
            body.style.overflow = prevOverflow;
        };
    }, []);
    var _useState24 = _sliced_to_array(useState24(false), 2), bodyReady = _useState24[0], setBodyReady = _useState24[1];
    var published = formatPublishedDate(doc.publishedAt);
    var isSuperseded = doc.status === "superseded";
    return /* @__PURE__ */ jsx68("div", {
        className: className,
        children: /* @__PURE__ */ jsxs43("article", {
            className: "legal-doc",
            children: [
                /* @__PURE__ */ jsxs43("header", {
                    className: "legal-doc__head",
                    children: [
                        /* @__PURE__ */ jsx68("h1", {
                            className: "legal-doc__title",
                            children: doc.title
                        }),
                        /* @__PURE__ */ jsxs43("p", {
                            className: "legal-doc__meta",
                            children: [
                                "Version ",
                                doc.version,
                                published ? " \xb7 Published ".concat(published) : ""
                            ]
                        }),
                        isSuperseded && /* @__PURE__ */ jsxs43("div", {
                            className: "legal-doc__banner",
                            role: "note",
                            children: [
                                "This is version ",
                                doc.version,
                                ", which has been superseded.",
                                " ",
                                /* @__PURE__ */ jsx68("a", {
                                    href: "/legal/".concat(slug),
                                    children: "View the current version"
                                }),
                                "."
                            ]
                        }),
                        /* @__PURE__ */ jsx68("button", {
                            type: "button",
                            className: "legal-doc__print",
                            onClick: function() {
                                return window.print();
                            },
                            disabled: !bodyReady,
                            children: "Print / save as PDF"
                        })
                    ]
                }),
                /* @__PURE__ */ jsx68(LegalDocumentBody_default, {
                    contentHtml: doc.contentHtml,
                    onReadyChange: setBodyReady
                })
            ]
        })
    });
};
var LegalDocumentView_default = styled47(LegalDocumentView)(_templateObject67());
// src/components/SinglePanelLayout/SinglePanelLayout.tsx
import { useState as useState25 } from "react";
import styled48 from "styled-components";
import atomBg2 from "@repo/assets/atom-bg.png";
import { Outlet as Outlet2 } from "react-router-dom";
import { Fragment as Fragment15, jsx as jsx69, jsxs as jsxs44 } from "react/jsx-runtime";
var SinglePanelLayout = function(param) {
    var className = param.className, _param_centre = param.centre, centre = _param_centre === void 0 ? false : _param_centre;
    var _useState25 = _sliced_to_array(useState25(false), 2), isLoading = _useState25[0], setIsLoading = _useState25[1];
    return /* @__PURE__ */ jsxs44(Fragment15, {
        children: [
            isLoading && /* @__PURE__ */ jsx69(TLSpinnerPage_default, {
                loadingMessages: []
            }),
            /* @__PURE__ */ jsx69("div", {
                className: className,
                style: {
                    backgroundImage: "url(".concat(atomBg2, ")"),
                    backgroundSize: "cover",
                    backgroundRepeat: "repeat-y"
                },
                children: /* @__PURE__ */ jsx69("main", {
                    className: "panel-layout",
                    children: /* @__PURE__ */ jsx69("div", {
                        className: "panel",
                        children: /* @__PURE__ */ jsx69(Outlet2, {
                            context: {
                                isLoading: isLoading,
                                setIsLoading: setIsLoading
                            }
                        })
                    })
                })
            })
        ]
    });
};
var SinglePanelLayout_default = styled48(SinglePanelLayout)(_templateObject68());
// src/components/About/About.tsx
import styled49 from "styled-components";
import twinlabsAiStackedLogo from "@repo/assets/logos/twinlabs-ai-stacked-logo.svg";
import { jsx as jsx70, jsxs as jsxs45 } from "react/jsx-runtime";
var About = function(param) {
    var className = param.className, onClose = param.onClose, version = param.version;
    return /* @__PURE__ */ jsxs45("div", {
        className: className,
        children: [
            /* @__PURE__ */ jsx70("div", {
                className: "image-icon",
                children: /* @__PURE__ */ jsx70("img", {
                    src: twinlabsAiStackedLogo,
                    alt: "TwinLabs.ai Logo"
                })
            }),
            version && /* @__PURE__ */ jsxs45("p", {
                children: [
                    "Version ",
                    version
                ]
            }),
            /* @__PURE__ */ jsxs45("p", {
                children: [
                    "Copyright TwinLabs.ai ",
                    /* @__PURE__ */ new Date().getFullYear(),
                    " All Rights Reserved"
                ]
            }),
            /* @__PURE__ */ jsx70(SecondaryButton_default, {
                onClick: onClose,
                children: "Close"
            })
        ]
    });
};
var About_default = styled49(About)(_templateObject69());
// src/components/Admin/AdminForm/AdminForm.tsx
import styled50 from "styled-components";
import { jsx as jsx71 } from "react/jsx-runtime";
var AdminForm = function(param) {
    var className = param.className, children = param.children;
    return /* @__PURE__ */ jsx71("div", {
        className: className,
        children: /* @__PURE__ */ jsx71("div", {
            children: children
        })
    });
};
var AdminForm_default = styled50(AdminForm)(_templateObject70());
// src/components/DeleteUser/DeleteUser.tsx
import { useState as useState26 } from "react";
import styled51 from "styled-components";
import { useUserStore as useUserStore3 } from "@repo/front-end-state";
import { escapeHtml } from "@repo/front-end-utils";
import { Warning12Filled } from "@fluentui/react-icons";
import { deleteUser } from "@repo/front-end-services";
import { jsx as jsx72, jsxs as jsxs46 } from "react/jsx-runtime";
var DeleteUser = function(param) {
    var className = param.className, middlewareApi = param.middlewareApi, userId = param.userId, userName = param.userName, onClose = param.onClose, onDeleted = param.onDeleted;
    var authMetadata = useUserStore3().authMetadata;
    var _useState26 = _sliced_to_array(useState26(false), 2), isLoading = _useState26[0], setIsLoading = _useState26[1];
    var _useState261 = _sliced_to_array(useState26(null), 2), error = _useState261[0], setError = _useState261[1];
    var handleDeleteUser = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var _authMetadata_tokens, result;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(authMetadata === null || authMetadata === void 0 ? void 0 : (_authMetadata_tokens = authMetadata.tokens) === null || _authMetadata_tokens === void 0 ? void 0 : _authMetadata_tokens.accessToken)) return [
                            2
                        ];
                        setIsLoading(true);
                        setError(null);
                        return [
                            4,
                            deleteUser(middlewareApi, authMetadata.tokens.accessToken, userId)
                        ];
                    case 1:
                        result = _state.sent();
                        if (result) {
                            if (onDeleted) {
                                onDeleted();
                            }
                            onClose();
                        } else {
                            setError("Unable to delete user. Please try again.");
                        }
                        setIsLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDeleteUser() {
            return _ref.apply(this, arguments);
        };
    }();
    return /* @__PURE__ */ jsxs46("div", {
        className: className,
        children: [
            /* @__PURE__ */ jsx72(NotificationPanel_default, {
                icon: /* @__PURE__ */ jsx72(Warning12Filled, {
                    style: {
                        color: "#FF000D"
                    }
                }),
                header: "Are you sure you want to delete<br/>".concat(escapeHtml(userName), "?"),
                copy: "<p>This action cannot be undone. Press 'Delete Account' to confirm or 'Back' to return to the previous page.</p>",
                primaryButton: /* @__PURE__ */ jsx72(PrimaryButton_default, {
                    onClick: isLoading ? void 0 : handleDeleteUser,
                    children: isLoading ? "Deleting..." : "Delete Account"
                }),
                onBack: onClose,
                buttonTopMargin: "2rem"
            }),
            error && /* @__PURE__ */ jsx72("p", {
                className: "error",
                children: error
            })
        ]
    });
};
var DeleteUser_default = styled51(DeleteUser)(_templateObject71());
// src/components/ProfileForm/ProfileForm.tsx
import { yupResolver } from "@hookform/resolvers/yup";
import { useState as useState27 } from "react";
import { useForm } from "react-hook-form";
import styled52 from "styled-components";
import * as yup from "yup";
import { Roles as Roles2 } from "@repo/frontend-types";
import { useUserStore as useUserStore4, useDialogContext as useDialogContext2 } from "@repo/front-end-state";
import { MessageBar as MessageBar2 } from "@fluentui/react-components";
import { Person24Regular } from "@fluentui/react-icons";
import { updateProfile } from "@repo/front-end-services";
import { jsx as jsx73, jsxs as jsxs47 } from "react/jsx-runtime";
var formSchema = {
    email: yup.string().email().required("Please enter your e-mail address"),
    firstName: yup.string().required("Please enter your first name"),
    lastName: yup.string().optional(),
    developerMode: yup.boolean().optional()
};
var ProfileForm = function(param) {
    var className = param.className, middlewareApi = param.middlewareApi, onClose = param.onClose;
    var _errors_email, _errors_firstName, _errors_lastName;
    var _useUserStore4 = useUserStore4(), authMetadata = _useUserStore4.authMetadata, setAuthMetadata = _useUserStore4.setAuthMetadata;
    var hideDialog = useDialogContext2().hideDialog;
    var _useState27 = _sliced_to_array(useState27(false), 2), isLoading = _useState27[0], setIsLoading = _useState27[1];
    var _useState271 = _sliced_to_array(useState27(null), 2), message = _useState271[0], setMessage = _useState271[1];
    var _useState272 = _sliced_to_array(useState27(false), 2), discard = _useState272[0], setDiscard = _useState272[1];
    var role = (authMetadata === null || authMetadata === void 0 ? void 0 : authMetadata.roles) ? authMetadata.roles[0] : "";
    var _useForm = useForm({
        resolver: yupResolver(yup.object(formSchema)),
        defaultValues: {
            email: authMetadata === null || authMetadata === void 0 ? void 0 : authMetadata.email,
            firstName: authMetadata === null || authMetadata === void 0 ? void 0 : authMetadata.firstName,
            lastName: authMetadata === null || authMetadata === void 0 ? void 0 : authMetadata.lastName,
            developerMode: authMetadata === null || authMetadata === void 0 ? void 0 : authMetadata.developerMode
        }
    }), getValues = _useForm.getValues, handleSubmit = _useForm.handleSubmit, register = _useForm.register, reset = _useForm.reset, watch = _useForm.watch, _useForm_formState = _useForm.formState, errors = _useForm_formState.errors, isDirty = _useForm_formState.isDirty, isValid = _useForm_formState.isValid;
    var onSubmit = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(formData) {
            var _authMetadata_tokens, // Last name is optional now; pass '' when unset. updateProfile trims and omits a
            // blank last name, so '' and undefined are equivalent here.
            _formData_lastName, result, _result_data, _result_data1, _result_data2, _result_data3;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(authMetadata === null || authMetadata === void 0 ? void 0 : (_authMetadata_tokens = authMetadata.tokens) === null || _authMetadata_tokens === void 0 ? void 0 : _authMetadata_tokens.accessToken)) return [
                            3,
                            2
                        ];
                        setIsLoading(true);
                        return [
                            4,
                            updateProfile(middlewareApi, authMetadata === null || authMetadata === void 0 ? void 0 : authMetadata.tokens.accessToken, formData.email, formData.firstName, (_formData_lastName = formData.lastName) !== null && _formData_lastName !== void 0 ? _formData_lastName : "")
                        ];
                    case 1:
                        result = _state.sent();
                        if (result) {
                            ;
                            setAuthMetadata({
                                name: (_result_data = result.data) === null || _result_data === void 0 ? void 0 : _result_data.name,
                                firstName: (_result_data1 = result.data) === null || _result_data1 === void 0 ? void 0 : _result_data1.given_name,
                                lastName: (_result_data2 = result.data) === null || _result_data2 === void 0 ? void 0 : _result_data2.family_name,
                                email: (_result_data3 = result.data) === null || _result_data3 === void 0 ? void 0 : _result_data3.email,
                                developerMode: formData.developerMode
                            });
                            setMessage({
                                intent: "success",
                                content: "Profile updated successfully"
                            });
                        } else {
                            setMessage({
                                intent: "error",
                                content: "Failed to update profile"
                            });
                        }
                        setIsLoading(false);
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(formData) {
            return _ref.apply(this, arguments);
        };
    }();
    var email = watch("email");
    return /* @__PURE__ */ jsx73("div", {
        className: className,
        children: /* @__PURE__ */ jsxs47(DialogForm_default, {
            icon: /* @__PURE__ */ jsx73(Person24Regular, {}),
            header: "Profile",
            isLoading: isLoading,
            onClose: hideDialog,
            adminForm: true,
            children: [
                message && /* @__PURE__ */ jsx73(MessageBar2, {
                    className: "message-bar",
                    intent: message.intent,
                    layout: "multiline",
                    children: message.content
                }),
                /* @__PURE__ */ jsx73(AdminForm_default, {
                    children: /* @__PURE__ */ jsxs47("form", {
                        onSubmit: handleSubmit(onSubmit),
                        children: [
                            /* @__PURE__ */ jsxs47("fieldset", {
                                children: [
                                    /* @__PURE__ */ jsx73("div", {
                                        className: "field",
                                        children: /* @__PURE__ */ jsx73(TLAdminInput_default, _object_spread_props(_object_spread({
                                            enableModes: true,
                                            discard: discard,
                                            id: "txtEmail",
                                            label: "E-mail Address",
                                            type: "email"
                                        }, register("email")), {
                                            currentValue: getValues("email"),
                                            errorMessage: (_errors_email = errors.email) === null || _errors_email === void 0 ? void 0 : _errors_email.message
                                        }))
                                    }),
                                    /* @__PURE__ */ jsx73("div", {
                                        className: "field",
                                        children: /* @__PURE__ */ jsx73(TLAdminInput_default, _object_spread_props(_object_spread({
                                            enableModes: true,
                                            discard: discard,
                                            id: "txtFirstName",
                                            label: "First Name",
                                            type: "text",
                                            currentValue: getValues("firstName")
                                        }, register("firstName")), {
                                            errorMessage: (_errors_firstName = errors.firstName) === null || _errors_firstName === void 0 ? void 0 : _errors_firstName.message
                                        }))
                                    }),
                                    /* @__PURE__ */ jsx73("div", {
                                        className: "field",
                                        children: /* @__PURE__ */ jsx73(TLAdminInput_default, _object_spread_props(_object_spread({
                                            enableModes: true,
                                            discard: discard,
                                            id: "txtLastname",
                                            label: "Last Name",
                                            type: "text",
                                            currentValue: getValues("lastName")
                                        }, register("lastName")), {
                                            errorMessage: (_errors_lastName = errors.lastName) === null || _errors_lastName === void 0 ? void 0 : _errors_lastName.message
                                        }))
                                    }),
                                    role === Roles2.TL_ADMIN && /* @__PURE__ */ jsx73("div", {
                                        className: "field",
                                        children: /* @__PURE__ */ jsx73(TLAdminSwitch_default, _object_spread({
                                            id: "ckbDeveloperMode",
                                            label: "Developer Mode",
                                            currentValue: getValues("developerMode")
                                        }, register("developerMode")))
                                    })
                                ]
                            }),
                            /* @__PURE__ */ jsx73(PrimaryButton_default, {
                                type: "submit",
                                disabled: !isValid || !isDirty,
                                children: "Save Changes"
                            }),
                            /* @__PURE__ */ jsx73(SecondaryButton_default, {
                                onClick: onClose,
                                children: "Close"
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var ProfileForm_default = styled52(ProfileForm)(_templateObject72());
// src/components/AddUserForm/AddUserForm.tsx
import { useState as useState28 } from "react";
import styled53 from "styled-components";
import { useForm as useForm2 } from "react-hook-form";
import { yupResolver as yupResolver2 } from "@hookform/resolvers/yup";
import * as yup2 from "yup";
import { Roles as Roles3 } from "@repo/frontend-types";
import { useUserStore as useUserStore5 } from "@repo/front-end-state";
import { passwordValidation } from "@repo/front-end-utils";
import { MessageBar as MessageBar3 } from "@fluentui/react-components";
import { PersonAdd24Regular } from "@fluentui/react-icons";
import { createUser } from "@repo/front-end-services";
import { jsx as jsx74, jsxs as jsxs48 } from "react/jsx-runtime";
var formSchema2 = {
    email: yup2.string().email().required("Please enter an e-mail address"),
    password: passwordValidation,
    reEnterPassword: yup2.string().required("Please re-enter the password").oneOf([
        yup2.ref("password")
    ], "Passwords must match"),
    firstName: yup2.string().required("Please enter a first name"),
    lastName: yup2.string().required("Please enter a last name"),
    role: yup2.string().typeError("You must select an option").notOneOf([
        ""
    ], "Please select an option").required("You must select an option")
};
var AddUserForm = function(param) {
    var className = param.className, middlewareApi = param.middlewareApi, onClose = param.onClose, onSuccess = param.onSuccess;
    var _errors_role, _errors_firstName, _errors_lastName, _errors_email, _errors_password, _errors_reEnterPassword;
    var authMetadata = useUserStore5().authMetadata;
    var _useState28 = _sliced_to_array(useState28(false), 2), isLoading = _useState28[0], setIsLoading = _useState28[1];
    var _useState281 = _sliced_to_array(useState28(null), 2), message = _useState281[0], setMessage = _useState281[1];
    var currentUserRole = (authMetadata === null || authMetadata === void 0 ? void 0 : authMetadata.roles) ? authMetadata.roles[0] : "";
    var _useForm2 = useForm2({
        resolver: yupResolver2(yup2.object(formSchema2)),
        defaultValues: {
            role: ""
        }
    }), register = _useForm2.register, handleSubmit = _useForm2.handleSubmit, reset = _useForm2.reset, _useForm2_formState = _useForm2.formState, errors = _useForm2_formState.errors, isValid = _useForm2_formState.isValid;
    var onSubmit = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(formData) {
            var _authMetadata_tokens, result;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!((authMetadata === null || authMetadata === void 0 ? void 0 : (_authMetadata_tokens = authMetadata.tokens) === null || _authMetadata_tokens === void 0 ? void 0 : _authMetadata_tokens.accessToken) && authMetadata.organisation && authMetadata.orgBID)) return [
                            3,
                            2
                        ];
                        setIsLoading(true);
                        setMessage(null);
                        return [
                            4,
                            createUser(middlewareApi, authMetadata.tokens.accessToken, "".concat(authMetadata.organisation, ":").concat(authMetadata.orgBID), formData.firstName, formData.lastName, formData.email, formData.password, formData.role)
                        ];
                    case 1:
                        result = _state.sent();
                        if (result) {
                            setMessage({
                                intent: "success",
                                content: "User created successfully"
                            });
                            reset();
                            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
                        } else {
                            setMessage({
                                intent: "error",
                                content: "Failed to create user. Please try again."
                            });
                        }
                        setIsLoading(false);
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(formData) {
            return _ref.apply(this, arguments);
        };
    }();
    var getRoleOptions = function(role) {
        var options = [
            {
                text: "Please select",
                value: ""
            }
        ];
        var customerAdminOptions = [
            {
                text: "Admin",
                value: Roles3.CUSTOMER_ADMIN
            },
            {
                text: "User",
                value: Roles3.CUSTOMER_USER
            }
        ];
        if (role === Roles3.TL_ADMIN) {
            options = _to_consumable_array(options).concat([
                {
                    text: "TL Admin",
                    value: Roles3.TL_ADMIN
                }
            ], _to_consumable_array(customerAdminOptions));
        } else {
            options = _to_consumable_array(options).concat(_to_consumable_array(customerAdminOptions));
        }
        return options;
    };
    return /* @__PURE__ */ jsx74("div", {
        className: className,
        children: /* @__PURE__ */ jsxs48(DialogForm_default, {
            icon: /* @__PURE__ */ jsx74(PersonAdd24Regular, {}),
            header: "Add New User",
            isLoading: isLoading,
            onClose: onClose,
            adminForm: true,
            children: [
                message && /* @__PURE__ */ jsx74(MessageBar3, {
                    className: "message-bar",
                    intent: message.intent,
                    layout: "multiline",
                    children: message.content
                }),
                /* @__PURE__ */ jsx74(AdminForm_default, {
                    children: /* @__PURE__ */ jsxs48("form", {
                        onSubmit: handleSubmit(onSubmit),
                        children: [
                            /* @__PURE__ */ jsxs48("fieldset", {
                                children: [
                                    /* @__PURE__ */ jsx74("div", {
                                        className: "field",
                                        children: /* @__PURE__ */ jsx74(TLAdminSelect_default, {
                                            enableModes: false,
                                            id: "ddlRole",
                                            label: "Role",
                                            options: getRoleOptions(currentUserRole),
                                            props: _object_spread({}, register("role")),
                                            errorMessage: (_errors_role = errors.role) === null || _errors_role === void 0 ? void 0 : _errors_role.message
                                        })
                                    }),
                                    /* @__PURE__ */ jsx74("div", {
                                        className: "field",
                                        children: /* @__PURE__ */ jsx74(TLAdminInput_default, _object_spread_props(_object_spread({
                                            enableModes: false,
                                            id: "txtFirstName",
                                            label: "First Name"
                                        }, register("firstName")), {
                                            errorMessage: (_errors_firstName = errors.firstName) === null || _errors_firstName === void 0 ? void 0 : _errors_firstName.message
                                        }))
                                    }),
                                    /* @__PURE__ */ jsx74("div", {
                                        className: "field",
                                        children: /* @__PURE__ */ jsx74(TLAdminInput_default, _object_spread_props(_object_spread({
                                            enableModes: false,
                                            id: "txtLastName",
                                            label: "Last Name"
                                        }, register("lastName")), {
                                            errorMessage: (_errors_lastName = errors.lastName) === null || _errors_lastName === void 0 ? void 0 : _errors_lastName.message
                                        }))
                                    }),
                                    /* @__PURE__ */ jsx74("div", {
                                        className: "field",
                                        children: /* @__PURE__ */ jsx74(TLAdminInput_default, _object_spread_props(_object_spread({
                                            enableModes: false,
                                            id: "txtEmail",
                                            label: "E-mail Address",
                                            type: "email"
                                        }, register("email")), {
                                            errorMessage: (_errors_email = errors.email) === null || _errors_email === void 0 ? void 0 : _errors_email.message
                                        }))
                                    }),
                                    /* @__PURE__ */ jsx74(PasswordRequirements_default, {}),
                                    /* @__PURE__ */ jsx74("div", {
                                        className: "field",
                                        children: /* @__PURE__ */ jsx74(TLAdminInput_default, _object_spread_props(_object_spread({
                                            enableModes: false,
                                            id: "txtPassword",
                                            label: "Password",
                                            type: "password"
                                        }, register("password")), {
                                            errorMessage: (_errors_password = errors.password) === null || _errors_password === void 0 ? void 0 : _errors_password.message
                                        }))
                                    }),
                                    /* @__PURE__ */ jsx74("div", {
                                        className: "field",
                                        children: /* @__PURE__ */ jsx74(TLAdminInput_default, _object_spread_props(_object_spread({
                                            enableModes: false,
                                            id: "txtReEnterPassword",
                                            label: "Re-enter Password",
                                            type: "password"
                                        }, register("reEnterPassword")), {
                                            errorMessage: (_errors_reEnterPassword = errors.reEnterPassword) === null || _errors_reEnterPassword === void 0 ? void 0 : _errors_reEnterPassword.message
                                        }))
                                    })
                                ]
                            }),
                            /* @__PURE__ */ jsx74(PrimaryButton_default, {
                                type: "submit",
                                disabled: !isValid,
                                children: "Add User"
                            }),
                            /* @__PURE__ */ jsx74(SecondaryButton_default, {
                                onClick: onClose,
                                children: "Cancel"
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var AddUserForm_default = styled53(AddUserForm)(_templateObject73());
// src/components/EditUserForm/EditUserForm.tsx
import { useEffect as useEffect18, useState as useState29 } from "react";
import styled54 from "styled-components";
import { useForm as useForm3 } from "react-hook-form";
import { yupResolver as yupResolver3 } from "@hookform/resolvers/yup";
import * as yup3 from "yup";
import { Roles as Roles4 } from "@repo/frontend-types";
import { useUserStore as useUserStore6 } from "@repo/front-end-state";
import { MessageBar as MessageBar4 } from "@fluentui/react-components";
import { Pen24Regular as Pen24Regular3 } from "@fluentui/react-icons";
import { getUserById, updateUserById } from "@repo/front-end-services";
import { jsx as jsx75, jsxs as jsxs49 } from "react/jsx-runtime";
var formSchema3 = {
    email: yup3.string().email().required("Please enter an e-mail address"),
    firstName: yup3.string().required("Please enter a first name"),
    lastName: yup3.string().required("Please enter a last name"),
    role: yup3.string().typeError("You must select an option").notOneOf([
        ""
    ], "Please select an option").required("You must select an option")
};
var EditUserForm = function(param) {
    var className = param.className, middlewareApi = param.middlewareApi, userId = param.userId, onClose = param.onClose, onSuccess = param.onSuccess;
    var _authMetadata_tokens, _errors_role, _errors_firstName, _errors_lastName, _errors_email;
    var authMetadata = useUserStore6().authMetadata;
    var _useState29 = _sliced_to_array(useState29(true), 2), isLoading = _useState29[0], setIsLoading = _useState29[1];
    var _useState291 = _sliced_to_array(useState29(null), 2), message = _useState291[0], setMessage = _useState291[1];
    var currentUserRole = (authMetadata === null || authMetadata === void 0 ? void 0 : authMetadata.roles) ? authMetadata.roles[0] : "";
    var _useForm3 = useForm3({
        resolver: yupResolver3(yup3.object(formSchema3)),
        defaultValues: {
            role: "",
            email: "",
            firstName: "",
            lastName: ""
        }
    }), register = _useForm3.register, handleSubmit = _useForm3.handleSubmit, setValue = _useForm3.setValue, _useForm3_formState = _useForm3.formState, errors = _useForm3_formState.errors, isValid = _useForm3_formState.isValid, isDirty = _useForm3_formState.isDirty;
    useEffect18(function() {
        var fetchUser = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function() {
                var _authMetadata_tokens, _userData_roles, userData, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(authMetadata === null || authMetadata === void 0 ? void 0 : (_authMetadata_tokens = authMetadata.tokens) === null || _authMetadata_tokens === void 0 ? void 0 : _authMetadata_tokens.accessToken)) return [
                                3,
                                5
                            ];
                            setIsLoading(true);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                getUserById(middlewareApi, authMetadata.tokens.accessToken, userId)
                            ];
                        case 2:
                            userData = _state.sent();
                            setValue("email", userData.email || "");
                            setValue("firstName", userData.given_name || "");
                            setValue("lastName", userData.family_name || "");
                            setValue("role", ((_userData_roles = userData.roles) === null || _userData_roles === void 0 ? void 0 : _userData_roles[0]) || "");
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            setMessage({
                                intent: "error",
                                content: "Failed to load user data."
                            });
                            return [
                                3,
                                4
                            ];
                        case 4:
                            setIsLoading(false);
                            _state.label = 5;
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchUser() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchUser();
    }, [
        authMetadata === null || authMetadata === void 0 ? void 0 : (_authMetadata_tokens = authMetadata.tokens) === null || _authMetadata_tokens === void 0 ? void 0 : _authMetadata_tokens.accessToken,
        userId,
        setValue,
        middlewareApi
    ]);
    var onSubmit = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(formData) {
            var _authMetadata_tokens, result;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(authMetadata === null || authMetadata === void 0 ? void 0 : (_authMetadata_tokens = authMetadata.tokens) === null || _authMetadata_tokens === void 0 ? void 0 : _authMetadata_tokens.accessToken)) return [
                            3,
                            2
                        ];
                        setIsLoading(true);
                        setMessage(null);
                        return [
                            4,
                            updateUserById(middlewareApi, authMetadata.tokens.accessToken, formData.email, formData.firstName, formData.lastName, formData.role, userId)
                        ];
                    case 1:
                        result = _state.sent();
                        if (result) {
                            setMessage({
                                intent: "success",
                                content: "User updated successfully"
                            });
                            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
                        } else {
                            setMessage({
                                intent: "error",
                                content: "Failed to update user. Please try again."
                            });
                        }
                        setIsLoading(false);
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(formData) {
            return _ref.apply(this, arguments);
        };
    }();
    var getRoleOptions = function(role) {
        var options = [
            {
                text: "Please select",
                value: ""
            }
        ];
        var customerAdminOptions = [
            {
                text: "Admin",
                value: Roles4.CUSTOMER_ADMIN
            },
            {
                text: "User",
                value: Roles4.CUSTOMER_USER
            }
        ];
        if (role === Roles4.TL_ADMIN) {
            options = _to_consumable_array(options).concat([
                {
                    text: "TL Admin",
                    value: Roles4.TL_ADMIN
                }
            ], _to_consumable_array(customerAdminOptions));
        } else {
            options = _to_consumable_array(options).concat(_to_consumable_array(customerAdminOptions));
        }
        return options;
    };
    return /* @__PURE__ */ jsx75("div", {
        className: className,
        children: /* @__PURE__ */ jsxs49(DialogForm_default, {
            icon: /* @__PURE__ */ jsx75(Pen24Regular3, {}),
            header: "Edit User",
            isLoading: isLoading,
            onClose: onClose,
            adminForm: true,
            children: [
                message && /* @__PURE__ */ jsx75(MessageBar4, {
                    className: "message-bar",
                    intent: message.intent,
                    layout: "multiline",
                    children: message.content
                }),
                /* @__PURE__ */ jsx75(AdminForm_default, {
                    children: /* @__PURE__ */ jsxs49("form", {
                        onSubmit: handleSubmit(onSubmit),
                        children: [
                            /* @__PURE__ */ jsxs49("fieldset", {
                                children: [
                                    /* @__PURE__ */ jsx75("div", {
                                        className: "field",
                                        children: /* @__PURE__ */ jsx75(TLAdminSelect_default, {
                                            enableModes: false,
                                            id: "ddlRole",
                                            label: "Role",
                                            options: getRoleOptions(currentUserRole),
                                            props: _object_spread({}, register("role")),
                                            errorMessage: (_errors_role = errors.role) === null || _errors_role === void 0 ? void 0 : _errors_role.message
                                        })
                                    }),
                                    /* @__PURE__ */ jsx75("div", {
                                        className: "field",
                                        children: /* @__PURE__ */ jsx75(TLAdminInput_default, _object_spread_props(_object_spread({
                                            enableModes: false,
                                            id: "txtFirstName",
                                            label: "First Name"
                                        }, register("firstName")), {
                                            errorMessage: (_errors_firstName = errors.firstName) === null || _errors_firstName === void 0 ? void 0 : _errors_firstName.message
                                        }))
                                    }),
                                    /* @__PURE__ */ jsx75("div", {
                                        className: "field",
                                        children: /* @__PURE__ */ jsx75(TLAdminInput_default, _object_spread_props(_object_spread({
                                            enableModes: false,
                                            id: "txtLastName",
                                            label: "Last Name"
                                        }, register("lastName")), {
                                            errorMessage: (_errors_lastName = errors.lastName) === null || _errors_lastName === void 0 ? void 0 : _errors_lastName.message
                                        }))
                                    }),
                                    /* @__PURE__ */ jsx75("div", {
                                        className: "field",
                                        children: /* @__PURE__ */ jsx75(TLAdminInput_default, _object_spread_props(_object_spread({
                                            enableModes: false,
                                            id: "txtEmail",
                                            label: "E-mail Address",
                                            type: "email"
                                        }, register("email")), {
                                            errorMessage: (_errors_email = errors.email) === null || _errors_email === void 0 ? void 0 : _errors_email.message
                                        }))
                                    })
                                ]
                            }),
                            /* @__PURE__ */ jsx75(PrimaryButton_default, {
                                type: "submit",
                                disabled: !isValid || !isDirty,
                                children: "Save Changes"
                            }),
                            /* @__PURE__ */ jsx75(SecondaryButton_default, {
                                onClick: onClose,
                                children: "Cancel"
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var EditUserForm_default = styled54(EditUserForm)(_templateObject74());
// src/components/ChangePasswordForm/ChangePasswordForm.tsx
import { useState as useState30 } from "react";
import styled55 from "styled-components";
import { useForm as useForm4 } from "react-hook-form";
import { yupResolver as yupResolver4 } from "@hookform/resolvers/yup";
import * as yup4 from "yup";
import { useUserStore as useUserStore7, useDialogContext as useDialogContext3 } from "@repo/front-end-state";
import { passwordValidation as passwordValidation2 } from "@repo/front-end-utils";
import { MessageBar as MessageBar5 } from "@fluentui/react-components";
import { Key24Regular } from "@fluentui/react-icons";
import { changePassword } from "@repo/front-end-services";
import { jsx as jsx76, jsxs as jsxs50 } from "react/jsx-runtime";
var formSchema4 = {
    password: passwordValidation2,
    reEnterPassword: yup4.string().required("Please re-enter your new password").oneOf([
        yup4.ref("password")
    ], "Passwords must match").required("Confirm password is required")
};
var ChangePasswordForm = function(param) {
    var className = param.className, middlewareApi = param.middlewareApi, onClose = param.onClose;
    var _errors_password, _errors_reEnterPassword;
    var _useState30 = _sliced_to_array(useState30(""), 1), serverError = _useState30[0];
    var authMetadata = useUserStore7().authMetadata;
    var hideDialog = useDialogContext3().hideDialog;
    var _useState301 = _sliced_to_array(useState30(false), 2), isLoading = _useState301[0], setIsLoading = _useState301[1];
    var _useState302 = _sliced_to_array(useState30(null), 2), message = _useState302[0], setMessage = _useState302[1];
    var _useForm4 = useForm4({
        resolver: yupResolver4(yup4.object(formSchema4))
    }), register = _useForm4.register, handleSubmit = _useForm4.handleSubmit, _useForm4_formState = _useForm4.formState, errors = _useForm4_formState.errors, isValid = _useForm4_formState.isValid;
    var onSubmit = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(formData) {
            var _authMetadata_tokens, result;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(authMetadata === null || authMetadata === void 0 ? void 0 : (_authMetadata_tokens = authMetadata.tokens) === null || _authMetadata_tokens === void 0 ? void 0 : _authMetadata_tokens.accessToken)) return [
                            3,
                            2
                        ];
                        setIsLoading(true);
                        return [
                            4,
                            changePassword(middlewareApi, authMetadata === null || authMetadata === void 0 ? void 0 : authMetadata.tokens.accessToken, formData.password)
                        ];
                    case 1:
                        result = _state.sent();
                        if (result) {
                            setMessage({
                                intent: "success",
                                content: "Password updated successfully"
                            });
                        } else {
                            setMessage({
                                intent: "error",
                                content: "Failed to update password"
                            });
                        }
                        setIsLoading(false);
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(formData) {
            return _ref.apply(this, arguments);
        };
    }();
    return /* @__PURE__ */ jsx76("div", {
        className: className,
        children: /* @__PURE__ */ jsxs50(DialogForm_default, {
            icon: /* @__PURE__ */ jsx76(Key24Regular, {}),
            header: "Change Password",
            isLoading: isLoading,
            onClose: hideDialog,
            adminForm: true,
            children: [
                message && /* @__PURE__ */ jsx76(MessageBar5, {
                    className: "message-bar",
                    intent: message.intent,
                    layout: "multiline",
                    children: message.content
                }),
                /* @__PURE__ */ jsxs50(AdminForm_default, {
                    children: [
                        /* @__PURE__ */ jsx76(PasswordRequirements_default, {}),
                        /* @__PURE__ */ jsxs50("form", {
                            onSubmit: handleSubmit(onSubmit),
                            children: [
                                /* @__PURE__ */ jsxs50("fieldset", {
                                    children: [
                                        /* @__PURE__ */ jsx76("div", {
                                            className: "field",
                                            children: /* @__PURE__ */ jsx76(TLAdminInput_default, _object_spread_props(_object_spread({
                                                enableModes: false,
                                                id: "txtNewPassword",
                                                label: "New Password",
                                                type: "password"
                                            }, register("password")), {
                                                errorMessage: (_errors_password = errors.password) === null || _errors_password === void 0 ? void 0 : _errors_password.message,
                                                autoFocus: true
                                            }))
                                        }),
                                        /* @__PURE__ */ jsx76("div", {
                                            className: "field",
                                            children: /* @__PURE__ */ jsx76(TLAdminInput_default, _object_spread_props(_object_spread({
                                                enableModes: false,
                                                id: "txtReEnterPassword",
                                                label: "Re-enter password",
                                                type: "password"
                                            }, register("reEnterPassword")), {
                                                errorMessage: (_errors_reEnterPassword = errors.reEnterPassword) === null || _errors_reEnterPassword === void 0 ? void 0 : _errors_reEnterPassword.message
                                            }))
                                        })
                                    ]
                                }),
                                serverError ? /* @__PURE__ */ jsx76(MessageBar5, {
                                    id: "server-error",
                                    intent: "error",
                                    layout: "multiline",
                                    children: serverError
                                }) : null,
                                /* @__PURE__ */ jsx76(PrimaryButton_default, {
                                    type: "submit",
                                    disabled: !isValid,
                                    children: "Save Changes"
                                }),
                                /* @__PURE__ */ jsx76(SecondaryButton_default, {
                                    onClick: onClose,
                                    children: "Close"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var ChangePasswordForm_default = styled55(ChangePasswordForm)(_templateObject75());
// src/components/ManageUsers/ManageUsers.tsx
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useState as useState31 } from "react";
import styled56 from "styled-components";
import { useDebounce } from "use-debounce";
import { useUserStore as useUserStore9, useDialogContext as useDialogContext4 } from "@repo/front-end-state";
// src/hooks/useRequireAuthMetadata.ts
import { useEffect as useEffect19 } from "react";
import { useUserStore as useUserStore8 } from "@repo/front-end-state";
var useRequireAuthMetadata = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _authMetadata_tokens, _authMetadata_tokens1;
    var authMetadata = useUserStore8().authMetadata;
    var _options_requireAccessToken = options.requireAccessToken, requireAccessToken = _options_requireAccessToken === void 0 ? true : _options_requireAccessToken, _options_requireOrganisation = options.requireOrganisation, requireOrganisation = _options_requireOrganisation === void 0 ? true : _options_requireOrganisation, _options_requireRoles = options.requireRoles, requireRoles = _options_requireRoles === void 0 ? true : _options_requireRoles, _options_requireOrgBID = options.requireOrgBID, requireOrgBID = _options_requireOrgBID === void 0 ? false : _options_requireOrgBID, onAuthError = options.onAuthError;
    useEffect19(function() {
        var _authMetadata_tokens, _authMetadata_tokens1;
        if (authMetadata === null) {
            return;
        }
        if (requireRoles && authMetadata.roles === void 0) {
            return;
        }
        if (requireAccessToken && !(authMetadata === null || authMetadata === void 0 ? void 0 : (_authMetadata_tokens = authMetadata.tokens) === null || _authMetadata_tokens === void 0 ? void 0 : _authMetadata_tokens.accessToken)) {
            return;
        }
        var missingFields = [];
        if (requireAccessToken && !(authMetadata === null || authMetadata === void 0 ? void 0 : (_authMetadata_tokens1 = authMetadata.tokens) === null || _authMetadata_tokens1 === void 0 ? void 0 : _authMetadata_tokens1.accessToken)) {
            missingFields.push("accessToken");
        }
        if (requireOrganisation && !(authMetadata === null || authMetadata === void 0 ? void 0 : authMetadata.organisation)) {
            missingFields.push("organisation");
        }
        if (requireRoles && (!(authMetadata === null || authMetadata === void 0 ? void 0 : authMetadata.roles) || authMetadata.roles.length === 0)) {
            missingFields.push("roles");
        }
        if (requireOrgBID && !(authMetadata === null || authMetadata === void 0 ? void 0 : authMetadata.orgBID)) {
            missingFields.push("orgBID");
        }
        if (missingFields.length > 0) {
            var timeoutId = setTimeout(function() {
                var _authMetadata_tokens;
                var stillMissing = [];
                if (requireAccessToken && !(authMetadata === null || authMetadata === void 0 ? void 0 : (_authMetadata_tokens = authMetadata.tokens) === null || _authMetadata_tokens === void 0 ? void 0 : _authMetadata_tokens.accessToken)) {
                    stillMissing.push("accessToken");
                }
                if (requireOrganisation && !(authMetadata === null || authMetadata === void 0 ? void 0 : authMetadata.organisation)) {
                    stillMissing.push("organisation");
                }
                if (requireRoles && (!(authMetadata === null || authMetadata === void 0 ? void 0 : authMetadata.roles) || authMetadata.roles.length === 0)) {
                    stillMissing.push("roles");
                }
                if (requireOrgBID && !(authMetadata === null || authMetadata === void 0 ? void 0 : authMetadata.orgBID)) {
                    stillMissing.push("orgBID");
                }
                if (stillMissing.length > 0) {
                    console.warn("Missing required authMetadata fields after restoration:", stillMissing);
                    onAuthError === null || onAuthError === void 0 ? void 0 : onAuthError(stillMissing);
                }
            }, 100);
            return function() {
                return clearTimeout(timeoutId);
            };
        }
    }, [
        authMetadata,
        requireAccessToken,
        requireOrganisation,
        requireRoles,
        requireOrgBID,
        onAuthError
    ]);
    if (authMetadata === null) {
        return false;
    }
    if (requireRoles && authMetadata.roles === void 0) {
        return false;
    }
    if (requireAccessToken && !(authMetadata === null || authMetadata === void 0 ? void 0 : (_authMetadata_tokens = authMetadata.tokens) === null || _authMetadata_tokens === void 0 ? void 0 : _authMetadata_tokens.accessToken)) {
        return false;
    }
    var hasAccessToken = !requireAccessToken || !!(authMetadata === null || authMetadata === void 0 ? void 0 : (_authMetadata_tokens1 = authMetadata.tokens) === null || _authMetadata_tokens1 === void 0 ? void 0 : _authMetadata_tokens1.accessToken);
    var hasOrganisation = !requireOrganisation || !!(authMetadata === null || authMetadata === void 0 ? void 0 : authMetadata.organisation);
    var hasRoles = !requireRoles || !!(authMetadata === null || authMetadata === void 0 ? void 0 : authMetadata.roles) && authMetadata.roles.length > 0;
    var hasOrgBID = !requireOrgBID || !!(authMetadata === null || authMetadata === void 0 ? void 0 : authMetadata.orgBID);
    return hasAccessToken && hasOrganisation && hasRoles && hasOrgBID;
};
// src/components/ManageUsers/ManageUsers.tsx
import { PersonAdd20Regular } from "@fluentui/react-icons";
import { getUsers } from "@repo/front-end-services";
import { jsx as jsx77, jsxs as jsxs51 } from "react/jsx-runtime";
var ManageUsers = function(param) {
    var className = param.className, middlewareApi = param.middlewareApi, onClose = param.onClose;
    var authMetadata = useUserStore9().authMetadata;
    var setDialogWidth = useDialogContext4().setDialogWidth;
    var queryClient2 = useQueryClient();
    var _useState31 = _sliced_to_array(useState31(false), 2), showAddUserForm = _useState31[0], setShowAddUserForm = _useState31[1];
    var _useState311 = _sliced_to_array(useState31(null), 2), editUserId = _useState311[0], setEditUserId = _useState311[1];
    var _useState312 = _sliced_to_array(useState31(null), 2), deleteUser2 = _useState312[0], setDeleteUser = _useState312[1];
    var _useState313 = _sliced_to_array(useState31(0), 2), page = _useState313[0], setPage = _useState313[1];
    var _useState314 = _sliced_to_array(useState31(10), 2), limit = _useState314[0], setLimit = _useState314[1];
    var _useState315 = _sliced_to_array(useState31(0), 1), totalPages = _useState315[0];
    var _useState316 = _sliced_to_array(useState31(""), 2), searchQuery = _useState316[0], setSearchQuery = _useState316[1];
    var _useDebounce = _sliced_to_array(useDebounce(searchQuery, 500), 1), debouncedQuery = _useDebounce[0];
    var isAuthMetadataReady = useRequireAuthMetadata({
        requireAccessToken: true,
        requireOrganisation: true,
        requireRoles: false,
        requireOrgBID: true
    });
    var changeLimit = function(newLimit) {
        setLimit(newLimit);
    };
    var switchPage = function(newPage) {
        setPage(newPage);
    };
    var fetchUsers = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(page2, limit2, debouncedQuery2) {
            var _authMetadata_tokens, users;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!((authMetadata === null || authMetadata === void 0 ? void 0 : (_authMetadata_tokens = authMetadata.tokens) === null || _authMetadata_tokens === void 0 ? void 0 : _authMetadata_tokens.accessToken) && authMetadata.organisation && authMetadata.orgBID)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            getUsers(middlewareApi, authMetadata.tokens.accessToken, "".concat(authMetadata.organisation, ":").concat(authMetadata.orgBID), page2, limit2, debouncedQuery2)
                        ];
                    case 1:
                        users = _state.sent().users;
                        return [
                            2,
                            users
                        ];
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchUsers(page2, limit2, debouncedQuery2) {
            return _ref.apply(this, arguments);
        };
    }();
    var _useQuery = useQuery({
        queryKey: [
            "users",
            page,
            limit,
            debouncedQuery
        ],
        queryFn: function() {
            return fetchUsers(page, limit, debouncedQuery);
        }
    }), data = _useQuery.data, isLoading = _useQuery.isLoading;
    if (!isAuthMetadataReady) {
        return null;
    }
    var handleShowAddUserForm = function() {
        setShowAddUserForm(true);
        setDialogWidth(void 0);
    };
    var handleCloseAddUserForm = function() {
        setShowAddUserForm(false);
        setDialogWidth("1100px");
    };
    var handleEditUser = function(userId) {
        setEditUserId(userId);
        setDialogWidth(void 0);
    };
    var handleCloseEditUserForm = function() {
        setEditUserId(null);
        setDialogWidth("1100px");
    };
    var handleDeleteUser = function(userId, userName) {
        setDeleteUser({
            userId: userId,
            userName: userName
        });
        setDialogWidth(void 0);
    };
    var handleCloseDeleteUser = function() {
        setDeleteUser(null);
        setDialogWidth("1100px");
    };
    var invalidateUsers = function() {
        queryClient2.invalidateQueries({
            queryKey: [
                "users"
            ]
        });
    };
    if (deleteUser2) {
        return /* @__PURE__ */ jsx77(DeleteUser_default, {
            middlewareApi: middlewareApi,
            userId: deleteUser2.userId,
            userName: deleteUser2.userName,
            onClose: handleCloseDeleteUser,
            onDeleted: invalidateUsers
        });
    }
    if (editUserId) {
        return /* @__PURE__ */ jsx77(EditUserForm_default, {
            middlewareApi: middlewareApi,
            userId: editUserId,
            onClose: handleCloseEditUserForm,
            onSuccess: invalidateUsers
        });
    }
    if (showAddUserForm) {
        return /* @__PURE__ */ jsx77(AddUserForm_default, {
            middlewareApi: middlewareApi,
            onClose: handleCloseAddUserForm,
            onSuccess: invalidateUsers
        });
    }
    return /* @__PURE__ */ jsxs51("div", {
        className: className,
        children: [
            /* @__PURE__ */ jsx77("div", {
                className: "header",
                children: /* @__PURE__ */ jsx77("h2", {
                    children: "Manage Users"
                })
            }),
            /* @__PURE__ */ jsxs51("div", {
                className: "controls",
                children: [
                    /* @__PURE__ */ jsxs51("button", {
                        type: "button",
                        className: "button",
                        onClick: handleShowAddUserForm,
                        children: [
                            /* @__PURE__ */ jsx77("span", {
                                className: "icon",
                                children: /* @__PURE__ */ jsx77(PersonAdd20Regular, {})
                            }),
                            "Add New User"
                        ]
                    }),
                    /* @__PURE__ */ jsx77(TLSearch_default, {
                        borderColor: "#cccccc",
                        isLoading: isLoading,
                        setSearchQuery: setSearchQuery
                    })
                ]
            }),
            /* @__PURE__ */ jsxs51("div", {
                className: "users-table",
                children: [
                    /* @__PURE__ */ jsx77(UsersTable_default, {
                        data: data,
                        onEditUser: handleEditUser,
                        onDeleteUser: handleDeleteUser
                    }),
                    /* @__PURE__ */ jsx77(Pagination_default, {
                        limit: limit,
                        currentPage: page,
                        totalPages: totalPages,
                        enableChangeLimit: false,
                        switchPage: switchPage,
                        changeLimit: changeLimit,
                        noMoreRecords: !data || data.length === 0 || data.length < limit
                    })
                ]
            }),
            /* @__PURE__ */ jsx77(SecondaryButton_default, {
                onClick: onClose,
                children: "Close"
            })
        ]
    });
};
var ManageUsers_default = styled56(ManageUsers)(_templateObject76());
// src/components/3DScene/ErrorBoundary.tsx
import { Component } from "react";
import { jsx as jsx78, jsxs as jsxs52 } from "react/jsx-runtime";
var ErrorBoundary = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(ErrorBoundary, Component);
    function ErrorBoundary(props) {
        _class_call_check(this, ErrorBoundary);
        var _this;
        _this = _call_super(this, ErrorBoundary, [
            props
        ]);
        _this.state = {
            hasError: false,
            errorMessage: ""
        };
        return _this;
    }
    _create_class(ErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("Error occurred within the ErrorBoundary", error, errorInfo);
                this.props.onError(error);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prev, prevState) {
                if (prevState.hasError && prev.resetKey !== this.props.resetKey) {
                    this.setState({
                        hasError: false,
                        errorMessage: ""
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                if (this.state.hasError) {
                    return /* @__PURE__ */ jsx78(FallbackUI, {
                        errorMessage: this.state.errorMessage
                    });
                }
                return this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    hasError: true,
                    errorMessage: error.message
                };
            }
        }
    ]);
    return ErrorBoundary;
}(Component);
function FallbackUI(param) {
    var errorMessage = param.errorMessage;
    return /* @__PURE__ */ jsxs52("div", {
        role: "alert",
        style: {
            position: "absolute",
            left: 0,
            right: 0,
            marginTop: "300px",
            marginBottom: "auto",
            marginLeft: "auto",
            marginRight: "auto",
            width: "300px"
        },
        children: [
            /* @__PURE__ */ jsx78("p", {
                children: "Something went wrong rendering the Twin in 3D"
            }),
            /* @__PURE__ */ jsx78("br", {}),
            /* @__PURE__ */ jsx78("p", {
                children: "Error message: "
            }),
            /* @__PURE__ */ jsx78("br", {}),
            /* @__PURE__ */ jsxs52("p", {
                children: [
                    " ",
                    errorMessage
                ]
            })
        ]
    });
}
// src/components/Timeline/Timeline.tsx
import { AppMode } from "@repo/frontend-types";
import React34, { useEffect as useEffect20, useRef as useRef11, useState as useState32 } from "react";
import { Timeline24Regular } from "@fluentui/react-icons";
import { useUserStore as useUserStore10, useSettingsStore as useSettingsStore2, useTimelineCalendarSyncStore as useTimelineCalendarSyncStore2, useTwinContext, useFilterContext, useModeContext } from "@repo/front-end-state";
import { generateTimeSlots } from "@repo/front-end-utils";
import { getTodaysDateRange } from "@repo/front-end-utils";
import { convertIntervalToNumber } from "@repo/front-end-utils";
import { convertUnixTimestampToDate } from "@repo/front-end-utils";
import { Fragment as Fragment16, jsx as jsx79, jsxs as jsxs53 } from "react/jsx-runtime";
var Timeline = function(param) {
    var className = param.className;
    var _settings_timeline, _settings_timeline1;
    var calendarDateTimeRange = useTimelineCalendarSyncStore2().calendarDateTimeRange;
    var _useFilterContext = useFilterContext(), heroMetric = _useFilterContext.heroMetric, setStartDateTime = _useFilterContext.setStartDateTime, setFinishDateTime = _useFilterContext.setFinishDateTime;
    var setAppModeWithFilterReset = useModeContext().setAppModeWithFilterReset;
    var settings = useSettingsStore2().settings;
    var twin = useTwinContext().twin;
    var authMetadata = useUserStore10().authMetadata;
    var _useState32 = _sliced_to_array(useState32(getTodaysDateRange()), 2), timelineDate = _useState32[0], setTimelineDate = _useState32[1];
    var _useState321 = _sliced_to_array(useState32((settings === null || settings === void 0 ? void 0 : (_settings_timeline = settings.timeline) === null || _settings_timeline === void 0 ? void 0 : _settings_timeline.interval) ? settings === null || settings === void 0 ? void 0 : (_settings_timeline1 = settings.timeline) === null || _settings_timeline1 === void 0 ? void 0 : _settings_timeline1.interval : "15m"), 1), interval = _useState321[0];
    var _useState322 = _sliced_to_array(useState32(), 2), timeline = _useState322[0], setTimeline = _useState322[1];
    var _useState323 = _sliced_to_array(useState32(null), 2), currentInterval = _useState323[0], setCurrentInterval = _useState323[1];
    var timelineRef = useRef11(null);
    var intervalRefs = useRef11([]);
    useEffect20(function() {
        if (calendarDateTimeRange) {
            setTimelineDate(calendarDateTimeRange);
        }
    }, [
        calendarDateTimeRange
    ]);
    useEffect20(function() {
        var fetchTimelineData = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function() {
                var _heroMetric_modes_AppMode_HISTORICAL, _heroMetric_modes, _settings_timeline, aggregation, data, processsed, timelineData, intervalIndex;
                return _ts_generator(this, function(_state) {
                    if (timelineDate.startDateTime && timelineDate.finishDateTime && settings && settings.organisation && authMetadata && heroMetric) {
                        ;
                        if (!authMetadata.tsdbUrl) {
                            throw new Error("Missing analytics endpoint");
                        }
                        aggregation = (_heroMetric_modes = heroMetric.modes) === null || _heroMetric_modes === void 0 ? void 0 : (_heroMetric_modes_AppMode_HISTORICAL = _heroMetric_modes[AppMode.HISTORICAL]) === null || _heroMetric_modes_AppMode_HISTORICAL === void 0 ? void 0 : _heroMetric_modes_AppMode_HISTORICAL.aggregation;
                        if (!aggregation) {
                            throw new Error("Hero metric aggregation is missing for Timeline");
                        }
                        data = [];
                        processsed = parseValues(data);
                        timelineData = generateTimeSlots(timelineDate.startDateTime, processsed, convertIntervalToNumber(interval), settings === null || settings === void 0 ? void 0 : (_settings_timeline = settings.timeline) === null || _settings_timeline === void 0 ? void 0 : _settings_timeline.hourRange);
                        intervalIndex = timelineData.findIndex(function(interval2) {
                            return interval2.showIndicator === true;
                        });
                        setTimeline(timelineData);
                        setCurrentInterval(intervalIndex);
                    } else {
                        throw new Error("Unable to retrieve timeline data due to a missing start/finish date time");
                    }
                    return [
                        2
                    ];
                });
            });
            return function fetchTimelineData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchTimelineData();
    }, [
        interval,
        settings,
        timelineDate
    ]);
    var parseValues = function(data) {
        var processed = [];
        data.forEach(function(r) {
            r.values.forEach(function(v) {
                var pr = {
                    dateTime: convertUnixTimestampToDate(v[0]),
                    value: Math.round(parseFloat(v[1]))
                };
                processed.push(pr);
            });
        });
        return processed;
    };
    var applyIndicatorLineHeight = function(value) {
        if (value === 0) {
            return "8px";
        } else if (value >= 1 && value <= 25) {
            return "12px";
        } else if (value >= 26 && value <= 50) {
            return "16px";
        } else if (value >= 51 && value <= 100) {
            return "24px";
        } else if (value > 100) {
            return "30px";
        }
        return "8px";
    };
    useEffect20(function() {
        if (currentInterval) {
            if (intervalRefs.current && intervalRefs.current[currentInterval]) {
                var selectedInterval = intervalRefs.current[currentInterval];
                var timeline2 = timelineRef.current;
                if (timeline2 && selectedInterval) {
                    var scrollPosition = selectedInterval.offsetLeft - timeline2.offsetWidth / 2 + selectedInterval.offsetWidth / 2;
                    timeline2.scrollTo({
                        left: scrollPosition,
                        behavior: "smooth"
                    });
                }
            }
        }
    }, [
        currentInterval
    ]);
    return /* @__PURE__ */ jsx79("div", {
        className: className,
        children: /* @__PURE__ */ jsx79(Panel_default, {
            id: "timeline",
            icon: /* @__PURE__ */ jsx79(Timeline24Regular, {}),
            title: "Timeline",
            children: timeline ? /* @__PURE__ */ jsxs53(Fragment16, {
                children: [
                    timelineDate.startDateTime ? /* @__PURE__ */ jsx79(DayStepper_default, {
                        currentDateTimeISO: timelineDate.startDateTime,
                        setTimelineDate: setTimelineDate
                    }) : null,
                    /* @__PURE__ */ jsxs53("div", {
                        ref: timelineRef,
                        style: {
                            minHeight: "60px",
                            overflowX: "scroll"
                        },
                        children: [
                            /* @__PURE__ */ jsx79("div", {
                                style: {
                                    display: "flex"
                                },
                                children: timeline.map(function(interval2, i) {
                                    return /* @__PURE__ */ jsx79(React34.Fragment, {
                                        children: interval2.isOnHour && /* @__PURE__ */ jsx79("div", {
                                            style: {
                                                fontSize: "10px",
                                                lineHeight: "14px",
                                                fontWeight: "bold",
                                                minWidth: "32px",
                                                height: "24px",
                                                paddingTop: "10px"
                                            },
                                            children: interval2.text
                                        })
                                    }, i);
                                })
                            }),
                            /* @__PURE__ */ jsx79("div", {
                                style: {
                                    display: "flex",
                                    alignItems: "flex-end",
                                    position: "relative"
                                },
                                children: timeline.map(function(interval2, i) {
                                    var twinCapacity = (twin === null || twin === void 0 ? void 0 : twin.totalCapacity) ? twin === null || twin === void 0 ? void 0 : twin.totalCapacity : 0;
                                    return /* @__PURE__ */ jsxs53("div", {
                                        className: "".concat(i),
                                        style: {
                                            position: "relative",
                                            paddingTop: "8px"
                                        },
                                        ref: function(div) {
                                            intervalRefs.current[i] = div;
                                        },
                                        children: [
                                            /* @__PURE__ */ jsx79(TimelineIndicator_default, {
                                                show: interval2.showIndicator
                                            }),
                                            /* @__PURE__ */ jsx79("button", {
                                                onClick: function() {
                                                    if (timelineDate.startDateTime && timelineDate.finishDateTime) {
                                                        var _timelineDate_startDateTime, _timelineDate_finishDateTime;
                                                        var startTime = interval2.value.split("-")[0];
                                                        var finishTime = interval2.value.split("-")[1];
                                                        var selectedStartDateTime = (_timelineDate_startDateTime = timelineDate.startDateTime) === null || _timelineDate_startDateTime === void 0 ? void 0 : _timelineDate_startDateTime.replace("T00:00:00", "T".concat(startTime, ":00"));
                                                        var selectedFinishDateTime = (_timelineDate_finishDateTime = timelineDate.finishDateTime) === null || _timelineDate_finishDateTime === void 0 ? void 0 : _timelineDate_finishDateTime.replace("T23:59:59", "T".concat(finishTime, ":00"));
                                                        setAppModeWithFilterReset(AppMode.HISTORICAL);
                                                        setStartDateTime(selectedStartDateTime);
                                                        setFinishDateTime(selectedFinishDateTime);
                                                    }
                                                },
                                                style: {
                                                    //TODO: backgroundColor: interval.count ? getIndicator(interval.count, twinCapacity, settings?.rangeMapping).color : getIndicator(interval.count, twinCapacity, settings?.rangeMapping).color,
                                                    backgroundColor: "pink",
                                                    height: interval2.count ? applyIndicatorLineHeight(interval2.count) : applyIndicatorLineHeight(0),
                                                    minWidth: "2px",
                                                    marginRight: "6px",
                                                    borderRadius: "1px 1px 0 0"
                                                },
                                                id: interval2.value
                                            })
                                        ]
                                    }, i);
                                })
                            })
                        ]
                    })
                ]
            }) : /* @__PURE__ */ jsx79(TLSpinner_default, {})
        })
    });
};
var Timeline_default = Timeline;
// src/components/AI/AI.tsx
import { useEffect as useEffect22, useState as useState34 } from "react";
import styled58 from "styled-components";
import { entitySelectionPrompts } from "@repo/front-end-data";
import { useUserStore as useUserStore12 } from "@repo/front-end-state";
// src/components/AI/AIPrompt.tsx
import { useEffect as useEffect21, useRef as useRef12, useState as useState33 } from "react";
import { useForm as useForm5 } from "react-hook-form";
import { yupResolver as yupResolver5 } from "@hookform/resolvers/yup";
import * as yup5 from "yup";
import axios from "axios";
import styled57 from "styled-components";
import { useUserStore as useUserStore11, useTwinContext as useTwinContext2 } from "@repo/front-end-state";
import Square from "@repo/assets/react/icons/Square";
import ArrowUp from "@repo/assets/react/icons/ArrowUp";
// src/components/AI/parseChatEntities.ts
function parseChatEntities(raw) {
    if (!Array.isArray(raw)) return [];
    var result = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = raw[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            if ((typeof item === "undefined" ? "undefined" : _type_of(item)) !== "object" || item === null) continue;
            var entry = item;
            if (typeof entry.name !== "string" || typeof entry.bid !== "string") continue;
            var name = entry.name.trim();
            var bid = entry.bid.trim();
            if (name.length === 0 || bid.length === 0) continue;
            result.push({
                name: name,
                bid: bid
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return result;
}
// src/components/AI/AIPrompt.tsx
import { jsx as jsx80, jsxs as jsxs54 } from "react/jsx-runtime";
var formSchema5 = {
    message: yup5.string().required("Sorry, I didn't catch your message")
};
var AIPrompt = function(param) {
    var className = param.className, sessionId = param.sessionId, apiEndpoint = param.apiEndpoint, apiKey = param.apiKey, triggerPrompt = param.triggerPrompt, addMessage = param.addMessage, setAwaitingMessage = param.setAwaitingMessage;
    var authMetadata = useUserStore11().authMetadata;
    var twinBId = useTwinContext2().twinBId;
    var _useForm5 = useForm5({
        resolver: yupResolver5(yup5.object(formSchema5))
    }), register = _useForm5.register, handleSubmit = _useForm5.handleSubmit, setValue = _useForm5.setValue, watch = _useForm5.watch;
    var _useState33 = _sliced_to_array(useState33(false), 2), isGenerating = _useState33[0], setIsGenerating = _useState33[1];
    var abortControllerRef = useRef12(null);
    var clearPromptInput = function() {
        setValue("message", "");
    };
    var message = watch("message", "");
    var askAIQuestion = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(apiEndpoint2, userPrompt, apiKey2) {
            var _authMetadata_tokens, signal, headers;
            return _ts_generator(this, function(_state) {
                setAwaitingMessage(true);
                setIsGenerating(true);
                abortControllerRef.current = new AbortController();
                signal = abortControllerRef.current.signal;
                if (!apiEndpoint2) {
                    console.warn("[AIPrompt] apiEndpoint is empty \u2014 MariaConfigStore was not initialised.", {
                        orgBID: authMetadata === null || authMetadata === void 0 ? void 0 : authMetadata.orgBID,
                        organisation: authMetadata === null || authMetadata === void 0 ? void 0 : authMetadata.organisation,
                        twinBId: twinBId
                    });
                    addMessage({
                        content: "Sorry, I cannot answer. You need to ensure your API URL is correct.",
                        response: true,
                        prompts: []
                    });
                    setAwaitingMessage(false);
                    setIsGenerating(false);
                    return [
                        2
                    ];
                }
                headers = {
                    "Content-Type": "application/json",
                    Authorization: "Bearer ".concat(authMetadata === null || authMetadata === void 0 ? void 0 : (_authMetadata_tokens = authMetadata.tokens) === null || _authMetadata_tokens === void 0 ? void 0 : _authMetadata_tokens.accessToken)
                };
                axios.post(apiEndpoint2, {
                    question: userPrompt,
                    organisation: authMetadata === null || authMetadata === void 0 ? void 0 : authMetadata.organisation,
                    organisation_bid: authMetadata === null || authMetadata === void 0 ? void 0 : authMetadata.orgBID,
                    root_entity_bid: twinBId,
                    session_id: sessionId
                }, {
                    headers: headers,
                    signal: signal,
                    timeout: 12e4
                }).then(function(response) {
                    var _response_data_machine;
                    var uiResponse = "";
                    var chartElement;
                    var suggestedPrompts = [];
                    if (response.data.response) {
                        var _response_data_machine1;
                        uiResponse = response.data.response;
                        var chartImage = (_response_data_machine1 = response.data.machine) === null || _response_data_machine1 === void 0 ? void 0 : _response_data_machine1.chart_image;
                        if (chartImage === null || chartImage === void 0 ? void 0 : chartImage.data) {
                            var ALLOWED_IMAGE_MIME_TYPES = [
                                "image/png",
                                "image/jpeg",
                                "image/webp"
                            ];
                            var mimeType = chartImage.mime_type && ALLOWED_IMAGE_MIME_TYPES.includes(chartImage.mime_type) ? chartImage.mime_type : "image/png";
                            chartElement = /* @__PURE__ */ jsx80("img", {
                                src: "data:".concat(mimeType, ";base64,").concat(chartImage.data),
                                alt: chartImage.alt_text || "Chart generated by Maria",
                                style: {
                                    display: "block",
                                    maxWidth: "800px",
                                    width: "100%",
                                    height: "auto",
                                    marginTop: "1.25em"
                                }
                            });
                        }
                    }
                    var _response_data_run_id;
                    addMessage({
                        content: uiResponse,
                        response: true,
                        chart: chartElement,
                        prompts: suggestedPrompts,
                        entities: parseChatEntities((_response_data_machine = response.data.machine) === null || _response_data_machine === void 0 ? void 0 : _response_data_machine.entities),
                        runId: (_response_data_run_id = response.data.run_id) !== null && _response_data_run_id !== void 0 ? _response_data_run_id : void 0
                    });
                }).catch(function(error) {
                    if (axios.isCancel(error)) {
                        addMessage({
                            content: "",
                            prompts: [],
                            response: true
                        });
                    } else {
                        var errorContent;
                        if (authMetadata === null || authMetadata === void 0 ? void 0 : authMetadata.developerMode) {
                            if (error.response && error.response.data && Array.isArray(error.response.data.errors)) {
                                var errors = error.response.data.errors;
                                var errorCount = errors.length;
                                if (errorCount > 0) {
                                    addMessage({
                                        content: "<strong>".concat(errorCount, " error").concat(errorCount > 1 ? "s</strong> have" : "</strong> has", " been reported from the API. <strong>Session ID:</strong> ").concat(sessionId),
                                        prompts: [],
                                        response: true,
                                        error: true
                                    });
                                }
                                errors.forEach(function(e) {
                                    errorContent = "<strong>Code:</strong> ".concat(e.code, "<br />");
                                    errorContent = errorContent + "<strong>Message:</strong> ".concat(e.message, "<br />");
                                    errorContent = errorContent + "<strong>Technical Message:</strong> ".concat(e.technicalMessage);
                                    addMessage({
                                        content: errorContent,
                                        prompts: [],
                                        response: true,
                                        error: true
                                    });
                                });
                            } else if (error.message) {
                                errorContent = error.message;
                                addMessage({
                                    content: errorContent,
                                    prompts: [],
                                    response: true,
                                    error: true
                                });
                            }
                        } else {
                            errorContent = "Something went wrong. Please try asking again.";
                            addMessage({
                                content: errorContent,
                                prompts: [],
                                response: true
                            });
                        }
                    }
                }).finally(function() {
                    setAwaitingMessage(false);
                    setIsGenerating(false);
                });
                return [
                    2
                ];
            });
        });
        return function askAIQuestion(apiEndpoint2, userPrompt, apiKey2) {
            return _ref.apply(this, arguments);
        };
    }();
    useEffect21(function() {
        var sendMessage = function sendMessage(triggerPrompt2) {
            return _sendMessage.apply(this, arguments);
        };
        function _sendMessage() {
            _sendMessage = _async_to_generator(function(triggerPrompt2) {
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                askAIQuestion(apiEndpoint, triggerPrompt2, apiKey)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return _sendMessage.apply(this, arguments);
        }
        if (triggerPrompt) {
            sendMessage(triggerPrompt);
        }
    }, []);
    var onSubmit = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(formData) {
            var userPrompt;
            return _ts_generator(this, function(_state) {
                userPrompt = formData.message;
                clearPromptInput();
                submitMessage({
                    content: userPrompt,
                    response: false,
                    prompts: []
                });
                return [
                    2
                ];
            });
        });
        return function onSubmit(formData) {
            return _ref.apply(this, arguments);
        };
    }();
    var submitMessage = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(message2) {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        addMessage(message2);
                        return [
                            4,
                            askAIQuestion(apiEndpoint, message2.content, apiKey)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function submitMessage(message2) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancelRequest = function() {
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }
    };
    return /* @__PURE__ */ jsx80("div", {
        className: className,
        children: /* @__PURE__ */ jsxs54("form", {
            onSubmit: handleSubmit(onSubmit),
            children: [
                /* @__PURE__ */ jsx80(TLPromptInput_default, {
                    props: _object_spread({
                        placeholder: "Type here. 0/500",
                        type: "text"
                    }, register("message"))
                }),
                !isGenerating && /* @__PURE__ */ jsx80("button", {
                    className: "submit-button",
                    type: "submit",
                    disabled: !message,
                    children: /* @__PURE__ */ jsx80(ArrowUp, {})
                }),
                isGenerating && /* @__PURE__ */ jsx80("button", {
                    className: "cancel-button",
                    onClick: handleCancelRequest,
                    children: /* @__PURE__ */ jsx80(Square, {})
                })
            ]
        })
    });
};
var AIPrompt_default = styled57(AIPrompt)(_templateObject77());
// src/components/AI/sendFeedback.ts
import axios2 from "axios";
var sendFeedback = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(param) {
        var apiEndpoint, accessToken, payload, error;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    apiEndpoint = param.apiEndpoint, accessToken = param.accessToken, payload = param.payload;
                    if (!accessToken) {
                        console.warn("[sendFeedback] No access token available; feedback not sent.");
                        return [
                            2
                        ];
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        axios2.post("".concat(apiEndpoint, "/feedback"), payload, {
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: "Bearer ".concat(accessToken)
                            }
                        })
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    console.warn("[sendFeedback] Failed to send feedback:", error);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function sendFeedback(_) {
        return _ref.apply(this, arguments);
    };
}();
// src/components/AI/AI.tsx
import { Scrollbar as Scrollbar2 } from "@repo/design-system";
import { jsx as jsx81, jsxs as jsxs55 } from "react/jsx-runtime";
var AI = function(param) {
    var className = param.className, openingMessage = param.openingMessage, filter = param.filter, apiEndpoint = param.apiEndpoint, apiKey = param.apiKey, dynamicHeight = param.dynamicHeight, maxHeight = param.maxHeight;
    var authMetadata = useUserStore12().authMetadata;
    var _useState34 = _sliced_to_array(useState34(""), 2), sessionId = _useState34[0], setSessionId = _useState34[1];
    var _useState341 = _sliced_to_array(useState34(false), 2), awaitingMessage = _useState341[0], setAwaitingMessage = _useState341[1];
    var _useState342 = _sliced_to_array(useState34(), 2), triggerPrompt = _useState342[0], setTriggerPrompt = _useState342[1];
    var _useState343 = _sliced_to_array(useState34(openingMessage ? [
        openingMessage
    ] : []), 2), messages = _useState343[0], setMessages = _useState343[1];
    var addMessage = function(newMessage) {
        setTriggerPrompt(void 0);
        setMessages(function(prevMessages) {
            return _to_consumable_array(prevMessages).concat([
                newMessage
            ]);
        });
        if (newMessage.triggerPrompt) {
            setTriggerPrompt(newMessage.content);
        }
    };
    var addFeedback = function(messageIndex, feedback) {
        var _messages_messageIndex;
        setMessages(function(prevMessages) {
            return prevMessages.map(function(message, index) {
                return index === messageIndex ? _object_spread_props(_object_spread({}, message), {
                    feedback: feedback
                }) : message;
            });
        });
        var runId = (_messages_messageIndex = messages[messageIndex]) === null || _messages_messageIndex === void 0 ? void 0 : _messages_messageIndex.runId;
        var orgBID = authMetadata === null || authMetadata === void 0 ? void 0 : authMetadata.orgBID;
        if (runId && orgBID) {
            var _authMetadata_tokens;
            void sendFeedback({
                apiEndpoint: apiEndpoint,
                accessToken: authMetadata === null || authMetadata === void 0 ? void 0 : (_authMetadata_tokens = authMetadata.tokens) === null || _authMetadata_tokens === void 0 ? void 0 : _authMetadata_tokens.accessToken,
                payload: {
                    run_id: runId,
                    session_id: sessionId,
                    organisation_bid: orgBID,
                    feedback: feedback
                }
            });
        } else if (runId) {
            console.warn("[sendFeedback] No organisation BID available; feedback not sent.");
        }
    };
    var clearMessages = function() {
        setMessages([]);
    };
    useEffect22(function() {
        setSessionId(crypto.randomUUID());
        if (filter && filter.length > 0) {
            var lastEntity = "";
            var entities = filter.filter(function(fp) {
                return fp.type === 0;
            });
            if (entities && entities.length > 0) {
                entities.forEach(function(f) {
                    lastEntity = f.label;
                });
                var prompts = [];
                entitySelectionPrompts.forEach(function(pgp) {
                    var content = pgp.content.replaceAll("{ENTITY}", lastEntity);
                    prompts.push({
                        title: content,
                        prompt: content
                    });
                });
                addMessage({
                    content: "I've spotted you've selected the <strong>".concat(lastEntity, "</strong>; here are some options:"),
                    response: true,
                    prompts: prompts
                });
            }
        }
    }, [
        filter
    ]);
    return /* @__PURE__ */ jsxs55("div", {
        className: className,
        children: [
            /* @__PURE__ */ jsx81(Scrollbar2, {
                maxHeight: maxHeight || "calc(100vh - 300px)",
                dynamicHeight: dynamicHeight,
                right: -30,
                contentUpdated: messages.length,
                children: /* @__PURE__ */ jsx81(AIConversation_default, {
                    conversation: messages,
                    awaitingMessage: awaitingMessage,
                    addMessage: addMessage,
                    addFeedback: addFeedback,
                    clearMessages: clearMessages
                })
            }),
            /* @__PURE__ */ jsx81(AIPrompt_default, {
                setAwaitingMessage: setAwaitingMessage,
                addMessage: addMessage,
                sessionId: sessionId,
                triggerPrompt: triggerPrompt,
                apiEndpoint: apiEndpoint,
                apiKey: apiKey
            }),
            /* @__PURE__ */ jsx81("p", {
                className: "ai-disclaimer",
                children: "Maria is an AI and can make mistakes. Please double check responses."
            })
        ]
    });
};
var AI_default = styled58(AI)(_templateObject78());
// src/components/Maria/Maria.tsx
import { useState as useState35 } from "react";
import { useAuth0 as useAuth03 } from "@auth0/auth0-react";
import { useUserStore as useUserStore13, useSettingsStore as useSettingsStore3, useMariaConfigStore } from "@repo/front-end-state";
import { capitaliseFirstLetter } from "@repo/front-end-utils";
// src/components/Maria/MariaHeader.tsx
import styled59 from "styled-components";
import { Dismiss16Regular as Dismiss16Regular2 } from "@fluentui/react-icons";
import MariaIconDarkGrey from "@repo/assets/react/icons/MariaIconDarkGrey";
import { jsx as jsx82, jsxs as jsxs56 } from "react/jsx-runtime";
var MariaHeader = function(param) {
    var className = param.className, setIsHeaderHovered = param.setIsHeaderHovered, setSupportCopilotVisible = param.setSupportCopilotVisible, onMouseDown = param.onMouseDown, onPointerDown = param.onPointerDown;
    return /* @__PURE__ */ jsx82("div", {
        className: className,
        children: /* @__PURE__ */ jsxs56("div", {
            className: "maria-header",
            onMouseEnter: function() {
                return setIsHeaderHovered(true);
            },
            onMouseLeave: function() {
                return setIsHeaderHovered(false);
            },
            onMouseDown: onMouseDown,
            onPointerDown: onPointerDown,
            children: [
                /* @__PURE__ */ jsxs56("div", {
                    className: "maria-header-title",
                    children: [
                        /* @__PURE__ */ jsx82("div", {
                            className: "avatar",
                            children: /* @__PURE__ */ jsx82(MariaIconDarkGrey, {})
                        }),
                        /* @__PURE__ */ jsx82(Subtitle_default, {
                            m: "auto",
                            children: "Maria"
                        })
                    ]
                }),
                /* @__PURE__ */ jsx82("button", {
                    className: "close-button",
                    onClick: function() {
                        return setSupportCopilotVisible(false);
                    },
                    children: /* @__PURE__ */ jsx82(Dismiss16Regular2, {})
                })
            ]
        })
    });
};
var MariaHeader_default = styled59(MariaHeader)(_templateObject79());
// src/components/Maria/Maria.tsx
import { jsx as jsx83 } from "react/jsx-runtime";
var Maria = function(param) {
    var setSupportCopilotVisible = param.setSupportCopilotVisible;
    var _authMetadata_tokens, _user_name, _user_name1, _settings_maria, _settings_maria1, _settings_maria2;
    var user = useAuth03().user;
    var settings = useSettingsStore3().settings;
    var authMetadata = useUserStore13().authMetadata;
    var aiUrl = useMariaConfigStore().aiUrl;
    var _useState35 = _sliced_to_array(useState35(false), 2), isHeaderHovered = _useState35[0], setIsHeaderHovered = _useState35[1];
    return /* @__PURE__ */ jsx83(DraggablePanel_default, {
        headerElement: /* @__PURE__ */ jsx83(MariaHeader_default, {
            setIsHeaderHovered: setIsHeaderHovered,
            setSupportCopilotVisible: setSupportCopilotVisible
        }),
        isHeaderHovered: isHeaderHovered,
        children: /* @__PURE__ */ jsx83(AI_default, {
            apiEndpoint: aiUrl,
            apiKey: authMetadata === null || authMetadata === void 0 ? void 0 : (_authMetadata_tokens = authMetadata.tokens) === null || _authMetadata_tokens === void 0 ? void 0 : _authMetadata_tokens.accessToken,
            openingMessage: {
                content: "Hello ".concat((user === null || user === void 0 ? void 0 : (_user_name = user.name) === null || _user_name === void 0 ? void 0 : _user_name.split(" ")[0]) ? "".concat(capitaliseFirstLetter(user === null || user === void 0 ? void 0 : (_user_name1 = user.name) === null || _user_name1 === void 0 ? void 0 : _user_name1.split(" ")[0]), ",") : ",", " my name is Maria. Ask me about the app, explore your data, or request analysis — I'm here to help.").concat((settings === null || settings === void 0 ? void 0 : (_settings_maria = settings.maria) === null || _settings_maria === void 0 ? void 0 : _settings_maria.introPrompts) && (settings === null || settings === void 0 ? void 0 : (_settings_maria1 = settings.maria) === null || _settings_maria1 === void 0 ? void 0 : _settings_maria1.introPrompts.length) > 0 ? " Or use the ideas below to get started." : ""),
                response: true,
                prompts: settings === null || settings === void 0 ? void 0 : (_settings_maria2 = settings.maria) === null || _settings_maria2 === void 0 ? void 0 : _settings_maria2.introPrompts
            },
            maxHeight: "calc(100vh - 210px)",
            dynamicHeight: true
        })
    });
};
var Maria_default = Maria;
// src/components/Onboarding/OnboardingPanel.tsx
import { useCallback as useCallback4, useEffect as useEffect24, useLayoutEffect as useLayoutEffect3, useMemo as useMemo4, useRef as useRef13, useState as useState37 } from "react";
import styled60 from "styled-components";
import { useFilterContext as useFilterContext2, useModeContext as useModeContext2 } from "@repo/front-end-state";
import { setCookie } from "@repo/front-end-utils";
import GlassPin from "@repo/assets/react/icons/GlassPin";
import { Dismiss16Regular as Dismiss16Regular3 } from "@fluentui/react-icons";
import { PanelAnchorPos } from "@repo/frontend-types";
// src/hooks/useStepValidation.tsx
import { AppMode as AppMode2, TimeUnit } from "@repo/frontend-types";
import { useState as useState36, useEffect as useEffect23 } from "react";
import { hasCalendarBeenUsed } from "@repo/front-end-utils";
var useStepValidation = function(currentStep, dependencies) {
    var _useState36 = _sliced_to_array(useState36(true), 2), isNextButtonEnabled = _useState36[0], setIsNextButtonEnabled = _useState36[1];
    var appMode = dependencies.appMode, calendarView = dependencies.calendarView, startDateTime = dependencies.startDateTime, finishDateTime = dependencies.finishDateTime;
    useEffect23(function() {
        switch(currentStep){
            case 6:
                setIsNextButtonEnabled(appMode === AppMode2.HISTORICAL);
                break;
            case 7:
                var hasUsedCalendar = Boolean(startDateTime && finishDateTime && hasCalendarBeenUsed(startDateTime, finishDateTime));
                setIsNextButtonEnabled(hasUsedCalendar);
                break;
            case 8:
                setIsNextButtonEnabled(calendarView === TimeUnit.MONTH);
                break;
            default:
                setIsNextButtonEnabled(true);
                break;
        }
    }, [
        currentStep,
        appMode,
        calendarView,
        startDateTime,
        finishDateTime
    ]);
    return isNextButtonEnabled;
};
// src/components/Onboarding/OnboardingPanel.tsx
import { useDebounce as useDebounce2 } from "use-debounce";
import { jsx as jsx84, jsxs as jsxs57 } from "react/jsx-runtime";
var OnboardingPanel = function(param) {
    var className = param.className, header = param.header, copy = param.copy, pointerPos = param.pointerPos, currentStep = param.currentStep, totalSteps = param.totalSteps, anchorPos = param.anchorPos, posX = param.posX, posY = param.posY, setCurrentStep = param.setCurrentStep, onComplete = param.onComplete, _param_cookieKey = param.cookieKey, cookieKey = _param_cookieKey === void 0 ? "hasSeenTutorial" : _param_cookieKey, nextEnabledOverride = param.nextEnabledOverride, targetSelector = param.targetSelector, _param_placement = param.placement, placement = _param_placement === void 0 ? "bottom" : _param_placement;
    var PANEL_WIDTH = 364;
    var FADE_TRANSITION_TIME = 500;
    var _useState37 = _sliced_to_array(useState37(false), 2), isTransitioning = _useState37[0], setIsTransitioning = _useState37[1];
    var _useState371 = _sliced_to_array(useState37("fade-in" /* IN */ ), 2), fade = _useState371[0], setFade = _useState371[1];
    var _useModeContext2 = useModeContext2(), appMode = _useModeContext2.appMode, calendarView = _useModeContext2.calendarView;
    var _useFilterContext2 = useFilterContext2(), startDateTime = _useFilterContext2.startDateTime, finishDateTime = _useFilterContext2.finishDateTime;
    var changeStep = useCallback4(function(nextStep) {
        if (isTransitioning) return;
        setIsTransitioning(true);
        setFade("fade-out" /* OUT */ );
        setTimeout(function() {
            setCurrentStep(nextStep);
            requestAnimationFrame(function() {
                setTimeout(function() {
                    setFade("fade-in" /* IN */ );
                    setTimeout(function() {
                        setIsTransitioning(false);
                    }, 50);
                }, 50);
            });
        }, FADE_TRANSITION_TIME);
    }, [
        isTransitioning,
        setCurrentStep,
        FADE_TRANSITION_TIME
    ]);
    var _useState372 = _sliced_to_array(useState37({
        display: "none",
        top: "0",
        left: "0"
    }), 2), position = _useState372[0], setPosition = _useState372[1];
    var internalNextEnabled = useStepValidation(currentStep, {
        appMode: appMode,
        calendarView: calendarView,
        startDateTime: startDateTime,
        finishDateTime: finishDateTime
    });
    var nextButtonEnabled = nextEnabledOverride !== null && nextEnabledOverride !== void 0 ? nextEnabledOverride : internalNextEnabled;
    var sourceRef = useRef13(null);
    var _useState373 = _sliced_to_array(useState37(0), 2), cardHeight = _useState373[0], setCardHeight = _useState373[1];
    var completeTutorial = useCallback4(function() {
        setCookie(cookieKey, "true");
        onComplete && onComplete();
    }, [
        onComplete,
        cookieKey
    ]);
    useEffect24(function() {
        if (!sourceRef.current) return;
        var updateHeight = function() {
            if (!sourceRef.current) return;
            var height2 = sourceRef.current.offsetHeight;
            if (height2) {
                setCardHeight(height2 + 100);
            }
        };
        updateHeight();
        var resizeObserver = new ResizeObserver(updateHeight);
        resizeObserver.observe(sourceRef.current);
        return function() {
            return resizeObserver.disconnect();
        };
    }, [
        currentStep
    ]);
    var getAnchorPos = useMemo4(function() {
        return function(anchorPos2, posX2, posY2, viewportWidth, viewportHeight) {
            var anchorPosX = 0;
            var anchorPosY = 0;
            switch(anchorPos2){
                case PanelAnchorPos.TOP_LEFT:
                    anchorPosX = 0;
                    anchorPosY = 0;
                    break;
                case PanelAnchorPos.TOP_CENTRE:
                    anchorPosX = viewportWidth / 2 - PANEL_WIDTH / 2;
                    anchorPosY = 0;
                    break;
                case PanelAnchorPos.TOP_RIGHT:
                    anchorPosX = viewportWidth - PANEL_WIDTH;
                    anchorPosY = 0;
                    break;
                case PanelAnchorPos.CENTRE:
                    anchorPosX = viewportWidth / 2;
                    anchorPosY = viewportHeight / 2;
                    break;
                case PanelAnchorPos.CENTRE_LEFT:
                    anchorPosX = 0;
                    anchorPosY = viewportHeight / 2;
                    break;
                case PanelAnchorPos.CENTRE_RIGHT:
                    anchorPosX = viewportWidth - PANEL_WIDTH;
                    anchorPosY = 0;
                    break;
                case PanelAnchorPos.BOTTOM_LEFT:
                    anchorPosX = 0;
                    anchorPosY = viewportHeight;
                    break;
                case PanelAnchorPos.BOTTOM_CENTRE:
                    anchorPosX = viewportWidth / 2 - PANEL_WIDTH / 2;
                    anchorPosY = viewportHeight;
                    break;
                case PanelAnchorPos.BOTTOM_RIGHT:
                    anchorPosX = viewportWidth - PANEL_WIDTH;
                    anchorPosY = viewportHeight;
                    break;
                default:
                    anchorPosX = 0;
                    anchorPosY = 0;
                    break;
            }
            return {
                x: anchorPosX + posX2,
                y: anchorPosY + posY2
            };
        };
    }, [
        PANEL_WIDTH
    ]);
    var calculatePosition = useCallback4(function() {
        if (isTransitioning) return;
        try {
            var viewportWidth = window.innerWidth;
            var viewportHeight = window.innerHeight;
            if (targetSelector) {
                var el = document.querySelector(targetSelector);
                if (el) {
                    var r = el.getBoundingClientRect();
                    var GAP = 12;
                    var top;
                    var left2;
                    if (placement === "top") {
                        top = r.top - cardHeight - GAP;
                        left2 = r.left + r.width / 2 - PANEL_WIDTH / 2;
                    } else if (placement === "left") {
                        top = r.top + r.height / 2 - cardHeight / 2;
                        left2 = r.left - PANEL_WIDTH - GAP;
                    } else if (placement === "right") {
                        top = r.top + r.height / 2 - cardHeight / 2;
                        left2 = r.right + GAP;
                    } else {
                        top = r.bottom + GAP;
                        left2 = r.left + r.width / 2 - PANEL_WIDTH / 2;
                    }
                    left2 = Math.max(8, Math.min(left2, viewportWidth - PANEL_WIDTH - 8));
                    top = Math.max(8, Math.min(top, viewportHeight - 80));
                    setPosition({
                        display: "block",
                        top: "".concat(top, "px"),
                        left: "".concat(left2, "px")
                    });
                    return;
                }
            }
            var calcPos = getAnchorPos(anchorPos, posX, posY, viewportWidth, viewportHeight);
            setPosition({
                display: "block",
                top: "".concat(calcPos.y, "px"),
                left: "".concat(calcPos.x, "px")
            });
        } catch (error) {
            console.error("Error calculating position:", error);
        }
    }, [
        targetSelector,
        placement,
        cardHeight,
        anchorPos,
        posX,
        posY,
        getAnchorPos,
        isTransitioning
    ]);
    var _useDebounce2 = _sliced_to_array(useDebounce2(calculatePosition, 100), 1), debouncedCalculatePosition = _useDebounce2[0];
    useEffect24(function() {
        if (!targetSelector) return;
        var id = setInterval(calculatePosition, 200);
        return function() {
            return clearInterval(id);
        };
    }, [
        targetSelector,
        calculatePosition
    ]);
    useEffect24(function() {
        var handleKeyDown = function(e) {
            if (e.key === "Escape") {
                completeTutorial();
            } else if (e.key === "ArrowRight" && nextButtonEnabled && currentStep + 1 < totalSteps && !isTransitioning) {
                changeStep(currentStep + 1);
            } else if (e.key === "ArrowLeft" && currentStep > 0 && !isTransitioning) {
                changeStep(currentStep - 1);
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return function() {
            return window.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        currentStep,
        totalSteps,
        nextButtonEnabled,
        completeTutorial,
        changeStep,
        isTransitioning
    ]);
    useLayoutEffect3(function() {
        if (cardHeight > 0 && !isTransitioning) {
            calculatePosition();
        }
    }, [
        cardHeight,
        currentStep,
        calculatePosition,
        isTransitioning
    ]);
    useEffect24(function() {
        if (cardHeight > 0) {
            window.addEventListener("resize", debouncedCalculatePosition);
            return function() {
                window.removeEventListener("resize", debouncedCalculatePosition);
            };
        }
    }, [
        cardHeight,
        debouncedCalculatePosition
    ]);
    useEffect24(function() {
        if (!isTransitioning) {
            var timeoutId = setTimeout(function() {
                calculatePosition();
            }, 100);
            return function() {
                return clearTimeout(timeoutId);
            };
        }
    }, [
        currentStep,
        isTransitioning,
        calculatePosition
    ]);
    return /* @__PURE__ */ jsxs57("div", {
        "data-testid": "tutorial-step-".concat(currentStep + 1),
        className: "".concat(className, " ").concat(fade),
        style: {
            top: position.top,
            left: position.left
        },
        children: [
            /* @__PURE__ */ jsx84("div", {
                className: "back-panel",
                style: {
                    height: "".concat(cardHeight, "px")
                }
            }),
            /* @__PURE__ */ jsxs57("div", {
                className: "pointer-wrapper",
                children: [
                    /* @__PURE__ */ jsx84("div", {
                        className: "glass-pin pos-".concat(pointerPos),
                        children: /* @__PURE__ */ jsx84(GlassPin, {
                            viewBox: "0 0 38 43"
                        })
                    }),
                    /* @__PURE__ */ jsxs57("div", {
                        className: "card",
                        ref: sourceRef,
                        children: [
                            /* @__PURE__ */ jsxs57("div", {
                                className: "card-header",
                                children: [
                                    header && /* @__PURE__ */ jsx84("p", {
                                        className: "header",
                                        dangerouslySetInnerHTML: {
                                            __html: header
                                        }
                                    }),
                                    /* @__PURE__ */ jsx84("button", {
                                        className: "close-tutorial",
                                        "aria-label": "Close tutorial",
                                        onClick: completeTutorial,
                                        children: /* @__PURE__ */ jsx84(Dismiss16Regular3, {})
                                    })
                                ]
                            }),
                            copy ? /* @__PURE__ */ jsx84("div", {
                                className: "copy",
                                children: copy
                            }) : null,
                            /* @__PURE__ */ jsx84(Steps_default, {
                                current: currentStep,
                                total: totalSteps
                            }),
                            /* @__PURE__ */ jsxs57("div", {
                                className: "controls",
                                children: [
                                    currentStep > 0 && /* @__PURE__ */ jsx84("button", {
                                        className: "secondary",
                                        onClick: function() {
                                            return changeStep(currentStep - 1);
                                        },
                                        disabled: isTransitioning,
                                        children: "Back"
                                    }),
                                    currentStep + 1 < totalSteps && /* @__PURE__ */ jsx84("button", {
                                        "data-testid": "tutorial-step-".concat(currentStep + 1, "-next-button"),
                                        className: "primary ".concat(nextButtonEnabled === false ? "disabled" : ""),
                                        onClick: function() {
                                            return changeStep(currentStep + 1);
                                        },
                                        disabled: !nextButtonEnabled || isTransitioning,
                                        children: "Next"
                                    }),
                                    currentStep + 1 === totalSteps && /* @__PURE__ */ jsx84("button", {
                                        className: "primary ".concat(nextButtonEnabled === false ? "disabled" : ""),
                                        onClick: completeTutorial,
                                        disabled: !nextButtonEnabled || isTransitioning,
                                        children: "Got it!"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var calcPadding = function(pointerPos) {
    switch(pointerPos){
        case 15:
            return "40px 0";
        default:
            return "46px 0";
    }
};
var OnboardingPanel_default = styled60(OnboardingPanel)(_templateObject80(), function(param) {
    var pointerPos = param.pointerPos;
    return calcPadding(pointerPos);
});
// src/components/Onboarding/OnboardingWrapper.tsx
import { useCallback as useCallback5, useEffect as useEffect25, useState as useState38 } from "react";
import styled61 from "styled-components";
import { onboardingSteps } from "@repo/front-end-data";
import { jsx as jsx85 } from "react/jsx-runtime";
var OnboardingWrapper = function(param) {
    var className = param.className, restartTutorial = param.restartTutorial, onComplete = param.onComplete, _param_steps = param.steps, steps = _param_steps === void 0 ? onboardingSteps : _param_steps, cookieKey = param.cookieKey, isStepComplete = param.isStepComplete, controlledStep = param.step, onStepChange = param.onStepChange;
    var _useState38 = _sliced_to_array(useState38(0), 2), localStep = _useState38[0], setLocalStep = _useState38[1];
    var controlled = controlledStep !== void 0;
    var currentStep = controlled ? controlledStep : localStep;
    var step = steps[currentStep];
    useEffect25(function() {
        if (!controlled) setLocalStep(0);
    }, [
        restartTutorial,
        controlled
    ]);
    var handleStepChange = useCallback5(function(stepIndex) {
        if (!controlled) setLocalStep(stepIndex);
        onStepChange === null || onStepChange === void 0 ? void 0 : onStepChange(stepIndex);
    }, [
        controlled,
        onStepChange
    ]);
    return /* @__PURE__ */ jsx85("div", {
        className: className,
        children: /* @__PURE__ */ jsx85(OnboardingPanel_default, {
            header: step.header,
            copy: step.copy,
            anchorPos: step.anchorPos,
            posX: step.posX || 0,
            posY: step.posY || 0,
            pointerPos: step.pointerPos,
            currentStep: currentStep,
            totalSteps: steps.length,
            setCurrentStep: handleStepChange,
            onComplete: onComplete,
            cookieKey: cookieKey,
            nextEnabledOverride: isStepComplete ? isStepComplete(currentStep) : void 0,
            targetSelector: step.targetSelector,
            placement: step.placement
        })
    });
};
var OnboardingWrapper_default = styled61(OnboardingWrapper)(_templateObject81());
// src/components/NotificationsWindow/NotificationsWindow.tsx
import { useState as useState39, useMemo as useMemo5 } from "react";
import styled62 from "styled-components";
import { useNotifications, useLegalNotices, useNotificationIsLoading, useSelectedNotification, useNotificationLoadingDetail, useNotificationStore, useUserStore as useUserStore14, useTwinModelStore, useSpotlightStore as useSpotlightStore2 } from "@repo/front-end-state";
import { getNotificationTypeColors as getNotificationTypeColors2, legalDocumentLinks, parseScenarioPayload, formatDateToDateTimeString as formatDateToDateTimeString2 } from "@repo/front-end-utils";
import { Fragment as Fragment17, jsx as jsx86, jsxs as jsxs58 } from "react/jsx-runtime";
var STRINGS = {
    markAllLabel: "Mark all as read",
    markAllInFlight: "Marking\u2026",
    markAllConfirmation: function(count) {
        return "".concat(count, " notification").concat(count === 1 ? "" : "s", " marked as read");
    },
    markAllError: "Could not mark notifications as read. Please try again.",
    /** Equipment row utilisation line, e.g. "12% vs usual 47%". */ findingUtil: function(yesterdayPct, baselinePct) {
        return "".concat(yesterdayPct, "% vs usual ").concat(baselinePct, "%");
    }
};
var NotificationsWindow = function(param) {
    var middlewareApi = param.middlewareApi, twinAppBaseUrl = param.twinAppBaseUrl, setNotificationsVisible = param.setNotificationsVisible;
    var _useState39 = _sliced_to_array(useState39(false), 2), isHeaderHovered = _useState39[0], setIsHeaderHovered = _useState39[1];
    var _useState391 = _sliced_to_array(useState39("unread"), 2), activeTab = _useState391[0], setActiveTab = _useState391[1];
    var _useState392 = _sliced_to_array(useState39(false), 2), isDetailView = _useState392[0], setIsDetailView = _useState392[1];
    var authMetadata = useUserStore14().authMetadata;
    var notifications = useNotifications();
    var legalNotices = useLegalNotices();
    var isLoading = useNotificationIsLoading();
    var selectedNotification = useSelectedNotification();
    var isLoadingDetail = useNotificationLoadingDetail();
    var accessibleTwins = useTwinModelStore(function(state) {
        return state.accessibleTwins;
    });
    var _useState393 = _sliced_to_array(useState39(false), 2), isMarkingAll = _useState393[0], setIsMarkingAll = _useState393[1];
    var _useState394 = _sliced_to_array(useState39(null), 2), markAllMessage = _useState394[0], setMarkAllMessage = _useState394[1];
    var _useState395 = _sliced_to_array(useState39(null), 2), markAllError = _useState395[0], setMarkAllError = _useState395[1];
    var resolveTwinName = function(twinBid) {
        var _accessibleTwins_find;
        if (!accessibleTwins) {
            return null;
        }
        var _accessibleTwins_find_name;
        return (_accessibleTwins_find_name = (_accessibleTwins_find = accessibleTwins.find(function(twin) {
            return twin.bid === twinBid;
        })) === null || _accessibleTwins_find === void 0 ? void 0 : _accessibleTwins_find.name) !== null && _accessibleTwins_find_name !== void 0 ? _accessibleTwins_find_name : twinBid;
    };
    var renderTwinChip = function(twinBid) {
        if (!twinBid) {
            return null;
        }
        var label = resolveTwinName(twinBid);
        return label ? /* @__PURE__ */ jsx86("span", {
            className: "twin-chip",
            children: label
        }) : null;
    };
    var handleTabChange = function(tab) {
        setActiveTab(tab);
        setMarkAllMessage(null);
        setMarkAllError(null);
    };
    var handleEquipmentClick = function(entityBid, notificationId) {
        var _authMetadata_tokens;
        useSpotlightStore2.getState().fireSpotlight(entityBid);
        setNotificationsVisible(false);
        var token = authMetadata === null || authMetadata === void 0 ? void 0 : (_authMetadata_tokens = authMetadata.tokens) === null || _authMetadata_tokens === void 0 ? void 0 : _authMetadata_tokens.accessToken;
        if (token) {
            var markAsRead = useNotificationStore.getState().markAsRead;
            void markAsRead(middlewareApi, token, notificationId).catch(function(error) {
                return console.error("Error marking notification as read on spotlight click:", error);
            });
        }
    };
    var renderScenarioFindings = function(payload, notificationId) {
        return /* @__PURE__ */ jsx86("ul", {
            className: "scenario-findings",
            children: payload.findings.map(function(finding) {
                return /* @__PURE__ */ jsx86("li", {
                    children: /* @__PURE__ */ jsxs58("button", {
                        type: "button",
                        className: "finding-row",
                        onClick: function(event) {
                            event.stopPropagation();
                            handleEquipmentClick(finding.entityBid, notificationId);
                        },
                        children: [
                            /* @__PURE__ */ jsxs58("span", {
                                className: "finding-label",
                                children: [
                                    finding.entityLabel,
                                    finding.zoneLabel ? " (".concat(finding.zoneLabel, ")") : ""
                                ]
                            }),
                            /* @__PURE__ */ jsx86("span", {
                                className: "finding-util",
                                children: STRINGS.findingUtil(finding.yesterdayUtilPct, finding.baselineUtilPct)
                            })
                        ]
                    })
                }, finding.entityBid);
            })
        });
    };
    var scenarioPayloadOf = function(notification) {
        return notification.scenario ? parseScenarioPayload(notification.payload) : null;
    };
    var handleMarkAllAsRead = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var _authMetadata_tokens, orgBid, token, markAllNotificationsAsRead, marked;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        orgBid = authMetadata === null || authMetadata === void 0 ? void 0 : authMetadata.orgBID;
                        token = authMetadata === null || authMetadata === void 0 ? void 0 : (_authMetadata_tokens = authMetadata.tokens) === null || _authMetadata_tokens === void 0 ? void 0 : _authMetadata_tokens.accessToken;
                        if (!orgBid || !token) return [
                            2
                        ];
                        setIsMarkingAll(true);
                        setMarkAllMessage(null);
                        setMarkAllError(null);
                        markAllNotificationsAsRead = useNotificationStore.getState().markAllNotificationsAsRead;
                        return [
                            4,
                            markAllNotificationsAsRead(middlewareApi, token, orgBid)
                        ];
                    case 1:
                        marked = _state.sent();
                        if (marked === null) {
                            setMarkAllError(STRINGS.markAllError);
                        } else {
                            setMarkAllMessage(STRINGS.markAllConfirmation(marked));
                        }
                        setIsMarkingAll(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleMarkAllAsRead() {
            return _ref.apply(this, arguments);
        };
    }();
    var _useState396 = _sliced_to_array(useState39(/* @__PURE__ */ new Set()), 2), acceptingDocuments = _useState396[0], setAcceptingDocuments = _useState396[1];
    var _useState397 = _sliced_to_array(useState39({}), 2), noticeErrors = _useState397[0], setNoticeErrors = _useState397[1];
    var legalLinks = legalDocumentLinks(twinAppBaseUrl);
    var handleAcceptNotice = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(notice) {
            var _authMetadata_tokens, document2, acknowledgeLegalNotice, ok, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(authMetadata === null || authMetadata === void 0 ? void 0 : (_authMetadata_tokens = authMetadata.tokens) === null || _authMetadata_tokens === void 0 ? void 0 : _authMetadata_tokens.accessToken)) return [
                            2
                        ];
                        document2 = notice.document;
                        setNoticeErrors(function(prev) {
                            var next = _object_spread({}, prev);
                            delete next[document2];
                            return next;
                        });
                        setAcceptingDocuments(function(prev) {
                            return new Set(prev).add(document2);
                        });
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        acknowledgeLegalNotice = useNotificationStore.getState().acknowledgeLegalNotice;
                        return [
                            4,
                            acknowledgeLegalNotice(middlewareApi, authMetadata.tokens.accessToken, notice)
                        ];
                    case 2:
                        ok = _state.sent();
                        if (!ok) {
                            setNoticeErrors(function(prev) {
                                return _object_spread_props(_object_spread({}, prev), _define_property({}, document2, "Could not record your acceptance. Please try again."));
                            });
                        }
                        return [
                            3,
                            5
                        ];
                    case 3:
                        error = _state.sent();
                        console.error("Error accepting legal notice:", error);
                        setNoticeErrors(function(prev) {
                            return _object_spread_props(_object_spread({}, prev), _define_property({}, document2, "Could not record your acceptance. Please try again."));
                        });
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setAcceptingDocuments(function(prev) {
                            var next = new Set(prev);
                            next.delete(document2);
                            return next;
                        });
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleAcceptNotice(notice) {
            return _ref.apply(this, arguments);
        };
    }();
    var renderLegalNotices = function() {
        return legalNotices.map(function(notice) {
            var link = legalLinks === null || legalLinks === void 0 ? void 0 : legalLinks[notice.document];
            var isAccepting = acceptingDocuments.has(notice.document);
            var error = noticeErrors[notice.document];
            return /* @__PURE__ */ jsxs58("div", {
                className: "notification-item legal-notice",
                children: [
                    /* @__PURE__ */ jsxs58("div", {
                        className: "notification-header",
                        children: [
                            /* @__PURE__ */ jsx86("div", {
                                className: "notification-header-text",
                                children: /* @__PURE__ */ jsxs58("span", {
                                    className: "notification-title",
                                    children: [
                                        notice.title,
                                        " (v",
                                        notice.version,
                                        ")"
                                    ]
                                })
                            }),
                            /* @__PURE__ */ jsx86("span", {
                                className: "notification-type action-required",
                                children: "Action required"
                            })
                        ]
                    }),
                    /* @__PURE__ */ jsx86("div", {
                        className: "notification-description",
                        children: notice.noticeMessage
                    }),
                    error && /* @__PURE__ */ jsx86("div", {
                        className: "notice-error",
                        role: "alert",
                        children: error
                    }),
                    /* @__PURE__ */ jsxs58("div", {
                        className: "notification-actions",
                        children: [
                            link && /* @__PURE__ */ jsx86("a", {
                                className: "action-button read-document",
                                href: link,
                                target: "_blank",
                                rel: "noreferrer",
                                "aria-label": "Read the document: ".concat(notice.title),
                                children: "Read the document"
                            }),
                            /* @__PURE__ */ jsx86("button", {
                                className: "action-button accept-notice",
                                disabled: isAccepting,
                                onClick: function() {
                                    return handleAcceptNotice(notice);
                                },
                                children: isAccepting ? "Accepting\u2026" : "Accept"
                            })
                        ]
                    })
                ]
            }, "legal-".concat(notice.document));
        });
    };
    var unreadNotifications = useMemo5(function() {
        return notifications.filter(function(notification) {
            return !notification.read_at;
        }).sort(function(a, b) {
            return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
        });
    }, [
        notifications
    ]);
    var readNotifications = useMemo5(function() {
        return notifications.filter(function(notification) {
            return notification.read_at;
        }).sort(function(a, b) {
            return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
        });
    }, [
        notifications
    ]);
    var currentNotifications = activeTab === "unread" ? unreadNotifications : readNotifications;
    var handleNotificationClick = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(notificationId) {
            var _authMetadata_tokens, fetchNotificationById;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(authMetadata === null || authMetadata === void 0 ? void 0 : (_authMetadata_tokens = authMetadata.tokens) === null || _authMetadata_tokens === void 0 ? void 0 : _authMetadata_tokens.accessToken)) return [
                            2
                        ];
                        fetchNotificationById = useNotificationStore.getState().fetchNotificationById;
                        return [
                            4,
                            fetchNotificationById(middlewareApi, authMetadata.tokens.accessToken, notificationId)
                        ];
                    case 1:
                        _state.sent();
                        setIsDetailView(true);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleNotificationClick(notificationId) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleBackToList = function() {
        setIsDetailView(false);
        var setSelectedNotification = useNotificationStore.getState().setSelectedNotification;
        setSelectedNotification(null);
    };
    var renderNotificationDetail = function() {
        if (!selectedNotification) return null;
        return /* @__PURE__ */ jsxs58(NotificationDetailView, {
            children: [
                /* @__PURE__ */ jsxs58("div", {
                    className: "detail-header",
                    children: [
                        /* @__PURE__ */ jsxs58("button", {
                            className: "action-button",
                            onClick: handleBackToList,
                            children: [
                                /* @__PURE__ */ jsx86("svg", {
                                    width: "12",
                                    height: "12",
                                    viewBox: "0 0 16 16",
                                    fill: "currentColor",
                                    children: /* @__PURE__ */ jsx86("path", {
                                        d: "M10.78 12.78a.75.75 0 0 1-1.06 0L4.47 7.53a.75.75 0 0 1 0-1.06l5.25-5.25a.75.75 0 0 1 1.06 1.06L6.06 7l4.72 4.72a.75.75 0 0 1 0 1.06z"
                                    })
                                }),
                                "Back"
                            ]
                        }),
                        /* @__PURE__ */ jsxs58("div", {
                            className: "detail-header-info",
                            children: [
                                /* @__PURE__ */ jsxs58("div", {
                                    className: "header-text",
                                    children: [
                                        /* @__PURE__ */ jsx86("h3", {
                                            className: "detail-title",
                                            children: selectedNotification.title
                                        }),
                                        /* @__PURE__ */ jsx86("span", {
                                            className: "detail-time",
                                            children: function() {
                                                var date = new Date(selectedNotification.created_at);
                                                var day = date.getDate().toString().padStart(2, "0");
                                                var month = (date.getMonth() + 1).toString().padStart(2, "0");
                                                var year = date.getFullYear().toString();
                                                var time = formatDateToDateTimeString2(date).split(" ")[1];
                                                return "".concat(day, "/").concat(month, "/").concat(year, " ").concat(time);
                                            }()
                                        })
                                    ]
                                }),
                                /* @__PURE__ */ jsx86("span", {
                                    className: "type-badge",
                                    style: getNotificationTypeColors2(selectedNotification.type),
                                    children: selectedNotification.type
                                })
                            ]
                        })
                    ]
                }),
                /* @__PURE__ */ jsxs58("div", {
                    className: "detail-content",
                    children: [
                        renderTwinChip(selectedNotification.twin_bid),
                        /* @__PURE__ */ jsx86("div", {
                            className: "detail-summary",
                            children: /* @__PURE__ */ jsx86("p", {
                                children: selectedNotification.summary
                            })
                        }),
                        /* @__PURE__ */ jsx86("div", {
                            className: "detail-message",
                            children: function() {
                                var payload = scenarioPayloadOf(selectedNotification);
                                return payload ? renderScenarioFindings(payload, selectedNotification.id) : /* @__PURE__ */ jsx86("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: selectedNotification.message
                                    }
                                });
                            }()
                        })
                    ]
                })
            ]
        });
    };
    if (isDetailView) {
        return /* @__PURE__ */ jsx86(DraggablePanel_default, {
            headerElement: /* @__PURE__ */ jsx86(NotificationsHeader_default, {
                setIsHeaderHovered: setIsHeaderHovered,
                setNotificationsVisible: setNotificationsVisible
            }),
            isHeaderHovered: isHeaderHovered,
            children: isLoadingDetail ? /* @__PURE__ */ jsx86(NotificationsContent, {
                children: /* @__PURE__ */ jsx86("div", {
                    className: "loading-state",
                    children: "Loading notification details..."
                })
            }) : renderNotificationDetail()
        });
    }
    return /* @__PURE__ */ jsx86(DraggablePanel_default, {
        headerElement: /* @__PURE__ */ jsx86(NotificationsHeader_default, {
            setIsHeaderHovered: setIsHeaderHovered,
            setNotificationsVisible: setNotificationsVisible
        }),
        isHeaderHovered: isHeaderHovered,
        children: /* @__PURE__ */ jsxs58(NotificationsContent, {
            children: [
                /* @__PURE__ */ jsxs58("div", {
                    className: "tab-container",
                    children: [
                        /* @__PURE__ */ jsx86("button", {
                            className: "tab ".concat(activeTab === "unread" ? "active" : ""),
                            onClick: function() {
                                return handleTabChange("unread");
                            },
                            children: "Unread"
                        }),
                        /* @__PURE__ */ jsx86("button", {
                            className: "tab ".concat(activeTab === "read" ? "active" : ""),
                            onClick: function() {
                                return handleTabChange("read");
                            },
                            children: "Read"
                        })
                    ]
                }),
                activeTab === "unread" && /* @__PURE__ */ jsxs58("div", {
                    className: "bulk-actions",
                    children: [
                        /* @__PURE__ */ jsx86("button", {
                            type: "button",
                            className: "action-button mark-all-read",
                            disabled: isMarkingAll || unreadNotifications.length === 0,
                            onClick: handleMarkAllAsRead,
                            children: isMarkingAll ? STRINGS.markAllInFlight : STRINGS.markAllLabel
                        }),
                        markAllMessage && /* @__PURE__ */ jsx86("span", {
                            className: "mark-all-confirmation",
                            role: "status",
                            children: markAllMessage
                        }),
                        markAllError && /* @__PURE__ */ jsx86("span", {
                            className: "mark-all-error",
                            role: "alert",
                            children: markAllError
                        })
                    ]
                }),
                /* @__PURE__ */ jsx86("div", {
                    className: "notifications-list",
                    children: activeTab === "unread" ? /* @__PURE__ */ jsxs58(Fragment17, {
                        children: [
                            renderLegalNotices(),
                            isLoading ? /* @__PURE__ */ jsx86("div", {
                                className: "loading-state",
                                children: "Loading notifications..."
                            }) : currentNotifications.length > 0 ? currentNotifications.map(function(notification) {
                                var scenarioPayload = scenarioPayloadOf(notification);
                                return /* @__PURE__ */ jsxs58("div", {
                                    className: "notification-item ".concat(!notification.read_at ? "unread" : ""),
                                    onClick: function() {
                                        return handleNotificationClick(notification.id);
                                    },
                                    children: [
                                        /* @__PURE__ */ jsxs58("div", {
                                            className: "notification-header",
                                            children: [
                                                /* @__PURE__ */ jsxs58("div", {
                                                    className: "notification-header-text",
                                                    children: [
                                                        /* @__PURE__ */ jsx86("span", {
                                                            className: "notification-title",
                                                            children: notification.title
                                                        }),
                                                        /* @__PURE__ */ jsx86("span", {
                                                            className: "notification-time",
                                                            children: function() {
                                                                var date = new Date(notification.created_at);
                                                                var day = date.getDate().toString().padStart(2, "0");
                                                                var month = (date.getMonth() + 1).toString().padStart(2, "0");
                                                                var year = date.getFullYear().toString();
                                                                var time = formatDateToDateTimeString2(date).split(" ")[1];
                                                                return "".concat(day, "/").concat(month, "/").concat(year, " ").concat(time);
                                                            }()
                                                        })
                                                    ]
                                                }),
                                                /* @__PURE__ */ jsx86("span", {
                                                    className: "notification-type",
                                                    style: getNotificationTypeColors2(notification.type),
                                                    children: notification.type
                                                })
                                            ]
                                        }),
                                        renderTwinChip(notification.twin_bid),
                                        /* @__PURE__ */ jsx86("div", {
                                            className: "notification-description",
                                            children: notification.summary
                                        }),
                                        scenarioPayload && renderScenarioFindings(scenarioPayload, notification.id),
                                        /* @__PURE__ */ jsx86("div", {
                                            className: "notification-actions",
                                            children: !notification.read_at && /* @__PURE__ */ jsx86("button", {
                                                className: "action-button mark-read",
                                                onClick: /*#__PURE__*/ function() {
                                                    var _ref = _async_to_generator(function(e) {
                                                        var _authMetadata_tokens, markAsRead, error;
                                                        return _ts_generator(this, function(_state) {
                                                            switch(_state.label){
                                                                case 0:
                                                                    e.stopPropagation();
                                                                    if (!(authMetadata === null || authMetadata === void 0 ? void 0 : (_authMetadata_tokens = authMetadata.tokens) === null || _authMetadata_tokens === void 0 ? void 0 : _authMetadata_tokens.accessToken)) return [
                                                                        3,
                                                                        4
                                                                    ];
                                                                    _state.label = 1;
                                                                case 1:
                                                                    _state.trys.push([
                                                                        1,
                                                                        3,
                                                                        ,
                                                                        4
                                                                    ]);
                                                                    markAsRead = useNotificationStore.getState().markAsRead;
                                                                    return [
                                                                        4,
                                                                        markAsRead(middlewareApi, authMetadata.tokens.accessToken, notification.id)
                                                                    ];
                                                                case 2:
                                                                    _state.sent();
                                                                    return [
                                                                        3,
                                                                        4
                                                                    ];
                                                                case 3:
                                                                    error = _state.sent();
                                                                    console.error("Error in mark as read button click:", error);
                                                                    return [
                                                                        3,
                                                                        4
                                                                    ];
                                                                case 4:
                                                                    return [
                                                                        2
                                                                    ];
                                                            }
                                                        });
                                                    });
                                                    return function(e) {
                                                        return _ref.apply(this, arguments);
                                                    };
                                                }(),
                                                children: "Mark as read"
                                            })
                                        })
                                    ]
                                }, notification.id);
                            }) : legalNotices.length === 0 ? /* @__PURE__ */ jsx86("div", {
                                className: "empty-state",
                                children: "No unread notifications"
                            }) : null
                        ]
                    }) : isLoading ? /* @__PURE__ */ jsx86("div", {
                        className: "loading-state",
                        children: "Loading notifications..."
                    }) : currentNotifications.length > 0 ? currentNotifications.map(function(notification) {
                        var scenarioPayload = scenarioPayloadOf(notification);
                        return /* @__PURE__ */ jsxs58("div", {
                            className: "notification-item",
                            onClick: function() {
                                return handleNotificationClick(notification.id);
                            },
                            children: [
                                /* @__PURE__ */ jsxs58("div", {
                                    className: "notification-header",
                                    children: [
                                        /* @__PURE__ */ jsxs58("div", {
                                            className: "notification-header-text",
                                            children: [
                                                /* @__PURE__ */ jsx86("span", {
                                                    className: "notification-title",
                                                    children: notification.title
                                                }),
                                                /* @__PURE__ */ jsx86("span", {
                                                    className: "notification-time",
                                                    children: function() {
                                                        var date = new Date(notification.created_at);
                                                        var day = date.getDate().toString().padStart(2, "0");
                                                        var month = (date.getMonth() + 1).toString().padStart(2, "0");
                                                        var year = date.getFullYear().toString();
                                                        var time = formatDateToDateTimeString2(date).split(" ")[1];
                                                        return "".concat(day, "/").concat(month, "/").concat(year, " ").concat(time);
                                                    }()
                                                })
                                            ]
                                        }),
                                        /* @__PURE__ */ jsx86("span", {
                                            className: "notification-type",
                                            style: getNotificationTypeColors2(notification.type),
                                            children: notification.type
                                        })
                                    ]
                                }),
                                renderTwinChip(notification.twin_bid),
                                /* @__PURE__ */ jsx86("div", {
                                    className: "notification-description",
                                    children: notification.summary
                                }),
                                scenarioPayload && renderScenarioFindings(scenarioPayload, notification.id),
                                /* @__PURE__ */ jsx86("div", {
                                    className: "notification-actions",
                                    children: /* @__PURE__ */ jsx86("button", {
                                        className: "action-button mark-unread",
                                        onClick: /*#__PURE__*/ function() {
                                            var _ref = _async_to_generator(function(e) {
                                                var _authMetadata_tokens, markAsUnread, error;
                                                return _ts_generator(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            e.stopPropagation();
                                                            if (!(authMetadata === null || authMetadata === void 0 ? void 0 : (_authMetadata_tokens = authMetadata.tokens) === null || _authMetadata_tokens === void 0 ? void 0 : _authMetadata_tokens.accessToken)) return [
                                                                3,
                                                                4
                                                            ];
                                                            _state.label = 1;
                                                        case 1:
                                                            _state.trys.push([
                                                                1,
                                                                3,
                                                                ,
                                                                4
                                                            ]);
                                                            markAsUnread = useNotificationStore.getState().markAsUnread;
                                                            return [
                                                                4,
                                                                markAsUnread(middlewareApi, authMetadata.tokens.accessToken, notification.id)
                                                            ];
                                                        case 2:
                                                            _state.sent();
                                                            return [
                                                                3,
                                                                4
                                                            ];
                                                        case 3:
                                                            error = _state.sent();
                                                            console.error("Error in mark as unread button click:", error);
                                                            return [
                                                                3,
                                                                4
                                                            ];
                                                        case 4:
                                                            return [
                                                                2
                                                            ];
                                                    }
                                                });
                                            });
                                            return function(e) {
                                                return _ref.apply(this, arguments);
                                            };
                                        }(),
                                        children: "Mark as unread"
                                    })
                                })
                            ]
                        }, notification.id);
                    }) : /* @__PURE__ */ jsx86("div", {
                        className: "empty-state",
                        children: "No read notifications"
                    })
                })
            ]
        })
    });
};
var NotificationDetailView = styled62.div(_templateObject82());
var NotificationsContent = styled62.div(_templateObject83());
var NotificationsWindow_default = NotificationsWindow;
// src/components/BIDashboard/BIDashboard.tsx
import { useEffect as useEffect29, useMemo as useMemo7, useState as useState43 } from "react";
import { Scrollbar as Scrollbar4 } from "@repo/design-system";
import styled65 from "styled-components";
import { useUserStore as useUserStore15, useModeContext as useModeContext3, useTwinModelStore as useTwinModelStore2 } from "@repo/front-end-state";
import { Roles as Roles5, AppMode as AppMode3 } from "@repo/frontend-types";
import { getBiDashboards } from "@repo/front-end-services";
// src/components/BIDashboard/BIDashboardSelect.tsx
import styled63 from "styled-components";
import { ChartMultiple16Regular } from "@fluentui/react-icons";
import { jsx as jsx87 } from "react/jsx-runtime";
var BIDashboardSelect = function(param) {
    var className = param.className, dashboards = param.dashboards, currentDashboardId = param.currentDashboardId, onDashboardChange = param.onDashboardChange, isAdmin = param.isAdmin;
    if (dashboards.length === 0) {
        return /* @__PURE__ */ jsx87("div", {
            className: className,
            children: /* @__PURE__ */ jsx87("div", {
                className: "loading-state",
                children: "No active dashboards available"
            })
        });
    }
    var options = dashboards.map(function(dashboard) {
        var isDraftOnly = dashboard.published_version === null || dashboard.published_version === void 0;
        return {
            value: String(dashboard.id),
            // TL_ADMIN previews unpublished dashboards, marked "(draft)".
            label: isDraftOnly && isAdmin ? "".concat(dashboard.name, " (draft)") : dashboard.name,
            icon: /* @__PURE__ */ jsx87(ChartMultiple16Regular, {})
        };
    });
    return /* @__PURE__ */ jsx87(BaseDropdown_default, {
        className: className,
        currentValue: currentDashboardId,
        options: options,
        onOptionChange: onDashboardChange,
        maxHeight: 300,
        width: "auto",
        minWidth: "260px"
    });
};
var StyledBIDashboardSelect = styled63(BIDashboardSelect)(_templateObject84());
var BIDashboardSelect_default = StyledBIDashboardSelect;
// src/components/BIDashboard/NativeDashboardView.tsx
import { useEffect as useEffect28, useState as useState42 } from "react";
import { getBiDashboardDefinition } from "@repo/front-end-services";
// src/components/DashboardRenderer/DashboardRenderer.tsx
import { Fragment as Fragment18, useCallback as useCallback7, useEffect as useEffect27, useMemo as useMemo6, useRef as useRef15, useState as useState41 } from "react";
import { ink as ink5, surface as surface3, line as line2, radius as radius2, space as space9 } from "@repo/design-tokens";
import { Scrollbar as Scrollbar3 } from "@repo/design-system";
// src/components/DashboardRenderer/panels/TextPanel.tsx
import React37 from "react";
import { ink as ink2, space as space5 } from "@repo/design-tokens";
import { jsx as jsx88, jsxs as jsxs59 } from "react/jsx-runtime";
var INLINE_TOKEN = /(\*\*[^*]+\*\*|\*[^*]+\*|`[^`]+`)/g;
function renderInline(text) {
    var nodes = [];
    var lastIndex = 0;
    var key = 0;
    var match;
    INLINE_TOKEN.lastIndex = 0;
    while((match = INLINE_TOKEN.exec(text)) !== null){
        if (match.index > lastIndex) nodes.push(text.slice(lastIndex, match.index));
        var tok = match[0];
        if (tok.startsWith("**")) {
            nodes.push(/* @__PURE__ */ jsx88("strong", {
                children: tok.slice(2, -2)
            }, key++));
        } else if (tok.startsWith("`")) {
            nodes.push(/* @__PURE__ */ jsx88("code", {
                children: tok.slice(1, -1)
            }, key++));
        } else {
            nodes.push(/* @__PURE__ */ jsx88("em", {
                children: tok.slice(1, -1)
            }, key++));
        }
        lastIndex = match.index + tok.length;
    }
    if (lastIndex < text.length) nodes.push(text.slice(lastIndex));
    return nodes;
}
function renderBlocks(content, markdown) {
    var blocks = content.split(/\n{2,}/);
    return blocks.map(function(block, i) {
        var trimmed = block.trim();
        if (markdown) {
            var heading = /^(#{1,3})\s+(.*)$/.exec(trimmed);
            if (heading) {
                var level = heading[1].length;
                var Tag6 = "h".concat(level);
                var size2 = level === 1 ? "18px" : level === 2 ? "15px" : "13px";
                return /* @__PURE__ */ jsx88(Tag6, {
                    style: {
                        margin: 0,
                        fontSize: size2,
                        color: ink2[1]
                    },
                    children: renderInline(heading[2])
                }, i);
            }
        }
        var lines = trimmed.split("\n");
        return /* @__PURE__ */ jsx88("p", {
            style: {
                margin: 0,
                fontSize: "13px",
                color: ink2[2]
            },
            children: lines.map(function(line9, j) {
                return /* @__PURE__ */ jsxs59(React37.Fragment, {
                    children: [
                        markdown ? renderInline(line9) : line9,
                        j < lines.length - 1 ? /* @__PURE__ */ jsx88("br", {}) : null
                    ]
                }, j);
            })
        }, i);
    });
}
function TextPanel(param) {
    var props = param.props, inComposite = param.inComposite;
    var content = typeof props.content === "string" ? props.content : "";
    var markdown = props.format !== "text";
    return /* @__PURE__ */ jsx88("div", {
        "data-testid": "text-panel",
        "data-in-composite": inComposite ? "true" : void 0,
        style: _object_spread_props(_object_spread({}, inComposite ? {
            height: "auto",
            flex: "0 0 auto"
        } : {
            height: "100%"
        }), {
            display: "flex",
            flexDirection: "column",
            gap: space5[2],
            overflow: "auto"
        }),
        children: renderBlocks(content, markdown)
    });
}
// src/components/DashboardRenderer/panels/StatPanel.tsx
import { ink as ink3, brand as brand2, space as space6 } from "@repo/design-tokens";
import { jsx as jsx89, jsxs as jsxs60 } from "react/jsx-runtime";
function formatValue(raw, precision) {
    if (raw === null || raw === void 0) return "\u2014";
    if (typeof raw === "number" && Number.isFinite(raw)) {
        return precision === void 0 ? String(raw) : raw.toFixed(precision);
    }
    return String(raw);
}
function StatPanel(param) {
    var props = param.props, data = param.data;
    var label = typeof props.label === "string" ? props.label : void 0;
    var _data_data;
    var headline = (_data_data = data === null || data === void 0 ? void 0 : data.data) !== null && _data_data !== void 0 ? _data_data : void 0;
    var unit2 = typeof props.unit === "string" ? props.unit : typeof (headline === null || headline === void 0 ? void 0 : headline.unit) === "string" ? headline.unit : void 0;
    var precision = typeof props.precision === "number" ? props.precision : void 0;
    var value = formatValue(headline === null || headline === void 0 ? void 0 : headline.value, precision);
    return /* @__PURE__ */ jsxs60("div", {
        "data-testid": "stat-panel",
        style: {
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            gap: space6[1]
        },
        children: [
            label ? /* @__PURE__ */ jsx89("span", {
                style: {
                    fontSize: "11px",
                    letterSpacing: ".08em",
                    textTransform: "uppercase",
                    color: ink3[4]
                },
                children: label
            }) : null,
            /* @__PURE__ */ jsxs60("span", {
                style: {
                    display: "flex",
                    alignItems: "baseline",
                    gap: space6[1]
                },
                children: [
                    /* @__PURE__ */ jsx89("span", {
                        "data-testid": "stat-panel-value",
                        style: {
                            fontSize: "32px",
                            fontWeight: 700,
                            color: brand2.cyan
                        },
                        children: value
                    }),
                    unit2 ? /* @__PURE__ */ jsx89("span", {
                        style: {
                            fontSize: "14px",
                            color: ink3[3]
                        },
                        children: unit2
                    }) : null
                ]
            })
        ]
    });
}
// src/components/DashboardRenderer/panels/ShowWholeTwinPanel.tsx
import { useCallback as useCallback6, useEffect as useEffect26, useRef as useRef14, useState as useState40 } from "react";
import styled64 from "styled-components";
import { Button as Button8, Icon } from "@repo/design-system";
import { space as space7 } from "@repo/design-tokens";
import { jsx as jsx90, jsxs as jsxs61 } from "react/jsx-runtime";
var DEFAULT_LABEL = "Show whole twin";
var ANNOUNCEMENT = "Selection cleared. Showing whole twin.";
var REANNOUNCE_GAP_MS = 150;
var Centre = styled64.div(_templateObject85(), space7[1]);
var Hit = styled64.span(_templateObject86());
function ShowWholeTwinPanel(param) {
    var props = param.props, hostActions = param.hostActions;
    var onShowWholeTwin = hostActions === null || hostActions === void 0 ? void 0 : hostActions.onShowWholeTwin;
    var label = typeof props.label === "string" && props.label.trim().length > 0 ? props.label : DEFAULT_LABEL;
    var _useState40 = _sliced_to_array(useState40(""), 2), announcement = _useState40[0], setAnnouncement = _useState40[1];
    var refill = useRef14(void 0);
    useEffect26(function() {
        return function() {
            return clearTimeout(refill.current);
        };
    }, []);
    var press = useCallback6(function() {
        onShowWholeTwin === null || onShowWholeTwin === void 0 ? void 0 : onShowWholeTwin();
        clearTimeout(refill.current);
        setAnnouncement("");
        refill.current = setTimeout(function() {
            return setAnnouncement(ANNOUNCEMENT);
        }, REANNOUNCE_GAP_MS);
    }, [
        onShowWholeTwin
    ]);
    if (!onShowWholeTwin) return null;
    return /* @__PURE__ */ jsxs61(Centre, {
        children: [
            /* @__PURE__ */ jsx90(Hit, {
                children: /* @__PURE__ */ jsx90(Button8, {
                    variant: "frosted",
                    iconLeft: /* @__PURE__ */ jsx90(Icon, {
                        name: "expand"
                    }),
                    onClick: press,
                    children: label
                })
            }),
            /* @__PURE__ */ jsx90("span", {
                role: "status",
                "aria-live": "polite",
                style: visuallyHidden,
                children: announcement
            })
        ]
    });
}
// src/components/DashboardRenderer/panelRegistry.tsx
var PANEL_REGISTRY = {
    TextPanel: TextPanel,
    StatPanel: StatPanel,
    ShowWholeTwin: ShowWholeTwinPanel
};
function getPanelComponent(name) {
    return PANEL_REGISTRY[name];
}
function resolvePanelComponent(name, overlay) {
    var _own;
    return (_own = own(overlay, name)) !== null && _own !== void 0 ? _own : own(PANEL_REGISTRY, name);
}
function own(map, name) {
    return map && Object.prototype.hasOwnProperty.call(map, name) ? map[name] : void 0;
}
// src/components/DashboardRenderer/propsValidation.ts
function checkValue(key, value, schema) {
    var errors = [];
    if (schema.type) {
        var t = schema.type;
        var typeOk = t === "string" && typeof value === "string" || t === "boolean" && typeof value === "boolean" || t === "object" && (typeof value === "undefined" ? "undefined" : _type_of(value)) === "object" && value !== null && !Array.isArray(value) || t === "array" && Array.isArray(value) || t === "number" && typeof value === "number" && Number.isFinite(value) || t === "integer" && typeof value === "number" && Number.isInteger(value);
        if (!typeOk) errors.push('"'.concat(key, '" must be of type ').concat(t));
    }
    if (schema.enum && !schema.enum.includes(value)) {
        errors.push('"'.concat(key, '" must be one of ').concat(JSON.stringify(schema.enum)));
    }
    if (typeof value === "number") {
        if (schema.minimum !== void 0 && value < schema.minimum) {
            errors.push('"'.concat(key, '" must be ≥ ').concat(schema.minimum));
        }
        if (schema.maximum !== void 0 && value > schema.maximum) {
            errors.push('"'.concat(key, '" must be ≤ ').concat(schema.maximum));
        }
    }
    return errors;
}
function validatePanelProps(props, schema) {
    var value = props !== null && props !== void 0 ? props : {};
    var errors = [];
    var _schema_properties;
    var properties = (_schema_properties = schema === null || schema === void 0 ? void 0 : schema.properties) !== null && _schema_properties !== void 0 ? _schema_properties : {};
    var _schema_required;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = ((_schema_required = schema === null || schema === void 0 ? void 0 : schema.required) !== null && _schema_required !== void 0 ? _schema_required : [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (value[key] === void 0) errors.push('missing required prop "'.concat(key, '"'));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if ((schema === null || schema === void 0 ? void 0 : schema.additionalProperties) === false) {
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = Object.keys(value)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var key1 = _step1.value;
                if (!(key1 in properties)) errors.push('unexpected prop "'.concat(key1, '"'));
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
    try {
        for(var _iterator2 = Object.entries(properties)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var _step_value = _sliced_to_array(_step2.value, 2), key2 = _step_value[0], propSchema = _step_value[1];
            if (value[key2] !== void 0) {
                var _errors;
                (_errors = errors).push.apply(_errors, _to_consumable_array(checkValue(key2, value[key2], propSchema)));
            }
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
            }
        } finally{
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }
    return {
        ok: errors.length === 0,
        errors: errors
    };
}
// src/components/DashboardRenderer/PanelBoundary.tsx
import { Component as Component2 } from "react";
var PanelBoundary = /*#__PURE__*/ function(Component2) {
    "use strict";
    _inherits(PanelBoundary, Component2);
    function PanelBoundary() {
        _class_call_check(this, PanelBoundary);
        var _this;
        _this = _call_super(this, PanelBoundary, arguments);
        _this.state = {
            error: null
        };
        return _this;
    }
    _create_class(PanelBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error) {
                console.error("[DashboardRenderer] panel render error:", error);
            }
        },
        {
            key: "render",
            value: function render() {
                if (this.state.error) return this.props.fallback(this.state.error);
                return this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        }
    ]);
    return PanelBoundary;
}(Component2);
// src/components/DashboardRenderer/panels/PanelFallback.tsx
import { ink as ink4, surface as surface2, line, radius, space as space8 } from "@repo/design-tokens";
import { jsx as jsx91, jsxs as jsxs62 } from "react/jsx-runtime";
var NEUTRAL_MESSAGE = "This panel is temporarily unavailable.";
function PanelFallback(param) {
    var title = param.title, detail = param.detail, isAdmin = param.isAdmin, bare = param.bare;
    return /* @__PURE__ */ jsxs62("div", {
        role: "note",
        "data-testid": "panel-fallback",
        "data-degrade-reason": detail.reason,
        "data-bare": bare ? "" : void 0,
        style: _object_spread({
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
            gap: space8[1],
            color: ink4[3]
        }, bare ? {} : {
            height: "100%",
            padding: space8[3],
            background: surface2[1],
            border: "1px dashed ".concat(line[1]),
            borderRadius: radius.lg
        }),
        children: [
            title ? /* @__PURE__ */ jsx91("span", {
                style: {
                    fontSize: "13px",
                    fontWeight: 600,
                    color: ink4[2]
                },
                children: title
            }) : null,
            /* @__PURE__ */ jsx91("span", {
                style: {
                    fontSize: "13px"
                },
                children: NEUTRAL_MESSAGE
            }),
            isAdmin ? /* @__PURE__ */ jsxs62("span", {
                "data-testid": "panel-fallback-diagnostic",
                style: {
                    fontSize: "11px",
                    color: ink4[4],
                    marginTop: "auto"
                },
                children: [
                    detail.reason,
                    ": ",
                    detail.message
                ]
            }) : null
        ]
    });
}
// src/components/DashboardRenderer/resolveBinding.ts
function toResolvedParam(v) {
    if (v === null) return null;
    if (typeof v === "string" || typeof v === "number" || typeof v === "boolean") return v;
    if (Array.isArray(v)) {
        if (v.every(function(x) {
            return typeof x === "string";
        })) return v;
        if (v.every(function(x) {
            return typeof x === "number";
        })) return v;
    }
    return void 0;
}
function resolveControlRef(ref3, controlState) {
    if (!controlState) return void 0;
    var _ref3_split = _to_array(ref3.split(".")), id = _ref3_split[0], path = _ref3_split.slice(1);
    var cur = controlState[id];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = path[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var seg = _step.value;
            if (cur === null || (typeof cur === "undefined" ? "undefined" : _type_of(cur)) !== "object") return void 0;
            cur = cur[seg];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return toResolvedParam(cur);
}
function resolveParam(value, context, controlState) {
    if (value !== null && (typeof value === "undefined" ? "undefined" : _type_of(value)) === "object" && !Array.isArray(value)) {
        if ("fromContext" in value) {
            return value.fromContext === "twin_bid" ? context.twinBid : context.twinName;
        }
        if ("fromControl" in value) {
            return resolveControlRef(value.fromControl, controlState);
        }
    }
    return value;
}
function unresolvedControlParams(binding, context, controlState) {
    if (!binding.params) return [];
    var missing = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(binding.params)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _sliced_to_array(_step.value, 2), key = _step_value[0], value = _step_value[1];
            var isControlRef = value !== null && (typeof value === "undefined" ? "undefined" : _type_of(value)) === "object" && !Array.isArray(value) && "fromControl" in value;
            if (!isControlRef) continue;
            var ref3 = value.fromControl;
            var owner = ref3.split(".")[0];
            if (!controlState || !(owner in controlState)) continue;
            var got = resolveParam(value, context, controlState);
            if (got === void 0 || got === "") missing.push(key);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return missing;
}
function resolveBinding(binding, context, controlState) {
    if (!binding.params) return binding;
    var params = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(binding.params)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _sliced_to_array(_step.value, 2), key = _step_value[0], value = _step_value[1];
            var resolved = resolveParam(value, context, controlState);
            if (resolved !== void 0 && resolved !== null) params[key] = resolved;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        endpoint: binding.endpoint,
        params: params,
        refreshMs: binding.refreshMs
    };
}
function serialiseParamValue(v) {
    if (Array.isArray(v)) return "[".concat(v.join(","), "]");
    return String(v);
}
function bindingIdentity(binding) {
    var _binding_params;
    var params = (_binding_params = binding.params) !== null && _binding_params !== void 0 ? _binding_params : {};
    var parts = Object.keys(params).sort().map(function(k) {
        return "".concat(k, "=").concat(serialiseParamValue(params[k]));
    });
    var refresh = binding.refreshMs === void 0 ? "" : "#refreshMs=".concat(binding.refreshMs);
    return "".concat(binding.endpoint, "?").concat(parts.join("&")).concat(refresh);
}
// src/components/DashboardRenderer/controlState.ts
function seedValue(def, context, component) {
    if (def === null || def === void 0 ? void 0 : def.fromContext) {
        var value = def.fromContext === "twin_bid" ? context.twinBid : context.twinName;
        return MULTI_SELECT_CONTROLS.has(component !== null && component !== void 0 ? component : "") && value !== void 0 ? [
            value
        ] : value;
    }
    if (def && "value" in def) return def.value;
    return void 0;
}
var MULTI_SELECT_CONTROLS = /* @__PURE__ */ new Set([
    "GymMultiSelect"
]);
function seedControlState(definition, context) {
    var state = /* @__PURE__ */ Object.create(null);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = (Array.isArray(definition.controls) ? definition.controls : [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var control = _step.value;
            if (control === null || control === void 0 ? void 0 : control.id) state[control.id] = seedValue(control.default, context, control.component);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = (Array.isArray(definition.panels) ? definition.panels : [])[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var panel = _step1.value;
            var _panel_state;
            if (panel === null || panel === void 0 ? void 0 : (_panel_state = panel.state) === null || _panel_state === void 0 ? void 0 : _panel_state.id) {
                state[panel.state.id] = seedValue(panel.state.default, context, panel.component);
            }
            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
            try {
                for(var _iterator2 = (Array.isArray(panel === null || panel === void 0 ? void 0 : panel.components) ? panel.components : [])[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                    var child = _step2.value;
                    var _child_state;
                    if (child === null || child === void 0 ? void 0 : (_child_state = child.state) === null || _child_state === void 0 ? void 0 : _child_state.id) {
                        state[child.state.id] = seedValue(child.state.default, context, child.component);
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                        _iterator2.return();
                    }
                } finally{
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return state;
}
// src/components/DashboardRenderer/types.ts
var LIVE_SCENE_REQUIREMENT = "live_scene";
function isSingleBinding(data) {
    return !!data && typeof data.endpoint === "string";
}
function namedBindings(data) {
    if (!data) return {};
    if (isSingleBinding(data)) return {
        primary: _object_spread_props(_object_spread({}, data), {
            required: true
        })
    };
    return data;
}
// src/components/DashboardRenderer/DashboardRenderer.tsx
import { jsx as jsx92, jsxs as jsxs63 } from "react/jsx-runtime";
var SUPPORTED_SCHEMA_VERSIONS = [
    1
];
var DEFAULT_CONTROL_GRID = {
    x: 0,
    y: 0,
    w: 3,
    h: 2
};
function startBindingFetch(provider, binding, context, nodeId, onState, onData, warned) {
    var controller = new AbortController();
    var warnKey = "".concat(nodeId !== null && nodeId !== void 0 ? nodeId : "unknown", ":").concat(binding.endpoint);
    var active = true;
    onState("loading");
    var inFlight = false;
    var run = function() {
        if (inFlight) return;
        inFlight = true;
        void Promise.resolve().then(function() {
            return provider.fetch(binding, context, controller.signal);
        }).then(function(envelope) {
            if (active) {
                warned.delete(warnKey);
                onData(envelope);
                onState("ready");
            }
        }).catch(function(err) {
            var name = err === null || err === void 0 ? void 0 : err.name;
            if (name === "AbortError" || name === "CanceledError") return;
            if (!active) return;
            onState("error");
            if (warned.has(warnKey)) return;
            warned.add(warnKey);
            console.warn('[DashboardRenderer] data fetch failed for "'.concat(nodeId !== null && nodeId !== void 0 ? nodeId : "unknown", '" (endpoint "').concat(binding.endpoint, '"): ') + (_instanceof(err, Error) ? "".concat(err.name, ": ").concat(err.message) : String(err)));
        }).finally(function() {
            inFlight = false;
        });
    };
    run();
    var period = binding.refreshMs;
    var timer = typeof period === "number" && Number.isFinite(period) && period > 0 ? setInterval(run, period) : void 0;
    return function() {
        active = false;
        if (timer !== void 0) clearInterval(timer);
        controller.abort();
    };
}
function useResolvedBindings(bindings, context, controlState) {
    var entries = Object.entries(bindings);
    var resolved = entries.map(function(param) {
        var _param = _sliced_to_array(param, 2), name = _param[0], b = _param[1];
        var unresolved = unresolvedControlParams(b, context, controlState);
        var r = unresolved.length === 0 ? resolveBinding(b, context, controlState) : void 0;
        var identity = r ? bindingIdentity(r) : "pending:".concat(unresolved.join(","));
        return {
            name: name,
            binding: r,
            pending: unresolved.length > 0,
            required: b.required === true,
            identity: identity
        };
    });
    var key = resolved.map(function(r) {
        return "".concat(r.name, "=").concat(r.identity).concat(r.required ? "!" : "");
    }).sort().join("|");
    return useMemo6(function() {
        return Object.fromEntries(resolved.map(function(r) {
            return [
                r.name,
                {
                    binding: r.binding,
                    pending: r.pending,
                    required: r.required
                }
            ];
        }));
    }, [
        key
    ]);
}
function usePanelDataMap(provider, resolved, context, nodeId) {
    var _useState41 = _sliced_to_array(useState41({}), 2), fetched = _useState41[0], setFetched = _useState41[1];
    var key = Object.entries(resolved).map(function(param) {
        var _param = _sliced_to_array(param, 2), n = _param[0], r = _param[1];
        return "".concat(n, "=").concat(r.binding ? bindingIdentity(r.binding) : r.pending ? "pending" : "idle");
    }).sort().join("|");
    var multi = Object.keys(resolved).length > 1;
    var active = useRef15(/* @__PURE__ */ new Map());
    var depsKey = useRef15("");
    var lastProvider = useRef15(provider);
    var lastContext = useRef15(context);
    var warnedFetches = useRef15(/* @__PURE__ */ new Set());
    useEffect27(function() {
        var wanted = /* @__PURE__ */ new Map();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.entries(resolved)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = _sliced_to_array(_step.value, 2), name = _step_value[0], r = _step_value[1];
                wanted.set(name, r.binding ? bindingIdentity(r.binding) : r.pending ? "pending" : "idle");
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var deps = "".concat(nodeId !== null && nodeId !== void 0 ? nodeId : "", "|").concat(multi);
        if (depsKey.current !== deps || lastProvider.current !== provider || lastContext.current !== context) {
            active.current.forEach(function(e) {
                return e.cancel();
            });
            active.current.clear();
            depsKey.current = deps;
            lastProvider.current = provider;
            lastContext.current = context;
        }
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = Array.from(active.current.entries())[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var _step_value1 = _sliced_to_array(_step1.value, 2), name1 = _step_value1[0], entry = _step_value1[1];
                if (wanted.get(name1) !== entry.identity) {
                    entry.cancel();
                    active.current.delete(name1);
                }
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
        try {
            var _loop = function() {
                var _step_value = _sliced_to_array(_step2.value, 2), name = _step_value[0], r = _step_value[1];
                if (active.current.has(name)) return "continue";
                var _wanted_get;
                var identity = (_wanted_get = wanted.get(name)) !== null && _wanted_get !== void 0 ? _wanted_get : "idle";
                if (!r.binding) {
                    var state = r.pending ? "loading" : "idle";
                    setFetched(function(prev) {
                        var _prev_name;
                        return _object_spread_props(_object_spread({}, prev), _define_property({}, name, {
                            state: state,
                            data: (_prev_name = prev[name]) === null || _prev_name === void 0 ? void 0 : _prev_name.data
                        }));
                    });
                    active.current.set(name, {
                        identity: identity,
                        cancel: function() {}
                    });
                    return "continue";
                }
                active.current.set(name, {
                    identity: identity,
                    cancel: startBindingFetch(provider, r.binding, context, // ⚠️ THE BINDING NAME IS APPENDED ONLY WHEN THERE IS MORE THAN ONE. With four bindings
                    // "data fetch failed for side-by-side-card" is ambiguous and the name is the diagnostic;
                    // with one it is noise, and it would change the log line every single-binding panel in
                    // the estate emits — for no gain, and breaking the pin that covers it.
                    multi && nodeId ? "".concat(nodeId, ":").concat(name) : nodeId, function(st) {
                        return setFetched(function(prev) {
                            return _object_spread_props(_object_spread({}, prev), _define_property({}, name, _object_spread_props(_object_spread({}, prev[name]), {
                                state: st
                            })));
                        });
                    }, // ⭐ THE ENVELOPE IS STORED WITH THE IDENTITY IT ANSWERS. Without that, a panel cannot
                    // tell a current answer from the previous scope's — and the control moves a render
                    // BEFORE the binding does, so there is always a window where the two disagree.
                    function(env) {
                        return setFetched(function(prev) {
                            return _object_spread_props(_object_spread({}, prev), _define_property({}, name, _object_spread_props(_object_spread({}, prev[name]), {
                                data: env,
                                identity: identity
                            })));
                        });
                    }, warnedFetches.current)
                });
            };
            for(var _iterator2 = Object.entries(resolved)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true)_loop();
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                    _iterator2.return();
                }
            } finally{
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }
    }, [
        key,
        provider,
        context,
        nodeId,
        multi
    ]);
    useEffect27(function() {
        var inFlight = active.current;
        return function() {
            inFlight.forEach(function(e) {
                return e.cancel();
            });
            inFlight.clear();
        };
    }, []);
    return useMemo6(function() {
        return Object.fromEntries(Object.entries(resolved).map(function(param) {
            var _param = _sliced_to_array(param, 2), name = _param[0], r = _param[1];
            var _fetched_name, _r_binding, _fetched_name1, _fetched_name2;
            var _fetched_name_state;
            return [
                name,
                {
                    data: (_fetched_name = fetched[name]) === null || _fetched_name === void 0 ? void 0 : _fetched_name.data,
                    endpoint: (_r_binding = r.binding) === null || _r_binding === void 0 ? void 0 : _r_binding.endpoint,
                    state: (_fetched_name_state = (_fetched_name1 = fetched[name]) === null || _fetched_name1 === void 0 ? void 0 : _fetched_name1.state) !== null && _fetched_name_state !== void 0 ? _fetched_name_state : r.binding || r.pending ? "loading" : "idle",
                    required: r.required,
                    /**
           * Does the envelope in `data` answer the request this binding is making NOW?
           *
           * 🚨 IT IS OFTEN NOT, AND NOTHING USED TO SAY SO. The previous envelope is deliberately
           * retained across a refetch, and a control change re-renders the panel a beat before
           * the fetch effect runs — so there is always a window in which `data` is the previous
           * scope's answer while the panel's props already describe the new one. A panel that
           * judges one by the other either paints the wrong scope's numbers or, worse, decides
           * there is no data and says so.
           */ answersCurrentRequest: r.binding !== void 0 && ((_fetched_name2 = fetched[name]) === null || _fetched_name2 === void 0 ? void 0 : _fetched_name2.identity) === bindingIdentity(r.binding)
                }
            ];
        }));
    }, [
        key,
        fetched,
        resolved
    ]);
}
function isContained(grid, autoTracks) {
    return autoTracks && (grid === null || grid === void 0 ? void 0 : grid.grow) === false;
}
function gridCellStyle(grid, autoTracks) {
    var g = grid !== null && grid !== void 0 ? grid : {
        x: 0,
        y: 0,
        w: 12,
        h: 2
    };
    var x = Number.isFinite(g.x) ? g.x : 0;
    var y = Number.isFinite(g.y) ? g.y : 0;
    var w = Number.isFinite(g.w) && g.w > 0 ? g.w : 12;
    var h = Number.isFinite(g.h) && g.h > 0 ? g.h : 2;
    var base = {
        gridColumn: "".concat(x + 1, " / span ").concat(w),
        gridRow: "".concat(y + 1, " / span ").concat(h),
        minWidth: 0
    };
    if (isContained(grid, autoTracks)) {
        return _object_spread_props(_object_spread({}, base), {
            contain: "size",
            overflow: "hidden"
        });
    }
    return base;
}
var FLEX_ALIGN = {
    start: "flex-start",
    center: "center",
    end: "flex-end",
    stretch: "stretch"
};
function manifestEntry(map, name) {
    return Object.prototype.hasOwnProperty.call(map, name) ? map[name] : void 0;
}
function layoutGap(layout) {
    var _layout_gap, _manifestEntry;
    return (_manifestEntry = manifestEntry(space9, String((_layout_gap = layout === null || layout === void 0 ? void 0 : layout.gap) !== null && _layout_gap !== void 0 ? _layout_gap : 2))) !== null && _manifestEntry !== void 0 ? _manifestEntry : space9[2];
}
function layoutAlign(layout) {
    var _ref;
    return (_ref = (layout === null || layout === void 0 ? void 0 : layout.align) && manifestEntry(FLEX_ALIGN, layout.align)) !== null && _ref !== void 0 ? _ref : "stretch";
}
var warnedOnce = /* @__PURE__ */ new Set();
function warnOnce(message) {
    if (warnedOnce.has(message)) return;
    warnedOnce.add(message);
    console.warn(message);
}
function safeForLog(value) {
    var flat = value.replace(/[\u0000-\u001f\u007f-\u009f\u2028\u2029]/g, " ");
    return flat.length > 120 ? "".concat(flat.slice(0, 120), "…") : flat;
}
function groupIntoRows(rendered, ids, layout, panelId) {
    var rows = layout === null || layout === void 0 ? void 0 : layout.rows;
    if (rows === void 0) return rendered;
    if (!Array.isArray(rows) || rows.length === 0) {
        warnOnce('[DashboardRenderer] panel "'.concat(safeForLog(panelId), '" panelLayout.rows is not a non-empty array; ignoring it and rendering the components in order.'));
        return rendered;
    }
    var notArrays = rows.map(function(row, i) {
        return Array.isArray(row) ? -1 : i;
    }).filter(function(i) {
        return i >= 0;
    });
    var emptyRows = rows.map(function(row, i) {
        return Array.isArray(row) && row.length === 0 ? i : -1;
    }).filter(function(i) {
        return i >= 0;
    });
    var nonStrings = rows.map(function(row, i) {
        return Array.isArray(row) && row.some(function(v) {
            return typeof v !== "string";
        }) ? i : -1;
    }).filter(function(i) {
        return i >= 0;
    });
    var shapeOk = notArrays.length === 0 && emptyRows.length === 0 && nonStrings.length === 0;
    var named = shapeOk ? rows.flat() : [];
    var unknown = named.filter(function(id) {
        return !ids.includes(id);
    });
    var missing = ids.filter(function(id) {
        return !named.includes(id);
    });
    var duplicated = named.filter(function(id, i) {
        return named.indexOf(id) !== i;
    });
    var duplicatedChildren = ids.filter(function(id, i) {
        return ids.indexOf(id) !== i;
    });
    if (!shapeOk || unknown.length || missing.length || duplicated.length || duplicatedChildren.length) {
        warnOnce('[DashboardRenderer] panel "'.concat(safeForLog(panelId), '" panelLayout.rows does not partition its components; ignoring it and rendering them in order. ').concat(notArrays.length ? "rows at index [".concat(notArrays.join(", "), "] are not arrays. ") : "").concat(emptyRows.length ? "rows at index [".concat(emptyRows.join(", "), "] are empty. ") : "").concat(nonStrings.length ? "rows at index [".concat(nonStrings.join(", "), "] hold a non-string. ") : "", "unknown: [").concat(safeForLog(unknown.join(", ")), "] missing: [").concat(safeForLog(missing.join(", ")), "] duplicated: [").concat(safeForLog(duplicated.join(", ")), "] duplicate component ids: [").concat(safeForLog(duplicatedChildren.join(", ")), "]"));
        return rendered;
    }
    var byId = new Map(ids.map(function(id, i) {
        return [
            id,
            rendered[i]
        ];
    }));
    var gap = layoutGap(layout);
    var alignItems = layoutAlign(layout);
    var rowDirection = (layout === null || layout === void 0 ? void 0 : layout.direction) === "row" ? "column" : "row";
    return rows.map(function(row, i) {
        if (row.length === 1) return byId.get(row[0]);
        return /* @__PURE__ */ jsx92("div", {
            style: {
                display: "flex",
                flexDirection: rowDirection,
                gap: gap,
                alignItems: alignItems,
                // `alignSelf`, not `width: 100%`: the row must fill the body's CROSS axis, and which
                // axis that is follows `direction`. A hardcoded width is only correct for a `column`
                // body — under `direction: "row"` the wrappers would each demand the full width and
                // flex-shrink would divide the space equally, silently turning authored rows into
                // equal-width columns. `stretch` is the same 798px today and correct in both.
                alignSelf: "stretch"
            },
            children: row.map(function(id) {
                return byId.get(id);
            })
        }, "row:".concat(i, ":").concat(row.join(",")));
    });
}
var cardStyle = {
    height: "100%",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    gap: space9[2],
    padding: space9[3],
    background: surface3[0],
    border: "1px solid ".concat(line2[1]),
    borderRadius: radius2.lg
};
function PanelCard2(param) {
    var title = param.title, titleId = param.titleId, scrollBody = param.scrollBody, layout = param.layout, children = param.children;
    var fillsPane = Boolean(scrollBody) && !layout;
    var body = /* @__PURE__ */ jsx92("div", {
        style: _object_spread({
            flex: 1,
            minHeight: 0
        }, fillsPane ? {
            height: "100%",
            display: "grid",
            gridTemplateRows: "1fr"
        } : {}, layout ? {
            display: "flex",
            flexDirection: layout.direction === "row" ? "row" : "column",
            gap: layoutGap(layout),
            alignItems: layoutAlign(layout)
        } : {}),
        "data-panel-body-fills-pane": fillsPane ? "true" : void 0,
        children: children
    });
    return /* @__PURE__ */ jsxs63("div", {
        style: cardStyle,
        "data-panel-card": true,
        children: [
            title ? /* @__PURE__ */ jsx92("span", {
                id: titleId,
                style: {
                    fontSize: "12px",
                    fontWeight: 600,
                    color: ink5[3]
                },
                children: title
            }) : null,
            scrollBody ? /* @__PURE__ */ jsx92(Scrollbar3, {
                variant: "onSolid",
                maxHeight: "100%",
                className: "panel-scroll",
                children: body
            }) : body
        ]
    });
}
function ComponentHost(param) {
    var node = param.node, panelTitle = param.panelTitle, card = param.card, context = param.context, viewContext = param.viewContext, provider = param.provider, panelComponents = param.panelComponents, hostActions = param.hostActions, hostValues = param.hostValues, isAdmin = param.isAdmin, controlState = param.controlState, cellNoun = param.noun, value = param.value, onChange = param.onChange, ariaControls = param.ariaControls;
    var bare = !card;
    var noun = bare ? "component" : cellNoun;
    var panelEntry = cellNoun === "control" ? void 0 : manifestEntry(DASHBOARD_PANEL_MANIFEST.panels, node.component);
    var controlEntry = manifestEntry(DASHBOARD_PANEL_MANIFEST.controls, node.component);
    var entry = panelEntry !== null && panelEntry !== void 0 ? panelEntry : controlEntry;
    var Component3 = resolvePanelComponent(node.component, panelComponents);
    var isDataPanel = Boolean(entry === null || entry === void 0 ? void 0 : entry.requiresData);
    var rendersThroughDataError = panelEntry === void 0 && controlEntry !== void 0;
    var allowsData = Boolean(entry === null || entry === void 0 ? void 0 : entry.optionalData);
    var propsCheck = entry ? validatePanelProps(node.props, entry.propsSchema) : void 0;
    var canRender = !!Component3 && !!entry && !!(propsCheck === null || propsCheck === void 0 ? void 0 : propsCheck.ok);
    var declared = useMemo6(function() {
        return canRender && (isDataPanel || allowsData) ? namedBindings(node.data) : {};
    }, [
        canRender,
        isDataPanel,
        allowsData,
        node.data
    ]);
    var resolvedBindings = useResolvedBindings(declared, context, controlState);
    var bindings = usePanelDataMap(provider, resolvedBindings, context, node.id);
    var primary = bindings.primary;
    var data = primary === null || primary === void 0 ? void 0 : primary.data;
    var _primary_state;
    var state = (_primary_state = primary === null || primary === void 0 ? void 0 : primary.state) !== null && _primary_state !== void 0 ? _primary_state : "idle";
    var dataIsCurrent = (primary === null || primary === void 0 ? void 0 : primary.answersCurrentRequest) === true;
    var failedRequired = Object.entries(bindings).filter(function(param) {
        var _param = _sliced_to_array(param, 2), b = _param[1];
        return b.required && b.state === "error";
    });
    var anyRequiredFailed = failedRequired.length > 0;
    var fallback = function(detail) {
        return /* @__PURE__ */ jsx92(PanelFallback, {
            title: panelTitle,
            detail: detail,
            isAdmin: isAdmin,
            bare: bare
        });
    };
    if (!Component3 || !entry) {
        return fallback({
            reason: "unknown-component",
            message: "no ".concat(noun, ' component named "').concat(node.component, '"')
        });
    }
    if (propsCheck && !propsCheck.ok) {
        return fallback({
            reason: "props-invalid",
            message: propsCheck.errors.join("; ")
        });
    }
    if (isDataPanel && Object.keys(declared).length === 0) {
        return fallback({
            reason: "props-invalid",
            message: "".concat(noun, ' "').concat(node.id, '" (').concat(node.component, ") is missing its data binding")
        });
    }
    if (!isDataPanel && !allowsData && node.data) {
        return fallback({
            reason: "props-invalid",
            message: "".concat(noun, ' "').concat(node.id, '" (').concat(node.component, ") is static and must not declare a data binding")
        });
    }
    if (isDataPanel && !rendersThroughDataError && anyRequiredFailed) {
        return fallback({
            reason: "data-error",
            // ⚠️ NAMES THE BINDING, not only the endpoint — the one diagnostic the named form bought. Two
            // required sides of a comparison bind the SAME endpoint, so an endpoint-only message prints
            // it twice and identifies neither. Singular/plural because N is now genuinely variable.
            message: "data provider failed for ".concat(failedRequired.length === 1 ? "binding" : "bindings", " ").concat(failedRequired.map(function(param) {
                var _param = _sliced_to_array(param, 2), name = _param[0], b = _param[1];
                return "".concat(name, ' ("').concat(b.endpoint, '")');
            }).join(", "))
        });
    }
    var _node_props;
    var rendered = /* @__PURE__ */ jsx92(Component3, {
        title: panelTitle,
        props: (_node_props = node.props) !== null && _node_props !== void 0 ? _node_props : {},
        data: data,
        endpoint: primary === null || primary === void 0 ? void 0 : primary.endpoint,
        state: state,
        dataIsCurrent: dataIsCurrent,
        bindings: bindings,
        context: viewContext,
        controlState: controlState,
        value: value,
        onChange: onChange,
        ariaControls: ariaControls,
        hostActions: hostActions,
        hostValues: hostValues,
        isAdmin: isAdmin,
        inComposite: bare
    });
    return card ? /* @__PURE__ */ jsx92(PanelBoundary, {
        fallback: function(err) {
            return fallback({
                reason: "render-error",
                message: err.message
            });
        },
        children: card(rendered)
    }) : rendered;
}
function controlAsPanel(control) {
    var _control_grid;
    return {
        id: control === null || control === void 0 ? void 0 : control.id,
        component: control === null || control === void 0 ? void 0 : control.component,
        props: control === null || control === void 0 ? void 0 : control.params,
        grid: (_control_grid = control === null || control === void 0 ? void 0 : control.grid) !== null && _control_grid !== void 0 ? _control_grid : DEFAULT_CONTROL_GRID,
        data: control === null || control === void 0 ? void 0 : control.data,
        state: {
            id: control === null || control === void 0 ? void 0 : control.id,
            default: control === null || control === void 0 ? void 0 : control.default
        }
    };
}
function gridOrd(v) {
    return typeof v === "number" && Number.isFinite(v) ? v : 0;
}
function normaliseCells(slug, panels, controls) {
    var drafts = _to_consumable_array(panels.filter(Boolean).map(function(panel) {
        return {
            panel: panel,
            componentTitle: panel === null || panel === void 0 ? void 0 : panel.title,
            noun: "panel",
            /** Only a panel-authored cell may be an `aria-controls` TARGET at CELL level.
       *  `controls[]` entries are still not addressable — "a control is not a region a
       *  switcher can meaningfully be said to control". Row 36 widened the target set to
       *  include a composite's own CHILDREN (see `componentDomIds`), because a switcher and
       *  the chart it drives may now share one cell; `validate.ts` resolves against exactly
       *  the same two sets, and panels win over components on a name clash in both. Two
       *  contracts for one lookup is the divergence this whole feature exists to stop. */ addressable: true
        };
    })).concat(_to_consumable_array(controls.filter(Boolean).map(function(control) {
        var _panel_props;
        var panel = controlAsPanel(control);
        return {
            panel: panel,
            componentTitle: typeof ((_panel_props = panel.props) === null || _panel_props === void 0 ? void 0 : _panel_props.title) === "string" ? panel.props.title : void 0,
            noun: "control",
            addressable: false
        };
    })));
    drafts.sort(function(a, b) {
        var _a_panel_grid, _b_panel_grid, _a_panel_grid1, _b_panel_grid1;
        var ay = gridOrd((_a_panel_grid = a.panel.grid) === null || _a_panel_grid === void 0 ? void 0 : _a_panel_grid.y);
        var by = gridOrd((_b_panel_grid = b.panel.grid) === null || _b_panel_grid === void 0 ? void 0 : _b_panel_grid.y);
        if (ay !== by) return ay - by;
        var ax = gridOrd((_a_panel_grid1 = a.panel.grid) === null || _a_panel_grid1 === void 0 ? void 0 : _a_panel_grid1.x);
        var bx = gridOrd((_b_panel_grid1 = b.panel.grid) === null || _b_panel_grid1 === void 0 ? void 0 : _b_panel_grid1.x);
        if (ax !== bx) return ax - bx;
        var _a_panel_id;
        var aid = String((_a_panel_id = a.panel.id) !== null && _a_panel_id !== void 0 ? _a_panel_id : "");
        var _b_panel_id;
        var bid = String((_b_panel_id = b.panel.id) !== null && _b_panel_id !== void 0 ? _b_panel_id : "");
        return aid < bid ? -1 : aid > bid ? 1 : 0;
    });
    var idSafe = function(v) {
        return String(v !== null && v !== void 0 ? v : "").replace(/[^A-Za-z0-9_-]/g, "-");
    };
    var safeSlug = idSafe(slug) || "dashboard";
    var panelIdSet = new Set(panels.filter(Boolean).map(function(p) {
        return p.id;
    }));
    var referenced = /* @__PURE__ */ new Set();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = panels.filter(Boolean)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var p = _step.value;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = (Array.isArray(p.components) ? p.components : [])[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var c = _step1.value;
                    if ((c === null || c === void 0 ? void 0 : c.controlsPanel) && !panelIdSet.has(c.controlsPanel)) referenced.add(c.controlsPanel);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var taken = /* @__PURE__ */ new Set();
    var byPanelId = /* @__PURE__ */ new Map();
    var cells = drafts.map(function(draft) {
        var safe = idSafe(draft.panel.id) || "cell";
        var domId = "dash-".concat(safeSlug, "-").concat(safe);
        for(var n = 2; taken.has(domId); n++)domId = "dash-".concat(safeSlug, "-").concat(safe, "-").concat(n);
        taken.add(domId);
        var titleDomId = "".concat(domId, "-title");
        for(var n1 = 2; taken.has(titleDomId); n1++)titleDomId = "".concat(domId, "-title-").concat(n1);
        taken.add(titleDomId);
        if (draft.addressable && !byPanelId.has(draft.panel.id)) {
            byPanelId.set(draft.panel.id, domId);
        }
        var componentDomIds = /* @__PURE__ */ new Map();
        var childList = Array.isArray(draft.panel.components) ? draft.panel.components : [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = childList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var child = _step.value;
                if (!(child === null || child === void 0 ? void 0 : child.id)) continue;
                if (!referenced.has(child.id)) continue;
                var childDomId = "".concat(domId, "-").concat(idSafe(child.id));
                for(var n2 = 2; taken.has(childDomId); n2++)childDomId = "".concat(domId, "-").concat(idSafe(child.id), "-").concat(n2);
                taken.add(childDomId);
                if (!componentDomIds.has(child.id)) componentDomIds.set(child.id, childDomId);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return {
            key: domId,
            domId: domId,
            titleDomId: titleDomId,
            componentDomIds: componentDomIds,
            panel: draft.panel,
            componentTitle: draft.componentTitle,
            noun: draft.noun
        };
    });
    return {
        cells: cells,
        domIdOf: function(panelId) {
            return byPanelId.get(panelId);
        }
    };
}
function PanelShell(param) {
    var cell = param.cell, context = param.context, viewContext = param.viewContext, provider = param.provider, panelComponents = param.panelComponents, hostActions = param.hostActions, hostValues = param.hostValues, isAdmin = param.isAdmin, capability = param.capability, controlState = param.controlState, onControlChange = param.onControlChange, autoTracks = param.autoTracks, domIdOf = param.domIdOf;
    var panel = cell.panel, domId = cell.domId, titleDomId = cell.titleDomId, componentTitle = cell.componentTitle, noun = cell.noun;
    var cardTitle = panel.title;
    var cellStyle = gridCellStyle(panel.grid, autoTracks);
    var scrollBody = isContained(panel.grid, autoTracks);
    var cellProps = {
        id: domId,
        style: cellStyle
    };
    if (!capability.schemaOk) {
        return /* @__PURE__ */ jsx92("div", _object_spread_props(_object_spread({}, cellProps), {
            children: /* @__PURE__ */ jsx92(PanelFallback, {
                title: componentTitle,
                isAdmin: isAdmin,
                detail: {
                    reason: "schema-version-unsupported",
                    message: "dashboard schemaVersion is not supported by this app"
                }
            })
        }));
    }
    if (!capability.manifestOk) {
        return /* @__PURE__ */ jsx92("div", _object_spread_props(_object_spread({}, cellProps), {
            children: /* @__PURE__ */ jsx92(PanelFallback, {
                title: componentTitle,
                isAdmin: isAdmin,
                detail: {
                    reason: "manifest-version-unsupported",
                    message: "dashboard requires a newer panel manifest than this app has"
                }
            })
        }));
    }
    var shared = {
        context: context,
        viewContext: viewContext,
        provider: provider,
        panelComponents: panelComponents,
        // The SINGLE fan-out point: `shared` already feeds both the composite-child arm and the
        // plain-panel arm, so the host channels reach every `ComponentHost` from here and are
        // never threaded twice.
        hostActions: hostActions,
        hostValues: hostValues,
        isAdmin: isAdmin,
        controlState: controlState,
        noun: noun
    };
    var resolveControlsPanel = function(ref3) {
        if (ref3 === void 0) return void 0;
        var _domIdOf;
        var resolved = (_domIdOf = domIdOf(ref3)) !== null && _domIdOf !== void 0 ? _domIdOf : cell.componentDomIds.get(ref3);
        if (resolved === void 0) {
            warnOnce('[DashboardRenderer] "'.concat(safeForLog(panel.id), '" declares controlsPanel "').concat(safeForLog(ref3), '", which names no panel in this definition and no sibling component of this one; no aria-controls was emitted.'));
        }
        return resolved;
    };
    var wiring = function(node) {
        return {
            value: node.state ? controlState[node.state.id] : void 0,
            onChange: node.state ? function(next) {
                return onControlChange(node.state.id, next);
            } : void 0,
            // An UNRESOLVABLE `controlsPanel` emits nothing rather than a dangling reference:
            // `aria-controls` pointing at an id that is not in the document is worse than absent,
            // because a screen reader announces a relationship to a region that does not exist.
            // The validator rejects one, so this only bites a definition that bypassed validation
            // — but it is said out loud rather than resolved quietly, because the sibling
            // bypassed-validation branches in this file (an empty composite, both arms populated)
            // all warn, and one policy applied two ways is how a silent path survives review.
            ariaControls: resolveControlsPanel(node.controlsPanel)
        };
    };
    if (panel.components !== void 0) {
        var children = Array.isArray(panel.components) ? panel.components : [];
        if (children.length === 0) {
            console.warn('[DashboardRenderer] composite panel "'.concat(panel.id, '" declares no usable components (got ').concat(JSON.stringify(panel.components), "); the schema requires at least one."));
            return /* @__PURE__ */ jsx92("div", _object_spread_props(_object_spread({}, cellProps), {
                children: /* @__PURE__ */ jsx92(PanelFallback, {
                    title: cardTitle,
                    isAdmin: isAdmin,
                    detail: {
                        reason: "props-invalid",
                        message: 'composite panel "'.concat(panel.id, '" declares no components')
                    }
                })
            }));
        }
        if (panel.component) {
            console.warn('[DashboardRenderer] panel "'.concat(panel.id, '" declares BOTH component "').concat(panel.component, "\" and components[]; rendering the composite and ignoring the panel's own component").concat(panel.data ? ' and its "'.concat(panel.data.endpoint, '" binding') : "", "."));
        }
        var titleId = cardTitle ? titleDomId : void 0;
        var _panel_panelLayout;
        return /* @__PURE__ */ jsx92("div", _object_spread_props(_object_spread({}, cellProps), {
            role: "group",
            "aria-labelledby": titleId,
            "aria-label": titleId ? void 0 : panel.ariaLabel,
            children: /* @__PURE__ */ jsx92(PanelCard2, {
                title: cardTitle,
                titleId: titleId,
                scrollBody: scrollBody,
                layout: (_panel_panelLayout = panel.panelLayout) !== null && _panel_panelLayout !== void 0 ? _panel_panelLayout : {},
                children: groupIntoRows(// The FIRST child to own each reserved DOM id, so a duplicate sibling id (reachable
                // only on a bypassed-validation definition) does not stamp two elements with one id.
                // `componentDomIds` is first-writer-wins, so the owner is the first occurrence.
                function(emitted) {
                    return children.map(function(child, i) {
                        var hosted = /* @__PURE__ */ jsx92(PanelBoundary, {
                            fallback: function(err) {
                                return /* @__PURE__ */ jsx92(PanelFallback, {
                                    bare: true,
                                    isAdmin: isAdmin,
                                    detail: {
                                        reason: "render-error",
                                        message: err.message
                                    }
                                });
                            },
                            children: /* @__PURE__ */ jsx92(ComponentHost, _object_spread({
                                node: child
                            }, shared, wiring(child)))
                        });
                        var ownDomId = (child === null || child === void 0 ? void 0 : child.id) ? cell.componentDomIds.get(child.id) : void 0;
                        var childDomId = ownDomId && !emitted.has(ownDomId) ? ownDomId : void 0;
                        if (childDomId) emitted.add(childDomId);
                        var _child_id;
                        if (!childDomId) return /* @__PURE__ */ jsx92(Fragment18, {
                            children: hosted
                        }, "".concat(i, ":").concat((_child_id = child === null || child === void 0 ? void 0 : child.id) !== null && _child_id !== void 0 ? _child_id : ""));
                        var _panel_ariaLabel, _ref, _child_id1;
                        return /* @__PURE__ */ jsx92("div", {
                            id: childDomId,
                            style: {
                                display: "contents"
                            },
                            role: "group",
                            "aria-label": (_ref = (_panel_ariaLabel = panel.ariaLabel) !== null && _panel_ariaLabel !== void 0 ? _panel_ariaLabel : cardTitle) !== null && _ref !== void 0 ? _ref : void 0,
                            children: hosted
                        }, "".concat(i, ":").concat((_child_id1 = child === null || child === void 0 ? void 0 : child.id) !== null && _child_id1 !== void 0 ? _child_id1 : ""));
                    });
                }(/* @__PURE__ */ new Set()), // `child?.id ?? ''` keeps this array positionally aligned with the rendered one
                // even when a child is nullish, so `groupIntoRows`' missing/duplicate checks stay
                // honest instead of throwing.
                children.map(function(child) {
                    var _child_id;
                    return (_child_id = child === null || child === void 0 ? void 0 : child.id) !== null && _child_id !== void 0 ? _child_id : "";
                }), panel.panelLayout, panel.id)
            })
        }));
    }
    var frameless = panel.chrome === "none";
    var _panel_component;
    return /* @__PURE__ */ jsx92("div", _object_spread_props(_object_spread({}, cellProps), {
        "data-chrome": frameless ? "none" : void 0,
        children: /* @__PURE__ */ jsx92(ComponentHost, _object_spread({
            node: {
                id: panel.id,
                component: (_panel_component = panel.component) !== null && _panel_component !== void 0 ? _panel_component : "",
                props: panel.props,
                data: panel.data,
                state: panel.state,
                controlsPanel: panel.controlsPanel
            },
            panelTitle: frameless ? void 0 : componentTitle,
            card: frameless ? function(content) {
                return content;
            } : function(content) {
                return(// No `layout`: `panelLayout` governs how a COMPOSITE stacks its children, and
                // the schema forbids it on this arm. Passing it here would turn a single
                // component's card body into a flex container — silently changing the layout
                // of a chart wrapper that relies on a block body — while the schema, `types.ts`
                // and this file all documented it as inert.
                /* @__PURE__ */ jsx92(PanelCard2, {
                    title: cardTitle,
                    titleId: cardTitle ? titleDomId : void 0,
                    scrollBody: scrollBody,
                    children: content
                }));
            }
        }, shared, wiring(panel)))
    }));
}
function DashboardRenderer(param) {
    var definition = param.definition, context = param.context, dataProvider = param.dataProvider, panelComponents = param.panelComponents, hostActions = param.hostActions, hostValues = param.hostValues, isAdmin = param.isAdmin, className = param.className;
    var _definition_layout, _definition_layout1, _definition_layout2, _definition_layout3, _definition_layout4;
    var capability = useMemo6(function() {
        var schemaOk = SUPPORTED_SCHEMA_VERSIONS.includes(definition.schemaVersion);
        var manifestOk = definition.requiresManifestVersion <= CURRENT_MANIFEST_VERSION;
        if (!schemaOk || !manifestOk) {
            console.warn('[DashboardRenderer] "'.concat(definition.slug, '" degraded EVERY cell: schemaVersion ').concat(definition.schemaVersion, " (supported: ").concat(SUPPORTED_SCHEMA_VERSIONS.join(", "), "), requiresManifestVersion ").concat(definition.requiresManifestVersion, " (runtime has ").concat(CURRENT_MANIFEST_VERSION, ")."));
        }
        return {
            schemaOk: schemaOk,
            manifestOk: manifestOk
        };
    }, [
        definition.slug,
        definition.schemaVersion,
        definition.requiresManifestVersion
    ]);
    var dataContext = useMemo6(function() {
        return {
            twinBid: context.twinBid,
            twinName: context.twinName
        };
    }, [
        context.twinBid,
        context.twinName
    ]);
    var twinsKey = context.twins ? JSON.stringify(context.twins) : "";
    var viewContext = useMemo6(function() {
        return {
            twinBid: context.twinBid,
            twinName: context.twinName,
            // Parsed back from the key so the OBJECT identity follows the CONTENT: an equal list yields the
            // same memo result, and a changed one yields a new object exactly once.
            twins: twinsKey ? JSON.parse(twinsKey) : void 0
        };
    }, [
        context.twinBid,
        context.twinName,
        twinsKey
    ]);
    var controls = useMemo6(function() {
        return Array.isArray(definition.controls) ? definition.controls : [];
    }, [
        definition.controls
    ]);
    var panels = useMemo6(function() {
        return Array.isArray(definition.panels) ? definition.panels : [];
    }, [
        definition.panels
    ]);
    var _useMemo6 = useMemo6(function() {
        return normaliseCells(definition.slug, panels, controls);
    }, [
        definition.slug,
        panels,
        controls
    ]), cells = _useMemo6.cells, domIdOf = _useMemo6.domIdOf;
    var _useState41 = _sliced_to_array(useState41(function() {
        return seedControlState({
            controls: controls,
            panels: panels
        }, dataContext);
    }), 2), controlState = _useState41[0], setControlState = _useState41[1];
    var setControlValue = useCallback7(function(id, next) {
        setControlState(function(prev) {
            return _object_spread_props(_object_spread({}, prev), _define_property({}, id, next));
        });
    }, []);
    var _definition_layout_columns;
    var columns = (_definition_layout_columns = (_definition_layout = definition.layout) === null || _definition_layout === void 0 ? void 0 : _definition_layout.columns) !== null && _definition_layout_columns !== void 0 ? _definition_layout_columns : 12;
    var rowHeight = (_definition_layout1 = definition.layout) === null || _definition_layout1 === void 0 ? void 0 : _definition_layout1.rowHeight;
    var rowSizing = ((_definition_layout2 = definition.layout) === null || _definition_layout2 === void 0 ? void 0 : _definition_layout2.rowSizing) === "auto" ? "auto" : "fixed";
    var autoTracks = rowSizing === "auto" || !(rowHeight && rowHeight > 0);
    var gridAutoRows = rowHeight && rowHeight > 0 ? rowSizing === "auto" ? "minmax(".concat(rowHeight, "px, auto)") : "".concat(rowHeight, "px") : "minmax(88px, auto)";
    var rowGap = (_definition_layout3 = definition.layout) === null || _definition_layout3 === void 0 ? void 0 : _definition_layout3.rowGap;
    var columnGap = (_definition_layout4 = definition.layout) === null || _definition_layout4 === void 0 ? void 0 : _definition_layout4.columnGap;
    var rowGapCss = rowGap != null && rowGap >= 0 ? "".concat(rowGap, "px") : space9[3];
    var columnGapCss = columnGap != null && columnGap >= 0 ? "".concat(columnGap, "px") : space9[3];
    return /* @__PURE__ */ jsx92("div", {
        className: className,
        "data-testid": "dashboard-renderer",
        "data-dashboard-slug": definition.slug,
        style: {
            display: "grid",
            gridTemplateColumns: "repeat(".concat(columns, ", 1fr)"),
            gridAutoRows: gridAutoRows,
            rowGap: rowGapCss,
            columnGap: columnGapCss,
            width: "100%"
        },
        children: cells.map(function(cell) {
            return /* @__PURE__ */ jsx92(PanelBoundary, {
                fallback: function(err) {
                    return /* @__PURE__ */ jsx92("div", {
                        id: cell.domId,
                        style: gridCellStyle(cell.panel.grid, autoTracks),
                        children: /* @__PURE__ */ jsx92(PanelFallback, {
                            title: cell.componentTitle,
                            detail: {
                                reason: "render-error",
                                message: err.message
                            },
                            isAdmin: isAdmin
                        })
                    });
                },
                children: /* @__PURE__ */ jsx92(PanelShell, {
                    cell: cell,
                    context: dataContext,
                    viewContext: viewContext,
                    provider: dataProvider,
                    panelComponents: panelComponents,
                    hostActions: hostActions,
                    hostValues: hostValues,
                    isAdmin: isAdmin,
                    capability: capability,
                    controlState: controlState,
                    onControlChange: setControlValue,
                    autoTracks: autoTracks,
                    domIdOf: domIdOf
                })
            }, cell.key);
        })
    });
}
// src/components/DashboardRenderer/fixtureDataProvider.ts
var DEFAULT_FIXTURES = {
    // `_sample` binds the real `now` catalogue endpoint (post-FR7 hard-fail flip);
    // the fixture serves a canned `{ value, unit }` headline (StatPanel's payload
    // shape) inside the rich envelope so the smoke dashboard renders offline.
    now: {
        data: {
            value: 72,
            unit: "%"
        }
    }
};
function createFixtureDataProvider() {
    var fixtures = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : DEFAULT_FIXTURES;
    return {
        fetch: function fetch1(binding, context) {
            return _async_to_generator(function() {
                var entry;
                return _ts_generator(this, function(_state) {
                    entry = fixtures[binding.endpoint];
                    if (entry === void 0) {
                        throw new Error('fixtureDataProvider: no fixture for endpoint "'.concat(binding.endpoint, '"'));
                    }
                    return [
                        2,
                        typeof entry === "function" ? entry(context) : entry
                    ];
                });
            })();
        }
    };
}
var fixtureDataProvider = createFixtureDataProvider();
// src/components/BIDashboard/NativeDashboardView.tsx
import { jsx as jsx93 } from "react/jsx-runtime";
function useDashboardDefinition(middlewareApi, accessToken, dashboardId) {
    var _useState42 = _sliced_to_array(useState42(null), 2), definition = _useState42[0], setDefinition = _useState42[1];
    var _useState421 = _sliced_to_array(useState42("loading"), 2), state = _useState421[0], setState = _useState421[1];
    useEffect28(function() {
        var active = true;
        if (!accessToken || dashboardId === void 0) {
            setDefinition(null);
            setState("loading");
            return;
        }
        setState("loading");
        getBiDashboardDefinition(middlewareApi, accessToken, dashboardId).then(function(res) {
            if (!active) return;
            var def = res === null || res === void 0 ? void 0 : res.definition;
            if (def && typeof def.schemaVersion === "number" && Array.isArray(def.panels)) {
                setDefinition(def);
                setState("ready");
            } else {
                setDefinition(null);
                setState("error");
            }
        }).catch(function() {
            if (active) {
                setDefinition(null);
                setState("error");
            }
        });
        return function() {
            active = false;
        };
    }, [
        middlewareApi,
        accessToken,
        dashboardId
    ]);
    return {
        definition: definition,
        state: state
    };
}
var NativeDashboardView = function(param) {
    var definition = param.definition, state = param.state, context = param.context, _param_dataProvider = param.dataProvider, dataProvider = _param_dataProvider === void 0 ? fixtureDataProvider : _param_dataProvider, panelComponents = param.panelComponents, hostActions = param.hostActions, hostValues = param.hostValues, isAdmin = param.isAdmin;
    if (state === "loading") return /* @__PURE__ */ jsx93("p", {
        children: "Loading dashboard\u2026"
    });
    if (state === "error" || !definition) {
        return /* @__PURE__ */ jsx93("p", {
            children: "This dashboard is currently unavailable."
        });
    }
    var _context_twinBid;
    return(// Key on the definition slug + twin so switching dashboards (or twins) REMOUNTS
    // the renderer — its control state is seeded once per mount, so without this the
    // new dashboard would inherit the previous one's stale control values.
    /* @__PURE__ */ jsx93(DashboardRenderer, {
        definition: definition,
        context: context,
        dataProvider: dataProvider,
        panelComponents: panelComponents,
        hostActions: hostActions,
        hostValues: hostValues,
        isAdmin: isAdmin
    }, "".concat(definition.slug, ":").concat((_context_twinBid = context.twinBid) !== null && _context_twinBid !== void 0 ? _context_twinBid : "")));
};
var NativeDashboardView_default = NativeDashboardView;
// src/components/BIDashboard/BIDashboard.tsx
import { jsx as jsx94, jsxs as jsxs64 } from "react/jsx-runtime";
function isSelectable(d, isAdmin) {
    return d.is_active && (d.published_version != null || isAdmin && d.latest_version != null);
}
var BIDashboard = function(param) {
    var className = param.className, dashboardId = param.dashboardId, twinBID = param.twinBID, twinName = param.twinName, middlewareApi = param.middlewareApi, dashboardDataProvider = param.dashboardDataProvider, dashboardPanelComponents = param.dashboardPanelComponents, dashboardHostActions = param.dashboardHostActions, dashboardHostValues = param.dashboardHostValues, onSurfaceChange = param.onSurfaceChange;
    var _authMetadata_tokens, _authMetadata_roles, _definition_context_requires, _definition_context, _definition_layout;
    var authMetadata = useUserStore15().authMetadata;
    var _useModeContext3 = useModeContext3(), appMode = _useModeContext3.appMode, setAppModeWithFilterReset = _useModeContext3.setAppModeWithFilterReset;
    var accessToken = authMetadata === null || authMetadata === void 0 ? void 0 : (_authMetadata_tokens = authMetadata.tokens) === null || _authMetadata_tokens === void 0 ? void 0 : _authMetadata_tokens.accessToken;
    var isAdmin = Boolean(authMetadata === null || authMetadata === void 0 ? void 0 : (_authMetadata_roles = authMetadata.roles) === null || _authMetadata_roles === void 0 ? void 0 : _authMetadata_roles.includes(Roles5.TL_ADMIN));
    var _useState43 = _sliced_to_array(useState43([]), 2), dashboards = _useState43[0], setDashboards = _useState43[1];
    var _useState431 = _sliced_to_array(useState43(true), 2), isLoading = _useState431[0], setIsLoading = _useState431[1];
    var _useState432 = _sliced_to_array(useState43(""), 2), selectedId = _useState432[0], setSelectedId = _useState432[1];
    useEffect29(function() {
        var active = true;
        var fetchDashboards = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function() {
                var data;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!accessToken) return [
                                2
                            ];
                            setIsLoading(true);
                            return [
                                4,
                                getBiDashboards(middlewareApi, accessToken)
                            ];
                        case 1:
                            data = _state.sent();
                            if (active && data) setDashboards(data);
                            if (active) setIsLoading(false);
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchDashboards() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchDashboards();
        return function() {
            active = false;
        };
    }, [
        accessToken,
        middlewareApi
    ]);
    var selectable = useMemo7(function() {
        return dashboards.filter(function(d) {
            return isSelectable(d, isAdmin);
        });
    }, [
        dashboards,
        isAdmin
    ]);
    useEffect29(function() {
        if (selectable.length === 0) return;
        var stillValid = selectable.some(function(d) {
            return String(d.id) === selectedId;
        });
        if (stillValid) return;
        var fromProp = dashboardId ? selectable.find(function(d) {
            return String(d.id) === dashboardId;
        }) : void 0;
        setSelectedId(String((fromProp !== null && fromProp !== void 0 ? fromProp : selectable[0]).id));
    }, [
        selectable,
        selectedId,
        dashboardId
    ]);
    var selected = selectable.find(function(d) {
        return String(d.id) === selectedId;
    });
    var accessibleTwins = useTwinModelStore2(function(state) {
        return state.accessibleTwins;
    });
    var twins = useMemo7(function() {
        return accessibleTwins === null || accessibleTwins === void 0 ? void 0 : accessibleTwins.map(function(t) {
            return {
                bid: t.bid,
                name: t.name || t.bid
            };
        });
    }, [
        accessibleTwins
    ]);
    var context = useMemo7(function() {
        return {
            twinBid: twinBID,
            twinName: twinName,
            twins: twins
        };
    }, [
        twinBID,
        twinName,
        twins
    ]);
    var _useDashboardDefinition = useDashboardDefinition(middlewareApi, accessToken, selected === null || selected === void 0 ? void 0 : selected.id), definition = _useDashboardDefinition.definition, definitionState = _useDashboardDefinition.state;
    var needsLiveScene = (definition === null || definition === void 0 ? void 0 : (_definition_context = definition.context) === null || _definition_context === void 0 ? void 0 : (_definition_context_requires = _definition_context.requires) === null || _definition_context_requires === void 0 ? void 0 : _definition_context_requires.includes(LIVE_SCENE_REQUIREMENT)) === true;
    useEffect29(function() {
        if (definitionState !== "ready") return;
        if (needsLiveScene && appMode !== AppMode3.OPERATIONS) {
            setAppModeWithFilterReset(AppMode3.OPERATIONS);
        } else if (!needsLiveScene && appMode === AppMode3.OPERATIONS) {
            setAppModeWithFilterReset(AppMode3.DASHBOARD_UTILISATION);
        }
    }, [
        needsLiveScene,
        definitionState,
        appMode,
        setAppModeWithFilterReset
    ]);
    var _definition_layout_surface;
    var surface12 = (_definition_layout_surface = definition === null || definition === void 0 ? void 0 : (_definition_layout = definition.layout) === null || _definition_layout === void 0 ? void 0 : _definition_layout.surface) !== null && _definition_layout_surface !== void 0 ? _definition_layout_surface : "panel";
    useEffect29(function() {
        onSurfaceChange === null || onSurfaceChange === void 0 ? void 0 : onSurfaceChange(surface12);
    }, [
        surface12,
        onSurfaceChange
    ]);
    var renderBody = function() {
        if (isLoading) return /* @__PURE__ */ jsx94("p", {
            children: "Loading..."
        });
        if (!selected) return /* @__PURE__ */ jsx94("p", {
            children: "No active dashboards available"
        });
        if (!accessToken) return /* @__PURE__ */ jsx94("p", {
            children: "Loading..."
        });
        return /* @__PURE__ */ jsx94(NativeDashboardView_default, {
            definition: definition,
            state: definitionState,
            context: context,
            dataProvider: dashboardDataProvider,
            panelComponents: dashboardPanelComponents,
            hostActions: dashboardHostActions,
            hostValues: dashboardHostValues,
            isAdmin: isAdmin
        });
    };
    var picker = /* @__PURE__ */ jsx94("div", {
        className: "dashboard-header",
        children: /* @__PURE__ */ jsx94(BIDashboardSelect_default, {
            dashboards: selectable,
            currentDashboardId: selectedId,
            onDashboardChange: setSelectedId,
            isAdmin: isAdmin
        })
    });
    if (surface12 === "sceneOverlay") {
        return /* @__PURE__ */ jsx94("div", {
            className: className,
            "data-dashboard-surface": "sceneOverlay",
            children: /* @__PURE__ */ jsxs64("div", {
                className: "scene-overlay",
                children: [
                    picker,
                    renderBody()
                ]
            })
        });
    }
    return /* @__PURE__ */ jsx94("div", {
        className: className,
        "data-dashboard-surface": "panel",
        children: /* @__PURE__ */ jsx94(Scrollbar4, {
            className: "scrollable-container",
            maxHeight: "calc(100vh - 90px)",
            children: /* @__PURE__ */ jsxs64("div", {
                className: "bg-glass",
                children: [
                    picker,
                    renderBody()
                ]
            })
        })
    });
};
var BIDashboard_default = styled65(BIDashboard)(_templateObject87());
// src/components/PlatformHealthTree/PlatformHealthTree.tsx
import React44, { useCallback as useCallback8, useMemo as useMemo9, useState as useState44 } from "react";
import styled67 from "styled-components";
import { ink as ink7, surface as surface4, line as line4, inkOn, fontSans, glass, shadow } from "@repo/design-tokens";
// src/components/PlatformHealthTree/bucketColour.ts
import { semanticColor, ink as ink6 } from "@repo/design-tokens";
var BUCKET_COLOUR = {
    down: semanticColor.error,
    degraded: semanticColor.warn,
    setting_up: ink6[4],
    healthy: semanticColor.success,
    // A deliberately switched-off stream: a dimmer neutral ink than setting_up, so "disabled" reads as
    // muted-off rather than coming-up. Not a fault colour.
    disabled: ink6[5]
};
// src/components/PlatformHealthTree/PlatformHealthTree.tsx
import { ChevronRight16Regular, ChevronDown16Regular, CheckmarkCircle16Filled, Warning16Filled, DismissCircle16Filled, Circle16Regular, Prohibited16Regular } from "@fluentui/react-icons";
// src/components/PlatformHealthTree/HealthStrip.tsx
import { useMemo as useMemo8 } from "react";
import styled66 from "styled-components";
import { line as line3, accent } from "@repo/design-tokens";
import { jsx as jsx95 } from "react/jsx-runtime";
var OFFLINE_COLOUR = line3[3];
function verdictColour(v) {
    return v === "offline" ? OFFLINE_COLOUR : BUCKET_COLOUR[v];
}
var ESCALATION_RAMP = [
    {
        colour: accent.butter,
        upToHours: 4,
        label: "\u2264 4h"
    },
    {
        colour: accent.peach,
        upToHours: 12,
        label: "4\u201312h"
    },
    {
        colour: accent.pink,
        upToHours: Infinity,
        label: "> 12h"
    }
];
var isBad = function(v) {
    return v === "down" || v === "degraded" || v === "offline";
};
function escalationColour(cumulativeBadHours) {
    var stop = ESCALATION_RAMP.find(function(s) {
        return cumulativeBadHours <= s.upToHours;
    });
    return (stop !== null && stop !== void 0 ? stop : ESCALATION_RAMP[ESCALATION_RAMP.length - 1]).colour;
}
function escalates(resolutionMinutes) {
    return resolutionMinutes >= 120;
}
function bucketColours(verdicts, resolutionMinutes) {
    if (!escalates(resolutionMinutes)) {
        return verdicts.map(verdictColour);
    }
    var bucketHours = resolutionMinutes / 60;
    var out = [];
    var runBuckets = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = verdicts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var v = _step.value;
            if (isBad(v)) {
                runBuckets += 1;
                out.push(escalationColour(runBuckets * bucketHours));
            } else {
                runBuckets = 0;
                out.push(verdictColour(v));
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return out;
}
function boundaryPct(i, n) {
    return Math.round(i / n * 1e5) / 1e3;
}
function gradientFromColours(colours) {
    var n = colours.length;
    if (n === 0) return "transparent";
    var stops = [];
    var runStart = 0;
    for(var i = 1; i <= n; i++){
        if (i === n || colours[i] !== colours[runStart]) {
            stops.push("".concat(colours[runStart], " ").concat(boundaryPct(runStart, n), "% ").concat(boundaryPct(i, n), "%"));
            runStart = i;
        }
    }
    return "linear-gradient(90deg, ".concat(stops.join(", "), ")");
}
function buildStripGradient(verdicts, resolutionMinutes) {
    return gradientFromColours(bucketColours(verdicts, resolutionMinutes));
}
var VERDICT_LABEL = {
    down: "down",
    degraded: "degraded",
    setting_up: "setting up",
    healthy: "healthy",
    offline: "offline / no data"
};
function windowLabel(bucketCount, resolutionMinutes) {
    var hours = Math.round(bucketCount * resolutionMinutes / 60);
    return hours >= 48 ? "".concat(Math.round(hours / 24), "d") : "".concat(hours, "h");
}
function stripAriaSummary(verdicts, resolutionMinutes, label) {
    var order = [
        "down",
        "degraded",
        "healthy",
        "setting_up",
        "offline"
    ];
    var counts = /* @__PURE__ */ new Map();
    var _counts_get;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = verdicts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var v = _step.value;
            counts.set(v, ((_counts_get = counts.get(v)) !== null && _counts_get !== void 0 ? _counts_get : 0) + 1);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var parts = order.filter(function(v) {
        var _counts_get;
        return ((_counts_get = counts.get(v)) !== null && _counts_get !== void 0 ? _counts_get : 0) > 0;
    }).map(function(v) {
        return "".concat(counts.get(v), " ").concat(VERDICT_LABEL[v]);
    });
    var who = label ? "".concat(label, " — ") : "";
    var win = windowLabel(verdicts.length, resolutionMinutes);
    var newest = verdicts[verdicts.length - 1];
    var newestPart = newest ? "; latest ".concat(VERDICT_LABEL[newest]) : "";
    return "".concat(who).concat(win, ": ").concat(parts.length > 0 ? parts.join(", ") : "no data").concat(newestPart);
}
var HealthStrip = function(param) {
    var verdicts = param.verdicts, resolutionMinutes = param.resolutionMinutes, label = param.label, className = param.className;
    var gradient = useMemo8(function() {
        return buildStripGradient(verdicts, resolutionMinutes);
    }, [
        verdicts,
        resolutionMinutes
    ]);
    var summary = useMemo8(function() {
        return stripAriaSummary(verdicts, resolutionMinutes, label);
    }, [
        verdicts,
        resolutionMinutes,
        label
    ]);
    return /* @__PURE__ */ jsx95(Bar, {
        className: className,
        $gradient: gradient,
        $coarse: escalates(resolutionMinutes),
        role: "img",
        "aria-label": summary,
        "data-testid": "health-strip",
        "data-cells": verdicts.length,
        "data-resolution": resolutionMinutes
    });
};
var Bar = styled66.div(_templateObject88(), function(param) {
    var $coarse = param.$coarse;
    return $coarse ? "13px" : "12px";
}, function(param) {
    var $gradient = param.$gradient;
    return $gradient;
});
var HealthStrip_default = HealthStrip;
// src/components/PlatformHealthTree/PlatformHealthTree.tsx
import { Fragment as Fragment19, jsx as jsx96, jsxs as jsxs65 } from "react/jsx-runtime";
var METRIC_COLOUR = {
    neutral: ink7[4],
    degraded: inkOn.butter,
    down: inkOn.error
};
function ragIcon(bucket) {
    switch(bucket){
        case "down":
            return /* @__PURE__ */ jsx96(DismissCircle16Filled, {});
        case "degraded":
            return /* @__PURE__ */ jsx96(Warning16Filled, {});
        case "healthy":
            return /* @__PURE__ */ jsx96(CheckmarkCircle16Filled, {});
        case "setting_up":
            return /* @__PURE__ */ jsx96(Circle16Regular, {});
        // A deliberately switched-off stream: the "prohibited" outline reads as off/blocked, distinct
        // from setting_up's hollow circle, and its outline weight (like setting_up) marks it a non-verdict.
        case "disabled":
            return /* @__PURE__ */ jsx96(Prohibited16Regular, {});
    }
}
function nameWeight(kind) {
    return kind === "customer" || kind === "twin" ? 600 : kind === "device" ? 500 : 400;
}
function formatClock(iso) {
    if (!iso) return "\u2014";
    var ms = Date.parse(iso);
    if (!Number.isFinite(ms)) return "\u2014";
    return new Date(ms).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit"
    });
}
function formatDurationShort(totalSeconds) {
    var s = Math.max(0, Math.round(totalSeconds));
    if (s < 60) return "".concat(s, "s");
    var m = Math.floor(s / 60);
    if (m < 60) return "".concat(m, "m");
    var h = Math.floor(m / 60);
    if (h < 24) return "".concat(h, "h");
    return "".concat(Math.floor(h / 24), "d");
}
function darken(hex, factor) {
    var f = Math.max(0, Math.min(1, factor));
    var n = parseInt(hex.slice(1), 16);
    var r = Math.round((n >> 16 & 255) * (1 - f));
    var g = Math.round((n >> 8 & 255) * (1 - f));
    var b = Math.round((n & 255) * (1 - f));
    return "#".concat((1 << 24 | r << 16 | g << 8 | b).toString(16).slice(1));
}
function hexToRgba(hex, alpha) {
    var n = parseInt(hex.slice(1), 16);
    return "rgba(".concat(n >> 16 & 255, ", ").concat(n >> 8 & 255, ", ").concat(n & 255, ", ").concat(alpha, ")");
}
function ageingChipColour(base, durationS) {
    if (durationS == null || durationS <= 0) return base;
    var factor = Math.min(0.55, durationS / (24 * 3600) * 0.55);
    return darken(base, factor);
}
var EMPTY_FILTERS = {
    bucket: "all",
    customerId: "all",
    search: ""
};
function filterPlatformHealthTree(customers, filters) {
    var search = filters.search.trim().toLowerCase();
    var scoped = filters.customerId === "all" ? customers : customers.filter(function(c) {
        return c.id === filters.customerId;
    });
    var matchesSelf = function(node) {
        var searchOk = search === "" || node.label.toLowerCase().includes(search);
        var bucketOk = filters.bucket === "all" || node.bucket === filters.bucket;
        return searchOk && bucketOk;
    };
    var filterNode = function(node) {
        var keptChildren = node.children.map(filterNode).filter(function(c) {
            return c !== null;
        });
        if (matchesSelf(node) || keptChildren.length > 0) {
            return _object_spread_props(_object_spread({}, node), {
                children: keptChildren
            });
        }
        return null;
    };
    return scoped.map(filterNode).filter(function(c) {
        return c !== null;
    });
}
function TreeRow(param) {
    var node = param.node, depth = param.depth, overrides2 = param.overrides, filterActive = param.filterActive, onToggle = param.onToggle, renderOpStatusLink = param.renderOpStatusLink, history = param.history, historyActive = param.historyActive;
    var hasChildren2 = node.children.length > 0;
    var strip = history === null || history === void 0 ? void 0 : history.byNode[node.id];
    var _overrides2_node_id;
    var expanded = filterActive || ((_overrides2_node_id = overrides2[node.id]) !== null && _overrides2_node_id !== void 0 ? _overrides2_node_id : node.kind === "customer");
    var faulted = node.bucket === "down" || node.bucket === "degraded";
    var durText = node.durationS != null ? formatDurationShort(node.durationS) : "\u2014";
    var originText = node.faultOrigin === "self" ? "own fault" : "fault below";
    var durAria = node.durationS != null ? "".concat(formatDurationShort(node.durationS), ", ").concat(originText) : "unknown duration, ".concat(originText);
    var _node_faultOrigin, _history_resolutionMinutes;
    return /* @__PURE__ */ jsxs65(Fragment19, {
        children: [
            /* @__PURE__ */ jsxs65(Row3, {
                role: "treeitem",
                "aria-level": depth + 1,
                "aria-expanded": hasChildren2 ? expanded : void 0,
                "data-testid": "node-".concat(node.id),
                "data-fault-origin": (_node_faultOrigin = node.faultOrigin) !== null && _node_faultOrigin !== void 0 ? _node_faultOrigin : "none",
                $history: historyActive,
                children: [
                    /* @__PURE__ */ jsxs65(Entity, {
                        children: [
                            Array.from({
                                length: depth
                            }).map(function(_, i) {
                                return /* @__PURE__ */ jsx96(Guide, {
                                    "aria-hidden": "true",
                                    "data-guide": "true"
                                }, i);
                            }),
                            hasChildren2 ? /* @__PURE__ */ jsx96(Chevron, {
                                type: "button",
                                "aria-label": "".concat(expanded ? "Collapse" : "Expand", " ").concat(node.label),
                                "aria-expanded": expanded,
                                "data-testid": "toggle-".concat(node.id),
                                onClick: function() {
                                    return onToggle(node.id, expanded);
                                },
                                children: expanded ? /* @__PURE__ */ jsx96(ChevronDown16Regular, {}) : /* @__PURE__ */ jsx96(ChevronRight16Regular, {})
                            }) : /* @__PURE__ */ jsx96(ChevronSpacer, {
                                "aria-hidden": "true"
                            }),
                            /* @__PURE__ */ jsx96(Rag, {
                                $colour: BUCKET_COLOUR[node.bucket],
                                "data-testid": "rag-".concat(node.id),
                                "data-bucket": node.bucket,
                                "aria-label": node.bucket,
                                children: ragIcon(node.bucket)
                            }),
                            /* @__PURE__ */ jsx96(Name, {
                                $weight: nameWeight(node.kind),
                                "data-kind": node.kind,
                                children: node.label
                            }),
                            /* @__PURE__ */ jsx96(Sub, {
                                children: node.state
                            }),
                            node.kind === "device" && node.deviceId != null && renderOpStatusLink && /* @__PURE__ */ jsx96(OpLink, {
                                "data-testid": "oplink-".concat(node.id),
                                children: renderOpStatusLink(node.deviceId)
                            })
                        ]
                    }),
                    historyActive && // FR5/FR6 — the node's health strip in its own fixed grid column (design 2A), so strips
                    // align vertically across rows. Empty cell when this node has no rollup history.
                    /* @__PURE__ */ jsx96(StripCell, {
                        "data-testid": "strip-".concat(node.id),
                        children: strip && strip.length > 0 && /* @__PURE__ */ jsx96(HealthStrip_default, {
                            verdicts: strip,
                            resolutionMinutes: (_history_resolutionMinutes = history === null || history === void 0 ? void 0 : history.resolutionMinutes) !== null && _history_resolutionMinutes !== void 0 ? _history_resolutionMinutes : 30,
                            label: node.label
                        })
                    }),
                    /* @__PURE__ */ jsx96(ForCell, {
                        children: faulted && node.faultOrigin && // FR4/FR5 — filled pill = the fault is this node's own; hollow = it lives in a
                        // descendant. Carries the current bad-state duration and darkens as the issue ages.
                        /* @__PURE__ */ jsx96(DurPill, {
                            $colour: ageingChipColour(BUCKET_COLOUR[node.bucket], node.durationS),
                            $filled: node.faultOrigin === "self",
                            "data-testid": "chip-".concat(node.id),
                            "data-fault-origin": node.faultOrigin,
                            "aria-label": durAria,
                            children: durText
                        })
                    }),
                    /* @__PURE__ */ jsx96(MetricsCell, {
                        "data-testid": "metrics-".concat(node.id),
                        children: node.metrics.map(function(m, idx) {
                            return /* @__PURE__ */ jsxs65(React44.Fragment, {
                                children: [
                                    idx > 0 && /* @__PURE__ */ jsx96(MetricSep, {
                                        "aria-hidden": "true",
                                        children: "\xB7"
                                    }),
                                    /* @__PURE__ */ jsxs65(Metric, {
                                        $colour: METRIC_COLOUR[m.state],
                                        "data-metric-state": m.state,
                                        children: [
                                            /* @__PURE__ */ jsx96(MetricKey, {
                                                children: m.k
                                            }),
                                            " ",
                                            m.val
                                        ]
                                    })
                                ]
                            }, m.k);
                        })
                    })
                ]
            }),
            hasChildren2 && expanded && node.children.map(function(child) {
                return /* @__PURE__ */ jsx96(TreeRow, {
                    node: child,
                    depth: depth + 1,
                    overrides: overrides2,
                    filterActive: filterActive,
                    onToggle: onToggle,
                    renderOpStatusLink: renderOpStatusLink,
                    history: history,
                    historyActive: historyActive
                }, child.id);
            })
        ]
    });
}
var PlatformHealthTree = function(param) {
    var className = param.className, data = param.data, loading = param.loading, renderOpStatusLink = param.renderOpStatusLink, history = param.history, historyWindow = param.historyWindow, onHistoryWindowChange = param.onHistoryWindowChange;
    var _useState44 = _sliced_to_array(useState44(EMPTY_FILTERS), 2), filters = _useState44[0], setFilters = _useState44[1];
    var _useState441 = _sliced_to_array(useState44({}), 2), overrides2 = _useState441[0], setOverrides = _useState441[1];
    var onToggle = useCallback8(function(id, expanded) {
        setOverrides(function(o) {
            return _object_spread_props(_object_spread({}, o), _define_property({}, id, !expanded));
        });
    }, []);
    var _data_customers;
    var customers = (_data_customers = data === null || data === void 0 ? void 0 : data.customers) !== null && _data_customers !== void 0 ? _data_customers : [];
    var filtered = useMemo9(function() {
        return filterPlatformHealthTree(customers, filters);
    }, [
        customers,
        filters
    ]);
    var filterActive = filters.bucket !== "all" || filters.customerId !== "all" || filters.search.trim() !== "";
    var historyActive = !!history;
    if (loading) {
        return /* @__PURE__ */ jsx96(Shell, {
            className: className,
            children: "Loading\u2026"
        });
    }
    if (!data || data.customers.length === 0) {
        return /* @__PURE__ */ jsx96(Shell, {
            className: className,
            children: "No platform health data."
        });
    }
    var summary = data.summary;
    return /* @__PURE__ */ jsxs65(Shell, {
        className: className,
        children: [
            /* @__PURE__ */ jsxs65(FilterBar, {
                "data-testid": "ph-filters",
                children: [
                    /* @__PURE__ */ jsx96("input", {
                        type: "search",
                        placeholder: "Search\u2026",
                        "aria-label": "Search platform health",
                        value: filters.search,
                        "data-testid": "ph-filter-search",
                        onChange: function(e) {
                            return setFilters(function(f) {
                                return _object_spread_props(_object_spread({}, f), {
                                    search: e.target.value
                                });
                            });
                        }
                    }),
                    /* @__PURE__ */ jsxs65("select", {
                        "aria-label": "Filter by state",
                        value: filters.bucket,
                        "data-testid": "ph-filter-bucket",
                        onChange: function(e) {
                            return setFilters(function(f) {
                                return _object_spread_props(_object_spread({}, f), {
                                    bucket: e.target.value
                                });
                            });
                        },
                        children: [
                            /* @__PURE__ */ jsx96("option", {
                                value: "all",
                                children: "All states"
                            }),
                            /* @__PURE__ */ jsx96("option", {
                                value: "down",
                                children: "Down"
                            }),
                            /* @__PURE__ */ jsx96("option", {
                                value: "degraded",
                                children: "Degraded"
                            }),
                            /* @__PURE__ */ jsx96("option", {
                                value: "setting_up",
                                children: "Setting up"
                            }),
                            /* @__PURE__ */ jsx96("option", {
                                value: "healthy",
                                children: "Healthy"
                            }),
                            /* @__PURE__ */ jsx96("option", {
                                value: "disabled",
                                children: "Disabled"
                            })
                        ]
                    }),
                    /* @__PURE__ */ jsxs65("select", {
                        "aria-label": "Filter by customer",
                        value: filters.customerId,
                        "data-testid": "ph-filter-customer",
                        onChange: function(e) {
                            return setFilters(function(f) {
                                return _object_spread_props(_object_spread({}, f), {
                                    customerId: e.target.value
                                });
                            });
                        },
                        children: [
                            /* @__PURE__ */ jsx96("option", {
                                value: "all",
                                children: "All customers"
                            }),
                            data.customers.map(function(c) {
                                return /* @__PURE__ */ jsx96("option", {
                                    value: c.id,
                                    children: c.label
                                }, c.id);
                            })
                        ]
                    }),
                    onHistoryWindowChange && // FR5/FR6 — the 24 h (1B) / 7 d (2A) strip window toggle. Only shown when the host wires a
                    // handler (so the Phase-1 tree, with no history, renders unchanged).
                    /* @__PURE__ */ jsx96(WindowToggle, {
                        role: "group",
                        "aria-label": "History window",
                        "data-testid": "ph-window-toggle",
                        children: [
                            "24h",
                            "7d"
                        ].map(function(w) {
                            return /* @__PURE__ */ jsx96(WindowButton, {
                                type: "button",
                                "data-testid": "ph-window-".concat(w),
                                "aria-pressed": historyWindow === w,
                                $active: historyWindow === w,
                                onClick: function() {
                                    return onHistoryWindowChange(w);
                                },
                                children: w === "24h" ? "24h" : "7d"
                            }, w);
                        })
                    }),
                    historyActive && (history === null || history === void 0 ? void 0 : history.dataAsOf) && // The rollup's OWN freshness (newest refreshed_at), distinct from the tree's live "updated"
                    // stamp. If the refresh cron stalls, recent buckets decay to a false `offline`; this stamp
                    // is how an operator tells a stale rollup from a real outage.
                    /* @__PURE__ */ jsxs65(StripFreshness, {
                        "data-testid": "ph-strip-freshness",
                        children: [
                            "history to ",
                            formatClock(history.dataAsOf)
                        ]
                    })
                ]
            }),
            /* @__PURE__ */ jsxs65(Card2, {
                children: [
                    /* @__PURE__ */ jsxs65(CardHeader2, {
                        "data-testid": "ph-summary",
                        children: [
                            /* @__PURE__ */ jsxs65("div", {
                                children: [
                                    /* @__PURE__ */ jsx96(Title, {
                                        children: "Platform Health"
                                    }),
                                    /* @__PURE__ */ jsxs65(Subtitle2, {
                                        children: [
                                            summary.customers,
                                            " customers \xB7 ",
                                            summary.twins,
                                            " twins \xB7 ",
                                            summary.devices,
                                            " edge devices \xB7 ",
                                            summary.down,
                                            " down, ",
                                            summary.degraded,
                                            " degraded"
                                        ]
                                    })
                                ]
                            }),
                            /* @__PURE__ */ jsxs65(HeaderRight, {
                                children: [
                                    summary.down > 0 && /* @__PURE__ */ jsxs65(CountPill, {
                                        $bg: hexToRgba(BUCKET_COLOUR.down, 0.14),
                                        $fg: inkOn.error,
                                        children: [
                                            summary.down,
                                            " down"
                                        ]
                                    }),
                                    summary.degraded > 0 && /* @__PURE__ */ jsxs65(CountPill, {
                                        $bg: hexToRgba(BUCKET_COLOUR.degraded, 0.16),
                                        $fg: inkOn.butter,
                                        children: [
                                            summary.degraded,
                                            " degraded"
                                        ]
                                    }),
                                    /* @__PURE__ */ jsxs65(Freshness, {
                                        "data-testid": "ph-freshness",
                                        children: [
                                            "updated ",
                                            formatClock(summary.freshestUpdateAt)
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /* @__PURE__ */ jsxs65(ColHeader, {
                        "aria-hidden": "true",
                        $history: historyActive,
                        children: [
                            /* @__PURE__ */ jsx96("div", {
                                children: "ENTITY"
                            }),
                            historyActive && /* @__PURE__ */ jsxs65(StripHead, {
                                children: [
                                    /* @__PURE__ */ jsx96("span", {
                                        children: (history === null || history === void 0 ? void 0 : history.window) === "7d" ? "7 DAYS AGO" : "24 H AGO"
                                    }),
                                    /* @__PURE__ */ jsx96("span", {
                                        children: "NOW"
                                    })
                                ]
                            }),
                            /* @__PURE__ */ jsx96("div", {
                                children: "FOR"
                            }),
                            /* @__PURE__ */ jsx96("div", {
                                children: "KEY METRICS"
                            })
                        ]
                    }),
                    /* @__PURE__ */ jsx96(Tree, {
                        role: "tree",
                        children: filtered.length === 0 ? /* @__PURE__ */ jsx96(Empty, {
                            "data-testid": "ph-no-matches",
                            children: "No entities match the current filters."
                        }) : filtered.map(function(node) {
                            return /* @__PURE__ */ jsx96(TreeRow, {
                                node: node,
                                depth: 0,
                                overrides: overrides2,
                                filterActive: filterActive,
                                onToggle: onToggle,
                                renderOpStatusLink: renderOpStatusLink,
                                history: history,
                                historyActive: historyActive
                            }, node.id);
                        })
                    }),
                    historyActive && (history === null || history === void 0 ? void 0 : history.window) === "7d" && // 2A — the escalation ramp legend for the 7-day strip: continuous bad time walks the ramp.
                    // Gated on the LOADED window so it appears in lock-step with the 7-day strips it explains.
                    /* @__PURE__ */ jsxs65(Legend, {
                        "data-testid": "ph-escalation-legend",
                        "aria-hidden": "true",
                        children: [
                            /* @__PURE__ */ jsx96(LegendLabel, {
                                children: "CONTINUOUS TIME IN A BAD STATE"
                            }),
                            ESCALATION_RAMP.map(function(stop) {
                                return /* @__PURE__ */ jsxs65(LegendItem, {
                                    children: [
                                        /* @__PURE__ */ jsx96(Swatch, {
                                            $c: stop.colour
                                        }),
                                        stop.label
                                    ]
                                }, stop.label);
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var GRID = "1fr 96px 236px";
var GRID_HISTORY = "1fr 240px 96px 236px";
var Shell = styled67.div(_templateObject89(), fontSans, ink7[1]);
var FilterBar = styled67.div(_templateObject90(), fontSans, line4.control, surface4[0], ink7[1]);
var Card2 = styled67.div(_templateObject91(), glass.bg, glass.blur, glass.border, shadow.glassSm);
var CardHeader2 = styled67.div(_templateObject92());
var Title = styled67.div(_templateObject93(), ink7[1]);
var Subtitle2 = styled67.div(_templateObject94(), ink7[4]);
var HeaderRight = styled67.div(_templateObject95());
var CountPill = styled67.span(_templateObject96(), function(param) {
    var $bg = param.$bg;
    return $bg;
}, function(param) {
    var $fg = param.$fg;
    return $fg;
});
var Freshness = styled67.span(_templateObject97(), ink7[5]);
var StripFreshness = styled67.span(_templateObject98(), ink7[5]);
var ColHeader = styled67.div(_templateObject99(), function(param) {
    var $history = param.$history;
    return $history ? GRID_HISTORY : GRID;
}, line4[1], ink7[4]);
var StripHead = styled67.div(_templateObject100());
var Tree = styled67.div(_templateObject101());
var Empty = styled67.div(_templateObject102(), ink7[4]);
var Row3 = styled67.div(_templateObject103(), function(param) {
    var $history = param.$history;
    return $history ? GRID_HISTORY : GRID;
}, hexToRgba(line4[2], 0.5), hexToRgba(surface4[2], 0.6));
var StripCell = styled67.div(_templateObject104());
var Legend = styled67.div(_templateObject105(), line4[1], ink7[4]);
var LegendLabel = styled67.span(_templateObject106());
var LegendItem = styled67.span(_templateObject107());
var Swatch = styled67.span(_templateObject108(), function(param) {
    var $c = param.$c;
    return $c;
});
var WindowToggle = styled67.div(_templateObject109(), line4.control);
var WindowButton = styled67.button(_templateObject110(), fontSans, function(param) {
    var $active = param.$active;
    return $active ? surface4[0] : ink7[2];
}, function(param) {
    var $active = param.$active;
    return $active ? ink7[1] : surface4[0];
}, line4.control);
var Entity = styled67.div(_templateObject111());
var Guide = styled67.span(_templateObject112(), line4[4]);
var Chevron = styled67.button(_templateObject113(), ink7[5]);
var ChevronSpacer = styled67.span(_templateObject114());
var Rag = styled67.span(_templateObject115(), function(param) {
    var $colour = param.$colour;
    return $colour;
});
var Name = styled67.span(_templateObject116(), function(param) {
    var $weight = param.$weight;
    return $weight;
}, ink7[1]);
var Sub = styled67.span(_templateObject117(), ink7[4]);
var OpLink = styled67.span(_templateObject118(), inkOn.aqua);
var ForCell = styled67.div(_templateObject119());
var DurPill = styled67.span(_templateObject120(), function(param) {
    var $colour = param.$colour;
    return $colour;
}, function(param) {
    var $colour = param.$colour, $filled = param.$filled;
    return $filled ? surface4[0] : $colour;
}, function(param) {
    var $colour = param.$colour, $filled = param.$filled;
    return $filled ? $colour : "transparent";
});
var MetricsCell = styled67.div(_templateObject121(), ink7[3]);
var MetricSep = styled67.span(_templateObject122(), ink7[5]);
var Metric = styled67.span(_templateObject123(), function(param) {
    var $colour = param.$colour;
    return $colour;
});
var MetricKey = styled67.span(_templateObject124(), ink7[5]);
var PlatformHealthTree_default = PlatformHealthTree;
// src/components/CameraWall/CameraWall.tsx
import React49, { useCallback as useCallback10, useEffect as useEffect33, useMemo as useMemo10, useRef as useRef17, useState as useState47 } from "react";
import styled71 from "styled-components";
import { Button as Button9, Tag as Tag2, Scrollbar as Scrollbar5, EmptyInline, FilterChipGroup, FilterChipCaption } from "@repo/design-system";
import { space as space11, inset, ink as ink9, radius as radius5, glass as glass3, shadow as shadow5, line as line5, typeRole as typeRole6, weight as weight2, semantic as semantic8, inkOn as inkOn3 } from "@repo/design-tokens";
// src/components/CameraWall/useDragEdgeScroll.ts
import { useEffect as useEffect30 } from "react";
function useDragEdgeScroll(viewportRef, enabled) {
    useEffect30(function() {
        if (!enabled) return;
        var pointerY = null;
        var scroller = createEdgeScroller(function() {
            var el = viewportRef.current;
            return el && pointerY !== null ? {
                el: el,
                y: pointerY
            } : null;
        });
        var stop = function() {
            scroller.stop();
            pointerY = null;
        };
        var over = function(e) {
            var _e_dataTransfer;
            var viewport = viewportRef.current;
            var _e_dataTransfer_types;
            if (!viewport || !Array.from((_e_dataTransfer_types = (_e_dataTransfer = e.dataTransfer) === null || _e_dataTransfer === void 0 ? void 0 : _e_dataTransfer.types) !== null && _e_dataTransfer_types !== void 0 ? _e_dataTransfer_types : []).includes(STREAM_DRAG_TYPE)) return;
            var rect = viewport.getBoundingClientRect();
            var inside = e.clientX >= rect.left && e.clientX <= rect.right && e.clientY >= rect.top && e.clientY <= rect.bottom;
            if (!inside) {
                stop();
                return;
            }
            pointerY = e.clientY;
            scroller.kick();
        };
        var leave = function(e) {
            var outside = e.clientX <= 0 || e.clientY <= 0 || e.clientX >= window.innerWidth || e.clientY >= window.innerHeight;
            if (outside) stop();
        };
        document.addEventListener("dragover", over, true);
        document.addEventListener("dragleave", leave, true);
        document.addEventListener("drop", stop, true);
        document.addEventListener("dragend", stop, true);
        return function() {
            stop();
            document.removeEventListener("dragover", over, true);
            document.removeEventListener("dragleave", leave, true);
            document.removeEventListener("drop", stop, true);
            document.removeEventListener("dragend", stop, true);
        };
    }, [
        viewportRef,
        enabled
    ]);
}
// src/components/CameraWall/CameraWallTile.tsx
import React47 from "react";
import styled69, { css as css2 } from "styled-components";
import { radius as radius3, shadow as shadow3, motion as motion3, brand as brand3, rgba, semantic as semantic6 } from "@repo/design-tokens";
// src/components/CameraWall/FrameZoom.tsx
import React46 from "react";
import { createPortal as createPortal2 } from "react-dom";
import styled68 from "styled-components";
import { shadow as shadow2 } from "@repo/design-tokens";
// src/components/CameraWall/frameZoomGeometry.ts
var DEFAULT_ASPECT = 16 / 9;
var usableAspect = function(aspect) {
    return typeof aspect === "number" && Number.isFinite(aspect) && aspect > 0 ? aspect : DEFAULT_ASPECT;
};
var zoomTargetRect = function(aspect, viewport, inset6) {
    var ratio = usableAspect(aspect);
    var availW = Math.max(1, viewport.width - 2 * inset6);
    var availH = Math.max(1, viewport.height - 2 * inset6);
    var width = Math.min(availW, availH * ratio);
    var height2 = width / ratio;
    return {
        left: (viewport.width - width) / 2,
        top: (viewport.height - height2) / 2,
        width: width,
        height: height2
    };
};
var flipTransform = function(from, to) {
    var sx = to.width > 0 ? from.width / to.width : 1;
    var sy = to.height > 0 ? from.height / to.height : 1;
    return "translate(".concat(from.left - to.left, "px, ").concat(from.top - to.top, "px) scale(").concat(sx, ", ").concat(sy, ")");
};
// src/components/CameraWall/FrameRegionOverlay.tsx
import { useEffect as useEffect31, useState as useState45 } from "react";
import { ink as ink8, inkOn as inkOn2, semantic as semantic5, typeRole as typeRole5, weight } from "@repo/design-tokens";
import { jsx as jsx97, jsxs as jsxs66 } from "react/jsx-runtime";
var OUTLINE = {
    dotColor: ink8.inverse,
    dotWidth: 2,
    /** A zero-length dash with a round cap is a dot: one every 6 px. */ dash: "0 6",
    underlayColor: semantic5.text.primary,
    underlayWidth: 1,
    underlayOpacity: 0.35
};
var FIT_ASPECT = {
    cover: "xMidYMid slice",
    contain: "xMidYMid meet"
};
var centroid = function(points) {
    var n = points.length || 1;
    return {
        x: points.reduce(function(sum, p) {
            return sum + p.x;
        }, 0) / n,
        y: points.reduce(function(sum, p) {
            return sum + p.y;
        }, 0) / n
    };
};
var pointsAttr = function(points) {
    return points.map(function(p) {
        return "".concat(p.x, ",").concat(p.y);
    }).join(" ");
};
var OutlineRegion = function(param) {
    var region = param.region;
    var points = pointsAttr(region.points);
    return /* @__PURE__ */ jsxs66("g", {
        "data-region": region.id,
        "data-style": "outline",
        children: [
            /* @__PURE__ */ jsx97("polygon", {
                points: points,
                fill: "none",
                stroke: OUTLINE.underlayColor,
                strokeWidth: OUTLINE.underlayWidth,
                strokeOpacity: OUTLINE.underlayOpacity,
                strokeLinejoin: "round",
                vectorEffect: "non-scaling-stroke"
            }),
            /* @__PURE__ */ jsx97("polygon", {
                points: points,
                fill: "none",
                stroke: OUTLINE.dotColor,
                strokeWidth: OUTLINE.dotWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeDasharray: OUTLINE.dash,
                vectorEffect: "non-scaling-stroke"
            })
        ]
    });
};
var AccentRegion = function(param) {
    var region = param.region, unit2 = param.unit;
    var points = pointsAttr(region.points);
    var c = centroid(region.points);
    var _region_marker;
    var marker = (_region_marker = region.marker) !== null && _region_marker !== void 0 ? _region_marker : "";
    return /* @__PURE__ */ jsxs66("g", {
        "data-region": region.id,
        "data-style": "accent",
        children: [
            /* @__PURE__ */ jsx97("polygon", {
                points: points,
                fill: "none",
                stroke: semantic5.text.primary,
                strokeWidth: unit2 * 1.2,
                strokeOpacity: 0.6,
                strokeLinejoin: "round"
            }),
            /* @__PURE__ */ jsx97("polygon", {
                points: points,
                fill: semantic5.interactive.accent,
                fillOpacity: 0.15,
                stroke: semantic5.interactive.accent,
                strokeWidth: unit2 * 0.6,
                strokeLinejoin: "round"
            }),
            marker ? /* @__PURE__ */ jsxs66("g", {
                children: [
                    /* @__PURE__ */ jsx97("circle", {
                        cx: c.x,
                        cy: c.y,
                        r: unit2 * (marker.length > 2 ? 4.2 : 3),
                        fill: semantic5.interactive.accent,
                        stroke: semantic5.text.primary,
                        strokeWidth: unit2 * 0.3
                    }),
                    /* @__PURE__ */ jsx97("text", {
                        x: c.x,
                        y: c.y,
                        textAnchor: "middle",
                        dominantBaseline: "central",
                        fill: inkOn2.aqua,
                        fontFamily: typeRole5.caption1.fontFamily,
                        fontWeight: weight.semibold,
                        fontSize: unit2 * (marker.length > 2 ? 2.6 : 3.4),
                        children: marker
                    })
                ]
            }) : null
        ]
    });
};
var FrameRegionOverlay = function(param) {
    var imageUrl = param.imageUrl, regions = param.regions, fit = param.fit, onDecodeError = param.onDecodeError;
    var _useState45 = _sliced_to_array(useState45(null), 2), size2 = _useState45[0], setSize = _useState45[1];
    useEffect31(function() {
        var live = true;
        setSize(null);
        var image = new Image();
        image.onload = function() {
            if (live && image.naturalWidth > 0 && image.naturalHeight > 0) {
                setSize({
                    width: image.naturalWidth,
                    height: image.naturalHeight
                });
            }
        };
        image.onerror = function() {
            if (live) onDecodeError === null || onDecodeError === void 0 ? void 0 : onDecodeError();
        };
        image.src = imageUrl;
        return function() {
            live = false;
            image.onload = null;
            image.onerror = null;
        };
    }, [
        imageUrl
    ]);
    if (!size2) return null;
    var unit2 = Math.max(size2.width, size2.height) / 160;
    var outlines = regions.filter(function(r) {
        return r.style === "outline";
    });
    var accents = regions.filter(function(r) {
        return r.style !== "outline";
    });
    return /* @__PURE__ */ jsxs66("svg", {
        "aria-hidden": "true",
        "data-testid": "frame-region-overlay",
        viewBox: "0 0 ".concat(size2.width, " ").concat(size2.height),
        preserveAspectRatio: FIT_ASPECT[fit],
        width: "100%",
        height: "100%",
        style: {
            display: "block"
        },
        children: [
            outlines.map(function(region) {
                return /* @__PURE__ */ jsx97(OutlineRegion, {
                    region: region
                }, region.id);
            }),
            accents.map(function(region) {
                return /* @__PURE__ */ jsx97(AccentRegion, {
                    region: region,
                    unit: unit2
                }, region.id);
            })
        ]
    });
};
// src/components/CameraWall/FrameZoom.tsx
import { Fragment as Fragment20, jsx as jsx98, jsxs as jsxs67 } from "react/jsx-runtime";
var closeCurrent = null;
var isFocusVisible = function(el) {
    try {
        return el.matches(":focus-visible");
    } catch (e) {
        return false;
    }
};
var canAnimate2 = function(el) {
    return !!el && typeof el.animate === "function" && !prefersReducedMotion();
};
var rectOf = function(el) {
    var r = el.getBoundingClientRect();
    return {
        left: r.left,
        top: r.top,
        width: r.width,
        height: r.height
    };
};
var FRAME_ZOOM_TRIGGER_ATTR = "data-frame-zoom-trigger";
var CONTROL_SELECTOR = 'button, a[href], input, select, textarea, [role="button"]';
var FOCUS_TARGET_PROPS = _define_property({}, FRAME_ZOOM_TRIGGER_ATTR, "");
var MODIFIER_KEYS = /* @__PURE__ */ new Set([
    "Shift",
    "Control",
    "Alt",
    "Meta"
]);
var viewportNow = function() {
    return {
        width: window.innerWidth,
        height: window.innerHeight
    };
};
function useFrameZoom(param) {
    var imageUrl = param.imageUrl, label = param.label, aspectRatio = param.aspectRatio, enabledProp = param.enabled, regions = param.regions, feed = param.feed, caption = param.caption;
    var enabled = enabledProp && !!imageUrl;
    var _React46_useState = _sliced_to_array(React46.useState("idle"), 2), phase = _React46_useState[0], setPhaseState = _React46_useState[1];
    var _React46_useState1 = _sliced_to_array(React46.useState(null), 2), target = _React46_useState1[0], setTarget = _React46_useState1[1];
    var anchorRef = React46.useRef(null);
    var imageRef = React46.useRef(null);
    var layerRef = React46.useRef(null);
    var phaseRef = React46.useRef("idle");
    var targetRef = React46.useRef(null);
    var targetViewportRef = React46.useRef(null);
    var enabledRef = React46.useRef(enabled);
    enabledRef.current = enabled;
    var aspectRef = React46.useRef(aspectRatio);
    aspectRef.current = aspectRatio;
    var timerRef = React46.useRef(null);
    var warnedUrlRef = React46.useRef(null);
    var warnUndrawn = React46.useCallback(function() {
        if (!imageUrl || warnedUrlRef.current === imageUrl) return;
        warnedUrlRef.current = imageUrl;
        console.warn("Frame zoom: the picture for ".concat(label, " could not be decoded, so its regions are not drawn."));
    }, [
        imageUrl,
        label
    ]);
    var animRef = React46.useRef(null);
    var growOnOpenRef = React46.useRef(false);
    var setPhase = React46.useCallback(function(p) {
        phaseRef.current = p;
        setPhaseState(p);
    }, []);
    var clearTimer = function() {
        if (timerRef.current !== null) {
            window.clearTimeout(timerRef.current);
            timerRef.current = null;
        }
    };
    var closeRef = React46.useRef(function() {
        return void 0;
    });
    var close3 = React46.useCallback(function() {
        return closeRef.current();
    }, []);
    var finishClose = React46.useCallback(function() {
        var _animRef_current;
        if (closeCurrent === close3) closeCurrent = null;
        (_animRef_current = animRef.current) === null || _animRef_current === void 0 ? void 0 : _animRef_current.cancel();
        animRef.current = null;
        targetRef.current = null;
        targetViewportRef.current = null;
        setTarget(null);
        setPhase("idle");
    }, [
        setPhase,
        close3
    ]);
    closeRef.current = function() {
        var _animRef_current;
        clearTimer();
        var p = phaseRef.current;
        if (p === "resting") {
            if (closeCurrent === close3) closeCurrent = null;
            setPhase("idle");
            return;
        }
        if (p === "closing") {
            finishClose();
            return;
        }
        if (p !== "open") return;
        var layer2 = layerRef.current;
        var to = targetRef.current;
        if (!canAnimate2(layer2) || !to) {
            finishClose();
            return;
        }
        setPhase("closing");
        var running = animRef.current;
        if (running && running.playState === "running") {
            running.onfinish = function() {
                if (animRef.current === running) finishClose();
            };
            running.reverse();
            return;
        }
        var anchor = anchorRef.current;
        var frames = anchor && anchor.isConnected ? [
            {
                transform: "none"
            },
            {
                transform: flipTransform(rectOf(anchor), to)
            }
        ] : [
            {
                opacity: 1
            },
            {
                opacity: 0
            }
        ];
        (_animRef_current = animRef.current) === null || _animRef_current === void 0 ? void 0 : _animRef_current.cancel();
        var anim = layer2.animate(frames, {
            duration: EXPAND_MS,
            easing: EXPAND_EASE,
            fill: "both"
        });
        animRef.current = anim;
        anim.onfinish = function() {
            if (animRef.current === anim) finishClose();
        };
    };
    var open = function() {
        timerRef.current = null;
        if (!enabledRef.current) {
            setPhase("idle");
            return;
        }
        if (closeCurrent && closeCurrent !== close3) closeCurrent();
        closeCurrent = close3;
        var img = imageRef.current;
        var natural = img && img.naturalWidth > 0 && img.naturalHeight > 0 ? img.naturalWidth / img.naturalHeight : aspectRef.current;
        var viewport = viewportNow();
        var t = zoomTargetRect(natural, viewport, FRAME_ZOOM_INSET_PX);
        targetRef.current = t;
        targetViewportRef.current = viewport;
        growOnOpenRef.current = true;
        setTarget(t);
        setPhase("open");
    };
    var rest = function() {
        var p = phaseRef.current;
        if (p === "open" || p === "resting") return;
        if (p === "closing") {
            var was = targetViewportRef.current;
            var now = viewportNow();
            var anim = animRef.current;
            if (anim && was && was.width === now.width && was.height === now.height) {
                anim.onfinish = null;
                anim.reverse();
                if (closeCurrent && closeCurrent !== close3) closeCurrent();
                closeCurrent = close3;
                setPhase("open");
                return;
            }
            finishClose();
        }
        setPhase("resting");
        clearTimer();
        timerRef.current = window.setTimeout(open, FRAME_ZOOM_REST_MS);
    };
    React46.useLayoutEffect(function() {
        var _animRef_current;
        if (phase !== "open" || !growOnOpenRef.current) return;
        growOnOpenRef.current = false;
        var layer2 = layerRef.current;
        var anchor = anchorRef.current;
        var to = targetRef.current;
        if (!canAnimate2(layer2) || !anchor || !to) return;
        (_animRef_current = animRef.current) === null || _animRef_current === void 0 ? void 0 : _animRef_current.cancel();
        animRef.current = layer2.animate([
            {
                transform: flipTransform(rectOf(anchor), to)
            },
            {
                transform: "none"
            }
        ], {
            duration: EXPAND_MS,
            easing: EXPAND_EASE,
            fill: "both"
        });
    }, [
        phase
    ]);
    React46.useEffect(function() {
        if (!enabled && phaseRef.current !== "idle") {
            clearTimer();
            if (closeCurrent === close3) closeCurrent = null;
            finishClose();
        }
    }, [
        enabled,
        close3,
        finishClose
    ]);
    var active = phase === "resting" || phase === "open";
    React46.useEffect(function() {
        if (!active) return void 0;
        var onAnything = function() {
            return close3();
        };
        var onKey = function(e) {
            if (MODIFIER_KEYS.has(e.key)) return;
            if (e.key === "Escape" && phaseRef.current === "open") return;
            close3();
        };
        window.addEventListener("resize", onAnything);
        window.addEventListener("blur", onAnything);
        window.addEventListener("pointerdown", onAnything, true);
        window.addEventListener("keydown", onKey, true);
        document.addEventListener("visibilitychange", onAnything);
        return function() {
            window.removeEventListener("resize", onAnything);
            window.removeEventListener("blur", onAnything);
            window.removeEventListener("pointerdown", onAnything, true);
            window.removeEventListener("keydown", onKey, true);
            document.removeEventListener("visibilitychange", onAnything);
        };
    }, [
        active,
        close3
    ]);
    React46.useEffect(function() {
        if (phase !== "open") return void 0;
        var onScroll = function() {
            return close3();
        };
        window.addEventListener("scroll", onScroll, {
            capture: true,
            passive: true
        });
        return function() {
            return window.removeEventListener("scroll", onScroll, {
                capture: true
            });
        };
    }, [
        phase,
        close3
    ]);
    React46.useEffect(function() {
        if (phase !== "open") return void 0;
        var onKeyDown = function(e) {
            if (e.key !== "Escape") return;
            e.stopPropagation();
            close3();
        };
        window.addEventListener("keydown", onKeyDown, true);
        return function() {
            return window.removeEventListener("keydown", onKeyDown, true);
        };
    }, [
        phase,
        close3
    ]);
    React46.useEffect(function() {
        return function() {
            var _animRef_current;
            clearTimer();
            (_animRef_current = animRef.current) === null || _animRef_current === void 0 ? void 0 : _animRef_current.cancel();
            if (closeCurrent === close3) closeCurrent = null;
        };
    }, [
        close3
    ]);
    var triggerProps = {
        /*
     * `pointerover`, not `pointerenter`: it fires again as the pointer crosses the hit layers
     * INSIDE the thumbnail, so resting on the tile's refresh button or footer action — a control
     * with its own job — cancels the look instead of burying that control under a window-sized
     * picture. Keyboard focus follows the same rule through `focusTargetProps`.
     */ onPointerOver: function(e) {
            var _e_target_closest, _e_target;
            if (e.pointerType !== "mouse") return;
            if (e.buttons !== 0 || !enabledRef.current) return;
            var control = (_e_target_closest = (_e_target = e.target).closest) === null || _e_target_closest === void 0 ? void 0 : _e_target_closest.call(_e_target, CONTROL_SELECTOR);
            if (control && !control.hasAttribute(FRAME_ZOOM_TRIGGER_ATTR)) {
                close3();
                return;
            }
            rest();
        },
        onPointerLeave: function() {
            return close3();
        },
        onDragStart: function() {
            return close3();
        },
        onFocus: function(e) {
            var _el_hasAttribute;
            var el = e.target;
            if (!enabledRef.current || !((_el_hasAttribute = el.hasAttribute) === null || _el_hasAttribute === void 0 ? void 0 : _el_hasAttribute.call(el, FRAME_ZOOM_TRIGGER_ATTR))) return;
            if (!isFocusVisible(el)) return;
            rest();
        },
        onBlur: function() {
            return close3();
        }
    };
    var pictureFeed = feed !== null && feed !== void 0 ? feed : {
        id: label,
        name: label,
        state: "healthy",
        imageUrl: imageUrl,
        aspectRatio: aspectRatio
    };
    var layer = (phase === "open" || phase === "closing") && target && imageUrl && typeof document !== "undefined" ? createPortal2(/* @__PURE__ */ jsxs67(Fragment20, {
        children: [
            /* @__PURE__ */ jsx98(Surround, {
                "aria-hidden": "true",
                "data-testid": "frame-zoom-surround",
                $closing: phase === "closing"
            }),
            /* @__PURE__ */ jsx98(Layer, {
                ref: layerRef,
                "aria-hidden": "true",
                "data-testid": "frame-zoom-layer",
                style: {
                    left: target.left,
                    top: target.top,
                    width: target.width,
                    height: target.height
                },
                children: /* @__PURE__ */ jsx98(CameraPicture, {
                    feed: pictureFeed,
                    size: "enlarged",
                    caption: caption,
                    showStatus: !!feed,
                    decorative: true,
                    onImageError: finishClose,
                    overlay: regions && regions.length > 0 ? // `contain`, because the picture is: the layer is sized at the frame's own
                    // ratio, so the two letterbox identically and every region sits on what it
                    // measures.
                    /* @__PURE__ */ jsx98(FrameRegionOverlay, {
                        imageUrl: imageUrl,
                        regions: regions,
                        fit: "contain",
                        onDecodeError: warnUndrawn
                    }) : void 0
                })
            })
        ]
    }), document.body) : null;
    return {
        triggerProps: triggerProps,
        focusTargetProps: FOCUS_TARGET_PROPS,
        anchorRef: anchorRef,
        imageRef: imageRef,
        layer: layer
    };
}
var Surround = styled68(CameraWallSurround)(_templateObject125(), FRAME_ZOOM_LAYER, function(p) {
    return p.$closing ? 0 : 1;
}, EXPAND_MS, EXPAND_EASE);
var Layer = styled68.div(_templateObject126(), FRAME_ZOOM_LAYER, FEED_OUTER_RADIUS, shadow2.glass);
// src/components/CameraWall/CameraWallTile.tsx
import { Fragment as Fragment21, jsx as jsx99, jsxs as jsxs68 } from "react/jsx-runtime";
var ExpandHit = styled69.button(_templateObject127(), radius3.md);
var DragSurface = styled69.div(_templateObject128(), function(p) {
    return p.$z;
});
var BlankDragImage = styled69.div(_templateObject129());
var SelectHit = styled69.button(_templateObject130(), radius3.md);
var Plain = styled69.div(_templateObject131());
var LOOK = {
    idle: css2(_templateObject132()),
    /* Card 21 writes `0 0 12px 3px aqua, 0 2px 6px rgba(40,30,80,.14)`; the page design calls it "the
     selected-card look", which is `shadow.selected` — Rob's 2026-09-30 ruling for a selected tile.
     The 1 px of spread and the shadow colour are recorded in PROVENANCE. */ selected: css2(_templateObject133(), rgba(brand3.frost, 0.9), shadow3.selected),
    arrived: css2(_templateObject134(), semantic6.status.fadingGlow),
    // The shared dragged look (floor-plan-page-list-rows): this tile drew it first; the onboarding
    // list rows draw the same, from one copy.
    dragging: draggedLook
};
var hoverLine = semantic6.status.hover;
var PlacementTile = styled69.div(_templateObject135(), radius3.xl, shadow3.inkGlassRgb, motion3.durFast, motion3.easeUi, motion3.durFast, motion3.easeUi, motion3.durFast, motion3.easeUi, motion3.durFast, motion3.easeUi, hoverLine.width, hoverLine.style, hoverLine.edge, hoverLine.width, function(p) {
    return LOOK[p.$look];
});
var CameraWallTileImpl = function(props) {
    var feed = props.feed, onRefresh = props.onRefresh, onConfigure = props.onConfigure, action = props.action, drag = props.drag, _props_selected = props.selected, selected = _props_selected === void 0 ? false : _props_selected, placement = props.placement, _props_arrived = props.arrived, arrived = _props_arrived === void 0 ? false : _props_arrived, overlay = props.overlay, zoomRegions = props.zoomRegions, onSelect = props.onSelect, onExpand = props.onExpand, selectLabel = props.selectLabel, onHoverChange = props.onHoverChange;
    var _props_selectAction;
    var selectAction = (_props_selectAction = props.selectAction) !== null && _props_selectAction !== void 0 ? _props_selectAction : false;
    var _React47_useState = _sliced_to_array(React47.useState(false), 2), imageBroken = _React47_useState[0], setImageBroken = _React47_useState[1];
    React47.useEffect(function() {
        return setImageBroken(false);
    }, [
        feed.imageUrl
    ]);
    var _React47_useState1 = _sliced_to_array(React47.useState(false), 2), dragging = _React47_useState1[0], setDragging = _React47_useState1[1];
    var hasPicture = pictureAvailable(feed, imageBroken);
    var selectable = !!onSelect;
    var clickable = !!onExpand;
    var zoom = useFrameZoom({
        imageUrl: feed.imageUrl,
        label: feed.name,
        aspectRatio: feed.aspectRatio,
        enabled: hasPicture,
        regions: zoomRegions,
        feed: feed,
        caption: placement
    });
    var blankDragImageRef = React47.useRef(null);
    var _React47_useState2 = _sliced_to_array(React47.useState(null), 2), dragStart = _React47_useState2[0], setDragStart = _React47_useState2[1];
    var selectHitRef = React47.useRef(null);
    var handleDragStart = React47.useCallback(function(e) {
        var _drag_onDragStart;
        if (!drag) return;
        e.dataTransfer.setData(STREAM_DRAG_TYPE, drag.payload);
        e.dataTransfer.effectAllowed = "copy";
        if (blankDragImageRef.current) {
            e.dataTransfer.setDragImage(blankDragImageRef.current, 0, 0);
        }
        setDragStart({
            x: e.clientX,
            y: e.clientY
        });
        setDragging(true);
        startedDragRef.current = drag;
        (_drag_onDragStart = drag.onDragStart) === null || _drag_onDragStart === void 0 ? void 0 : _drag_onDragStart.call(drag);
    }, [
        drag
    ]);
    var startedDragRef = React47.useRef(null);
    var handleDragEnd = React47.useCallback(function() {
        var _started_onDragEnd;
        setDragging(false);
        setDragStart(null);
        var started = startedDragRef.current;
        startedDragRef.current = null;
        started === null || started === void 0 ? void 0 : (_started_onDragEnd = started.onDragEnd) === null || _started_onDragEnd === void 0 ? void 0 : _started_onDragEnd.call(started);
    }, []);
    React47.useEffect(function() {
        return function() {
            var _started_onDragEnd;
            var started = startedDragRef.current;
            startedDragRef.current = null;
            started === null || started === void 0 ? void 0 : (_started_onDragEnd = started.onDragEnd) === null || _started_onDragEnd === void 0 ? void 0 : _started_onDragEnd.call(started);
        };
    }, []);
    var dragOnPicture = !!drag && !placement;
    var dragOnTile = !!drag && !!placement;
    var picture = /* @__PURE__ */ jsxs68(CameraPicture, {
        feed: feed,
        size: "tile",
        selected: selected && !placement,
        onRefresh: onRefresh,
        onConfigure: onConfigure,
        action: action,
        overlay: overlay,
        imageBroken: imageBroken,
        onImageError: function() {
            return setImageBroken(true);
        },
        imageRef: zoom.imageRef,
        feedRef: zoom.anchorRef,
        raised: selectable,
        feedProps: {
            draggable: dragOnPicture ? true : void 0,
            onPointerOver: zoom.triggerProps.onPointerOver,
            onPointerLeave: zoom.triggerProps.onPointerLeave,
            onFocus: zoom.triggerProps.onFocus,
            onBlur: zoom.triggerProps.onBlur,
            // Composed: a drag closes the zoom, and the feed's own drag (when there is one) runs as before.
            onDragStart: function(e) {
                zoom.triggerProps.onDragStart(e);
                if (dragOnPicture) handleDragStart(e);
            },
            // Bound unconditionally: `drop` fires before `dragend`, and a host re-rendering on the drop
            // (the stream now placed, so no longer a drag source) would otherwise unbind this before
            // `dragend` arrives and leave the tile dragging for good. Clearing twice is harmless.
            onDragEnd: handleDragEnd,
            "data-testid": "camera-wall-tile-".concat(feed.id),
            "data-selected": selected || void 0
        },
        children: [
            clickable ? /* @__PURE__ */ jsx99(ExpandHit, _object_spread_props(_object_spread({}, zoom.focusTargetProps), {
                "data-whole-tile-hit": true,
                type: "button",
                "aria-label": "Expand ".concat(feed.name),
                onClick: function() {
                    return onExpand === null || onExpand === void 0 ? void 0 : onExpand(feed.id);
                }
            })) : null,
            selectable ? /* @__PURE__ */ jsx99(SelectHit, _object_spread_props(_object_spread(_object_spread_props(_object_spread({}, zoom.focusTargetProps), {
                ref: selectHitRef,
                "data-whole-tile-hit": true,
                type: "button",
                "aria-label": selectLabel !== null && selectLabel !== void 0 ? selectLabel : "Draw on ".concat(feed.name)
            }), selectAction ? {} : {
                "aria-pressed": selected
            }), {
                onClick: function() {
                    return onSelect === null || onSelect === void 0 ? void 0 : onSelect(feed.id);
                }
            })) : null,
            (clickable || selectable) && drag ? /* @__PURE__ */ jsx99(DragSurface, {
                $z: selectable ? 3 : 1,
                "aria-hidden": "true",
                draggable: true,
                title: selectable ? feed.name : void 0,
                onDragStart: dragOnPicture ? handleDragStart : void 0,
                onClick: function() {
                    if (selectable) {
                        var _selectHitRef_current;
                        (_selectHitRef_current = selectHitRef.current) === null || _selectHitRef_current === void 0 ? void 0 : _selectHitRef_current.focus({
                            preventScroll: true
                        });
                        onSelect === null || onSelect === void 0 ? void 0 : onSelect(feed.id);
                    } else {
                        onExpand === null || onExpand === void 0 ? void 0 : onExpand(feed.id);
                    }
                }
            }) : null
        ]
    });
    var hoverProps = onHoverChange ? {
        onPointerEnter: function() {
            return onHoverChange(feed.id, "pointer");
        },
        onPointerLeave: function() {
            return onHoverChange(null, "pointer");
        },
        // Focus arriving from outside the tile only — a move between the tile's own controls is
        // neither an arrival nor a leave (the blur below applies the same test).
        onFocus: function(e) {
            if (!e.currentTarget.contains(e.relatedTarget)) {
                onHoverChange(feed.id, "focus");
            }
        },
        onBlur: function(e) {
            if (!e.currentTarget.contains(e.relatedTarget)) {
                onHoverChange(null, "focus");
            }
        }
    } : {};
    var dragPicture = drag ? /* @__PURE__ */ jsxs68(Fragment21, {
        children: [
            /* @__PURE__ */ jsx99(BlankDragImage, {
                ref: blankDragImageRef,
                "aria-hidden": "true",
                "data-testid": "feed-drag-blank"
            }),
            dragging && dragStart ? /* @__PURE__ */ jsx99(FeedDragCard, {
                feed: hasPicture ? feed : _object_spread_props(_object_spread({}, feed), {
                    imageUrl: void 0
                }),
                start: dragStart
            }) : null
        ]
    }) : null;
    if (!placement) {
        return /* @__PURE__ */ jsxs68(Plain, _object_spread_props(_object_spread({}, hoverProps), {
            children: [
                dragPicture,
                picture,
                zoom.layer
            ]
        }));
    }
    var look = dragging ? "dragging" : arrived ? "arrived" : selected ? "selected" : "idle";
    return /* @__PURE__ */ jsxs68(PlacementTile, _object_spread_props(_object_spread({
        $look: look,
        "data-testid": "camera-wall-placement-".concat(feed.id),
        "data-look": look,
        draggable: dragOnTile ? true : void 0,
        onDragStart: dragOnTile ? handleDragStart : void 0,
        onDragEnd: handleDragEnd
    }, hoverProps), {
        children: [
            dragPicture,
            picture,
            /* @__PURE__ */ jsx99(PlacementFoot, {
                placement: placement,
                feedName: feed.name
            }),
            zoom.layer
        ]
    }));
};
var CameraWallTile = React47.memo(CameraWallTileImpl, function(a, b) {
    var _a_action, _b_action, _a_action1, _b_action1, // `drag` is built per render by the host's `feedDrag`, exactly as `action` is — so it is
    // compared BY VALUE for the same reason, or the memo is lost for every tile on a wall of
    // frames in flight.
    _a_drag, _b_drag, _a_drag1, _b_drag1;
    return a.feed === b.feed && a.onRefresh === b.onRefresh && a.onConfigure === b.onConfigure && a.onExpand === b.onExpand && // `camera-feeds-page-stage`: a prop this list leaves out never re-renders the tile.
    a.onHoverChange === b.onHoverChange && ((_a_action = a.action) === null || _a_action === void 0 ? void 0 : _a_action.label) === ((_b_action = b.action) === null || _b_action === void 0 ? void 0 : _b_action.label) && ((_a_action1 = a.action) === null || _a_action1 === void 0 ? void 0 : _a_action1.ariaLabel) === ((_b_action1 = b.action) === null || _b_action1 === void 0 ? void 0 : _b_action1.ariaLabel) && ((_a_drag = a.drag) === null || _a_drag === void 0 ? void 0 : _a_drag.payload) === ((_b_drag = b.drag) === null || _b_drag === void 0 ? void 0 : _b_drag.payload) && ((_a_drag1 = a.drag) === null || _a_drag1 === void 0 ? void 0 : _a_drag1.label) === ((_b_drag1 = b.drag) === null || _b_drag1 === void 0 ? void 0 : _b_drag1.label) && /*
   * ⚠️ **The PICKER props, added 2026-09-17 because this comparator silently dropped them.**
   *
   * The comparator listed `feed`, the three callbacks, `expanded` and `action` — and nothing
   * else — so `selected`, `selectLabel` and `onSelect` could all change and the tile would not
   * re-render. The Observers step's camera picker (since retired) varied `selected` against a
   * `feed` object whose identity `useCameraWallFeeds.patch()` deliberately preserves, so the memo
   * bailed out on exactly the path production takes. Clicking a feed did not visibly select it
   * until the next frame for that feed happened to land seconds later. The tile's own selection
   * tests passed throughout because they build a fresh `feed` and a fresh `onSelect` on each
   * render, which fails the first two clauses and never reaches these.
   */ a.selected === b.selected && a.selectLabel === b.selectLabel && a.onSelect === b.onSelect && a.selectAction === b.selectAction && // By identity, like the callbacks: a host that wants the memo holds its overlay stable. Missing
    // it here would be the dropped-prop defect the note above records, one prop later.
    a.overlay === b.overlay && // The zoom's regions, by identity for the same reason — and missing it would be that defect
    // again: a camera's regions edited while its feed object stayed the same would never reach its zoom.
    a.zoomRegions === b.zoomRegions && // Placement BY VALUE: a wall builds it per render, as it does `action`. Missing it is the
    // dropped-prop defect once more — a stream placed while its frame stood still would keep
    // saying "Not placed".
    placementKey(a.placement) === placementKey(b.placement) && a.arrived === b.arrived;
});
CameraWallTile.displayName = "CameraWallTile";
// src/components/CameraWall/CameraPictureDialog.tsx
import { useCallback as useCallback9, useEffect as useEffect32, useLayoutEffect as useLayoutEffect4, useRef as useRef16, useState as useState46 } from "react";
import styled70, { keyframes as keyframes2 } from "styled-components";
import { glass as glass2, motion as motion4, radius as radius4, semantic as semantic7, shadow as shadow4, space as space10 } from "@repo/design-tokens";
import { Fragment as Fragment22, jsx as jsx100, jsxs as jsxs69 } from "react/jsx-runtime";
var CameraPictureDialog = function(param) {
    var feed = param.feed, onClose = param.onClose, onRefresh = param.onRefresh;
    var layerRef = useRef16(null);
    var _useState46 = _sliced_to_array(useState46({
        w: 0,
        h: 0
    }), 2), area = _useState46[0], setArea = _useState46[1];
    useLayoutEffect4(function() {
        var el = layerRef.current;
        if (!el) return;
        var update = function() {
            return setArea(function(prev) {
                return prev.w === el.clientWidth && prev.h === el.clientHeight ? prev : {
                    w: el.clientWidth,
                    h: el.clientHeight
                };
            });
        };
        update();
        if (typeof ResizeObserver === "undefined") return;
        var ro = new ResizeObserver(update);
        ro.observe(el);
        return function() {
            return ro.disconnect();
        };
    }, []);
    var _useState461 = _sliced_to_array(useState46(function() {
        return typeof document === "undefined" ? null : document.activeElement;
    }), 1), opener = _useState461[0];
    useLayoutEffect4(function() {
        var made = [];
        var node = layerRef.current;
        while(node && node.parentElement && node !== document.body){
            var parent = node.parentElement;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Array.from(parent.children)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var sibling = _step.value;
                    if (sibling !== node && !sibling.hasAttribute("inert")) {
                        sibling.setAttribute("inert", "");
                        made.push(sibling);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            node = parent;
        }
        return function() {
            made.forEach(function(el) {
                return el.removeAttribute("inert");
            });
            if (_instanceof(opener, HTMLElement) && opener.isConnected) opener.focus();
        };
    }, [
        opener
    ]);
    var focusOnMount = useCallback9(function(node) {
        node === null || node === void 0 ? void 0 : node.focus();
    }, []);
    var closeRef = useRef16(onClose);
    closeRef.current = onClose;
    useEffect32(function() {
        var onKey = function(e) {
            if (e.key !== "Escape") return;
            var target = _instanceof(e.target, Element) ? e.target : null;
            var otherDialog = target === null || target === void 0 ? void 0 : target.closest('[role="dialog"], [aria-modal="true"]');
            if (otherDialog && otherDialog !== layerRef.current) return;
            e.preventDefault();
            e.stopPropagation();
            closeRef.current();
        };
        document.addEventListener("keydown", onKey, true);
        return function() {
            return document.removeEventListener("keydown", onKey, true);
        };
    }, []);
    var trapTab = function(e) {
        if (e.key !== "Tab") return;
        var buttons = Array.from(e.currentTarget.querySelectorAll("button:not([disabled])"));
        if (buttons.length === 0) return;
        var first = buttons[0];
        var last = buttons[buttons.length - 1];
        if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
        }
    };
    var rect = area.w > 0 && area.h > 0 ? expandedRectFor(feed.aspectRatio, area.w, area.h) : null;
    return /* @__PURE__ */ jsx100(ExpandLayer, {
        ref: layerRef,
        "data-testid": "camera-wall-expanded",
        onKeyDown: trapTab,
        role: "dialog",
        "aria-modal": "true",
        "aria-label": "".concat(feed.name, " — expanded"),
        children: rect ? /* @__PURE__ */ jsxs69(Fragment22, {
            children: [
                /* @__PURE__ */ jsx100(CameraWallSurround, {
                    onClick: onClose
                }),
                /* @__PURE__ */ jsxs69(ExpandedPanel, {
                    onClick: onClose,
                    style: {
                        left: rect.left,
                        top: rect.top,
                        width: rect.width,
                        height: rect.height
                    },
                    children: [
                        /* @__PURE__ */ jsxs69(ExpandActions, {
                            children: [
                                onRefresh && CAMERA_WALL_STATES[feed.state].live ? /* @__PURE__ */ jsx100(CollapseButton, {
                                    type: "button",
                                    "aria-label": "Refresh ".concat(feed.name),
                                    onClick: function(e) {
                                        e.stopPropagation();
                                        onRefresh(feed.id);
                                    },
                                    children: /* @__PURE__ */ jsx100(RefreshIcon, {
                                        size: "sm"
                                    })
                                }) : null,
                                /* @__PURE__ */ jsx100(CollapseButton, {
                                    ref: focusOnMount,
                                    type: "button",
                                    "aria-label": "Collapse ".concat(feed.name),
                                    onClick: function(e) {
                                        e.stopPropagation();
                                        onClose();
                                    },
                                    children: /* @__PURE__ */ jsx100(CollapseIcon, {
                                        size: "sm"
                                    })
                                })
                            ]
                        }),
                        /* @__PURE__ */ jsx100("div", {
                            "data-camera-wall-expanded-tile": true,
                            children: /* @__PURE__ */ jsx100(CameraPicture, {
                                feed: feed,
                                size: "enlarged"
                            })
                        })
                    ]
                })
            ]
        }) : null
    });
};
var ExpandLayer = styled70.div(_templateObject136());
var zoomIn = keyframes2(_templateObject137());
var ExpandedPanel = styled70.div(_templateObject138(), zoomIn, EXPAND_MS, EXPAND_EASE);
var ExpandActions = styled70.div(_templateObject139(), space10[3], space10[3], space10[2]);
var CollapseButton = styled70.button(_templateObject140(), radius4.pill, glass2.blurSm, glass2.blurSm, shadow4.glassSm, semantic7.text.primary, motion4.durFast, motion4.easeUi, shadow4.glassHover);
// src/components/CameraWall/cameraWallSort.ts
var compareCameraWallFeeds = function(sort) {
    return function(a, b) {
        if (sort.key === "name") return a.name.localeCompare(b.name) * sort.dir;
        var at = capturedMs(a);
        var bt = capturedMs(b);
        if (at === null && bt === null) return a.name.localeCompare(b.name);
        if (at === null) return 1;
        if (bt === null) return -1;
        return (at - bt) * sort.dir;
    };
};
var capturedMs = function(f) {
    var _f_capturedAt;
    var ms = (_f_capturedAt = f.capturedAt) === null || _f_capturedAt === void 0 ? void 0 : _f_capturedAt.getTime();
    return ms === void 0 || Number.isNaN(ms) ? null : ms;
};
// src/components/CameraWall/cameraWallSearch.ts
var cameraWallFeedMatches = function(feed, query, placementOf) {
    var q = query.trim().toLocaleLowerCase();
    if (q === "") return true;
    if (feed.name.toLocaleLowerCase().includes(q)) return true;
    var where = placementOf === null || placementOf === void 0 ? void 0 : placementOf(feed);
    var camera = where && where.placed ? where.camera : void 0;
    return camera != null && camera.toLocaleLowerCase().includes(q);
};
var cameraWallInPlacement = function(feeds, placementFilter, placementOf) {
    if (!placementOf || placementFilter === "all") return feeds.slice();
    var wantPlaced = placementFilter === "placed";
    return feeds.filter(function(f) {
        return placementOf(f).placed === wantPlaced;
    });
};
var cameraWallShownFeeds = function(feeds, param) {
    var _param_placementFilter = param.placementFilter, placementFilter = _param_placementFilter === void 0 ? "all" : _param_placementFilter, activeFilters = param.activeFilters, query = param.query, placementOf = param.placementOf;
    var inPlacement = cameraWallInPlacement(feeds, placementFilter, placementOf);
    return (activeFilters.length > 0 ? inPlacement.filter(function(f) {
        return activeFilters.includes(f.state);
    }) : inPlacement).filter(function(f) {
        return cameraWallFeedMatches(f, query, placementOf);
    });
};
var noSearchMatchMessage = function(query) {
    return "No RTSP streams or cameras match “".concat(query.trim(), "”.");
};
// src/components/CameraWall/CameraWall.tsx
import { Fragment as Fragment23, jsx as jsx101, jsxs as jsxs70 } from "react/jsx-runtime";
var MAX_MOVES = 8;
var TIER_MIN_TRACK = {
    panel: "260px",
    modal: "190px"
};
var LIST_PANEL_MIN_TRACK = "180px";
var Card3 = styled71.section(_templateObject141(), radius5.xl, glass3.bg, glass3.blur, glass3.blur, glass3.border, shadow5.glass, space11[3], inset[3], function(p) {
    return p.$fill ? "height: 100%; min-height: 0; box-sizing: border-box;" : "";
});
var Head = styled71.header(_templateObject142(), space11[3], space11[1]);
var TwinName = styled71.span(_templateObject143(), typeRole6.subtitle2.fontSize, typeRole6.subtitle2.lineHeight, weight2.semibold, semantic8.text.primary);
var CustomerName = styled71.span(_templateObject144(), typeRole6.body1.fontSize, typeRole6.body1.lineHeight, semantic8.text.body);
var CountPill2 = styled71.span(_templateObject145(), space11[2], radius5.pill, inkOn3.aqua, typeRole6.caption2.fontSize, typeRole6.caption2.lineHeight, weight2.semibold);
var Spacer = styled71.span(_templateObject146());
var Controls = styled71.div(_templateObject147(), space11[2], space11[1]);
var Divider = styled71.span(_templateObject148(), line5[2], space11[1]);
var Rule = styled71.div(_templateObject149(), line5[2], inset[1]);
var ScrollArea = styled71.div(_templateObject150(), function(p) {
    return p.$fill ? "flex: 1 1 0; min-height: 0;" : "height: ".concat(p.$height, ";");
}, space11[3], space11[3], space11[3]);
var ScrollHost = styled71(Scrollbar5)(_templateObject151(), rowMotionGapLook("0"));
var Summary = styled71.div(_templateObject152(), inset[1]);
var SummaryMain = styled71.span(_templateObject153(), typeRole6.body1Stronger.fontSize, typeRole6.body1Stronger.lineHeight, weight2.semibold, semantic8.text.primary);
var NOTE_INK = {
    "no-stream": PLACEMENT_TONE["no-stream"].ink,
    placed: ink9[3],
    neutral: ink9[3]
};
var SummaryNote = styled71.span(_templateObject154(), inset[2], typeRole6.captionCompact.fontSize, typeRole6.captionCompact.lineHeight, weight2.medium, function(p) {
    return NOTE_INK[p.$tone];
});
var RUN_TAG_NOT_PLACED = {
    tone: semantic8.status.roles.workToDo.tagTone,
    dotTone: "peri"
};
var RunHeader = styled71.div(_templateObject155(), space11[3], inset[1], inset[1]);
var RunSort = styled71.div(_templateObject156(), inset[1]);
var ListHeader = styled71.div(_templateObject157(), space11[3]);
var ListSummaryRow = styled71.div(_templateObject158(), space11[3]);
var MotionCell = styled71.div(_templateObject159());
var Grid = styled71.div(_templateObject160(), function(p) {
    return p.$minTrack;
}, space11[1]);
var STATUS_ALL = "all";
var CameraWall = function(param) {
    var feeds = param.feeds, _param_tier = param.tier, tier = _param_tier === void 0 ? "panel" : _param_tier, title = param.title, subtitle = param.subtitle, sort = param.sort, activeFilters = param.activeFilters, onSortChange = param.onSortChange, onFiltersChange = param.onFiltersChange, onRefreshAll = param.onRefreshAll, onRefreshFeed = param.onRefreshFeed, onConfigureFeed = param.onConfigureFeed, feedAction = param.feedAction, feedDrag = param.feedDrag, feedSelect = param.feedSelect, onFeedHover = param.onFeedHover, onSelectFeed = param.onSelectFeed, selectedFeedIds = param.selectedFeedIds, zoomRegionsFor = param.zoomRegionsFor, _param_isRefreshing = param.isRefreshing, isRefreshing = _param_isRefreshing === void 0 ? false : _param_isRefreshing, placement = param.placement, tmp = param.height, height2 = tmp === void 0 ? 472 : tmp, className = param.className, _param_layout = param.layout, layout = _param_layout === void 0 ? "default" : _param_layout, frame = param.frame, bodyOverride = param.bodyOverride, _param_chipSize = param.chipSize, chipSize = _param_chipSize === void 0 ? "dense" : _param_chipSize, _param_query = param.query, query = _param_query === void 0 ? "" : _param_query;
    var listPanel = layout === "list-panel" && frame != null;
    var _useState47 = _sliced_to_array(useState47(null), 2), expandedId = _useState47[0], setExpandedId = _useState47[1];
    var fill = height2 === "fill";
    var areaRef = useRef17(null);
    var placementOf = placement === null || placement === void 0 ? void 0 : placement.of;
    var _placement_filter;
    var placementFilter = (_placement_filter = placement === null || placement === void 0 ? void 0 : placement.filter) !== null && _placement_filter !== void 0 ? _placement_filter : "all";
    var placementById = useMemo10(function() {
        if (!placementOf) return null;
        var byId = /* @__PURE__ */ new Map();
        feeds.forEach(function(f) {
            return byId.set(String(f.id), placementOf(f));
        });
        return byId;
    }, [
        feeds,
        placementOf
    ]);
    var placedCount = useMemo10(function() {
        return placementById ? feeds.reduce(function(n, f) {
            var _placementById_get;
            return n + (((_placementById_get = placementById.get(String(f.id))) === null || _placementById_get === void 0 ? void 0 : _placementById_get.placed) ? 1 : 0);
        }, 0) : 0;
    }, [
        feeds,
        placementById
    ]);
    var inPlacement = useMemo10(function() {
        return cameraWallInPlacement(feeds, placementFilter, placementOf);
    }, [
        feeds,
        placementFilter,
        placementOf
    ]);
    var counts = useMemo10(function() {
        var c = {};
        inPlacement.forEach(function(f) {
            var _c_f_state;
            c[f.state] = ((_c_f_state = c[f.state]) !== null && _c_f_state !== void 0 ? _c_f_state : 0) + 1;
        });
        return c;
    }, [
        inPlacement
    ]);
    var visible = useMemo10(function() {
        return cameraWallShownFeeds(feeds, {
            placementFilter: placementFilter,
            activeFilters: activeFilters,
            query: query,
            placementOf: placementOf
        }).sort(// One comparator, shared with Camera Feeds' stream picker (`compareCameraWallFeeds`).
        compareCameraWallFeeds(sort));
    }, [
        feeds,
        placementFilter,
        activeFilters,
        sort,
        query,
        placementOf
    ]);
    var chipsLeaveAny = useMemo10(function() {
        return cameraWallShownFeeds(feeds, {
            placementFilter: placementFilter,
            activeFilters: activeFilters,
            query: "",
            placementOf: placementOf
        }).length > 0;
    }, [
        feeds,
        placementFilter,
        activeFilters,
        placementOf
    ]);
    var onFeedHoverRef = useRef17(onFeedHover);
    var pointerOnRef = useRef17(null);
    var focusOnRef = useRef17(null);
    var reportedRef = useRef17(null);
    var tellHost = useCallback10(function() {
        var _onFeedHoverRef_current;
        var _pointerOnRef_current;
        var now = (_pointerOnRef_current = pointerOnRef.current) !== null && _pointerOnRef_current !== void 0 ? _pointerOnRef_current : focusOnRef.current;
        if (now === reportedRef.current) return;
        reportedRef.current = now;
        (_onFeedHoverRef_current = onFeedHoverRef.current) === null || _onFeedHoverRef_current === void 0 ? void 0 : _onFeedHoverRef_current.call(onFeedHoverRef, now);
    }, []);
    onFeedHoverRef.current = onFeedHover;
    var previousListenerRef = useRef17(onFeedHover);
    useEffect33(function() {
        var previous = previousListenerRef.current;
        previousListenerRef.current = onFeedHover;
        if (previous === onFeedHover) return;
        var current = reportedRef.current;
        if (previous && current != null) previous(null);
        if (onFeedHover) {
            if (current != null) onFeedHover(current);
            return;
        }
        pointerOnRef.current = null;
        focusOnRef.current = null;
        reportedRef.current = null;
    }, [
        onFeedHover
    ]);
    var hasHoverListener = !!onFeedHover;
    var reportHover = useMemo10(function() {
        return hasHoverListener ? function(id, source) {
            if (source === "pointer") pointerOnRef.current = id;
            else focusOnRef.current = id;
            tellHost();
        } : void 0;
    }, [
        hasHoverListener,
        tellHost
    ]);
    useEffect33(function() {
        var drawn = function(id) {
            return id != null && visible.some(function(f) {
                return f.id === id;
            });
        };
        if (pointerOnRef.current != null && !drawn(pointerOnRef.current)) pointerOnRef.current = null;
        if (focusOnRef.current != null) {
            var _viewportRef_current;
            var _viewportRef_current_contains;
            var inside = (_viewportRef_current_contains = (_viewportRef_current = viewportRef.current) === null || _viewportRef_current === void 0 ? void 0 : _viewportRef_current.contains(document.activeElement)) !== null && _viewportRef_current_contains !== void 0 ? _viewportRef_current_contains : true;
            if (!drawn(focusOnRef.current) || !inside) focusOnRef.current = null;
        }
        tellHost();
    }, [
        visible,
        tellHost
    ]);
    useEffect33(function() {
        return function() {
            var _onFeedHoverRef_current;
            if (reportedRef.current != null) (_onFeedHoverRef_current = onFeedHoverRef.current) === null || _onFeedHoverRef_current === void 0 ? void 0 : _onFeedHoverRef_current.call(onFeedHoverRef, null);
        };
    }, []);
    var runs = useMemo10(function() {
        if (!placementById) return null;
        var isPlaced = function(f) {
            var _placementById_get;
            var _placementById_get_placed;
            return (_placementById_get_placed = (_placementById_get = placementById.get(String(f.id))) === null || _placementById_get === void 0 ? void 0 : _placementById_get.placed) !== null && _placementById_get_placed !== void 0 ? _placementById_get_placed : false;
        };
        return [
            {
                key: "not-placed",
                title: "Not placed",
                feeds: visible.filter(function(f) {
                    return !isPlaced(f);
                })
            },
            {
                key: "placed",
                title: "Placed",
                feeds: visible.filter(isPlaced)
            }
        ].filter(function(run) {
            return run.feeds.length > 0;
        });
    }, [
        visible,
        placementById
    ]);
    var groupsKey = placementById ? JSON.stringify(feeds.map(function(f) {
        var _placementById_get;
        return [
            String(f.id),
            ((_placementById_get = placementById.get(String(f.id))) === null || _placementById_get === void 0 ? void 0 : _placementById_get.placed) ? "placed" : "not-placed"
        ];
    })) : "";
    var motionGroups = useMemo10(function() {
        return new Map(groupsKey ? JSON.parse(groupsKey) : []);
    }, [
        groupsKey
    ]);
    var motionEpoch = [
        sort.key,
        sort.dir,
        placementFilter,
        activeFilters.join(","),
        query.trim()
    ].join("|");
    var viewportRef = useRef17(null);
    var moved = useRowMotion(viewportRef, {
        groups: motionGroups,
        epoch: motionEpoch,
        maxMoves: MAX_MOVES
    }).moved;
    useKeepFocusAcrossMove(viewportRef);
    useDragEdgeScroll(viewportRef, !!feedDrag);
    var _useState471 = _sliced_to_array(useState47(function() {
        return /* @__PURE__ */ new Set();
    }), 2), arrivedIds = _useState471[0], setArrivedIds = _useState471[1];
    var arriveTimers = useRef17(/* @__PURE__ */ new Map());
    var groupsRef = useRef17(motionGroups);
    groupsRef.current = motionGroups;
    useEffect33(function() {
        if (moved.length === 0) return;
        var into = moved.filter(function(key) {
            return groupsRef.current.get(key) === "placed";
        });
        var outOf = moved.filter(function(key) {
            return groupsRef.current.get(key) !== "placed";
        });
        outOf.forEach(function(key) {
            var pending = arriveTimers.current.get(key);
            if (pending !== void 0) window.clearTimeout(pending);
            arriveTimers.current.delete(key);
        });
        setArrivedIds(function(prev) {
            if (into.length === 0 && !outOf.some(function(key) {
                return prev.has(key);
            })) return prev;
            var next = new Set(prev);
            outOf.forEach(function(key) {
                return next.delete(key);
            });
            into.forEach(function(key) {
                return next.add(key);
            });
            return next;
        });
        into.forEach(function(key) {
            var pending = arriveTimers.current.get(key);
            if (pending !== void 0) window.clearTimeout(pending);
            var t = window.setTimeout(function() {
                arriveTimers.current.delete(key);
                setArrivedIds(function(prev) {
                    if (!prev.has(key)) return prev;
                    var next = new Set(prev);
                    next.delete(key);
                    return next;
                });
            }, ARRIVED_MS);
            arriveTimers.current.set(key, t);
        });
    }, [
        moved
    ]);
    useEffect33(function() {
        var timers = arriveTimers.current;
        return function() {
            timers.forEach(function(t) {
                return window.clearTimeout(t);
            });
            timers.clear();
            setArrivedIds(function(prev) {
                return prev.size === 0 ? prev : /* @__PURE__ */ new Set();
            });
        };
    }, [
        motionEpoch
    ]);
    var expandedFeed = useMemo10(function() {
        var _feeds_find;
        return expandedId == null ? null : (_feeds_find = feeds.find(function(f) {
            return f.id === expandedId;
        })) !== null && _feeds_find !== void 0 ? _feeds_find : null;
    }, [
        feeds,
        expandedId
    ]);
    var collapse = useCallback10(function() {
        return setExpandedId(null);
    }, []);
    var actionPropsFor = function(feed) {
        var _feedSelect;
        var select = (_feedSelect = feedSelect === null || feedSelect === void 0 ? void 0 : feedSelect(feed)) !== null && _feedSelect !== void 0 ? _feedSelect : null;
        if (select && onSelectFeed) {
            return {
                onSelect: onSelectFeed,
                selectLabel: select.label,
                selectAction: true
            };
        }
        return {
            onExpand: setExpandedId
        };
    };
    var lastGroupsRef = useRef17(motionGroups);
    var lastEpochRef = useRef17(motionEpoch);
    var prevSelectedRef = useRef17(selectedFeedIds);
    useEffect33(function() {
        var prev = prevSelectedRef.current;
        prevSelectedRef.current = selectedFeedIds;
        if (!selectedFeedIds || selectedFeedIds === prev) return;
        var lastGroups = lastGroupsRef.current;
        var changedRun = function(key) {
            var had = lastGroups.get(key);
            return had !== void 0 && had !== motionGroups.get(key);
        };
        var changes = 0;
        motionGroups.forEach(function(_group, key) {
            if (changedRun(key)) changes += 1;
        });
        var rowMotionMoves = lastEpochRef.current === motionEpoch && changes >= 1 && changes <= MAX_MOVES;
        var movedNow = function(id) {
            return rowMotionMoves && changedRun(String(id));
        };
        var el = null;
        selectedFeedIds.forEach(function(id) {
            var _areaRef_current;
            if (el || (prev === null || prev === void 0 ? void 0 : prev.has(id)) || movedNow(id)) return;
            var _areaRef_current_querySelector;
            el = (_areaRef_current_querySelector = (_areaRef_current = areaRef.current) === null || _areaRef_current === void 0 ? void 0 : _areaRef_current.querySelector('[data-testid="camera-wall-tile-'.concat(CSS.escape(String(id)), '"]'))) !== null && _areaRef_current_querySelector !== void 0 ? _areaRef_current_querySelector : null;
        });
        var target = el;
        if (target && typeof target.scrollIntoView === "function") {
            target.scrollIntoView({
                block: "nearest",
                inline: "nearest"
            });
        }
    }, [
        selectedFeedIds
    ]);
    useEffect33(function() {
        lastGroupsRef.current = motionGroups;
        lastEpochRef.current = motionEpoch;
    }, [
        motionGroups,
        motionEpoch
    ]);
    useEffect33(function() {
        if (expandedId != null && !feeds.some(function(f) {
            return f.id === expandedId;
        })) setExpandedId(null);
    }, [
        feeds,
        expandedId
    ]);
    var toggleSort = function(key) {
        return onSortChange(sort.key === key ? {
            key: key,
            dir: sort.dir === 1 ? -1 : 1
        } : {
            key: key,
            dir: key === "name" ? 1 : -1
        });
    };
    var toggleFilter = function(state) {
        return onFiltersChange(activeFilters.includes(state) ? activeFilters.filter(function(s) {
            return s !== state;
        }) : _to_consumable_array(activeFilters).concat([
            state
        ]));
    };
    var pickPlacement = function(next) {
        if (placement && placement.filter !== next) placement.onFilterChange(next);
    };
    var pickStatus = function(state) {
        var already = state === null ? activeFilters.length === 0 : activeFilters.length === 1 && activeFilters[0] === state;
        if (already) return;
        onFiltersChange(state === null ? [] : [
            state
        ]);
    };
    var summary = placement && feeds.length > 0 ? placementSummary(placedCount, feeds.length, placement.camerasWithoutStream, listPanel ? "RTSP stream" : "stream") : null;
    var emptyMessage = feeds.length === 0 ? "This twin has no RTSP streams." : query.trim() !== "" && chipsLeaveAny ? noSearchMatchMessage(query) : !placement ? "No streams match the selected status filters." : placementFilter === "placed" && placedCount === 0 ? "No stream is placed yet. Drag one onto the plan." : placementFilter === "not-placed" && placedCount === feeds.length ? "Every stream is placed." : "No streams match this status.";
    var _counts_warning, _counts_error;
    var needsAttention = ((_counts_warning = counts.warning) !== null && _counts_warning !== void 0 ? _counts_warning : 0) + ((_counts_error = counts.error) !== null && _counts_error !== void 0 ? _counts_error : 0);
    var allPlacementChip = placement ? {
        key: "all",
        label: "All",
        count: feeds.length,
        active: placement.filter === "all"
    } : null;
    var placementChips = placement ? // Frame 02 leads with All; the default wall keeps it last, as it always was.
    _to_consumable_array(listPanel && allPlacementChip ? [
        allPlacementChip
    ] : []).concat([
        {
            key: "not-placed",
            label: "Not placed",
            count: feeds.length - placedCount,
            dot: PLACEMENT_TONE["not-placed"].dot,
            active: placement.filter === "not-placed"
        },
        {
            key: "placed",
            label: "Placed",
            count: placedCount,
            active: placement.filter === "placed"
        }
    ], _to_consumable_array(!listPanel && allPlacementChip ? [
        allPlacementChip
    ] : [])) : [];
    var statusChips = _to_consumable_array(placement ? [
        {
            key: STATUS_ALL,
            label: "All",
            count: inPlacement.length,
            active: activeFilters.length === 0
        }
    ] : []).concat(_to_consumable_array((placement ? CAMERA_WALL_PLACEMENT_STATUS_ORDER : CAMERA_WALL_STATE_ORDER).map(function(state) {
        var _counts_state;
        return {
            key: state,
            label: CAMERA_WALL_FILTER_LABELS[state],
            count: (_counts_state = counts[state]) !== null && _counts_state !== void 0 ? _counts_state : 0,
            dot: CAMERA_WALL_STATES[state].dot,
            active: activeFilters.includes(state)
        };
    })));
    var tileFor = function(feed) {
        var _feedAction, _feedDrag, _selectedFeedIds_has;
        return /* @__PURE__ */ jsx101(CameraWallTile, _object_spread_props(_object_spread({
            feed: feed,
            onRefresh: onRefreshFeed,
            onConfigure: onConfigureFeed,
            action: (_feedAction = feedAction === null || feedAction === void 0 ? void 0 : feedAction(feed)) !== null && _feedAction !== void 0 ? _feedAction : void 0,
            drag: (_feedDrag = feedDrag === null || feedDrag === void 0 ? void 0 : feedDrag(feed)) !== null && _feedDrag !== void 0 ? _feedDrag : void 0
        }, actionPropsFor(feed)), {
            selected: (_selectedFeedIds_has = selectedFeedIds === null || selectedFeedIds === void 0 ? void 0 : selectedFeedIds.has(feed.id)) !== null && _selectedFeedIds_has !== void 0 ? _selectedFeedIds_has : false,
            zoomRegions: zoomRegionsFor === null || zoomRegionsFor === void 0 ? void 0 : zoomRegionsFor(feed),
            placement: placementById === null || placementById === void 0 ? void 0 : placementById.get(String(feed.id)),
            arrived: arrivedIds.has(String(feed.id)),
            onHoverChange: reportHover
        }));
    };
    var _counts_healthy;
    var summaryEl = placement ? summary ? /* @__PURE__ */ jsxs70(Summary, {
        "data-testid": "camera-wall-summary",
        children: [
            /* @__PURE__ */ jsx101(SummaryMain, {
                children: summary.main
            }),
            /* @__PURE__ */ jsxs70(SummaryNote, {
                $tone: summary.note.tone,
                children: [
                    summary.note.tone === "no-stream" ? /* @__PURE__ */ jsx101(PlacementDot, {
                        $tone: "no-stream"
                    }) : null,
                    summary.note.text
                ]
            })
        ]
    }) : null : /* @__PURE__ */ jsxs70(CountPill2, {
        children: [
            feeds.length,
            " ",
            feeds.length === 1 ? "stream" : "streams",
            " \xB7 ",
            (_counts_healthy = counts.healthy) !== null && _counts_healthy !== void 0 ? _counts_healthy : 0,
            " healthy",
            needsAttention > 0 ? " \xb7 ".concat(needsAttention, " need attention") : ""
        ]
    });
    var refreshAllEl = onRefreshAll ? /* @__PURE__ */ jsx101(Button9, {
        variant: "frosted",
        size: "inline",
        onClick: onRefreshAll,
        loading: isRefreshing,
        iconLeft: /* @__PURE__ */ jsx101(RefreshIcon, {
            size: "md"
        }),
        children: "Refresh All"
    }) : null;
    var sortTags = /* @__PURE__ */ jsxs70(Fragment23, {
        children: [
            /* @__PURE__ */ jsxs70(Tag2, {
                surface: "on-glass",
                size: chipSize,
                toggle: true,
                active: sort.key === "name",
                onToggle: function() {
                    return toggleSort("name");
                },
                "aria-label": "Sort by name".concat(sort.key === "name" ? sort.dir === 1 ? ", ascending" : ", descending" : ""),
                children: [
                    "Name",
                    sort.key === "name" ? sort.dir === 1 ? " \u2191" : " \u2193" : ""
                ]
            }),
            /* @__PURE__ */ jsxs70(Tag2, {
                surface: "on-glass",
                size: chipSize,
                toggle: true,
                active: sort.key === "time",
                onToggle: function() {
                    return toggleSort("time");
                },
                "aria-label": "Sort by last frame".concat(sort.key === "time" ? sort.dir === 1 ? ", oldest first" : ", newest first" : ""),
                children: [
                    "Last frame",
                    sort.key === "time" ? sort.dir === 1 ? " \u2191" : " \u2193" : ""
                ]
            })
        ]
    });
    var onStatusToggle = function(key) {
        if (placement) pickStatus(key === STATUS_ALL ? null : key);
        else if (key !== STATUS_ALL) toggleFilter(key);
    };
    var minTrack = listPanel ? LIST_PANEL_MIN_TRACK : TIER_MIN_TRACK[tier];
    var scrollArea = /* @__PURE__ */ jsxs70(ScrollArea, {
        ref: areaRef,
        $fill: fill || listPanel,
        $height: fill || listPanel ? void 0 : typeof height2 === "number" ? "".concat(height2, "px") : height2,
        className: listPanel ? "is-list-panel" : void 0,
        children: [
            /* @__PURE__ */ jsx101(ScrollHost, {
                variant: "glass",
                maxHeight: "100%",
                viewportRef: viewportRef,
                "aria-hidden": expandedId != null || void 0,
                children: visible.length === 0 ? // `EmptyInline` is the design system's shared empty treatment and carries role="status",
                // so a filter that empties the wall is announced rather than changing silently.
                /* @__PURE__ */ jsx101(EmptyInline, {
                    message: emptyMessage
                }) : runs ? /*
               * ONE flat keyed list under the grid — headers and tiles as siblings, never a Fragment
               * per run. React matches keys only among siblings, so a keyed Fragment per run would
               * make a feed that changes run a different child: unmounted from one run and mounted
               * in the other, losing its picture, rest timer and focus (review, 2026-10-10). As
               * siblings, a placement is a keyed REORDER and React moves the existing tile.
               */ /* @__PURE__ */ jsx101(Grid, {
                    $minTrack: minTrack,
                    "data-testid": "camera-wall-grid",
                    children: runs.flatMap(function(run, i) {
                        return [
                            /* @__PURE__ */ jsxs70(RunHeader, {
                                "data-testid": "camera-wall-run-".concat(run.key),
                                children: [
                                    /* @__PURE__ */ jsx101(Tag2, {
                                        surface: "on-glass",
                                        tone: run.key === "placed" ? "neutral" : RUN_TAG_NOT_PLACED.tone,
                                        dot: run.key !== "placed",
                                        dotTone: run.key === "placed" ? void 0 : RUN_TAG_NOT_PLACED.dotTone,
                                        count: run.feeds.length,
                                        children: run.title
                                    }),
                                    listPanel && i === 0 ? /* @__PURE__ */ jsx101(RunSort, {
                                        role: "group",
                                        "aria-label": "Sort",
                                        children: sortTags
                                    }) : null
                                ]
                            }, "run:".concat(run.key))
                        ].concat(_to_consumable_array(run.feeds.map(function(feed) {
                            return /* @__PURE__ */ jsx101(MotionCell, {
                                "data-motion-key": String(feed.id),
                                children: tileFor(feed)
                            }, "feed:".concat(String(feed.id)));
                        })));
                    })
                }) : /* @__PURE__ */ jsx101(Grid, {
                    $minTrack: minTrack,
                    "data-testid": "camera-wall-grid",
                    children: visible.map(function(feed) {
                        return /* @__PURE__ */ jsx101(React49.Fragment, {
                            children: tileFor(feed)
                        }, feed.id);
                    })
                })
            }),
            expandedFeed ? /* @__PURE__ */ jsx101(CameraPictureDialog, {
                feed: expandedFeed,
                onClose: collapse,
                onRefresh: onRefreshFeed
            }) : null
        ]
    });
    if (listPanel && bodyOverride !== void 0) {
        return /* @__PURE__ */ jsx101(Fragment23, {
            children: frame({
                header: null,
                body: bodyOverride
            })
        });
    }
    if (listPanel) {
        var header = /* @__PURE__ */ jsxs70(ListHeader, {
            "data-testid": "camera-wall-list-header",
            children: [
                /* @__PURE__ */ jsxs70(ListSummaryRow, {
                    children: [
                        summaryEl,
                        /* @__PURE__ */ jsx101(Spacer, {}),
                        refreshAllEl
                    ]
                }),
                placement ? /* @__PURE__ */ jsx101(FilterChipGroup, {
                    label: "Placement",
                    caption: "above",
                    size: chipSize,
                    chips: placementChips,
                    onToggle: pickPlacement
                }) : null,
                /* @__PURE__ */ jsx101(FilterChipGroup, {
                    label: "Status",
                    caption: "above",
                    size: chipSize,
                    chips: statusChips,
                    onToggle: onStatusToggle
                })
            ]
        });
        return /* @__PURE__ */ jsx101(Fragment23, {
            children: frame({
                header: header,
                body: scrollArea
            })
        });
    }
    return /* @__PURE__ */ jsxs70(Card3, {
        className: className,
        "aria-label": "Camera wall",
        $fill: fill,
        children: [
            /* @__PURE__ */ jsxs70(Head, {
                children: [
                    title ? /* @__PURE__ */ jsx101(TwinName, {
                        children: title
                    }) : null,
                    subtitle ? /* @__PURE__ */ jsx101(CustomerName, {
                        children: subtitle
                    }) : null,
                    summaryEl,
                    /* @__PURE__ */ jsx101(Spacer, {}),
                    refreshAllEl
                ]
            }),
            /* @__PURE__ */ jsxs70(Controls, {
                children: [
                    placement ? /* @__PURE__ */ jsxs70(Fragment23, {
                        children: [
                            /* @__PURE__ */ jsx101(FilterChipGroup, {
                                label: "Placement",
                                caption: "hidden",
                                size: chipSize,
                                chips: placementChips,
                                onToggle: pickPlacement
                            }),
                            /* @__PURE__ */ jsx101(Divider, {})
                        ]
                    }) : null,
                    /* @__PURE__ */ jsx101(FilterChipCaption, {
                        id: "camera-wall-sort-label",
                        children: "Sort"
                    }),
                    sortTags,
                    /* @__PURE__ */ jsx101(Divider, {}),
                    /* @__PURE__ */ jsx101(FilterChipGroup, {
                        label: "Status",
                        caption: "inline",
                        size: chipSize,
                        chips: statusChips,
                        onToggle: onStatusToggle
                    })
                ]
            }),
            /* @__PURE__ */ jsx101(Rule, {}),
            scrollArea
        ]
    });
};
// src/components/CameraWall/CameraPictureModal.tsx
import { useCallback as useCallback11, useEffect as useEffect34, useLayoutEffect as useLayoutEffect5, useRef as useRef18, useState as useState48 } from "react";
import { createPortal as createPortal3 } from "react-dom";
import styled72 from "styled-components";
import { glass as glass4, motion as motion6, radius as radius6, semantic as semantic9, shadow as shadow6, space as space12 } from "@repo/design-tokens";
import { jsx as jsx102, jsxs as jsxs71 } from "react/jsx-runtime";
var viewportNow2 = function() {
    return {
        width: window.innerWidth,
        height: window.innerHeight
    };
};
var rectOf2 = function(el) {
    var r = el.getBoundingClientRect();
    return {
        left: r.left,
        top: r.top,
        width: r.width,
        height: r.height
    };
};
var CameraPictureModal = function(param) {
    var feed = param.feed, label = param.label, anchor = param.anchor, returnFocusTo = param.returnFocusTo, onClose = param.onClose, overlay = param.overlay, controls = param.controls;
    var rootRef = useRef18(null);
    var boxRef = useRef18(null);
    var _useState48 = _sliced_to_array(useState48(function() {
        return zoomTargetRect(feed.aspectRatio, viewportNow2(), FRAME_ZOOM_INSET_PX);
    }), 2), target = _useState48[0], setTarget = _useState48[1];
    var _useState481 = _sliced_to_array(useState48(false), 2), closing = _useState481[0], setClosing = _useState481[1];
    var animRef = useRef18(null);
    var closeRef = useRef18(onClose);
    closeRef.current = onClose;
    var closedRef = useRef18(false);
    var closeOnce = useCallback11(function() {
        if (closedRef.current) return;
        closedRef.current = true;
        closeRef.current();
    }, []);
    var anchorRef = useRef18(anchor);
    anchorRef.current = anchor;
    var returnRef = useRef18(returnFocusTo !== null && returnFocusTo !== void 0 ? returnFocusTo : anchor);
    returnRef.current = returnFocusTo !== null && returnFocusTo !== void 0 ? returnFocusTo : anchor;
    useEffect34(function() {
        var onResize = function() {
            return setTarget(zoomTargetRect(feed.aspectRatio, viewportNow2(), FRAME_ZOOM_INSET_PX));
        };
        onResize();
        window.addEventListener("resize", onResize);
        return function() {
            return window.removeEventListener("resize", onResize);
        };
    }, [
        feed.aspectRatio
    ]);
    useLayoutEffect5(function() {
        var box = boxRef.current;
        var from = anchorRef.current;
        if (!box || !from || prefersReducedMotion() || typeof box.animate !== "function") return;
        animRef.current = box.animate([
            {
                transform: flipTransform(rectOf2(from), target)
            },
            {
                transform: "none"
            }
        ], {
            duration: EXPAND_MS,
            easing: EXPAND_EASE
        });
    }, []);
    useLayoutEffect5(function() {
        var made = [];
        var node = rootRef.current;
        while(node && node.parentElement && node !== document.body){
            var parent = node.parentElement;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Array.from(parent.children)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var sibling = _step.value;
                    if (sibling !== node && !sibling.hasAttribute("inert")) {
                        sibling.setAttribute("inert", "");
                        made.push(sibling);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            node = parent;
        }
        return function() {
            var _animRef_current;
            made.forEach(function(el) {
                return el.removeAttribute("inert");
            });
            (_animRef_current = animRef.current) === null || _animRef_current === void 0 ? void 0 : _animRef_current.cancel();
            var opener = returnRef.current;
            if (opener === null || opener === void 0 ? void 0 : opener.isConnected) opener.focus();
        };
    }, []);
    var close3 = useCallback11(function() {
        var _animRef_current;
        if (closing) return;
        var box = boxRef.current;
        var to = anchorRef.current;
        if (!box || !to || !to.isConnected || prefersReducedMotion() || typeof box.animate !== "function") {
            closeOnce();
            return;
        }
        setClosing(true);
        (_animRef_current = animRef.current) === null || _animRef_current === void 0 ? void 0 : _animRef_current.cancel();
        var anim = box.animate([
            {
                transform: "none"
            },
            {
                transform: flipTransform(rectOf2(to), rectOf2(box))
            }
        ], {
            duration: EXPAND_MS,
            easing: EXPAND_EASE,
            fill: "forwards"
        });
        animRef.current = anim;
        anim.onfinish = closeOnce;
        anim.oncancel = closeOnce;
    }, [
        closing,
        closeOnce
    ]);
    useEffect34(function() {
        var onKey = function(e) {
            if (e.key !== "Escape") return;
            e.preventDefault();
            e.stopPropagation();
            close3();
        };
        document.addEventListener("keydown", onKey, true);
        return function() {
            return document.removeEventListener("keydown", onKey, true);
        };
    }, [
        close3
    ]);
    var focusOnMount = useCallback11(function(node) {
        node === null || node === void 0 ? void 0 : node.focus();
    }, []);
    var trapTab = function(e) {
        if (e.key !== "Tab") return;
        var focusables = Array.from(e.currentTarget.querySelectorAll('button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(function(el) {
            return el.getAttribute("aria-disabled") !== "true" || el.tagName === "INPUT";
        });
        if (focusables.length === 0) return;
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
        }
    };
    if (typeof document === "undefined") return null;
    return createPortal3(/* @__PURE__ */ jsxs71(Root, {
        ref: rootRef,
        role: "dialog",
        "aria-modal": "true",
        "aria-label": label,
        "data-testid": "camera-picture-modal",
        onKeyDown: trapTab,
        children: [
            /* @__PURE__ */ jsx102(Surround2, {
                onClick: close3,
                "data-testid": "camera-picture-modal-surround"
            }),
            /* @__PURE__ */ jsxs71(Box, {
                ref: boxRef,
                "data-testid": "camera-picture-modal-box",
                style: {
                    left: target.left,
                    top: target.top,
                    width: target.width,
                    height: target.height
                },
                children: [
                    /* @__PURE__ */ jsx102(CameraPicture, {
                        feed: feed,
                        size: "enlarged",
                        overlay: overlay
                    }),
                    /* @__PURE__ */ jsxs71(Actions, {
                        children: [
                            /* @__PURE__ */ jsx102(CloseButton, {
                                ref: focusOnMount,
                                type: "button",
                                "aria-label": "Close",
                                onClick: close3,
                                children: /* @__PURE__ */ jsx102(CollapseIcon, {
                                    size: "sm"
                                })
                            }),
                            controls
                        ]
                    })
                ]
            })
        ]
    }), document.body);
};
var Root = styled72.div(_templateObject161(), FRAME_ZOOM_LAYER);
var Surround2 = styled72(CameraWallSurround)(_templateObject162());
var Box = styled72.div(_templateObject163(), FEED_OUTER_RADIUS, shadow6.glass);
var Actions = styled72.div(_templateObject164(), space12[3], space12[3], space12[2]);
var CloseButton = styled72.button(_templateObject165(), radius6.pill, glass4.bgStrong, glass4.blurSm, glass4.blurSm, shadow6.glassSm, semantic9.text.primary, motion6.durFast, motion6.easeUi, shadow6.glassHover);
// src/components/CameraWall/useCameraWallFeeds.ts
import { useCallback as useCallback12, useEffect as useEffect35, useMemo as useMemo11, useRef as useRef19, useState as useState49 } from "react";
import { ensureLatestStreamFrame, fetchStreamFrame, getLatestStreamFrame, getRTSPEndpointsOrThrow, EnsureLatestStreamFrameStatus } from "@repo/front-end-services";
var POLL_INTERVAL_MS = 3e3;
var POLL_MAX_ATTEMPTS = 30;
var MAX_CONCURRENCY = 6;
var STALE_AFTER_MS = 15 * 60 * 1e3;
var cameraWallFeedName = function(r) {
    var _r_description;
    return ((_r_description = r.description) === null || _r_description === void 0 ? void 0 : _r_description.trim()) || r.bid || "Stream ".concat(r.id);
};
var toEndpoint = function(r) {
    return {
        id: Number(r.id),
        name: cameraWallFeedName(r),
        // The camera's real ratio, so the tile letterboxes at it instead of assuming 16:9 —
        // FR2's "never crop" rule can only do its job with a true ratio. Both dimensions must be
        // present and positive; a partially-populated row falls back to the 16:9 default.
        aspectRatio: r.width && r.height && r.width > 0 && r.height > 0 ? r.width / r.height : void 0,
        attached: r.twin_device_id != null
    };
};
var NO_FRAME_YET = {
    state: "not_configured",
    reason: "No picture yet",
    statusLabel: "No picture"
};
var NOT_ATTACHED = {
    state: "not_configured",
    reason: "Not attached to a box",
    statusLabel: void 0
};
var stateForFrame = function(capturedAt) {
    return Date.now() - capturedAt.getTime() > STALE_AFTER_MS ? "warning" : "healthy";
};
var staleLabel = function(capturedAt) {
    var mins = Math.floor((Date.now() - capturedAt.getTime()) / 6e4);
    if (mins < 60) return "Stale ".concat(mins, " m");
    var hours = Math.floor(mins / 60);
    if (hours < 24) return "Stale ".concat(hours, " h");
    return "Stale ".concat(Math.floor(hours / 24), " d");
};
var runLimited = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(tasks, limit) {
        var next, workers;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    next = 0;
                    workers = Array.from({
                        length: Math.min(limit, tasks.length)
                    }, /*#__PURE__*/ _async_to_generator(function() {
                        var i;
                        return _ts_generator(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    i = next++;
                                    if (i >= tasks.length) return [
                                        2
                                    ];
                                    return [
                                        4,
                                        tasks[i]()
                                    ];
                                case 1:
                                    _state.sent();
                                    _state.label = 2;
                                case 2:
                                    return [
                                        3,
                                        0
                                    ];
                                case 3:
                                    return [
                                        2
                                    ];
                            }
                        });
                    }));
                    return [
                        4,
                        Promise.all(workers)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function runLimited(tasks, limit) {
        return _ref.apply(this, arguments);
    };
}();
var sleep = function(ms, signal) {
    return new Promise(function(resolve, reject) {
        if (signal.aborted) {
            reject(new DOMException("aborted", "AbortError"));
            return;
        }
        var onAbort = function() {
            clearTimeout(timer);
            reject(new DOMException("aborted", "AbortError"));
        };
        var timer = setTimeout(function() {
            signal.removeEventListener("abort", onAbort);
            resolve();
        }, ms);
        signal.addEventListener("abort", onAbort, {
            once: true
        });
    });
};
var capturedAtFromFrameId = function(frameId) {
    var ts = frameId.split(".")[2];
    var m = /^(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2})Z$/.exec(ts !== null && ts !== void 0 ? ts : "");
    if (!m) return null;
    var _m = _sliced_to_array(m, 7), y = _m[1], mo = _m[2], d = _m[3], h = _m[4], mi = _m[5], sec = _m[6];
    var at = /* @__PURE__ */ new Date("".concat(y, "-").concat(mo, "-").concat(d, "T").concat(h, ":").concat(mi, ":").concat(sec, "Z"));
    return Number.isNaN(at.getTime()) ? null : at;
};
var classifyFailure = function(err) {
    var _err_response;
    var status = err === null || err === void 0 ? void 0 : (_err_response = err.response) === null || _err_response === void 0 ? void 0 : _err_response.status;
    if (status === 401 || status === 403) return {
        state: "error",
        statusLabel: "Session expired"
    };
    if (status && status >= 500) return {
        state: "error",
        statusLabel: "Service error"
    };
    if (status) return {
        state: "error",
        statusLabel: "Request failed (".concat(status, ")")
    };
    return {
        state: "error",
        statusLabel: "Signal lost"
    };
};
var useCameraWallFeeds = function(param) {
    var baseUrl = param.baseUrl, accessToken = param.accessToken, twinId = param.twinId, suppliedEndpoints = param.endpoints, _param_pictureSize = param.pictureSize, pictureSize = _param_pictureSize === void 0 ? "original" : _param_pictureSize, _param_storedOnly = param.storedOnly, storedOnly = _param_storedOnly === void 0 ? false : _param_storedOnly;
    var bytesSize = pictureSize === "thumb" ? "thumb" : void 0;
    var tokenRef = useRef19(accessToken);
    useEffect35(function() {
        tokenRef.current = accessToken;
    }, [
        accessToken
    ]);
    var hasToken = !!accessToken;
    var suppliedKey = suppliedEndpoints ? "".concat(twinId !== null && twinId !== void 0 ? twinId : "none", ":").concat(suppliedEndpoints.map(function(r) {
        return r.id;
    }).join(",")) : null;
    var suppliedForKey = useMemo11(function() {
        return suppliedEndpoints;
    }, [
        suppliedKey
    ]);
    var _useState49 = _sliced_to_array(useState49([]), 2), endpoints = _useState49[0], setEndpoints = _useState49[1];
    var _useState491 = _sliced_to_array(useState49({}), 2), byId = _useState491[0], setById = _useState491[1];
    var _useState492 = _sliced_to_array(useState49(false), 2), isLoading = _useState492[0], setIsLoading = _useState492[1];
    var _useState493 = _sliced_to_array(useState49(false), 2), isRefreshing = _useState493[0], setIsRefreshing = _useState493[1];
    var _useState494 = _sliced_to_array(useState49(null), 2), error = _useState494[0], setError = _useState494[1];
    var _useState495 = _sliced_to_array(useState49(null), 2), seededKey = _useState495[0], setSeededKey = _useState495[1];
    var urlsRef = useRef19(/* @__PURE__ */ new Map());
    var attachedRef = useRef19(/* @__PURE__ */ new Map());
    var genRef = useRef19(/* @__PURE__ */ new Map());
    var abortRef = useRef19(new AbortController());
    var resetWall = useCallback12(function() {
        urlsRef.current.forEach(function(url) {
            return URL.revokeObjectURL(url);
        });
        urlsRef.current.clear();
        genRef.current.clear();
        attachedRef.current.clear();
        setEndpoints([]);
        setById({});
        setSeededKey(null);
    }, []);
    var setUrl = useCallback12(function(id, url) {
        var prev = urlsRef.current.get(id);
        if (prev && prev !== url) {
            URL.revokeObjectURL(prev);
            urlsRef.current.delete(id);
        }
        if (url) urlsRef.current.set(id, url);
    }, []);
    var patch = useCallback12(function(id, next) {
        setById(function(prev) {
            return prev[id] ? _object_spread_props(_object_spread({}, prev), _define_property({}, id, _object_spread({}, prev[id], next))) : prev;
        });
    }, []);
    var fetchBytes = useCallback12(function(id, frameId, signal) {
        return bytesSize ? fetchStreamFrame(baseUrl, tokenRef.current, twinId, id, frameId, signal, bytesSize) : fetchStreamFrame(baseUrl, tokenRef.current, twinId, id, frameId, signal);
    }, [
        baseUrl,
        twinId,
        bytesSize
    ]);
    var showFrame = useCallback12(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(id, frame, signal, superseded) {
            var result, url, capturedAt, state;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetchBytes(id, frame.frame_id, signal)
                        ];
                    case 1:
                        result = _state.sent();
                        if (!result) return [
                            2,
                            false
                        ];
                        if (superseded()) return [
                            2,
                            true
                        ];
                        url = URL.createObjectURL(result.blob);
                        setUrl(id, url);
                        capturedAt = new Date(frame.captured_at);
                        state = stateForFrame(capturedAt);
                        patch(id, {
                            imageUrl: url,
                            capturedAt: capturedAt,
                            frameId: frame.frame_id,
                            reason: void 0,
                            state: state,
                            statusLabel: state === "warning" ? staleLabel(capturedAt) : void 0
                        });
                        return [
                            2,
                            true
                        ];
                }
            });
        });
        return function(id, frame, signal, superseded) {
            return _ref.apply(this, arguments);
        };
    }(), [
        patch,
        setUrl,
        fetchBytes
    ]);
    var forceCapture = useCallback12(function(id, signal) {
        return ensureLatestStreamFrame(baseUrl, tokenRef.current, twinId, id, signal, true);
    }, [
        baseUrl,
        twinId
    ]);
    var pollFor = useCallback12(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(id, signal, superseded, res) {
            var frameId, deadline, got, url, _capturedAtFromFrameId, capturedAt, err;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        frameId = res.frame_id;
                        if (!frameId) {
                            patch(id, {
                                state: "error",
                                statusLabel: "No frame id"
                            });
                            return [
                                2
                            ];
                        }
                        deadline = Date.now() + POLL_INTERVAL_MS * POLL_MAX_ATTEMPTS;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        _state.label = 2;
                    case 2:
                        if (!(Date.now() < deadline)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            sleep(POLL_INTERVAL_MS, signal)
                        ];
                    case 3:
                        _state.sent();
                        if (superseded()) return [
                            2
                        ];
                        return [
                            4,
                            fetchBytes(id, frameId, signal)
                        ];
                    case 4:
                        got = _state.sent();
                        if (superseded()) return [
                            2
                        ];
                        if (got) {
                            url = URL.createObjectURL(got.blob);
                            setUrl(id, url);
                            ;
                            capturedAt = (_capturedAtFromFrameId = capturedAtFromFrameId(frameId)) !== null && _capturedAtFromFrameId !== void 0 ? _capturedAtFromFrameId : /* @__PURE__ */ new Date();
                            patch(id, {
                                imageUrl: url,
                                capturedAt: capturedAt,
                                frameId: frameId,
                                state: stateForFrame(capturedAt)
                            });
                            return [
                                2
                            ];
                        }
                        return [
                            3,
                            2
                        ];
                    case 5:
                        if (!superseded()) patch(id, {
                            state: "error",
                            statusLabel: "Signal lost"
                        });
                        return [
                            3,
                            7
                        ];
                    case 6:
                        err = _state.sent();
                        if ((err === null || err === void 0 ? void 0 : err.name) === "AbortError" || superseded()) return [
                            2
                        ];
                        patch(id, classifyFailure(err));
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function(id, signal, superseded, res) {
            return _ref.apply(this, arguments);
        };
    }(), [
        patch,
        setUrl,
        fetchBytes
    ]);
    var loadStored = useCallback12(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(id, signal, superseded) {
            var noFrame, res, frame, at, capturedAt, state, shown, err;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        noFrame = function() {
                            setUrl(id, void 0);
                            patch(id, _object_spread_props(_object_spread({}, attachedRef.current.get(id) === false ? NOT_ATTACHED : NO_FRAME_YET), {
                                imageUrl: void 0,
                                capturedAt: null,
                                frameId: void 0
                            }));
                        };
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            getLatestStreamFrame(baseUrl, tokenRef.current, twinId, id, signal)
                        ];
                    case 2:
                        res = _state.sent();
                        if (superseded()) return [
                            2
                        ];
                        frame = res === null || res === void 0 ? void 0 : res.frame;
                        if (!frame) {
                            noFrame();
                            return [
                                2
                            ];
                        }
                        at = new Date(frame.captured_at);
                        capturedAt = Number.isNaN(at.getTime()) ? null : at;
                        if (bytesSize === "thumb" && frame.has_thumb !== true) {
                            state = capturedAt ? stateForFrame(capturedAt) : "healthy";
                            setUrl(id, void 0);
                            patch(id, {
                                imageUrl: void 0,
                                capturedAt: capturedAt,
                                frameId: frame.frame_id,
                                reason: void 0,
                                state: state,
                                statusLabel: capturedAt && state === "warning" ? staleLabel(capturedAt) : void 0
                            });
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            showFrame(id, frame, signal, superseded)
                        ];
                    case 3:
                        shown = _state.sent();
                        if (superseded()) return [
                            2
                        ];
                        if (!shown) noFrame();
                        else if (!capturedAt) patch(id, {
                            capturedAt: null
                        });
                        return [
                            3,
                            5
                        ];
                    case 4:
                        err = _state.sent();
                        if ((err === null || err === void 0 ? void 0 : err.name) === "AbortError" || superseded()) return [
                            2
                        ];
                        patch(id, classifyFailure(err));
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(id, signal, superseded) {
            return _ref.apply(this, arguments);
        };
    }(), [
        baseUrl,
        twinId,
        patch,
        setUrl,
        showFrame,
        bytesSize
    ]);
    var loadOne = useCallback12(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(id, signal) {
            var force, _genRef_current_get, myGen, superseded, res, shown, _tmp, err;
            var _arguments = arguments;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        force = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                        myGen = ((_genRef_current_get = genRef.current.get(id)) !== null && _genRef_current_get !== void 0 ? _genRef_current_get : 0) + 1;
                        genRef.current.set(id, myGen);
                        superseded = function() {
                            return genRef.current.get(id) !== myGen || signal.aborted;
                        };
                        if (signal.aborted) return [
                            2
                        ];
                        patch(id, {
                            state: "connecting",
                            statusLabel: void 0
                        });
                        if (storedOnly) return [
                            2,
                            loadStored(id, signal, superseded)
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            ,
                            8
                        ]);
                        return [
                            4,
                            ensureLatestStreamFrame(baseUrl, tokenRef.current, twinId, id, signal, force)
                        ];
                    case 2:
                        res = _state.sent();
                        if (superseded()) return [
                            2
                        ];
                        if (res.status === EnsureLatestStreamFrameStatus.NotConfigured) {
                            setUrl(id, void 0);
                            patch(id, {
                                state: "not_configured",
                                imageUrl: void 0,
                                capturedAt: null,
                                reason: res.reason
                            });
                            return [
                                2
                            ];
                        }
                        if (!(res.status === EnsureLatestStreamFrameStatus.Stored && res.frame)) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            showFrame(id, res.frame, signal, superseded)
                        ];
                    case 3:
                        shown = _state.sent();
                        if (!(!shown && !superseded())) return [
                            3,
                            5
                        ];
                        _tmp = [
                            id,
                            signal,
                            superseded
                        ];
                        return [
                            4,
                            forceCapture(id, signal)
                        ];
                    case 4:
                        return [
                            2,
                            pollFor.apply(void 0, _tmp.concat([
                                _state.sent()
                            ]))
                        ];
                    case 5:
                        return [
                            2
                        ];
                    case 6:
                        if (res.status !== EnsureLatestStreamFrameStatus.Capturing) {
                            patch(id, {
                                state: "connecting",
                                statusLabel: void 0
                            });
                            return [
                                2
                            ];
                        }
                        return [
                            2,
                            pollFor(id, signal, superseded, res)
                        ];
                    case 7:
                        err = _state.sent();
                        if ((err === null || err === void 0 ? void 0 : err.name) === "AbortError" || superseded()) return [
                            2
                        ];
                        patch(id, classifyFailure(err));
                        return [
                            3,
                            8
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        });
        return function(id, signal) {
            return _ref.apply(this, arguments);
        };
    }(), [
        baseUrl,
        twinId,
        patch,
        setUrl,
        showFrame,
        pollFor,
        forceCapture,
        storedOnly,
        loadStored
    ]);
    var loadMany = useCallback12(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(ids, signal) {
            var force;
            var _arguments = arguments;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        force = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                        return [
                            4,
                            runLimited(ids.map(function(id) {
                                return function() {
                                    return loadOne(id, signal, force);
                                };
                            }), MAX_CONCURRENCY)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(ids, signal) {
            return _ref.apply(this, arguments);
        };
    }(), [
        loadOne
    ]);
    useEffect35(function() {
        if (!hasToken || twinId == null) return;
        abortRef.current.abort();
        var controller = new AbortController();
        abortRef.current = controller;
        var cancelled = false;
        resetWall();
        setIsLoading(true);
        setError(null);
        _async_to_generator(function() {
            var supplied, rows, _tmp, list, err;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            5,
                            ,
                            6
                        ]);
                        supplied = suppliedForKey;
                        if (!(supplied !== null && supplied !== void 0)) return [
                            3,
                            1
                        ];
                        _tmp = supplied;
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            getRTSPEndpointsOrThrow(baseUrl, tokenRef.current, twinId)
                        ];
                    case 2:
                        _tmp = _state.sent();
                        _state.label = 3;
                    case 3:
                        rows = _tmp;
                        if (cancelled || controller.signal.aborted) return [
                            2
                        ];
                        list = (rows !== null && rows !== void 0 ? rows : []).map(toEndpoint);
                        attachedRef.current = new Map(list.map(function(e) {
                            return [
                                e.id,
                                e.attached
                            ];
                        }));
                        setEndpoints(list);
                        setSeededKey(suppliedKey);
                        setById(Object.fromEntries(list.map(function(e) {
                            return [
                                e.id,
                                {
                                    id: e.id,
                                    name: e.name,
                                    aspectRatio: e.aspectRatio,
                                    state: "connecting"
                                }
                            ];
                        })));
                        setIsLoading(false);
                        return [
                            4,
                            loadMany(list.map(function(e) {
                                return e.id;
                            }), controller.signal)
                        ];
                    case 4:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 5:
                        err = _state.sent();
                        if (cancelled || controller.signal.aborted) return [
                            2
                        ];
                        setError("Failed to load this twin\u2019s RTSP streams.");
                        setIsLoading(false);
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
        return function() {
            cancelled = true;
            controller.abort();
        };
    }, [
        baseUrl,
        hasToken,
        twinId,
        loadMany,
        resetWall,
        suppliedKey,
        suppliedForKey
    ]);
    useEffect35(function() {
        return function() {
            abortRef.current.abort();
            urlsRef.current.forEach(function(url) {
                return URL.revokeObjectURL(url);
            });
            urlsRef.current.clear();
        };
    }, []);
    var attachmentKey = storedOnly && suppliedEndpoints ? suppliedEndpoints.map(function(r) {
        return "".concat(r.id, ":").concat(r.twin_device_id != null ? 1 : 0);
    }).join(",") : null;
    useEffect35(function() {
        if (!attachmentKey || !suppliedForKey || !hasToken || twinId == null) return;
        var changed = [];
        (suppliedEndpoints !== null && suppliedEndpoints !== void 0 ? suppliedEndpoints : []).forEach(function(r) {
            var id = Number(r.id);
            var attached = r.twin_device_id != null;
            var before = attachedRef.current.get(id);
            if (before !== void 0 && before !== attached) {
                attachedRef.current.set(id, attached);
                changed.push(id);
            }
        });
        changed.forEach(function(id) {
            return void loadOne(id, abortRef.current.signal);
        });
    }, [
        attachmentKey
    ]);
    var refreshAll = useCallback12(function() {
        if (!accessToken || twinId == null) return;
        setIsRefreshing(true);
        void loadMany(endpoints.map(function(e) {
            return e.id;
        }), abortRef.current.signal, true).finally(function() {
            return setIsRefreshing(false);
        });
    }, [
        accessToken,
        twinId,
        endpoints,
        loadMany
    ]);
    var refreshFeed = useCallback12(function(id) {
        if (!accessToken || twinId == null) return;
        var n = typeof id === "string" && id.trim() === "" ? NaN : Number(id);
        if (!Number.isFinite(n)) return;
        void loadOne(n, abortRef.current.signal, true);
    }, [
        accessToken,
        twinId,
        loadOne
    ]);
    var reloadQueueRef = useRef19(/* @__PURE__ */ new Set());
    var reloadFeed = useCallback12(function(id) {
        if (!accessToken || twinId == null) return;
        var n = typeof id === "string" && id.trim() === "" ? NaN : Number(id);
        if (!Number.isFinite(n)) return;
        var queue = reloadQueueRef.current;
        queue.add(n);
        if (queue.size > 1) return;
        queueMicrotask(function() {
            var ids = Array.from(queue);
            queue.clear();
            var signal = abortRef.current.signal;
            var reserved = ids.map(function(n2) {
                var _genRef_current_get;
                var myGen = ((_genRef_current_get = genRef.current.get(n2)) !== null && _genRef_current_get !== void 0 ? _genRef_current_get : 0) + 1;
                genRef.current.set(n2, myGen);
                return {
                    n: n2,
                    myGen: myGen
                };
            });
            void runLimited(reserved.map(function(param) {
                var n2 = param.n, myGen = param.myGen;
                return function() {
                    var superseded = function() {
                        return genRef.current.get(n2) !== myGen || signal.aborted;
                    };
                    if (superseded()) return Promise.resolve();
                    return loadStored(n2, signal, superseded);
                };
            }), MAX_CONCURRENCY);
        });
    }, [
        accessToken,
        twinId,
        loadStored
    ]);
    var _useState496 = _sliced_to_array(useState49(0), 2), tick = _useState496[0], setTick = _useState496[1];
    var hasFeeds = endpoints.length > 0;
    useEffect35(function() {
        if (!hasFeeds) return;
        var t = setInterval(function() {
            return setTick(function(n) {
                return n + 1;
            });
        }, 6e4);
        return function() {
            return clearInterval(t);
        };
    }, [
        hasFeeds
    ]);
    var feeds = useMemo11(function() {
        return(/*
       * The current key and the committed seed disagree: show NOTHING rather than the previous
       * twin's tiles. See `seededKey`.
       *
       * ⚠ The null case is IN, not excluded. An earlier form read `suppliedKey !== null && …`,
       * which switched the guard off in exactly the window it was needed: the Observers stage
       * passes `endpoints: undefined` while its own stream read is loading or failed, so
       * `suppliedKey` goes null on a retry or a twin change and the previous twin's rows stayed
       * exposed through `feedById` to the open editor. On the self-read path both sides are null,
       * so they agree and nothing is gated — the admin wall is untouched either way.
       */ suppliedKey !== seededKey ? [] : endpoints.map(function(e) {
            return byId[e.id];
        }).filter(Boolean).map(function(f) {
            if (!f.capturedAt || Number.isNaN(f.capturedAt.getTime())) return f;
            var state = stateForFrame(f.capturedAt);
            if (f.state !== "healthy" && f.state !== "warning") return f;
            var statusLabel = state === "warning" ? staleLabel(f.capturedAt) : void 0;
            if (state === f.state && f.statusLabel === statusLabel) return f;
            return _object_spread_props(_object_spread({}, f), {
                state: state,
                statusLabel: statusLabel
            });
        }));
    }, // `tick` is not read in the body — it is here to RE-RUN the memo so the derivation above sees
    // a new `Date.now()`. Depending on `setTick` instead (which is stable) silently defeats the
    // whole thing: the memo never re-runs and staleness is frozen again.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        endpoints,
        byId,
        tick,
        suppliedKey,
        seededKey
    ]);
    return {
        feeds: feeds,
        isLoading: isLoading,
        isRefreshing: isRefreshing,
        error: error,
        refreshAll: refreshAll,
        refreshFeed: refreshFeed,
        reloadFeed: reloadFeed
    };
};
// src/components/CameraWall/useThumbnailRun.ts
import { useCallback as useCallback13, useEffect as useEffect36, useRef as useRef20, useState as useState50 } from "react";
import { getThumbnailRun, startThumbnailRun } from "@repo/front-end-services";
var THUMBNAIL_RUN_POLL_MS = 1e4;
var POLL_BACKOFF_MS = [
    1e4,
    2e4,
    4e4,
    6e4
];
var STORAGE_PREFIX = "tl.thumbnailRun.v1.";
var isThumbnailRunActive = function(run) {
    var now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
    if (!run) return false;
    if (run.status === "ACTIVE") return true;
    if (run.status === "COMPLETED" || run.status === "EXPIRED") return false;
    var expires = Date.parse(run.expires_at);
    return Number.isFinite(expires) && expires > now;
};
var normalise = function(r) {
    var _r_counts, _r_counts1, _r_counts2, _r_counts3;
    var _r_counts_total, _r_counts_pending, _r_counts_captured, _r_counts_failed;
    return _object_spread_props(_object_spread({}, r), {
        counts: {
            total: (_r_counts_total = (_r_counts = r.counts) === null || _r_counts === void 0 ? void 0 : _r_counts.total) !== null && _r_counts_total !== void 0 ? _r_counts_total : 0,
            pending: (_r_counts_pending = (_r_counts1 = r.counts) === null || _r_counts1 === void 0 ? void 0 : _r_counts1.pending) !== null && _r_counts_pending !== void 0 ? _r_counts_pending : 0,
            captured: (_r_counts_captured = (_r_counts2 = r.counts) === null || _r_counts2 === void 0 ? void 0 : _r_counts2.captured) !== null && _r_counts_captured !== void 0 ? _r_counts_captured : 0,
            failed: (_r_counts_failed = (_r_counts3 = r.counts) === null || _r_counts3 === void 0 ? void 0 : _r_counts3.failed) !== null && _r_counts_failed !== void 0 ? _r_counts_failed : 0
        },
        streams: Array.isArray(r.streams) ? r.streams : []
    });
};
var readRemembered = function(twinId) {
    try {
        var raw = window.localStorage.getItem(STORAGE_PREFIX + twinId);
        if (raw == null || !/^\d+$/.test(raw)) return null;
        var n = Number(raw);
        return Number.isSafeInteger(n) && n > 0 ? n : null;
    } catch (e) {
        return null;
    }
};
var remember = function(twinId, runId) {
    try {
        window.localStorage.setItem(STORAGE_PREFIX + twinId, String(runId));
    } catch (e) {}
};
var forget = function(twinId) {
    try {
        window.localStorage.removeItem(STORAGE_PREFIX + twinId);
    } catch (e) {}
};
var statusOf = function(err) {
    var _err_response;
    return err === null || err === void 0 ? void 0 : (_err_response = err.response) === null || _err_response === void 0 ? void 0 : _err_response.status;
};
var useThumbnailRun = function(param) {
    var baseUrl = param.baseUrl, accessToken = param.accessToken, twinId = param.twinId;
    var _useState50 = _sliced_to_array(useState50(null), 2), run = _useState50[0], setRun = _useState50[1];
    var _useState501 = _sliced_to_array(useState50(false), 2), starting = _useState501[0], setStarting = _useState501[1];
    var _useState502 = _sliced_to_array(useState50(null), 2), startError = _useState502[0], setStartError = _useState502[1];
    var _useState503 = _sliced_to_array(useState50(null), 2), pollError = _useState503[0], setPollError = _useState503[1];
    var _useState504 = _sliced_to_array(useState50(false), 2), alreadyRunning = _useState504[0], setAlreadyRunning = _useState504[1];
    var tokenRef = useRef20(accessToken);
    useEffect36(function() {
        tokenRef.current = accessToken;
    }, [
        accessToken
    ]);
    var hasToken = typeof accessToken === "string" && accessToken.length > 0;
    var abortRef = useRef20(new AbortController());
    var timerRef = useRef20(null);
    var runRef = useRef20(null);
    var startingRef = useRef20(false);
    var twinRef = useRef20(null);
    var seqRef = useRef20(0);
    var appliedSeqRef = useRef20(0);
    var failuresRef = useRef20(0);
    var watchedRef = useRef20(false);
    var deferredRef = useRef20(null);
    var clearTimer = function() {
        if (timerRef.current != null) clearTimeout(timerRef.current);
        timerRef.current = null;
    };
    var setRunBoth = function(r) {
        runRef.current = r;
        setRun(r);
    };
    var drop = function(tid) {
        clearTimer();
        deferredRef.current = null;
        forget(tid);
        watchedRef.current = false;
        setRunBoth(null);
        setPollError(null);
    };
    var pollRef = useRef20(function() {});
    var schedule = function(tid, runId, signal, delay) {
        clearTimer();
        timerRef.current = setTimeout(function() {
            timerRef.current = null;
            if (signal.aborted) return;
            if (typeof document !== "undefined" && document.visibilityState === "hidden") {
                deferredRef.current = {
                    tid: tid,
                    runId: runId
                };
                return;
            }
            pollRef.current(tid, runId, signal);
        }, delay);
    };
    var apply = function(tid, r, signal) {
        deferredRef.current = null;
        failuresRef.current = 0;
        setPollError(null);
        if (isThumbnailRunActive(r)) {
            watchedRef.current = true;
            remember(tid, r.run_id);
            setRunBoth(r);
            schedule(tid, r.run_id, signal, THUMBNAIL_RUN_POLL_MS);
            return;
        }
        clearTimer();
        forget(tid);
        setRunBoth(watchedRef.current ? r : null);
    };
    pollRef.current = function(tid, runId, signal) {
        var seq = ++seqRef.current;
        var sentWith = tokenRef.current;
        getThumbnailRun(baseUrl, sentWith, tid, runId, signal).then(function(r) {
            if (signal.aborted || seq < appliedSeqRef.current) return;
            appliedSeqRef.current = seq;
            if (r === null) return drop(tid);
            apply(tid, normalise(r), signal);
        }, function(err) {
            if (signal.aborted || seq < appliedSeqRef.current) return;
            appliedSeqRef.current = seq;
            var status = statusOf(err);
            if (status === 403 || status === 404) return drop(tid);
            if (status === 401) {
                if (tokenRef.current && tokenRef.current !== sentWith) {
                    pollRef.current(tid, runId, signal);
                    return;
                }
                clearTimer();
                deferredRef.current = {
                    tid: tid,
                    runId: runId
                };
                setPollError("Session expired");
                return;
            }
            var n = failuresRef.current++;
            setPollError("Progress not updating");
            schedule(tid, runId, signal, POLL_BACKOFF_MS[Math.min(n, POLL_BACKOFF_MS.length - 1)]);
        });
    };
    useEffect36(function() {
        var ctrl = new AbortController();
        abortRef.current = ctrl;
        twinRef.current = twinId;
        clearTimer();
        runRef.current = null;
        startingRef.current = false;
        watchedRef.current = false;
        deferredRef.current = null;
        failuresRef.current = 0;
        appliedSeqRef.current = seqRef.current;
        setRun(null);
        setStarting(false);
        setStartError(null);
        setPollError(null);
        setAlreadyRunning(false);
        if (twinId != null && hasToken) {
            var remembered = readRemembered(twinId);
            if (remembered != null) pollRef.current(twinId, remembered, ctrl.signal);
        }
        return function() {
            ctrl.abort();
            clearTimer();
        };
    }, [
        twinId,
        hasToken,
        baseUrl
    ]);
    useEffect36(function() {
        if (typeof document === "undefined") return;
        var onVisibility = function() {
            if (document.visibilityState !== "visible") return;
            var tid = twinRef.current;
            var signal = abortRef.current.signal;
            if (tid == null || signal.aborted) return;
            var r = runRef.current;
            var deferred = deferredRef.current;
            deferredRef.current = null;
            var runId = r && isThumbnailRunActive(r) ? r.run_id : deferred && deferred.tid === tid ? deferred.runId : null;
            if (runId == null) return;
            clearTimer();
            pollRef.current(tid, runId, signal);
        };
        document.addEventListener("visibilitychange", onVisibility);
        return function() {
            return document.removeEventListener("visibilitychange", onVisibility);
        };
    }, []);
    useEffect36(function() {
        var deferred = deferredRef.current;
        var signal = abortRef.current.signal;
        if (!accessToken || !deferred || deferred.tid !== twinRef.current || signal.aborted) return;
        if (typeof document !== "undefined" && document.visibilityState === "hidden") return;
        deferredRef.current = null;
        pollRef.current(deferred.tid, deferred.runId, signal);
    }, [
        accessToken
    ]);
    var start = useCallback13(function(includeDisabled) {
        var tid = twinRef.current;
        if (tid == null || !tokenRef.current) return;
        if (startingRef.current || isThumbnailRunActive(runRef.current)) return;
        var signal = abortRef.current.signal;
        startingRef.current = true;
        setStarting(true);
        setStartError(null);
        setAlreadyRunning(false);
        startThumbnailRun(baseUrl, tokenRef.current, tid, includeDisabled, signal).then(function(res) {
            if (signal.aborted) return;
            appliedSeqRef.current = ++seqRef.current;
            var already_running = res.already_running, _statusUrl = res.status_url, rest = _object_without_properties(res, [
                "already_running",
                "status_url"
            ]);
            setAlreadyRunning(already_running === true);
            watchedRef.current = true;
            apply(tid, normalise(rest), signal);
        }, function(err) {
            if (signal.aborted) return;
            var status = statusOf(err);
            setStartError(status === 401 || status === 403 ? "denied" : "unconfirmed");
        }).finally(function() {
            if (signal.aborted) return;
            startingRef.current = false;
            setStarting(false);
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        baseUrl
    ]);
    var dismiss = useCallback13(function() {
        setAlreadyRunning(false);
        setStartError(null);
        if (isThumbnailRunActive(runRef.current)) return;
        watchedRef.current = false;
        setPollError(null);
        setRunBoth(null);
    }, []);
    return {
        run: run,
        starting: starting,
        startError: startError,
        pollError: pollError,
        alreadyRunning: alreadyRunning,
        start: start,
        dismiss: dismiss
    };
};
var useReloadOnCapture = function(run, reloadFeed) {
    var seenRef = useRef20({
        runId: null,
        reloaded: /* @__PURE__ */ new Set()
    });
    useEffect36(function() {
        if (!run) return;
        if (seenRef.current.runId !== run.run_id) {
            seenRef.current = {
                runId: run.run_id,
                reloaded: /* @__PURE__ */ new Set()
            };
        }
        var reloaded = seenRef.current.reloaded;
        var _run_streams;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = ((_run_streams = run.streams) !== null && _run_streams !== void 0 ? _run_streams : [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var s = _step.value;
                if (s.status !== "captured" || reloaded.has(s.rtsp_endpoint_id)) continue;
                reloaded.add(s.rtsp_endpoint_id);
                reloadFeed(s.rtsp_endpoint_id);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }, [
        run,
        reloadFeed
    ]);
};
// src/components/CheckCard/CheckCard.tsx
import React51 from "react";
import styled73 from "styled-components";
import { fontMono, fontSans as fontSans2, ink as ink10, motion as motion7, radius as radius7, rgba as rgba2, semantic as semantic10, shadow as shadow7, space as space13, surface as surface5, typeScale, weight as weight3 } from "@repo/design-tokens";
import { Icon as Icon2, Table as Table3 } from "@repo/design-system";
import { jsx as jsx103, jsxs as jsxs72 } from "react/jsx-runtime";
var roles = semantic10.status.roles;
var ERROR_WASH = {
    wash: roles.problem.mark,
    washAlpha: 0.16
};
var MINT_WASH = {
    wash: roles.justChanged.mark,
    washAlpha: 0.32
};
var CHECK_CARD_COLOURS = {
    /**
   * The resting card is near-white: white at `surfaceAlpha` over the column it sits on (frame 03
   * samples 253,254,254 on a 249,251,252 column). The open card is solid white. `column` is the
   * page surface the contrast test composites over; the card itself does not paint it.
   */ surface: surface5[0],
    surfaceAlpha: 0.7,
    surfaceOpen: surface5[0],
    column: surface5[1],
    /** The open card's hairline edge and glow: the selection, never a status hue. */ openAccent: semantic10.status.selected.edge,
    title: ink10[1],
    /** The frame's grey, which clears 4.5:1 on the near-white resting card. */ where: ink10[3],
    label: ink10[3],
    /**
   * The stickers: each tone's role mark at frame 03's sticker alphas (.16, .32), and `info` the
   * information role's own wash (its mark at .34), ringed in its mark.
   */ sticker: {
        error: _object_spread_props(_object_spread({}, ERROR_WASH), {
            glyph: roles.problem.ink
        }),
        fixed: _object_spread_props(_object_spread({}, MINT_WASH), {
            glyph: roles.justChanged.ink
        }),
        info: {
            wash: roles.information.mark,
            washAlpha: 0.34,
            glyph: roles.information.ink,
            ring: roles.information.mark
        }
    },
    /** The *Found* pill (problem) and the *Use* pill (just changed): the same washes as the stickers. */ found: _object_spread_props(_object_spread({}, ERROR_WASH), {
        ink: roles.problem.ink
    }),
    use: _object_spread_props(_object_spread({}, MINT_WASH), {
        ink: roles.justChanged.ink
    })
};
var CARD_PADDING = "".concat(space13[3], " ").concat(space13[4]);
var CARD_GAP = space13[3];
var STICKER_SIZE = "34px";
var STICKER_RING = "3px";
var TITLE_FONT = "".concat(weight3.semibold, " 13.5px / 1.3 ").concat(fontSans2);
var WHERE_FONT = "".concat(weight3.regular, " 11.5px / 1.4 ").concat(fontSans2);
var LABEL_FONT = "".concat(weight3.regular, " 11.5px / 1 ").concat(fontSans2);
var VALUE_FONT = "".concat(weight3.semibold, " ").concat(typeScale.caption1.fontSize, " / 1 ").concat(fontMono);
var VALUE_HEIGHT = "22px";
var VALUE_PADDING = "0 ".concat(space13[2]);
var C = CHECK_CARD_COLOURS;
var glow = function(a) {
    return rgba2(C.openAccent, a);
};
var inkGlassShadow = function(a) {
    return "rgba(".concat(shadow7.inkGlassRgb, ", ").concat(a, ")");
};
var wash = function(w) {
    return rgba2(w.wash, w.washAlpha);
};
var isGiven = function(value) {
    return value !== null && value !== void 0 && value !== false && value !== "";
};
var StyledCheckCard = styled73.div(_templateObject166(), space13[3], CARD_PADDING, radius7.lg, rgba2(C.surface, C.surfaceAlpha), rgba2(surface5[0], 0.9), inkGlassShadow(0.04), motion7.durFast, motion7.easeUi, motion7.durFast, motion7.easeUi, motion7.durFast, motion7.easeUi, C.surfaceOpen, rgba2(C.openAccent, 0.22), inkGlassShadow(0.05), glow(0.06), glow(0.14), CARD_GAP, STICKER_SIZE, STICKER_SIZE, radius7.pill, STICKER_RING, surface5[0], inkGlassShadow(0.08), wash(C.sticker.error), C.sticker.error.glyph, wash(C.sticker.fixed), C.sticker.fixed.glyph, wash(C.sticker.info), C.sticker.info.glyph, rgba2(C.sticker.info.ring, 0.9), glow(0.18), TITLE_FONT, C.title, WHERE_FONT, C.where, space13[2], C.label, LABEL_FONT, VALUE_HEIGHT, VALUE_PADDING, radius7.sm, VALUE_FONT, wash(C.found), C.found.ink, wash(C.use), C.use.ink, ink10[3], space13[2], STICKER_SIZE, CARD_GAP);
function CheckCardInner(props, ref3) {
    var tone = props.tone, icon = props.icon, title = props.title, _props_headingLevel = props.headingLevel, headingLevel = _props_headingLevel === void 0 ? 3 : _props_headingLevel, where = props.where, found = props.found, use = props.use, _props_foundLabel = props.foundLabel, foundLabel = _props_foundLabel === void 0 ? "Found" : _props_foundLabel, _props_useLabel = props.useLabel, useLabel = _props_useLabel === void 0 ? "Use" : _props_useLabel, actions = props.actions, _props_open = props.open, open = _props_open === void 0 ? false : _props_open, lines = props.lines, className = props.className, describedByProp = props["aria-describedby"], rest = _object_without_properties(props, [
        "tone",
        "icon",
        "title",
        "headingLevel",
        "where",
        "found",
        "use",
        "foundLabel",
        "useLabel",
        "actions",
        "open",
        "lines",
        "className",
        "aria-describedby"
    ]);
    var id = React51.useId();
    var titleId = "".concat(id, "-title");
    var whereId = "".concat(id, "-where");
    var Heading = "h".concat(headingLevel);
    var hasPair = isGiven(found) && isGiven(use);
    var hasWhere = isGiven(where);
    var describedBy = [
        hasWhere ? whereId : null,
        describedByProp
    ].filter(Boolean).join(" ");
    var _lines_label;
    return /* @__PURE__ */ jsxs72(StyledCheckCard, _object_spread_props(_object_spread({}, rest), {
        ref: ref3,
        role: "group",
        "aria-labelledby": titleId,
        "aria-describedby": describedBy || void 0,
        "data-tone": tone,
        "data-open": open ? "" : void 0,
        className: [
            "tl-check-card",
            className
        ].filter(Boolean).join(" "),
        children: [
            /* @__PURE__ */ jsxs72("div", {
                className: "tl-cc-head",
                children: [
                    /* @__PURE__ */ jsx103("span", {
                        className: "tl-cc-sticker",
                        "aria-hidden": "true",
                        children: icon
                    }),
                    /* @__PURE__ */ jsxs72("div", {
                        className: "tl-cc-text",
                        children: [
                            /* @__PURE__ */ jsx103(Heading, {
                                className: "tl-cc-title",
                                id: titleId,
                                children: title
                            }),
                            hasWhere ? /* @__PURE__ */ jsx103("p", {
                                className: "tl-cc-where",
                                id: whereId,
                                children: where
                            }) : null
                        ]
                    }),
                    hasPair ? /* @__PURE__ */ jsxs72("span", {
                        className: "tl-cc-pair",
                        children: [
                            /* @__PURE__ */ jsx103("span", {
                                children: foundLabel
                            }),
                            " ",
                            /* @__PURE__ */ jsx103("span", {
                                className: "tl-cc-value",
                                "data-kind": "found",
                                children: found
                            }),
                            " ",
                            /* @__PURE__ */ jsx103("span", {
                                className: "tl-cc-arrow",
                                "aria-hidden": "true",
                                children: /* @__PURE__ */ jsx103(Icon2, {
                                    name: "arrow-right",
                                    size: "xs"
                                })
                            }),
                            " ",
                            /* @__PURE__ */ jsx103("span", {
                                children: useLabel
                            }),
                            " ",
                            /* @__PURE__ */ jsx103("span", {
                                className: "tl-cc-value",
                                "data-kind": "use",
                                children: use
                            })
                        ]
                    }) : null,
                    isGiven(actions) ? /* @__PURE__ */ jsx103("div", {
                        className: "tl-cc-actions",
                        children: actions
                    }) : null
                ]
            }),
            lines && lines.data.length > 0 ? /* @__PURE__ */ jsx103("div", {
                className: "tl-cc-lines",
                children: /* @__PURE__ */ jsx103(Table3, {
                    "aria-label": (_lines_label = lines.label) !== null && _lines_label !== void 0 ? _lines_label : "Affected lines",
                    colourMode: "none",
                    resizable: false,
                    columns: lines.columns,
                    data: lines.data,
                    keyExtractor: lines.keyExtractor
                })
            }) : null
        ]
    }));
}
var CheckCard = React51.forwardRef(CheckCardInner);
CheckCard.displayName = "CheckCard";
// src/components/ColumnMapRow/ColumnMapRow.tsx
import styled74 from "styled-components";
import { fontMono as fontMono2, ink as ink11, inset as inset2, radius as radius8, rgba as rgba3, semantic as semantic11, space as space14, surface as surface6, tracking, typeScale as typeScale2, weight as weight4 } from "@repo/design-tokens";
import { Icon as Icon3, Select as Select2 } from "@repo/design-system";
import { jsx as jsx104, jsxs as jsxs73 } from "react/jsx-runtime";
var STATE = {
    exact: {
        disc: "plain",
        icon: "check",
        tag: null,
        words: "Exact match"
    },
    close: {
        disc: "lavender",
        icon: "wand-magic-sparkles",
        tag: "Close match",
        words: "Close match"
    },
    chosen: {
        disc: "neutral",
        icon: "check",
        tag: "Chosen",
        words: "Chosen"
    },
    decide: {
        disc: "identify",
        icon: "question",
        tag: "Choose",
        words: "Needs a decision"
    },
    out: {
        disc: "neutral",
        icon: "eye-slash",
        tag: "Left out",
        words: "Left out"
    }
};
var _semantic11_status = semantic11.status, roles2 = _semantic11_status.roles;
var COLUMN_MAP_ROW_COLOURS = {
    exactWash: rgba3(surface6[0], 0.5),
    closeWash: roles2.information.wash,
    decideWash: rgba3(roles2.workToDo.mark, 0.14),
    decideBorder: rgba3(roles2.workToDo.mark, 0.55),
    decideGlow: "0 0 10px 1px ".concat(rgba3(roles2.workToDo.mark, 0.25)),
    outWash: rgba3(surface6[0], 0.35),
    closeTag: roles2.information.ink,
    decideTag: roles2.workToDo.ink,
    chosenTag: roles2.neutral.ink,
    outTag: ink11[3]
};
var TAG_INK = {
    exact: ink11[3],
    close: COLUMN_MAP_ROW_COLOURS.closeTag,
    chosen: COLUMN_MAP_ROW_COLOURS.chosenTag,
    decide: COLUMN_MAP_ROW_COLOURS.decideTag,
    out: COLUMN_MAP_ROW_COLOURS.outTag
};
var COLUMN_MAP_ROW_FIRST_INK = {
    exact: ink11[3],
    close: COLUMN_MAP_ROW_COLOURS.closeTag,
    chosen: ink11[3],
    decide: COLUMN_MAP_ROW_COLOURS.decideTag,
    out: ink11[3]
};
var COLUMN_MAP_ROW_GRID = "28px minmax(0, 1fr) 18px minmax(0, 1fr) 150px";
var Row4 = styled74.div(_templateObject167(), COLUMN_MAP_ROW_GRID, inset2[3], inset2[2], inset2[3], radius8.md, COLUMN_MAP_ROW_COLOURS.exactWash, COLUMN_MAP_ROW_COLOURS.closeWash, COLUMN_MAP_ROW_COLOURS.decideWash, COLUMN_MAP_ROW_COLOURS.decideBorder, COLUMN_MAP_ROW_COLOURS.decideGlow, COLUMN_MAP_ROW_COLOURS.outWash, typeScale2.body1.fontSize, typeScale2.body1.lineHeight, weight4.medium, ink11[1], ink11[3], ink11[4], fontMono2, ink11[3], space14[2], ink11[3], fontMono2, typeScale2.caption1.fontSize, typeScale2.caption1.lineHeight, weight4.medium, ink11[3], COLUMN_MAP_ROW_FIRST_INK.close, COLUMN_MAP_ROW_FIRST_INK.decide, ink11[4]);
var ColumnMapRow = function(param) {
    var header = param.header, firstValue = param.firstValue, state = param.state, value = param.value, options = param.options, onChange = param.onChange, reason = param.reason, id = param.id, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, className = param.className;
    var look = STATE[state];
    var descriptionId = "".concat(id, "-description");
    var description = [
        look.words + (state === "out" && reason ? ": ".concat(reason) : "."),
        firstValue === null ? "Empty in every row." : "First value: ".concat(firstValue, ".")
    ].join(" ");
    return /* @__PURE__ */ jsxs73(Row4, {
        className: [
            "is-".concat(state),
            className
        ].filter(Boolean).join(" "),
        "data-state": state,
        title: state === "out" && reason ? reason : void 0,
        style: _define_property({}, "--cm-tag-ink", TAG_INK[state]),
        children: [
            /* @__PURE__ */ jsx104(IconDisc, {
                tone: look.disc,
                size: 24,
                children: /* @__PURE__ */ jsx104(Icon3, {
                    name: look.icon,
                    variant: "solid",
                    size: "xs"
                })
            }),
            /* @__PURE__ */ jsx104("span", {
                className: "cm-header",
                children: header
            }),
            /* @__PURE__ */ jsx104("span", {
                className: "cm-arrow",
                "aria-hidden": "true",
                children: /* @__PURE__ */ jsx104(Icon3, {
                    name: "arrow-right",
                    variant: "solid",
                    size: "xs"
                })
            }),
            /* @__PURE__ */ jsx104("div", {
                className: "cm-select",
                children: /* @__PURE__ */ jsx104(Select2, {
                    size: "sm",
                    fitOptions: true,
                    options: options,
                    value: value,
                    onChange: onChange,
                    placeholder: "Choose a column or leave out",
                    ariaLabel: "TwinLabs column for ".concat(header),
                    ariaDescribedBy: descriptionId,
                    disabled: disabled,
                    trailing: look.tag ? /* @__PURE__ */ jsx104("span", {
                        className: "cm-tag",
                        children: look.tag
                    }) : void 0
                })
            }),
            /* @__PURE__ */ jsx104("span", {
                className: firstValue === null ? "cm-first is-empty" : "cm-first",
                title: firstValue !== null && firstValue !== void 0 ? firstValue : void 0,
                children: firstValue !== null && firstValue !== void 0 ? firstValue : "empty in every row"
            }),
            /* @__PURE__ */ jsx104("span", {
                id: descriptionId,
                style: visuallyHidden,
                children: description
            })
        ]
    });
};
var Captions = styled74.div(_templateObject168(), COLUMN_MAP_ROW_GRID, inset2[3], inset2[3], space14[1], weight4.medium, typeScale2.caption2.fontSize, typeScale2.caption2.lineHeight, fontMono2, tracking.label, ink11[4]);
var ColumnMapCaptions = function(param) {
    var className = param.className;
    return /* @__PURE__ */ jsxs73(Captions, {
        className: className,
        "aria-hidden": "true",
        children: [
            /* @__PURE__ */ jsx104("span", {}),
            /* @__PURE__ */ jsx104("span", {
                children: "IN YOUR FILE"
            }),
            /* @__PURE__ */ jsx104("span", {}),
            /* @__PURE__ */ jsx104("span", {
                children: "TWINLABS COLUMN"
            }),
            /* @__PURE__ */ jsx104("span", {
                children: "FIRST VALUE"
            })
        ]
    });
};
// src/components/StepGuide/StepGuide.tsx
import styled75 from "styled-components";
import { Icon as Icon4 } from "@repo/design-system";
import { accent as accent2, brand as brand4, glass as glass5, ink as ink12, inkOn as inkOn4, radius as radius9, rgba as rgba4, space as space15, support, surface as surface7, typeRole as typeRole7 } from "@repo/design-tokens";
import { jsx as jsx105, jsxs as jsxs74 } from "react/jsx-runtime";
var StepGuide = function(param) {
    var guide = param.guide, _param_label = param.label, label = _param_label === void 0 ? "Steps" : _param_label;
    return /* @__PURE__ */ jsx105(Steps2, {
        "aria-label": label,
        children: guide.labels.map(function(stepLabel, i) {
            var done = guide.done.includes(i);
            var state = done ? "done" : i === guide.current ? "current" : "next";
            return /* @__PURE__ */ jsxs74(Step, {
                className: "is-".concat(state),
                "aria-current": state === "current" ? "step" : void 0,
                children: [
                    /* @__PURE__ */ jsx105(Num, {
                        "aria-hidden": "true",
                        children: done ? /* @__PURE__ */ jsx105(Icon4, {
                            name: "check"
                        }) : i + 1
                    }),
                    /* @__PURE__ */ jsx105("span", {
                        children: stepLabel
                    }),
                    done && /* @__PURE__ */ jsx105("span", {
                        style: visuallyHidden,
                        children: " (done)"
                    })
                ]
            }, i);
        })
    });
};
var StepHint = function(param) {
    var hint = param.hint;
    return /* @__PURE__ */ jsxs74(Hint, {
        title: hint,
        children: [
            /* @__PURE__ */ jsx105("span", {
                className: "hint-icon",
                "aria-hidden": "true",
                children: /* @__PURE__ */ jsx105(Icon4, {
                    name: "lightbulb",
                    variant: "regular"
                })
            }),
            /* @__PURE__ */ jsx105("span", {
                className: "hint-text",
                children: hint
            })
        ]
    });
};
var Steps2 = styled75.ol(_templateObject169(), space15[2]);
var Num = styled75.span(_templateObject170(), radius9.pill, typeRole7.caption2Strong, surface7[0], ink12[4]);
var Step = styled75.li(_templateObject171(), space15[2], space15[1], space15[3], space15[1], space15[1], radius9.pill, glass5.bgSoft, typeRole7.caption1, ink12[4], rgba4(support.mint, 0.3), inkOn4.mint, Num, inkOn4.mint, typeRole7.caption1Strong, ink12[1], brand4.gelIdle, brand4.glow, Num, brand4.cyanPress);
var Hint = styled75.p(_templateObject172(), space15[1], typeRole7.caption1, ink12[3], accent2.butter);
// src/components/BrandMixCard/BrandMixCard.tsx
import { useId as useId5 } from "react";
import styled76 from "styled-components";
import { fontMono as fontMono3, fontSans as fontSans3, ink as ink13, line as line6, radius as radius10, SELECTED_RAMP, space as space16, surface as surface8, typeRole as typeRole8, typeScale as typeScale3, weight as weight5 } from "@repo/design-tokens";
import { Button as Button10, Card as Card4, Icon as Icon5, Tag as Tag3 } from "@repo/design-system";
import { jsx as jsx106, jsxs as jsxs75 } from "react/jsx-runtime";
var BRAND_MIX_SHOWN = 3;
var BRAND_MIX_OTHER_TWINS_SHOWN = 3;
var BRAND_MIX_EMPTY = "No brands identified yet.";
var BRAND_MIX_ERROR = "Your brands could not be read.";
var percentOf = function(share) {
    return Math.round(Math.max(0, Math.min(1, share)) * 100);
};
var brandMixRows = function(mix) {
    var brands = mix.twin.brands;
    var shown = brands.slice(0, BRAND_MIX_SHOWN).map(function(b) {
        return {
            label: b.manufacturer,
            share: b.share,
            other: false
        };
    });
    if (brands.length > BRAND_MIX_SHOWN) {
        var rest = brands.slice(BRAND_MIX_SHOWN).reduce(function(sum, b) {
            return sum + b.share;
        }, 0);
        shown.push({
            label: "Other",
            share: rest,
            other: true
        });
    }
    return shown;
};
var Root2 = styled76(Card4)(_templateObject173(), space16[2]);
var Head2 = styled76.div(_templateObject174(), space16[2]);
var Title2 = styled76.h4(_templateObject175(), fontSans3, typeRole8.body1.fontSize, typeRole8.body1.lineHeight, weight5.semibold, ink13[1]);
var Aside = styled76.span(_templateObject176(), fontSans3, typeScale3.caption1.fontSize, typeScale3.caption1.lineHeight, ink13[3]);
var Rows = styled76.ul(_templateObject177(), space16[1]);
var Row5 = styled76.li(_templateObject178(), space16[2], fontSans3, typeScale3.caption1.fontSize, typeScale3.caption1.lineHeight, weight5.medium, ink13[1], ink13[3], fontMono3, typeScale3.captionCompact.fontSize, weight5.regular, ink13[3]);
var Bar2 = styled76.span(_templateObject179(), radius10.pill, surface8[2], function(param) {
    var $percent = param.$percent;
    return $percent > 0 ? "max(6px, ".concat($percent, "%)") : "0";
}, radius10.pill, function(param) {
    var $other = param.$other;
    return $other ? ink13[5] : "linear-gradient(90deg, ".concat(SELECTED_RAMP[5], " 0%, ").concat(SELECTED_RAMP[5], " 55%, ").concat(SELECTED_RAMP[3], " 100%)");
});
var Others = styled76.div(_templateObject180(), space16[1], space16[2], space16[2], line6[2], fontSans3, typeScale3.caption1.fontSize, typeScale3.caption1.lineHeight, ink13[3]);
var Sentence = styled76.p(_templateObject181(), fontSans3, typeScale3.caption1.fontSize, typeScale3.caption1.lineHeight, ink13[3]);
var BrandMixCard = function(param) {
    var mix = param.mix, state = param.state, onRetry = param.onRetry, _param_headingLevel = param.headingLevel, headingLevel = _param_headingLevel === void 0 ? 4 : _param_headingLevel, tmp = param.// Named apart from the `surface` token imported above, which the share bar's track reads.
    surface, cardSurface = tmp === void 0 ? "on-solid" : tmp, className = param.className;
    var headingId = useId5();
    var Heading = "h".concat(headingLevel);
    var otherTwins = state === "ready" && mix ? mix.otherTwins.brands : [];
    var shownOthers = otherTwins.slice(0, BRAND_MIX_OTHER_TWINS_SHOWN);
    var moreOthers = otherTwins.length - shownOthers.length;
    var body = null;
    if (state === "error") {
        body = /* @__PURE__ */ jsxs75("div", {
            children: [
                /* @__PURE__ */ jsx106(Sentence, {
                    "aria-hidden": "true",
                    children: BRAND_MIX_ERROR
                }),
                /* @__PURE__ */ jsx106(Button10, {
                    type: "button",
                    variant: "text",
                    size: "inline",
                    iconLeft: /* @__PURE__ */ jsx106(Icon5, {
                        name: "arrows-rotate",
                        size: "sm"
                    }),
                    "aria-label": "Retry reading your brands",
                    onClick: onRetry,
                    children: "Retry"
                })
            ]
        });
    } else if (state === "ready" && mix) {
        body = mix.twin.total === 0 ? /* @__PURE__ */ jsx106(Sentence, {
            children: BRAND_MIX_EMPTY
        }) : /* @__PURE__ */ jsx106(Rows, {
            children: brandMixRows(mix).map(function(row) {
                var percent = percentOf(row.share);
                return /* @__PURE__ */ jsxs75(Row5, {
                    className: row.other ? "other" : void 0,
                    children: [
                        /* @__PURE__ */ jsx106("span", {
                            className: "name",
                            children: row.label
                        }),
                        /* @__PURE__ */ jsx106(Bar2, {
                            "aria-hidden": "true",
                            $percent: percent,
                            $other: row.other
                        }),
                        /* @__PURE__ */ jsxs75("span", {
                            className: "share",
                            children: [
                                percent,
                                " %"
                            ]
                        })
                    ]
                }, row.label);
            })
        });
    }
    return /* @__PURE__ */ jsxs75(Root2, {
        surface: cardSurface,
        size: "sm",
        role: "region",
        className: className,
        "aria-labelledby": headingId,
        "aria-busy": state === "loading" || void 0,
        "data-testid": "brand-mix-card",
        children: [
            /* @__PURE__ */ jsxs75(Head2, {
                children: [
                    /* @__PURE__ */ jsx106(Title2, {
                        as: Heading,
                        id: headingId,
                        children: "Your brands"
                    }),
                    /* @__PURE__ */ jsx106(Aside, {
                        children: "our first guess for the rest"
                    })
                ]
            }),
            body,
            /* @__PURE__ */ jsx106("span", {
                role: "status",
                style: visuallyHidden,
                children: state === "error" ? BRAND_MIX_ERROR : ""
            }),
            shownOthers.length > 0 && /* @__PURE__ */ jsxs75(Others, {
                children: [
                    /* @__PURE__ */ jsx106("span", {
                        children: "On this customer\u2019s other twins"
                    }),
                    shownOthers.map(function(b) {
                        return /* @__PURE__ */ jsx106(Tag3, {
                            surface: cardSurface,
                            size: "dense",
                            children: b.manufacturer
                        }, b.manufacturer);
                    }),
                    moreOthers > 0 && /* @__PURE__ */ jsxs75("span", {
                        children: [
                            "+",
                            moreOthers,
                            " more"
                        ]
                    })
                ]
            })
        ]
    });
};
// src/components/IdentifyCard/IdentifyCard.tsx
import { useCallback as useCallback14, useId as useId6, useRef as useRef21, useState as useState51 } from "react";
import styled78 from "styled-components";
import { Button as Button11, DockedCard, Icon as Icon6, Note } from "@repo/design-system";
import { fontSans as fontSans5, ink as ink15, space as space18, typeScale as typeScale5, weight as weight6 } from "@repo/design-tokens";
// src/components/IdentifyCard/facts.ts
import styled77 from "styled-components";
import { fontSans as fontSans4, ink as ink14, inkOn as inkOn5, space as space17, typeScale as typeScale4 } from "@repo/design-tokens";
var Facts = styled77.dl(_templateObject182(), space17[6], space17[2], fontSans4, typeScale4.caption1.fontSize, typeScale4.caption1.lineHeight, ink14[3], ink14[1], ink14[3], inkOn5.error);
// src/components/IdentifyCard/IdentifyCard.tsx
import { Fragment as Fragment24, jsx as jsx107, jsxs as jsxs76 } from "react/jsx-runtime";
var IDENTIFY_ANSWERS = [
    {
        value: "brand",
        text: "Brand",
        icon: "industry"
    },
    {
        value: "generic",
        text: "Generic",
        icon: "shapes"
    },
    {
        value: "not_tracked",
        text: "Not tracked",
        icon: "ban"
    }
];
var IDENTIFY_NAMES_NOTE = "Names stay as they are. Only what the asset is changes.";
var NOT_TRACKED_NOTE = "Not tracked is never placed on the plan.";
var NONE_GIVEN = "none given";
var identifyTitle = function(count) {
    return count === 1 ? "Identify 1 asset" : "Identify ".concat(count, " assets");
};
var Caption = styled78.div(_templateObject183(), space18[2], fontSans5, typeScale5.caption1.fontSize, typeScale5.caption1.lineHeight, weight6.semibold, ink15[2], weight6.regular, ink15[3]);
var Section = styled78.section(_templateObject184(), space18[2]);
var Body2 = styled78.div(_templateObject185());
var Foot = styled78.div(_templateObject186(), space18[3]);
var Fact = function(param) {
    var term = param.term, value = param.value;
    return /* @__PURE__ */ jsxs76(Fragment24, {
        children: [
            /* @__PURE__ */ jsx107("dt", {
                children: term
            }),
            /* @__PURE__ */ jsx107("dd", {
                children: value && value.trim() !== "" ? value : /* @__PURE__ */ jsx107("span", {
                    className: "identify-none",
                    children: NONE_GIVEN
                })
            })
        ]
    });
};
var IdentifyCard = function(props) {
    return props.layout === "plan" ? /* @__PURE__ */ jsx107(IdentifyPlanCard, _object_spread({}, props)) : /* @__PURE__ */ jsx107(EquipmentIdentifyCard, _object_spread({}, props));
};
var EquipmentIdentifyCard = function(param) {
    var group = param.group, position = param.position, fetchers = param.fetchers, organisationName = param.organisationName, _param_busy = param.busy, busy = _param_busy === void 0 ? false : _param_busy, onIdentify = param.onIdentify, onMarkNotTracked = param.onMarkNotTracked, onSkip = param.onSkip, onClose = param.onClose, _param_placement = param.placement, placement = _param_placement === void 0 ? "beside" : _param_placement, _param_headingLevel = param.headingLevel, headingLevel = _param_headingLevel === void 0 ? 3 : _param_headingLevel, returnFocusTo = param.returnFocusTo, optionMeta = param.optionMeta, onGroupChange = param.onGroupChange, logContext = param.logContext, className = param.className;
    var _useState51 = _sliced_to_array(useState51("brand"), 2), answer = _useState51[0], setAnswer = _useState51[1];
    var _useState511 = _sliced_to_array(useState51(null), 2), chosen = _useState511[0], setChosen = _useState511[1];
    var _useState512 = _sliced_to_array(useState51(""), 2), fieldKey = _useState512[0], setFieldKey = _useState512[1];
    var subId = useId6();
    var bodyRef = useRef21(null);
    useIdentifyCardFocus({
        bodyRef: bodyRef,
        target: function(body) {
            return body.querySelector('input[role="combobox"]');
        },
        groupKey: group.key,
        onGroupChange: onGroupChange,
        fieldKey: fieldKey,
        busy: busy
    });
    var chooseAnswer = useCallback14(function(value) {
        setAnswer(value);
        setChosen(null);
    }, []);
    var onChosenChange = useCallback14(function(value) {
        return setChosen(value);
    }, []);
    var onTake = useCallback14(function(value) {
        if (answer !== "not_tracked") onIdentify(value, answer);
    }, [
        answer,
        onIdentify
    ]);
    var submit = function() {
        if (busy) return;
        if (answer === "not_tracked") onMarkNotTracked();
        else if (chosen) onIdentify(chosen, answer);
    };
    var footer = /* @__PURE__ */ jsxs76(Foot, {
        children: [
            /* @__PURE__ */ jsx107(Button11, {
                variant: "text",
                onClick: onSkip,
                disabled: busy,
                children: "Skip"
            }),
            /* @__PURE__ */ jsx107(Button11, {
                variant: "primary",
                iconLeft: /* @__PURE__ */ jsx107(Icon6, {
                    name: "check",
                    size: "xs"
                }),
                loading: busy,
                disabled: answer !== "not_tracked" && !chosen,
                onClick: submit,
                children: answer === "not_tracked" ? "Mark ".concat(group.count, " Not Tracked") : "Identify ".concat(group.count)
            })
        ]
    });
    return /* @__PURE__ */ jsx107(DockedCard, {
        className: className,
        tone: "peri",
        placement: placement,
        icon: /* @__PURE__ */ jsx107(Icon6, {
            name: "magnifying-glass"
        }),
        title: identifyTitle(group.count),
        headingLevel: headingLevel,
        sub: /* @__PURE__ */ jsx107("span", {
            id: subId,
            children: group.proposal ? // Opened on one guess by *Change* — it does not walk the groups (R11).
            "".concat(group.label, " \xb7 guessed") : "".concat(group.label, " \xb7 ").concat(position.n, " of ").concat(position.of, " ").concat(position.of === 1 ? "group" : "groups")
        }),
        onClose: onClose,
        closeLabel: "Close identify card",
        returnFocusTo: returnFocusTo,
        footer: footer,
        children: /* @__PURE__ */ jsxs76(Body2, {
            ref: bodyRef,
            children: [
                /* @__PURE__ */ jsxs76(Section, {
                    "aria-label": "What you wrote",
                    children: [
                        /* @__PURE__ */ jsxs76(Caption, {
                            as: "h4",
                            children: [
                                "What you wrote",
                                /* @__PURE__ */ jsx107("span", {
                                    className: "identify-aside",
                                    children: "kept as written"
                                })
                            ]
                        }),
                        /* @__PURE__ */ jsxs76(Facts, {
                            children: [
                                /* @__PURE__ */ jsx107(Fact, {
                                    term: "Name",
                                    value: group.label
                                }),
                                /* @__PURE__ */ jsx107(Fact, {
                                    term: "Category",
                                    value: group.written.category
                                }),
                                /* @__PURE__ */ jsx107(Fact, {
                                    term: "Manufacturer",
                                    value: group.written.manufacturer
                                })
                            ]
                        })
                    ]
                }),
                /* @__PURE__ */ jsxs76(Section, {
                    children: [
                        /* @__PURE__ */ jsx107(Caption, {
                            as: "p",
                            "aria-hidden": "true",
                            children: "It is"
                        }),
                        /* @__PURE__ */ jsx107(TagSwitcher_default, {
                            label: "It is",
                            size: "default",
                            options: _to_consumable_array(IDENTIFY_ANSWERS),
                            selectedValue: answer,
                            onChange: chooseAnswer,
                            disabled: busy
                        })
                    ]
                }),
                answer === "not_tracked" ? /* @__PURE__ */ jsx107(Note, {
                    tone: "peri",
                    icon: /* @__PURE__ */ jsx107(Icon6, {
                        name: "ban",
                        size: "xs"
                    }),
                    children: NOT_TRACKED_NOTE
                }) : /* @__PURE__ */ jsx107(IdentifyProductField, {
                    assetId: group.sampleAssetId,
                    answer: answer,
                    proposal: group.proposal,
                    fetchers: fetchers,
                    organisationName: organisationName,
                    logContext: logContext,
                    busy: busy,
                    describedBy: subId,
                    value: chosen,
                    onChosenChange: onChosenChange,
                    onTake: onTake,
                    onFieldKey: setFieldKey,
                    optionMeta: optionMeta
                }),
                /* @__PURE__ */ jsx107(Note, {
                    tone: "peri",
                    icon: /* @__PURE__ */ jsx107(Icon6, {
                        name: "circle-info",
                        size: "xs"
                    }),
                    children: IDENTIFY_NAMES_NOTE
                })
            ]
        })
    });
};
// src/components/IdentifyCard/useIdentifyGroup.tsx
import { useCallback as useCallback15, useEffect as useEffect37, useRef as useRef22, useState as useState52 } from "react";
import { Icon as Icon7, useToast } from "@repo/design-system";
import { IDENTIFY_MAX_IDS, canUndoIdentify, isWriteOutcomeUnknown } from "@repo/front-end-services";
import { jsx as jsx108 } from "react/jsx-runtime";
var describe = function(error) {
    var _error_response;
    var _error_status;
    return {
        status: (_error_status = error === null || error === void 0 ? void 0 : error.status) !== null && _error_status !== void 0 ? _error_status : error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.status,
        code: error === null || error === void 0 ? void 0 : error.code
    };
};
var newIdempotencyKey = function() {
    return typeof crypto !== "undefined" && typeof crypto.randomUUID === "function" ? crypto.randomUUID() : "identify-".concat(Date.now(), "-").concat(Math.random().toString(36).slice(2));
};
var chunkIds = function(ids) {
    var size2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : IDENTIFY_MAX_IDS;
    var chunks = [];
    for(var i = 0; i < ids.length; i += size2)chunks.push(ids.slice(i, i + size2));
    return chunks;
};
var COPY = {
    identified: {
        verb: "identify",
        undone: "Identify undone",
        stay: "The rows stay identified.",
        nothing: "Nothing to change \u2014 already identified",
        batchNone: "Couldn\u2019t identify the groups"
    },
    confirmed: {
        verb: "confirm",
        undone: "Confirm undone",
        stay: "The rows stay confirmed.",
        nothing: "Nothing to change \u2014 already confirmed",
        batchNone: "Couldn\u2019t confirm the guesses"
    },
    changed: {
        verb: "change the product of",
        undone: "Product change undone",
        stay: "The rows keep the new product.",
        nothing: "Nothing to change \u2014 all already have this product",
        batchNone: "Couldn\u2019t change the product"
    }
};
var identifiedTitle = function(label, written, alreadyIdentified, gone, score, sub2) {
    var verb = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : "identified";
    if (verb === "changed") {
        var changed = [
            "Product changed for ".concat(written)
        ];
        if (alreadyIdentified > 0) changed.push("".concat(alreadyIdentified, " already had it"));
        if (gone > 0) changed.push("".concat(gone, " ").concat(gone === 1 ? "was" : "were", " removed meanwhile"));
        return changed.join(" \xB7 ");
    }
    var scored = !!score && score.before !== null && score.after !== null;
    var parts = [
        scored && sub2 ? "".concat(written, " ").concat(verb) : "".concat(label, " \xd7 ").concat(written, " ").concat(verb)
    ];
    if (alreadyIdentified > 0) parts.push("".concat(alreadyIdentified, " already identified"));
    if (gone > 0) parts.push("".concat(gone, " gone"));
    if (scored) parts.push("".concat(score.before, " % → ").concat(score.after, " %"));
    return parts.join(" \xB7 ");
};
var batchTitle = function(written, groups, alreadyIdentified, gone) {
    var verb = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "identified";
    var rows = verb === "confirmed" ? "".concat(written, " ").concat(written === 1 ? "guess" : "guesses") : "".concat(written);
    var parts = [
        "".concat(rows, " ").concat(verb, " in ").concat(groups, " ").concat(groups === 1 ? "group" : "groups")
    ];
    if (alreadyIdentified > 0) parts.push("".concat(alreadyIdentified, " already identified"));
    if (gone > 0) parts.push("".concat(gone, " gone"));
    return parts.join(" \xB7 ");
};
var undoneTitle = function(restored, total, changedSince) {
    var verb = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "identified";
    return changedSince === 0 && restored === total ? COPY[verb].undone : "".concat(restored, " of ").concat(total, " put back \xb7 ").concat(changedSince, " changed since");
};
var useIdentifyGroup = function(api) {
    var toast = useToast();
    var apiRef = useRef22(api);
    apiRef.current = api;
    var show = useCallback15(function(options) {
        var region = apiRef.current.toastRegion;
        return toast.show(region ? _object_spread_props(_object_spread({}, options), {
            region: region
        }) : options);
    }, [
        toast
    ]);
    var _useState52 = _sliced_to_array(useState52(false), 2), busy = _useState52[0], setBusy = _useState52[1];
    var busyRef = useRef22(false);
    var raised = useRef22([]);
    var mounted = useRef22(true);
    useEffect37(function() {
        mounted.current = true;
        return function() {
            mounted.current = false;
            raised.current.forEach(function(id) {
                return toast.dismiss(id);
            });
        };
    }, []);
    var refreshing = useRef22(null);
    var refreshQueued = useRef22(false);
    var refresh = useCallback15(function() {
        if (refreshing.current) {
            refreshQueued.current = true;
            return;
        }
        var run = function() {
            return apiRef.current.refresh().then(function() {
                return apiRef.current.reload();
            }).catch(function(error) {
                console.warn("[identify] guess refresh failed", _object_spread({}, apiRef.current.logContext, describe(error)));
            }).then(function() {
                if (refreshQueued.current) {
                    refreshQueued.current = false;
                    refreshing.current = run();
                    return refreshing.current;
                }
                refreshing.current = null;
                return void 0;
            });
        };
        refreshing.current = run();
    }, []);
    var undo = useCallback15(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(results) {
            var verb, _apiRef_current_writeBlocked, _apiRef_current, _apiRef_current_beginWrite, _apiRef_current1, copy, _apiRef_current_writeBlocked1, blocked, undoable, total, restored, changedSince, _apiRef_current_beginWrite1, saveTicket, _apiRef_current_settleWrite, _apiRef_current2, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, result, answer, err, error, _apiRef_current_settleWrite1, _apiRef_current3, unavailable;
            var _arguments = arguments;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        verb = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "identified";
                        copy = COPY[verb];
                        blocked = (_apiRef_current_writeBlocked1 = (_apiRef_current_writeBlocked = (_apiRef_current = apiRef.current).writeBlocked) === null || _apiRef_current_writeBlocked === void 0 ? void 0 : _apiRef_current_writeBlocked.call(_apiRef_current)) !== null && _apiRef_current_writeBlocked1 !== void 0 ? _apiRef_current_writeBlocked1 : null;
                        if (blocked) {
                            raised.current.push(show({
                                tone: "neutral",
                                icon: /* @__PURE__ */ jsx108(Icon7, {
                                    name: "circle-info"
                                }),
                                title: blocked,
                                actions: [
                                    {
                                        label: "Undo",
                                        onAction: function() {
                                            return void undoRef.current(results, verb);
                                        }
                                    }
                                ]
                            }));
                            return [
                                2
                            ];
                        }
                        undoable = results.filter(canUndoIdentify);
                        if (undoable.length === 0) {
                            raised.current.push(show({
                                tone: "error",
                                icon: /* @__PURE__ */ jsx108(Icon7, {
                                    name: "circle-exclamation"
                                }),
                                title: "Undo isn\u2019t available right now",
                                detail: copy.stay
                            }));
                            return [
                                2
                            ];
                        }
                        total = undoable.reduce(function(n, r) {
                            return n + r.identified.length;
                        }, 0);
                        restored = 0;
                        changedSince = 0;
                        saveTicket = (_apiRef_current_beginWrite1 = (_apiRef_current_beginWrite = (_apiRef_current1 = apiRef.current).beginWrite) === null || _apiRef_current_beginWrite === void 0 ? void 0 : _apiRef_current_beginWrite.call(_apiRef_current1)) !== null && _apiRef_current_beginWrite1 !== void 0 ? _apiRef_current_beginWrite1 : null;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            10,
                            ,
                            11
                        ]);
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            7,
                            8,
                            9
                        ]);
                        _iterator = undoable[Symbol.iterator]();
                        _state.label = 3;
                    case 3:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            6
                        ];
                        result = _step.value;
                        return [
                            4,
                            apiRef.current.undo(result, newIdempotencyKey())
                        ];
                    case 4:
                        answer = _state.sent();
                        restored += answer.restored.length + answer.alreadyRestored.length;
                        changedSince += answer.changedSince.length;
                        _state.label = 5;
                    case 5:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            3
                        ];
                    case 6:
                        return [
                            3,
                            9
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            9
                        ];
                    case 8:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 9:
                        (_apiRef_current_settleWrite = (_apiRef_current2 = apiRef.current).settleWrite) === null || _apiRef_current_settleWrite === void 0 ? void 0 : _apiRef_current_settleWrite.call(_apiRef_current2, saveTicket, true);
                        return [
                            3,
                            11
                        ];
                    case 10:
                        error = _state.sent();
                        (_apiRef_current_settleWrite1 = (_apiRef_current3 = apiRef.current).settleWrite) === null || _apiRef_current_settleWrite1 === void 0 ? void 0 : _apiRef_current_settleWrite1.call(_apiRef_current3, saveTicket, false, error === null || error === void 0 ? void 0 : error.message);
                        apiRef.current.reload();
                        console.warn("[identify] undo failed", _object_spread_props(_object_spread({}, apiRef.current.logContext, describe(error)), {
                            calls: undoable.length,
                            restoredSoFar: restored
                        }));
                        if (restored > 0) refresh();
                        if (!mounted.current) return [
                            2
                        ];
                        unavailable = (error === null || error === void 0 ? void 0 : error.status) === 501;
                        raised.current.push(show(_object_spread({
                            tone: "error",
                            icon: /* @__PURE__ */ jsx108(Icon7, {
                                name: "circle-exclamation"
                            }),
                            title: unavailable ? "Undo isn\u2019t available right now" : "Couldn\u2019t undo",
                            detail: unavailable ? copy.stay : "The list has been refreshed to show what is saved."
                        }, unavailable ? {} : {
                            actions: [
                                {
                                    label: "Try again",
                                    onAction: function() {
                                        return void undoRef.current(undoable, verb);
                                    }
                                }
                            ]
                        })));
                        return [
                            2
                        ];
                    case 11:
                        apiRef.current.reload();
                        if (restored > 0) refresh();
                        if (!mounted.current) return [
                            2
                        ];
                        raised.current.push(show({
                            tone: "neutral",
                            icon: /* @__PURE__ */ jsx108(Icon7, {
                                name: "rotate-left"
                            }),
                            title: undoneTitle(restored, total, changedSince, verb)
                        }));
                        return [
                            2
                        ];
                }
            });
        });
        return function(results) {
            return _ref.apply(this, arguments);
        };
    }(), [
        show,
        refresh
    ]);
    var undoRef = useRef22(undo);
    undoRef.current = undo;
    var writeGroup = useCallback15(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(referenceId, rowIds, replay) {
            var _replay_ids, replayed, calls, results, unsettled, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, call, _, err, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        replayed = new Set((_replay_ids = replay === null || replay === void 0 ? void 0 : replay.ids) !== null && _replay_ids !== void 0 ? _replay_ids : []);
                        calls = _to_consumable_array(replay ? [
                            replay
                        ] : []).concat(_to_consumable_array(chunkIds(rowIds.filter(function(id) {
                            return !replayed.has(id);
                        })).map(function(ids) {
                            return {
                                ids: ids,
                                key: newIdempotencyKey()
                            };
                        })));
                        results = [];
                        unsettled = null;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            10,
                            ,
                            11
                        ]);
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            7,
                            8,
                            9
                        ]);
                        _iterator = calls[Symbol.iterator]();
                        _state.label = 3;
                    case 3:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            6
                        ];
                        call = _step.value;
                        unsettled = call;
                        _ = results.push;
                        return [
                            4,
                            apiRef.current.identify(referenceId, call.ids, call.key)
                        ];
                    case 4:
                        _.apply(results, [
                            _state.sent()
                        ]);
                        _state.label = 5;
                    case 5:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            3
                        ];
                    case 6:
                        return [
                            3,
                            9
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            9
                        ];
                    case 8:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 9:
                        return [
                            2,
                            {
                                allIds: calls.flatMap(function(c) {
                                    return c.ids;
                                }),
                                calls: calls.length,
                                results: results,
                                failure: null,
                                unsettled: null
                            }
                        ];
                    case 10:
                        error = _state.sent();
                        return [
                            2,
                            {
                                allIds: calls.flatMap(function(c) {
                                    return c.ids;
                                }),
                                calls: calls.length,
                                results: results,
                                failure: error,
                                // Only a call that may have landed is replayed; a refused one is simply sent again.
                                unsettled: isWriteOutcomeUnknown(error) ? unsettled : null
                            }
                        ];
                    case 11:
                        return [
                            2
                        ];
                }
            });
        });
        return function(referenceId, rowIds, replay) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    var identify = useCallback15(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(group, referenceId, rowIds, retry, onMoved, replay) {
            var options, _apiRef_current_writeBlocked, _apiRef_current, _apiRef_current_beginWrite, _apiRef_current1, _apiRef_current_settleWrite, _apiRef_current2, _apiRef_current_toastSub, _apiRef_current3, _apiRef_current_scoreFor, _apiRef_current4, _apiRef_current_writeBlocked1, blocked, _options_verb, verb, copy, _apiRef_current_beginWrite1, saveTicket, outcome, allIds, calls, results, failure, written, unknown, pending, landed, _failure_message, already, gone, _apiRef_current_toastSub1, sub2, _apiRef_current_scoreFor1, id;
            var _arguments = arguments;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        options = _arguments.length > 6 && _arguments[6] !== void 0 ? _arguments[6] : {};
                        if (busyRef.current) return [
                            2,
                            "stayed"
                        ];
                        blocked = (_apiRef_current_writeBlocked1 = (_apiRef_current_writeBlocked = (_apiRef_current = apiRef.current).writeBlocked) === null || _apiRef_current_writeBlocked === void 0 ? void 0 : _apiRef_current_writeBlocked.call(_apiRef_current)) !== null && _apiRef_current_writeBlocked1 !== void 0 ? _apiRef_current_writeBlocked1 : null;
                        if (blocked) {
                            raised.current.push(show({
                                tone: "neutral",
                                icon: /* @__PURE__ */ jsx108(Icon7, {
                                    name: "circle-info"
                                }),
                                title: blocked,
                                actions: [
                                    {
                                        label: "Try again",
                                        onAction: function() {
                                            return void identifyRef.current(group, referenceId, rowIds, retry, onMoved, replay, options);
                                        }
                                    }
                                ]
                            }));
                            return [
                                2,
                                "stayed"
                            ];
                        }
                        busyRef.current = true;
                        setBusy(true);
                        verb = (_options_verb = options.verb) !== null && _options_verb !== void 0 ? _options_verb : "identified";
                        copy = COPY[verb];
                        saveTicket = (_apiRef_current_beginWrite1 = (_apiRef_current_beginWrite = (_apiRef_current1 = apiRef.current).beginWrite) === null || _apiRef_current_beginWrite === void 0 ? void 0 : _apiRef_current_beginWrite.call(_apiRef_current1)) !== null && _apiRef_current_beginWrite1 !== void 0 ? _apiRef_current_beginWrite1 : null;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4,
                            writeGroup(referenceId, rowIds, replay)
                        ];
                    case 2:
                        outcome = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        busyRef.current = false;
                        if (mounted.current) setBusy(false);
                        return [
                            7
                        ];
                    case 4:
                        allIds = outcome.allIds, calls = outcome.calls, results = outcome.results, failure = outcome.failure;
                        (_apiRef_current_settleWrite = (_apiRef_current2 = apiRef.current).settleWrite) === null || _apiRef_current_settleWrite === void 0 ? void 0 : _apiRef_current_settleWrite.call(_apiRef_current2, saveTicket, failure === null, failure === null || failure === void 0 ? void 0 : failure.message);
                        apiRef.current.reload();
                        written = results.reduce(function(n, r) {
                            return n + r.identified.length;
                        }, 0);
                        if (written > 0) refresh();
                        if (failure !== null) {
                            console.warn("[identify] identify failed", _object_spread_props(_object_spread({}, apiRef.current.logContext, describe(failure)), {
                                rows: allIds.length,
                                calls: calls,
                                callsWritten: results.length,
                                written: written
                            }));
                            if (!mounted.current) return [
                                2,
                                "stayed"
                            ];
                            unknown = isWriteOutcomeUnknown(failure);
                            pending = outcome.unsettled;
                            landed = results.filter(function(r) {
                                return r.identified.length > 0;
                            });
                            ;
                            raised.current.push(show({
                                tone: "error",
                                icon: /* @__PURE__ */ jsx108(Icon7, {
                                    name: "circle-exclamation"
                                }),
                                title: written > 0 ? "".concat(written, " of ").concat(allIds.length, " ").concat(verb, " \xb7 the rest couldn’t be") : "Couldn’t ".concat(copy.verb, " ").concat(group.label),
                                detail: unknown ? "We couldn\u2019t tell whether it saved. The list has been refreshed." : (_failure_message = failure === null || failure === void 0 ? void 0 : failure.message) !== null && _failure_message !== void 0 ? _failure_message : void 0,
                                actions: [
                                    {
                                        label: "Try again",
                                        onAction: function() {
                                            var still = retry(allIds);
                                            if (still.length === 0 && !pending) return;
                                            void identifyRef.current(group, referenceId, still, retry, onMoved, pending !== null && pending !== void 0 ? pending : void 0, options).then(function(next) {
                                                if (next === "moved") onMoved === null || onMoved === void 0 ? void 0 : onMoved();
                                            });
                                        }
                                    }
                                ].concat(_to_consumable_array(landed.length > 0 ? [
                                    {
                                        label: "Undo ".concat(written, " ").concat(verb),
                                        onAction: function() {
                                            return void undo(landed, verb);
                                        }
                                    }
                                ] : []))
                            }));
                            return [
                                2,
                                "stayed"
                            ];
                        }
                        if (!mounted.current) return [
                            2,
                            "moved"
                        ];
                        already = results.reduce(function(n, r) {
                            return n + r.alreadyIdentified.length;
                        }, 0);
                        gone = results.reduce(function(n, r) {
                            return n + r.alreadyGone.length;
                        }, 0);
                        if (written === 0) {
                            raised.current.push(show({
                                tone: "neutral",
                                icon: /* @__PURE__ */ jsx108(Icon7, {
                                    name: "check"
                                }),
                                title: copy.nothing
                            }));
                            return [
                                2,
                                "moved"
                            ];
                        }
                        sub2 = options.sub ? options.sub(written, results) : (_apiRef_current_toastSub1 = (_apiRef_current_toastSub = (_apiRef_current3 = apiRef.current).toastSub) === null || _apiRef_current_toastSub === void 0 ? void 0 : _apiRef_current_toastSub.call(_apiRef_current3, group, referenceId)) !== null && _apiRef_current_toastSub1 !== void 0 ? _apiRef_current_toastSub1 : null;
                        id = show(_object_spread_props(_object_spread({
                            tone: "success",
                            icon: /* @__PURE__ */ jsx108(Icon7, {
                                name: "check"
                            }),
                            title: identifiedTitle(group.label, written, already, gone, (_apiRef_current_scoreFor1 = (_apiRef_current_scoreFor = (_apiRef_current4 = apiRef.current).scoreFor) === null || _apiRef_current_scoreFor === void 0 ? void 0 : _apiRef_current_scoreFor.call(_apiRef_current4, group, written, results.flatMap(function(r) {
                                return r.identified.map(function(row) {
                                    return row.asset.id;
                                });
                            }))) !== null && _apiRef_current_scoreFor1 !== void 0 ? _apiRef_current_scoreFor1 : null, sub2, verb)
                        }, sub2 ? {
                            sub: sub2
                        } : {}), {
                            inlineAction: {
                                label: "Undo",
                                onAction: function() {
                                    toast.dismiss(id);
                                    void undo(results, verb);
                                }
                            }
                        }));
                        raised.current.push(id);
                        return [
                            2,
                            "moved"
                        ];
                }
            });
        });
        return function(group, referenceId, rowIds, retry, onMoved, replay) {
            return _ref.apply(this, arguments);
        };
    }(), [
        show,
        refresh,
        undo,
        writeGroup
    ]);
    var identifyRef = useRef22(identify);
    identifyRef.current = identify;
    var identifyBatch = useCallback15(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(entries) {
            var options, _apiRef_current_beginWrite, _apiRef_current, _apiRef_current_settleWrite, _apiRef_current1, _options_sub, _options_verb, verb, copy, _apiRef_current_beginWrite1, saveTicket, results, done, failed, firstFailure, failures, unknown, sent, callsSent, groupsWritten, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, entry, _results, outcome, _outcome_unsettled, err, unsent, written, answer, total, landed, again, _firstFailure_message, already, gone, _options_sub1, sub2, id;
            var _arguments = arguments;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        if (busyRef.current || entries.length === 0) return [
                            2,
                            {
                                outcome: "stayed",
                                done: []
                            }
                        ];
                        busyRef.current = true;
                        setBusy(true);
                        verb = (_options_verb = options.verb) !== null && _options_verb !== void 0 ? _options_verb : "identified";
                        copy = COPY[verb];
                        saveTicket = (_apiRef_current_beginWrite1 = (_apiRef_current_beginWrite = (_apiRef_current = apiRef.current).beginWrite) === null || _apiRef_current_beginWrite === void 0 ? void 0 : _apiRef_current_beginWrite.call(_apiRef_current)) !== null && _apiRef_current_beginWrite1 !== void 0 ? _apiRef_current_beginWrite1 : null;
                        results = [];
                        done = [];
                        failed = [];
                        firstFailure = null;
                        failures = [];
                        unknown = false;
                        sent = 0;
                        callsSent = 0;
                        groupsWritten = 0;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            10,
                            11
                        ]);
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            7,
                            8,
                            9
                        ]);
                        _iterator = entries[Symbol.iterator]();
                        _state.label = 3;
                    case 3:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            6
                        ];
                        entry = _step.value;
                        sent += 1;
                        return [
                            4,
                            writeGroup(entry.referenceId, entry.rowIds, entry.replay)
                        ];
                    case 4:
                        outcome = _state.sent();
                        callsSent += outcome.calls;
                        (_results = results).push.apply(_results, _to_consumable_array(outcome.results));
                        if (outcome.results.some(function(r) {
                            return r.identified.length > 0;
                        })) groupsWritten += 1;
                        if (outcome.failure === null) {
                            done.push(entry);
                            return [
                                3,
                                5
                            ];
                        }
                        if (firstFailure === null) firstFailure = outcome.failure;
                        if (failures.length < 5) failures.push(describe(outcome.failure));
                        failed.push(_object_spread_props(_object_spread({}, entry), {
                            rowIds: outcome.allIds,
                            replay: (_outcome_unsettled = outcome.unsettled) !== null && _outcome_unsettled !== void 0 ? _outcome_unsettled : void 0
                        }));
                        if (isWriteOutcomeUnknown(outcome.failure)) {
                            unknown = true;
                            return [
                                3,
                                6
                            ];
                        }
                        _state.label = 5;
                    case 5:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            3
                        ];
                    case 6:
                        return [
                            3,
                            9
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            9
                        ];
                    case 8:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 9:
                        return [
                            3,
                            11
                        ];
                    case 10:
                        busyRef.current = false;
                        if (mounted.current) setBusy(false);
                        return [
                            7
                        ];
                    case 11:
                        unsent = entries.slice(sent);
                        (_apiRef_current_settleWrite = (_apiRef_current1 = apiRef.current).settleWrite) === null || _apiRef_current_settleWrite === void 0 ? void 0 : _apiRef_current_settleWrite.call(_apiRef_current1, saveTicket, firstFailure === null, firstFailure === null || firstFailure === void 0 ? void 0 : firstFailure.message);
                        apiRef.current.reload();
                        written = results.reduce(function(n, r) {
                            return n + r.identified.length;
                        }, 0);
                        if (written > 0) refresh();
                        answer = {
                            outcome: firstFailure === null ? "moved" : "stayed",
                            done: done
                        };
                        if (firstFailure !== null) {
                            console.warn("[identify] batch failed", _object_spread_props(_object_spread({}, apiRef.current.logContext, describe(firstFailure)), {
                                groups: entries.length,
                                groupsSent: sent,
                                groupsFailed: failed.length,
                                failures: failures,
                                calls: callsSent,
                                written: written
                            }));
                            if (!mounted.current) return [
                                2,
                                answer
                            ];
                            total = entries.reduce(function(n, e) {
                                return n + e.rowIds.length;
                            }, 0);
                            landed = results.filter(function(r) {
                                return r.identified.length > 0;
                            });
                            again = _to_consumable_array(failed).concat(_to_consumable_array(unsent));
                            ;
                            raised.current.push(show({
                                tone: "error",
                                icon: /* @__PURE__ */ jsx108(Icon7, {
                                    name: "circle-exclamation"
                                }),
                                title: written > 0 ? "".concat(written, " of ").concat(total, " ").concat(verb, " \xb7 the rest couldn’t be") : copy.batchNone,
                                detail: unknown ? "We couldn\u2019t tell whether it saved. The list has been refreshed." : (_firstFailure_message = firstFailure === null || firstFailure === void 0 ? void 0 : firstFailure.message) !== null && _firstFailure_message !== void 0 ? _firstFailure_message : void 0,
                                actions: [
                                    {
                                        label: "Try again",
                                        onAction: function() {
                                            var next = again.map(function(entry) {
                                                return _object_spread_props(_object_spread({}, entry), {
                                                    rowIds: entry.retry(entry.rowIds)
                                                });
                                            }).filter(function(entry) {
                                                return entry.rowIds.length > 0 || entry.replay;
                                            });
                                            if (next.length === 0) return;
                                            void identifyBatchRef.current(next, options).then(function(retried) {
                                                var _options_onRetried;
                                                if (retried.done.length > 0) (_options_onRetried = options.onRetried) === null || _options_onRetried === void 0 ? void 0 : _options_onRetried.call(options, retried);
                                            });
                                        }
                                    }
                                ].concat(_to_consumable_array(landed.length > 0 ? [
                                    {
                                        label: "Undo ".concat(written, " ").concat(verb),
                                        onAction: function() {
                                            return void undo(landed, verb);
                                        }
                                    }
                                ] : []))
                            }));
                            return [
                                2,
                                answer
                            ];
                        }
                        if (!mounted.current) return [
                            2,
                            answer
                        ];
                        if (written === 0) {
                            raised.current.push(show({
                                tone: "neutral",
                                icon: /* @__PURE__ */ jsx108(Icon7, {
                                    name: "check"
                                }),
                                title: copy.nothing
                            }));
                            return [
                                2,
                                answer
                            ];
                        }
                        already = results.reduce(function(n, r) {
                            return n + r.alreadyIdentified.length;
                        }, 0);
                        gone = results.reduce(function(n, r) {
                            return n + r.alreadyGone.length;
                        }, 0);
                        sub2 = (_options_sub1 = (_options_sub = options.sub) === null || _options_sub === void 0 ? void 0 : _options_sub.call(options, written, results)) !== null && _options_sub1 !== void 0 ? _options_sub1 : null;
                        id = show(_object_spread_props(_object_spread({
                            tone: "success",
                            icon: /* @__PURE__ */ jsx108(Icon7, {
                                name: "check"
                            }),
                            title: batchTitle(written, groupsWritten, already, gone, verb)
                        }, sub2 ? {
                            sub: sub2
                        } : {}), {
                            inlineAction: {
                                label: "Undo",
                                onAction: function() {
                                    toast.dismiss(id);
                                    void undo(results, verb);
                                }
                            }
                        }));
                        raised.current.push(id);
                        return [
                            2,
                            answer
                        ];
                }
            });
        });
        return function(entries) {
            return _ref.apply(this, arguments);
        };
    }(), [
        show,
        refresh,
        undo,
        writeGroup
    ]);
    var identifyBatchRef = useRef22(identifyBatch);
    identifyBatchRef.current = identifyBatch;
    return {
        busy: busy,
        identify: identify,
        identifyBatch: identifyBatch,
        undo: undo,
        refresh: refresh
    };
};
// src/components/IdentifyCard/useNotTrackedAction.tsx
import { useCallback as useCallback16, useEffect as useEffect38, useRef as useRef23, useState as useState53 } from "react";
import { Icon as Icon8, useToast as useToast2 } from "@repo/design-system";
import { opensIdentifyCard } from "@repo/front-end-utils";
import { jsx as jsx109 } from "react/jsx-runtime";
var notTrackedDetail = function(alreadyIdentified) {
    return alreadyIdentified > 0 ? "".concat(alreadyIdentified, " ").concat(alreadyIdentified === 1 ? "was" : "were", " identified by someone else first, so ").concat(alreadyIdentified === 1 ? "it was" : "they were", " left as ").concat(alreadyIdentified === 1 ? "it is" : "they are", ".") : "Identify them to give them a product.";
};
var useNotTrackedAction = function(param) {
    var onMarkNotTracked = param.onMarkNotTracked, stateOf = param.stateOf;
    var toast = useToast2();
    var _useState53 = _sliced_to_array(useState53(/* @__PURE__ */ new Set()), 2), busy = _useState53[0], setBusy = _useState53[1];
    var inFlight = useRef23(/* @__PURE__ */ new Set());
    var stateOfRef = useRef23(stateOf);
    stateOfRef.current = stateOf;
    var mounted = useRef23(true);
    var raised = useRef23([]);
    useEffect38(function() {
        mounted.current = true;
        return function() {
            mounted.current = false;
            raised.current.forEach(function(id) {
                return toast.dismiss(id);
            });
        };
    }, []);
    var mark = useCallback16(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(group, rowIds, onLanded) {
            var _outcome_alreadyIdentified, origin, outcome, error, total, _outcome_alreadyIdentified_length, already, failed;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!onMarkNotTracked || inFlight.current.has(group.key)) return [
                            2,
                            false
                        ];
                        origin = typeof document === "undefined" ? null : document.activeElement;
                        inFlight.current.add(group.key);
                        setBusy(function(current) {
                            return new Set(current).add(group.key);
                        });
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            onMarkNotTracked(group.key, rowIds)
                        ];
                    case 2:
                        outcome = _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 3:
                        error = _state.sent();
                        console.warn("[identify] not tracked rejected", {
                            rows: rowIds.length,
                            status: error === null || error === void 0 ? void 0 : error.status
                        });
                        outcome = {
                            written: [],
                            failed: rowIds
                        };
                        return [
                            3,
                            5
                        ];
                    case 4:
                        inFlight.current.delete(group.key);
                        if (mounted.current) {
                            setBusy(function(current) {
                                var next = new Set(current);
                                next.delete(group.key);
                                return next;
                            });
                        }
                        return [
                            7
                        ];
                    case 5:
                        if (outcome.stale || !mounted.current) return [
                            2,
                            false
                        ];
                        total = rowIds.length;
                        already = (_outcome_alreadyIdentified_length = (_outcome_alreadyIdentified = outcome.alreadyIdentified) === null || _outcome_alreadyIdentified === void 0 ? void 0 : _outcome_alreadyIdentified.length) !== null && _outcome_alreadyIdentified_length !== void 0 ? _outcome_alreadyIdentified_length : 0;
                        if (outcome.failed.length === 0) {
                            raised.current.push(toast.show({
                                tone: "neutral",
                                icon: /* @__PURE__ */ jsx109(Icon8, {
                                    name: "ban"
                                }),
                                title: "".concat(outcome.written.length, " marked Not tracked"),
                                detail: notTrackedDetail(already)
                            }));
                            onLanded === null || onLanded === void 0 ? void 0 : onLanded(origin);
                            return [
                                2,
                                true
                            ];
                        }
                        failed = outcome.failed;
                        raised.current.push(toast.show({
                            tone: "error",
                            icon: /* @__PURE__ */ jsx109(Icon8, {
                                name: "circle-exclamation"
                            }),
                            title: "".concat(failed.length, " of ").concat(total, " could not be marked Not tracked"),
                            actions: [
                                {
                                    label: "Try again",
                                    onAction: function() {
                                        var still = failed.filter(function(row) {
                                            return opensIdentifyCard(stateOfRef.current(row));
                                        });
                                        if (still.length > 0) void markRef.current(group, still, onLanded);
                                    }
                                }
                            ]
                        }));
                        return [
                            2,
                            false
                        ];
                }
            });
        });
        return function(group, rowIds, onLanded) {
            return _ref.apply(this, arguments);
        };
    }(), [
        onMarkNotTracked,
        toast
    ]);
    var markRef = useRef23(mark);
    markRef.current = mark;
    return {
        mark: mark,
        busy: busy
    };
};
// src/components/MessageBar/MessageBar.tsx
import styled79, { css as css3 } from "styled-components";
import { jsx as jsx110 } from "react/jsx-runtime";
var INTENT_STYLES = {
    success: css3(_templateObject187()),
    error: css3(_templateObject188()),
    warning: css3(_templateObject189()),
    info: css3(_templateObject190())
};
var StyledMessageBar = styled79.div(_templateObject191(), function(param) {
    var $intent = param.$intent;
    return INTENT_STYLES[$intent];
});
var MessageBar6 = function(param) {
    var className = param.className, _param_intent = param.intent, intent = _param_intent === void 0 ? "info" : _param_intent, children = param.children, style = param.style;
    return /* @__PURE__ */ jsx110(StyledMessageBar, {
        className: className,
        $intent: intent,
        style: style,
        children: children
    });
};
var MessageBar_default = MessageBar6;
// src/components/CompositeMeasures/CompositeMeasuresPanel.tsx
import { useCallback as useCallback17, useEffect as useEffect39, useLayoutEffect as useLayoutEffect6, useMemo as useMemo12, useRef as useRef24, useState as useState54 } from "react";
import styled80 from "styled-components";
import { Banner as Banner5, Button as Button12, Card as Card5, Dot, Icon as Icon9, Note as Note2, SourceChip, Tag as Tag4 } from "@repo/design-system";
import { brand as brand5, focus, fontMono as fontMono4, ink as ink17, inset as inset3, line as line7, radius as radius11, rgba as rgba5, semantic as semantic13, space as space19, surface as surface9, typeScale as typeScale6, weight as weight7 } from "@repo/design-tokens";
// src/components/CompositeMeasures/compositeListModel.ts
import { ink as ink16, semantic as semantic12 } from "@repo/design-tokens";
// src/components/CompositeMeasures/compositeRules.ts
var ownCamerasReason = function(label, watching) {
    return "".concat(label, " is watched by ").concat(watching, " cameras, so this total has to count them.");
};
var PARTLY_MEASURED_SUMMARY = "They go live adding up only the sources that are measured, so they read low until they are finished.";
var EMPTY_TOTAL_WARNING = "This total adds up nothing yet, so it will not measure anything. It saves as a draft and is held back from the live system until you add something to it.";
var partlyMeasuredLaunchNote = function(n) {
    return n === 1 ? "The twin still goes live, and it goes live adding up only the sources that are measured, so it reads low until it is finished." : "The twin still goes live, and these go live adding up only the sources that are measured, so they read low until they are finished.";
};
var nothingMeasuredNote = function(n) {
    return n === 1 ? "It is held back from the live system until something it adds up has a camera." : "They are held back from the live system until something they add up has a camera.";
};
var labelOf = function(value, ctx) {
    var _ctx_labels_get;
    return (_ctx_labels_get = ctx.labels.get(value)) !== null && _ctx_labels_get !== void 0 ? _ctx_labels_get : value;
};
var labelWithCode = function(value, ctx) {
    var _ctx_codes_get, _ctx_codes;
    var label = labelOf(value, ctx);
    var code = (_ctx_codes = ctx.codes) === null || _ctx_codes === void 0 ? void 0 : (_ctx_codes_get = _ctx_codes.get(value)) === null || _ctx_codes_get === void 0 ? void 0 : _ctx_codes_get.trim();
    return code ? "".concat(label, " (").concat(code, ")") : label;
};
var validateCompositeForm = function(form, ctx) {
    var _ctx_graph, _ctx_graph1, _ctx_graph2, _ctx_graph3, _ctx_graph4;
    var errors = {
        rows: form.inputs.map(function() {
            return void 0;
        })
    };
    var onThePlan = function(value) {
        return ctx.pickable ? ctx.pickable.has(value) : ctx.labels.has(value);
    };
    if (form.target === null || form.target === "") {
        errors.target = "Pick the thing this measure totals.";
    } else if (!onThePlan(form.target)) {
        errors.target = "This is no longer on the plan. Pick what this measure totals, or cancel and delete the measure.";
    }
    var filled = form.inputs.filter(function(v) {
        return v !== "";
    });
    if (form.target !== null && form.target !== "" && ((_ctx_graph = ctx.graph) === null || _ctx_graph === void 0 ? void 0 : _ctx_graph.duplicateTarget)) {
        var _errors_target;
        errors.target = (_errors_target = errors.target) !== null && _errors_target !== void 0 ? _errors_target : "".concat(labelOf(form.target, ctx), " is already totalled by another composite measure.");
    }
    if (form.target !== null && form.target !== "" && !form.includesOwnObservers) {
        var _ctx_observerCounts;
        var _ctx_observerCounts_get;
        var watching = (_ctx_observerCounts_get = (_ctx_observerCounts = ctx.observerCounts) === null || _ctx_observerCounts === void 0 ? void 0 : _ctx_observerCounts.get(form.target)) !== null && _ctx_observerCounts_get !== void 0 ? _ctx_observerCounts_get : 0;
        if (watching > 1) {
            var _errors_target1;
            errors.target = (_errors_target1 = errors.target) !== null && _errors_target1 !== void 0 ? _errors_target1 : ownCamerasReason(labelOf(form.target, ctx), watching);
        }
    }
    var blankRowIsAMistake = filled.length > 0;
    var seen = /* @__PURE__ */ new Set();
    form.inputs.forEach(function(value, i) {
        if (value === "") {
            if (blankRowIsAMistake) {
                var _errors_rows_i;
                errors.rows[i] = (_errors_rows_i = errors.rows[i]) !== null && _errors_rows_i !== void 0 ? _errors_rows_i : "Pick something to add up, or remove this row.";
            }
            return;
        }
        if (!onThePlan(value)) {
            var _errors_rows_i1;
            errors.rows[i] = (_errors_rows_i1 = errors.rows[i]) !== null && _errors_rows_i1 !== void 0 ? _errors_rows_i1 : "This is no longer on the plan. Pick another, or remove this row.";
        } else if (value === form.target) {
            var _errors_rows_i2;
            errors.rows[i] = (_errors_rows_i2 = errors.rows[i]) !== null && _errors_rows_i2 !== void 0 ? _errors_rows_i2 : "".concat(labelOf(value, ctx), " is what this measure totals. Remove it and count its own cameras instead.");
        } else if (seen.has(value)) {
            var _errors_rows_i3;
            errors.rows[i] = (_errors_rows_i3 = errors.rows[i]) !== null && _errors_rows_i3 !== void 0 ? _errors_rows_i3 : "".concat(labelOf(value, ctx), " is already added up here.");
            var _errors_members;
            errors.members = (_errors_members = errors.members) !== null && _errors_members !== void 0 ? _errors_members : "Each thing may be added up only once.";
        }
        seen.add(value);
    });
    var rowOf = function(value) {
        return form.inputs.indexOf(value);
    };
    if (((_ctx_graph1 = ctx.graph) === null || _ctx_graph1 === void 0 ? void 0 : _ctx_graph1.cycleThrough) !== void 0) {
        var i = rowOf(ctx.graph.cycleThrough);
        var _form_target;
        var message = "This would make ".concat(labelOf((_form_target = form.target) !== null && _form_target !== void 0 ? _form_target : "", ctx), " add up to itself through ").concat(labelOf(ctx.graph.cycleThrough, ctx), ".");
        var _errors_rows_i, _errors_members;
        if (i >= 0) errors.rows[i] = (_errors_rows_i = errors.rows[i]) !== null && _errors_rows_i !== void 0 ? _errors_rows_i : message;
        else errors.members = (_errors_members = errors.members) !== null && _errors_members !== void 0 ? _errors_members : message;
    }
    if ((_ctx_graph2 = ctx.graph) === null || _ctx_graph2 === void 0 ? void 0 : _ctx_graph2.doubleCount) {
        var _ctx_graph_doubleCount = ctx.graph.doubleCount, input = _ctx_graph_doubleCount.input, through = _ctx_graph_doubleCount.through;
        var i1 = rowOf(input);
        var message1 = "".concat(labelOf(input, ctx), " is already counted through ").concat(labelOf(through, ctx), ", so it would be counted twice.");
        var _errors_rows_i1, _errors_members1;
        if (i1 >= 0) errors.rows[i1] = (_errors_rows_i1 = errors.rows[i1]) !== null && _errors_rows_i1 !== void 0 ? _errors_rows_i1 : message1;
        else errors.members = (_errors_members1 = errors.members) !== null && _errors_members1 !== void 0 ? _errors_members1 : message1;
    }
    if ((_ctx_graph3 = ctx.graph) === null || _ctx_graph3 === void 0 ? void 0 : _ctx_graph3.containedInput) {
        var _ctx_graph_containedInput = ctx.graph.containedInput, input1 = _ctx_graph_containedInput.input, through1 = _ctx_graph_containedInput.through;
        var i2 = rowOf(input1);
        var message2 = "".concat(labelOf(input1, ctx), " sits inside ").concat(labelOf(through1, ctx), ", which is watched by its own cameras — so it would be counted twice.");
        var _errors_rows_i2, _errors_members2;
        if (i2 >= 0) errors.rows[i2] = (_errors_rows_i2 = errors.rows[i2]) !== null && _errors_rows_i2 !== void 0 ? _errors_rows_i2 : message2;
        else errors.members = (_errors_members2 = errors.members) !== null && _errors_members2 !== void 0 ? _errors_members2 : message2;
    }
    if ((_ctx_graph4 = ctx.graph) === null || _ctx_graph4 === void 0 ? void 0 : _ctx_graph4.undecidedContainment) {
        var _ctx_graph_undecidedContainment = ctx.graph.undecidedContainment, input2 = _ctx_graph_undecidedContainment.input, through2 = _ctx_graph_undecidedContainment.through, because = _ctx_graph_undecidedContainment.because;
        var i3 = rowOf(input2);
        var clause = because === "through-no-outline" ? "".concat(labelOf(through2, ctx), " has no outline on the plan") : because === "through-not-on-plan" ? "".concat(labelOf(through2, ctx), " is not on the plan") : because === "input-no-outline" ? "".concat(labelOf(input2, ctx), " has no outline on the plan") : because === "input-not-on-plan" ? "".concat(labelOf(input2, ctx), " is not on the plan") : "".concat(labelOf(input2, ctx), " has no position on the plan");
        var message3 = "We can't tell whether ".concat(labelOf(input2, ctx), " sits inside ").concat(labelOf(through2, ctx), " — ").concat(clause, ". Fix it on the Floor Plan step, or pick something else.");
        var _errors_rows_i3, _errors_members3;
        if (i3 >= 0) errors.rows[i3] = (_errors_rows_i3 = errors.rows[i3]) !== null && _errors_rows_i3 !== void 0 ? _errors_rows_i3 : message3;
        else errors.members = (_errors_members3 = errors.members) !== null && _errors_members3 !== void 0 ? _errors_members3 : message3;
    }
    return errors;
};
var warnCompositeForm = function(form, ctx) {
    var _ctx_graph, _ctx_graph1, _ctx_graph2;
    var warnings = {
        rows: form.inputs.map(function() {
            return void 0;
        })
    };
    var rowOf = function(value) {
        return form.inputs.indexOf(value);
    };
    var _ctx_graph_unmeasured;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = ((_ctx_graph_unmeasured = (_ctx_graph = ctx.graph) === null || _ctx_graph === void 0 ? void 0 : _ctx_graph.unmeasured) !== null && _ctx_graph_unmeasured !== void 0 ? _ctx_graph_unmeasured : [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var input = _step.value;
            var i = rowOf(input);
            var message = "Adds up ".concat(labelWithCode(input, ctx), ", which has no camera and no total of its own.");
            var _warnings_rows_i, _warnings_members;
            if (i >= 0) warnings.rows[i] = (_warnings_rows_i = warnings.rows[i]) !== null && _warnings_rows_i !== void 0 ? _warnings_rows_i : message;
            else warnings.members = (_warnings_members = warnings.members) !== null && _warnings_members !== void 0 ? _warnings_members : message;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _ctx_graph_unfinishedTotals;
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = ((_ctx_graph_unfinishedTotals = (_ctx_graph1 = ctx.graph) === null || _ctx_graph1 === void 0 ? void 0 : _ctx_graph1.unfinishedTotals) !== null && _ctx_graph_unfinishedTotals !== void 0 ? _ctx_graph_unfinishedTotals : [])[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var input1 = _step1.value;
            var i1 = rowOf(input1);
            var message1 = "Adds up ".concat(labelWithCode(input1, ctx), ", whose own total is not finished.");
            var _warnings_rows_i1, _warnings_members1;
            if (i1 >= 0) warnings.rows[i1] = (_warnings_rows_i1 = warnings.rows[i1]) !== null && _warnings_rows_i1 !== void 0 ? _warnings_rows_i1 : message1;
            else warnings.members = (_warnings_members1 = warnings.members) !== null && _warnings_members1 !== void 0 ? _warnings_members1 : message1;
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    var filledInputs = form.inputs.filter(function(value) {
        return value !== "";
    });
    if (filledInputs.length === 0 && !form.includesOwnObservers) {
        var _warnings_members2;
        warnings.members = (_warnings_members2 = warnings.members) !== null && _warnings_members2 !== void 0 ? _warnings_members2 : EMPTY_TOTAL_WARNING;
    }
    var _ctx_graph_excludedTotals;
    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
    try {
        for(var _iterator2 = ((_ctx_graph_excludedTotals = (_ctx_graph2 = ctx.graph) === null || _ctx_graph2 === void 0 ? void 0 : _ctx_graph2.excludedTotals) !== null && _ctx_graph_excludedTotals !== void 0 ? _ctx_graph_excludedTotals : [])[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var input2 = _step2.value;
            var i2 = rowOf(input2);
            var message2 = "Adds up ".concat(labelWithCode(input2, ctx), ", whose own total is excluded from processing, so it contributes nothing.");
            var _warnings_rows_i2, _warnings_members3;
            if (i2 >= 0) warnings.rows[i2] = (_warnings_rows_i2 = warnings.rows[i2]) !== null && _warnings_rows_i2 !== void 0 ? _warnings_rows_i2 : message2;
            else warnings.members = (_warnings_members3 = warnings.members) !== null && _warnings_members3 !== void 0 ? _warnings_members3 : message2;
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
            }
        } finally{
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }
    return warnings;
};
// src/components/CompositeMeasures/compositeListModel.ts
var _semantic12_status = semantic12.status, roles3 = _semantic12_status.roles;
var COMPOSITE_STATE_ROLE = {
    refused: "problem",
    unfinished: "workToDo",
    review: "workToDo",
    complete: null,
    automatic: "neutral"
};
var COMPOSITE_REASON_LOOK = {
    problem: {
        role: "problem",
        icon: "circle-exclamation"
    },
    warning: {
        role: "workToDo",
        icon: "circle-half-stroke"
    },
    review: {
        role: "workToDo",
        icon: "eye"
    }
};
var reasonLookOf = function(kind) {
    var look = Object.prototype.hasOwnProperty.call(COMPOSITE_REASON_LOOK, kind) ? COMPOSITE_REASON_LOOK[kind] : COMPOSITE_REASON_LOOK.problem;
    var _roles3_look_role_noteTone;
    return _object_spread_props(_object_spread({}, look), {
        noteTone: (_roles3_look_role_noteTone = roles3[look.role].noteTone) !== null && _roles3_look_role_noteTone !== void 0 ? _roles3_look_role_noteTone : "neutral"
    });
};
var tagToneOf = function(role) {
    var _ref;
    return (_ref = role ? roles3[role].tagTone : null) !== null && _ref !== void 0 ? _ref : "neutral";
};
var STATE_RANK = {
    refused: 0,
    unfinished: 1,
    review: 2,
    complete: 3,
    automatic: 4
};
var rowState = function(row) {
    if (row.automatic) return "automatic";
    var _row_problems;
    if (((_row_problems = row.problems) !== null && _row_problems !== void 0 ? _row_problems : []).length > 0) return "refused";
    var _row_warnings;
    if (((_row_warnings = row.warnings) !== null && _row_warnings !== void 0 ? _row_warnings : []).length > 0) return "unfinished";
    var _row_review;
    if (((_row_review = row.review) !== null && _row_review !== void 0 ? _row_review : []).length > 0) return "review";
    return "complete";
};
var byLabel = function(a, b) {
    return a.target.label.localeCompare(b.target.label, void 0, {
        sensitivity: "base"
    });
};
var groupRows = function(rows, held) {
    var placeOf = function(row) {
        return row.refid === (held === null || held === void 0 ? void 0 : held.refid) ? held.state : rowState(row);
    };
    var needsWork = [];
    var setUp = [];
    var automatic = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = rows[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var row = _step.value;
            var state = placeOf(row);
            if (state === "automatic") automatic.push(row);
            else if (state === "complete") setUp.push(row);
            else needsWork.push(row);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    needsWork.sort(function(a, b) {
        return STATE_RANK[placeOf(a)] - STATE_RANK[placeOf(b)] || byLabel(a, b);
    });
    setUp.sort(byLabel);
    automatic.sort(byLabel);
    return {
        needsWork: needsWork,
        setUp: setUp,
        automatic: automatic
    };
};
var plural4 = function(n, one, many) {
    return "".concat(n, " ").concat(n === 1 ? one : many);
};
var summaryLines = function(rows) {
    var counts = {
        refused: 0,
        unfinished: 0,
        "nothing-measured": 0,
        review: 0,
        complete: 0,
        automatic: 0
    };
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = rows[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var row = _step.value;
            var state = rowState(row);
            if (state === "unfinished" && row.excluded === true) continue;
            counts[state === "unfinished" && row.nothingMeasured === true ? "nothing-measured" : state] += 1;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var nothingMeasured = counts["nothing-measured"];
    var n = rows.length;
    var lines = [
        {
            key: "total",
            text: "".concat(plural4(n, "composite measure", "composite measures"), " on this plan"),
            ink: ink16[3],
            weight: 600
        },
        {
            key: "refused",
            text: "".concat(counts.refused, " would be refused when the twin goes live"),
            dot: roles3.problem.mark,
            ink: roles3.problem.ink,
            weight: 500
        },
        {
            key: "unfinished",
            text: "".concat(counts.unfinished, " not finished yet. ").concat(PARTLY_MEASURED_SUMMARY),
            dot: roles3.workToDo.mark,
            ink: roles3.workToDo.ink,
            weight: 500
        },
        {
            key: "nothing-measured",
            text: "".concat(nothingMeasured, " ").concat(nothingMeasured === 1 ? "has" : "have", " nothing measured yet. ").concat(nothingMeasuredNote(nothingMeasured)),
            dot: roles3.workToDo.mark,
            ink: roles3.workToDo.ink,
            weight: 500
        },
        {
            key: "review",
            text: "".concat(plural4(counts.review, "generated total", "generated totals"), " to review"),
            dot: roles3.workToDo.mark,
            ink: ink16[3],
            weight: 400
        },
        {
            key: "complete",
            // Done is unmarked: no dot, and the line keeps its spacer.
            text: "".concat(counts.complete, " complete"),
            ink: ink16[3],
            weight: 400
        },
        {
            key: "automatic",
            text: "".concat(counts.automatic, " maintained automatically from their observers"),
            dot: roles3.neutral.mark,
            ink: ink16[3],
            weight: 400
        }
    ];
    return lines.filter(function(line9) {
        return line9.key === "total" || counts[line9.key] > 0;
    });
};
var dataFor = function(state) {
    switch(state){
        case "own-cameras":
        case "observed":
        case "automatic":
        case "complete":
        case "review":
        case "partial":
            return "has";
        case "refused":
            return "refused";
        case "excluded":
            return "excluded";
        case "gone":
            return "gone";
        case "unfinished":
        case "uncovered":
        default:
            return "none";
    }
};
var sourceName = function(source) {
    return "".concat(source.label, ", ").concat(source.text.charAt(0).toLowerCase()).concat(source.text.slice(1));
};
var LINK_FLASH_MS = 1200;
var KIND_ICON2 = {
    twin: "building",
    floor: "layer-group",
    zone: "object-union",
    equipment: "dumbbell"
};
var STATE_CHIP = {
    refused: {
        text: "Would be refused",
        tone: tagToneOf(COMPOSITE_STATE_ROLE.refused),
        icon: "circle-exclamation"
    },
    unfinished: {
        text: "Not finished",
        tone: tagToneOf(COMPOSITE_STATE_ROLE.unfinished),
        icon: "circle-half-stroke"
    },
    review: {
        text: "Review",
        tone: tagToneOf(COMPOSITE_STATE_ROLE.review),
        icon: "eye"
    },
    complete: {
        text: "Complete",
        tone: tagToneOf(COMPOSITE_STATE_ROLE.complete),
        icon: "check"
    },
    automatic: {
        text: "Automatic",
        tone: tagToneOf(COMPOSITE_STATE_ROLE.automatic),
        icon: "gears"
    }
};
var SUB_LOOK = {
    has: {
        dot: null,
        ink: ink16[3]
    },
    none: {
        dot: roles3.workToDo.mark,
        ink: roles3.workToDo.ink
    },
    refused: {
        dot: roles3.problem.mark,
        ink: roles3.problem.ink
    },
    excluded: {
        dot: roles3.neutral.mark,
        ink: ink16[3]
    },
    gone: {
        dot: roles3.problem.mark,
        ink: roles3.problem.ink
    }
};
var PICKER_GROUP = {
    /** *Total for*: nothing totals it yet — picking it starts a new total. */ new: "No total yet",
    /** *Total for*: only an automatic (or, re-targeting, a generated) total — a pick replaces it. */ replaces: "Automatic \xB7 replaced if you add one",
    /** *Total for*: a written total stands there — a pick opens it. */ opens: "Already totalled \xB7 opens it",
    /** *Add source*: has data to give, by the source chip's own split (`dataFor`). */ has: "Has data",
    /** *Add source*: everything else. */ none: "No data yet"
};
// src/components/CompositeMeasures/CompositeMeasuresPanel.tsx
import { Fragment as Fragment25, jsx as jsx111, jsxs as jsxs77 } from "react/jsx-runtime";
var GROUPS = [
    {
        key: "needsWork",
        title: "Needs work",
        tone: "peri",
        dotTone: "peri"
    },
    {
        key: "setUp",
        title: "Set up"
    },
    {
        key: "automatic",
        title: "Automatic",
        tone: "neutral",
        dotTone: "ink-5",
        hint: "Kept up to date from their observers. Nothing to edit here."
    }
];
var reasonsOf = function(row) {
    var seen = /* @__PURE__ */ new Set();
    var out = [];
    var add2 = function(kind, list) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = (list !== null && list !== void 0 ? list : [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var text = _step.value;
                if (seen.has(text)) continue;
                seen.add(text);
                out.push({
                    kind: kind,
                    text: text
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    add2("problem", row.problems);
    add2("warning", row.warnings);
    add2("review", row.review);
    return out;
};
var CompositeMeasuresPanel = function(param) {
    var className = param.className, composites = param.composites, notice = param.notice, error = param.error, selectedRefid = param.selectedRefid, _param_editingOpen = param.editingOpen, editingOpen = _param_editingOpen === void 0 ? false : _param_editingOpen, sourceAction = param.sourceAction, onAdd = param.onAdd, onEdit = param.onEdit, onDelete = param.onDelete, onAddSource = param.onAddSource, _param_motionEpoch = param.motionEpoch, motionEpoch = _param_motionEpoch === void 0 ? "" : _param_motionEpoch, _param_rowGlow = param.rowGlow, rowGlow = _param_rowGlow === void 0 ? null : _param_rowGlow, _param_jumpRequest = param.jumpRequest, jumpRequest = _param_jumpRequest === void 0 ? null : _param_jumpRequest;
    var _heldRef_current;
    var heldRef = useRef24(null);
    var selectedRow = selectedRefid ? composites.find(function(r) {
        return r.refid === selectedRefid;
    }) : void 0;
    var heldRow = editingOpen ? selectedRow : void 0;
    if (!heldRow) heldRef.current = null;
    else if (((_heldRef_current = heldRef.current) === null || _heldRef_current === void 0 ? void 0 : _heldRef_current.refid) !== heldRow.refid) heldRef.current = {
        refid: heldRow.refid,
        state: rowState(heldRow)
    };
    var held = heldRef.current;
    var groups = useMemo12(function() {
        return groupRows(composites, held !== null && held !== void 0 ? held : void 0);
    }, [
        composites,
        held
    ]);
    var _selectedRow_target_label;
    var editingName = (_selectedRow_target_label = selectedRow === null || selectedRow === void 0 ? void 0 : selectedRow.target.label) !== null && _selectedRow_target_label !== void 0 ? _selectedRow_target_label : "this total";
    var lines = useMemo12(function() {
        return summaryLines(composites);
    }, [
        composites
    ]);
    var groupOf = useMemo12(function() {
        var map = /* @__PURE__ */ new Map();
        Object.keys(groups).forEach(function(key) {
            return groups[key].forEach(function(row) {
                return map.set(row.refid, key);
            });
        });
        return map;
    }, [
        groups
    ]);
    var lastMotionGroups = useRef24(groupOf);
    var motionGroups = useMemo12(function() {
        var prev = lastMotionGroups.current;
        var same = prev.size === groupOf.size;
        groupOf.forEach(function(g, k) {
            if (prev.get(k) !== g) same = false;
        });
        if (!same) lastMotionGroups.current = groupOf;
        return lastMotionGroups.current;
    }, [
        groupOf
    ]);
    var _useState54 = _sliced_to_array(useState54({
        needsWork: true,
        setUp: true,
        automatic: false
    }), 2), open = _useState54[0], setOpen = _useState54[1];
    var _useState541 = _sliced_to_array(useState54(null), 2), previewRefid = _useState541[0], setPreviewRefid = _useState541[1];
    var _useState542 = _sliced_to_array(useState54(null), 2), flash = _useState542[0], setFlash = _useState542[1];
    var _useState543 = _sliced_to_array(useState54(null), 2), pendingJump = _useState543[0], setPendingJump = _useState543[1];
    var _useState544 = _sliced_to_array(useState54(null), 2), focusRow = _useState544[0], setFocusRow = _useState544[1];
    useEffect39(function() {
        return setFocusRow(null);
    }, [
        editingOpen,
        selectedRefid
    ]);
    var bodyRef = useRef24(null);
    var moved = useRowMotion(bodyRef, {
        groups: motionGroups,
        epoch: motionEpoch,
        scrollMargin: 8
    }).moved;
    useKeepFocusAcrossMove(bodyRef);
    var motionText = useRowMotionAnnouncement(moved, function(refid) {
        var _GROUPS_find;
        var row = composites.find(function(r) {
            return r.refid === refid;
        });
        var key = groupOf.get(refid);
        var title = (_GROUPS_find = GROUPS.find(function(g) {
            return g.key === key;
        })) === null || _GROUPS_find === void 0 ? void 0 : _GROUPS_find.title;
        return row && title ? "".concat(row.target.label, " moved to ").concat(title) : null;
    });
    var rowEls = useRef24(/* @__PURE__ */ new Map());
    var rowRef = useCallback17(function(refid) {
        return function(el) {
            if (el) rowEls.current.set(refid, el);
            else rowEls.current.delete(refid);
        };
    }, []);
    var scrollToRow = useCallback17(function(refid) {
        var container = bodyRef.current;
        var el = rowEls.current.get(refid);
        if (!container || !el) return;
        var _layoutBoxWithin;
        scrollWithin(container, el, {
            margin: 8,
            reduced: prefersReducedMotion(),
            box: (_layoutBoxWithin = layoutBoxWithin(container, el)) !== null && _layoutBoxWithin !== void 0 ? _layoutBoxWithin : void 0
        });
    }, []);
    var jumpTo = useCallback17(function(refid) {
        var group = groupOf.get(refid);
        if (!group) return;
        setFlash(function(f) {
            var _f_n;
            return {
                refid: refid,
                n: ((_f_n = f === null || f === void 0 ? void 0 : f.n) !== null && _f_n !== void 0 ? _f_n : 0) + 1
            };
        });
        if (!open[group]) {
            setOpen(function(o) {
                return _object_spread_props(_object_spread({}, o), _define_property({}, group, true));
            });
            setPendingJump(refid);
        } else {
            scrollToRow(refid);
        }
    }, [
        groupOf,
        open,
        scrollToRow
    ]);
    var jumpRequestN = jumpRequest === null || jumpRequest === void 0 ? void 0 : jumpRequest.n;
    useEffect39(function() {
        if (jumpRequest) jumpTo(jumpRequest.refid);
    }, [
        jumpRequestN
    ]);
    useLayoutEffect6(function() {
        if (!focusRow) return;
        if ((sourceAction === null || sourceAction === void 0 ? void 0 : sourceAction.get(focusRow)) === "add") return;
        var el = rowEls.current.get(focusRow);
        var button = el === null || el === void 0 ? void 0 : el.querySelector(".source-state button");
        if (button) {
            if (!(el === null || el === void 0 ? void 0 : el.contains(document.activeElement))) button.focus();
            setFocusRow(null);
            return;
        }
        var group = groupOf.get(focusRow);
        if (group && !open[group]) setOpen(function(o) {
            return _object_spread_props(_object_spread({}, o), _define_property({}, group, true));
        });
        else setFocusRow(null);
    }, [
        composites,
        focusRow,
        groupOf,
        open,
        sourceAction
    ]);
    useLayoutEffect6(function() {
        if (!pendingJump) return;
        scrollToRow(pendingJump);
        setPendingJump(null);
    }, [
        pendingJump,
        scrollToRow
    ]);
    useEffect39(function() {
        if (!flash) return;
        var timer = window.setTimeout(function() {
            return setFlash(null);
        }, LINK_FLASH_MS);
        return function() {
            return window.clearTimeout(timer);
        };
    }, [
        flash
    ]);
    var previewFor = useCallback17(function(refid) {
        return function(active) {
            return setPreviewRefid(function(current) {
                return active ? refid : current === refid ? null : current;
            });
        };
    }, []);
    var renderChip = function(source) {
        var icon = source.state === "own-cameras" ? /* @__PURE__ */ jsx111(Icon9, {
            name: "video"
        }) : source.kind === "equipment" ? /* @__PURE__ */ jsx111(Icon9, {
            name: "dumbbell"
        }) : void 0;
        var target = source.rowRefid;
        var data = dataFor(source.state);
        var dot2 = SUB_LOOK[data].dot;
        return /* @__PURE__ */ jsx111(SourceChip, _object_spread_props(_object_spread(_object_spread_props(_object_spread({}, dot2 ? {
            data: data,
            dotColor: dot2
        } : {}), {
            icon: icon,
            "aria-label": sourceName(source)
        }), target && groupOf.has(target) ? {
            onClick: function() {
                return jumpTo(target);
            },
            onPreview: previewFor(target)
        } : {}), {
            children: source.label
        }), source.key);
    };
    var renderRow = function(row) {
        var state = rowState(row);
        var chip = STATE_CHIP[state];
        var selected = selectedRefid === row.refid;
        var linked = previewRefid === row.refid || (flash === null || flash === void 0 ? void 0 : flash.refid) === row.refid;
        var reasons = reasonsOf(row);
        var name = row.target.label;
        var action = sourceAction === null || sourceAction === void 0 ? void 0 : sourceAction.get(row.refid);
        var glow2 = (rowGlow === null || rowGlow === void 0 ? void 0 : rowGlow.refid) === row.refid ? rowGlow.tone : null;
        var _row_target_meta;
        return /* @__PURE__ */ jsxs77("li", _object_spread_props(_object_spread({
            ref: rowRef(row.refid),
            "data-refid": row.refid
        }, _define_property({}, ROW_MOTION_KEY_ATTR, row.refid)), {
            className: [
                "row",
                state === "automatic" ? "automatic" : "",
                selected ? "selected" : "",
                linked ? "linked" : "",
                // A total just added, one Reset put back, or a row just added as a source (while it
                // reads *Added*) glows in the just-changed mint (spec R6, R7).
                glow2 === "new" ? "glow-new" : "",
                glow2 === "arrived" || action === "added" ? "glow-arrived" : ""
            ].filter(Boolean).join(" "),
            children: [
                /* @__PURE__ */ jsx111("span", {
                    className: "kind",
                    "aria-hidden": "true",
                    children: /* @__PURE__ */ jsx111(Icon9, {
                        name: KIND_ICON2[row.kind],
                        variant: selected ? "solid" : "regular",
                        size: "xs"
                    })
                }),
                /* @__PURE__ */ jsxs77("div", {
                    className: "name-cell",
                    children: [
                        row.automatic ? /* @__PURE__ */ jsx111("span", {
                            className: "name",
                            children: name
                        }) : /* @__PURE__ */ jsxs77("button", {
                            type: "button",
                            className: row.target.unresolved ? "name name-button unresolved" : "name name-button",
                            onClick: function() {
                                return onEdit(row.refid);
                            },
                            children: [
                                name,
                                row.target.unresolved ? /* @__PURE__ */ jsxs77("span", {
                                    className: "gone",
                                    children: [
                                        " ",
                                        (_row_target_meta = row.target.meta) !== null && _row_target_meta !== void 0 ? _row_target_meta : "no longer on the plan"
                                    ]
                                }) : null
                            ]
                        }),
                        /* @__PURE__ */ jsxs77("span", {
                            className: "under",
                            children: [
                                row.code ? /* @__PURE__ */ jsx111("span", {
                                    className: "code",
                                    children: row.code
                                }) : null,
                                row.generated ? /* @__PURE__ */ jsx111(Tag4, {
                                    surface: "on-glass",
                                    tone: "neutral",
                                    size: "dense",
                                    children: "Generated"
                                }) : null,
                                row.excluded ? /* @__PURE__ */ jsx111(Tag4, {
                                    surface: "on-glass",
                                    tone: "neutral",
                                    size: "dense",
                                    children: "Not published"
                                }) : null
                            ]
                        })
                    ]
                }),
                /* @__PURE__ */ jsxs77("div", {
                    className: "adds-up",
                    children: [
                        /* @__PURE__ */ jsx111("div", {
                            className: "chips",
                            children: row.automatic ? /* @__PURE__ */ jsx111(SourceChip, {
                                variant: "automatic",
                                icon: /* @__PURE__ */ jsx111(Icon9, {
                                    name: "video"
                                }),
                                "aria-label": "".concat(plural4(row.automatic.observers, "observer", "observers"), ", automatic"),
                                children: plural4(row.automatic.observers, "observer", "observers")
                            }) : row.sources.map(renderChip)
                        }),
                        reasons.length > 0 ? /* @__PURE__ */ jsx111("div", {
                            className: "reasons",
                            children: reasons.map(function(reason) {
                                var look = reasonLookOf(reason.kind);
                                return /* @__PURE__ */ jsx111(Note2, {
                                    bare: true,
                                    tone: look.noteTone,
                                    icon: /* @__PURE__ */ jsx111(Icon9, {
                                        name: look.icon,
                                        size: "xs"
                                    }),
                                    children: reason.text
                                }, reason.text);
                            })
                        }) : null
                    ]
                }),
                /* @__PURE__ */ jsx111("div", {
                    className: "state",
                    children: /* @__PURE__ */ jsx111(Tag4, {
                        surface: "on-glass",
                        size: "dense",
                        tone: chip.tone,
                        icon: /* @__PURE__ */ jsx111(Icon9, {
                            name: chip.icon,
                            size: "xs"
                        }),
                        children: chip.text
                    })
                }),
                /* @__PURE__ */ jsx111("div", {
                    className: "row-actions",
                    children: row.automatic || editingOpen && !selected ? null : /* @__PURE__ */ jsxs77(Fragment25, {
                        children: [
                            /* @__PURE__ */ jsx111(Button12, {
                                iconOnly: true,
                                "aria-label": "Edit the ".concat(row.generated ? "generated " : "", "total for ").concat(name),
                                variant: "frosted",
                                size: "sm",
                                iconLeft: /* @__PURE__ */ jsx111(Icon9, {
                                    name: "pen"
                                }),
                                onClick: function() {
                                    return onEdit(row.refid);
                                }
                            }),
                            /* @__PURE__ */ jsx111(Button12, {
                                iconOnly: true,
                                "aria-label": row.generated ? "Reset the generated total for ".concat(name) : row.resets ? "Reset the total for ".concat(name) : "Delete the total for ".concat(name),
                                variant: "frosted",
                                size: "sm",
                                iconLeft: /* @__PURE__ */ jsx111(Icon9, {
                                    name: "trash-can"
                                }),
                                onClick: function() {
                                    return onDelete(row.refid);
                                }
                            })
                        ]
                    })
                }),
                action ? /* @__PURE__ */ jsx111("div", {
                    className: action === "add" ? "source-state reveal" : "source-state",
                    children: /* @__PURE__ */ jsx111(Button12, {
                        type: "button",
                        variant: action === "add" ? "frosted" : action === "added" ? "success" : "text",
                        size: "sm",
                        done: action === "in-total",
                        iconLeft: /* @__PURE__ */ jsx111(Icon9, {
                            name: action === "add" ? "plus" : "check"
                        }),
                        "aria-label": action === "add" ? "Add as source: ".concat(name, ", to ").concat(editingName) : action === "added" ? "Added ".concat(name, " to ").concat(editingName) : "In total: ".concat(name),
                        onClick: action === "add" ? function() {
                            if ((onAddSource === null || onAddSource === void 0 ? void 0 : onAddSource(row.refid)) !== false) setFocusRow(row.refid);
                        } : void 0,
                        children: action === "add" ? "Add as source" : action === "added" ? "Added" : "In total"
                    })
                }) : null
            ]
        }), row.refid);
    };
    var empty = composites.length === 0;
    return /* @__PURE__ */ jsxs77("section", {
        className: className,
        "aria-labelledby": "composite-measures-heading",
        children: [
            /* @__PURE__ */ jsx111("h4", {
                id: "composite-measures-heading",
                style: visuallyHidden,
                children: "Composite measures on this plan"
            }),
            /* @__PURE__ */ jsx111("span", {
                role: "status",
                "aria-live": "polite",
                "data-testid": "motion-status",
                style: visuallyHidden,
                children: motionText
            }),
            /* @__PURE__ */ jsxs77(Card5, {
                surface: "on-scene",
                size: "md",
                className: editingOpen ? "list-card editing" : "list-card",
                children: [
                    empty ? null : /* @__PURE__ */ jsxs77("div", {
                        className: "top-strip",
                        children: [
                            /* @__PURE__ */ jsx111("ul", {
                                className: "summary",
                                children: lines.map(function(l) {
                                    return /* @__PURE__ */ jsxs77("li", {
                                        className: "summary-line",
                                        style: {
                                            color: l.ink,
                                            fontWeight: l.weight
                                        },
                                        children: [
                                            /* @__PURE__ */ jsx111("span", {
                                                className: "summary-dot",
                                                "aria-hidden": "true",
                                                children: l.dot ? /* @__PURE__ */ jsx111(Dot, {
                                                    color: l.dot,
                                                    label: l.text,
                                                    labelHidden: true
                                                }) : null
                                            }),
                                            /* @__PURE__ */ jsx111("span", {
                                                className: "summary-text",
                                                children: l.text
                                            })
                                        ]
                                    }, l.key);
                                })
                            }),
                            /* @__PURE__ */ jsx111(Button12, {
                                variant: "primary",
                                size: "inline",
                                iconLeft: /* @__PURE__ */ jsx111(Icon9, {
                                    name: "plus"
                                }),
                                onClick: onAdd,
                                children: "Add composite measure"
                            })
                        ]
                    }),
                    /* @__PURE__ */ jsx111("div", {
                        className: "region",
                        "aria-live": "polite",
                        "aria-atomic": "false",
                        children: notice && /* @__PURE__ */ jsx111(Banner5, {
                            surface: "on-glass",
                            role: "status",
                            tone: "success",
                            title: notice
                        })
                    }),
                    /* @__PURE__ */ jsx111("div", {
                        className: "region",
                        "aria-live": "assertive",
                        "aria-atomic": "false",
                        children: error && /* @__PURE__ */ jsx111(Banner5, {
                            surface: "on-glass",
                            role: "alert",
                            tone: "error",
                            title: error
                        })
                    }),
                    empty ? /* @__PURE__ */ jsxs77("div", {
                        className: "empty",
                        children: [
                            /* @__PURE__ */ jsx111("span", {
                                className: "empty-disc",
                                "aria-hidden": "true",
                                children: /* @__PURE__ */ jsx111(Icon9, {
                                    name: "object-union",
                                    size: "lg"
                                })
                            }),
                            /* @__PURE__ */ jsx111("p", {
                                className: "empty-text",
                                children: "No composite measures yet. Add one to total a zone, a floor or the whole twin."
                            }),
                            /* @__PURE__ */ jsx111(Button12, {
                                variant: "primary",
                                size: "inline",
                                iconLeft: /* @__PURE__ */ jsx111(Icon9, {
                                    name: "plus"
                                }),
                                onClick: onAdd,
                                children: "Add composite measure"
                            })
                        ]
                    }) : /* @__PURE__ */ jsxs77(Fragment25, {
                        children: [
                            /* @__PURE__ */ jsxs77("div", {
                                className: "column-header",
                                "aria-hidden": "true",
                                children: [
                                    /* @__PURE__ */ jsx111("span", {}),
                                    /* @__PURE__ */ jsx111("span", {
                                        className: "col-target",
                                        children: "Total for"
                                    }),
                                    /* @__PURE__ */ jsx111("span", {
                                        children: "Adds up"
                                    }),
                                    /* @__PURE__ */ jsx111("span", {
                                        children: "State"
                                    }),
                                    /* @__PURE__ */ jsx111("span", {})
                                ]
                            }),
                            /* @__PURE__ */ jsx111("div", {
                                className: "list-body",
                                ref: bodyRef,
                                children: GROUPS.filter(function(g) {
                                    return groups[g.key].length > 0;
                                }).map(function(g) {
                                    return /* @__PURE__ */ jsx111(ListGroup_default, {
                                        id: "composite-group-".concat(g.key),
                                        title: g.title,
                                        tone: g.tone,
                                        dotTone: g.dotTone,
                                        count: groups[g.key].length,
                                        hint: g.hint,
                                        open: open[g.key],
                                        onOpenChange: function(next) {
                                            return setOpen(function(o) {
                                                return _object_spread_props(_object_spread({}, o), _define_property({}, g.key, next));
                                            });
                                        },
                                        children: /* @__PURE__ */ jsx111("ul", {
                                            className: "rows",
                                            children: groups[g.key].map(renderRow)
                                        })
                                    }, g.key);
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var GRID2 = "26px minmax(0, 1fr) minmax(0, 1.5fr) 132px 112px";
var GRID_EDITING = "26px minmax(0, 1fr) minmax(0, 1.5fr) 132px 132px";
var CompositeMeasuresPanel_default = styled80(CompositeMeasuresPanel)(_templateObject192(), space19[3], typeScale6.captionCompact.fontSize, typeScale6.captionCompact.lineHeight, space19[3], GRID2, space19[3], space19[2], space19[4], inset3[2], line7[2], ink17[3], typeScale6.caption1.fontSize, typeScale6.caption1.lineHeight, weight7.medium, ink17[1], weight7.semibold, rowMotionGapLook("4px 10px 4px 42px"), GRID2, space19[3], space19[2], radius11.md, listRowLook, radius11.pill, rgba5(surface9[0], 0.75), rgba5(surface9[0], 0.95), ink17[3], typeScale6.body1.fontSize, typeScale6.body1.lineHeight, weight7.medium, ink17[1], weight7.regular, ink17[2], ink17[4], rgba5(surface9[0], 0.6), semantic13.status.roles.problem.ink, typeScale6.caption1.fontSize, weight7.medium, inset3[2], weight7.medium, typeScale6.caption2.fontSize, typeScale6.caption2.lineHeight, fontMono4, ink17[3], inset3[2], space19[1], GRID_EDITING, space19[1], radius11.sm, brand5.cyanPress, focus.tight, space19[4], radius11.pill, rgba5(surface9[0], 0.75), rgba5(surface9[0], 0.95), ink17[3], typeScale6.subtitle2.fontSize, typeScale6.subtitle2.lineHeight, ink17[2]);
// src/components/CompositeMeasures/CompositeMeasureEditor.tsx
import { useLayoutEffect as useLayoutEffect7, useMemo as useMemo13, useRef as useRef25, useState as useState56 } from "react";
import styled83 from "styled-components";
import { Button as Button15, Combobox, DockedCard as DockedCard2, Field as Field2, Icon as Icon12, Note as Note4, Tag as Tag5 } from "@repo/design-system";
import { fontMono as fontMono5, ink as ink19, inset as inset5, motion as motion8, radius as radius13, rgba as rgba8, semantic as semantic15, shadow as shadow8, space as space22, surface as surface11, typeScale as typeScale8, weight as weight9 } from "@repo/design-tokens";
// src/components/CompositeMeasures/MoreOptions.tsx
import { useId as useId7, useState as useState55 } from "react";
import styled81 from "styled-components";
import { Button as Button13, Icon as Icon10, Switch as Switch2 } from "@repo/design-system";
import { line as line8, rgba as rgba6, space as space20 } from "@repo/design-tokens";
import { jsx as jsx112, jsxs as jsxs78 } from "react/jsx-runtime";
var MoreOptions = function(param) {
    var className = param.className, excluded = param.excluded, onExcluded = param.onExcluded;
    var _useState55 = _sliced_to_array(useState55(false), 2), open = _useState55[0], setOpen = _useState55[1];
    var id = useId7();
    return /* @__PURE__ */ jsxs78("div", {
        className: className,
        children: [
            /* @__PURE__ */ jsx112(Button13, {
                type: "button",
                variant: "text",
                size: "sm",
                "aria-expanded": open,
                "aria-controls": id,
                iconLeft: /* @__PURE__ */ jsx112(Icon10, {
                    name: open ? "chevron-down" : "chevron-right",
                    size: "xs"
                }),
                onClick: function() {
                    return setOpen(function(o) {
                        return !o;
                    });
                },
                children: "More options"
            }),
            open ? /* @__PURE__ */ jsx112("div", {
                id: id,
                className: "more-body",
                children: /* @__PURE__ */ jsx112(Switch2, {
                    checked: excluded,
                    onChange: function(e) {
                        return onExcluded(e.target.checked);
                    },
                    description: "Kept on the plan but not published. Totals that add this one up get nothing from it.",
                    children: "Exclude from processing"
                })
            }) : null
        ]
    });
};
var MoreOptions_default = styled81(MoreOptions)(_templateObject193(), space20[2], space20[3], rgba6(line8[2], 0.9));
// src/components/CompositeMeasures/OwnCamerasRow.tsx
import styled82 from "styled-components";
import { Button as Button14, Icon as Icon11, Note as Note3 } from "@repo/design-system";
import { ink as ink18, inset as inset4, radius as radius12, rgba as rgba7, semantic as semantic14, space as space21, surface as surface10, typeScale as typeScale7, weight as weight8 } from "@repo/design-tokens";
import { jsx as jsx113, jsxs as jsxs79 } from "react/jsx-runtime";
var OWN_CAMERAS_REQUIRED_LOOK = {
    wash: semantic14.status.roles.problem.wash,
    edge: semantic14.status.roles.problem.mark,
    ink: semantic14.status.roles.problem.ink,
    noteTone: semantic14.status.roles.problem.noteTone
};
var watchers = function(n) {
    return n === 1 ? "1 observer watches" : "".concat(n, " observers watch");
};
var OwnCamerasRow = function(param) {
    var className = param.className, view = param.view, onChange = param.onChange;
    var state = view.state, watching = view.watching, targetLabel = view.targetLabel, reason = view.reason;
    if (state === "available") {
        return /* @__PURE__ */ jsx113("div", {
            className: "".concat(className !== null && className !== void 0 ? className : "", " own available"),
            children: /* @__PURE__ */ jsx113(Button14, {
                type: "button",
                variant: "ghost",
                size: "inline",
                iconLeft: /* @__PURE__ */ jsx113(Icon11, {
                    name: "plus"
                }),
                onClick: function() {
                    return onChange(true);
                },
                children: "Add its own cameras \xb7 ".concat(watching, " observer")
            })
        });
    }
    if (state === "none") {
        return /* @__PURE__ */ jsxs79("div", {
            className: "".concat(className !== null && className !== void 0 ? className : "", " own none"),
            children: [
                /* @__PURE__ */ jsx113("span", {
                    className: "own-disc",
                    "aria-hidden": "true",
                    children: /* @__PURE__ */ jsx113(Icon11, {
                        name: "video",
                        size: "xs"
                    })
                }),
                /* @__PURE__ */ jsx113("span", {
                    className: "own-sub",
                    children: "No cameras watch ".concat(targetLabel, " directly")
                })
            ]
        });
    }
    var sub2 = state === "required" ? "Not counted \xb7 ".concat(watchers(watching), " ").concat(targetLabel) : watching === 0 ? "No cameras watch ".concat(targetLabel, " directly") : "".concat(watchers(watching), " ").concat(targetLabel);
    return /* @__PURE__ */ jsxs79("div", {
        className: "".concat(className !== null && className !== void 0 ? className : "", " own ").concat(state),
        children: [
            /* @__PURE__ */ jsxs79("div", {
                className: "own-grid",
                children: [
                    /* @__PURE__ */ jsx113("span", {
                        className: "own-disc",
                        "aria-hidden": "true",
                        children: /* @__PURE__ */ jsx113(Icon11, {
                            name: "video",
                            size: "xs"
                        })
                    }),
                    /* @__PURE__ */ jsxs79("span", {
                        className: "own-text",
                        children: [
                            /* @__PURE__ */ jsx113("span", {
                                className: "own-label",
                                children: "Its own cameras"
                            }),
                            /* @__PURE__ */ jsx113("span", {
                                className: "own-sub",
                                children: sub2
                            })
                        ]
                    }),
                    state === "locked" ? /* @__PURE__ */ jsx113("span", {
                        className: "own-lock",
                        "aria-hidden": "true",
                        children: /* @__PURE__ */ jsx113(Icon11, {
                            name: "lock",
                            size: "xs"
                        })
                    }) : state === "required" ? /* @__PURE__ */ jsx113(Button14, {
                        type: "button",
                        variant: "frosted",
                        size: "sm",
                        iconLeft: /* @__PURE__ */ jsx113(Icon11, {
                            name: "plus"
                        }),
                        "aria-label": "Add: count ".concat(targetLabel, "’s own cameras"),
                        onClick: function() {
                            return onChange(true);
                        },
                        children: "Add"
                    }) : /* @__PURE__ */ jsx113(Button14, {
                        type: "button",
                        iconOnly: true,
                        circle: true,
                        size: "xs",
                        variant: "frosted",
                        "aria-label": "Stop counting ".concat(targetLabel, "’s own cameras"),
                        iconLeft: /* @__PURE__ */ jsx113(Icon11, {
                            name: "xmark",
                            variant: "solid"
                        }),
                        onClick: function() {
                            return onChange(false);
                        }
                    })
                ]
            }),
            state === "locked" && reason ? /* @__PURE__ */ jsx113("p", {
                className: "own-reason",
                children: reason
            }) : null,
            state === "required" && reason ? /* @__PURE__ */ jsx113("div", {
                className: "own-note",
                children: /* @__PURE__ */ jsx113(Note3, {
                    tone: OWN_CAMERAS_REQUIRED_LOOK.noteTone,
                    icon: /* @__PURE__ */ jsx113(Icon11, {
                        name: "circle-exclamation",
                        size: "xs"
                    }),
                    children: reason
                })
            }) : null
        ]
    });
};
var OwnCamerasRow_default = styled82(OwnCamerasRow)(_templateObject194(), radius12.md, rgba7(surface10[0], 0.62), rgba7(surface10[0], 0.95), OWN_CAMERAS_REQUIRED_LOOK.wash, OWN_CAMERAS_REQUIRED_LOOK.edge, OWN_CAMERAS_REQUIRED_LOOK.ink, inset4[3], rgba7(ink18[1], 0.16), space21[1], space21[2], space21[2], space21[2], space21[2], inset4[3], ink18[4], rgba7(ink18[1], 0.16), inset4[3], space21[2], space21[2], space21[2], inset4[3], radius12.pill, rgba7(surface10[0], 0.8), ink18[3], typeScale7.body1.fontSize, typeScale7.body1.lineHeight, weight8.medium, ink18[1], typeScale7.caption2.fontSize, typeScale7.caption2.lineHeight, weight8.medium, ink18[3], ink18[4], ink18[3], space21[1], space21[3], space21[2], typeScale7.caption1.fontSize, typeScale7.caption1.lineHeight, weight8.regular, ink18[2], space21[3], space21[2]);
// src/components/CompositeMeasures/CompositeMeasureEditor.tsx
import { jsx as jsx114, jsxs as jsxs80 } from "react/jsx-runtime";
var SECONDARY_LABEL = {
    revert: "Revert",
    cancel: "Cancel",
    discard: "Discard"
};
var NoteStack = function(param) {
    var notes = param.notes, className = param.className;
    return notes.length === 0 ? null : /* @__PURE__ */ jsx114("div", {
        className: className ? "notes ".concat(className) : "notes",
        children: notes.map(function(note) {
            var look = reasonLookOf(note.kind);
            return /* @__PURE__ */ jsx114(Note4, {
                tone: look.noteTone,
                icon: /* @__PURE__ */ jsx114(Icon12, {
                    name: look.icon,
                    size: "xs"
                }),
                children: note.text
            }, note.text);
        })
    });
};
var toOption = function(c) {
    var look = SUB_LOOK[c.state];
    return {
        value: c.value,
        label: c.label,
        meta: c.code,
        group: c.group,
        disabled: c.disabled,
        icon: /* @__PURE__ */ jsx114(Icon12, {
            name: KIND_ICON2[c.kind],
            size: "xs"
        }),
        trailing: /* @__PURE__ */ jsxs80("span", {
            className: "picker-state",
            style: {
                color: look.ink
            },
            children: [
                look.dot ? /* @__PURE__ */ jsx114("span", {
                    className: "sub-dot",
                    style: {
                        background: look.dot
                    },
                    "aria-hidden": "true"
                }) : null,
                c.text
            ]
        }),
        trailingText: c.text
    };
};
var nameOrCode = function(option, query) {
    var q = query.toLowerCase();
    var _option_meta;
    return option.label.toLowerCase().includes(q) || ((_option_meta = option.meta) !== null && _option_meta !== void 0 ? _option_meta : "").toLowerCase().includes(q);
};
var nameOrCodeExact = function(option, query) {
    var q = query.toLowerCase();
    var _option_meta;
    return option.label.toLowerCase() === q || ((_option_meta = option.meta) !== null && _option_meta !== void 0 ? _option_meta : "").toLowerCase() === q;
};
var SourcePicker = function(param) {
    var options = param.options, onPick = param.onPick;
    var wrap = useRef25(null);
    useLayoutEffect7(function() {
        var _wrap_current_querySelector, _wrap_current;
        (_wrap_current = wrap.current) === null || _wrap_current === void 0 ? void 0 : (_wrap_current_querySelector = _wrap_current.querySelector("input")) === null || _wrap_current_querySelector === void 0 ? void 0 : _wrap_current_querySelector.focus();
    }, []);
    return /* @__PURE__ */ jsx114("div", {
        ref: wrap,
        children: /* @__PURE__ */ jsx114(Field2, {
            label: "Add a source",
            children: function(wiring) {
                return /* @__PURE__ */ jsx114(Combobox, _object_spread_props(_object_spread({}, wiring), {
                    onGlass: true,
                    variant: "rich",
                    options: options,
                    filter: nameOrCode,
                    isExactMatch: nameOrCodeExact,
                    commitOnClose: false,
                    onChange: function(value) {
                        if (value) onPick(value);
                    },
                    emptyText: "Nothing on this plan matches",
                    maxResults: Infinity
                }));
            }
        })
    });
};
var CompositeMeasureEditor = function(param) {
    var className = param.className, mode = param.mode, sessionKey = param.sessionKey, title = param.title, sub2 = param.sub, state = param.state, generatedNote = param.generatedNote, target = param.target, targetNotes = param.targetNotes, sources = param.sources, prefilled = param.prefilled, sourceOptions = param.sourceOptions, ownCameras = param.ownCameras, totalNotes = param.totalNotes, emptyNote = param.emptyNote, excluded = param.excluded, footer = param.footer, focusOnOpen = param.focusOnOpen, returnFocusTo = param.returnFocusTo, onPickTarget = param.onPickTarget, onRemoveSource = param.onRemoveSource, onAddSource = param.onAddSource, onOwnCameras = param.onOwnCameras, onExcluded = param.onExcluded, onSecondary = param.onSecondary, onDestructive = param.onDestructive, onDone = param.onDone;
    var regionRef = useRef25(null);
    var addSourceRef = useRef25(null);
    var _useState56 = _sliced_to_array(useState56(false), 2), picking = _useState56[0], setPicking = _useState56[1];
    var targetOptions = useMemo13(function() {
        return target.options.map(toOption);
    }, [
        target.options
    ]);
    var sourcePickerOptions = useMemo13(function() {
        return sourceOptions.map(toOption);
    }, [
        sourceOptions
    ]);
    var _useState561 = _sliced_to_array(useState56(null), 2), removed = _useState561[0], setRemoved = _useState561[1];
    var _useState562 = _sliced_to_array(useState56(null), 2), pendingFocus = _useState562[0], setPendingFocus = _useState562[1];
    useLayoutEffect7(function() {
        setPicking(false);
        setRemoved(null);
        setPendingFocus(null);
        var region = regionRef.current;
        if (!region || focusOnOpen === "none") return;
        if (focusOnOpen === "target") {
            var _region_querySelector;
            (_region_querySelector = region.querySelector(".target-field input")) === null || _region_querySelector === void 0 ? void 0 : _region_querySelector.focus();
        } else {
            region.focus();
        }
    }, [
        sessionKey
    ]);
    useLayoutEffect7(function() {
        var _regionRef_current, _this;
        if (removed === null) return;
        if (sources.some(function(s) {
            return s.key === removed.key;
        })) {
            if (sources !== removed.before) setRemoved(null);
            return;
        }
        var _regionRef_current_querySelectorAll;
        var removes = Array.from((_regionRef_current_querySelectorAll = (_regionRef_current = regionRef.current) === null || _regionRef_current === void 0 ? void 0 : _regionRef_current.querySelectorAll(".source-remove")) !== null && _regionRef_current_querySelectorAll !== void 0 ? _regionRef_current_querySelectorAll : []);
        var _removes_removed_at, _ref;
        (_this = (_ref = (_removes_removed_at = removes[removed.at]) !== null && _removes_removed_at !== void 0 ? _removes_removed_at : removes[removed.at - 1]) !== null && _ref !== void 0 ? _ref : addSourceRef.current) === null || _this === void 0 ? void 0 : _this.focus();
        setRemoved(null);
    }, [
        removed,
        sources
    ]);
    useLayoutEffect7(function() {
        if (pendingFocus === null) return;
        var region = regionRef.current;
        if (pendingFocus.kind === "added") {
            var _this;
            if (sources === pendingFocus.before) return;
            var _region_querySelectorAll;
            var removes = Array.from((_region_querySelectorAll = region === null || region === void 0 ? void 0 : region.querySelectorAll(".source-remove")) !== null && _region_querySelectorAll !== void 0 ? _region_querySelectorAll : []);
            var grew = sources.length > pendingFocus.before.length;
            (_this = grew ? removes[removes.length - 1] : addSourceRef.current) === null || _this === void 0 ? void 0 : _this.focus();
        } else {
            var _this1;
            if ((ownCameras === null || ownCameras === void 0 ? void 0 : ownCameras.state) === pendingFocus.ownBefore) {
                if (sources !== pendingFocus.before) setPendingFocus(null);
                return;
            }
            var _region_querySelector;
            (_this1 = (_region_querySelector = region === null || region === void 0 ? void 0 : region.querySelector(".own button")) !== null && _region_querySelector !== void 0 ? _region_querySelector : addSourceRef.current) === null || _this1 === void 0 ? void 0 : _this1.focus();
        }
        setPendingFocus(null);
    }, [
        ownCameras === null || ownCameras === void 0 ? void 0 : ownCameras.state,
        pendingFocus,
        sources
    ]);
    var hasTarget = target.value !== null;
    var chip = state ? STATE_CHIP[state] : void 0;
    var ownCounted = (ownCameras === null || ownCameras === void 0 ? void 0 : ownCameras.state) === "locked" || (ownCameras === null || ownCameras === void 0 ? void 0 : ownCameras.state) === "removable";
    var count = sources.length + (ownCounted ? 1 : 0);
    return /* @__PURE__ */ jsx114(DockedCard2, {
        ref: regionRef,
        className: className,
        placement: "beside",
        tabIndex: -1,
        tone: "butter",
        icon: /* @__PURE__ */ jsx114(Icon12, {
            name: mode === "edit" ? "pen" : "plus"
        }),
        title: title,
        headingLevel: 3,
        sub: sub2,
        state: chip ? /* @__PURE__ */ jsx114(Tag5, {
            surface: "on-glass",
            size: "dense",
            tone: chip.tone,
            icon: /* @__PURE__ */ jsx114(Icon12, {
                name: chip.icon,
                size: "xs"
            }),
            children: chip.text
        }) : void 0,
        onClose: onDone,
        closeLabel: "Close the editor",
        returnFocusTo: returnFocusTo,
        footer: /* @__PURE__ */ jsxs80("div", {
            className: "footer",
            children: [
                footer.destructive ? /* @__PURE__ */ jsx114(Button15, {
                    type: "button",
                    variant: "text",
                    tone: "destructive",
                    iconLeft: /* @__PURE__ */ jsx114(Icon12, {
                        name: footer.destructive === "reset" ? "rotate-left" : "trash-can"
                    }),
                    onClick: onDestructive,
                    children: footer.destructive === "reset" ? "Reset Total" : "Delete Total"
                }) : null,
                /* @__PURE__ */ jsx114("span", {
                    className: "footer-gap"
                }),
                /* @__PURE__ */ jsx114(Button15, {
                    type: "button",
                    variant: "text",
                    onClick: onSecondary,
                    disabled: footer.secondary === "revert" && !footer.revertEnabled,
                    children: SECONDARY_LABEL[footer.secondary]
                }),
                /* @__PURE__ */ jsx114(Button15, {
                    type: "button",
                    variant: "primary",
                    size: "inline",
                    onClick: onDone,
                    children: "Done"
                })
            ]
        }),
        children: /* @__PURE__ */ jsxs80("div", {
            className: prefersReducedMotion() ? "body reduced" : "body",
            children: [
                generatedNote ? /* @__PURE__ */ jsx114(Note4, {
                    tone: semantic15.status.roles.information.noteTone,
                    icon: /* @__PURE__ */ jsx114(Icon12, {
                        name: "wand-magic-sparkles",
                        size: "xs"
                    }),
                    children: "This total was generated from the plan. Your first change makes it hand-made; opening it without changing anything keeps it generated."
                }) : null,
                /* @__PURE__ */ jsxs80("div", {
                    className: "target-field",
                    children: [
                        /* @__PURE__ */ jsx114(Field2, {
                            label: "Total for",
                            children: function(wiring) {
                                var _target_value;
                                return /* @__PURE__ */ jsx114(Combobox, _object_spread_props(_object_spread({}, wiring), {
                                    onGlass: true,
                                    variant: "rich",
                                    size: "lg",
                                    showCode: true,
                                    options: targetOptions,
                                    filter: nameOrCode,
                                    isExactMatch: nameOrCodeExact,
                                    commitOnClose: false,
                                    value: (_target_value = target.value) !== null && _target_value !== void 0 ? _target_value : void 0,
                                    onChange: function(value) {
                                        if (value) onPickTarget(value);
                                    },
                                    placeholder: "Search zones, floors and the whole twin",
                                    emptyText: "Nothing on this plan matches",
                                    maxResults: Infinity
                                }));
                            }
                        }),
                        /* @__PURE__ */ jsx114(NoteStack, {
                            notes: targetNotes
                        })
                    ]
                }),
                hasTarget ? /* @__PURE__ */ jsxs80("div", {
                    className: "adds-up",
                    children: [
                        /* @__PURE__ */ jsxs80("div", {
                            className: "adds-up-head",
                            children: [
                                /* @__PURE__ */ jsx114("h4", {
                                    className: "adds-up-label",
                                    children: "Adds up"
                                }),
                                /* @__PURE__ */ jsx114("span", {
                                    className: "adds-up-count",
                                    children: count
                                }),
                                prefilled && sources.length > 0 ? /* @__PURE__ */ jsx114("span", {
                                    className: "adds-up-hint",
                                    children: "Filled in from its child spaces"
                                }) : null
                            ]
                        }),
                        emptyNote && sources.length === 0 ? /* @__PURE__ */ jsx114("p", {
                            className: "empty-box",
                            children: emptyNote
                        }) : null,
                        sources.length > 0 ? /* @__PURE__ */ jsx114("ul", {
                            className: "cards",
                            children: sources.map(function(source, i) {
                                var look = SUB_LOOK[dataFor(source.state)];
                                return /* @__PURE__ */ jsxs80("li", {
                                    className: source.arriving ? "card arriving" : "card",
                                    "data-source-key": source.key,
                                    children: [
                                        /* @__PURE__ */ jsxs80("div", {
                                            className: "card-grid",
                                            children: [
                                                /* @__PURE__ */ jsx114("span", {
                                                    className: "disc",
                                                    "aria-hidden": "true",
                                                    children: /* @__PURE__ */ jsx114(Icon12, {
                                                        name: KIND_ICON2[source.kind],
                                                        size: "xs"
                                                    })
                                                }),
                                                /* @__PURE__ */ jsxs80("span", {
                                                    className: "card-text",
                                                    children: [
                                                        /* @__PURE__ */ jsx114("span", {
                                                            className: "card-name",
                                                            children: source.label
                                                        }),
                                                        /* @__PURE__ */ jsxs80("span", {
                                                            className: "card-sub",
                                                            style: {
                                                                color: look.ink
                                                            },
                                                            children: [
                                                                look.dot ? /* @__PURE__ */ jsx114("span", {
                                                                    className: "sub-dot",
                                                                    style: {
                                                                        background: look.dot
                                                                    },
                                                                    "aria-hidden": "true"
                                                                }) : null,
                                                                source.text
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                source.code ? /* @__PURE__ */ jsx114(Tag5, {
                                                    surface: "on-glass",
                                                    tone: "code",
                                                    children: source.code
                                                }) : /* @__PURE__ */ jsx114("span", {}),
                                                /* @__PURE__ */ jsx114(Button15, {
                                                    type: "button",
                                                    iconOnly: true,
                                                    circle: true,
                                                    size: "xs",
                                                    variant: "frosted",
                                                    className: "source-remove",
                                                    "aria-label": "Remove ".concat(source.label, " from this total"),
                                                    iconLeft: /* @__PURE__ */ jsx114(Icon12, {
                                                        name: "xmark",
                                                        variant: "solid"
                                                    }),
                                                    onClick: function() {
                                                        setRemoved({
                                                            at: i,
                                                            key: source.key,
                                                            before: sources
                                                        });
                                                        onRemoveSource(source.key);
                                                    }
                                                })
                                            ]
                                        }),
                                        /* @__PURE__ */ jsx114(NoteStack, {
                                            notes: source.notes,
                                            className: "card-notes"
                                        })
                                    ]
                                }, source.key);
                            })
                        }) : null,
                        ownCameras ? /* @__PURE__ */ jsx114(OwnCamerasRow_default, {
                            view: ownCameras,
                            onChange: function(on) {
                                setPendingFocus({
                                    kind: "own",
                                    before: sources,
                                    ownBefore: ownCameras.state
                                });
                                onOwnCameras(on);
                            }
                        }) : null,
                        /* @__PURE__ */ jsxs80("div", {
                            className: "add-source",
                            children: [
                                /* @__PURE__ */ jsx114(Button15, {
                                    ref: addSourceRef,
                                    type: "button",
                                    variant: "ghost",
                                    size: "inline",
                                    iconLeft: /* @__PURE__ */ jsx114(Icon12, {
                                        name: "plus"
                                    }),
                                    "aria-expanded": picking,
                                    onClick: function() {
                                        return setPicking(function(p) {
                                            return !p;
                                        });
                                    },
                                    children: "Add source"
                                }),
                                /* @__PURE__ */ jsx114("p", {
                                    className: "add-source-help",
                                    children: "Or use Add on any row in the list."
                                }),
                                picking ? /* @__PURE__ */ jsx114("div", {
                                    className: "source-picker",
                                    onKeyDown: function(e) {
                                        if (e.key === "Escape") {
                                            var _addSourceRef_current;
                                            e.preventDefault();
                                            setPicking(false);
                                            (_addSourceRef_current = addSourceRef.current) === null || _addSourceRef_current === void 0 ? void 0 : _addSourceRef_current.focus();
                                        }
                                    },
                                    children: /* @__PURE__ */ jsx114(SourcePicker, {
                                        options: sourcePickerOptions,
                                        onPick: function(value) {
                                            setPicking(false);
                                            setPendingFocus({
                                                kind: "added",
                                                before: sources
                                            });
                                            onAddSource(value);
                                        }
                                    })
                                }) : null
                            ]
                        }),
                        /* @__PURE__ */ jsx114(NoteStack, {
                            notes: totalNotes
                        })
                    ]
                }) : null,
                hasTarget ? /* @__PURE__ */ jsx114(MoreOptions_default, {
                    excluded: excluded,
                    onExcluded: onExcluded
                }, sessionKey) : null
            ]
        })
    });
};
var CompositeMeasureEditor_default = styled83(CompositeMeasureEditor)(_templateObject195(), space22[2], space22[4], space22[1], space22[2], space22[2], typeScale8.caption1.fontSize, typeScale8.caption1.lineHeight, weight9.semibold, ink19[2], weight9.regular, typeScale8.caption2.fontSize, typeScale8.caption2.lineHeight, fontMono5, ink19[4], typeScale8.caption2.fontSize, typeScale8.caption2.lineHeight, ink19[4], inset5[5], space22[4], rgba8(ink19[1], 0.18), radius13.md, ink19[3], typeScale8.body1.fontSize, typeScale8.body1.lineHeight, space22[2], radius13.md, rgba8(surface11[0], 0.62), rgba8(surface11[0], 0.9), shadow8.inkGlassRgb, motion8.durFast, motion8.easeUi, linkedRing, inset5[3], space22[2], space22[2], space22[2], inset5[3], radius13.pill, rgba8(surface11[0], 0.8), ink19[3], typeScale8.body1.fontSize, typeScale8.body1.lineHeight, weight9.medium, ink19[1], space22[1], typeScale8.caption2.fontSize, typeScale8.caption2.lineHeight, weight9.medium, inset5[2], radius13.pill, space22[3], space22[2], space22[1], typeScale8.caption1.fontSize, typeScale8.caption1.lineHeight, ink19[3]);
// src/components/StatusBadge/StatusBadge.tsx
import styled84 from "styled-components";
import { jsx as jsx115 } from "react/jsx-runtime";
var VARIANT_STYLES = {
    success: {
        bg: "#d4edda",
        color: "#155724"
    },
    danger: {
        bg: "#f8d7da",
        color: "#721c24"
    },
    warning: {
        bg: "#fff3cd",
        color: "#856404"
    },
    neutral: {
        bg: "#e9ecef",
        color: "#495057"
    }
};
var Badge = styled84.span(_templateObject196(), function(param) {
    var $variant = param.$variant;
    return VARIANT_STYLES[$variant].bg;
}, function(param) {
    var $variant = param.$variant;
    return VARIANT_STYLES[$variant].color;
});
var StatusBadge = function(param) {
    var className = param.className, label = param.label, variant = param.variant;
    return /* @__PURE__ */ jsx115(Badge, {
        className: className,
        $variant: variant,
        children: label
    });
};
var StatusBadge_default = StatusBadge;
// src/components/ValidationPipeline/ValidationPipeline.tsx
import styled85, { css as css4, keyframes as keyframes3 } from "styled-components";
import { jsx as jsx116, jsxs as jsxs81 } from "react/jsx-runtime";
var pulse = keyframes3(_templateObject197());
var COLORS = {
    done: "var(--tl-cyan, #00bbcc)",
    failed: "var(--tl-error, #f15d5d)",
    active: "var(--tl-warn, #d29200)",
    pending: "var(--tl-line-1, #d9dee8)"
};
var STATE_WORD = {
    done: "complete",
    failed: "failed",
    active: "in progress",
    pending: "not started"
};
var Root3 = styled85.div(_templateObject198(), function(param) {
    var $compact = param.$compact;
    return $compact ? "center" : "flex-start";
}, function(param) {
    var $compact = param.$compact;
    return $compact ? "0.3rem" : "0";
});
var StepItem = styled85.div(_templateObject200(), function(param) {
    var $compact = param.$compact, $isLast = param.$isLast;
    return !$compact && css4(_templateObject199(), $isLast ? "0 0 auto" : "1 1 0");
});
var DotRow = styled85.div(_templateObject202(), function(param) {
    var $compact = param.$compact;
    return !$compact && css4(_templateObject201());
});
var Dot2 = styled85.span(_templateObject204(), function(param) {
    var $compact = param.$compact;
    return $compact ? "0.5rem" : "0.75rem";
}, function(param) {
    var $compact = param.$compact;
    return $compact ? "0.5rem" : "0.75rem";
}, function(param) {
    var $state = param.$state;
    return $state === "pending" ? "transparent" : COLORS[$state];
}, function(param) {
    var $state = param.$state;
    return $state === "pending" ? "1px solid ".concat(COLORS.pending) : "1px solid transparent";
}, function(param) {
    var $state = param.$state;
    return $state === "active" && css4(_templateObject203(), pulse);
});
var Connector = styled85.span(_templateObject205(), function(param) {
    var $done = param.$done;
    return $done ? COLORS.done : COLORS.pending;
});
var StepLabel = styled85.span(_templateObject206(), function(param) {
    var $failed = param.$failed, $active = param.$active;
    return $failed ? "var(--tl-error-strong, #c50f1f)" : $active ? "var(--tl-ink-2, #565c66)" : "var(--tl-ink-4, #7f8691)";
}, function(param) {
    var $failed = param.$failed;
    return $failed ? "var(--tl-fw-semibold, 600)" : "inherit";
});
var VisuallyHidden = styled85.span(_templateObject207());
var ValidationPipeline = function(param) {
    var steps = param.steps, compact = param.compact, className = param.className, ariaLabel = param["aria-label"];
    if (compact) {
        return /* @__PURE__ */ jsx116(Root3, {
            className: className,
            $compact: true,
            role: "img",
            "aria-label": ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : "Validation pipeline",
            children: steps.map(function(step) {
                return /* @__PURE__ */ jsx116(Dot2, {
                    "aria-hidden": "true",
                    $state: step.state,
                    $compact: true
                }, step.label);
            })
        });
    }
    return /* @__PURE__ */ jsx116(Root3, {
        as: "ol",
        className: className,
        "aria-label": ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : "Validation pipeline",
        children: steps.map(function(step, i) {
            var isLast = i === steps.length - 1;
            var leftDone = i > 0 && steps[i - 1].state === "done";
            var rightDone = step.state === "done";
            return /* @__PURE__ */ jsxs81(StepItem, {
                as: "li",
                $isLast: isLast,
                children: [
                    /* @__PURE__ */ jsxs81(DotRow, {
                        "aria-hidden": "true",
                        children: [
                            i > 0 && /* @__PURE__ */ jsx116(Connector, {
                                $done: leftDone
                            }),
                            /* @__PURE__ */ jsx116(Dot2, {
                                $state: step.state
                            }),
                            !isLast && /* @__PURE__ */ jsx116(Connector, {
                                $done: rightDone
                            })
                        ]
                    }),
                    /* @__PURE__ */ jsxs81(StepLabel, {
                        $active: step.state === "active",
                        $failed: step.state === "failed",
                        children: [
                            step.label,
                            /* @__PURE__ */ jsxs81(VisuallyHidden, {
                                children: [
                                    ": ",
                                    STATE_WORD[step.state]
                                ]
                            })
                        ]
                    })
                ]
            }, step.label);
        })
    });
};
var ValidationPipeline_default = ValidationPipeline;
// src/components/TableActions/TableActions.tsx
import styled86 from "styled-components";
import { jsx as jsx117 } from "react/jsx-runtime";
var ActionsRow = styled86.div(_templateObject208());
var ActionBtn = styled86.button(_templateObject209());
var TableActions = function(param) {
    var className = param.className, actions = param.actions;
    return /* @__PURE__ */ jsx117(ActionsRow, {
        className: className,
        children: actions.map(function(action, i) {
            return /* @__PURE__ */ jsx117(ActionBtn, {
                onClick: function(e) {
                    e.stopPropagation();
                    action.onClick();
                },
                title: action.title,
                children: action.icon
            }, i);
        })
    });
};
var TableActions_default = TableActions;
// src/components/TableActionsMenu/TableActionsMenu.tsx
import { useState as useState57 } from "react";
import styled87 from "styled-components";
import { MoreHorizontal20Regular } from "@fluentui/react-icons";
import { jsx as jsx118, jsxs as jsxs82 } from "react/jsx-runtime";
var Wrapper3 = styled87.div(_templateObject210());
var TriggerButton = styled87.button(_templateObject211());
var DropdownMenu = styled87.div(_templateObject212());
var MenuItem = styled87.button(_templateObject213(), function(param) {
    var $danger = param.$danger;
    return $danger ? "#dc2626" : "#374151";
}, function(param) {
    var $danger = param.$danger;
    return $danger ? "rgba(254, 242, 242, 0.6)" : "rgba(255, 255, 255, 0.4)";
});
var TableActionsMenu = function(param) {
    var className = param.className, actions = param.actions;
    var _useState57 = _sliced_to_array(useState57(false), 2), isOpen = _useState57[0], setIsOpen = _useState57[1];
    var ref3 = useClickOutside(function() {
        return setIsOpen(false);
    });
    return /* @__PURE__ */ jsxs82(Wrapper3, {
        className: className,
        ref: ref3,
        children: [
            /* @__PURE__ */ jsx118(TriggerButton, {
                onClick: function(e) {
                    e.stopPropagation();
                    setIsOpen(function(prev) {
                        return !prev;
                    });
                },
                title: "More actions",
                children: /* @__PURE__ */ jsx118(MoreHorizontal20Regular, {})
            }),
            isOpen && /* @__PURE__ */ jsx118(DropdownMenu, {
                children: actions.map(function(action, i) {
                    return /* @__PURE__ */ jsx118(MenuItem, {
                        $danger: action.variant === "danger",
                        onMouseDown: function(e) {
                            e.stopPropagation();
                            e.preventDefault();
                            setIsOpen(false);
                            action.onClick(e);
                        },
                        children: action.label
                    }, i);
                })
            })
        ]
    });
};
var TableActionsMenu_default = TableActionsMenu;
// src/hooks/useTableSort.ts
import { useState as useState58, useCallback as useCallback18 } from "react";
var useTableSort = function(param) {
    var defaultField = param.defaultField, _param_defaultDirection = param.defaultDirection, defaultDirection = _param_defaultDirection === void 0 ? "asc" : _param_defaultDirection, fieldDefaults = param.fieldDefaults;
    var _useState58 = _sliced_to_array(useState58(defaultField), 2), sortField = _useState58[0], setSortField = _useState58[1];
    var _useState581 = _sliced_to_array(useState58(defaultDirection), 2), sortDirection = _useState581[0], setSortDirection = _useState581[1];
    var handleSort = useCallback18(function(field) {
        if (sortField === field) {
            setSortDirection(function(prev) {
                return prev === "asc" ? "desc" : "asc";
            });
        } else {
            setSortField(field);
            var _fieldDefaults_field;
            setSortDirection((_fieldDefaults_field = fieldDefaults === null || fieldDefaults === void 0 ? void 0 : fieldDefaults[field]) !== null && _fieldDefaults_field !== void 0 ? _fieldDefaults_field : "asc");
        }
    }, [
        sortField,
        fieldDefaults
    ]);
    var sortData = useCallback18(function(data, accessor) {
        if (!sortField || !data.length) return data;
        return _to_consumable_array(data).sort(function(a, b) {
            var aValue = accessor(a, sortField);
            var bValue = accessor(b, sortField);
            if (aValue == null && bValue == null) return 0;
            if (aValue == null) return sortDirection === "asc" ? 1 : -1;
            if (bValue == null) return sortDirection === "asc" ? -1 : 1;
            var comparison;
            if (_instanceof(aValue, Date) && _instanceof(bValue, Date)) {
                comparison = aValue.getTime() - bValue.getTime();
            } else if (typeof aValue === "string" && typeof bValue === "string") {
                comparison = aValue.toLowerCase().localeCompare(bValue.toLowerCase());
            } else {
                comparison = Number(aValue) - Number(bValue);
            }
            return sortDirection === "asc" ? comparison : -comparison;
        });
    }, [
        sortField,
        sortDirection
    ]);
    return {
        sortField: sortField,
        sortDirection: sortDirection,
        handleSort: handleSort,
        sortData: sortData
    };
};
// src/hooks/useHeroIndicator.tsx
import { useMemo as useMemo15 } from "react";
import { useDataContext, useFilterContext as useFilterContext3, useModeContext as useModeContext4, useEventContext } from "@repo/front-end-state";
import { dataModeFor, entityKeyFor, getDataValue, modeConfigFor } from "@repo/front-end-utils";
import { getIndicator } from "@repo/front-end-utils";
var useHeroIndicator = function(entity) {
    var heroMetric = useFilterContext3().heroMetric;
    var appMode = useModeContext4().appMode;
    var data = useDataContext().data;
    var selectedEntityIds = useEventContext().selectedEntityIds;
    var presentation = useMemo15(function() {
        return modeConfigFor(heroMetric, appMode);
    }, [
        appMode,
        heroMetric
    ]);
    var id = entity[entityKeyFor(appMode)];
    var isSelected2 = selectedEntityIds.has(entity.id);
    var metricData = [];
    var indicatorData = [];
    if (data.processed && heroMetric) {
        metricData = data.processed ? data.processed[heroMetric.valueMetricName] : [];
        indicatorData = data.processed ? data.processed[heroMetric.indicatorMetricName] : [];
    }
    var metricValue = getDataValue(dataModeFor(appMode), metricData, id);
    var indicatorValue = getDataValue(dataModeFor(appMode), indicatorData, id);
    var indicator = metricValue && indicatorValue && getIndicator(metricValue, // Raw metric value
    indicatorValue, // Raw indicator value
    heroMetric === null || heroMetric === void 0 ? void 0 : heroMetric.indicatorConfig, // Color rules and thresholds
    isSelected2, // Whether entity is selected
    presentation === null || presentation === void 0 ? void 0 : presentation.showDecimalPlace, // Format with decimals
    presentation === null || presentation === void 0 ? void 0 : presentation.showUnit, // Show unit symbol
    presentation === null || presentation === void 0 ? void 0 : presentation.unit, // Use presentation unit from hero metric config
    heroMetric === null || heroMetric === void 0 ? void 0 : heroMetric.name);
    return {
        indicator: indicator,
        presentation: presentation
    };
};
// src/hooks/useDataWarning.tsx
import { useMemo as useMemo16 } from "react";
import { useDataContext as useDataContext2 } from "@repo/front-end-state";
var useDataWarning = function() {
    var warning = useDataContext2().warning;
    return useMemo16(function() {
        return warning;
    }, [
        warning
    ]);
};
// src/hooks/useQueryParams.tsx
import { useMemo as useMemo17 } from "react";
import { useLocation } from "react-router-dom";
var useQueryParams = function() {
    var search = useLocation().search;
    return useMemo17(function() {
        var params = new URLSearchParams(search);
        var queryObject = {};
        params.forEach(function(value, key) {
            queryObject[key] = value;
        });
        return queryObject;
    }, [
        search
    ]);
};
// src/hooks/useLastURLSegment.tsx
import { useState as useState59, useEffect as useEffect40 } from "react";
var useLastUrlSegment = function() {
    var _useState59 = _sliced_to_array(useState59(""), 2), lastSegment = _useState59[0], setLastSegment = _useState59[1];
    useEffect40(function() {
        var path = window.location.pathname;
        var segments = path.split("/").filter(function(segment) {
            return segment;
        });
        var lastPart = segments.length > 0 ? segments[segments.length - 1] : "";
        setLastSegment(lastPart);
    }, []);
    return lastSegment;
};
// src/components/Labels/Labels.tsx
import styled88 from "styled-components";
import { Roles as Roles6 } from "@repo/frontend-types";
import { useUserStore as useUserStore16 } from "@repo/front-end-state";
import { jsx as jsx119, jsxs as jsxs83 } from "react/jsx-runtime";
var Labels = function(param) {
    var className = param.className, entity = param.entity, resolvedRows = param.resolvedRows, cssProperties = param.cssProperties;
    var _authMetadata_roles;
    var authMetadata = useUserStore16().authMetadata;
    var isTLAdmin = (authMetadata === null || authMetadata === void 0 ? void 0 : (_authMetadata_roles = authMetadata.roles) === null || _authMetadata_roles === void 0 ? void 0 : _authMetadata_roles.includes(Roles6.TL_ADMIN)) || false;
    var isUntracked = entity.tracked === false;
    var untrackedClass = isUntracked ? "untracked" : "";
    return(// ⚠️ THE UNTRACKED STATE IS NAMED, not just styled. Italic (below) is the non-colour signal for
    // a sighted reader, but a font change is invisible to assistive technology — a screen-reader
    // user would hear "Utilisation 42.4%" identically for a tracked and an untracked entity and
    // read values that are explicitly not measurements of that entity as if they were. The list's
    // accessible name carries it once, which is the right granularity: untracked is a property of
    // the ENTITY, not of each row.
    /* @__PURE__ */ jsxs83("ul", {
        className: className,
        style: cssProperties,
        "aria-label": isUntracked ? "Labels \u2014 untracked entity, values are not measured" : void 0,
        children: [
            resolvedRows.map(function(row, i) {
                return /* @__PURE__ */ jsxs83("li", {
                    className: untrackedClass,
                    children: [
                        /* @__PURE__ */ jsx119("span", {
                            children: row.name
                        }),
                        row.value
                    ]
                }, "".concat(row.name, "-").concat(i));
            }),
            isTLAdmin && /* @__PURE__ */ jsxs83("li", {
                children: [
                    /* @__PURE__ */ jsx119("span", {
                        children: "BID"
                    }),
                    entity.bID
                ]
            })
        ]
    }));
};
var Labels_default = styled88(Labels)(_templateObject214(), INTER_FONT_FAMILY);
// src/components/EntityIndicator/EntityIndicator.tsx
import styled89 from "styled-components";
import { useDataContext as useDataContext3, useFilterContext as useFilterContext4 } from "@repo/front-end-state";
import { Warning12Filled as Warning12Filled2 } from "@fluentui/react-icons";
// src/utils/formatIndicatorValue.ts
import { formatToOneDecimal } from "@repo/front-end-utils";
var formatIndicatorValue = function(value, presentation) {
    var formatted = (presentation === null || presentation === void 0 ? void 0 : presentation.showDecimalPlace) ? formatToOneDecimal(value) : Math.round(value).toString();
    var _presentation_unit;
    var unit2 = (presentation === null || presentation === void 0 ? void 0 : presentation.showUnit) ? (_presentation_unit = presentation === null || presentation === void 0 ? void 0 : presentation.unit) !== null && _presentation_unit !== void 0 ? _presentation_unit : "" : "";
    return "".concat(formatted).concat(unit2);
};
// src/components/EntityIndicator/EntityIndicator.tsx
import { Fragment as Fragment26, jsx as jsx120, jsxs as jsxs84 } from "react/jsx-runtime";
var EntityIndicatorV2 = function(param) {
    var className = param.className, entity = param.entity, fontSize = param.fontSize, _param_showWarning = param.showWarning, showWarning = _param_showWarning === void 0 ? true : _param_showWarning, showWarningFontSize = param.showWarningFontSize, tmp = param.isSelected, isSelected2 = tmp === void 0 ? false : tmp, _param_showNoDataTag = param.showNoDataTag, showNoDataTag = _param_showNoDataTag === void 0 ? false : _param_showNoDataTag;
    var _data_processed, _data_processed1;
    var _useHeroIndicator = useHeroIndicator(entity), indicator = _useHeroIndicator.indicator, presentation = _useHeroIndicator.presentation;
    var data = useDataContext3().data;
    var heroMetric = useFilterContext4().heroMetric;
    var indicatorValue = indicator != null && typeof indicator.value === "number" && Number.isFinite(indicator.value) ? indicator.value : null;
    var hasValue = indicatorValue != null;
    var valueRows = heroMetric ? (_data_processed = data.processed) === null || _data_processed === void 0 ? void 0 : _data_processed[heroMetric.valueMetricName] : void 0;
    var indicatorRows = heroMetric ? (_data_processed1 = data.processed) === null || _data_processed1 === void 0 ? void 0 : _data_processed1[heroMetric.indicatorMetricName] : void 0;
    var dataArrived = Array.isArray(valueRows) && valueRows.length > 0 && Array.isArray(indicatorRows) && indicatorRows.length > 0;
    var showNoData = showNoDataTag && entity.tracked !== false && !hasValue && dataArrived;
    var displayUsageWarning = false;
    if (showWarning && indicatorValue != null && indicatorValue > 100) {
        displayUsageWarning = true;
    }
    return /* @__PURE__ */ jsxs84("div", {
        className: className,
        children: [
            entity.tracked === false && /* @__PURE__ */ jsxs84(Fragment26, {
                children: [
                    /* @__PURE__ */ jsx120("span", {
                        className: "indicator-label untracked-label",
                        style: {
                            fontSize: "10px",
                            marginLeft: "4px"
                        },
                        children: "Untracked"
                    }),
                    /* @__PURE__ */ jsx120("span", {
                        className: "indicator-badge na-indicator-badge"
                    })
                ]
            }),
            showNoData && /* @__PURE__ */ jsx120("span", {
                className: "indicator-label no-data-label",
                style: {
                    fontSize: "10px",
                    marginLeft: "4px"
                },
                children: "No data"
            }),
            indicator && indicatorValue != null ? /* @__PURE__ */ jsxs84(Fragment26, {
                children: [
                    displayUsageWarning ? /* @__PURE__ */ jsx120("span", {
                        className: "indicator over-capacity-indicator",
                        style: {
                            fontSize: Number.isInteger(showWarningFontSize) ? "".concat(showWarningFontSize, "px") : showWarningFontSize
                        },
                        children: /* @__PURE__ */ jsx120(Warning12Filled2, {})
                    }) : null,
                    /* @__PURE__ */ jsx120("span", {
                        className: "indicator-label",
                        style: {
                            fontSize: fontSize !== null && fontSize !== void 0 ? fontSize : "12px",
                            marginLeft: !displayUsageWarning ? "auto" : "4px"
                        },
                        children: /* @__PURE__ */ jsx120("span", {
                            className: "indicator-value",
                            children: formatIndicatorValue(indicatorValue, presentation)
                        })
                    }),
                    /* @__PURE__ */ jsx120("span", {
                        className: "indicator-badge",
                        style: {
                            backgroundColor: indicator.colors.bgColor
                        }
                    })
                ]
            }) : null
        ]
    });
};
var EntityIndicator_default = styled89(EntityIndicatorV2)(_templateObject215());
// src/components/EntityRow/EntityRow.tsx
import styled90 from "styled-components";
import { hexToRgb } from "@repo/front-end-utils";
import { jsx as jsx121 } from "react/jsx-runtime";
var entityRowGradient = function(indicator) {
    var rgbColor = indicator && hexToRgb(indicator.colors.bgColor);
    return rgbColor ? "linear-gradient(to right, rgba(255,255,255, 0) 0%, rgba(".concat(rgbColor, ", 0.2) 100%)") : "transparent";
};
var EntityRow = function(param) {
    var className = param.className, entity = param.entity, indicator = param.indicator, isSelected2 = param.isSelected, showChrome = param.showChrome, isHovered = param.isHovered, onClick = param.onClick, onMouseEnter = param.onMouseEnter, onMouseLeave = param.onMouseLeave, testId = param.testId, _param_labelFontSize = param.labelFontSize, labelFontSize = _param_labelFontSize === void 0 ? "10px" : _param_labelFontSize, _param_showNoDataTag = param.showNoDataTag, showNoDataTag = _param_showNoDataTag === void 0 ? false : _param_showNoDataTag;
    var gradientStyle = entityRowGradient(indicator);
    return /* @__PURE__ */ jsx121("div", {
        className: "".concat(className, " ").concat(showChrome ? "selected" : "", " ").concat(isHovered ? "hovered" : ""),
        "data-testid": testId,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onClick: onClick,
        style: {
            background: gradientStyle
        },
        children: /* @__PURE__ */ jsx121(LabelHeader_default, {
            id: entity.id,
            fontSize: labelFontSize,
            indicator: /* @__PURE__ */ jsx121(EntityIndicator_default, {
                entity: entity,
                showWarning: true,
                isSelected: isSelected2,
                showNoDataTag: showNoDataTag
            }),
            title: "".concat(entity.name),
            showId: false
        })
    });
};
var EntityRow_default = styled90(EntityRow)(_templateObject216());
// src/components/EntityAccordion/EntityAccordion.tsx
import React61 from "react";
import { compareEntitiesForDisplay as compareEntitiesForDisplay2 } from "@repo/front-end-utils";
// src/components/EntityAccordion/EntityAccordionItemWithContext.tsx
import { useState as useState60 } from "react";
import { useEventContext as useEventContext3 } from "@repo/front-end-state";
// src/components/EntityAccordion/EntityAccordionItem.tsx
import { FilterType as FilterType2 } from "@repo/frontend-types";
import React60, { useCallback as useCallback20, useMemo as useMemo19 } from "react";
import styled91 from "styled-components";
import { useTwinContext as useTwinContext4, useFilterContext as useFilterContext6 } from "@repo/front-end-state";
import { excludedTypes } from "@repo/front-end-data";
import { createFilterPath as createFilterPath2, liftLoneFloor } from "@repo/front-end-utils";
import { compareEntitiesForDisplay, naturalSort } from "@repo/front-end-utils";
import { AccordionHeader as AccordionHeader2, AccordionItem as AccordionItem2, AccordionPanel as AccordionPanel2 } from "@fluentui/react-components";
// src/components/EntityAccordion/AssetItem.tsx
import { FilterType } from "@repo/frontend-types";
import { useCallback as useCallback19, useMemo as useMemo18 } from "react";
import { useTwinContext as useTwinContext3, useFilterContext as useFilterContext5, useEventContext as useEventContext2 } from "@repo/front-end-state";
import { createFilterPath } from "@repo/front-end-utils";
import { findObjectByPropertyValue } from "@repo/front-end-utils";
import { jsx as jsx122 } from "react/jsx-runtime";
var AssetItemV2 = function(param) {
    var className = param.className, asset = param.asset;
    var _useFilterContext5 = useFilterContext5(), filter = _useFilterContext5.filter, removeFilterByType = _useFilterContext5.removeFilterByType, setFilter = _useFilterContext5.setFilter;
    var _useEventContext2 = useEventContext2(), currentHoveredEntity = _useEventContext2.currentHoveredEntity, setCurrentHoveredValue = _useEventContext2.setCurrentHoveredValue, currentHoveredEntityOn3DScene = _useEventContext2.currentHoveredEntityOn3DScene, selectedEntityIds = _useEventContext2.selectedEntityIds;
    var twin = useTwinContext3().twin;
    var entityForHook = useMemo18(function() {
        return {
            id: asset.id,
            bID: asset.bID,
            name: asset.name,
            type: asset.type,
            capacity: asset.capacity,
            tracked: asset.tracked,
            depth: 0,
            // Assets don't have depth, default to 0
            children: asset.children || [],
            content: void 0
        };
    }, [
        asset
    ]);
    var indicator = useHeroIndicator(entityForHook).indicator;
    var setFilterPath = useCallback19(function(pathId) {
        if (twin) {
            removeFilterByType(FilterType.ENTITY);
            removeFilterByType(FilterType.ASSET);
            var filter2 = createFilterPath(pathId, twin.physicalModel);
            setFilter(filter2);
        }
    }, [
        twin,
        removeFilterByType,
        setFilter
    ]);
    var enableCurrentSelection = true;
    var id = asset.id;
    var isSelected2 = selectedEntityIds.has(asset.id);
    var selected = findObjectByPropertyValue(filter, "id", asset.id);
    var isHovered = useMemo18(function() {
        return (currentHoveredEntity === null || currentHoveredEntity === void 0 ? void 0 : currentHoveredEntity.id) === asset.id || (currentHoveredEntityOn3DScene === null || currentHoveredEntityOn3DScene === void 0 ? void 0 : currentHoveredEntityOn3DScene.id) === asset.id;
    }, [
        currentHoveredEntity,
        currentHoveredEntityOn3DScene,
        asset.id
    ]);
    return /* @__PURE__ */ jsx122(EntityRow_default, {
        className: className,
        entity: entityForHook,
        indicator: indicator || null,
        isSelected: isSelected2,
        showChrome: !!selected,
        isHovered: isHovered,
        testId: "asset-".concat(asset.name.toLowerCase().replace(/ /g, "-")),
        labelFontSize: "10px",
        onClick: function() {
            setFilterPath(asset.id);
        },
        onMouseEnter: function() {
            if (enableCurrentSelection) {
                setCurrentHoveredValue({
                    id: id,
                    type: "ENTITY"
                });
            }
        },
        onMouseLeave: function() {
            if (enableCurrentSelection) {
                setCurrentHoveredValue(null);
            }
        }
    });
};
var AssetItem_default = AssetItemV2;
// src/components/EntityAccordion/EntityAccordionItem.tsx
import { Fragment as Fragment27, jsx as jsx123, jsxs as jsxs85 } from "react/jsx-runtime";
var EntityAccordionItem = React60.memo(function(param) {
    var className = param.className, size2 = param.size, handleToggle = param.handleToggle, handleMouseEnter = param.handleMouseEnter, handleMouseLeave = param.handleMouseLeave, entity = param.entity, currentHoveredEntity = param.currentHoveredEntity, currentHovered3DEntity = param.currentHovered3DEntity, live = param.live, isSelected2 = param.isSelected;
    var _useFilterContext6 = useFilterContext6(), removeFilterByType = _useFilterContext6.removeFilterByType, setFilter = _useFilterContext6.setFilter;
    var twin = useTwinContext4().twin;
    var setFilterPath = useCallback20(function(pathId) {
        if (twin) {
            removeFilterByType(FilterType2.ENTITY);
            removeFilterByType(FilterType2.ASSET);
            var filter = createFilterPath2(pathId, twin.physicalModel);
            setFilter(filter);
        }
    }, [
        twin,
        removeFilterByType,
        setFilter
    ]);
    var isHovered = useMemo19(function() {
        return (currentHoveredEntity === null || currentHoveredEntity === void 0 ? void 0 : currentHoveredEntity.id) === entity.id || (currentHovered3DEntity === null || currentHovered3DEntity === void 0 ? void 0 : currentHovered3DEntity.id) === entity.id;
    }, [
        currentHoveredEntity,
        currentHovered3DEntity,
        entity.id
    ]);
    var enableCurrentSelection = true;
    var title = entity.name;
    var children = entity.children ? liftLoneFloor(entity, entity.children) : entity.children;
    var entityChildren = children === null || children === void 0 ? void 0 : children.filter(function(e) {
        return !excludedTypes.includes(e.type.name);
    });
    var hasAssets = children === null || children === void 0 ? void 0 : children.filter(function(e) {
        return e.type.name === "asset";
    });
    var showAsPanelButton = hasAssets && (hasAssets === null || hasAssets === void 0 ? void 0 : hasAssets.length) === 0 && entityChildren && entityChildren.length === 0;
    return /* @__PURE__ */ jsx123("div", {
        className: className,
        children: /* @__PURE__ */ jsx123(AccordionItem2, {
            id: "entity-".concat(entity.type.name.toLowerCase(), "-").concat(entity.id),
            "data-testid": "entity-".concat(entity.name.toLowerCase().replace(/ /g, "-")),
            onMouseEnter: function() {
                if (enableCurrentSelection) {
                    handleMouseEnter(entity.id, "ENTITY");
                }
            },
            onMouseLeave: function() {
                if (enableCurrentSelection) {
                    handleMouseLeave();
                }
            },
            value: entity.id,
            children: /* @__PURE__ */ jsx123(TLCard_default, {
                className: "accordion-item",
                padding: "8px",
                hovered: isHovered,
                selected: isSelected2,
                children: /* @__PURE__ */ jsxs85(Fragment27, {
                    children: [
                        !showAsPanelButton ? /* @__PURE__ */ jsx123(AccordionHeader2, {
                            size: size2 ? size2 : "small",
                            expandIconPosition: "end",
                            children: /* @__PURE__ */ jsx123("div", {
                                className: "header-content",
                                children: /* @__PURE__ */ jsx123(LabelHeader_default, {
                                    id: entity.id,
                                    fontSize: "".concat(entity.depth === 0 ? "14px" : "12px"),
                                    indicator: /* @__PURE__ */ jsx123(EntityIndicator_default, {
                                        entity: entity,
                                        showWarning: true,
                                        isSelected: isSelected2
                                    }),
                                    title: "".concat(title),
                                    showId: false
                                })
                            })
                        }) : /* @__PURE__ */ jsx123("div", {
                            className: "accordion-button",
                            onClick: function() {
                                setFilterPath(entity.id);
                            },
                            children: /* @__PURE__ */ jsx123(LabelHeader_default, {
                                id: entity.id,
                                fontSize: "".concat(entity.depth === 0 ? "14px" : "12px"),
                                indicator: /* @__PURE__ */ jsx123(EntityIndicator_default, {
                                    entity: entity,
                                    showWarning: true,
                                    isSelected: isSelected2
                                }),
                                title: "".concat(title),
                                showId: false
                            })
                        }),
                        !showAsPanelButton && (entityChildren && entityChildren.length > 0 || hasAssets && hasAssets.length > 0) && /* @__PURE__ */ jsxs85(AccordionPanel2, {
                            style: {
                                margin: 0
                            },
                            children: [
                                entityChildren && entityChildren.length > 0 && /* @__PURE__ */ jsx123(EntityAccordion_default, {
                                    entities: _to_consumable_array(entityChildren).sort(compareEntitiesForDisplay),
                                    handleToggle: handleToggle,
                                    live: live
                                }),
                                hasAssets && _to_consumable_array(hasAssets).sort(function(a, b) {
                                    return naturalSort(a.name, b.name);
                                }).map(function(asset, i) {
                                    return /* @__PURE__ */ jsx123("div", {
                                        children: /* @__PURE__ */ jsx123(AssetItem_default, {
                                            asset: asset
                                        })
                                    }, i);
                                })
                            ]
                        })
                    ]
                })
            })
        }, entity.id)
    });
}, function(prevProps, nextProps) {
    var _prevProps_currentHoveredEntity, _nextProps_currentHoveredEntity, _prevProps_currentHovered3DEntity, _nextProps_currentHovered3DEntity;
    var hasCurrentHoverChanged = ((_prevProps_currentHoveredEntity = prevProps.currentHoveredEntity) === null || _prevProps_currentHoveredEntity === void 0 ? void 0 : _prevProps_currentHoveredEntity.id) === prevProps.entity.id !== (((_nextProps_currentHoveredEntity = nextProps.currentHoveredEntity) === null || _nextProps_currentHoveredEntity === void 0 ? void 0 : _nextProps_currentHoveredEntity.id) === nextProps.entity.id);
    var hasCurrent3DHoverChanged = ((_prevProps_currentHovered3DEntity = prevProps.currentHovered3DEntity) === null || _prevProps_currentHovered3DEntity === void 0 ? void 0 : _prevProps_currentHovered3DEntity.id) === prevProps.entity.id !== (((_nextProps_currentHovered3DEntity = nextProps.currentHovered3DEntity) === null || _nextProps_currentHovered3DEntity === void 0 ? void 0 : _nextProps_currentHovered3DEntity.id) === nextProps.entity.id);
    var isSelectedChanged = nextProps.isSelected !== prevProps.isSelected;
    var hasLiveModeChanged = nextProps.live !== prevProps.live;
    return !(hasCurrentHoverChanged || hasCurrent3DHoverChanged || hasLiveModeChanged || isSelectedChanged);
});
var EntityAccordionItem_default = styled91(EntityAccordionItem)(_templateObject217());
// src/components/EntityAccordion/EntityAccordionItemWithContext.tsx
import { jsx as jsx124 } from "react/jsx-runtime";
var withContext = function(Component3) {
    return function(props) {
        var _useEventContext3 = useEventContext3(), currentHoveredEntity = _useEventContext3.currentHoveredEntity, setCurrentHoveredValue = _useEventContext3.setCurrentHoveredValue, currentHoveredEntityOn3DScene = _useEventContext3.currentHoveredEntityOn3DScene, selectedEntityIds = _useEventContext3.selectedEntityIds;
        var _useState60 = _sliced_to_array(useState60(false), 2), isHovered = _useState60[0], setIsHovered = _useState60[1];
        var handleMouseEnter = function(id, type) {
            if (!isHovered) {
                setCurrentHoveredValue({
                    id: id,
                    type: type
                });
                setIsHovered(true);
            }
        };
        var handleMouseLeave = function() {
            if (isHovered) {
                setCurrentHoveredValue(null);
                setIsHovered(false);
            }
        };
        var isSelected2 = selectedEntityIds.has(props.entity.id);
        return /* @__PURE__ */ jsx124(Component3, _object_spread_props(_object_spread({}, props), {
            currentHoveredEntity: currentHoveredEntity,
            currentHovered3DEntity: currentHoveredEntityOn3DScene,
            handleMouseEnter: handleMouseEnter,
            handleMouseLeave: handleMouseLeave,
            live: props.live,
            isSelected: isSelected2
        }));
    };
};
var EntityAccordionItemWithContext = withContext(EntityAccordionItem_default);
var EntityAccordionItemWithContext_default = EntityAccordionItemWithContext;
// src/components/EntityAccordion/EntityAccordion.tsx
import { Fragment as Fragment28, jsx as jsx125 } from "react/jsx-runtime";
var EntityAccordion = React61.memo(function(param) {
    var entities = param.entities, handleToggle = param.handleToggle, live = param.live;
    var sortedEntities = _to_consumable_array(entities).sort(compareEntitiesForDisplay2);
    return /* @__PURE__ */ jsx125(Fragment28, {
        children: sortedEntities.map(function(entity, i) {
            return /* @__PURE__ */ jsx125(EntityAccordionItemWithContext_default, {
                entity: entity,
                handleToggle: handleToggle,
                live: live
            }, i);
        })
    });
});
var EntityAccordion_default = EntityAccordion;
// src/components/Assets/Assets.tsx
import { AppMode as AppMode4, FilterType as FilterType3 } from "@repo/frontend-types";
import { useEffect as useEffect41, useState as useState61 } from "react";
import { useTwinContext as useTwinContext5, useFilterContext as useFilterContext7, useModeContext as useModeContext5 } from "@repo/front-end-state";
import { createFilterPath as createFilterPath3 } from "@repo/front-end-utils";
import { Accordion as Accordion3 } from "@fluentui/react-components";
import { jsx as jsx126 } from "react/jsx-runtime";
var Assets = function(param) {
    var className = param.className;
    var twin = useTwinContext5().twin;
    var renderTwin = {
        children: []
    };
    if (twin && twin.physicalModel) {
        var _renderTwin_children;
        (_renderTwin_children = renderTwin.children) === null || _renderTwin_children === void 0 ? void 0 : _renderTwin_children.push(twin.physicalModel);
    }
    var _useFilterContext7 = useFilterContext7(), filter = _useFilterContext7.filter, setFilter = _useFilterContext7.setFilter, removeFilter = _useFilterContext7.removeFilter, removeFilterByType = _useFilterContext7.removeFilterByType;
    var appMode = useModeContext5().appMode;
    var _useState61 = _sliced_to_array(useState61([]), 2), openItems = _useState61[0], setOpenItems = _useState61[1];
    useEffect41(function() {
        var openedFilterItems = [];
        filter.forEach(function(f) {
            f.id && openedFilterItems.push(f.id);
        });
        setOpenItems(openedFilterItems);
    }, [
        filter
    ]);
    var handleToggle = function(isCollapsed) {
        var clickedItem = isCollapsed.value;
        var wasOpen = openItems.includes(clickedItem);
        var isNowOpen = isCollapsed.openItems.includes(clickedItem);
        removeFilterByType(FilterType3.ENTITY);
        removeFilterByType(FilterType3.ASSET);
        if (isCollapsed.openItems.length > 0) {
            var targetId;
            if (!wasOpen && isNowOpen) {
                targetId = clickedItem;
                if (twin) {
                    var newFilter = createFilterPath3(targetId, twin.physicalModel);
                    var filteredFilter = newFilter.filter(function(filterItem) {
                        return filterItem.id && isCollapsed.openItems.includes(filterItem.id);
                    });
                    if (filteredFilter.length > 0) {
                        setFilter(filteredFilter);
                    }
                }
            } else {
                var clickedItemId = isCollapsed.value;
                var clickedItemFilterIdx = filter.findIndex(function(filterPath) {
                    return filterPath.id && filterPath.id === clickedItemId;
                });
                removeFilter(clickedItemFilterIdx);
            }
        }
    };
    return /* @__PURE__ */ jsx126("div", {
        className: className,
        children: /* @__PURE__ */ jsx126(Accordion3, {
            onToggle: function(_, isCollapsed) {
                return handleToggle(isCollapsed);
            },
            openItems: openItems,
            collapsible: true,
            multiple: true,
            children: /* @__PURE__ */ jsx126(EntityAccordion_default, {
                entities: renderTwin.children ? renderTwin.children : [],
                handleToggle: handleToggle,
                live: appMode === AppMode4.LIVE
            })
        })
    });
};
var Assets_default = Assets;
// src/components/AssetsAndAnalytics/AssetsAndAnalytics.tsx
import { useState as useState62 } from "react";
import styled92 from "styled-components";
import { TabPanel } from "@repo/frontend-types";
import { WebAsset24Filled, WebAsset24Regular } from "@fluentui/react-icons";
import { Scrollbar as Scrollbar6 } from "@repo/design-system";
import { jsx as jsx127, jsxs as jsxs86 } from "react/jsx-runtime";
var AssetsAndAnalytics = function(param) {
    var className = param.className;
    var tabOpts = [
        {
            inactiveIcon: /* @__PURE__ */ jsx127(WebAsset24Regular, {}),
            activeIcon: /* @__PURE__ */ jsx127(WebAsset24Filled, {}),
            value: TabPanel.ASSETS.toString(),
            text: "Assets"
        }
    ];
    var _useState62 = _sliced_to_array(useState62(TabPanel.ASSETS), 2), tabPanel = _useState62[0], setTabPanel = _useState62[1];
    var _useState621 = _sliced_to_array(useState62(tabOpts), 1), tabOptions = _useState621[0];
    return /* @__PURE__ */ jsxs86("div", {
        className: className,
        children: [
            /* @__PURE__ */ jsx127("div", {
                className: "header",
                children: /* @__PURE__ */ jsx127(TLCard_default, {
                    size: "small",
                    children: /* @__PURE__ */ jsx127(TLSwitcher_default, {
                        size: "small",
                        selectedValue: tabPanel.toString(),
                        options: tabOptions,
                        setValue: setTabPanel
                    })
                })
            }),
            tabPanel === TabPanel.ASSETS && /* @__PURE__ */ jsx127(Scrollbar6, {
                fadeOutEnabled: false,
                className: "scrollable-container",
                maxHeight: "calc(100vh - 220px)",
                children: /* @__PURE__ */ jsx127(Assets_default, {})
            })
        ]
    });
};
var AssetsAndAnalytics_default = styled92(AssetsAndAnalytics)(_templateObject218());
// src/components/EquipmentPanel/EquipmentPanel.tsx
import { useEffect as useEffect42, useMemo as useMemo23, useRef as useRef26, useState as useState64 } from "react";
import styled96 from "styled-components";
import { useTwinContext as useTwinContext7, useFilterContext as useFilterContext10, useDataContext as useDataContext4, useModeContext as useModeContext6, useEventContext as useEventContext5 } from "@repo/front-end-state";
import { EQUIPMENT_PHASES, collectEquipmentEntities, currentEquipmentLoadToken, averageSelectedEquipmentValue, naturalSort as naturalSort2, markEnd, modeConfigFor as modeConfigFor2 } from "@repo/front-end-utils";
import { Dumbbell24Filled, Dumbbell24Regular, Filter24Filled, Filter24Regular } from "@fluentui/react-icons";
import { Scrollbar as Scrollbar7 } from "@repo/design-system";
// src/components/EquipmentPanel/EquipmentListItem.tsx
import React64, { useMemo as useMemo20 } from "react";
import { FilterType as FilterType4 } from "@repo/frontend-types";
import { useEventContext as useEventContext4, useFilterContext as useFilterContext8 } from "@repo/front-end-state";
import { jsx as jsx128 } from "react/jsx-runtime";
var EquipmentListItem = function(param) {
    var className = param.className, entity = param.entity;
    var _useEventContext4 = useEventContext4(), currentHoveredEntity = _useEventContext4.currentHoveredEntity, currentHoveredEntityOn3DScene = _useEventContext4.currentHoveredEntityOn3DScene, setCurrentHoveredValue = _useEventContext4.setCurrentHoveredValue, selectedEntityIds = _useEventContext4.selectedEntityIds;
    var _useFilterContext8 = useFilterContext8(), filter = _useFilterContext8.filter, toggleEquipmentSelection = _useFilterContext8.toggleEquipmentSelection;
    var indicator = useHeroIndicator(entity).indicator;
    var isSelected2 = selectedEntityIds.has(entity.id);
    var showChrome = useMemo20(function() {
        return filter.some(function(f) {
            return f.type === FilterType4.ASSET && f.id === entity.id;
        });
    }, [
        filter,
        entity.id
    ]);
    var isHovered = useMemo20(function() {
        return (currentHoveredEntity === null || currentHoveredEntity === void 0 ? void 0 : currentHoveredEntity.id) === entity.id || (currentHoveredEntityOn3DScene === null || currentHoveredEntityOn3DScene === void 0 ? void 0 : currentHoveredEntityOn3DScene.id) === entity.id;
    }, [
        currentHoveredEntity,
        currentHoveredEntityOn3DScene,
        entity.id
    ]);
    var _entity_name;
    return /* @__PURE__ */ jsx128(EntityRow_default, {
        className: className,
        entity: entity,
        indicator: indicator || null,
        isSelected: isSelected2,
        showChrome: showChrome,
        isHovered: isHovered,
        showNoDataTag: true,
        testId: "equipment-".concat(((_entity_name = entity.name) !== null && _entity_name !== void 0 ? _entity_name : "").toLowerCase().replace(/ /g, "-")),
        labelFontSize: "10px",
        onClick: function() {
            return toggleEquipmentSelection({
                id: entity.id,
                bId: entity.bID,
                label: entity.name
            });
        },
        onMouseEnter: function() {
            return setCurrentHoveredValue({
                id: entity.id,
                type: "ENTITY"
            });
        },
        onMouseLeave: function() {
            return setCurrentHoveredValue(null);
        }
    });
};
var EquipmentListItem_default = React64.memo(EquipmentListItem);
// src/components/EquipmentPanel/EquipmentSortControls.tsx
import styled93 from "styled-components";
import { jsx as jsx129, jsxs as jsxs87 } from "react/jsx-runtime";
var SortGlyph = function(param) {
    var active = param.active, direction = param.direction;
    if (!active) {
        return /* @__PURE__ */ jsxs87("svg", {
            className: "sort-glyph idle",
            viewBox: "0 0 10 14",
            "aria-hidden": "true",
            children: [
                /* @__PURE__ */ jsx129("path", {
                    d: "M5 0L8 4H2L5 0Z"
                }),
                /* @__PURE__ */ jsx129("path", {
                    d: "M5 14L2 10H8L5 14Z"
                })
            ]
        });
    }
    return /* @__PURE__ */ jsx129("svg", {
        className: "sort-glyph active",
        viewBox: "0 0 10 14",
        "aria-hidden": "true",
        children: direction === "asc" ? /* @__PURE__ */ jsx129("path", {
            d: "M5 3L9 9H1L5 3Z"
        }) : /* @__PURE__ */ jsx129("path", {
            d: "M5 11L1 5H9L5 11Z"
        })
    });
};
var EquipmentSortControls = function(param) {
    var className = param.className, sortField = param.sortField, sortDirection = param.sortDirection, onSort = param.onSort, valueLabel = param.valueLabel;
    var ariaLabel = function(field, text) {
        return sortField === field ? "Sorted by ".concat(text, ", ").concat(sortDirection === "asc" ? "ascending" : "descending", ". Activate to reverse.") : "Sort by ".concat(text);
    };
    return /* @__PURE__ */ jsxs87("div", {
        className: className,
        children: [
            /* @__PURE__ */ jsxs87("button", {
                type: "button",
                className: "sort-toggle name ".concat(sortField === "name" ? "active" : ""),
                "aria-label": ariaLabel("name", "Name"),
                onClick: function() {
                    return onSort("name");
                },
                "data-testid": "equipment-sort-name",
                children: [
                    /* @__PURE__ */ jsx129("span", {
                        className: "sort-label",
                        children: "Name"
                    }),
                    /* @__PURE__ */ jsx129(SortGlyph, {
                        active: sortField === "name",
                        direction: sortDirection
                    })
                ]
            }),
            /* @__PURE__ */ jsxs87("button", {
                type: "button",
                className: "sort-toggle value ".concat(sortField === "value" ? "active" : ""),
                "aria-label": ariaLabel("value", valueLabel),
                onClick: function() {
                    return onSort("value");
                },
                "data-testid": "equipment-sort-value",
                children: [
                    /* @__PURE__ */ jsx129("span", {
                        className: "sort-label",
                        children: valueLabel
                    }),
                    /* @__PURE__ */ jsx129(SortGlyph, {
                        active: sortField === "value",
                        direction: sortDirection
                    })
                ]
            })
        ]
    });
};
var EquipmentSortControls_default = styled93(EquipmentSortControls)(_templateObject219(), INTER_FONT_FAMILY);
// src/components/EquipmentPanel/EquipmentFilterTab.tsx
import { useCallback as useCallback21, useMemo as useMemo22 } from "react";
import styled95 from "styled-components";
import { useFilterContext as useFilterContext9, useEquipmentClassificationStore, useTwinContext as useTwinContext6 } from "@repo/front-end-state";
import { buildEquipmentClassificationTrees, buildFloorFilterTree, nextSelectionOnToggle, selectedNodesFromBids } from "@repo/front-end-utils";
// src/components/EquipmentPanel/EquipmentFilterTree.tsx
import { useMemo as useMemo21, useState as useState63 } from "react";
import styled94 from "styled-components";
import { computeTriStates } from "@repo/front-end-utils";
import { jsx as jsx130, jsxs as jsxs88 } from "react/jsx-runtime";
var Checkbox2 = function(param) {
    var state = param.state;
    if (state === "off") {
        return /* @__PURE__ */ jsx130("span", {
            className: "checkbox off",
            "aria-hidden": "true"
        });
    }
    return /* @__PURE__ */ jsx130("span", {
        className: "checkbox ".concat(state),
        "aria-hidden": "true",
        children: state === "on" ? /* @__PURE__ */ jsx130("svg", {
            viewBox: "0 0 12 12",
            fill: "none",
            stroke: "#fff",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            children: /* @__PURE__ */ jsx130("path", {
                d: "M2 6l3 3 5-6"
            })
        }) : /* @__PURE__ */ jsx130("span", {
            className: "dash"
        })
    });
};
var EquipmentFilterTree = function(param) {
    var className = param.className, groups = param.groups;
    var _useState63 = _sliced_to_array(useState63(/* @__PURE__ */ new Set()), 2), expanded = _useState63[0], setExpanded = _useState63[1];
    var toggleExpand = function(bid) {
        return setExpanded(function(prev) {
            var next = new Set(prev);
            if (next.has(bid)) next.delete(bid);
            else next.add(bid);
            return next;
        });
    };
    var triStatesByGroup = useMemo21(function() {
        return groups.map(function(group) {
            return computeTriStates(group.roots, group.selectedBids);
        });
    }, [
        groups
    ]);
    var sections = useMemo21(function() {
        return groups.map(function(group, groupIndex) {
            var triStates = triStatesByGroup[groupIndex];
            var rows = [];
            var walk = function(nodes, depth) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var node = _step.value;
                        var hasChildren2 = !!(node.children && node.children.length);
                        var isOpen = expanded.has("".concat(group.key, ":").concat(node.bid));
                        var _triStates_get;
                        rows.push({
                            node: node,
                            depth: depth,
                            state: (_triStates_get = triStates.get(node.bid)) !== null && _triStates_get !== void 0 ? _triStates_get : "off",
                            hasChildren: hasChildren2,
                            isOpen: isOpen
                        });
                        if (hasChildren2 && isOpen) walk(node.children, depth + 1);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            };
            walk(group.roots, 0);
            return {
                group: group,
                rows: rows
            };
        });
    }, [
        groups,
        expanded,
        triStatesByGroup
    ]);
    return /* @__PURE__ */ jsx130("div", {
        className: className,
        "data-testid": "equipment-filter-tree",
        children: sections.map(function(param) {
            var group = param.group, rows = param.rows;
            return /* @__PURE__ */ jsxs88("div", {
                className: "group",
                "data-testid": "filter-group-".concat(group.key),
                children: [
                    /* @__PURE__ */ jsx130("div", {
                        className: "group-heading",
                        children: group.label
                    }),
                    rows.map(function(param) {
                        var node = param.node, depth = param.depth, state = param.state, hasChildren2 = param.hasChildren, isOpen = param.isOpen;
                        return /* @__PURE__ */ jsxs88("div", {
                            className: "node-row",
                            style: {
                                paddingLeft: depth * 22
                            },
                            "data-testid": "filter-node-".concat(group.key, "-").concat(node.bid),
                            "data-state": state,
                            children: [
                                hasChildren2 ? /* @__PURE__ */ jsx130("button", {
                                    type: "button",
                                    className: "chevron",
                                    "aria-label": "".concat(isOpen ? "Collapse" : "Expand", " ").concat(node.label),
                                    "aria-expanded": isOpen,
                                    onClick: function() {
                                        return toggleExpand("".concat(group.key, ":").concat(node.bid));
                                    },
                                    "data-testid": "filter-expand-".concat(group.key, "-").concat(node.bid),
                                    children: /* @__PURE__ */ jsx130("svg", {
                                        viewBox: "0 0 16 16",
                                        style: {
                                            transform: isOpen ? "rotate(90deg)" : "none"
                                        },
                                        "aria-hidden": "true",
                                        children: /* @__PURE__ */ jsx130("path", {
                                            d: "M6 4l4 4-4 4",
                                            fill: "none",
                                            stroke: "currentColor",
                                            strokeWidth: "1.5",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round"
                                        })
                                    })
                                }) : /* @__PURE__ */ jsx130("span", {
                                    className: "chevron-spacer"
                                }),
                                /* @__PURE__ */ jsxs88("button", {
                                    type: "button",
                                    className: "node-label state-".concat(state),
                                    "aria-pressed": state === "mixed" ? "mixed" : state === "on",
                                    onClick: function() {
                                        return group.onToggle(node.bid);
                                    },
                                    "data-testid": "filter-toggle-".concat(group.key, "-").concat(node.bid),
                                    children: [
                                        /* @__PURE__ */ jsx130(Checkbox2, {
                                            state: state
                                        }),
                                        /* @__PURE__ */ jsx130("span", {
                                            className: "label-text",
                                            children: node.label
                                        }),
                                        /* @__PURE__ */ jsx130("span", {
                                            className: "count-badge",
                                            children: node.equipmentBids.length
                                        })
                                    ]
                                })
                            ]
                        }, "".concat(group.key, ":").concat(node.bid));
                    })
                ]
            }, group.key);
        })
    });
};
var EquipmentFilterTree_default = styled94(EquipmentFilterTree)(_templateObject220(), INTER_FONT_FAMILY);
// src/components/EquipmentPanel/EquipmentFilterTab.tsx
import { jsx as jsx131, jsxs as jsxs89 } from "react/jsx-runtime";
var EquipmentFilterTab = function(param) {
    var className = param.className;
    var _useFilterContext9 = useFilterContext9(), classificationFilters = _useFilterContext9.classificationFilters, setClassificationFilter = _useFilterContext9.setClassificationFilter;
    var _useEquipmentClassificationStore = useEquipmentClassificationStore(), classifications = _useEquipmentClassificationStore.classifications, loading = _useEquipmentClassificationStore.loading, error = _useEquipmentClassificationStore.error, retryEquipmentClassifications = _useEquipmentClassificationStore.retryEquipmentClassifications;
    var _useTwinContext6 = useTwinContext6(), twin = _useTwinContext6.twin, multifloor = _useTwinContext6.multifloor;
    var trees = useMemo22(function() {
        return buildEquipmentClassificationTrees(classifications !== null && classifications !== void 0 ? classifications : []);
    }, [
        classifications
    ]);
    var floorRoots = useMemo22(function() {
        return buildFloorFilterTree(twin === null || twin === void 0 ? void 0 : twin.physicalModel, multifloor);
    }, [
        twin,
        multifloor
    ]);
    var selectedBids = useMemo22(function() {
        var _classificationFilters_floor, _classificationFilters_equipmentType, _classificationFilters_manufacturer;
        return {
            floor: new Set(((_classificationFilters_floor = classificationFilters === null || classificationFilters === void 0 ? void 0 : classificationFilters.floor) !== null && _classificationFilters_floor !== void 0 ? _classificationFilters_floor : []).map(function(node) {
                return node.bid;
            })),
            equipmentType: new Set(((_classificationFilters_equipmentType = classificationFilters === null || classificationFilters === void 0 ? void 0 : classificationFilters.equipmentType) !== null && _classificationFilters_equipmentType !== void 0 ? _classificationFilters_equipmentType : []).map(function(node) {
                return node.bid;
            })),
            manufacturer: new Set(((_classificationFilters_manufacturer = classificationFilters === null || classificationFilters === void 0 ? void 0 : classificationFilters.manufacturer) !== null && _classificationFilters_manufacturer !== void 0 ? _classificationFilters_manufacturer : []).map(function(node) {
                return node.bid;
            }))
        };
    }, [
        classificationFilters
    ]);
    var makeToggle = useCallback21(function(hierarchy, roots) {
        return function(bid) {
            var nextBids = nextSelectionOnToggle(roots, selectedBids[hierarchy], bid);
            setClassificationFilter(hierarchy, selectedNodesFromBids(roots, nextBids));
        };
    }, [
        selectedBids,
        setClassificationFilter
    ]);
    var _classifications_length;
    var showClassifications = !loading && !error && ((_classifications_length = classifications === null || classifications === void 0 ? void 0 : classifications.length) !== null && _classifications_length !== void 0 ? _classifications_length : 0) > 0;
    var _classifications_length1;
    var isEmpty = !loading && !error && ((_classifications_length1 = classifications === null || classifications === void 0 ? void 0 : classifications.length) !== null && _classifications_length1 !== void 0 ? _classifications_length1 : 0) === 0;
    var groups = useMemo22(function() {
        var next = [];
        if (floorRoots.length > 0) {
            next.push({
                key: "floor",
                label: "Floor",
                roots: floorRoots,
                selectedBids: selectedBids.floor,
                onToggle: makeToggle("floor", floorRoots)
            });
        }
        if (showClassifications) {
            next.push({
                key: "equipmentType",
                label: "Equipment type",
                roots: trees.equipmentType,
                selectedBids: selectedBids.equipmentType,
                onToggle: makeToggle("equipmentType", trees.equipmentType)
            });
            next.push({
                key: "manufacturer",
                label: "Manufacturer",
                roots: trees.manufacturer,
                selectedBids: selectedBids.manufacturer,
                onToggle: makeToggle("manufacturer", trees.manufacturer)
            });
        }
        return next;
    }, [
        floorRoots,
        trees,
        selectedBids,
        makeToggle,
        showClassifications
    ]);
    return /* @__PURE__ */ jsxs89("div", {
        className: className,
        "data-testid": "equipment-filter-tab",
        children: [
            groups.length > 0 && /* @__PURE__ */ jsx131(EquipmentFilterTree_default, {
                groups: groups
            }),
            loading && /* @__PURE__ */ jsx131("div", {
                className: "state",
                "data-testid": "equipment-filter-loading",
                children: /* @__PURE__ */ jsx131(TLSpinner_default, {
                    props: {
                        size: "small",
                        label: "Loading classifications\u2026"
                    }
                })
            }),
            !loading && error && /* @__PURE__ */ jsxs89("div", {
                className: "state error",
                "data-testid": "equipment-filter-error",
                children: [
                    /* @__PURE__ */ jsx131("p", {
                        children: "Couldn\u2019t load equipment classifications."
                    }),
                    /* @__PURE__ */ jsx131("button", {
                        type: "button",
                        onClick: retryEquipmentClassifications,
                        "data-testid": "equipment-filter-retry",
                        children: "Retry"
                    })
                ]
            }),
            isEmpty && /* @__PURE__ */ jsx131("div", {
                className: "state",
                "data-testid": "equipment-filter-empty",
                children: "No classification data for this twin yet."
            })
        ]
    });
};
var EquipmentFilterTab_default = styled95(EquipmentFilterTab)(_templateObject221(), INTER_FONT_FAMILY, INTER_FONT_FAMILY);
// src/components/EquipmentPanel/EquipmentPanel.tsx
import { jsx as jsx132, jsxs as jsxs90 } from "react/jsx-runtime";
var EquipmentPanel = function(param) {
    var className = param.className;
    var _twin_physicalModel;
    var twin = useTwinContext7().twin;
    var _useFilterContext10 = useFilterContext10(), heroMetric = _useFilterContext10.heroMetric, classificationFilters = _useFilterContext10.classificationFilters, clearClassificationFilters = _useFilterContext10.clearClassificationFilters;
    var data = useDataContext4().data;
    var appMode = useModeContext6().appMode;
    var selectedEntityIds = useEventContext5().selectedEntityIds;
    var _useState64 = _sliced_to_array(useState64("equipment"), 2), tab = _useState64[0], setTab = _useState64[1];
    var equipment = useMemo23(function() {
        return collectEquipmentEntities(twin === null || twin === void 0 ? void 0 : twin.physicalModel);
    }, [
        twin
    ]);
    var _useTableSort = useTableSort({
        defaultField: "value",
        defaultDirection: "desc",
        fieldDefaults: {
            value: "desc",
            name: "asc"
        }
    }), sortField = _useTableSort.sortField, sortDirection = _useTableSort.sortDirection, handleSort = _useTableSort.handleSort;
    var presentation = useMemo23(function() {
        return modeConfigFor2(heroMetric, appMode);
    }, [
        heroMetric,
        appMode
    ]);
    var markedForLoad = useRef26(void 0);
    var twinBid = twin === null || twin === void 0 ? void 0 : (_twin_physicalModel = twin.physicalModel) === null || _twin_physicalModel === void 0 ? void 0 : _twin_physicalModel.bID;
    useEffect42(function() {
        if (!twinBid || equipment.length === 0) return;
        var loadToken = currentEquipmentLoadToken();
        if (loadToken === 0 || markedForLoad.current === loadToken) return;
        var frame = requestAnimationFrame(function() {
            if (markEnd(EQUIPMENT_PHASES.panelRender)) {
                markedForLoad.current = loadToken;
            }
        });
        return function() {
            return cancelAnimationFrame(frame);
        };
    }, [
        twinBid,
        equipment.length,
        data.processed
    ]);
    var sortedEquipment = useMemo23(function() {
        var _data_processed;
        var _data_processed_heroMetric_valueMetricName;
        var metricData = heroMetric ? (_data_processed_heroMetric_valueMetricName = (_data_processed = data.processed) === null || _data_processed === void 0 ? void 0 : _data_processed[heroMetric.valueMetricName]) !== null && _data_processed_heroMetric_valueMetricName !== void 0 ? _data_processed_heroMetric_valueMetricName : [] : [];
        var valueByBid = /* @__PURE__ */ new Map();
        metricData.forEach(function(dv) {
            if (dv.bID !== void 0 && !valueByBid.has(dv.bID) && Number.isFinite(dv.value)) {
                valueByBid.set(dv.bID, dv.value);
            }
        });
        var valueOf = function(e) {
            var v = valueByBid.get(e.bID);
            return v === void 0 ? null : v;
        };
        var byName = function(a, b) {
            var _a_name, _b_name;
            return naturalSort2((_a_name = a.name) !== null && _a_name !== void 0 ? _a_name : "", (_b_name = b.name) !== null && _b_name !== void 0 ? _b_name : "");
        };
        var list = _to_consumable_array(equipment);
        if (sortField === "name") {
            list.sort(function(a, b) {
                var c = byName(a, b);
                return sortDirection === "asc" ? c : -c;
            });
            return list;
        }
        list.sort(function(a, b) {
            var av = valueOf(a);
            var bv = valueOf(b);
            if (av === null && bv === null) return byName(a, b);
            if (av === null) return 1;
            if (bv === null) return -1;
            return sortDirection === "asc" ? av - bv : bv - av;
        });
        return list;
    }, [
        equipment,
        sortField,
        sortDirection,
        data.processed,
        heroMetric
    ]);
    var average = useMemo23(function() {
        var _data_processed;
        return heroMetric ? averageSelectedEquipmentValue(equipment, (_data_processed = data.processed) !== null && _data_processed !== void 0 ? _data_processed : {}, heroMetric.valueMetricName, selectedEntityIds) : null;
    }, [
        equipment,
        data.processed,
        heroMetric,
        selectedEntityIds
    ]);
    var averageLabel = average !== null ? formatIndicatorValue(average, presentation) : "";
    var activeFilterCount = useMemo23(function() {
        return Object.values(classificationFilters !== null && classificationFilters !== void 0 ? classificationFilters : {}).reduce(function(total, nodes) {
            var _nodes_length;
            return total + ((_nodes_length = nodes === null || nodes === void 0 ? void 0 : nodes.length) !== null && _nodes_length !== void 0 ? _nodes_length : 0);
        }, 0);
    }, [
        classificationFilters
    ]);
    var hasActiveFilter = activeFilterCount > 0;
    var workingSetCount = useMemo23(function() {
        if (!selectedEntityIds || selectedEntityIds.size === 0) {
            return hasActiveFilter ? 0 : equipment.length;
        }
        return equipment.filter(function(e) {
            return selectedEntityIds.has(e.id);
        }).length;
    }, [
        equipment,
        selectedEntityIds,
        hasActiveFilter
    ]);
    var renderTab = function(value, label, ActiveIcon, IdleIcon) {
        var active = tab === value;
        return /* @__PURE__ */ jsxs90("button", {
            type: "button",
            role: "tab",
            id: "equipment-tabbtn-".concat(value),
            "aria-selected": active,
            "aria-controls": "equipment-tabpanel-".concat(value),
            tabIndex: active ? 0 : -1,
            className: "tab ".concat(active ? "active" : "idle"),
            onClick: function() {
                return setTab(value);
            },
            "data-testid": "equipment-tab-".concat(value),
            children: [
                /* @__PURE__ */ jsx132("span", {
                    className: "tab-icon",
                    children: active ? /* @__PURE__ */ jsx132(ActiveIcon, {}) : /* @__PURE__ */ jsx132(IdleIcon, {})
                }),
                /* @__PURE__ */ jsx132("span", {
                    className: "tab-label",
                    children: label
                }),
                value === "filters" && hasActiveFilter && /* @__PURE__ */ jsx132("span", {
                    className: "tab-badge",
                    "data-testid": "equipment-filter-count",
                    children: activeFilterCount
                }),
                active && /* @__PURE__ */ jsx132("span", {
                    className: "tab-underline"
                })
            ]
        });
    };
    var TAB_ORDER = [
        "equipment",
        "filters"
    ];
    var onTabKeyDown = function(e) {
        var _e_currentTarget_querySelector;
        var idx = TAB_ORDER.indexOf(tab);
        var next = null;
        if (e.key === "ArrowRight" || e.key === "ArrowDown") next = TAB_ORDER[(idx + 1) % TAB_ORDER.length];
        else if (e.key === "ArrowLeft" || e.key === "ArrowUp") next = TAB_ORDER[(idx - 1 + TAB_ORDER.length) % TAB_ORDER.length];
        else if (e.key === "Home") next = TAB_ORDER[0];
        else if (e.key === "End") next = TAB_ORDER[TAB_ORDER.length - 1];
        if (!next) return;
        e.preventDefault();
        setTab(next);
        (_e_currentTarget_querySelector = e.currentTarget.querySelector("#equipment-tabbtn-".concat(next))) === null || _e_currentTarget_querySelector === void 0 ? void 0 : _e_currentTarget_querySelector.focus();
    };
    var _heroMetric_name;
    return /* @__PURE__ */ jsxs90("div", {
        className: className,
        "data-testid": "equipment-panel",
        children: [
            /* @__PURE__ */ jsxs90("div", {
                role: "tablist",
                className: "tab-strip",
                onKeyDown: onTabKeyDown,
                children: [
                    renderTab("equipment", "Equipment", Dumbbell24Filled, Dumbbell24Regular),
                    renderTab("filters", "Filters", Filter24Filled, Filter24Regular)
                ]
            }),
            tab === "equipment" && /* @__PURE__ */ jsxs90("div", {
                className: "equipment-tab",
                role: "tabpanel",
                id: "equipment-tabpanel-equipment",
                "aria-labelledby": "equipment-tabbtn-equipment",
                children: [
                    /* @__PURE__ */ jsxs90("div", {
                        className: "summary-header",
                        "data-testid": "equipment-all-header",
                        children: [
                            /* @__PURE__ */ jsxs90("div", {
                                className: "summary-text",
                                children: [
                                    /* @__PURE__ */ jsx132("div", {
                                        className: "summary-title",
                                        children: hasActiveFilter ? "Filtered equipment" : "All equipment"
                                    }),
                                    /* @__PURE__ */ jsxs90("div", {
                                        className: "summary-sub",
                                        children: [
                                            workingSetCount,
                                            " asset",
                                            workingSetCount === 1 ? "" : "s"
                                        ]
                                    })
                                ]
                            }),
                            /* @__PURE__ */ jsx132("div", {
                                className: "summary-value",
                                children: averageLabel
                            })
                        ]
                    }),
                    /* @__PURE__ */ jsx132("div", {
                        className: "sort-row",
                        children: /* @__PURE__ */ jsx132(EquipmentSortControls_default, {
                            sortField: sortField,
                            sortDirection: sortDirection,
                            onSort: handleSort,
                            valueLabel: (_heroMetric_name = heroMetric === null || heroMetric === void 0 ? void 0 : heroMetric.name) !== null && _heroMetric_name !== void 0 ? _heroMetric_name : "Value"
                        })
                    }),
                    /* @__PURE__ */ jsx132(Scrollbar7, {
                        fadeOutEnabled: false,
                        className: "scrollable-container",
                        maxHeight: "calc(100vh - 260px)",
                        children: sortedEquipment.map(function(entity) {
                            return /* @__PURE__ */ jsx132(EquipmentListItem_default, {
                                entity: entity
                            }, entity.id);
                        })
                    })
                ]
            }),
            tab === "filters" && /* @__PURE__ */ jsxs90("div", {
                className: "filters-tab",
                role: "tabpanel",
                id: "equipment-tabpanel-filters",
                "aria-labelledby": "equipment-tabbtn-filters",
                children: [
                    /* @__PURE__ */ jsx132(Scrollbar7, {
                        fadeOutEnabled: false,
                        className: "scrollable-container",
                        maxHeight: "calc(100vh - 210px)",
                        children: /* @__PURE__ */ jsx132(EquipmentFilterTab_default, {})
                    }),
                    /* @__PURE__ */ jsxs90("div", {
                        className: "filters-footer",
                        children: [
                            /* @__PURE__ */ jsx132("span", {
                                className: "filters-summary",
                                "data-testid": "equipment-filter-summary",
                                children: hasActiveFilter ? "".concat(activeFilterCount, " filter").concat(activeFilterCount === 1 ? "" : "s", " applied") : "No filters \u2014 showing the whole twin"
                            }),
                            /* @__PURE__ */ jsx132("button", {
                                type: "button",
                                className: "clear-all",
                                onClick: clearClassificationFilters,
                                "data-testid": "equipment-filter-clear-all",
                                children: "Clear all"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var EquipmentPanel_default = styled96(EquipmentPanel)(_templateObject222(), INTER_FONT_FAMILY, INTER_FONT_FAMILY, INTER_FONT_FAMILY);
// src/components/Calendar/Calendar.tsx
import { AppMode as AppMode6, TimeUnit as TimeUnit2 } from "@repo/frontend-types";
import { useState as useState70 } from "react";
import styled100 from "styled-components";
import { useModeContext as useModeContext9, useFilterContext as useFilterContext15 } from "@repo/front-end-state";
import { stringToTimeUnit } from "@repo/front-end-utils";
import { Calendar24Filled, Calendar24Regular, CalendarWeekNumbers24Filled, CalendarWeekNumbers24Regular } from "@fluentui/react-icons";
// src/components/Calendar/CalendarMonthView.tsx
import { AppMode as AppMode5, DataMode, FilterType as FilterType5, IndicatorColor } from "@repo/frontend-types";
import { useCallback as useCallback22, useEffect as useEffect44, useMemo as useMemo25, useRef as useRef27, useState as useState66 } from "react";
import { DateTime as DateTime3 } from "luxon";
import { useUserStore as useUserStore17, useSettingsStore as useSettingsStore4, useTwinContext as useTwinContext8, useFilterContext as useFilterContext13, useModeContext as useModeContext8 } from "@repo/front-end-state";
import { findEntityById } from "@repo/front-end-utils";
import { generateCalendarMonth } from "@repo/front-end-utils";
import { getIndicatorColor as getIndicatorColor2 } from "@repo/front-end-utils";
import { isSameDate } from "@repo/front-end-utils";
import { warnMissingIndicatorConfig as warnMissingIndicatorConfig2 } from "@repo/front-end-utils";
// src/components/Calendar/CalendarTotals.tsx
import { useMemo as useMemo24 } from "react";
import { useDataContext as useDataContext5, useFilterContext as useFilterContext11 } from "@repo/front-end-state";
// src/components/Calendar/CalendarTotalsStrip.tsx
import styled97 from "styled-components";
import { InlineBars } from "@repo/design-system";
// src/components/Calendar/calendarTotalsBars.ts
import { getIndicatorColor, roundToOneDecimalPlace, warnMissingIndicatorConfig } from "@repo/front-end-utils";
var NO_INDICATOR_CONFIG_FILL = "#FFFFFF";
var toInlineBars = function(bars, indicatorConfig, inSelection, metricName) {
    if (!indicatorConfig) warnMissingIndicatorConfig(metricName);
    return bars.map(function(bar) {
        if (bar.value === 0) {
            return {
                label: bar.weekDay,
                value: null
            };
        }
        var rounded = roundToOneDecimalPlace(bar.value);
        var colours = indicatorConfig ? getIndicatorColor(bar.indicatorValue, indicatorConfig, inSelection) : void 0;
        return {
            label: bar.weekDay,
            value: rounded,
            displayValue: rounded.toFixed(1),
            color: colours ? colours.bgColor : NO_INDICATOR_CONFIG_FILL,
            // The indicator config declares a text colour per band precisely because several
            // bands are dark (production carries #707070…#303030 unselected above 40%, and
            // #A24489/#D2377A selected above 100%, all with text_color #FFFFFF). ECharts picked
            // the label colour from the bar's luminance; using the config's own value honours
            // data the product already carries and keeps the colour logic out of the element.
            labelColor: colours === null || colours === void 0 ? void 0 : colours.textColor
        };
    });
};
var summariseTotals = function(inlineBars) {
    return "Total by weekday: ".concat(inlineBars.map(function(bar) {
        var _bar_displayValue;
        return "".concat(bar.label, " ").concat((_bar_displayValue = bar.displayValue) !== null && _bar_displayValue !== void 0 ? _bar_displayValue : "0.0");
    }).join(", "));
};
// src/components/Calendar/CalendarTotalsStrip.tsx
import { jsx as jsx133, jsxs as jsxs91 } from "react/jsx-runtime";
var ChartRow = styled97.div(_templateObject223());
var TotalColumn = styled97.div(_templateObject224());
var TotalLabel = styled97.p(_templateObject225());
var StripColumn = styled97.div(_templateObject226());
var STRIP_HEIGHT = 40;
var BAR_WIDTH = 43;
var CalendarTotalsStrip = function(param) {
    var className = param.className, bars = param.bars, indicatorConfig = param.indicatorConfig, inSelection = param.inSelection, metricName = param.metricName;
    var inlineBars = toInlineBars(bars, indicatorConfig, inSelection, metricName);
    return /* @__PURE__ */ jsx133("div", {
        className: className,
        children: /* @__PURE__ */ jsxs91(ChartRow, {
            children: [
                /* @__PURE__ */ jsx133(TotalColumn, {
                    children: /* @__PURE__ */ jsx133(TotalLabel, {
                        children: "Total"
                    })
                }),
                /* @__PURE__ */ jsx133(StripColumn, {
                    children: /* @__PURE__ */ jsx133(InlineBars, {
                        bars: inlineBars,
                        height: STRIP_HEIGHT,
                        barWidth: BAR_WIDTH,
                        baseline: true,
                        ariaLabel: summariseTotals(inlineBars)
                    })
                })
            ]
        })
    });
};
var CalendarTotalsStrip_default = CalendarTotalsStrip;
// src/components/Calendar/calendarTotalsPrep.ts
import { DateTime as DateTime2 } from "luxon";
import { averageWeekValuesForBids, findObjectByPropertyValue as findObjectByPropertyValue2 } from "@repo/front-end-utils";
var WEEK_DAYS = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
];
var zeroBars = function() {
    return WEEK_DAYS.map(function(day) {
        return {
            weekDay: day,
            value: 0,
            indicatorValue: 0
        };
    });
};
var hasTimeWindowsInCurrentWeek = function(weekViewDateTime, timeWindows) {
    if (!timeWindows || timeWindows.length === 0) {
        return false;
    }
    var weekStart = DateTime2.fromISO(weekViewDateTime).startOf("day");
    var weekEnd = weekStart.plus({
        days: 6
    }).endOf("day");
    return timeWindows.some(function(param) {
        var _param = _sliced_to_array(param, 2), startISO = _param[0], endISO = _param[1];
        var windowStart = DateTime2.fromISO(startISO);
        var windowEnd = DateTime2.fromISO(endISO);
        return windowStart < weekEnd && windowEnd > weekStart;
    });
};
var hasTimeWindowsInCurrentMonth = function(monthViewDateTime, timeWindows) {
    if (!timeWindows || timeWindows.length === 0) {
        return false;
    }
    var monthStart = DateTime2.fromJSDate(monthViewDateTime).startOf("month").startOf("day");
    var monthEnd = DateTime2.fromJSDate(monthViewDateTime).endOf("month").endOf("day");
    return timeWindows.some(function(param) {
        var _param = _sliced_to_array(param, 2), startISO = _param[0], endISO = _param[1];
        var windowStart = DateTime2.fromISO(startISO);
        var windowEnd = DateTime2.fromISO(endISO);
        return windowStart < monthEnd && windowEnd > monthStart;
    });
};
var dualMetricBars = function(param) {
    var data = param.data, heroMetric = param.heroMetric, digitalTwinEntity = param.digitalTwinEntity;
    var valueMetric = heroMetric === null || heroMetric === void 0 ? void 0 : heroMetric.valueMetricName;
    var indicatorMetric = heroMetric === null || heroMetric === void 0 ? void 0 : heroMetric.indicatorMetricName;
    if (!(data === null || data === void 0 ? void 0 : data.processed) || !valueMetric || !indicatorMetric || !digitalTwinEntity) {
        return null;
    }
    if (!data.processed[valueMetric] || !data.processed[indicatorMetric]) {
        return null;
    }
    var valueObj = findObjectByPropertyValue2(data.processed[valueMetric], "bID", digitalTwinEntity);
    var indicatorObj = findObjectByPropertyValue2(data.processed[indicatorMetric], "bID", digitalTwinEntity);
    if (!valueObj || !valueObj.weekValues || _type_of(valueObj.weekValues) !== "object") {
        return null;
    }
    return WEEK_DAYS.map(function(day) {
        var _indicatorObj_weekValues;
        return {
            weekDay: day,
            // `||` on both, not `??`: a null / NaN / 0 reading collapses to 0 here, and on the
            // indicator side a real 0 falls back to the day's value. Both are the retired
            // components' semantics and both are pinned by tests.
            value: valueObj.weekValues[day] || 0,
            indicatorValue: (indicatorObj === null || indicatorObj === void 0 ? void 0 : (_indicatorObj_weekValues = indicatorObj.weekValues) === null || _indicatorObj_weekValues === void 0 ? void 0 : _indicatorObj_weekValues[day]) || valueObj.weekValues[day] || 0
        };
    });
};
var aggregationBars = function(weekdayAggregation) {
    if (!weekdayAggregation || (typeof weekdayAggregation === "undefined" ? "undefined" : _type_of(weekdayAggregation)) !== "object") {
        return zeroBars();
    }
    var aggregation = weekdayAggregation;
    var bars = WEEK_DAYS.map(function(day) {
        var value = aggregation[day] || 0;
        return {
            weekDay: day,
            value: value,
            indicatorValue: value
        };
    });
    return bars.some(function(bar) {
        return bar.value > 0;
    }) ? bars : zeroBars();
};
var prepareWeekTotals = function(param) {
    var weekViewDateTime = param.weekViewDateTime, timeWindows = param.timeWindows, weekdayAggregation = param.weekdayAggregation, data = param.data, heroMetric = param.heroMetric, digitalTwinEntity = param.digitalTwinEntity;
    var inSelection = hasTimeWindowsInCurrentWeek(weekViewDateTime, timeWindows || []);
    if (inSelection) {
        var _dualMetricBars;
        return {
            bars: (_dualMetricBars = dualMetricBars({
                data: data,
                heroMetric: heroMetric,
                digitalTwinEntity: digitalTwinEntity
            })) !== null && _dualMetricBars !== void 0 ? _dualMetricBars : zeroBars(),
            inSelection: inSelection
        };
    }
    return {
        bars: aggregationBars(weekdayAggregation),
        inSelection: inSelection
    };
};
var prepareMonthTotals = function(param) {
    var monthViewDateTime = param.monthViewDateTime, timeWindows = param.timeWindows, weekdayAggregation = param.weekdayAggregation, data = param.data, heroMetric = param.heroMetric, digitalTwinEntity = param.digitalTwinEntity;
    var inSelection = hasTimeWindowsInCurrentMonth(monthViewDateTime, timeWindows || []);
    if (inSelection) {
        var _dualMetricBars;
        return {
            bars: (_dualMetricBars = dualMetricBars({
                data: data,
                heroMetric: heroMetric,
                digitalTwinEntity: digitalTwinEntity
            })) !== null && _dualMetricBars !== void 0 ? _dualMetricBars : zeroBars(),
            inSelection: inSelection
        };
    }
    return {
        bars: aggregationBars(weekdayAggregation),
        inSelection: inSelection
    };
};
var prepareInsightsTotals = function(param) {
    var data = param.data, heroMetric = param.heroMetric, digitalTwinEntity = param.digitalTwinEntity, entityScope = param.entityScope;
    var inSelection = true;
    var valueMetric = heroMetric === null || heroMetric === void 0 ? void 0 : heroMetric.valueMetricName;
    var indicatorMetric = heroMetric === null || heroMetric === void 0 ? void 0 : heroMetric.indicatorMetricName;
    if (!(data === null || data === void 0 ? void 0 : data.processed) || !valueMetric || !indicatorMetric) {
        return {
            bars: zeroBars(),
            inSelection: inSelection
        };
    }
    if (!data.processed[valueMetric] || !data.processed[indicatorMetric]) {
        return {
            bars: zeroBars(),
            inSelection: inSelection
        };
    }
    if ((entityScope === null || entityScope === void 0 ? void 0 : entityScope.kind) === "set") {
        var valueWeek = averageWeekValuesForBids(data.processed, valueMetric, entityScope.bids);
        var indicatorWeek = averageWeekValuesForBids(data.processed, indicatorMetric, entityScope.bids);
        return {
            bars: WEEK_DAYS.map(function(day) {
                var _valueWeek_day, _indicatorWeek_day, _ref;
                return {
                    weekDay: day,
                    value: (_valueWeek_day = valueWeek[day]) !== null && _valueWeek_day !== void 0 ? _valueWeek_day : 0,
                    // Nullish (not `||`) so a real 0 indicator mean keeps its own colour instead of
                    // falling back to the value mean; `averageWeekValuesForBids` omits days with no
                    // contributor, so a missing day is `undefined` and still defaults to 0.
                    indicatorValue: (_ref = (_indicatorWeek_day = indicatorWeek[day]) !== null && _indicatorWeek_day !== void 0 ? _indicatorWeek_day : valueWeek[day]) !== null && _ref !== void 0 ? _ref : 0
                };
            }),
            inSelection: inSelection
        };
    }
    var _dualMetricBars;
    return {
        bars: (_dualMetricBars = dualMetricBars({
            data: data,
            heroMetric: heroMetric,
            digitalTwinEntity: digitalTwinEntity
        })) !== null && _dualMetricBars !== void 0 ? _dualMetricBars : zeroBars(),
        inSelection: inSelection
    };
};
// src/components/Calendar/CalendarTotals.tsx
import { jsx as jsx134 } from "react/jsx-runtime";
var useTotalsContext = function() {
    var _useFilterContext11 = useFilterContext11(), heroMetric = _useFilterContext11.heroMetric, timeWindows = _useFilterContext11.timeWindows;
    var data = useDataContext5().data;
    return {
        heroMetric: heroMetric,
        timeWindows: timeWindows,
        data: data
    };
};
var CalendarWeekTotals = function(param) {
    var className = param.className, weekViewDateTime = param.weekViewDateTime, weekdayAggregation = param.weekdayAggregation, digitalTwinEntity = param.digitalTwinEntity;
    var _useTotalsContext = useTotalsContext(), heroMetric = _useTotalsContext.heroMetric, timeWindows = _useTotalsContext.timeWindows, data = _useTotalsContext.data;
    var totals = useMemo24(function() {
        return prepareWeekTotals({
            weekViewDateTime: weekViewDateTime,
            weekdayAggregation: weekdayAggregation,
            digitalTwinEntity: digitalTwinEntity,
            timeWindows: timeWindows,
            data: data,
            heroMetric: heroMetric
        });
    }, [
        weekViewDateTime,
        weekdayAggregation,
        digitalTwinEntity,
        timeWindows,
        data,
        heroMetric
    ]);
    return /* @__PURE__ */ jsx134(CalendarTotalsStrip_default, {
        className: className,
        bars: totals.bars,
        indicatorConfig: heroMetric === null || heroMetric === void 0 ? void 0 : heroMetric.indicatorConfig,
        metricName: heroMetric === null || heroMetric === void 0 ? void 0 : heroMetric.name,
        inSelection: totals.inSelection
    });
};
var CalendarMonthTotals = function(param) {
    var className = param.className, monthViewDateTime = param.monthViewDateTime, weekdayAggregation = param.weekdayAggregation, digitalTwinEntity = param.digitalTwinEntity;
    var _useTotalsContext = useTotalsContext(), heroMetric = _useTotalsContext.heroMetric, timeWindows = _useTotalsContext.timeWindows, data = _useTotalsContext.data;
    var totals = useMemo24(function() {
        return prepareMonthTotals({
            monthViewDateTime: monthViewDateTime,
            weekdayAggregation: weekdayAggregation,
            digitalTwinEntity: digitalTwinEntity,
            timeWindows: timeWindows,
            data: data,
            heroMetric: heroMetric
        });
    }, [
        monthViewDateTime,
        weekdayAggregation,
        digitalTwinEntity,
        timeWindows,
        data,
        heroMetric
    ]);
    return /* @__PURE__ */ jsx134(CalendarTotalsStrip_default, {
        className: className,
        bars: totals.bars,
        indicatorConfig: heroMetric === null || heroMetric === void 0 ? void 0 : heroMetric.indicatorConfig,
        metricName: heroMetric === null || heroMetric === void 0 ? void 0 : heroMetric.name,
        inSelection: totals.inSelection
    });
};
var InsightsCalendarTotals = function(param) {
    var className = param.className, digitalTwinEntity = param.digitalTwinEntity, entityScope = param.entityScope;
    var _useTotalsContext = useTotalsContext(), heroMetric = _useTotalsContext.heroMetric, data = _useTotalsContext.data;
    var totals = useMemo24(function() {
        return prepareInsightsTotals({
            digitalTwinEntity: digitalTwinEntity,
            entityScope: entityScope,
            data: data,
            heroMetric: heroMetric
        });
    }, [
        digitalTwinEntity,
        entityScope,
        data,
        heroMetric
    ]);
    return /* @__PURE__ */ jsx134(CalendarTotalsStrip_default, {
        className: className,
        bars: totals.bars,
        indicatorConfig: heroMetric === null || heroMetric === void 0 ? void 0 : heroMetric.indicatorConfig,
        metricName: heroMetric === null || heroMetric === void 0 ? void 0 : heroMetric.name,
        inSelection: totals.inSelection
    });
};
// src/components/Calendar/CalendarSelectionOverlay.tsx
import { useEffect as useEffect43, useState as useState65 } from "react";
import styled98 from "styled-components";
import { useFilterContext as useFilterContext12, useModeContext as useModeContext7, useDataContext as useDataContext6 } from "@repo/front-end-state";
import { dataModeFor as dataModeFor2, getDataValue as getDataValue2, getIndicator as getIndicator2, modeConfigFor as modeConfigFor3 } from "@repo/front-end-utils";
import { Fragment as Fragment29, jsx as jsx135, jsxs as jsxs92 } from "react/jsx-runtime";
var CalendarSelectionOverlay = function(param) {
    var className = param.className, digitalTwinEntity = param.digitalTwinEntity, entityCapacity = param.entityCapacity;
    var heroMetric = useFilterContext12().heroMetric;
    var data = useDataContext6().data;
    var appMode = useModeContext7().appMode;
    var _useState65 = _sliced_to_array(useState65(null), 2), indicatorColor = _useState65[0], setIndicatorColor = _useState65[1];
    var _useState651 = _sliced_to_array(useState65(null), 2), indicatorValue = _useState651[0], setIndicatorValue = _useState651[1];
    var _useState652 = _sliced_to_array(useState65(""), 2), indicatorUnit = _useState652[0], setIndicatorUnit = _useState652[1];
    useEffect43(function() {
        setIndicatorValue(null);
        setIndicatorColor(null);
        setIndicatorUnit("");
        if (!(data === null || data === void 0 ? void 0 : data.processed) || !(heroMetric === null || heroMetric === void 0 ? void 0 : heroMetric.valueMetricName) || !digitalTwinEntity) {
            return;
        }
        var presentation = modeConfigFor3(heroMetric, appMode);
        var metricData = data.processed[heroMetric.valueMetricName] || [];
        var indicatorData = data.processed[heroMetric.indicatorMetricName] || [];
        var metricValue = getDataValue2(dataModeFor2(appMode), metricData, digitalTwinEntity);
        var indicatorValue2 = getDataValue2(dataModeFor2(appMode), indicatorData, digitalTwinEntity);
        if (!metricValue || !indicatorValue2) {
            return;
        }
        var indicator = getIndicator2(metricValue, // Raw metric value (for display)
        indicatorValue2, // Raw indicator value (for color calculation)
        heroMetric === null || heroMetric === void 0 ? void 0 : heroMetric.indicatorConfig, // Color rules and thresholds
        true, // Always selected state for overlay highlighting
        presentation === null || presentation === void 0 ? void 0 : presentation.showDecimalPlace, // Use hero metric's decimal setting
        presentation === null || presentation === void 0 ? void 0 : presentation.showUnit, // Use hero metric's unit setting
        presentation === null || presentation === void 0 ? void 0 : presentation.unit, // Use presentation unit from hero metric config
        // colour-editor M2.2. This is the ONE calendar site that can actually reach
        // `getIndicatorColor`'s miss branch, and it omitted the 8th argument even though the name was
        // in scope — so the warning was gated off on the only path that could fire it. The argument
        // gates a `console.warn` and nothing else; no colour changes.
        heroMetric === null || heroMetric === void 0 ? void 0 : heroMetric.name);
        if (indicator) {
            var _indicator_value;
            setIndicatorValue(((_indicator_value = indicator.value) === null || _indicator_value === void 0 ? void 0 : _indicator_value.toFixed(1)) || "0");
            setIndicatorUnit(indicator.unit || "");
            setIndicatorColor(indicator.colors.bgColor);
        } else {
            setIndicatorValue(metricValue.value.toFixed(1));
            setIndicatorUnit((presentation === null || presentation === void 0 ? void 0 : presentation.unit) || "");
            setIndicatorColor("#FFFFFF");
        }
    }, [
        data,
        heroMetric,
        digitalTwinEntity,
        entityCapacity,
        appMode
    ]);
    return /* @__PURE__ */ jsx135(Fragment29, {
        children: indicatorValue && indicatorColor ? /* @__PURE__ */ jsx135("div", {
            className: className,
            children: /* @__PURE__ */ jsxs92("div", {
                className: "selection-overlay",
                children: [
                    /* @__PURE__ */ jsx135("div", {
                        className: "selection-overlay-value",
                        children: /* @__PURE__ */ jsx135(Indicator_default, {
                            backgroundColor: parseFloat(indicatorValue) ? indicatorColor : "#FFFFFF",
                            value: parseFloat(indicatorValue) ? indicatorValue : "-"
                        })
                    }),
                    /* @__PURE__ */ jsx135("div", {
                        className: "selection-overlay-arrow"
                    })
                ]
            })
        }) : null
    });
};
var CalendarSelectionOverlay_default = styled98(CalendarSelectionOverlay)(_templateObject227());
// src/components/Calendar/CalendarMonthView.tsx
import { getCalendarView } from "@repo/front-end-services";
import { jsx as jsx136, jsxs as jsxs93 } from "react/jsx-runtime";
var CalendarMonthView = function(param) {
    var className = param.className, _param_middlewareApi = param.middlewareApi, middlewareApi = _param_middlewareApi === void 0 ? "" : _param_middlewareApi, aggregation = param.aggregation;
    var _useFilterContext13 = useFilterContext13(), historicalReset = _useFilterContext13.historicalReset, filter = _useFilterContext13.filter, heroMetric = _useFilterContext13.heroMetric, timeWindows = _useFilterContext13.timeWindows, autoSelectCalendar = _useFilterContext13.autoSelectCalendar, setTimeWindows = _useFilterContext13.setTimeWindows, setAutoSelectCalendar = _useFilterContext13.setAutoSelectCalendar, setHistoricalReset = _useFilterContext13.setHistoricalReset;
    var setAppModeWithFilterReset = useModeContext8().setAppModeWithFilterReset;
    var settings = useSettingsStore4().settings;
    var twin = useTwinContext8().twin;
    var authMetadata = useUserStore17().authMetadata;
    var currentDateTime = /* @__PURE__ */ new Date();
    var timeZone = (settings === null || settings === void 0 ? void 0 : settings.timeZone) ? settings.timeZone : Intl.DateTimeFormat().resolvedOptions().timeZone;
    var _useState66 = _sliced_to_array(useState66(currentDateTime), 2), monthViewDateTime = _useState66[0], setMonthViewDateTime = _useState66[1];
    var _useState661 = _sliced_to_array(useState66([]), 2), calendarMonth = _useState661[0], setCalendarMonth = _useState661[1];
    var _useState662 = _sliced_to_array(useState66(null), 2), weekdayAggregation = _useState662[0], setWeekdayAggregation = _useState662[1];
    var totalCap = 0;
    if (twin && twin.totalCapacity) {
        totalCap = twin.totalCapacity;
    }
    if (totalCap === 0) {
        throw new Error("Unable to render MonthView calendar. Digital Twin is missing total capacity");
    }
    var digitalTwinEntity = useMemo25(function() {
        var entity = twin === null || twin === void 0 ? void 0 : twin.physicalModel.bID;
        var physicalEntityFilters = filter.filter(function(item) {
            return item.type === FilterType5.ENTITY;
        });
        if (physicalEntityFilters && physicalEntityFilters.length > 0) {
            entity = physicalEntityFilters[physicalEntityFilters.length - 1].bId;
        }
        return entity;
    }, [
        twin,
        filter
    ]);
    var entityCapacity = useMemo25(function() {
        var capacity = 0;
        if (twin && digitalTwinEntity) {
            var entity = findEntityById(DataMode.TIME_SERIES, [
                twin.physicalModel
            ], digitalTwinEntity);
            capacity = entity ? entity["capacity"] : 0;
        }
        return capacity;
    }, [
        digitalTwinEntity,
        twin
    ]);
    var updateDateCount = function(dateToUpdate, value, indicatorValue) {
        setCalendarMonth(function(prevCalendarMonth) {
            return prevCalendarMonth.map(function(week) {
                var updatedDays = week.days.map(function(day) {
                    if (day.dateString === dateToUpdate) {
                        return _object_spread_props(_object_spread({}, day), {
                            value: value,
                            indicatorValue: indicatorValue !== null && indicatorValue !== void 0 ? indicatorValue : value
                        });
                    }
                    return day;
                });
                return _object_spread_props(_object_spread({}, week), {
                    days: updatedDays
                });
            });
        });
    };
    useEffect44(function() {
        if (authMetadata && (authMetadata === null || authMetadata === void 0 ? void 0 : authMetadata.tsdbUrl) && monthViewDateTime) {
            var fetchCalendarData = /*#__PURE__*/ function() {
                var _ref = _async_to_generator(function(startDateTime, finishDateTime) {
                    var queryStartDate, queryFinishDate, _authMetadata_tokens, valueMetric, indicatorMetric, _authMetadata_tokens1, metricsToFetch, data, _data_indicatorMetric_digitalTwinEntity, _data_indicatorMetric, valueData, indicatorData, weekdayAgg, error;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                queryStartDate = DateTime3.fromISO(startDateTime, {
                                    zone: timeZone
                                }).toISO({
                                    suppressMilliseconds: true,
                                    includeOffset: false
                                }) || "";
                                queryFinishDate = DateTime3.fromISO(finishDateTime, {
                                    zone: timeZone
                                }).endOf("day").set({
                                    millisecond: 0
                                }).toISO({
                                    suppressMilliseconds: true,
                                    includeOffset: false
                                }) || "";
                                if (!(settings && settings.organisation && queryStartDate && queryFinishDate)) return [
                                    3,
                                    4
                                ];
                                valueMetric = heroMetric === null || heroMetric === void 0 ? void 0 : heroMetric.valueMetricName;
                                indicatorMetric = heroMetric === null || heroMetric === void 0 ? void 0 : heroMetric.indicatorMetricName;
                                if (!aggregation || !valueMetric || !indicatorMetric) {
                                    if (heroMetric) {
                                        console.warn("[CalendarMonthView] selected hero metric is missing its time-series aggregation, value-metric, or indicator-metric name; rendering empty calendar", {
                                            aggregation: aggregation,
                                            valueMetricName: valueMetric,
                                            indicatorMetricName: indicatorMetric,
                                            heroMetric: heroMetric
                                        });
                                    }
                                    setWeekdayAggregation(null);
                                    return [
                                        2
                                    ];
                                }
                                if (!authMetadata.tsdbUrl) {
                                    throw new Error("Missing analytics endpoint");
                                }
                                if (!(((_authMetadata_tokens = authMetadata.tokens) === null || _authMetadata_tokens === void 0 ? void 0 : _authMetadata_tokens.accessToken) && authMetadata.organisation && (twin === null || twin === void 0 ? void 0 : twin.physicalModel.bID) && digitalTwinEntity)) return [
                                    3,
                                    4
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                metricsToFetch = [
                                    valueMetric
                                ];
                                if (indicatorMetric && indicatorMetric !== valueMetric) {
                                    metricsToFetch.push(indicatorMetric);
                                }
                                return [
                                    4,
                                    getCalendarView(middlewareApi, (_authMetadata_tokens1 = authMetadata.tokens) === null || _authMetadata_tokens1 === void 0 ? void 0 : _authMetadata_tokens1.accessToken, twin === null || twin === void 0 ? void 0 : twin.physicalModel.bID, authMetadata.organisation, digitalTwinEntity, queryStartDate, queryFinishDate, (aggregation || "AVG").toUpperCase(), metricsToFetch, true, false)
                                ];
                            case 2:
                                data = _state.sent();
                                if (data && data[valueMetric] && data[valueMetric][digitalTwinEntity] && data[valueMetric][digitalTwinEntity].data) {
                                    ;
                                    valueData = data[valueMetric][digitalTwinEntity].data;
                                    indicatorData = (_data_indicatorMetric = data[indicatorMetric]) === null || _data_indicatorMetric === void 0 ? void 0 : (_data_indicatorMetric_digitalTwinEntity = _data_indicatorMetric[digitalTwinEntity]) === null || _data_indicatorMetric_digitalTwinEntity === void 0 ? void 0 : _data_indicatorMetric_digitalTwinEntity.data;
                                    Object.entries(valueData).forEach(function(param) {
                                        var _param = _sliced_to_array(param, 2), dateString = _param[0], values = _param[1];
                                        var _indicatorData_dateString;
                                        var displayValue = values[0];
                                        var _indicatorData_dateString_;
                                        var indicatorValue = (_indicatorData_dateString_ = indicatorData === null || indicatorData === void 0 ? void 0 : (_indicatorData_dateString = indicatorData[dateString]) === null || _indicatorData_dateString === void 0 ? void 0 : _indicatorData_dateString[0]) !== null && _indicatorData_dateString_ !== void 0 ? _indicatorData_dateString_ : displayValue;
                                        updateDateCount(dateString, displayValue, indicatorValue);
                                    });
                                    weekdayAgg = data[valueMetric][digitalTwinEntity].weekday_aggregation;
                                    if (weekdayAgg) {
                                        setWeekdayAggregation(weekdayAgg);
                                    }
                                } else {
                                    setWeekdayAggregation(null);
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                console.error("CalendarMonthView: Error fetching calendar data:", error);
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function fetchCalendarData(startDateTime, finishDateTime) {
                    return _ref.apply(this, arguments);
                };
            }();
            var calendarMonth2 = generateCalendarMonth(monthViewDateTime);
            setCalendarMonth(calendarMonth2);
            var startDate;
            var finishDate;
            if (Array.isArray(calendarMonth2)) {
                startDate = calendarMonth2[0].days[0].dateString;
                finishDate = calendarMonth2[4].days[6].dateString;
            }
            if (startDate && finishDate) {
                fetchCalendarData(startDate, finishDate);
            }
        }
    }, [
        authMetadata === null || authMetadata === void 0 ? void 0 : authMetadata.tsdbUrl,
        digitalTwinEntity,
        aggregation,
        heroMetric === null || heroMetric === void 0 ? void 0 : heroMetric.valueMetricName,
        heroMetric === null || heroMetric === void 0 ? void 0 : heroMetric.indicatorMetricName,
        monthViewDateTime,
        settings,
        timeZone,
        twin === null || twin === void 0 ? void 0 : twin.physicalModel.bID
    ]);
    var setMonth = function(currentMonth) {
        setMonthViewDateTime(currentMonth);
        setHideSelectionBox(true);
        if (timeWindows && timeWindows.length > 0) {
            var currentMonthNum = DateTime3.fromJSDate(currentMonth).month;
            var currentYearNum = DateTime3.fromJSDate(currentMonth).year;
            var hasTimeWindowsInNewMonth = timeWindows.some(function(param) {
                var _param = _sliced_to_array(param, 2), startISO = _param[0], endISO = _param[1];
                var windowStart = DateTime3.fromISO(startISO);
                var windowEnd = DateTime3.fromISO(endISO);
                var currentDay = windowStart.startOf("day");
                while(currentDay <= windowEnd.endOf("day")){
                    if (currentDay.month === currentMonthNum && currentDay.year === currentYearNum) {
                        return true;
                    }
                    currentDay = currentDay.plus({
                        days: 1
                    });
                }
                return false;
            });
            if (hasTimeWindowsInNewMonth) {
                setAutoSelectCalendar(true);
            } else {
                resetSelection();
            }
        } else {
            resetSelection();
        }
    };
    var cellWidthModifier2 = 43;
    var cellHeight2 = 32;
    var _useState663 = _sliced_to_array(useState66(false), 2), isDragging = _useState663[0], setIsDragging = _useState663[1];
    var _useState664 = _sliced_to_array(useState66([]), 2), selectedDateTimes = _useState664[0], setSelectedDateTimes = _useState664[1];
    var _useState665 = _sliced_to_array(useState66([]), 2), selectedTimeWindows = _useState665[0], setSelectedTimeWindows = _useState665[1];
    var _useState666 = _sliced_to_array(useState66(false), 2), hideSelectionBox = _useState666[0], setHideSelectionBox = _useState666[1];
    var _useState667 = _sliced_to_array(useState66({
        startX: 0,
        startY: 0,
        width: 0,
        height: 0,
        borderStyle: "dashed"
    }), 2), selectionBox = _useState667[0], setSelectionBox = _useState667[1];
    var _useState668 = _sliced_to_array(useState66(0), 2), initialMouseY = _useState668[0], setInitialMouseY = _useState668[1];
    var _useState669 = _sliced_to_array(useState66(0), 2), initialMouseX = _useState669[0], setInitialMouseX = _useState669[1];
    var gridRef = useRef27(null);
    var weekDays = [
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat",
        "Sun"
    ];
    useEffect44(function() {
        if (historicalReset) {
            resetSelection();
            setHistoricalReset(false);
        }
    }, [
        historicalReset,
        setHistoricalReset
    ]);
    var findMatchingDay = useCallback22(function(data, dateTimeISO) {
        if (!data || !Array.isArray(data) || !dateTimeISO) {
            return null;
        }
        var dateString = dateTimeISO.split("T")[0];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var week = _step.value;
                if (!week || !week.days || !Array.isArray(week.days)) {
                    continue;
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = week.days[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var day = _step1.value;
                        if (!day || !day.dateString) {
                            continue;
                        }
                        if (day.dateString === dateString) {
                            var cellValue = day.value;
                            var percentage = day.value ? day.value / entityCapacity * 100 : 0;
                            var selectedCellValue = {
                                dateTimeISO: dateTimeISO,
                                value: day.value,
                                pc: percentage,
                                cellValue: cellValue
                            };
                            return selectedCellValue;
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return null;
    }, [
        digitalTwinEntity,
        entityCapacity,
        heroMetric === null || heroMetric === void 0 ? void 0 : heroMetric.valueMetricName,
        twin
    ]);
    var handleMouseDown = function(event) {
        setHideSelectionBox(false);
        if (!gridRef.current) return;
        var gridRect = gridRef.current.getBoundingClientRect();
        var clientX = event.clientX, clientY = event.clientY;
        var relativeX = clientX - gridRect.left;
        var relativeY = clientY - gridRect.top;
        setIsDragging(true);
        setInitialMouseY(relativeY);
        setInitialMouseX(relativeX);
        setSelectionBox({
            startX: relativeX,
            startY: relativeY,
            width: 0,
            height: 0,
            borderStyle: "dashed"
        });
    };
    var handleMouseMove = function(event) {
        if (!isDragging || !gridRef.current) return;
        var clientX = event.clientX, clientY = event.clientY;
        var sbp = calcSelectionBoxPosition(gridRef, clientX, clientY, calendarMonth.length);
        if (sbp) {
            if (sbp.relativeY > initialMouseY && sbp.relativeX > initialMouseX) {
                var selectedDateTimes2 = [];
                var selectedTimeWindows2 = [];
                for(var row = Math.min(sbp.startRow, sbp.endRow); row < Math.max(sbp.startRow, sbp.endRow); row++){
                    for(var col = Math.min(sbp.startCol, sbp.endCol); col < Math.max(sbp.startCol, sbp.endCol); col++){
                        var week = calendarMonth[row - 1];
                        var day = week.days[col - 1];
                        var selectedDateTime = DateTime3.fromJSDate(day.date);
                        var selectedDateTimeISO = selectedDateTime.toISO({
                            suppressMilliseconds: true,
                            includeOffset: false
                        });
                        selectedDateTimes2.push(selectedDateTimeISO ? selectedDateTimeISO : "");
                        var startOfDay = selectedDateTime.startOf("day").toISO({
                            includeOffset: false
                        });
                        var endOfDay = selectedDateTime.endOf("day").toISO({
                            includeOffset: false
                        });
                        selectedTimeWindows2.push([
                            startOfDay || "",
                            endOfDay || ""
                        ]);
                    }
                }
                setSelectedDateTimes(selectedDateTimes2);
                setSelectedTimeWindows(selectedTimeWindows2);
                setSelectionBox({
                    startX: sbp.snapStartX,
                    startY: sbp.snapStartY,
                    width: Math.abs(sbp.snapEndX - sbp.snapStartX),
                    height: Math.abs(sbp.snapEndY - sbp.snapStartY),
                    borderStyle: "dashed"
                });
            }
        }
    };
    var handleMouseClick = function(event) {
        if (!gridRef.current) return;
        var clientX = event.clientX, clientY = event.clientY;
        var sbp = calcSelectionBoxPosition(gridRef, clientX, clientY, calendarMonth.length);
        if (sbp) {
            var selectedDateTimes2 = [];
            var selectedTimeWindows2 = [];
            for(var row = Math.min(sbp.startRow, sbp.endRow); row < Math.max(sbp.startRow, sbp.endRow); row++){
                for(var col = Math.min(sbp.startCol, sbp.endCol); col < Math.max(sbp.startCol, sbp.endCol); col++){
                    var week = calendarMonth[row - 1];
                    var day = week.days[col - 1];
                    var selectedDateTime = DateTime3.fromJSDate(day.date);
                    var selectedDateTimeISO = selectedDateTime.toISO({
                        suppressMilliseconds: true,
                        includeOffset: false
                    });
                    selectedDateTimes2.push(selectedDateTimeISO ? selectedDateTimeISO : "");
                    var startOfDay = selectedDateTime.startOf("day").toISO({
                        includeOffset: false
                    });
                    var endOfDay = selectedDateTime.endOf("day").toISO({
                        includeOffset: false
                    });
                    selectedTimeWindows2.push([
                        startOfDay || "",
                        endOfDay || ""
                    ]);
                }
            }
            setSelectedDateTimes(selectedDateTimes2);
            setSelectedTimeWindows(selectedTimeWindows2);
            setSelectionBox({
                startX: sbp.snapStartX,
                startY: sbp.snapStartY,
                width: Math.abs(sbp.snapEndX - sbp.snapStartX),
                height: Math.abs(sbp.snapEndY - sbp.snapStartY),
                borderStyle: "solid"
            });
        }
    };
    var handleMouseUp = function() {
        setIsDragging(false);
        setSelectionBox(_object_spread_props(_object_spread({}, selectionBox), {
            borderStyle: "solid"
        }));
    };
    var resetSelection = function() {
        setSelectedDateTimes([]);
        setSelectedTimeWindows([]);
        setHideSelectionBox(true);
    };
    var autoSelect = useCallback22(function(inputTimeWindows) {
        if (!inputTimeWindows || inputTimeWindows.length === 0) {
            resetSelection();
            return;
        }
        var selectedDateTimes2 = [];
        var selectedTimeWindows2 = [];
        var uniqueDates = /* @__PURE__ */ new Set();
        inputTimeWindows.forEach(function(param) {
            var _param = _sliced_to_array(param, 2), start = _param[0], end = _param[1];
            var startDate = DateTime3.fromISO(start).toISODate();
            var endDate = DateTime3.fromISO(end).toISODate();
            if (startDate) uniqueDates.add(startDate);
            if (endDate && endDate !== startDate) uniqueDates.add(endDate);
        });
        uniqueDates.forEach(function(dateString) {
            var cellValue = "".concat(dateString, "T00:00:00");
            var foundDay = findMatchingDay(calendarMonth, cellValue);
            if (foundDay) {
                selectedDateTimes2.push(cellValue);
                var dayStart = "".concat(dateString, "T00:00:00");
                var dayEnd = "".concat(dateString, "T23:59:59");
                selectedTimeWindows2.push([
                    dayStart,
                    dayEnd
                ]);
            }
        });
        if (selectedDateTimes2.length > 0 && gridRef.current) {
            var minRow = Infinity;
            var maxRow = -Infinity;
            var minCol = Infinity;
            var maxCol = -Infinity;
            var hasVisibleSelections = false;
            selectedDateTimes2.forEach(function(dateTimeISO) {
                var _dateTimeISO_split = _sliced_to_array(dateTimeISO.split("T"), 1), dateISO = _dateTimeISO_split[0];
                calendarMonth.forEach(function(week, weekIndex) {
                    week.days.forEach(function(day, dayIndex) {
                        if (day.dateString === dateISO) {
                            minCol = Math.min(minCol, dayIndex);
                            maxCol = Math.max(maxCol, dayIndex);
                            minRow = Math.min(minRow, weekIndex);
                            maxRow = Math.max(maxRow, weekIndex);
                            hasVisibleSelections = true;
                        }
                    });
                });
            });
            if (hasVisibleSelections && minRow !== Infinity && minCol !== Infinity) {
                var gridRect = gridRef.current.getBoundingClientRect();
                var adjustedCellWidth = (gridRect.width - cellWidthModifier2) / 7;
                var adjustedCellHeight = (gridRect.height - gridRef.current.querySelector("thead").clientHeight) / calendarMonth.length;
                var startX = (minCol + 1) * adjustedCellWidth;
                var theadHeight = gridRef.current.querySelector("thead").clientHeight;
                var startY = theadHeight + minRow * adjustedCellHeight;
                var endX = (maxCol + 2) * adjustedCellWidth;
                var endY = theadHeight + (maxRow + 1) * adjustedCellHeight;
                setSelectionBox({
                    startX: startX,
                    startY: startY,
                    width: endX - startX,
                    height: endY - startY,
                    borderStyle: "solid"
                });
            } else {
                setHideSelectionBox(true);
            }
        } else {
            setHideSelectionBox(true);
        }
        setHideSelectionBox(selectedDateTimes2.length === 0);
        setSelectedDateTimes(selectedDateTimes2);
        setSelectedTimeWindows(selectedTimeWindows2);
        setAutoSelectCalendar(false);
    }, [
        calendarMonth,
        findMatchingDay,
        setAutoSelectCalendar
    ]);
    useEffect44(function() {
        if (autoSelectCalendar) {
            if (timeWindows === null) {
                resetSelection();
            } else if (timeWindows && timeWindows.length > 0) {
                autoSelect(timeWindows);
            }
            setTimeout(function() {
                setAutoSelectCalendar(false);
            }, 0);
        }
    }, [
        timeWindows,
        autoSelectCalendar,
        autoSelect,
        setAutoSelectCalendar
    ]);
    useEffect44(function() {
        if (timeWindows && timeWindows.length > 0 && (!selectedDateTimes || selectedDateTimes.length === 0)) {
            var currentMonth = DateTime3.fromJSDate(monthViewDateTime).month;
            var currentYear = DateTime3.fromJSDate(monthViewDateTime).year;
            var hasTimeWindowsInCurrentMonth2 = timeWindows.some(function(param) {
                var _param = _sliced_to_array(param, 2), startISO = _param[0], endISO = _param[1];
                var windowStart = DateTime3.fromISO(startISO);
                var windowEnd = DateTime3.fromISO(endISO);
                var currentDay = windowStart.startOf("day");
                while(currentDay <= windowEnd.endOf("day")){
                    if (currentDay.month === currentMonth && currentDay.year === currentYear) {
                        return true;
                    }
                    currentDay = currentDay.plus({
                        days: 1
                    });
                }
                return false;
            });
            if (hasTimeWindowsInCurrentMonth2) {
                setAutoSelectCalendar(true);
            }
        }
    }, [
        timeWindows,
        selectedDateTimes,
        monthViewDateTime,
        setAutoSelectCalendar
    ]);
    var calcSelectionBoxPosition = function(gridRef2, clientX, clientY, numOfWeeks) {
        if (!gridRef2.current) return;
        var gridRect = gridRef2.current.getBoundingClientRect();
        var relativeX = clientX - gridRect.left;
        var relativeY = clientY - gridRect.top;
        var adjustedCellWidth = (gridRect.width - cellWidthModifier2) / 7;
        var adjustedCellHeight = (gridRect.height - gridRef2.current.querySelector("thead").clientHeight) / numOfWeeks;
        var startCol = Math.floor(initialMouseX / adjustedCellWidth);
        var startRow = Math.floor(initialMouseY / adjustedCellHeight);
        var endCol = Math.ceil(relativeX / adjustedCellWidth);
        var endRow = Math.ceil(relativeY / adjustedCellHeight);
        var snapStartX = startCol * adjustedCellWidth;
        var snapStartY = startRow * adjustedCellHeight;
        var snapEndX = endCol * adjustedCellWidth;
        var snapEndY = endRow * adjustedCellHeight;
        return {
            relativeX: relativeX,
            relativeY: relativeY,
            startCol: startCol,
            startRow: startRow,
            endCol: endCol,
            endRow: endRow,
            snapStartX: snapStartX,
            snapStartY: snapStartY,
            snapEndX: snapEndX,
            snapEndY: snapEndY
        };
    };
    useEffect44(function() {
        if (!historicalReset && !isDragging && !autoSelectCalendar && selectedTimeWindows && selectedTimeWindows.length > 0) {
            setAutoSelectCalendar(false);
            setAppModeWithFilterReset(AppMode5.HISTORICAL);
            setTimeWindows(selectedTimeWindows);
        }
    }, [
        historicalReset,
        isDragging,
        autoSelectCalendar,
        selectedTimeWindows,
        setAppModeWithFilterReset,
        setTimeWindows,
        setAutoSelectCalendar
    ]);
    return /* @__PURE__ */ jsxs93("div", {
        className: className,
        children: [
            /* @__PURE__ */ jsx136(CalendarMonthTotals, {
                monthViewDateTime: monthViewDateTime,
                digitalTwinEntity: digitalTwinEntity,
                weekdayAggregation: weekdayAggregation
            }),
            /* @__PURE__ */ jsx136(MonthStepper_default, {
                monthViewDateTime: monthViewDateTime,
                setMonth: setMonth
            }),
            monthViewDateTime && /* @__PURE__ */ jsx136("div", {
                children: /* @__PURE__ */ jsxs93("div", {
                    style: {
                        marginTop: "1rem",
                        position: "relative"
                    },
                    onMouseUp: handleMouseUp,
                    children: [
                        /* @__PURE__ */ jsxs93("table", {
                            id: "duration",
                            ref: gridRef,
                            onMouseMove: handleMouseMove,
                            children: [
                                /* @__PURE__ */ jsx136("thead", {
                                    children: /* @__PURE__ */ jsxs93("tr", {
                                        children: [
                                            /* @__PURE__ */ jsx136("th", {}),
                                            weekDays.map(function(wd, i) {
                                                return /* @__PURE__ */ jsx136("th", {
                                                    style: {
                                                        verticalAlign: "middle",
                                                        width: "".concat(cellWidthModifier2, "px"),
                                                        height: "".concat(cellHeight2, "px"),
                                                        fontSize: "10px",
                                                        textAlign: "center",
                                                        color: "#7A7A7A"
                                                    },
                                                    children: wd
                                                }, i);
                                            })
                                        ]
                                    })
                                }),
                                /* @__PURE__ */ jsx136("tbody", {
                                    children: calendarMonth.map(function(cm, i) {
                                        return /* @__PURE__ */ jsxs93("tr", {
                                            children: [
                                                /* @__PURE__ */ jsxs93("th", {
                                                    style: {
                                                        verticalAlign: "middle",
                                                        width: "".concat(cellWidthModifier2, "px"),
                                                        height: "".concat(cellHeight2, "px"),
                                                        fontSize: "10px",
                                                        fontWeight: "normal",
                                                        textAlign: "center"
                                                    },
                                                    children: [
                                                        "W",
                                                        cm.weekNo
                                                    ]
                                                }),
                                                cm.days.map(function(day, i2) {
                                                    var cellValue = "".concat(day.dateString, "T00:00:00");
                                                    var selected;
                                                    if (selectedDateTimes && selectedDateTimes.length === 0) {
                                                        selected = false;
                                                    } else {
                                                        selected = selectedDateTimes.includes(cellValue);
                                                    }
                                                    var currentDayStyle = isSameDate(currentDateTime, new Date(day.dateString)) ? {
                                                        borderBottom: "2px",
                                                        borderStyle: "solid",
                                                        borderBottomColor: "rgba(228, 255, 254, 1)"
                                                    } : {};
                                                    var displayValue = day.value;
                                                    var _day_indicatorValue;
                                                    var indicatorValue = (_day_indicatorValue = day.indicatorValue) !== null && _day_indicatorValue !== void 0 ? _day_indicatorValue : day.value;
                                                    var colors;
                                                    if (heroMetric === null || heroMetric === void 0 ? void 0 : heroMetric.indicatorConfig) {
                                                        colors = getIndicatorColor2(indicatorValue, // Use indicator value for color calculation
                                                        heroMetric.indicatorConfig, selected);
                                                    } else {
                                                        warnMissingIndicatorConfig2(heroMetric === null || heroMetric === void 0 ? void 0 : heroMetric.name);
                                                        colors = {
                                                            bgColor: IndicatorColor.WHITE,
                                                            textColor: IndicatorColor.BLACK
                                                        };
                                                    }
                                                    return /* @__PURE__ */ jsxs93("td", {
                                                        "data-value": cellValue,
                                                        style: _object_spread({
                                                            width: "".concat(cellWidthModifier2, "px"),
                                                            height: "".concat(cellHeight2, "px"),
                                                            color: colors.textColor,
                                                            backgroundColor: colors.bgColor
                                                        }, currentDayStyle),
                                                        onClick: function(event) {
                                                            return handleMouseClick(event);
                                                        },
                                                        onMouseDown: function(event) {
                                                            return handleMouseDown(event);
                                                        },
                                                        children: [
                                                            /* @__PURE__ */ jsx136("span", {
                                                                className: "cell-date",
                                                                children: day.date.getDate()
                                                            }),
                                                            displayValue > 0 ? "".concat(displayValue.toFixed(1)) : "-"
                                                        ]
                                                    }, i2);
                                                })
                                            ]
                                        }, i);
                                    })
                                })
                            ]
                        }),
                        function() {
                            var shouldRender = !hideSelectionBox && gridRef && gridRef.current && selectionBox.width !== 0 && selectionBox.height !== 0;
                            return shouldRender;
                        }() && /* @__PURE__ */ jsx136("div", {
                            className: "selection-box",
                            onClick: function() {
                                setHistoricalReset(true);
                            },
                            style: {
                                position: "absolute",
                                left: selectionBox.startX,
                                top: selectionBox.startY,
                                width: selectionBox.width,
                                height: selectionBox.height,
                                borderStyle: selectionBox.borderStyle,
                                pointerEvents: "auto"
                            },
                            children: !isDragging && /* @__PURE__ */ jsx136(CalendarSelectionOverlay_default, {
                                digitalTwinEntity: digitalTwinEntity,
                                entityCapacity: entityCapacity
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var CalendarMonthView_default = CalendarMonthView;
// src/components/Calendar/CalendarWeekView.tsx
import { DataMode as DataMode2, FilterType as FilterType6 } from "@repo/frontend-types";
import { useCallback as useCallback24, useEffect as useEffect46, useMemo as useMemo27, useState as useState69 } from "react";
import { DateTime as DateTime5 } from "luxon";
import { useTwinConfigStore, useUserStore as useUserStore18, useSettingsStore as useSettingsStore6, useTimelineCalendarSyncStore as useTimelineCalendarSyncStore3, useTwinContext as useTwinContext9, useFilterContext as useFilterContext14 } from "@repo/front-end-state";
import { createHourObjects } from "@repo/front-end-utils";
import { prependZero } from "@repo/front-end-utils";
import { findEntityById as findEntityById2 } from "@repo/front-end-utils";
import { generateCalendarWeek, buildClearedWeek, mergeWeekHoursData } from "@repo/front-end-utils";
// src/components/Calendar/WeekStepper.tsx
import { useState as useState67 } from "react";
import styled99 from "styled-components";
import { DateTime as DateTime4 } from "luxon";
import { useSettingsStore as useSettingsStore5 } from "@repo/front-end-state";
import { getWeekRange } from "@repo/front-end-utils";
import { getOrdinalSuffix as getOrdinalSuffix2 } from "@repo/front-end-utils";
import { ChevronLeft16Filled as ChevronLeft16Filled4, ChevronRight16Filled as ChevronRight16Filled4 } from "@fluentui/react-icons";
import { jsx as jsx137, jsxs as jsxs94 } from "react/jsx-runtime";
var WeekStepper = function(param) {
    var className = param.className, weekViewDateTime = param.weekViewDateTime, setCalendarDateTime = param.setCalendarDateTime;
    var settings = useSettingsStore5().settings;
    var _useState67 = _sliced_to_array(useState67(weekViewDateTime), 2), currentDay = _useState67[0], setCurrentDay = _useState67[1];
    var _useState671 = _sliced_to_array(useState67(getWeekRange(weekViewDateTime)), 2), weekRange = _useState671[0], setWeekRange = _useState671[1];
    var _useState672 = _sliced_to_array(useState67((settings === null || settings === void 0 ? void 0 : settings.timeZone) ? settings.timeZone : Intl.DateTimeFormat().resolvedOptions().timeZone), 1), timeZone = _useState672[0];
    var goBackOneWeek = function() {
        var prevWeek = DateTime4.fromISO(currentDay).minus({
            days: 7
        }).setZone(timeZone);
        if (prevWeek.isValid) {
            var prevWeekDateTimeISO = prevWeek.toISO({
                includeOffset: true
            });
            setCurrentDay(prevWeekDateTimeISO);
            var weekRange2 = getWeekRange(prevWeekDateTimeISO);
            setWeekRange(weekRange2);
            setCalendarDateTime(weekRange2.startDate, weekRange2.endDate);
        }
    };
    var goForwardOneWeek = function() {
        var nextWeek = DateTime4.fromISO(currentDay).plus({
            days: 7
        }).setZone(timeZone);
        if (nextWeek.isValid) {
            var nextWeekDateTimeISO = nextWeek.toISO({
                includeOffset: true
            });
            setCurrentDay(nextWeekDateTimeISO);
            var weekRange2 = getWeekRange(nextWeekDateTimeISO);
            setWeekRange(weekRange2);
            setCalendarDateTime(weekRange2.startDate, weekRange2.endDate);
        }
    };
    var formatWeekRange = function() {
        var displayString;
        if (weekRange.startDate && weekRange.endDate) {
            var startDay = DateTime4.fromISO(weekRange.startDate).day;
            var startMonth = DateTime4.fromISO(weekRange.startDate).monthLong;
            var finishDay = DateTime4.fromISO(weekRange.endDate).day;
            var finishMonth = DateTime4.fromISO(weekRange.endDate).monthLong;
            var year = DateTime4.fromISO(weekRange.endDate).year;
            displayString = "".concat(startDay).concat(getOrdinalSuffix2(startDay), " ").concat(startMonth === finishMonth ? "" : startMonth, " ").concat(finishDay ? "- ".concat(finishDay).concat(getOrdinalSuffix2(finishDay)) : "", " ").concat(finishMonth, " ").concat(year);
        }
        return displayString;
    };
    return /* @__PURE__ */ jsx137("div", {
        className: className,
        children: /* @__PURE__ */ jsxs94("div", {
            className: "calendar-stepper",
            children: [
                /* @__PURE__ */ jsx137("button", {
                    onClick: goBackOneWeek,
                    children: /* @__PURE__ */ jsx137(ChevronLeft16Filled4, {})
                }),
                /* @__PURE__ */ jsx137("p", {
                    children: formatWeekRange()
                }),
                /* @__PURE__ */ jsx137("button", {
                    onClick: goForwardOneWeek,
                    children: /* @__PURE__ */ jsx137(ChevronRight16Filled4, {})
                })
            ]
        })
    });
};
var WeekStepper_default = styled99(WeekStepper)(_templateObject228());
// src/components/Calendar/WeekGrid.tsx
import { useCallback as useCallback23, useEffect as useEffect45, useMemo as useMemo26, useRef as useRef28, useState as useState68 } from "react";
import { computeAutoSelectBox, computeCellDimensions, computeContiguousSelectionOutlines, computeSelectionBoxFromPointer, resolveWeekCellAppearance } from "@repo/front-end-utils";
import { Fragment as Fragment30, jsx as jsx138, jsxs as jsxs95 } from "react/jsx-runtime";
var cellWidthModifier = 43;
var cellHeight = 32;
var WeekGrid = function(param) {
    var className = param.className, columns = param.columns, rows = param.rows, cells = param.cells, selectedCellIds = param.selectedCellIds, indicatorConfig = param.indicatorConfig, metricName = param.metricName, lastRowFinishLabel = param.lastRowFinishLabel, cellKeyPrefix = param.cellKeyPrefix, refreshKey = param.refreshKey, resetKey = param.resetKey, hideBoxSignal = param.hideBoxSignal, selectionOverlay = param.selectionOverlay, _param_multiBlockOutline = param.multiBlockOutline, multiBlockOutline = _param_multiBlockOutline === void 0 ? false : _param_multiBlockOutline, onSelectionCommit = param.onSelectionCommit, onRequestReset = param.onRequestReset;
    var _useState68 = _sliced_to_array(useState68(false), 2), isDragging = _useState68[0], setIsDragging = _useState68[1];
    var _useState681 = _sliced_to_array(useState68([]), 2), selectedDateTimes = _useState681[0], setSelectedDateTimes = _useState681[1];
    var _useState682 = _sliced_to_array(useState68(false), 2), hideSelectionBox = _useState682[0], setHideSelectionBox = _useState682[1];
    var _useState683 = _sliced_to_array(useState68(true), 2), justResetToDefault = _useState683[0], setJustResetToDefault = _useState683[1];
    var _useState684 = _sliced_to_array(useState68({
        startX: 0,
        startY: 0,
        width: 0,
        height: 0,
        borderStyle: "dashed"
    }), 2), selectionBox = _useState684[0], setSelectionBox = _useState684[1];
    var _useState685 = _sliced_to_array(useState68([]), 2), selectionOutlines = _useState685[0], setSelectionOutlines = _useState685[1];
    var _useState686 = _sliced_to_array(useState68(0), 2), initialMouseY = _useState686[0], setInitialMouseY = _useState686[1];
    var _useState687 = _sliced_to_array(useState68(0), 2), initialMouseX = _useState687[0], setInitialMouseX = _useState687[1];
    var gridRef = useRef28(null);
    var hasDraggedRef = useRef28(false);
    var cellLookup = useMemo26(function() {
        var map = /* @__PURE__ */ new Map();
        cells.forEach(function(rowCells, rowIndex) {
            return rowCells.forEach(function(cell, colIndex) {
                return map.set(cell.cellId, {
                    rowIndex: rowIndex,
                    colIndex: colIndex,
                    value: cell.value
                });
            });
        });
        return map;
    }, [
        cells
    ]);
    var resetSelection = useCallback23(function() {
        setSelectedDateTimes([]);
        setHideSelectionBox(true);
        setSelectionOutlines([]);
    }, []);
    var calcSelectionBoxPosition = function(grid, clientX, clientY) {
        if (!grid.current) return;
        var gridRect = grid.current.getBoundingClientRect();
        var relativeX = clientX - gridRect.left;
        var relativeY = clientY - gridRect.top;
        var theadHeight = grid.current.querySelector("thead").clientHeight;
        var _computeCellDimensions = computeCellDimensions(gridRect.width, gridRect.height, theadHeight, columns.length, rows.length, cellWidthModifier), adjustedCellWidth = _computeCellDimensions.adjustedCellWidth, adjustedCellHeight = _computeCellDimensions.adjustedCellHeight;
        var box = computeSelectionBoxFromPointer(initialMouseX, initialMouseY, relativeX, relativeY, adjustedCellWidth, adjustedCellHeight);
        return _object_spread({
            relativeX: relativeX,
            relativeY: relativeY
        }, box);
    };
    var handleMouseDown = function(event) {
        setHideSelectionBox(false);
        setJustResetToDefault(false);
        hasDraggedRef.current = false;
        if (!gridRef.current) return;
        var gridRect = gridRef.current.getBoundingClientRect();
        var clientX = event.clientX, clientY = event.clientY;
        var relativeX = clientX - gridRect.left;
        var relativeY = clientY - gridRect.top;
        setIsDragging(true);
        setInitialMouseY(relativeY);
        setInitialMouseX(relativeX);
        setSelectionBox({
            startX: relativeX,
            startY: relativeY,
            width: 0,
            height: 0,
            borderStyle: "dashed"
        });
    };
    var handleMouseClick = function(event) {
        if (!gridRef.current) return;
        var clientX = event.clientX, clientY = event.clientY;
        var sbp = calcSelectionBoxPosition(gridRef, clientX, clientY);
        if (sbp) {
            var newSelectedDateTimes = [];
            for(var row = Math.min(sbp.startRow, sbp.endRow); row < Math.max(sbp.startRow, sbp.endRow); row++){
                for(var col = Math.min(sbp.startCol, sbp.endCol); col < Math.max(sbp.startCol, sbp.endCol); col++){
                    var cellId = cells[row - 1][col - 1].cellId;
                    newSelectedDateTimes.push(cellId);
                }
            }
            setSelectedDateTimes(newSelectedDateTimes);
            setSelectionBox({
                startX: sbp.snapStartX,
                startY: sbp.snapStartY,
                width: Math.abs(sbp.snapEndX - sbp.snapStartX),
                height: Math.abs(sbp.snapEndY - sbp.snapStartY),
                borderStyle: "solid"
            });
            onSelectionCommit(newSelectedDateTimes);
        }
    };
    var handleMouseUp = function() {
        setIsDragging(false);
        setSelectionBox(_object_spread_props(_object_spread({}, selectionBox), {
            borderStyle: "solid"
        }));
        if (hasDraggedRef.current) {
            onSelectionCommit(selectedDateTimes);
        }
    };
    var handleMouseMove = function(event) {
        if (!isDragging || !gridRef.current) return;
        var clientX = event.clientX, clientY = event.clientY;
        var sbp = calcSelectionBoxPosition(gridRef, clientX, clientY);
        if (sbp) {
            if (sbp.relativeY > initialMouseY && sbp.relativeX > initialMouseX) {
                hasDraggedRef.current = true;
                var newSelectedDateTimes = [];
                for(var row = Math.min(sbp.startRow, sbp.endRow); row < Math.max(sbp.startRow, sbp.endRow); row++){
                    for(var col = Math.min(sbp.startCol, sbp.endCol); col < Math.max(sbp.startCol, sbp.endCol); col++){
                        var cellId = cells[row - 1][col - 1].cellId;
                        newSelectedDateTimes.push(cellId);
                    }
                }
                setSelectedDateTimes(newSelectedDateTimes);
                setSelectionBox({
                    startX: sbp.snapStartX,
                    startY: sbp.snapStartY,
                    width: Math.abs(sbp.snapEndX - sbp.snapStartX),
                    height: Math.abs(sbp.snapEndY - sbp.snapStartY),
                    borderStyle: "dashed"
                });
            }
        }
    };
    var applyProgrammaticSelection = useCallback23(function(cellIds) {
        if (!cellIds || cellIds.length === 0) {
            resetSelection();
            return;
        }
        if (cellIds.length > 0 && gridRef.current) {
            var minRow = Infinity;
            var maxRow = -Infinity;
            var minCol = Infinity;
            var maxCol = -Infinity;
            var hasVisibleSelections = false;
            var positions = [];
            cellIds.forEach(function(cellId) {
                var pos = cellLookup.get(cellId);
                if (pos) {
                    minCol = Math.min(minCol, pos.colIndex);
                    maxCol = Math.max(maxCol, pos.colIndex);
                    minRow = Math.min(minRow, pos.rowIndex);
                    maxRow = Math.max(maxRow, pos.rowIndex);
                    positions.push({
                        rowIndex: pos.rowIndex,
                        colIndex: pos.colIndex
                    });
                    hasVisibleSelections = true;
                }
            });
            if (hasVisibleSelections && minRow !== Infinity && minCol !== Infinity) {
                var gridRect = gridRef.current.getBoundingClientRect();
                var theadHeight = gridRef.current.querySelector("thead").clientHeight;
                var _computeCellDimensions = computeCellDimensions(gridRect.width, gridRect.height, theadHeight, columns.length, rows.length, cellWidthModifier), adjustedCellWidth = _computeCellDimensions.adjustedCellWidth, adjustedCellHeight = _computeCellDimensions.adjustedCellHeight;
                var box = computeAutoSelectBox(minRow, maxRow, minCol, maxCol, theadHeight, adjustedCellWidth, adjustedCellHeight);
                setSelectionBox(_object_spread_props(_object_spread({}, box), {
                    borderStyle: "solid"
                }));
                setSelectionOutlines(multiBlockOutline ? computeContiguousSelectionOutlines(positions, theadHeight, adjustedCellWidth, adjustedCellHeight) : []);
                setHideSelectionBox(false);
            } else {
                setSelectionOutlines([]);
                setHideSelectionBox(true);
            }
        } else {
            setHideSelectionBox(true);
        }
        setSelectedDateTimes(cellIds);
        setHideSelectionBox(false);
    }, [
        cellLookup,
        columns.length,
        rows.length,
        resetSelection,
        multiBlockOutline
    ]);
    useEffect45(function() {
        applyProgrammaticSelection(selectedCellIds);
    }, [
        selectedCellIds,
        multiBlockOutline
    ]);
    useEffect45(function() {
        if (resetKey === void 0) return;
        resetSelection();
    }, [
        resetKey
    ]);
    useEffect45(function() {
        if (hideBoxSignal === void 0) return;
        setHideSelectionBox(true);
    }, [
        hideBoxSignal
    ]);
    useEffect45(function() {
        if (refreshKey === void 0) return;
        if (selectedDateTimes.length > 0) {
            var hasVisibleSelectionsInCurrentWeek = false;
            selectedDateTimes.forEach(function(cellId) {
                if (cellLookup.has(cellId)) {
                    hasVisibleSelectionsInCurrentWeek = true;
                }
            });
            setHideSelectionBox(!hasVisibleSelectionsInCurrentWeek);
        }
    }, [
        refreshKey
    ]);
    return /* @__PURE__ */ jsxs95("div", {
        className: className,
        style: {
            marginTop: "1rem",
            position: "relative"
        },
        onMouseUp: handleMouseUp,
        children: [
            /* @__PURE__ */ jsx138("div", {
                className: "diagonal-overlay"
            }),
            /* @__PURE__ */ jsxs95("table", {
                id: "duration",
                ref: gridRef,
                onMouseMove: handleMouseMove,
                children: [
                    /* @__PURE__ */ jsx138("thead", {
                        children: /* @__PURE__ */ jsxs95("tr", {
                            children: [
                                /* @__PURE__ */ jsx138("th", {
                                    style: {
                                        width: "".concat(cellWidthModifier, "px"),
                                        height: "".concat(cellHeight, "px")
                                    }
                                }),
                                columns.map(function(col, index) {
                                    return /* @__PURE__ */ jsxs95("th", {
                                        style: {
                                            width: "".concat(cellWidthModifier, "px"),
                                            height: "".concat(cellHeight, "px"),
                                            textAlign: "center",
                                            fontSize: "10px",
                                            lineHeight: "14px",
                                            fontWeight: "400"
                                        },
                                        children: [
                                            col.dayOfMonth !== void 0 && /* @__PURE__ */ jsx138("p", {
                                                style: {
                                                    color: "#7A7A7A"
                                                },
                                                children: col.dayOfMonth
                                            }),
                                            /* @__PURE__ */ jsx138("p", {
                                                children: col.weekdayLabel
                                            })
                                        ]
                                    }, index);
                                })
                            ]
                        })
                    }),
                    /* @__PURE__ */ jsx138("tbody", {
                        children: rows && rows.map(function(row, rowIndex) {
                            var isLastHour = rowIndex === rows.length - 1;
                            return /* @__PURE__ */ jsxs95("tr", {
                                children: [
                                    /* @__PURE__ */ jsx138("th", {
                                        style: {
                                            width: "".concat(cellWidthModifier, "px"),
                                            height: "".concat(cellHeight, "px"),
                                            fontSize: "10px",
                                            textAlign: "center",
                                            verticalAlign: "top",
                                            paddingTop: "1px",
                                            position: "relative",
                                            zIndex: 2
                                        },
                                        children: isLastHour ? /* @__PURE__ */ jsxs95(Fragment30, {
                                            children: [
                                                /* @__PURE__ */ jsx138("span", {
                                                    style: {
                                                        position: "absolute",
                                                        top: "1px",
                                                        left: "50%",
                                                        transform: "translateX(-50%)"
                                                    },
                                                    children: row.label
                                                }),
                                                /* @__PURE__ */ jsx138("span", {
                                                    style: {
                                                        position: "absolute",
                                                        bottom: "1px",
                                                        left: "50%",
                                                        transform: "translateX(-50%)"
                                                    },
                                                    children: lastRowFinishLabel
                                                })
                                            ]
                                        }) : row.label
                                    }),
                                    columns.map(function(col, i) {
                                        var cell = cells[rowIndex][i];
                                        var cellValue = cell.cellId;
                                        var selected;
                                        if (selectedDateTimes && selectedDateTimes.length === 0) {
                                            selected = true;
                                        } else {
                                            selected = selectedDateTimes.includes(cellValue);
                                        }
                                        var appearance = resolveWeekCellAppearance({
                                            indicatorConfig: indicatorConfig,
                                            metricName: metricName,
                                            colorValue: cell.colorValue,
                                            selected: selected,
                                            isFuture: cell.isFuture,
                                            open: cell.open,
                                            value: cell.value
                                        });
                                        return /* @__PURE__ */ jsx138("td", {
                                            "data-testid": "cell-".concat(col.testKey, "-").concat(row.hourKey, "-").concat(i),
                                            "data-value": cellValue,
                                            style: {
                                                width: "".concat(cellWidthModifier, "px"),
                                                height: "".concat(cellHeight, "px"),
                                                color: appearance.textColor,
                                                backgroundColor: appearance.backgroundColor,
                                                position: "relative",
                                                zIndex: 2
                                            },
                                            onClick: function(event) {
                                                return handleMouseClick(event);
                                            },
                                            onMouseDown: function(event) {
                                                return handleMouseDown(event);
                                            },
                                            children: appearance.displayValue
                                        }, "".concat(cellKeyPrefix, "-").concat(i));
                                    })
                                ]
                            }, rowIndex);
                        })
                    })
                ]
            }),
            multiBlockOutline ? !hideSelectionBox && gridRef && gridRef.current && selectionOutlines.length > 0 && /* @__PURE__ */ jsxs95(Fragment30, {
                children: [
                    /* @__PURE__ */ jsx138("svg", {
                        className: "selection-outline-svg",
                        style: {
                            position: "absolute",
                            left: 0,
                            top: 0,
                            width: "100%",
                            height: "100%",
                            overflow: "visible",
                            pointerEvents: "none",
                            // Above the cells (which carry zIndex: 2) so the thin perimeter strokes — which sit
                            // directly on cell edges — are not occluded by the opaque coloured cells.
                            zIndex: 3
                        },
                        children: selectionOutlines.map(function(outline, i) {
                            return /* @__PURE__ */ jsx138("path", {
                                className: "selection-outline-path",
                                d: outline.path,
                                fill: "none"
                            }, i);
                        })
                    }),
                    !isDragging && selectionOverlay && /* @__PURE__ */ jsx138("div", {
                        className: "selection-outline-overlay-anchor",
                        style: {
                            position: "absolute",
                            left: selectionBox.startX,
                            top: selectionBox.startY,
                            width: selectionBox.width,
                            height: selectionBox.height,
                            pointerEvents: "none"
                        },
                        children: selectionOverlay
                    })
                ]
            }) : !hideSelectionBox && gridRef && gridRef.current && selectionBox.width !== 0 && selectionBox.height !== 0 && /* @__PURE__ */ jsx138("div", {
                className: "selection-box",
                onClick: function() {
                    if (!justResetToDefault) {
                        onRequestReset === null || onRequestReset === void 0 ? void 0 : onRequestReset();
                        setJustResetToDefault(true);
                    }
                },
                style: {
                    position: "absolute",
                    left: selectionBox.startX,
                    top: selectionBox.startY,
                    width: selectionBox.width,
                    height: selectionBox.height,
                    borderStyle: selectionBox.borderStyle,
                    pointerEvents: justResetToDefault ? "none" : "auto",
                    // Inline (like the SVG ring overlay) so it reliably wins over the cells' z-index: 2 —
                    // the same value set via the styled-component .selection-box CSS class did not take
                    // effect for the manual box, while the inline z-index on the SVG rings did.
                    zIndex: 3
                },
                children: !isDragging && selectionOverlay
            })
        ]
    });
};
var WeekGrid_default = WeekGrid;
// src/components/Calendar/CalendarWeekView.tsx
import { getCalendarView as getCalendarView2 } from "@repo/front-end-services";
import { jsx as jsx139, jsxs as jsxs96 } from "react/jsx-runtime";
var CalendarWeekView = function(param) {
    var className = param.className, _param_middlewareApi = param.middlewareApi, middlewareApi = _param_middlewareApi === void 0 ? "" : _param_middlewareApi, aggregation = param.aggregation;
    var _authMetadata_tokens;
    var preferences = useTwinConfigStore().preferences;
    var _useFilterContext14 = useFilterContext14(), historicalReset = _useFilterContext14.historicalReset, filter = _useFilterContext14.filter, heroMetric = _useFilterContext14.heroMetric, timeWindows = _useFilterContext14.timeWindows, autoSelectCalendar = _useFilterContext14.autoSelectCalendar, setAutoSelectCalendar = _useFilterContext14.setAutoSelectCalendar, setHistoricalReset = _useFilterContext14.setHistoricalReset, commitSelection = _useFilterContext14.commitSelection, resetSelectionToDefault = _useFilterContext14.resetSelectionToDefault;
    var setCalendarDateRange = useTimelineCalendarSyncStore3().setCalendarDateRange;
    var settings = useSettingsStore6().settings;
    var twin = useTwinContext9().twin;
    var authMetadata = useUserStore18().authMetadata;
    var timeZone = (settings === null || settings === void 0 ? void 0 : settings.timeZone) ? settings.timeZone : Intl.DateTimeFormat().resolvedOptions().timeZone;
    var _useState69 = _sliced_to_array(useState69(DateTime5.now().startOf("week").toISO()), 2), weekViewDateTime = _useState69[0], setWeekViewDateTime = _useState69[1];
    var _useState691 = _sliced_to_array(useState69([]), 2), theWeek = _useState691[0], setTheWeek = _useState691[1];
    var _useState692 = _sliced_to_array(useState69(null), 2), weekdayAggregation = _useState692[0], setWeekdayAggregation = _useState692[1];
    var _useState693 = _sliced_to_array(useState69([]), 2), programmaticCellIds = _useState693[0], setProgrammaticCellIds = _useState693[1];
    var _useState694 = _sliced_to_array(useState69(0), 2), refreshKey = _useState694[0], setRefreshKey = _useState694[1];
    var _useState695 = _sliced_to_array(useState69(0), 2), resetKey = _useState695[0], setResetKey = _useState695[1];
    var _useState696 = _sliced_to_array(useState69(0), 2), hideBoxSignal = _useState696[0], setHideBoxSignal = _useState696[1];
    var setCalendarDateTime = function(startDateTimeISO, finishDateTimeISO) {
        setWeekViewDateTime(startDateTimeISO);
        setCalendarDateRange(startDateTimeISO, finishDateTimeISO);
        setHideBoxSignal(function(k) {
            return k + 1;
        });
        if (timeWindows && timeWindows.length > 0) {
            setAutoSelectCalendar(true);
        } else {
            resetSelection();
        }
    };
    var digitalTwinEntity = useMemo27(function() {
        var entity = twin === null || twin === void 0 ? void 0 : twin.physicalModel.bID;
        var physicalEntityFilters = filter.filter(function(item) {
            return item.type === FilterType6.ENTITY;
        });
        if (physicalEntityFilters && physicalEntityFilters.length > 0) {
            entity = physicalEntityFilters[physicalEntityFilters.length - 1].bId;
        }
        return entity;
    }, [
        twin,
        filter
    ]);
    var entityCapacity = useMemo27(function() {
        var capacity = 0;
        if (twin && digitalTwinEntity) {
            var entity = findEntityById2(DataMode2.TIME_SERIES, [
                twin.physicalModel
            ], digitalTwinEntity);
            capacity = entity ? entity["capacity"] : 0;
        }
        return capacity;
    }, [
        digitalTwinEntity,
        twin
    ]);
    var weeklyCalStartTime = preferences === null || preferences === void 0 ? void 0 : preferences.earliestOpeningTime;
    var weeklyCalFinishTime = preferences === null || preferences === void 0 ? void 0 : preferences.latestClosingTime;
    if (weeklyCalStartTime === "00:00:00" && weeklyCalFinishTime === "00:00:00") {
        weeklyCalStartTime = null;
        weeklyCalFinishTime = null;
    }
    var hoursData = createHourObjects(weeklyCalStartTime, weeklyCalFinishTime);
    useEffect46(function() {
        if ((authMetadata === null || authMetadata === void 0 ? void 0 : authMetadata.tsdbUrl) && weekViewDateTime) {
            var fetchCalendarData = /*#__PURE__*/ function() {
                var _ref = _async_to_generator(function() {
                    var calendarWeek, clearedWeek, startDateTime, finishDateTime, queryStartDate, queryFinishDate, _authMetadata_tokens, valueMetric, indicatorMetric, metricsToFetch, _authMetadata_tokens1, data, valueEntityData, valueTsData, indicatorTsData, indicatorEntityData, result, weekdayAgg, error;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                calendarWeek = generateCalendarWeek(weekViewDateTime);
                                clearedWeek = buildClearedWeek(calendarWeek, weeklyCalStartTime, weeklyCalFinishTime);
                                setTheWeek(clearedWeek);
                                if (Array.isArray(calendarWeek)) {
                                    startDateTime = calendarWeek[0].dateISO;
                                    finishDateTime = calendarWeek[6].dateISO;
                                }
                                if (!(startDateTime && finishDateTime)) return [
                                    3,
                                    5
                                ];
                                queryStartDate = DateTime5.fromISO(startDateTime, {
                                    zone: timeZone
                                }).toISO({
                                    suppressMilliseconds: true,
                                    includeOffset: false
                                }) || "";
                                queryFinishDate = DateTime5.fromISO(finishDateTime, {
                                    zone: timeZone
                                }).endOf("day").set({
                                    millisecond: 0
                                }).toISO({
                                    suppressMilliseconds: true,
                                    includeOffset: false
                                }) || "";
                                if (!(settings && settings.organisation && queryStartDate && queryFinishDate)) return [
                                    3,
                                    4
                                ];
                                valueMetric = heroMetric === null || heroMetric === void 0 ? void 0 : heroMetric.valueMetricName;
                                indicatorMetric = heroMetric === null || heroMetric === void 0 ? void 0 : heroMetric.indicatorMetricName;
                                if (!aggregation || !valueMetric) {
                                    if (heroMetric) {
                                        console.warn("[CalendarWeekView] selected hero metric is missing its time-series aggregation or value-metric name; rendering empty calendar", {
                                            aggregation: aggregation,
                                            valueMetricName: valueMetric,
                                            heroMetric: heroMetric
                                        });
                                    }
                                    setWeekdayAggregation(null);
                                    return [
                                        2
                                    ];
                                }
                                metricsToFetch = [
                                    valueMetric
                                ];
                                if (indicatorMetric && indicatorMetric !== valueMetric) {
                                    metricsToFetch.push(indicatorMetric);
                                }
                                if (!authMetadata.tsdbUrl) {
                                    throw new Error("Missing analytics endpoint");
                                }
                                if (!(((_authMetadata_tokens = authMetadata.tokens) === null || _authMetadata_tokens === void 0 ? void 0 : _authMetadata_tokens.accessToken) && authMetadata.organisation && (twin === null || twin === void 0 ? void 0 : twin.physicalModel.bID) && digitalTwinEntity)) return [
                                    3,
                                    4
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    getCalendarView2(middlewareApi, (_authMetadata_tokens1 = authMetadata.tokens) === null || _authMetadata_tokens1 === void 0 ? void 0 : _authMetadata_tokens1.accessToken, twin === null || twin === void 0 ? void 0 : twin.physicalModel.bID, authMetadata.organisation, digitalTwinEntity, queryStartDate, queryFinishDate, (aggregation || "AVG").toUpperCase(), metricsToFetch, false, false)
                                ];
                            case 2:
                                data = _state.sent();
                                if (data && data[valueMetric] && data[valueMetric][digitalTwinEntity]) {
                                    valueEntityData = data[valueMetric][digitalTwinEntity];
                                    valueTsData = valueEntityData.data || valueEntityData;
                                    indicatorTsData = null;
                                    if (indicatorMetric && data[indicatorMetric] && data[indicatorMetric][digitalTwinEntity]) {
                                        indicatorEntityData = data[indicatorMetric][digitalTwinEntity];
                                        indicatorTsData = indicatorEntityData.data || indicatorEntityData;
                                    }
                                    result = mergeWeekHoursData(calendarWeek, valueTsData);
                                    if (indicatorTsData) {
                                        result.forEach(function(day) {
                                            var dayIndicatorData = indicatorTsData[day.dateISO];
                                            if (dayIndicatorData) {
                                                day.hours.forEach(function(hour) {
                                                    var hourString = hour.hour.toString().padStart(2, "0");
                                                    var indicatorHourData = dayIndicatorData[hourString];
                                                    if (indicatorHourData) {
                                                        hour.indicatorValue = indicatorHourData[0];
                                                    }
                                                });
                                            }
                                        });
                                    }
                                    setTheWeek(result);
                                    weekdayAgg = valueEntityData.weekday_aggregation;
                                    if (weekdayAgg) {
                                        setWeekdayAggregation(weekdayAgg);
                                    }
                                } else {
                                    console.warn("CalendarWeekView: No data returned from API for week", queryStartDate, "to", queryFinishDate);
                                    setWeekdayAggregation(null);
                                    setTheWeek(calendarWeek);
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                console.error("CalendarWeekView: Error fetching calendar data:", error);
                                setTheWeek(calendarWeek);
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                setRefreshKey(function(k) {
                                    return k + 1;
                                });
                                _state.label = 5;
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function fetchCalendarData() {
                    return _ref.apply(this, arguments);
                };
            }();
            fetchCalendarData();
        }
    }, [
        authMetadata === null || authMetadata === void 0 ? void 0 : authMetadata.organisation,
        authMetadata === null || authMetadata === void 0 ? void 0 : (_authMetadata_tokens = authMetadata.tokens) === null || _authMetadata_tokens === void 0 ? void 0 : _authMetadata_tokens.accessToken,
        authMetadata === null || authMetadata === void 0 ? void 0 : authMetadata.tsdbUrl,
        digitalTwinEntity,
        aggregation,
        heroMetric === null || heroMetric === void 0 ? void 0 : heroMetric.valueMetricName,
        settings,
        timeZone,
        twin === null || twin === void 0 ? void 0 : twin.physicalModel.bID,
        weekViewDateTime
    ]);
    var getHourData = useCallback24(function(dateString, hourString) {
        if (!theWeek || !Array.isArray(theWeek)) {
            return {
                value: 0,
                open: false,
                indicatorValue: void 0
            };
        }
        var weekDay = theWeek.find(function(day) {
            return day && day.dateISO === dateString;
        });
        if (!weekDay || !weekDay.hours || !Array.isArray(weekDay.hours)) {
            return {
                value: 0,
                open: false,
                indicatorValue: void 0
            };
        }
        var hour = weekDay.hours.find(function(hr) {
            return hr && hr.hourString === hourString;
        });
        return hour ? {
            value: hour.value || 0,
            open: hour.open || false,
            indicatorValue: hour.indicatorValue
        } : {
            value: 0,
            open: false,
            indicatorValue: void 0
        };
    }, [
        theWeek
    ]);
    var resetSelection = useCallback24(function() {
        setProgrammaticCellIds([]);
        setResetKey(function(k) {
            return k + 1;
        });
    }, []);
    useEffect46(function() {
        if (historicalReset) {
            resetSelection();
            setHistoricalReset(false);
        }
    }, [
        historicalReset,
        setHistoricalReset,
        resetSelection
    ]);
    var autoSelect = useCallback24(function(inputTimeWindows) {
        if (!inputTimeWindows || inputTimeWindows.length === 0) {
            resetSelection();
            return;
        }
        var selectedDateTimes = [];
        inputTimeWindows.forEach(function(param) {
            var _param = _sliced_to_array(param, 2), start = _param[0], end = _param[1];
            var startDateTime = DateTime5.fromISO(start);
            var endDateTime = DateTime5.fromISO(end);
            var currentDateTime = startDateTime;
            while(currentDateTime < endDateTime){
                var dateISO = currentDateTime.toISODate();
                var hourFormatted = currentDateTime.toFormat("HH:mm");
                var cellValue = "".concat(dateISO, "T").concat(hourFormatted);
                selectedDateTimes.push(cellValue);
                currentDateTime = currentDateTime.plus({
                    hours: 1
                });
            }
        });
        setProgrammaticCellIds(selectedDateTimes);
    }, []);
    useEffect46(function() {
        if (autoSelectCalendar) {
            if (timeWindows === null) {
                resetSelection();
            } else if (timeWindows && timeWindows.length > 0) {
                autoSelect(timeWindows);
            }
            setTimeout(function() {
                setAutoSelectCalendar(false);
            }, 0);
        }
    }, [
        timeWindows,
        autoSelectCalendar,
        autoSelect,
        setAutoSelectCalendar,
        resetSelection
    ]);
    var handleSelectionCommit = useCallback24(function(cellIds) {
        var selectedTimeWindows = cellIds.map(function(cellId) {
            var endTime = DateTime5.fromISO(cellId).plus({
                hours: 1
            }).toISO({
                includeOffset: false
            });
            return [
                cellId,
                endTime || ""
            ];
        });
        commitSelection(selectedTimeWindows);
    }, [
        commitSelection
    ]);
    var columns = theWeek.map(function(day) {
        return {
            testKey: day.weekDay,
            dayOfMonth: day.dateObj.getDate(),
            weekdayLabel: day.dateObj.toLocaleDateString("en-GB", {
                weekday: "short"
            }).toUpperCase()
        };
    });
    var rows = hoursData.map(function(hour) {
        return {
            label: hour.text,
            hourKey: hour.hour
        };
    });
    var now = /* @__PURE__ */ new Date();
    var cells = hoursData.map(function(hour) {
        return theWeek.map(function(day) {
            var cellId = "".concat(day.dateISO, "T").concat(prependZero(hour.hour), ":00");
            var hourData = getHourData(day.dateISO, hour.value);
            var cellDisplayValue = hourData.value;
            var colorCalculationValue = hourData.indicatorValue !== void 0 ? hourData.indicatorValue : cellDisplayValue;
            var cellDateTime = /* @__PURE__ */ new Date("".concat(day.dateISO, "T").concat(hour.value));
            var isFuture = cellDateTime > now;
            return {
                cellId: cellId,
                value: cellDisplayValue,
                colorValue: colorCalculationValue,
                open: hourData.open,
                isFuture: isFuture
            };
        });
    });
    var finishTime = weeklyCalFinishTime || "24:00";
    var finishHour = parseInt(finishTime.split(":")[0]);
    var displayHour = finishHour === 24 ? 0 : finishHour;
    var lastRowFinishLabel = "".concat(displayHour % 12 === 0 ? 12 : displayHour % 12).concat(displayHour < 12 ? "am" : "pm");
    return /* @__PURE__ */ jsxs96("div", {
        className: className,
        children: [
            /* @__PURE__ */ jsx139(CalendarWeekTotals, {
                weekViewDateTime: weekViewDateTime,
                digitalTwinEntity: digitalTwinEntity,
                weekdayAggregation: weekdayAggregation ? weekdayAggregation : []
            }),
            weekViewDateTime && /* @__PURE__ */ jsxs96("div", {
                children: [
                    /* @__PURE__ */ jsx139(WeekStepper_default, {
                        weekViewDateTime: weekViewDateTime,
                        setCalendarDateTime: setCalendarDateTime
                    }),
                    /* @__PURE__ */ jsx139(WeekGrid_default, {
                        columns: columns,
                        rows: rows,
                        cells: cells,
                        selectedCellIds: programmaticCellIds,
                        indicatorConfig: heroMetric === null || heroMetric === void 0 ? void 0 : heroMetric.indicatorConfig,
                        metricName: heroMetric === null || heroMetric === void 0 ? void 0 : heroMetric.name,
                        lastRowFinishLabel: lastRowFinishLabel,
                        cellKeyPrefix: weekViewDateTime,
                        refreshKey: refreshKey,
                        resetKey: resetKey,
                        hideBoxSignal: hideBoxSignal,
                        onSelectionCommit: handleSelectionCommit,
                        onRequestReset: resetSelectionToDefault,
                        selectionOverlay: /* @__PURE__ */ jsx139(CalendarSelectionOverlay_default, {
                            digitalTwinEntity: digitalTwinEntity,
                            entityCapacity: entityCapacity !== null && entityCapacity !== void 0 ? entityCapacity : 0
                        })
                    })
                ]
            })
        ]
    });
};
var CalendarWeekView_default = CalendarWeekView;
// src/components/Calendar/Calendar.tsx
import { Scrollbar as Scrollbar8 } from "@repo/design-system";
import { Fragment as Fragment31, jsx as jsx140, jsxs as jsxs97 } from "react/jsx-runtime";
var Calendar = function(param) {
    var className = param.className, middlewareApi = param.middlewareApi;
    var _heroMetric_modes_AppMode6_HISTORICAL, _heroMetric_modes;
    var _useModeContext9 = useModeContext9(), appMode = _useModeContext9.appMode, setCurrentCalendarView = _useModeContext9.setCurrentCalendarView;
    var heroMetric = useFilterContext15().heroMetric;
    var aggregation = heroMetric === null || heroMetric === void 0 ? void 0 : (_heroMetric_modes = heroMetric.modes) === null || _heroMetric_modes === void 0 ? void 0 : (_heroMetric_modes_AppMode6_HISTORICAL = _heroMetric_modes[AppMode6.HISTORICAL]) === null || _heroMetric_modes_AppMode6_HISTORICAL === void 0 ? void 0 : _heroMetric_modes_AppMode6_HISTORICAL.aggregation;
    var _useState70 = _sliced_to_array(useState70(TimeUnit2.WEEK), 2), timeUnit = _useState70[0], setTimeUnit = _useState70[1];
    var handleTimeUnitSwitcher = function(value) {
        var timeUnit2 = stringToTimeUnit(value);
        setTimeUnit(timeUnit2);
        setCurrentCalendarView(timeUnit2);
    };
    return /* @__PURE__ */ jsx140(Fragment31, {
        children: appMode === AppMode6.HISTORICAL && /* @__PURE__ */ jsxs97("div", {
            className: className,
            children: [
                /* @__PURE__ */ jsx140("div", {
                    className: "header",
                    children: /* @__PURE__ */ jsx140(TLCard_default, {
                        size: "small",
                        children: /* @__PURE__ */ jsx140(TLSwitcher_default, {
                            size: "small",
                            selectedValue: timeUnit.toString(),
                            options: [
                                {
                                    activeIcon: /* @__PURE__ */ jsx140(CalendarWeekNumbers24Filled, {}),
                                    inactiveIcon: /* @__PURE__ */ jsx140(CalendarWeekNumbers24Regular, {}),
                                    value: TimeUnit2.WEEK.toString(),
                                    text: "Weekly"
                                },
                                {
                                    activeIcon: /* @__PURE__ */ jsx140(Calendar24Filled, {}),
                                    inactiveIcon: /* @__PURE__ */ jsx140(Calendar24Regular, {}),
                                    value: TimeUnit2.MONTH.toString(),
                                    text: "Monthly"
                                }
                            ],
                            setValue: handleTimeUnitSwitcher
                        })
                    })
                }),
                /* @__PURE__ */ jsx140(Scrollbar8, {
                    right: -20,
                    maxHeight: "calc(100vh - 210px)",
                    className: "right-scrollable-container",
                    children: /* @__PURE__ */ jsx140(Panel_default, {
                        id: "calendar",
                        icon: /* @__PURE__ */ jsx140(Calendar24Regular, {}),
                        title: "Calendar",
                        defaultOpenItems: [
                            "calendar"
                        ],
                        children: /* @__PURE__ */ jsxs97(Fragment31, {
                            children: [
                                timeUnit === TimeUnit2.WEEK ? /* @__PURE__ */ jsx140(CalendarWeekView_default, {
                                    middlewareApi: middlewareApi,
                                    aggregation: aggregation
                                }) : null,
                                timeUnit === TimeUnit2.MONTH ? /* @__PURE__ */ jsx140(CalendarMonthView_default, {
                                    middlewareApi: middlewareApi,
                                    aggregation: aggregation
                                }) : null
                            ]
                        })
                    })
                })
            ]
        })
    });
};
var Calendar_default = styled100(Calendar)(_templateObject229());
// src/components/TwinSelector/TwinSelector.tsx
import { Align as Align2, Roles as Roles7, TabPanel as TabPanel2 } from "@repo/frontend-types";
import React74, { useCallback as useCallback26, useEffect as useEffect47, useState as useState71 } from "react";
import styled101 from "styled-components";
import { useAuth0 as useAuth04 } from "@auth0/auth0-react";
import { useNavigate as useNavigate3 } from "react-router-dom";
import { useTwinStore as useTwinStore2, extractTwinMarkerData, useUserStore as useUserStore20, useDialogContext as useDialogContext5 } from "@repo/front-end-state";
import { Cube16Regular, Cube16Filled, Wrench16Regular } from "@fluentui/react-icons";
import { Accordion as Accordion4, AccordionItem as AccordionItem3, AccordionHeader as AccordionHeader3, AccordionPanel as AccordionPanel3 } from "@fluentui/react-components";
import AddTwinIcon from "@repo/assets/react/icons/AddTwinDark";
import { Scrollbar as Scrollbar9 } from "@repo/design-system";
import { getOrgTwins as getTwins } from "@repo/front-end-services";
// src/components/TwinSelector/twinSetupPath.ts
var twinSetupPath = function(twin) {
    return "/onboarding?twinId=".concat(twin.id, "&twinBid=").concat(encodeURIComponent(twin.bid));
};
// src/components/TwinSelector/useOpenTwin.ts
import { useCallback as useCallback25 } from "react";
import { useNavigate as useNavigate2 } from "react-router-dom";
import { AppMode as AppMode7, Template } from "@repo/frontend-types";
import { useFilterContext as useFilterContext16, useModeContext as useModeContext10, useSettingsStore as useSettingsStore7, useTwinConfigStore as useTwinConfigStore2, useTwinContext as useTwinContext10, useTwinStore, useUserStore as useUserStore19 } from "@repo/front-end-state";
import { gymTwinTemplate, expoTwinTemplate, eventTwinTemplate } from "@repo/front-end-data";
import { getTwinConfig } from "@repo/front-end-services";
var useOpenTwin = function(param) {
    var middlewareApi = param.middlewareApi, accessToken = param.accessToken;
    var navigate = useNavigate2();
    var _useTwinStore = useTwinStore(), setLoading = _useTwinStore.setLoading, setSelectedTwinBID = _useTwinStore.setSelectedTwinBID;
    var authMetadata = useUserStore19().authMetadata;
    var clearFilter = useFilterContext16().clearFilter;
    var setAppModeWithFilterReset = useModeContext10().setAppModeWithFilterReset;
    var _useSettingsStore7 = useSettingsStore7(), setMetrics = _useSettingsStore7.setMetrics, setSettings = _useSettingsStore7.setSettings;
    var _useTwinContext10 = useTwinContext10(), setTwin = _useTwinContext10.setTwin, setTwinBId = _useTwinContext10.setTwinBId;
    var _useTwinConfigStore2 = useTwinConfigStore2(), setTwinConfig = _useTwinConfigStore2.setTwinConfig, clearTwinConfig = _useTwinConfigStore2.clearTwinConfig;
    return useCallback25(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(twin, options) {
            var _options_accessToken, token, organisationName, timezone, template, bID, settings, twinPrefs, configLoaded, twinConfig, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        token = (_options_accessToken = options === null || options === void 0 ? void 0 : options.accessToken) !== null && _options_accessToken !== void 0 ? _options_accessToken : accessToken;
                        organisationName = authMetadata === null || authMetadata === void 0 ? void 0 : authMetadata.organisation;
                        timezone = twin.iana_timezone;
                        template = twin.template;
                        bID = twin.bid;
                        if (!organisationName) {
                            navigate("/something-went-wrong");
                        }
                        settings = null;
                        clearFilter(true);
                        setMetrics([]);
                        setTwinBId(null);
                        setTwin(null);
                        clearTwinConfig();
                        if (bID) {
                            twinPrefs = {
                                organisation: organisationName,
                                timeZone: timezone ? timezone : "Europe/London"
                            };
                            switch(template){
                                case Template.Gym:
                                    settings = _object_spread({}, gymTwinTemplate, twinPrefs);
                                    break;
                                case Template.Truck:
                                    settings = _object_spread({}, expoTwinTemplate, twinPrefs);
                                    break;
                                case Template.Event:
                                    settings = _object_spread({}, eventTwinTemplate, twinPrefs);
                                    break;
                                default:
                                    settings = _object_spread({}, gymTwinTemplate, twinPrefs);
                                    break;
                            }
                        }
                        setSettings(settings);
                        setLoading(true);
                        setTwinBId(twin.bid);
                        setSelectedTwinBID(twin.bid);
                        configLoaded = false;
                        if (!(token && twin.bid)) return [
                            3,
                            4
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            getTwinConfig(middlewareApi, token, twin.bid)
                        ];
                    case 2:
                        twinConfig = _state.sent();
                        if (twinConfig) {
                            setTwinConfig(twinConfig);
                            configLoaded = true;
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.error("Failed to load twin configuration:", error);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        if (configLoaded) {
                            setAppModeWithFilterReset(AppMode7.LIVE);
                            navigate("/twin");
                            return [
                                2,
                                true
                            ];
                        } else {
                            console.error("Failed to load twin configuration for:", twin.bid);
                            setLoading(false);
                            return [
                                2,
                                false
                            ];
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(twin, options) {
            return _ref.apply(this, arguments);
        };
    }(), [
        accessToken,
        authMetadata === null || authMetadata === void 0 ? void 0 : authMetadata.organisation,
        clearFilter,
        clearTwinConfig,
        middlewareApi,
        navigate,
        setAppModeWithFilterReset,
        setLoading,
        setMetrics,
        setSelectedTwinBID,
        setSettings,
        setTwin,
        setTwinBId,
        setTwinConfig
    ]);
};
// src/components/TwinSelector/TwinSelector.tsx
import { jsx as jsx141, jsxs as jsxs98 } from "react/jsx-runtime";
var TwinSelector = function(param) {
    var className = param.className, _param_middlewareApi = param.middlewareApi, middlewareApi = _param_middlewareApi === void 0 ? "" : _param_middlewareApi, createTwinElement = param.createTwinElement, onCreateTwin = param.onCreateTwin;
    var _authMetadata_roles, _availableTwins_sort;
    var _useAuth04 = useAuth04(), isAuthenticated = _useAuth04.isAuthenticated, getAccessTokenSilently = _useAuth04.getAccessTokenSilently;
    var _useDialogContext5 = useDialogContext5(), showDialog = _useDialogContext5.showDialog, hideDialog = _useDialogContext5.hideDialog;
    var navigate = useNavigate3();
    var _useTwinStore2 = useTwinStore2(), setAvailableTwins = _useTwinStore2.setAvailableTwins, setLoading = _useTwinStore2.setLoading, selectedTwinBID = _useTwinStore2.selectedTwinBID;
    var _useState71 = _sliced_to_array(useState71([]), 2), availableTwins = _useState71[0], setLocalAvailableTwins = _useState71[1];
    var _useState711 = _sliced_to_array(useState71(true), 2), fetchTwins = _useState711[0], setFetchTwins = _useState711[1];
    var _useState712 = _sliced_to_array(useState71(true), 2), isLoading = _useState712[0], setIsLoading = _useState712[1];
    var _useState713 = _sliced_to_array(useState71(null), 2), accessToken = _useState713[0], setAccessToken = _useState713[1];
    var _useState714 = _sliced_to_array(useState71(null), 2), hoveredTwinIndex = _useState714[0], setHoveredTwinIndex = _useState714[1];
    var authMetadata = useUserStore20().authMetadata;
    var _authMetadata_roles_includes;
    var isTlAdmin = (_authMetadata_roles_includes = authMetadata === null || authMetadata === void 0 ? void 0 : (_authMetadata_roles = authMetadata.roles) === null || _authMetadata_roles === void 0 ? void 0 : _authMetadata_roles.includes(Roles7.TL_ADMIN)) !== null && _authMetadata_roles_includes !== void 0 ? _authMetadata_roles_includes : false;
    var openTwin = useOpenTwin({
        middlewareApi: middlewareApi,
        accessToken: accessToken
    });
    var tabOpts = [
        {
            inactiveIcon: /* @__PURE__ */ jsx141(Cube16Regular, {}),
            activeIcon: /* @__PURE__ */ jsx141(Cube16Filled, {}),
            value: TabPanel2.TWINS.toString(),
            text: "Twins"
        }
    ];
    var _useState715 = _sliced_to_array(useState71(TabPanel2.TWINS), 2), tabPanel = _useState715[0], setTabPanel = _useState715[1];
    var _useState716 = _sliced_to_array(useState71(tabOpts), 1), tabOptions = _useState716[0];
    useEffect47(function() {
        var getAccessToken = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function() {
                var accessToken2;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                getAccessTokenSilently()
                            ];
                        case 1:
                            accessToken2 = _state.sent();
                            setAccessToken(accessToken2);
                            return [
                                2
                            ];
                    }
                });
            });
            return function getAccessToken() {
                return _ref.apply(this, arguments);
            };
        }();
        getAccessToken();
    }, [
        isAuthenticated,
        getAccessTokenSilently
    ]);
    useEffect47(function() {
        var localFetchTwins = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function() {
                var twins, twinMarkers;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(accessToken && isAuthenticated && (authMetadata === null || authMetadata === void 0 ? void 0 : authMetadata.orgBID) && fetchTwins)) return [
                                3,
                                2
                            ];
                            setIsLoading(true);
                            setLoading(true);
                            return [
                                4,
                                getTwins(middlewareApi, accessToken, authMetadata === null || authMetadata === void 0 ? void 0 : authMetadata.orgBID)
                            ];
                        case 1:
                            twins = _state.sent();
                            if (twins) {
                                setLocalAvailableTwins(twins);
                                twinMarkers = extractTwinMarkerData(twins);
                                setAvailableTwins(twinMarkers);
                            }
                            setIsLoading(false);
                            setFetchTwins(false);
                            _state.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            });
            return function localFetchTwins() {
                return _ref.apply(this, arguments);
            };
        }();
        localFetchTwins();
    }, [
        accessToken,
        authMetadata === null || authMetadata === void 0 ? void 0 : authMetadata.orgBID,
        fetchTwins,
        isAuthenticated,
        setAvailableTwins,
        setLoading
    ]);
    var handleTwinSelection = useCallback26(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(twin) {
            var opened;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsLoading(true);
                        return [
                            4,
                            openTwin(twin)
                        ];
                    case 1:
                        opened = _state.sent();
                        if (!opened) {
                            setIsLoading(false);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(twin) {
            return _ref.apply(this, arguments);
        };
    }(), [
        openTwin
    ]);
    var closeAddTwinDialog = useCallback26(function() {
        hideDialog();
        setFetchTwins(true);
    }, [
        hideDialog,
        setFetchTwins
    ]);
    return /* @__PURE__ */ jsxs98("div", {
        className: className,
        children: [
            /* @__PURE__ */ jsx141("div", {
                className: "header",
                children: /* @__PURE__ */ jsx141(TLCard_default, {
                    size: "small",
                    children: /* @__PURE__ */ jsx141(TLSwitcher_default, {
                        size: "small",
                        selectedValue: tabPanel.toString(),
                        options: tabOptions,
                        setValue: setTabPanel
                    })
                })
            }),
            /* @__PURE__ */ jsx141(Permissioned_default, {
                necessaryPermissions: [
                    "permission_twin_editing"
                ],
                children: /* @__PURE__ */ jsx141(PrimaryButton_default, {
                    className: "add-twin",
                    align: Align2.LEFT,
                    icon: /* @__PURE__ */ jsx141(AddTwinIcon, {}),
                    onClick: function() {
                        if (onCreateTwin) {
                            onCreateTwin();
                            return;
                        }
                        if (React74.isValidElement(createTwinElement)) {
                            showDialog({
                                title: "",
                                content: React74.cloneElement(createTwinElement, {
                                    onClose: closeAddTwinDialog
                                })
                            });
                        }
                    },
                    children: "Create New Twin"
                })
            }),
            tabPanel === TabPanel2.TWINS && /* @__PURE__ */ jsx141(Scrollbar9, {
                fadeOutEnabled: false,
                className: "scrollable-container",
                maxHeight: "calc(100vh - 280px)",
                children: /* @__PURE__ */ jsx141(Accordion4, {
                    collapsible: true,
                    defaultOpenItems: [
                        "twins-list"
                    ],
                    children: /* @__PURE__ */ jsx141(AccordionItem3, {
                        value: "twins-list",
                        children: /* @__PURE__ */ jsxs98(TLCard_default, {
                            padding: "0",
                            hovered: false,
                            selected: false,
                            children: [
                                /* @__PURE__ */ jsx141(AccordionHeader3, {
                                    expandIconPosition: "end",
                                    children: /* @__PURE__ */ jsx141("div", {
                                        className: "accordion-header",
                                        children: /* @__PURE__ */ jsx141(LabelHeader_default, {
                                            id: "pick-your-gym",
                                            fontSize: "14px",
                                            title: "Pick your gym",
                                            indicator: /* @__PURE__ */ jsxs98("strong", {
                                                children: [
                                                    availableTwins === null || availableTwins === void 0 ? void 0 : availableTwins.length,
                                                    " gym",
                                                    (availableTwins === null || availableTwins === void 0 ? void 0 : availableTwins.length) === 1 ? null : "s"
                                                ]
                                            })
                                        })
                                    })
                                }),
                                /* @__PURE__ */ jsx141(AccordionPanel3, {
                                    style: {
                                        padding: "0 8px",
                                        margin: 0
                                    },
                                    children: isLoading ? /* @__PURE__ */ jsx141("div", {
                                        className: "loading",
                                        children: /* @__PURE__ */ jsx141("p", {
                                            children: "Loading..."
                                        })
                                    }) : /* @__PURE__ */ jsx141("div", {
                                        className: "twins-list",
                                        children: availableTwins === null || availableTwins === void 0 ? void 0 : (_availableTwins_sort = availableTwins.sort(function(a, b) {
                                            return a.name.localeCompare(b.name);
                                        })) === null || _availableTwins_sort === void 0 ? void 0 : _availableTwins_sort.map(function(twin, i) {
                                            return /* @__PURE__ */ jsx141(TLCard_default, {
                                                className: "accordion-item",
                                                padding: "8px",
                                                hovered: hoveredTwinIndex === i,
                                                selected: twin.bid === selectedTwinBID,
                                                children: /* @__PURE__ */ jsxs98("div", {
                                                    className: "accordion-button",
                                                    onClick: function() {
                                                        return handleTwinSelection(twin);
                                                    },
                                                    onMouseEnter: function() {
                                                        return setHoveredTwinIndex(i);
                                                    },
                                                    onMouseLeave: function() {
                                                        return setHoveredTwinIndex(null);
                                                    },
                                                    children: [
                                                        /* @__PURE__ */ jsx141(LabelHeader_default, {
                                                            id: "".concat(i),
                                                            fontSize: "12px",
                                                            title: twin.name
                                                        }),
                                                        isTlAdmin && /* @__PURE__ */ jsx141("button", {
                                                            type: "button",
                                                            className: "setup-twin",
                                                            title: "Setup ".concat(twin.name),
                                                            "aria-label": "Setup ".concat(twin.name),
                                                            onClick: function(e) {
                                                                e.stopPropagation();
                                                                navigate(twinSetupPath(twin));
                                                            },
                                                            children: /* @__PURE__ */ jsx141(Wrench16Regular, {})
                                                        })
                                                    ]
                                                })
                                            }, i);
                                        })
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
var TwinSelector_default = styled101(TwinSelector)(_templateObject230());
// src/components/TwinMarkers/TwinMarkers.tsx
import { AppMode as AppMode8, Template as Template2 } from "@repo/frontend-types";
import { useEffect as useEffect48, useRef as useRef29, useState as useState72 } from "react";
import { Marker } from "react-map-gl/mapbox";
import styled102 from "styled-components";
import { useAuth0 as useAuth05 } from "@auth0/auth0-react";
import { useTwinMarkers, useSelectedTwinBID, useTwinStore as useTwinStore3, useUserStore as useUserStore21, useSettingsStore as useSettingsStore8, useTwinContext as useTwinContext11, useModeContext as useModeContext11, useFilterContext as useFilterContext17, createRequestSequencer, runLatestWins } from "@repo/front-end-state";
import { gymTwinTemplate as gymTwinTemplate2, expoTwinTemplate as expoTwinTemplate2, eventTwinTemplate as eventTwinTemplate2 } from "@repo/front-end-data";
import { getOrgTwins as getTwins2 } from "@repo/front-end-services";
import { Fragment as Fragment32, jsx as jsx142, jsxs as jsxs99 } from "react/jsx-runtime";
var hasMapPosition = function(twin) {
    return [
        twin.latitude,
        twin.longitude
    ].every(function(value) {
        return value !== null && value !== void 0 && value !== "" && Number.isFinite(Number(value));
    });
};
var TwinMarkers = function(param) {
    var className = param.className, middlewareApi = param.middlewareApi;
    var getAccessTokenSilently = useAuth05().getAccessTokenSilently;
    var appMode = useModeContext11().appMode;
    var twinMarkers = useTwinMarkers();
    var selectedTwinBID = useSelectedTwinBID();
    var setSelectedTwinBID = useTwinStore3().setSelectedTwinBID;
    var authMetadata = useUserStore21().authMetadata;
    var clearFilter = useFilterContext17().clearFilter;
    var _useSettingsStore8 = useSettingsStore8(), setMetrics = _useSettingsStore8.setMetrics, setSettings = _useSettingsStore8.setSettings;
    var _useTwinContext11 = useTwinContext11(), setTwin = _useTwinContext11.setTwin, setTwinBId = _useTwinContext11.setTwinBId;
    var _useState72 = _sliced_to_array(useState72([]), 2), fullTwinsData = _useState72[0], setFullTwinsData = _useState72[1];
    var sequencerRef = useRef29(createRequestSequencer());
    useEffect48(function() {
        var sequencer = sequencerRef.current;
        var fetchFullTwins = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function() {
                var orgBID, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (appMode !== AppMode8.TWIN_SELECTION || !(authMetadata === null || authMetadata === void 0 ? void 0 : authMetadata.orgBID) || !twinMarkers.length) {
                                return [
                                    2
                                ];
                            }
                            orgBID = authMetadata.orgBID;
                            if (!middlewareApi) {
                                console.error("TwinMarkers: middlewareApi is empty \u2014 skipping the org-twins fetch, which would otherwise resolve against the viewer origin and 404 silently.");
                                return [
                                    2
                                ];
                            }
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                runLatestWins(sequencer, /*#__PURE__*/ _async_to_generator(function() {
                                    var accessToken;
                                    return _ts_generator(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    getAccessTokenSilently()
                                                ];
                                            case 1:
                                                accessToken = _state.sent();
                                                return [
                                                    2,
                                                    getTwins2(middlewareApi, accessToken, orgBID)
                                                ];
                                        }
                                    });
                                }), function(twins) {
                                    if (twins) {
                                        setFullTwinsData(twins);
                                    }
                                })
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            console.error("Failed to fetch full twins data for markers:", error);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchFullTwins() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchFullTwins();
        return function() {
            sequencer.next();
        };
    }, [
        appMode,
        authMetadata === null || authMetadata === void 0 ? void 0 : authMetadata.orgBID,
        twinMarkers.length,
        middlewareApi,
        getAccessTokenSilently
    ]);
    if (appMode !== AppMode8.TWIN_SELECTION || !twinMarkers.length) {
        return null;
    }
    var clearContext = function() {
        clearFilter(true);
        setMetrics([]);
        setTwinBId(null);
        setTwin(null);
    };
    var setSitePref = function(organisationName, timezone, template, bID) {
        if (!organisationName) {
            return false;
        }
        var settings = null;
        clearContext();
        if (bID) {
            var twinPrefs = {
                organisation: organisationName,
                timeZone: timezone ? timezone : "Europe/London"
            };
            switch(template){
                case Template2.Gym:
                    settings = _object_spread({}, gymTwinTemplate2, twinPrefs);
                    break;
                case Template2.Truck:
                    settings = _object_spread({}, expoTwinTemplate2, twinPrefs);
                    break;
                case Template2.Event:
                    settings = _object_spread({}, eventTwinTemplate2, twinPrefs);
                    break;
                default:
                    settings = _object_spread({}, gymTwinTemplate2, twinPrefs);
                    break;
            }
        }
        setSettings(settings);
        return true;
    };
    var handleMarkerClick = function(twinBID) {
        var fullTwin = fullTwinsData === null || fullTwinsData === void 0 ? void 0 : fullTwinsData.find(function(twin) {
            return twin.bid === twinBID;
        });
        if (!fullTwin) {
            console.error("Could not find full twin data for BID:", twinBID);
            return;
        }
        if (setSitePref(authMetadata === null || authMetadata === void 0 ? void 0 : authMetadata.organisation, fullTwin.iana_timezone, fullTwin.template, fullTwin.bid)) {
            setTwinBId(fullTwin.bid);
            setSelectedTwinBID(fullTwin.bid);
        }
    };
    return /* @__PURE__ */ jsx142(Fragment32, {
        children: twinMarkers.filter(hasMapPosition).map(function(twin) {
            return /* @__PURE__ */ jsx142(Marker, {
                latitude: twin.latitude,
                longitude: twin.longitude,
                anchor: "bottom",
                onClick: function(e) {
                    e.originalEvent.stopPropagation();
                    handleMarkerClick(twin.bid);
                },
                children: /* @__PURE__ */ jsx142("div", {
                    className: className,
                    children: /* @__PURE__ */ jsxs99("div", {
                        className: "marker ".concat(selectedTwinBID === twin.bid ? "selected" : ""),
                        title: twin.name,
                        children: [
                            /* @__PURE__ */ jsx142("div", {
                                className: "marker-icon",
                                children: /* @__PURE__ */ jsx142("svg", {
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 24 24",
                                    fill: "currentColor",
                                    children: /* @__PURE__ */ jsx142("path", {
                                        d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
                                    })
                                })
                            }),
                            /* @__PURE__ */ jsx142("div", {
                                className: "marker-label",
                                children: twin.name
                            })
                        ]
                    })
                })
            }, twin.bid);
        })
    });
};
var TwinMarkers_default = styled102(TwinMarkers)(_templateObject231());
// src/components/MainNav/MainNav.tsx
import { AppMode as AppMode10, Roles as Roles9 } from "@repo/frontend-types";
import { useCallback as useCallback28, useState as useState74, useMemo as useMemo29, useEffect as useEffect50 } from "react";
import styled105 from "styled-components";
import { useAuth0 as useAuth06 } from "@auth0/auth0-react";
import { useNavigate as useNavigate4, useLocation as useLocation2 } from "react-router-dom";
import { useTwinConfigStore as useTwinConfigStore3, useUserStore as useUserStore24, useSettingsStore as useSettingsStore9, useSpotlightStore as useSpotlightStore3, useTwinContext as useTwinContext12, useFilterContext as useFilterContext18, useModeContext as useModeContext13, useUnreadCount } from "@repo/front-end-state";
import { buildHeroMetric, findIndicatorConfigForMetric, heroMetricModeFor, indicatorScopeFor, isHeroMetricEnabledForMode } from "@repo/front-end-utils";
import { Button as Button16, Icon as Icon14, NavBar, NavBarStatus, accountMenuLabel as accountMenuLabel2 } from "@repo/design-system";
import { DataUsage16Regular, People16Regular } from "@fluentui/react-icons";
import mariaIconSrc from "@repo/assets/icons/maria-icon-dark-grey.svg";
import twinlabsAiLogo from "@repo/assets/logos/twinlabs-ai-logo.svg";
// src/components/AccountMenu/AccountMenu.tsx
import styled104 from "styled-components";
import { Avatar as Avatar3, Icon as Icon13, MenuGroup, MenuSeparator, NavBarMenuItem, avatarInitialsName } from "@repo/design-system";
import { fontMono as fontMono6, ink as ink20, space as space23, typeScale as typeScale9, weight as weight10 } from "@repo/design-tokens";
// src/components/MainNav/useAccountActions.tsx
import { AppMode as AppMode9, Roles as Roles8 } from "@repo/frontend-types";
import { useMemo as useMemo28 } from "react";
import { useUserStore as useUserStore23, useDialogContext as useDialogContext6, useModeContext as useModeContext12 } from "@repo/front-end-state";
// src/components/NotificationSettings/NotificationSettings.tsx
import { useCallback as useCallback27, useEffect as useEffect49, useState as useState73 } from "react";
import styled103 from "styled-components";
import { useUserStore as useUserStore22 } from "@repo/front-end-state";
import { MessageBar as MessageBar7, MessageBarBody, RadioGroup, Radio } from "@fluentui/react-components";
import { Alert24Regular as Alert24Regular2 } from "@fluentui/react-icons";
import { getSubscriptionCatalog, getMySubscriptions, putSubscription, deleteSubscription } from "@repo/front-end-services";
import { jsx as jsx143, jsxs as jsxs100 } from "react/jsx-runtime";
var STRINGS2 = {
    header: "Notifications",
    intro: "Choose which reports you want, and whether to also receive them by email.",
    signedUpLabel: "Notify me",
    emailLabel: "Email me this report",
    frequencyLabel: "How often",
    // Keyed by catalog frequency value so the radios render from entry.frequencies (AC4).
    frequencyLabels: {
        daily: "Daily",
        weekly: "Weekly"
    },
    close: "Close",
    loadError: "We couldn\u2019t load your notification settings. Please close and try again.",
    saveError: "Something went wrong saving that change. Please try again.",
    noAuth: "You need to be signed in to manage notifications."
};
var defaultFrequency = function(entry) {
    var _entry_frequencies_;
    return (_entry_frequencies_ = entry.frequencies[0]) !== null && _entry_frequencies_ !== void 0 ? _entry_frequencies_ : "daily";
};
var buildScenarioState = function(catalog, subscriptions) {
    var state = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var entry = _step.value;
            var _rows_find;
            var rows = subscriptions.filter(function(s) {
                return s.scenario === entry.key;
            });
            var _rows_find_email_frequency;
            state[entry.key] = {
                signedUp: rows.length > 0,
                emailEnabled: rows.some(function(r) {
                    return r.email_enabled;
                }),
                frequency: (_rows_find_email_frequency = (_rows_find = rows.find(function(r) {
                    return r.email_frequency;
                })) === null || _rows_find === void 0 ? void 0 : _rows_find.email_frequency) !== null && _rows_find_email_frequency !== void 0 ? _rows_find_email_frequency : defaultFrequency(entry)
            };
        };
        for(var _iterator = catalog[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return state;
};
var NotificationSettings = function(param) {
    var className = param.className, middlewareApi = param.middlewareApi, onClose = param.onClose;
    var _authMetadata_tokens;
    var authMetadata = useUserStore22().authMetadata;
    var accessToken = authMetadata === null || authMetadata === void 0 ? void 0 : (_authMetadata_tokens = authMetadata.tokens) === null || _authMetadata_tokens === void 0 ? void 0 : _authMetadata_tokens.accessToken;
    var _useState73 = _sliced_to_array(useState73(true), 2), loading = _useState73[0], setLoading = _useState73[1];
    var _useState731 = _sliced_to_array(useState73(null), 2), loadError = _useState731[0], setLoadError = _useState731[1];
    var _useState732 = _sliced_to_array(useState73(null), 2), saveError = _useState732[0], setSaveError = _useState732[1];
    var _useState733 = _sliced_to_array(useState73([]), 2), catalog = _useState733[0], setCatalog = _useState733[1];
    var _useState734 = _sliced_to_array(useState73({}), 2), scenarioState = _useState734[0], setScenarioState = _useState734[1];
    var _useState735 = _sliced_to_array(useState73({}), 2), busy = _useState735[0], setBusy = _useState735[1];
    useEffect49(function() {
        var cancelled = false;
        if (!accessToken) {
            setLoadError(STRINGS2.noAuth);
            setLoading(false);
            return;
        }
        setLoading(true);
        setLoadError(null);
        setSaveError(null);
        _async_to_generator(function() {
            var _ref, catalogData, subs, e;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            3,
                            4
                        ]);
                        return [
                            4,
                            Promise.all([
                                getSubscriptionCatalog(middlewareApi, accessToken),
                                getMySubscriptions(middlewareApi, accessToken)
                            ])
                        ];
                    case 1:
                        _ref = _sliced_to_array.apply(void 0, [
                            _state.sent(),
                            2
                        ]), catalogData = _ref[0], subs = _ref[1];
                        if (cancelled) return [
                            2
                        ];
                        setCatalog(catalogData);
                        setScenarioState(buildScenarioState(catalogData, subs));
                        setLoadError(null);
                        return [
                            3,
                            4
                        ];
                    case 2:
                        e = _state.sent();
                        if (!cancelled) setLoadError(STRINGS2.loadError);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        if (!cancelled) setLoading(false);
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
        return function() {
            cancelled = true;
        };
    }, [
        accessToken,
        middlewareApi
    ]);
    var runScenarioWrite = useCallback27(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(key, optimistic, action) {
            var previous, e;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        previous = scenarioState[key];
                        setScenarioState(function(s) {
                            return _object_spread_props(_object_spread({}, s), _define_property({}, key, optimistic));
                        });
                        setBusy(function(b) {
                            return _object_spread_props(_object_spread({}, b), _define_property({}, key, true));
                        });
                        setSaveError(null);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            action()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 3:
                        e = _state.sent();
                        setScenarioState(function(s) {
                            return _object_spread_props(_object_spread({}, s), _define_property({}, key, previous));
                        });
                        setSaveError(STRINGS2.saveError);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setBusy(function(b) {
                            return _object_spread_props(_object_spread({}, b), _define_property({}, key, false));
                        });
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(key, optimistic, action) {
            return _ref.apply(this, arguments);
        };
    }(), [
        scenarioState
    ]);
    var onToggleSignedUp = function(entry, next) {
        if (!accessToken) return;
        var current = scenarioState[entry.key];
        if (next) {
            var _current_frequency;
            runScenarioWrite(entry.key, {
                signedUp: true,
                emailEnabled: false,
                frequency: (_current_frequency = current === null || current === void 0 ? void 0 : current.frequency) !== null && _current_frequency !== void 0 ? _current_frequency : defaultFrequency(entry)
            }, function() {
                return putSubscription(middlewareApi, accessToken, entry.key, {
                    email_enabled: false
                });
            });
        } else {
            var _current_frequency1;
            runScenarioWrite(entry.key, {
                signedUp: false,
                emailEnabled: false,
                frequency: (_current_frequency1 = current === null || current === void 0 ? void 0 : current.frequency) !== null && _current_frequency1 !== void 0 ? _current_frequency1 : defaultFrequency(entry)
            }, function() {
                return deleteSubscription(middlewareApi, accessToken, entry.key);
            });
        }
    };
    var onToggleEmail = function(entry, next) {
        if (!accessToken) return;
        var current = scenarioState[entry.key];
        var _current_frequency;
        var frequency = (_current_frequency = current === null || current === void 0 ? void 0 : current.frequency) !== null && _current_frequency !== void 0 ? _current_frequency : defaultFrequency(entry);
        if (next) {
            runScenarioWrite(entry.key, {
                signedUp: true,
                emailEnabled: true,
                frequency: frequency
            }, function() {
                return putSubscription(middlewareApi, accessToken, entry.key, {
                    email_enabled: true,
                    email_frequency: frequency
                });
            });
        } else {
            runScenarioWrite(entry.key, {
                signedUp: true,
                emailEnabled: false,
                frequency: frequency
            }, function() {
                return putSubscription(middlewareApi, accessToken, entry.key, {
                    email_enabled: false
                });
            });
        }
    };
    var onChangeFrequency = function(entry, frequency) {
        if (!accessToken) return;
        runScenarioWrite(entry.key, {
            signedUp: true,
            emailEnabled: true,
            frequency: frequency
        }, function() {
            return putSubscription(middlewareApi, accessToken, entry.key, {
                email_enabled: true,
                email_frequency: frequency
            });
        });
    };
    return /* @__PURE__ */ jsx143("div", {
        className: className,
        children: /* @__PURE__ */ jsxs100(DialogForm_default, {
            icon: /* @__PURE__ */ jsx143(Alert24Regular2, {}),
            header: STRINGS2.header,
            isLoading: loading,
            onClose: onClose,
            adminForm: true,
            children: [
                (loadError || saveError) && /* @__PURE__ */ jsx143(MessageBar7, {
                    className: "message-bar",
                    intent: "error",
                    layout: "multiline",
                    role: "alert",
                    children: /* @__PURE__ */ jsx143(MessageBarBody, {
                        children: loadError !== null && loadError !== void 0 ? loadError : saveError
                    })
                }),
                !loadError && /* @__PURE__ */ jsx143("p", {
                    className: "intro",
                    children: STRINGS2.intro
                }),
                !loadError && catalog.map(function(entry) {
                    var _scenarioState_entry_key;
                    var state = (_scenarioState_entry_key = scenarioState[entry.key]) !== null && _scenarioState_entry_key !== void 0 ? _scenarioState_entry_key : {
                        signedUp: false,
                        emailEnabled: false,
                        frequency: defaultFrequency(entry)
                    };
                    var isBusy = !!busy[entry.key];
                    return /* @__PURE__ */ jsxs100("section", {
                        className: "scenario",
                        "data-testid": "scenario-".concat(entry.key),
                        children: [
                            /* @__PURE__ */ jsxs100("div", {
                                className: "scenario-header",
                                children: [
                                    /* @__PURE__ */ jsxs100("div", {
                                        className: "scenario-copy",
                                        children: [
                                            /* @__PURE__ */ jsx143("h3", {
                                                children: entry.name
                                            }),
                                            /* @__PURE__ */ jsx143("p", {
                                                children: entry.description
                                            })
                                        ]
                                    }),
                                    /* @__PURE__ */ jsx143(TLAdminSwitch_default, {
                                        id: "notify-".concat(entry.key),
                                        ariaLabel: "".concat(STRINGS2.signedUpLabel, ": ").concat(entry.name),
                                        checked: state.signedUp,
                                        disabled: isBusy,
                                        onChange: function(e) {
                                            return onToggleSignedUp(entry, e.currentTarget.checked);
                                        }
                                    })
                                ]
                            }),
                            state.signedUp && entry.supportsEmail && /* @__PURE__ */ jsxs100("div", {
                                className: "scenario-email",
                                children: [
                                    /* @__PURE__ */ jsx143(TLAdminSwitch_default, {
                                        id: "email-".concat(entry.key),
                                        label: STRINGS2.emailLabel,
                                        ariaLabel: "".concat(STRINGS2.emailLabel, ": ").concat(entry.name),
                                        checked: state.emailEnabled,
                                        disabled: isBusy,
                                        onChange: function(e) {
                                            return onToggleEmail(entry, e.currentTarget.checked);
                                        }
                                    }),
                                    state.emailEnabled && /* @__PURE__ */ jsx143(RadioGroup, {
                                        layout: "horizontal",
                                        "aria-label": STRINGS2.frequencyLabel,
                                        value: state.frequency,
                                        disabled: isBusy,
                                        onChange: function(_, data) {
                                            return onChangeFrequency(entry, data.value);
                                        },
                                        children: entry.frequencies.map(function(freq) {
                                            return /* @__PURE__ */ jsx143(Radio, {
                                                value: freq,
                                                label: STRINGS2.frequencyLabels[freq]
                                            }, freq);
                                        })
                                    })
                                ]
                            })
                        ]
                    }, entry.key);
                }),
                /* @__PURE__ */ jsx143(SecondaryButton_default, {
                    onClick: onClose,
                    children: STRINGS2.close
                })
            ]
        })
    });
};
var NotificationSettings_default = styled103(NotificationSettings)(_templateObject232());
// src/components/MainNav/useAccountActions.tsx
import { Fragment as Fragment33, jsx as jsx144 } from "react/jsx-runtime";
var useAccountActions = function(param) {
    var _param_middlewareApi = param.middlewareApi, middlewareApi = _param_middlewareApi === void 0 ? "" : _param_middlewareApi, _param_appVersion = param.appVersion, appVersion = _param_appVersion === void 0 ? "" : _param_appVersion, restartTutorial = param.restartTutorial;
    var _authMetadata_roles;
    var _useDialogContext6 = useDialogContext6(), showDialog = _useDialogContext6.showDialog, hideDialog = _useDialogContext6.hideDialog;
    var appMode = useModeContext12().appMode;
    var authMetadata = useUserStore23().authMetadata;
    var isCustomerAdmin = (authMetadata === null || authMetadata === void 0 ? void 0 : (_authMetadata_roles = authMetadata.roles) === null || _authMetadata_roles === void 0 ? void 0 : _authMetadata_roles.includes(Roles8.CUSTOMER_ADMIN)) || false;
    return useMemo28(function() {
        var actions = [
            {
                key: "profile",
                label: "Profile",
                run: function() {
                    return showDialog({
                        title: "",
                        content: /* @__PURE__ */ jsx144(ProfileForm_default, {
                            middlewareApi: middlewareApi,
                            onClose: hideDialog
                        })
                    });
                }
            },
            {
                key: "changePassword",
                label: "Change Password",
                run: function() {
                    return showDialog({
                        title: "",
                        content: /* @__PURE__ */ jsx144(Fragment33, {
                            children: /* @__PURE__ */ jsx144(ChangePasswordForm_default, {
                                middlewareApi: middlewareApi,
                                onClose: hideDialog
                            })
                        })
                    });
                }
            },
            {
                key: "notifications",
                label: "Notifications",
                run: function() {
                    return showDialog({
                        title: "",
                        content: /* @__PURE__ */ jsx144(NotificationSettings_default, {
                            middlewareApi: middlewareApi,
                            onClose: hideDialog
                        })
                    });
                }
            }
        ];
        if (restartTutorial && appMode === AppMode9.LIVE) {
            actions.push({
                key: "restartTutorial",
                label: "Restart Tutorial",
                run: restartTutorial
            });
        }
        if (isCustomerAdmin) {
            actions.push({
                key: "manageUsers",
                label: "Manage Users",
                run: function() {
                    return showDialog({
                        title: "",
                        content: /* @__PURE__ */ jsx144(Fragment33, {
                            children: /* @__PURE__ */ jsx144(ManageUsers_default, {
                                middlewareApi: middlewareApi,
                                onClose: hideDialog
                            })
                        }),
                        width: "1100px"
                    });
                }
            });
        }
        actions.push({
            key: "logOut",
            label: "Log out",
            run: function() {
                return showDialog({
                    title: " Are you sure you wish to log out?",
                    content: /* @__PURE__ */ jsx144(LogOut_default, {
                        onClose: hideDialog
                    })
                });
            }
        }, {
            key: "about",
            label: "About",
            run: function() {
                return showDialog({
                    title: "",
                    content: /* @__PURE__ */ jsx144(Fragment33, {
                        children: /* @__PURE__ */ jsx144(About_default, {
                            onClose: hideDialog,
                            version: appVersion
                        })
                    })
                });
            }
        });
        return actions;
    }, [
        showDialog,
        hideDialog,
        appMode,
        isCustomerAdmin,
        middlewareApi,
        appVersion,
        restartTutorial
    ]);
};
// src/components/AccountMenu/AccountMenu.tsx
import { Fragment as Fragment34, jsx as jsx145, jsxs as jsxs101 } from "react/jsx-runtime";
var SUPPORT_EMAIL = "support@twinlabs.ai";
var ACCOUNT_ROWS = [
    "profile",
    "changePassword",
    "notifications",
    "manageUsers",
    "restartTutorial"
];
var ICON = {
    profile: "user",
    changePassword: "key",
    notifications: "bell",
    manageUsers: "users",
    restartTutorial: "arrow-rotate-right",
    about: "circle-info",
    logOut: "arrow-right-from-bracket"
};
var openMail = function(address) {
    var link = document.createElement("a");
    link.href = "mailto:".concat(address);
    link.click();
};
var Who = styled104.div(_templateObject233(), space23[2], weight10.semibold, ink20[1], weight10.regular, typeScale9.captionCompact.fontSize, fontMono6, ink20[3]);
var AccountMenu = function(param) {
    var name = param.name, email = param.email, picture = param.picture, middlewareApi = param.middlewareApi, appVersion = param.appVersion, restartTutorial = param.restartTutorial, _param_supportEmail = param.supportEmail, supportEmail = _param_supportEmail === void 0 ? SUPPORT_EMAIL : _param_supportEmail;
    var actions = useAccountActions({
        middlewareApi: middlewareApi,
        appVersion: appVersion,
        restartTutorial: restartTutorial
    });
    var byKey = new Map(actions.map(function(action) {
        return [
            action.key,
            action
        ];
    }));
    var row = function(key, variant) {
        var action = byKey.get(key);
        if (!action) return null;
        return /* @__PURE__ */ jsx145(NavBarMenuItem, {
            icon: /* @__PURE__ */ jsx145(Icon13, {
                name: ICON[key],
                size: "xs"
            }),
            variant: variant,
            onSelect: action.run,
            children: action.label
        }, key);
    };
    var shownName = (name === null || name === void 0 ? void 0 : name.trim()) ? name : email;
    var initialsFrom = avatarInitialsName(name, email);
    return /* @__PURE__ */ jsxs101(Fragment34, {
        children: [
            /* @__PURE__ */ jsxs101(Who, {
                "aria-hidden": "true",
                className: "account-who",
                children: [
                    /* @__PURE__ */ jsx145(Avatar3, {
                        name: initialsFrom,
                        src: picture,
                        size: "xs"
                    }),
                    /* @__PURE__ */ jsxs101("span", {
                        className: "who-text",
                        children: [
                            shownName ? /* @__PURE__ */ jsx145("span", {
                                className: "who-name",
                                children: shownName
                            }) : null,
                            email && shownName !== email ? /* @__PURE__ */ jsx145("span", {
                                className: "who-email",
                                children: email
                            }) : null
                        ]
                    })
                ]
            }),
            /* @__PURE__ */ jsx145(MenuSeparator, {}),
            ACCOUNT_ROWS.map(function(key) {
                return row(key);
            }),
            /* @__PURE__ */ jsx145(MenuSeparator, {}),
            /* @__PURE__ */ jsxs101(MenuGroup, {
                label: "Support",
                children: [
                    /* @__PURE__ */ jsx145(NavBarMenuItem, {
                        icon: /* @__PURE__ */ jsx145(Icon13, {
                            name: "circle-question",
                            size: "xs"
                        }),
                        meta: supportEmail,
                        onSelect: function() {
                            return openMail(supportEmail);
                        },
                        children: "Email support"
                    }),
                    row("about")
                ]
            }),
            /* @__PURE__ */ jsx145(MenuSeparator, {}),
            row("logOut", "danger")
        ]
    });
};
// src/components/MainNav/MainNav.tsx
import { Fragment as Fragment35, jsx as jsx146, jsxs as jsxs102 } from "react/jsx-runtime";
var MainNav = function(param) {
    var className = param.className, id = param.id, fullScreen = param.fullScreen, supportCopilotVisible = param.supportCopilotVisible, notificationsVisible = param.notificationsVisible, setFullScreen = param.setFullScreen, setSupportCopilotVisible = param.setSupportCopilotVisible, setNotificationsVisible = param.setNotificationsVisible, setShowTutorial = param.setShowTutorial, restartTutorial = param.restartTutorial, _param_middlewareApi = param.middlewareApi, middlewareApi = _param_middlewareApi === void 0 ? "" : _param_middlewareApi, onEditTwin = param.onEditTwin, onModeChoice = param.onModeChoice;
    var user = useAuth06().user;
    var navigate = useNavigate4();
    var location = useLocation2();
    var authMetadata = useUserStore24().authMetadata;
    var _useTwinContext12 = useTwinContext12(), twin = _useTwinContext12.twin, setTwin = _useTwinContext12.setTwin, twinBId = _useTwinContext12.twinBId, setTwinBId = _useTwinContext12.setTwinBId;
    var _useSettingsStore9 = useSettingsStore9(), setMetrics = _useSettingsStore9.setMetrics, settings = _useSettingsStore9.settings;
    var _useFilterContext18 = useFilterContext18(), lastUpdatedAt = _useFilterContext18.lastUpdatedAt, setHeroMetric = _useFilterContext18.setHeroMetric, heroMetric = _useFilterContext18.heroMetric, clearFilter = _useFilterContext18.clearFilter;
    var _useModeContext13 = useModeContext13(), appMode = _useModeContext13.appMode, setAppModeWithFilterReset = _useModeContext13.setAppModeWithFilterReset;
    var warning = useDataWarning();
    var _useTwinConfigStore3 = useTwinConfigStore3(), twinConfig = _useTwinConfigStore3.twinConfig, preferences = _useTwinConfigStore3.preferences, heroMetrics = _useTwinConfigStore3.heroMetrics, indicatorConfigs = _useTwinConfigStore3.indicatorConfigs, leftFieldMessages = _useTwinConfigStore3.leftFieldMessages, configLoading = _useTwinConfigStore3.isLoading, configError = _useTwinConfigStore3.error, hasPreferences = _useTwinConfigStore3.hasPreferences, hasHeroMetrics = _useTwinConfigStore3.hasHeroMetrics, hasIndicatorConfigs = _useTwinConfigStore3.hasIndicatorConfigs, hasLeftFieldMessages = _useTwinConfigStore3.hasLeftFieldMessages;
    var _useState74 = _sliced_to_array(useState74(""), 2), currentMetric = _useState74[0], setCurrentMetric = _useState74[1];
    var unreadCount = useUnreadCount();
    var isTLAdminOrPartner = useCallback28(function() {
        var _authMetadata_roles;
        return (authMetadata === null || authMetadata === void 0 ? void 0 : (_authMetadata_roles = authMetadata.roles) === null || _authMetadata_roles === void 0 ? void 0 : _authMetadata_roles.includes(Roles9.TL_ADMIN)) || false;
    }, [
        authMetadata === null || authMetadata === void 0 ? void 0 : authMetadata.roles
    ]);
    var clearContext = useCallback28(function() {
        clearFilter(true);
        setMetrics([]);
        setTwinBId(null);
        setTwin(null);
        useSpotlightStore3.getState().clearSpotlight();
    }, [
        clearFilter,
        setMetrics,
        setTwinBId,
        setTwin,
        twinBId,
        twin
    ]);
    var handleModeChange = useCallback28(function(mode) {
        onModeChoice === null || onModeChoice === void 0 ? void 0 : onModeChoice(mode);
        if (mode === AppMode10.EDIT && onEditTwin) {
            onEditTwin();
            return;
        }
        if (mode === AppMode10.TWIN_SELECTION || mode === AppMode10.ORG_SELECTION) {
            clearContext();
        }
        setAppModeWithFilterReset(mode);
    }, [
        clearContext,
        setAppModeWithFilterReset,
        onEditTwin,
        onModeChoice
    ]);
    useEffect50(function() {
        if (twin && appMode === AppMode10.TWIN_SELECTION) {
            setAppModeWithFilterReset(AppMode10.LIVE);
        }
    }, [
        twin,
        appMode,
        setAppModeWithFilterReset
    ]);
    var availableModes = useMemo29(function() {
        var _authMetadata_permissions;
        var hasTwinEditingPermission = authMetadata === null || authMetadata === void 0 ? void 0 : (_authMetadata_permissions = authMetadata.permissions) === null || _authMetadata_permissions === void 0 ? void 0 : _authMetadata_permissions.has("permission_twin_editing");
        var isTwinLoaded = !!twin;
        var liveMode = {
            value: AppMode10.LIVE,
            label: "Live",
            icon: /* @__PURE__ */ jsx146(Icon14, {
                name: "play"
            })
        };
        var historicalMode = {
            value: AppMode10.HISTORICAL,
            label: "Historical",
            icon: /* @__PURE__ */ jsx146(Icon14, {
                name: "chart-line"
            })
        };
        var dashboardMode = {
            value: AppMode10.DASHBOARD_UTILISATION,
            label: "BI Dashboards",
            icon: /* @__PURE__ */ jsx146(Icon14, {
                name: "chart-line"
            })
        };
        var editMode = {
            value: AppMode10.EDIT,
            label: "Edit",
            icon: /* @__PURE__ */ jsx146(Icon14, {
                name: "pen"
            })
        };
        var insightsMode = {
            value: AppMode10.INSIGHTS,
            label: "Insights",
            icon: /* @__PURE__ */ jsx146(Icon14, {
                name: "lightbulb"
            })
        };
        var equipmentMode = {
            value: AppMode10.EQUIPMENT,
            label: "Equipment",
            icon: /* @__PURE__ */ jsx146(Icon14, {
                name: "dumbbell"
            })
        };
        var modes = [];
        if (isTwinLoaded) {
            modes.push(liveMode, insightsMode, equipmentMode, historicalMode, dashboardMode);
            if (hasTwinEditingPermission) modes.push(editMode);
        }
        return modes;
    }, [
        authMetadata === null || authMetadata === void 0 ? void 0 : authMetadata.permissions,
        twin,
        authMetadata
    ]);
    useEffect50(function() {
        if (heroMetrics.length > 0 && !currentMetric) {
            var firstMetric = heroMetrics.sort(function(a, b) {
                return a.display_order - b.display_order;
            })[0];
            setCurrentMetric(firstMetric.id.toString());
        }
    }, [
        heroMetrics,
        currentMetric
    ]);
    var getIconComponent = useCallback28(function(iconName) {
        switch(iconName){
            case "DataUsage16Regular":
                return /* @__PURE__ */ jsx146(DataUsage16Regular, {});
            case "People16Regular":
                return /* @__PURE__ */ jsx146(People16Regular, {});
            default:
                return /* @__PURE__ */ jsx146(DataUsage16Regular, {});
        }
    }, []);
    var getIndicatorConfigForMetric = useCallback28(function(indicatorMetricName, modes) {
        return findIndicatorConfigForMetric(indicatorConfigs, indicatorMetricName, indicatorScopeFor(modes, appMode));
    }, [
        indicatorConfigs,
        appMode
    ]);
    var createHeroMetricFromStore = useCallback28(function(storeMetric) {
        return buildHeroMetric(storeMetric, getIndicatorConfigForMetric(storeMetric.indicator_metric.name, storeMetric.modes));
    }, [
        getIndicatorConfigForMetric
    ]);
    var availableMetrics = useMemo29(function() {
        if (!heroMetrics || heroMetrics.length === 0) {
            return [];
        }
        var filteredMetrics = heroMetrics.filter(function(metric) {
            return isHeroMetricEnabledForMode(metric.modes, appMode);
        });
        var modeName = heroMetricModeFor(appMode);
        return filteredMetrics.sort(function(a, b) {
            return a.display_order - b.display_order;
        }).map(function(metric) {
            var _metric_modes_find;
            return {
                value: metric.id.toString(),
                // Use ID as value for easier lookup
                label: ((_metric_modes_find = metric.modes.find(function(m) {
                    return m.mode === modeName;
                })) === null || _metric_modes_find === void 0 ? void 0 : _metric_modes_find.name) || metric.name,
                icon: getIconComponent(metric.icon),
                heroMetric: createHeroMetricFromStore(metric)
            };
        });
    }, [
        heroMetrics,
        appMode,
        getIconComponent,
        createHeroMetricFromStore
    ]);
    var handleHeroMetricChange = function(heroMetric2) {
        var storeMetric = heroMetrics.find(function(m) {
            return m.id === heroMetric2.id;
        });
        if (storeMetric) {
            setCurrentMetric(storeMetric.id.toString());
            setHeroMetric(heroMetric2);
        } else {
            console.error("MainNav: Could not find store metric for valueMetricName:", heroMetric2.valueMetricName);
        }
    };
    var getDataStatusText = function() {
        if (appMode === AppMode10.LIVE && warning) {
            return "Real-time data interrupted";
        }
        if (appMode === AppMode10.HISTORICAL && lastUpdatedAt) {
            return /* @__PURE__ */ jsxs102(Fragment35, {
                children: [
                    "Data last updated at ",
                    /* @__PURE__ */ jsx146("b", {
                        children: lastUpdatedAt
                    })
                ]
            });
        }
        return null;
    };
    var handleBrand = function() {
        var searchParams = new URLSearchParams(location.search);
        if (searchParams.has("spotlight")) {
            searchParams.delete("spotlight");
            var newSearch = searchParams.toString();
            var newPath = "".concat(location.pathname).concat(newSearch ? "?".concat(newSearch) : "");
            navigate(newPath, {
                replace: true
            });
        }
        if (location.pathname.includes("account")) {
            navigate("/twin");
        } else if (twin) {
            clearContext();
            handleModeChange(AppMode10.TWIN_SELECTION);
        } else if (isTLAdminOrPartner()) {
            handleModeChange(AppMode10.ORG_SELECTION);
        } else {
            handleModeChange(AppMode10.TWIN_SELECTION);
        }
    };
    var brandLabel = twin ? "Back to Twin Selection" : isTLAdminOrPartner() ? "Select organisation" : "Select twin";
    var statusText = getDataStatusText();
    var unreadText = unreadCount > 9 ? "9+" : "".concat(unreadCount);
    return /* @__PURE__ */ jsx146("div", {
        className: className,
        children: /* @__PURE__ */ jsx146(NavBar, {
            id: id,
            surface: "glass",
            "aria-label": "TwinLabs.ai",
            brand: {
                logoSrc: twinlabsAiLogo,
                logoAlt: "Twinlabs.ai",
                name: "TwinLabs.ai",
                label: brandLabel,
                onClick: handleBrand
            },
            right: /* @__PURE__ */ jsxs102(Fragment35, {
                children: [
                    availableModes.length > 0 && /* @__PURE__ */ jsxs102(Fragment35, {
                        children: [
                            statusText && /* @__PURE__ */ jsx146(NavBarStatus, {
                                children: statusText
                            }),
                            /* @__PURE__ */ jsx146(ModeDropdown_default, {
                                className: "mode-switcher",
                                currentMode: appMode,
                                availableModes: availableModes,
                                onChange: handleModeChange
                            }),
                            availableMetrics.length > 0 && /* @__PURE__ */ jsx146(HeroMetricDropdown_default, {
                                currentMetric: currentMetric,
                                availableMetrics: availableMetrics,
                                onChange: handleHeroMetricChange
                            })
                        ]
                    }),
                    setFullScreen && /* @__PURE__ */ jsx146(Button16, {
                        variant: "frosted",
                        size: "inline",
                        iconLeft: /* @__PURE__ */ jsx146(Icon14, {
                            name: "expand"
                        }),
                        onClick: function() {
                            return setFullScreen(!fullScreen);
                        },
                        "aria-label": "Toggle full screen",
                        "aria-pressed": !!fullScreen,
                        children: "Full Screen"
                    }),
                    /* @__PURE__ */ jsx146(Button16, {
                        variant: "frosted",
                        size: "inline",
                        iconLeft: /* @__PURE__ */ jsx146("img", {
                            src: mariaIconSrc,
                            alt: ""
                        }),
                        onClick: function() {
                            return setSupportCopilotVisible(!supportCopilotVisible);
                        },
                        "aria-label": "Toggle Maria assistant",
                        "aria-pressed": supportCopilotVisible,
                        children: "Maria"
                    })
                ]
            }),
            notifications: location.pathname === "/twin" ? /* @__PURE__ */ jsx146(Button16, {
                variant: "frosted",
                size: "inline",
                iconOnly: true,
                iconLeft: /* @__PURE__ */ jsx146(Icon14, {
                    name: "bell"
                }),
                onClick: function() {
                    return setNotificationsVisible(!notificationsVisible);
                },
                "aria-expanded": notificationsVisible,
                "aria-label": unreadCount > 0 ? "Notifications, ".concat(unreadText, " unread") : "Notifications"
            }) : void 0,
            notificationsUnread: unreadCount > 0,
            avatar: {
                name: user === null || user === void 0 ? void 0 : user.name,
                email: user === null || user === void 0 ? void 0 : user.email,
                src: (user === null || user === void 0 ? void 0 : user.picture) || void 0,
                label: accountMenuLabel2(user === null || user === void 0 ? void 0 : user.name),
                menu: /* @__PURE__ */ jsx146(AccountMenu, {
                    name: user === null || user === void 0 ? void 0 : user.name,
                    email: user === null || user === void 0 ? void 0 : user.email,
                    picture: (user === null || user === void 0 ? void 0 : user.picture) || void 0,
                    middlewareApi: middlewareApi,
                    restartTutorial: restartTutorial
                })
            }
        })
    });
};
var MainNav_default = styled105(MainNav)(_templateObject234());
// src/components/Frame/Frame.tsx
import { useState as useState77 } from "react";
import styled107 from "styled-components";
import loadingGif3 from "@repo/assets/loading.gif";
// src/components/Frame/frameLayout.ts
import { AppMode as AppMode11 } from "@repo/frontend-types";
var frameLayoutFor = function(appMode) {
    switch(appMode){
        case AppMode11.ORG_SELECTION:
            return {
                leftColumn: "orgSelector",
                centreColumn: "none",
                rightColumn: "none",
                overlay: "none"
            };
        case AppMode11.TWIN_SELECTION:
            return {
                leftColumn: "twinSelector",
                centreColumn: "none",
                rightColumn: "none",
                overlay: "none"
            };
        case AppMode11.LIVE:
        case AppMode11.HISTORICAL:
            return {
                leftColumn: "assets",
                centreColumn: "filter",
                rightColumn: "calendar",
                overlay: "none"
            };
        case AppMode11.INSIGHTS:
            return {
                leftColumn: "assets",
                centreColumn: "filter",
                rightColumn: "insightsCalendar",
                overlay: "none"
            };
        case AppMode11.EQUIPMENT:
            return {
                leftColumn: "equipment",
                centreColumn: "filter",
                rightColumn: "insightsCalendar",
                overlay: "none"
            };
        case AppMode11.OPERATIONS:
            return {
                leftColumn: "none",
                centreColumn: "none",
                rightColumn: "none",
                overlay: "dashboard"
            };
        case AppMode11.EDIT:
            return {
                leftColumn: "none",
                centreColumn: "none",
                rightColumn: "editor",
                overlay: "none"
            };
        case AppMode11.DASHBOARD_UTILISATION:
            return {
                leftColumn: "none",
                centreColumn: "none",
                rightColumn: "none",
                overlay: "dashboard"
            };
        default:
            {
                var _exhaustive = appMode;
                return _exhaustive;
            }
    }
};
// src/components/Frame/Frame.tsx
import { useUserStore as useUserStore26, useSettingsStore as useSettingsStore10, useTwinContext as useTwinContext16, useModeContext as useModeContext15 } from "@repo/front-end-state";
// src/components/Calendar/InsightsCalendar.tsx
import { useMemo as useMemo31, useState as useState76 } from "react";
import styled106 from "styled-components";
import { useModeContext as useModeContext14, useFilterContext as useFilterContext20, useTwinContext as useTwinContext14, useEventContext as useEventContext6 } from "@repo/front-end-state";
import { deriveSingleEntityBid as deriveSingleEntityBid2, isDatelessCalendarMode, modeConfigFor as modeConfigFor4 } from "@repo/front-end-utils";
import { AppMode as AppMode12 } from "@repo/frontend-types";
import { Calendar24Regular as Calendar24Regular2 } from "@fluentui/react-icons";
// src/components/Calendar/InsightsCalendarView.tsx
import { DataMode as DataMode3, WEEKDAYS } from "@repo/frontend-types";
import React79, { useEffect as useEffect51, useMemo as useMemo30, useState as useState75 } from "react";
import { useTwinConfigStore as useTwinConfigStore4, useUserStore as useUserStore25, useTwinContext as useTwinContext13, useFilterContext as useFilterContext19 } from "@repo/front-end-state";
import { createHourObjects as createHourObjects2, prependZero as prependZero2, findEntityById as findEntityById3, deriveSingleEntityBid } from "@repo/front-end-utils";
import { mergeWeekdayHoursData, cellIdsToWeekdayWindows, weekdayWindowsToCellIds } from "@repo/front-end-utils";
import { getBaselineView, getPeakHoursView } from "@repo/front-end-services";
import { jsx as jsx147, jsxs as jsxs103 } from "react/jsx-runtime";
var noop = function() {};
var InsightsCalendarView = function(param) {
    var className = param.className, _param_middlewareApi = param.middlewareApi, middlewareApi = _param_middlewareApi === void 0 ? "" : _param_middlewareApi, aggregation = param.aggregation, _param_peakHoursNotice = param.peakHoursNotice, peakHoursNotice = _param_peakHoursNotice === void 0 ? null : _param_peakHoursNotice, _param_setPeakHoursNotice = param.setPeakHoursNotice, setPeakHoursNotice = _param_setPeakHoursNotice === void 0 ? noop : _param_setPeakHoursNotice, entityScope = param.entityScope, peakEntityBid = param.peakEntityBid;
    var _authMetadata_tokens, _authMetadata_tokens1;
    var preferences = useTwinConfigStore4().preferences;
    var _useFilterContext19 = useFilterContext19(), filter = _useFilterContext19.filter, heroMetric = _useFilterContext19.heroMetric, weekdayWindows = _useFilterContext19.weekdayWindows, commitWeekdaySelection = _useFilterContext19.commitWeekdaySelection, resetWeekdaySelection = _useFilterContext19.resetWeekdaySelection, peakHoursActive = _useFilterContext19.peakHoursActive, setPeakHoursActive = _useFilterContext19.setPeakHoursActive;
    var twin = useTwinContext13().twin;
    var authMetadata = useUserStore25().authMetadata;
    var _useState75 = _sliced_to_array(useState75({}), 2), weekdayHours = _useState75[0], setWeekdayHours = _useState75[1];
    var fallbackSingleBid = useMemo30(function() {
        return deriveSingleEntityBid(twin === null || twin === void 0 ? void 0 : twin.physicalModel.bID, filter);
    }, [
        twin,
        filter
    ]);
    var scope = entityScope !== null && entityScope !== void 0 ? entityScope : {
        kind: "single",
        bid: fallbackSingleBid
    };
    var digitalTwinEntity = scope.kind === "single" ? scope.bid : twin === null || twin === void 0 ? void 0 : twin.physicalModel.bID;
    var effectivePeakBid = peakEntityBid !== null && peakEntityBid !== void 0 ? peakEntityBid : digitalTwinEntity;
    var overlayEntity = scope.kind === "single" ? digitalTwinEntity : void 0;
    var scopeBidsKey = scope.kind === "set" ? scope.bids.join("\0") : null;
    var entityCapacity = useMemo30(function() {
        var capacity = 0;
        if (twin && digitalTwinEntity) {
            var entity = findEntityById3(DataMode3.TIME_SERIES, [
                twin.physicalModel
            ], digitalTwinEntity);
            capacity = entity ? entity["capacity"] : 0;
        }
        return capacity;
    }, [
        digitalTwinEntity,
        twin
    ]);
    var openingStartTime = preferences === null || preferences === void 0 ? void 0 : preferences.earliestOpeningTime;
    var openingFinishTime = preferences === null || preferences === void 0 ? void 0 : preferences.latestClosingTime;
    if (openingStartTime === "00:00:00" && openingFinishTime === "00:00:00") {
        openingStartTime = null;
        openingFinishTime = null;
    }
    var hoursData = createHourObjects2(openingStartTime, openingFinishTime);
    useEffect51(function() {
        if (!(authMetadata === null || authMetadata === void 0 ? void 0 : authMetadata.tsdbUrl)) {
            setWeekdayHours({});
            return;
        }
        var cancelled = false;
        var fetchBaselineData = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function() {
                var _authMetadata_tokens, valueMetric, indicatorMetric, metricsToFetch, isSet, setBids, scopeReady, data, _data_valueMetric, setKey, rowFor, valueEntityData, valueTsData, indicatorTsData, indicatorEntityData, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            valueMetric = heroMetric === null || heroMetric === void 0 ? void 0 : heroMetric.valueMetricName;
                            indicatorMetric = heroMetric === null || heroMetric === void 0 ? void 0 : heroMetric.indicatorMetricName;
                            if (!aggregation || !valueMetric) {
                                if (heroMetric) {
                                    console.warn("[InsightsCalendarView] selected hero metric is missing its INSIGHTS aggregation or value-metric name; rendering empty calendar", {
                                        aggregation: aggregation,
                                        valueMetricName: valueMetric,
                                        heroMetric: heroMetric
                                    });
                                }
                                setWeekdayHours({});
                                return [
                                    2
                                ];
                            }
                            metricsToFetch = [
                                valueMetric
                            ];
                            if (indicatorMetric && indicatorMetric !== valueMetric) {
                                metricsToFetch.push(indicatorMetric);
                            }
                            isSet = scope.kind === "set";
                            setBids = scope.kind === "set" ? scope.bids : [];
                            scopeReady = isSet ? setBids.length > 0 : Boolean(digitalTwinEntity);
                            if (!((_authMetadata_tokens = authMetadata.tokens) === null || _authMetadata_tokens === void 0 ? void 0 : _authMetadata_tokens.accessToken) || !authMetadata.organisation || !(twin === null || twin === void 0 ? void 0 : twin.physicalModel.bID) || !scopeReady) {
                                setWeekdayHours({});
                                return [
                                    2
                                ];
                            }
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                getBaselineView(middlewareApi, authMetadata.tokens.accessToken, twin.physicalModel.bID, authMetadata.organisation, // Single-scope sends `bid`; set-scope sends `entityBids` (mutually exclusive) as the last arg.
                                isSet ? void 0 : digitalTwinEntity, (aggregation || "AVG").toUpperCase(), metricsToFetch, false, isSet ? setBids : void 0)
                            ];
                        case 2:
                            data = _state.sent();
                            if (cancelled) return [
                                2
                            ];
                            setKey = isSet ? Object.keys((_data_valueMetric = data === null || data === void 0 ? void 0 : data[valueMetric]) !== null && _data_valueMetric !== void 0 ? _data_valueMetric : {})[0] : void 0;
                            rowFor = function(metric) {
                                var metricData = data === null || data === void 0 ? void 0 : data[metric];
                                if (!metricData) return void 0;
                                if (isSet) return setKey !== void 0 ? metricData[setKey] : void 0;
                                return metricData[digitalTwinEntity];
                            };
                            valueEntityData = rowFor(valueMetric);
                            if (valueEntityData) {
                                valueTsData = valueEntityData.data || valueEntityData;
                                indicatorTsData = null;
                                if (indicatorMetric) {
                                    indicatorEntityData = rowFor(indicatorMetric);
                                    if (indicatorEntityData) {
                                        indicatorTsData = indicatorEntityData.data || indicatorEntityData;
                                    }
                                }
                                setWeekdayHours(mergeWeekdayHoursData(valueTsData, indicatorTsData));
                            } else {
                                console.warn("InsightsCalendarView: No baseline data returned from API");
                                setWeekdayHours({});
                            }
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            if (cancelled) return [
                                2
                            ];
                            console.error("InsightsCalendarView: Error fetching baseline data:", error);
                            setWeekdayHours({});
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchBaselineData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchBaselineData();
        return function() {
            cancelled = true;
        };
    }, [
        authMetadata === null || authMetadata === void 0 ? void 0 : authMetadata.organisation,
        authMetadata === null || authMetadata === void 0 ? void 0 : (_authMetadata_tokens = authMetadata.tokens) === null || _authMetadata_tokens === void 0 ? void 0 : _authMetadata_tokens.accessToken,
        authMetadata === null || authMetadata === void 0 ? void 0 : authMetadata.tsdbUrl,
        digitalTwinEntity,
        scope.kind,
        scopeBidsKey,
        aggregation,
        heroMetric === null || heroMetric === void 0 ? void 0 : heroMetric.valueMetricName,
        heroMetric === null || heroMetric === void 0 ? void 0 : heroMetric.indicatorMetricName,
        twin === null || twin === void 0 ? void 0 : twin.physicalModel.bID,
        middlewareApi,
        heroMetric
    ]);
    var columns = WEEKDAYS.map(function(weekday) {
        return {
            testKey: weekday.slice(0, 3).toLowerCase(),
            weekdayLabel: weekday.slice(0, 3).toUpperCase()
        };
    });
    var rows = hoursData.map(function(hour) {
        return {
            label: hour.text,
            hourKey: hour.hour
        };
    });
    var cells = hoursData.map(function(hour) {
        return WEEKDAYS.map(function(weekday) {
            var cellId = "".concat(weekday, "T").concat(prependZero2(hour.hour), ":00");
            var hours = weekdayHours[weekday];
            var hourData = hours ? hours.find(function(h) {
                return h.hour === hour.hour;
            }) : void 0;
            var _hourData_value;
            var cellDisplayValue = (_hourData_value = hourData === null || hourData === void 0 ? void 0 : hourData.value) !== null && _hourData_value !== void 0 ? _hourData_value : 0;
            var indicatorValue = hourData === null || hourData === void 0 ? void 0 : hourData.indicatorValue;
            var colorCalculationValue = indicatorValue !== void 0 ? indicatorValue : cellDisplayValue;
            var _hourData_open;
            return {
                cellId: cellId,
                value: cellDisplayValue,
                colorValue: colorCalculationValue,
                open: (_hourData_open = hourData === null || hourData === void 0 ? void 0 : hourData.open) !== null && _hourData_open !== void 0 ? _hourData_open : false,
                isFuture: false
            };
        });
    });
    var finishTime = openingFinishTime || "24:00";
    var finishHour = parseInt(finishTime.split(":")[0]);
    var displayHour = finishHour === 24 ? 0 : finishHour;
    var lastRowFinishLabel = "".concat(displayHour % 12 === 0 ? 12 : displayHour % 12).concat(displayHour < 12 ? "am" : "pm");
    var selectedCellIds = useMemo30(function() {
        return weekdayWindowsToCellIds(weekdayWindows !== null && weekdayWindows !== void 0 ? weekdayWindows : []);
    }, [
        weekdayWindows
    ]);
    useEffect51(function() {
        var _authMetadata_tokens;
        if (!peakHoursActive) {
            return;
        }
        var accessToken = authMetadata === null || authMetadata === void 0 ? void 0 : (_authMetadata_tokens = authMetadata.tokens) === null || _authMetadata_tokens === void 0 ? void 0 : _authMetadata_tokens.accessToken;
        var orgBID = authMetadata === null || authMetadata === void 0 ? void 0 : authMetadata.orgBID;
        var twinBID = twin === null || twin === void 0 ? void 0 : twin.physicalModel.bID;
        if (!accessToken || !orgBID || !twinBID || !effectivePeakBid) {
            return;
        }
        var cancelled = false;
        var fetchPeakHours = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function() {
                var windows;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                getPeakHoursView(middlewareApi, accessToken, orgBID, twinBID, effectivePeakBid)
                            ];
                        case 1:
                            windows = _state.sent();
                            if (cancelled) {
                                return [
                                    2
                                ];
                            }
                            if (windows && windows.length > 0) {
                                commitWeekdaySelection(windows);
                            } else {
                                setPeakHoursActive(false);
                                resetWeekdaySelection();
                                setPeakHoursNotice("No peak hours for this selection.");
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchPeakHours() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchPeakHours();
        return function() {
            cancelled = true;
        };
    }, [
        peakHoursActive,
        effectivePeakBid,
        authMetadata === null || authMetadata === void 0 ? void 0 : (_authMetadata_tokens1 = authMetadata.tokens) === null || _authMetadata_tokens1 === void 0 ? void 0 : _authMetadata_tokens1.accessToken,
        authMetadata === null || authMetadata === void 0 ? void 0 : authMetadata.orgBID,
        twin === null || twin === void 0 ? void 0 : twin.physicalModel.bID,
        middlewareApi,
        commitWeekdaySelection,
        resetWeekdaySelection,
        setPeakHoursActive,
        setPeakHoursNotice
    ]);
    useEffect51(function() {
        setPeakHoursNotice(null);
    }, [
        effectivePeakBid,
        setPeakHoursNotice
    ]);
    return /* @__PURE__ */ jsxs103("div", {
        className: className,
        children: [
            peakHoursNotice && /* @__PURE__ */ jsx147("div", {
                className: "peak-hours-notice",
                children: peakHoursNotice
            }),
            /* @__PURE__ */ jsx147(InsightsCalendarTotals, {
                digitalTwinEntity: digitalTwinEntity,
                entityScope: scope
            }),
            /* @__PURE__ */ jsx147(WeekGrid_default, {
                columns: columns,
                rows: rows,
                cells: cells,
                selectedCellIds: selectedCellIds,
                indicatorConfig: heroMetric === null || heroMetric === void 0 ? void 0 : heroMetric.indicatorConfig,
                metricName: heroMetric === null || heroMetric === void 0 ? void 0 : heroMetric.name,
                lastRowFinishLabel: lastRowFinishLabel,
                cellKeyPrefix: "insights",
                multiBlockOutline: peakHoursActive,
                onSelectionCommit: function(cellIds) {
                    var windows = cellIdsToWeekdayWindows(cellIds);
                    if (peakHoursActive && windows.length > 0) {
                        setPeakHoursActive(false);
                        setPeakHoursNotice(null);
                    }
                    commitWeekdaySelection(windows);
                },
                onRequestReset: resetWeekdaySelection,
                selectionOverlay: /* @__PURE__ */ jsx147(CalendarSelectionOverlay_default, {
                    digitalTwinEntity: overlayEntity,
                    entityCapacity: entityCapacity !== null && entityCapacity !== void 0 ? entityCapacity : 0
                })
            })
        ]
    });
};
var InsightsCalendarView_default = React79.memo(InsightsCalendarView);
// src/components/Calendar/InsightsCalendar.tsx
import { Scrollbar as Scrollbar10 } from "@repo/design-system";
import { Fragment as Fragment36, jsx as jsx148, jsxs as jsxs104 } from "react/jsx-runtime";
var InsightsCalendar = function(param) {
    var className = param.className, middlewareApi = param.middlewareApi;
    var _modeConfigFor4;
    var appMode = useModeContext14().appMode;
    var _useFilterContext20 = useFilterContext20(), heroMetric = _useFilterContext20.heroMetric, peakHoursActive = _useFilterContext20.peakHoursActive, setPeakHoursActive = _useFilterContext20.setPeakHoursActive, resetWeekdaySelection = _useFilterContext20.resetWeekdaySelection, filter = _useFilterContext20.filter;
    var twin = useTwinContext14().twin;
    var selectedEquipmentBids = useEventContext6().selectedEquipmentBids;
    var aggregation = (_modeConfigFor4 = modeConfigFor4(heroMetric, appMode)) === null || _modeConfigFor4 === void 0 ? void 0 : _modeConfigFor4.aggregation;
    var isEquipment = appMode === AppMode12.EQUIPMENT;
    var singleBid = useMemo31(function() {
        return deriveSingleEntityBid2(twin === null || twin === void 0 ? void 0 : twin.physicalModel.bID, filter);
    }, [
        twin,
        filter
    ]);
    var entityScope = useMemo31(function() {
        return isEquipment ? {
            kind: "set",
            bids: selectedEquipmentBids !== null && selectedEquipmentBids !== void 0 ? selectedEquipmentBids : []
        } : {
            kind: "single",
            bid: singleBid
        };
    }, [
        isEquipment,
        selectedEquipmentBids,
        singleBid
    ]);
    var peakEntityBid = isEquipment ? twin === null || twin === void 0 ? void 0 : twin.physicalModel.bID : singleBid;
    var peakHoursLabel = isEquipment ? "Gym Peak Hours" : "Peak Hours";
    var _useState76 = _sliced_to_array(useState76(null), 2), peakHoursNotice = _useState76[0], setPeakHoursNotice = _useState76[1];
    var handlePeakHoursToggle = function(event) {
        var active = event.target.checked;
        setPeakHoursActive(active);
        setPeakHoursNotice(null);
        if (!active) {
            resetWeekdaySelection();
        }
    };
    return /* @__PURE__ */ jsx148(Fragment36, {
        children: isDatelessCalendarMode(appMode) && /* @__PURE__ */ jsx148("div", {
            className: className,
            children: /* @__PURE__ */ jsx148(Scrollbar10, {
                right: -20,
                maxHeight: "calc(100vh - 210px)",
                className: "right-scrollable-container",
                children: /* @__PURE__ */ jsx148(Panel_default, {
                    id: "insights-calendar",
                    icon: /* @__PURE__ */ jsx148(Calendar24Regular2, {}),
                    title: "Baseline week",
                    defaultOpenItems: [
                        "insights-calendar"
                    ],
                    headerActions: // Peak Hours renders in both dateless modes (INSIGHTS and EQUIPMENT). The
                    // supporting machinery (filter reset on mode entry, PEAK pill add/remove, the
                    // fetch and middleware endpoint) is already mode-agnostic behind
                    // `isDatelessCalendarMode`, so the toggle just needs to render in both.
                    isDatelessCalendarMode(appMode) ? /* @__PURE__ */ jsxs104("div", {
                        className: "peak-hours-control",
                        children: [
                            /* @__PURE__ */ jsx148(TLAdminSwitch_default, {
                                id: "peak-hours-toggle",
                                surface: "on-glass",
                                checked: peakHoursActive,
                                onChange: handlePeakHoursToggle
                            }),
                            /* @__PURE__ */ jsx148("label", {
                                htmlFor: "peak-hours-toggle",
                                className: "peak-hours-label",
                                children: peakHoursLabel
                            })
                        ]
                    }) : void 0,
                    children: /* @__PURE__ */ jsx148(InsightsCalendarView_default, {
                        middlewareApi: middlewareApi,
                        aggregation: aggregation,
                        peakHoursNotice: peakHoursNotice,
                        setPeakHoursNotice: setPeakHoursNotice,
                        entityScope: entityScope,
                        peakEntityBid: peakEntityBid
                    })
                })
            })
        })
    });
};
var InsightsCalendar_default = styled106(InsightsCalendar)(_templateObject235());
// src/components/Frame/ConnectedTLFilter.tsx
import { useFilterContext as useFilterContext21, useTwinContext as useTwinContext15 } from "@repo/front-end-state";
import { jsx as jsx149 } from "react/jsx-runtime";
var ConnectedTLFilter = function() {
    var _useFilterContext21 = useFilterContext21(), filter = _useFilterContext21.filter, removeFilter = _useFilterContext21.removeFilter, clearFilter = _useFilterContext21.clearFilter;
    var twin = useTwinContext15().twin;
    return /* @__PURE__ */ jsx149(TLFilter_default, {
        filter: filter,
        removeFilter: removeFilter,
        clearFilter: clearFilter,
        rootEntityId: twin === null || twin === void 0 ? void 0 : twin.physicalModel.id
    });
};
var ConnectedTLFilter_default = ConnectedTLFilter;
// src/components/Frame/Frame.tsx
import { Fragment as Fragment37, jsx as jsx150, jsxs as jsxs105 } from "react/jsx-runtime";
var Frame = function(param) {
    var className = param.className, allModelsLoaded = param.allModelsLoaded, setShowTutorial = param.setShowTutorial, restartTutorial = param.restartTutorial, _param_middlewareApi = param.middlewareApi, middlewareApi = _param_middlewareApi === void 0 ? "" : _param_middlewareApi, twinAppBaseUrl = param.twinAppBaseUrl, editorElement = param.editorElement, developerConsoleElement = param.developerConsoleElement, organisationSelectorElement = param.organisationSelectorElement, createTwinElement = param.createTwinElement, onCreateTwin = param.onCreateTwin, onEditTwin = param.onEditTwin, onModeChoice = param.onModeChoice, dashboardDataProvider = param.dashboardDataProvider, dashboardPanelComponents = param.dashboardPanelComponents, dashboardHostActions = param.dashboardHostActions, dashboardHostValues = param.dashboardHostValues, _param_panelsHidden = param.panelsHidden, panelsHidden = _param_panelsHidden === void 0 ? false : _param_panelsHidden;
    var _settings_calendar;
    var _useState77 = _sliced_to_array(useState77(false), 2), fullScreen = _useState77[0], setFullScreen = _useState77[1];
    var _useState771 = _sliced_to_array(useState77(false), 2), supportCopilotVisible = _useState771[0], setSupportCopilotVisible = _useState771[1];
    var _useState772 = _sliced_to_array(useState77(false), 2), notificationsVisible = _useState772[0], setNotificationsVisible = _useState772[1];
    var settings = useSettingsStore10().settings;
    var appMode = useModeContext15().appMode;
    var authMetadata = useUserStore26().authMetadata;
    var twin = useTwinContext16().twin;
    var layout = frameLayoutFor(appMode);
    var _useState773 = _sliced_to_array(useState77("panel"), 2), dashboardSurface = _useState773[0], setDashboardSurface = _useState773[1];
    var panels = usePresence(!panelsHidden, {
        animate: panelsHidden
    });
    var windows = usePresence(!panelsHidden, {
        animate: panelsHidden
    });
    return /* @__PURE__ */ jsxs105("div", {
        className: className,
        children: [
            /* @__PURE__ */ jsx150(MainNav_default, {
                id: "main-nav",
                fullScreen: fullScreen,
                supportCopilotVisible: supportCopilotVisible,
                notificationsVisible: notificationsVisible,
                setFullScreen: setFullScreen,
                setSupportCopilotVisible: setSupportCopilotVisible,
                setNotificationsVisible: setNotificationsVisible,
                setShowTutorial: setShowTutorial,
                restartTutorial: restartTutorial,
                middlewareApi: middlewareApi,
                onEditTwin: onEditTwin,
                onModeChoice: onModeChoice
            }),
            !fullScreen && /* @__PURE__ */ jsxs105("div", {
                ref: panels.ref,
                className: "frame-panels",
                inert: panelsHidden || void 0,
                "aria-hidden": panelsHidden || void 0,
                style: panels.mounted ? void 0 : {
                    visibility: "hidden"
                },
                children: [
                    /* @__PURE__ */ jsxs105("div", {
                        className: "frame",
                        children: [
                            /* @__PURE__ */ jsxs105("div", {
                                className: "left-column",
                                children: [
                                    layout.leftColumn === "assets" && /* @__PURE__ */ jsx150(AssetsAndAnalytics_default, {
                                        className: "panel"
                                    }),
                                    layout.leftColumn === "equipment" && /* @__PURE__ */ jsx150(EquipmentPanel_default, {
                                        className: "panel"
                                    }),
                                    layout.leftColumn === "orgSelector" && organisationSelectorElement,
                                    layout.leftColumn === "twinSelector" && /* @__PURE__ */ jsx150(TwinSelector_default, {
                                        className: "panel",
                                        middlewareApi: middlewareApi,
                                        createTwinElement: createTwinElement,
                                        onCreateTwin: onCreateTwin
                                    })
                                ]
                            }),
                            allModelsLoaded ? /* @__PURE__ */ jsxs105(Fragment37, {
                                children: [
                                    /* @__PURE__ */ jsx150("div", {
                                        className: "centre-column",
                                        children: layout.centreColumn === "filter" && /* @__PURE__ */ jsx150(ConnectedTLFilter_default, {})
                                    }),
                                    /* @__PURE__ */ jsxs105("div", {
                                        className: "right-column",
                                        children: [
                                            layout.rightColumn === "calendar" && ((settings === null || settings === void 0 ? void 0 : (_settings_calendar = settings.calendar) === null || _settings_calendar === void 0 ? void 0 : _settings_calendar.visible) ? /* @__PURE__ */ jsx150(Calendar_default, {
                                                className: "calendar panel",
                                                middlewareApi: middlewareApi
                                            }) : null),
                                            layout.rightColumn === "insightsCalendar" && /* @__PURE__ */ jsx150(InsightsCalendar_default, {
                                                className: "calendar panel",
                                                middlewareApi: middlewareApi
                                            }),
                                            layout.rightColumn === "editor" && editorElement
                                        ]
                                    })
                                ]
                            }) : /* @__PURE__ */ jsx150("div", {
                                className: "loading",
                                children: /* @__PURE__ */ jsxs105("div", {
                                    children: [
                                        /* @__PURE__ */ jsx150(TLSpinner_default, {
                                            custom: /* @__PURE__ */ jsx150("img", {
                                                src: typeof loadingGif3 === "string" ? loadingGif3 : loadingGif3.src,
                                                width: 200,
                                                height: 200,
                                                alt: "Loading..."
                                            })
                                        }),
                                        /* @__PURE__ */ jsx150("p", {
                                            style: {
                                                textAlign: "center",
                                                fontSize: "1.25rem"
                                            },
                                            children: "Working, please wait..."
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /* @__PURE__ */ jsx150("div", {
                        className: dashboardSurface === "sceneOverlay" ? "dashboard-overlay scene-overlay" : "dashboard-overlay",
                        children: layout.overlay === "dashboard" && /* @__PURE__ */ jsx150(BIDashboard_default, {
                            twinBID: twin === null || twin === void 0 ? void 0 : twin.adminTwin.bid,
                            twinName: twin === null || twin === void 0 ? void 0 : twin.adminTwin.name,
                            middlewareApi: middlewareApi,
                            dashboardDataProvider: dashboardDataProvider,
                            dashboardPanelComponents: dashboardPanelComponents,
                            dashboardHostActions: dashboardHostActions,
                            dashboardHostValues: dashboardHostValues,
                            onSurfaceChange: setDashboardSurface
                        })
                    })
                ]
            }),
            /* @__PURE__ */ jsxs105("div", {
                ref: windows.ref,
                className: "frame-windows",
                inert: panelsHidden || void 0,
                "aria-hidden": panelsHidden || void 0,
                style: windows.mounted ? void 0 : {
                    visibility: "hidden"
                },
                children: [
                    supportCopilotVisible && /* @__PURE__ */ jsx150(Maria_default, {
                        setSupportCopilotVisible: setSupportCopilotVisible
                    }),
                    notificationsVisible && /* @__PURE__ */ jsx150(NotificationsWindow_default, {
                        middlewareApi: middlewareApi,
                        twinAppBaseUrl: twinAppBaseUrl,
                        setNotificationsVisible: setNotificationsVisible
                    }),
                    (authMetadata === null || authMetadata === void 0 ? void 0 : authMetadata.developerMode) && developerConsoleElement
                ]
            })
        ]
    });
};
var Frame_default = styled107(Frame)(_templateObject236());
// src/components/3D/SceneLighting.tsx
import { useRef as useRef30 } from "react";
import { useFrame } from "@react-three/fiber";
import { Object3D, Vector3 } from "three";
import { Fragment as Fragment38, jsx as jsx151, jsxs as jsxs106 } from "react/jsx-runtime";
var DIRECTION_LIGHT_POSITION = new Vector3(7, 7, 10);
var DIRECTION_LIGHT_TARGET = new Object3D();
var AMBIENT_INTENSITY = 3;
var DIRECTIONAL_INTENSITY = 1;
var DIRECTION_COLOR = 16777215;
var PLAN_SKY_COLOR = 16777215;
var PLAN_GROUND_COLOR = 8947848;
var PLAN_HEMISPHERE_INTENSITY = 1.2;
var PLAN_DIRECTIONAL_POSITION = new Vector3(2, 10, 3);
var PLAN_DIRECTIONAL_INTENSITY = 1.85;
var readMix = function(getMix) {
    var _getMix;
    var mix = (_getMix = getMix === null || getMix === void 0 ? void 0 : getMix()) !== null && _getMix !== void 0 ? _getMix : 0;
    return Number.isFinite(mix) ? Math.min(1, Math.max(0, mix)) : 0;
};
var LightsAndShadows = function(param) {
    var getMix = param.getMix;
    var directional = useRef30(null);
    var ambient = useRef30(null);
    var planHemisphere = useRef30(null);
    var planDirectional = useRef30(null);
    useFrame(function() {
        var mix = readMix(getMix);
        if (directional.current) directional.current.intensity = DIRECTIONAL_INTENSITY * (1 - mix);
        if (ambient.current) ambient.current.intensity = AMBIENT_INTENSITY * (1 - mix);
        if (planHemisphere.current) planHemisphere.current.intensity = PLAN_HEMISPHERE_INTENSITY * mix;
        if (planDirectional.current) planDirectional.current.intensity = PLAN_DIRECTIONAL_INTENSITY * mix;
    });
    return /* @__PURE__ */ jsxs106(Fragment38, {
        children: [
            /* @__PURE__ */ jsx151("directionalLight", {
                ref: directional,
                castShadow: true,
                "shadow-bias": -3e-3,
                position: DIRECTION_LIGHT_POSITION,
                color: DIRECTION_COLOR,
                intensity: DIRECTIONAL_INTENSITY,
                "shadow-mapSize": 1024,
                target: DIRECTION_LIGHT_TARGET,
                children: /* @__PURE__ */ jsx151("orthographicCamera", {
                    attach: "shadow-camera",
                    args: [
                        0,
                        45,
                        -10,
                        20,
                        0.1,
                        50
                    ]
                })
            }),
            /* @__PURE__ */ jsx151("ambientLight", {
                ref: ambient,
                intensity: AMBIENT_INTENSITY
            }),
            getMix && /* @__PURE__ */ jsxs106(Fragment38, {
                children: [
                    /* @__PURE__ */ jsx151("hemisphereLight", {
                        ref: planHemisphere,
                        args: [
                            PLAN_SKY_COLOR,
                            PLAN_GROUND_COLOR
                        ],
                        intensity: 0
                    }),
                    /* @__PURE__ */ jsx151("directionalLight", {
                        ref: planDirectional,
                        position: PLAN_DIRECTIONAL_POSITION,
                        color: DIRECTION_COLOR,
                        intensity: 0
                    })
                ]
            })
        ]
    });
};
// src/components/3D/utils/machineMaterial.ts
import { DoubleSide, MeshStandardMaterial } from "three";
var EQUIPTMENT_METALNESS = 0.3;
var EQUIPTMENT_ROUGHNESS = 1;
var MACHINE_MATERIAL = new MeshStandardMaterial({
    metalness: EQUIPTMENT_METALNESS,
    roughness: EQUIPTMENT_ROUGHNESS,
    color: ASSET_COLOR,
    side: DoubleSide
});
// src/components/3D/utils/machineLook.ts
var FULL_HEIGHT_MIX = 0.7;
var clamp = function(value, min, max) {
    return Math.min(max, Math.max(min, value));
};
var machineLook = function(k, flat) {
    var height2 = flat < 1 ? clamp(Number.isFinite(k) ? k : 1, flat, 1) : 1;
    var t = flat < 1 ? clamp((height2 - flat) / (1 - flat), 0, 1) : 1;
    var mix = FULL_HEIGHT_MIX + (1 - FULL_HEIGHT_MIX) * (1 - t);
    return {
        k: height2,
        occlusion: t,
        normalScale: height2,
        mix: mix,
        metalness: EQUIPTMENT_METALNESS * (1 - mix)
    };
};
// src/components/3D/utils/patchMachineLook.ts
var MACHINE_LOOK_PROGRAM_KEY = "machine-look";
var NORMAL_VERTEX = "#include <normal_vertex>";
var NORMAL_FIX = "{\n  mat3 machineLookView = mat3( viewMatrix );\n  vec3 machineLookWorld = transpose( machineLookView ) * transformedNormal;\n  machineLookWorld.y *= uMachineNormalScale;\n  transformedNormal = inverse( transpose( machineLookView ) ) * machineLookWorld;\n}\n";
var patchMachineLook = function(material3, uniform) {
    material3.onBeforeCompile = function(shader) {
        shader.uniforms.uMachineNormalScale = uniform;
        shader.vertexShader = "uniform float uMachineNormalScale;\n".concat(shader.vertexShader.replace(NORMAL_VERTEX, "".concat(NORMAL_FIX).concat(NORMAL_VERTEX)));
    };
    material3.customProgramCacheKey = function() {
        return MACHINE_LOOK_PROGRAM_KEY;
    };
    return material3;
};
// src/components/3D/materials/NotTrackedMaterial.tsx
import { RawShaderMaterial, Vector3 as Vector32 } from "three";
var vertexShader = "\n\nuniform mat4 modelMatrix;\nuniform mat4 viewMatrix;\nuniform mat4 projectionMatrix;\nuniform mat3 normalMatrix;\n\nattribute vec3 position;\nattribute vec2 uv;\nattribute vec3 normal;\n\nvarying vec4 worldPosition;\nvarying vec3 worldNormal; \n\nvoid main() {\n\n\n    worldPosition = modelMatrix * vec4(position, 1.0);\n    vec4 viewPosition = viewMatrix * worldPosition;\n    vec4 projectedPosition = projectionMatrix * viewPosition;\n\n    worldNormal = mat3(modelMatrix) * normal;\n\n    gl_Position = projectedPosition;\n\n}";
var fragmentShader = "\n\nprecision highp float;\n\nvarying vec4 worldPosition;\nvarying vec3 worldNormal; \n\nuniform vec3 color;\nuniform vec3 directionalLightDirection;\n\nfloat AMBIENT_LIGHT = 0.5;\nvec3 DIFFUSE_WHITE = vec3(0.6, 0.6, 0.6);\nvec3 DIFFUSE_GREY = vec3(0.2, 0.2, 0.2);\n\nvoid main() {\n\n    vec3 MAT_COLOR = DIFFUSE_WHITE;\n\n    float shift = cos((worldPosition.x + worldPosition.z + worldPosition.y) * 20.0);\n\n    if (shift > 0.8) {\n        MAT_COLOR = DIFFUSE_GREY;\n    }\n\n    float light = -dot(normalize(directionalLightDirection), normalize(worldNormal)) * 0.5  + AMBIENT_LIGHT;\n    gl_FragColor = vec4(MAT_COLOR * light, 0.5);\n}";
var NotTrackedMaterial = /*#__PURE__*/ function(RawShaderMaterial) {
    "use strict";
    _inherits(NotTrackedMaterial, RawShaderMaterial);
    function NotTrackedMaterial(directionalLightPosition, directionalLightTarget) {
        _class_call_check(this, NotTrackedMaterial);
        var _this;
        var uniforms = {
            directionalLightDirection: {
                value: new Vector32().subVectors(directionalLightTarget.position, directionalLightPosition)
            }
        };
        _this = _call_super(this, NotTrackedMaterial, [
            {
                uniforms: uniforms,
                vertexShader: vertexShader,
                fragmentShader: fragmentShader
            }
        ]);
        _this.transparent = true;
        return _this;
    }
    return NotTrackedMaterial;
}(RawShaderMaterial);
// src/components/3D/materials/WindMaterial.tsx
import { Color as Color2, RawShaderMaterial as RawShaderMaterial2 } from "three";
var vertexShader2 = "\n\nuniform mat4 modelMatrix;\nuniform mat4 viewMatrix;\nuniform mat4 projectionMatrix;\nuniform float time; \n\nattribute vec3 position;\nattribute vec2 uv;\nattribute vec3 normal;\n\nvarying vec2 texcoord;\n\nfloat FREQUENCY_FACTOR = 100.0;\nfloat PHASE_FREQUENCY_FACTOR = 10.0;\nfloat SHIFT_SCALE_FACTOR = 100.0;\n\nvoid main() {\n\n  vec3 shift = sin(-position.z * FREQUENCY_FACTOR + time * PHASE_FREQUENCY_FACTOR) * normal / SHIFT_SCALE_FACTOR;\n  vec4 modelPosition = modelMatrix * vec4(position + shift, 1.0);\n  vec4 viewPosition = viewMatrix * modelPosition;\n  vec4 projectedPosition = projectionMatrix * viewPosition;\n\n  gl_Position = projectedPosition;\n  texcoord = uv;\n\n}";
var fragmentShader2 = "\n\nprecision highp float;\n\nvarying vec2 texcoord;\n\nuniform vec3 color;\nuniform sampler2D texture;\n\nvoid main() {\n\n    gl_FragColor = vec4(color, texture2D(texture, texcoord).w);\n\n}";
var WindMaterial = /*#__PURE__*/ function(RawShaderMaterial2) {
    "use strict";
    _inherits(WindMaterial, RawShaderMaterial2);
    function WindMaterial(direction, color, texture) {
        _class_call_check(this, WindMaterial);
        var _this;
        var colorUniform = new Color2(color);
        var uniforms = {
            direction: {
                value: direction
            },
            color: {
                value: colorUniform
            },
            texture: {
                value: texture
            },
            time: {
                value: 0
            }
        };
        _this = _call_super(this, WindMaterial, [
            {
                uniforms: uniforms,
                vertexShader: vertexShader2,
                fragmentShader: fragmentShader2
            }
        ]);
        _this.color = new Color2(color);
        return _this;
    }
    _create_class(WindMaterial, [
        {
            key: "updateColor",
            value: function updateColor(color) {
                this.uniforms.color.value.set(color);
            }
        },
        {
            key: "addTime",
            value: function addTime(dt) {
                this.uniforms.time.value += dt;
            }
        }
    ]);
    return WindMaterial;
}(RawShaderMaterial2);
// src/components/3D/heatmap/HeatmapFloorView.tsx
import { useEffect as useEffect52, useMemo as useMemo32, useState as useState78 } from "react";
import { useThree } from "@react-three/fiber";
import { DataTexture as DataTexture3, FloatType, NearestFilter, RGBAFormat as RGBAFormat2 } from "three";
// src/components/3D/heatmap/buildSamplePlaneGeometry.ts
import { BufferAttribute, BufferGeometry } from "three";
// src/components/3D/heatmap/heatmapSampling.ts
var HEATMAP_BLOB_RADIUS_M = 1.75;
var HEATMAP_CORNER_RADIUS_FRAC = 0.5;
var HEATMAP_SAMPLE_TEXTURE_ROWS = 2;
var heatmapSampleBufferLength = function(maxSamples) {
    return maxSamples * 4 * HEATMAP_SAMPLE_TEXTURE_ROWS;
};
var HEATMAP_DENSITY_EPSILON = 1e-3;
var packHeatmapSamples = function(samples, target, maxSamples) {
    var count = Math.min(samples.length, maxSamples);
    var row1 = maxSamples * 4;
    for(var i = 0; i < count; i++){
        var s = samples[i];
        target[i * 4] = s.x;
        target[i * 4 + 1] = s.z;
        target[i * 4 + 2] = s.hx;
        target[i * 4 + 3] = s.hz;
        target[row1 + i * 4] = s.value;
        target[row1 + i * 4 + 1] = s.selected ? 1 : 0;
    }
    return count;
};
// src/components/3D/heatmap/buildSamplePlaneGeometry.ts
var HEATMAP_PLANE_MARGIN_M = 3 * HEATMAP_BLOB_RADIUS_M;
var buildSamplePlaneGeometry = function(footprints) {
    var marginM = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : HEATMAP_PLANE_MARGIN_M;
    var minX = Infinity;
    var maxX = -Infinity;
    var minZ = Infinity;
    var maxZ = -Infinity;
    footprints.forEach(function(f) {
        if (!Number.isFinite(f.x) || !Number.isFinite(f.z)) return;
        var hx = Number.isFinite(f.hx) ? Math.abs(f.hx) : 0;
        var hz = Number.isFinite(f.hz) ? Math.abs(f.hz) : 0;
        if (f.x - hx < minX) minX = f.x - hx;
        if (f.x + hx > maxX) maxX = f.x + hx;
        if (f.z - hz < minZ) minZ = f.z - hz;
        if (f.z + hz > maxZ) maxZ = f.z + hz;
    });
    var geometry = new BufferGeometry();
    if (minX > maxX || minZ > maxZ) {
        geometry.setAttribute("position", new BufferAttribute(new Float32Array(9), 3));
        geometry.computeBoundingBox();
        return geometry;
    }
    minX -= marginM;
    maxX += marginM;
    minZ -= marginM;
    maxZ += marginM;
    var position = new Float32Array([
        minX,
        0,
        minZ,
        maxX,
        0,
        minZ,
        maxX,
        0,
        maxZ,
        minX,
        0,
        minZ,
        maxX,
        0,
        maxZ,
        minX,
        0,
        maxZ
    ]);
    geometry.setAttribute("position", new BufferAttribute(position, 3));
    geometry.computeBoundingBox();
    return geometry;
};
// src/components/3D/heatmap/buildIndicatorRamp.ts
import { DataTexture, LinearFilter, RGBAFormat, SRGBColorSpace, UnsignedByteType } from "three";
import { rasteriseIndicatorRamp } from "@repo/front-end-utils";
var buildIndicatorRamp = function(config, selected, metricName) {
    var _rasteriseIndicatorRamp = rasteriseIndicatorRamp(config, selected, metricName), domain = _rasteriseIndicatorRamp.domain, data = _rasteriseIndicatorRamp.data;
    var texture = new DataTexture(data, 256, 1, RGBAFormat, UnsignedByteType);
    texture.colorSpace = SRGBColorSpace;
    texture.minFilter = LinearFilter;
    texture.magFilter = LinearFilter;
    texture.needsUpdate = true;
    return {
        texture: texture,
        domain: domain
    };
};
// src/components/3D/heatmap/collectHeatmapSamples.ts
import { Matrix4 as Matrix42, Vector3 as Vector33 } from "three";
// src/components/3D/heatmap/computeLocalBox3.ts
import { Box3, Matrix4 } from "three";
var computeLocalBox3 = function(object6, ancestorInverse) {
    var result = new Box3().makeEmpty();
    var childBox = new Box3();
    var m = new Matrix4();
    object6.traverse(function(node) {
        var mesh = node;
        var geometry = mesh.geometry;
        if (!mesh.isMesh || !geometry) return;
        if (!geometry.boundingBox) geometry.computeBoundingBox();
        var geoBox = geometry.boundingBox;
        if (!geoBox) return;
        m.multiplyMatrices(ancestorInverse, mesh.matrixWorld);
        childBox.copy(geoBox).applyMatrix4(m);
        result.union(childBox);
    });
    return result;
};
// src/components/3D/heatmap/collectHeatmapSamples.ts
var IDENTITY = new Matrix42();
var collectEntityFootprints = function(root) {
    var ancestorInverse = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : IDENTITY;
    var footprints = /* @__PURE__ */ new Map();
    var size2 = new Vector33();
    var centre = new Vector33();
    root.traverse(function(object6) {
        var _object6_userData;
        var bID = (_object6_userData = object6.userData) === null || _object6_userData === void 0 ? void 0 : _object6_userData.bID;
        if (typeof bID !== "string") return;
        if (footprints.has(bID)) return;
        var box = computeLocalBox3(object6, ancestorInverse);
        if (box.isEmpty()) return;
        box.getSize(size2);
        box.getCenter(centre);
        footprints.set(bID, {
            x: centre.x,
            z: centre.z,
            hx: size2.x / 2,
            hz: size2.z / 2
        });
    });
    return footprints;
};
var footprintsToSamples = function(footprints, values, colorModes) {
    var samples = [];
    values.forEach(function(value, bID) {
        var fp = footprints.get(bID);
        if (!fp) return;
        if (colorModes) {
            var mode = colorModes.get(bID);
            if (mode === void 0) return;
            samples.push({
                x: fp.x,
                z: fp.z,
                hx: fp.hx,
                hz: fp.hz,
                value: value,
                selected: mode === "colors"
            });
        } else {
            samples.push({
                x: fp.x,
                z: fp.z,
                hx: fp.hx,
                hz: fp.hz,
                value: value,
                selected: true
            });
        }
    });
    return samples;
};
// src/components/3D/heatmap/heatmapTuning.ts
import { useSyncExternalStore } from "react";
var HEATMAP_OPACITY = 0.82;
var HEATMAP_TUNING_DEFAULTS = {
    opacity: HEATMAP_OPACITY,
    blobRadiusM: HEATMAP_BLOB_RADIUS_M
};
var HEATMAP_TUNING_STORAGE_KEY = "tl-heatmap-tuning-overrides";
var KNOWN_KEYS = [
    "opacity",
    "blobRadiusM"
];
var overrides = null;
var listeners = /* @__PURE__ */ new Set();
var emit = function() {
    return listeners.forEach(function(l) {
        return l();
    });
};
var persist = function() {
    if (typeof localStorage === "undefined") return;
    try {
        if (overrides) localStorage.setItem(HEATMAP_TUNING_STORAGE_KEY, JSON.stringify(overrides));
        else localStorage.removeItem(HEATMAP_TUNING_STORAGE_KEY);
    } catch (e) {}
};
var heatmapTuningStore = {
    getSnapshot: function() {
        return overrides;
    },
    subscribe: function(listener) {
        listeners.add(listener);
        return function() {
            return listeners.delete(listener);
        };
    },
    /** Set one parameter override (finite only), merge + persist. */ setParam: function(key, value) {
        if (!Number.isFinite(value)) return;
        overrides = _object_spread_props(_object_spread({}, overrides !== null && overrides !== void 0 ? overrides : {}), _define_property({}, key, value));
        persist();
        emit();
    },
    /** Clear all overrides (→ committed defaults) + wipe persistence. */ resetAll: function() {
        overrides = null;
        persist();
        emit();
    },
    /** Load persisted overrides (dev-only; called by the panel on mount). Allowlists known finite keys. */ hydrateFromStorage: function() {
        if (typeof localStorage === "undefined") return;
        try {
            var raw = localStorage.getItem(HEATMAP_TUNING_STORAGE_KEY);
            if (!raw) return;
            var parsed = JSON.parse(raw);
            var next = {};
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = KNOWN_KEYS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var key = _step.value;
                    var v = parsed[key];
                    if (typeof v === "number" && Number.isFinite(v)) next[key] = v;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            overrides = Object.keys(next).length ? next : null;
            emit();
        } catch (e) {}
    }
};
var useHeatmapTuning = function() {
    return useSyncExternalStore(heatmapTuningStore.subscribe, heatmapTuningStore.getSnapshot, function() {
        return null;
    });
};
var resolveHeatmapTuning = function(o) {
    return o ? _object_spread({}, HEATMAP_TUNING_DEFAULTS, o) : _object_spread({}, HEATMAP_TUNING_DEFAULTS);
};
var fmt = function(n) {
    return String(Number(n.toFixed(6)));
};
var formatHeatmapTuningValues = function(e) {
    return [
        "// packages/ui/src/components/3D/heatmap/heatmapTuning.ts",
        "HEATMAP_OPACITY = ".concat(fmt(e.opacity)),
        "// packages/ui/src/components/3D/heatmap/heatmapSampling.ts",
        "HEATMAP_BLOB_RADIUS_M = ".concat(fmt(e.blobRadiusM))
    ].join("\n");
};
// src/components/3D/materials/HeatmapMaterial.ts
import { DoubleSide as DoubleSide2, ShaderMaterial } from "three";
var glslFloat = function(n) {
    return Number.isInteger(n) ? n.toFixed(1) : String(n);
};
var MAX_HEATMAP_SAMPLES = 512;
var vertexShader3 = "\nvarying vec2 vObjectXZ;\n\nvoid main() {\n  vObjectXZ = position.xz;\n  gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\n}\n";
var fragmentShader3 = /* glsl */ "\nprecision highp float;\n\nvarying vec2 vObjectXZ;\n\nuniform sampler2D samples;\nuniform int sampleCount;\nuniform sampler2D ramp;\nuniform sampler2D rampGrey;\nuniform float domainMin;\nuniform float domainMax;\nuniform float opacity;\n// Blob radius σ\xb2, a uniform so the dev tuning panel can adjust the blob extent live (default\n// HEATMAP_BLOB_RADIUS_M\xb2). Production is byte-identical when unset — HeatmapFloorView seeds it\n// with the constant and only the dev panel ever changes it.\nuniform float blobSigmaSq;\n\nconst int MAX_SAMPLES = ".concat(MAX_HEATMAP_SAMPLES, ";\nconst float CORNER_FRAC = ").concat(glslFloat(HEATMAP_CORNER_RADIUS_FRAC), ";\nconst float DENSITY_EPSILON = ").concat(glslFloat(HEATMAP_DENSITY_EPSILON), ";\n\n// Rounded-rectangle signed distance (twin: roundedRectDistance), clamped to >= 0 outside;\n// 0 inside the shape. h = (hx, hz) half-extents; corner radius r = CORNER_FRAC*min(hx,hz).\nfloat roundedRectDistance(vec2 p, vec2 c, vec2 h) {\n  float r = CORNER_FRAC * min(h.x, h.y);\n  vec2 q = abs(p - c) - (h - r);\n  float outside = length(max(q, 0.0));\n  float inside = min(max(q.x, q.y), 0.0);\n  return max(outside + inside - r, 0.0);\n}\n\nvoid main() {\n  float density = 0.0;      // Σ k  → opacity\n  float weightedSum = 0.0;  // Σ k\xb7value\n  float selWeight = 0.0;    // Σ k\xb7selected\n\n  for (int i = 0; i < MAX_SAMPLES; i++) {\n    if (i >= sampleCount) break;\n    float u = (float(i) + 0.5) / float(MAX_SAMPLES);\n    // Row 0 (v=0.25): centroid + half-extents. Row 1 (v=0.75): value in R, selected in G.\n    // NearestFilter + height 2 ⇒ these v-coords hit the two row centres exactly.\n    vec4 s0 = texture2D(samples, vec2(u, 0.25));\n    vec4 s1 = texture2D(samples, vec2(u, 0.75));\n    vec2 centre = s0.xy;\n    vec2 halfExtents = s0.zw;\n    float value = s1.r;\n    float sel = s1.g;\n\n    float d = roundedRectDistance(vObjectXZ, centre, halfExtents); // 0 inside the footprint\n    float k = exp(-(d * d) / blobSigmaSq);       // compact Gaussian blob kernel (σ = BLOB_RADIUS)\n    density += k;\n    weightedSum += k * value;\n    selWeight += k * sel;                        // parallel accumulation, never perturbs v\n  }\n\n  if (density <= DENSITY_EPSILON) discard;       // no blob reaches here → transparent\n\n  float v = weightedSum / density;\n  float t = clamp((v - domainMin) / (domainMax - domainMin), 0.0, 1.0);\n  // 1 ⇒ all selected, 0 ⇒ all greyed. Clamped against FP overshoot (selWeight ≤ density\n  // mathematically, but a fused multiply-add can nudge it a sub-ULP past the range).\n  float selFrac = clamp(selWeight / density, 0.0, 1.0);\n  // Mix grey→colour by the selected fraction. With no filter active every sample is selected ⇒\n  // selFrac==1 ⇒ this returns the colour ramp exactly; the domain is shared, so t matches on both.\n  vec3 col = mix(texture2D(rampGrey, vec2(t, 0.5)).rgb, texture2D(ramp, vec2(t, 0.5)).rgb, selFrac);\n\n  // Splat opacity: the density (Σ kernel) clamped to [0,1]. A lone blob fades 1→0 over ~σ (only\n  // opacity changes); overlaps saturate to full. This IS the soft edge — there is no geometry\n  // feather and no boundary. Colour never carries the transparency.\n  gl_FragColor = vec4(col, opacity * clamp(density, 0.0, 1.0));\n}\n");
var HeatmapMaterial = /*#__PURE__*/ function(ShaderMaterial) {
    "use strict";
    _inherits(HeatmapMaterial, ShaderMaterial);
    function HeatmapMaterial(param) {
        var samples = param.samples, sampleCount = param.sampleCount, ramp = param.ramp, rampGrey = param.rampGrey, domain = param.domain, opacity = param.opacity, blobSigmaSq = param.blobSigmaSq;
        _class_call_check(this, HeatmapMaterial);
        return _call_super(this, HeatmapMaterial, [
            {
                uniforms: {
                    samples: {
                        value: samples
                    },
                    sampleCount: {
                        value: sampleCount
                    },
                    ramp: {
                        value: ramp
                    },
                    rampGrey: {
                        value: rampGrey
                    },
                    domainMin: {
                        value: domain[0]
                    },
                    domainMax: {
                        value: domain[1]
                    },
                    opacity: {
                        value: opacity
                    },
                    blobSigmaSq: {
                        value: blobSigmaSq
                    }
                },
                vertexShader: vertexShader3,
                fragmentShader: fragmentShader3,
                transparent: true,
                depthWrite: false,
                side: DoubleSide2
            }
        ]);
    }
    return HeatmapMaterial;
}(ShaderMaterial);
// src/components/3D/heatmap/HeatmapFloorView.tsx
import { jsx as jsx152 } from "react/jsx-runtime";
var HEATMAP_ELEVATION = 5e-3;
var MODEL_SETTLE_MS = 800;
var warnedOverCap = false;
var HeatmapFloorView = function(param) {
    var values = param.values, indicatorConfig = param.indicatorConfig, metricName = param.metricName, colorModes = param.colorModes, root = param.root;
    var scene = useThree(function(state) {
        return state.scene;
    });
    var invalidate = useThree(function(state) {
        return state.invalidate;
    });
    var overrides2 = useHeatmapTuning();
    var tuning = useMemo32(function() {
        return resolveHeatmapTuning(overrides2);
    }, [
        overrides2
    ]);
    var ramp = useMemo32(function() {
        return buildIndicatorRamp(indicatorConfig, true, metricName);
    }, [
        indicatorConfig,
        metricName
    ]);
    var rampGrey = useMemo32(function() {
        return buildIndicatorRamp(indicatorConfig, false, metricName);
    }, [
        indicatorConfig,
        metricName
    ]);
    var sampleTexture = useMemo32(function() {
        var tex = new DataTexture3(new Float32Array(heatmapSampleBufferLength(MAX_HEATMAP_SAMPLES)), MAX_HEATMAP_SAMPLES, HEATMAP_SAMPLE_TEXTURE_ROWS, RGBAFormat2, FloatType);
        tex.minFilter = NearestFilter;
        tex.magFilter = NearestFilter;
        return tex;
    }, []);
    var material3 = useMemo32(function() {
        return new HeatmapMaterial({
            samples: sampleTexture,
            sampleCount: 0,
            ramp: ramp.texture,
            rampGrey: rampGrey.texture,
            domain: ramp.domain,
            opacity: tuning.opacity,
            blobSigmaSq: tuning.blobRadiusM * tuning.blobRadiusM
        });
    }, // Constructed once; ramp/domain + tuning uniforms updated via the effects below.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        sampleTexture
    ]);
    var _useState78 = _sliced_to_array(useState78(null), 2), planeMesh = _useState78[0], setPlaneMesh = _useState78[1];
    var _useState781 = _sliced_to_array(useState78(/* @__PURE__ */ new Map()), 2), footprints = _useState781[0], setFootprints = _useState781[1];
    useEffect52(function() {
        if (!planeMesh) return;
        var target = root !== null && root !== void 0 ? root : scene;
        var collect2 = function() {
            target.updateWorldMatrix(true, true);
            var ancestorInverse = planeMesh.matrixWorld.clone().invert();
            var det = ancestorInverse.determinant();
            if (det === 0 || !Number.isFinite(det)) return;
            setFootprints(collectEntityFootprints(target, ancestorInverse));
        };
        collect2();
        var timer = setTimeout(collect2, MODEL_SETTLE_MS);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        scene,
        root,
        planeMesh
    ]);
    var geometry = useMemo32(function() {
        return buildSamplePlaneGeometry(footprints);
    }, [
        footprints
    ]);
    var samples = useMemo32(function() {
        return footprintsToSamples(footprints, values, colorModes);
    }, [
        footprints,
        values,
        colorModes
    ]);
    useEffect52(function() {
        var arr = sampleTexture.image.data;
        var count = packHeatmapSamples(samples, arr, MAX_HEATMAP_SAMPLES);
        if (samples.length > MAX_HEATMAP_SAMPLES && !warnedOverCap) {
            warnedOverCap = true;
            console.warn("[HeatmapFloor] ".concat(samples.length, " samples exceed the ").concat(MAX_HEATMAP_SAMPLES, " cap; only the first ").concat(MAX_HEATMAP_SAMPLES, " are rendered."));
        }
        sampleTexture.needsUpdate = true;
        material3.uniforms.sampleCount.value = count;
        invalidate();
    }, [
        samples,
        sampleTexture,
        material3,
        invalidate
    ]);
    useEffect52(function() {
        material3.uniforms.ramp.value = ramp.texture;
        material3.uniforms.rampGrey.value = rampGrey.texture;
        material3.uniforms.domainMin.value = ramp.domain[0];
        material3.uniforms.domainMax.value = ramp.domain[1];
        invalidate();
    }, [
        ramp,
        rampGrey,
        material3,
        invalidate
    ]);
    useEffect52(function() {
        material3.uniforms.opacity.value = tuning.opacity;
        material3.uniforms.blobSigmaSq.value = tuning.blobRadiusM * tuning.blobRadiusM;
        invalidate();
    }, [
        tuning,
        material3,
        invalidate
    ]);
    useEffect52(function() {
        return function() {
            return geometry.dispose();
        };
    }, [
        geometry
    ]);
    useEffect52(function() {
        return function() {
            return ramp.texture.dispose();
        };
    }, [
        ramp
    ]);
    useEffect52(function() {
        return function() {
            return rampGrey.texture.dispose();
        };
    }, [
        rampGrey
    ]);
    useEffect52(function() {
        return function() {
            sampleTexture.dispose();
            material3.dispose();
        };
    }, [
        sampleTexture,
        material3
    ]);
    return /* @__PURE__ */ jsx152("mesh", {
        ref: setPlaneMesh,
        geometry: geometry,
        material: material3,
        position: [
            0,
            HEATMAP_ELEVATION,
            0
        ],
        renderOrder: 1
    });
};
// src/components/3D/heatmap/HeatmapTuningPanel.tsx
import { useEffect as useEffect53, useState as useState79 } from "react";
import { Fragment as Fragment39, jsx as jsx153, jsxs as jsxs107 } from "react/jsx-runtime";
var CONTROLS = [
    {
        key: "blobRadiusM",
        label: "Blob radius (m)",
        min: 0.25,
        max: 8,
        step: 0.25
    },
    {
        key: "opacity",
        label: "Opacity",
        min: 0,
        max: 1,
        step: 0.01
    }
];
var panelStyle = {
    position: "fixed",
    top: 12,
    right: 12,
    zIndex: 1e4,
    width: 280,
    padding: "10px 12px",
    background: "rgba(20, 22, 26, 0.92)",
    color: "#e8eaed",
    font: "12px/1.4 ui-monospace, SFMono-Regular, Menlo, monospace",
    borderRadius: 8,
    boxShadow: "0 4px 16px rgba(0,0,0,0.4)",
    userSelect: "none"
};
var rowStyle = {
    display: "grid",
    gridTemplateColumns: "1fr auto",
    gap: 4,
    alignItems: "center",
    marginTop: 8
};
var buttonStyle = {
    background: "#2b3138",
    color: "#e8eaed",
    border: "1px solid #444b54",
    borderRadius: 4,
    padding: "3px 8px",
    cursor: "pointer",
    font: "inherit"
};
var HeatmapTuningPanel = function() {
    var overrides2 = useHeatmapTuning();
    var _useState79 = _sliced_to_array(useState79(false), 2), collapsed = _useState79[0], setCollapsed = _useState79[1];
    var _useState791 = _sliced_to_array(useState79(false), 2), copied = _useState791[0], setCopied = _useState791[1];
    useEffect53(function() {
        heatmapTuningStore.hydrateFromStorage();
    }, []);
    var effective = resolveHeatmapTuning(overrides2);
    var copyValues = function() {
        var _navigator_clipboard;
        var done = (_navigator_clipboard = navigator.clipboard) === null || _navigator_clipboard === void 0 ? void 0 : _navigator_clipboard.writeText(formatHeatmapTuningValues(effective));
        if (!done) return;
        done.then(function() {
            setCopied(true);
            setTimeout(function() {
                return setCopied(false);
            }, 1200);
        }).catch(function() {});
    };
    return /* @__PURE__ */ jsxs107("div", {
        style: panelStyle,
        "data-testid": "heatmap-tuning-panel",
        children: [
            /* @__PURE__ */ jsxs107("div", {
                style: {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                },
                children: [
                    /* @__PURE__ */ jsx153("strong", {
                        children: "Heatmap tuning"
                    }),
                    /* @__PURE__ */ jsx153("button", {
                        style: buttonStyle,
                        onClick: function() {
                            return setCollapsed(function(c) {
                                return !c;
                            });
                        },
                        children: collapsed ? "+" : "\u2013"
                    })
                ]
            }),
            !collapsed && /* @__PURE__ */ jsxs107(Fragment39, {
                children: [
                    CONTROLS.map(function(c) {
                        var isOverridden = overrides2 != null && c.key in overrides2;
                        return /* @__PURE__ */ jsxs107("div", {
                            children: [
                                /* @__PURE__ */ jsxs107("div", {
                                    style: rowStyle,
                                    children: [
                                        /* @__PURE__ */ jsxs107("span", {
                                            children: [
                                                c.label,
                                                " ",
                                                isOverridden ? "\u2022" : ""
                                            ]
                                        }),
                                        /* @__PURE__ */ jsx153("span", {
                                            children: Number(effective[c.key].toFixed(3))
                                        })
                                    ]
                                }),
                                /* @__PURE__ */ jsx153("input", {
                                    type: "range",
                                    min: c.min,
                                    max: c.max,
                                    step: c.step,
                                    value: effective[c.key],
                                    style: {
                                        width: "100%"
                                    },
                                    onChange: function(e) {
                                        return heatmapTuningStore.setParam(c.key, Number(e.target.value));
                                    }
                                })
                            ]
                        }, c.key);
                    }),
                    /* @__PURE__ */ jsxs107("div", {
                        style: _object_spread_props(_object_spread({}, rowStyle), {
                            gridTemplateColumns: "1fr 1fr"
                        }),
                        children: [
                            /* @__PURE__ */ jsx153("button", {
                                style: buttonStyle,
                                onClick: function() {
                                    return heatmapTuningStore.resetAll();
                                },
                                children: "Reset all"
                            }),
                            /* @__PURE__ */ jsx153("button", {
                                style: buttonStyle,
                                onClick: copyValues,
                                children: copied ? "Copied!" : "Copy values"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
// src/components/3D/heatmap/buildHeatmapValues.ts
var buildHeatmapValues = function(valueSeries, indicatorSeries) {
    var values = /* @__PURE__ */ new Map();
    if (!indicatorSeries) return values;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = indicatorSeries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var dv = _step.value;
            if (dv.bID == null) continue;
            if (dv.value == null || Number.isNaN(dv.value)) continue;
            if (values.has(dv.bID)) continue;
            values.set(dv.bID, dv.value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (valueSeries === indicatorSeries) return values;
    var usableValueBIDs = /* @__PURE__ */ new Set();
    if (valueSeries) {
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = valueSeries[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var dv1 = _step1.value;
                if (dv1.bID == null) continue;
                if (dv1.value == null || Number.isNaN(dv1.value)) continue;
                usableValueBIDs.add(dv1.bID);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
    try {
        for(var _iterator2 = Array.from(values.keys())[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var bID = _step2.value;
            if (!usableValueBIDs.has(bID)) values.delete(bID);
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
            }
        } finally{
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }
    return values;
};
// src/components/3D/utils/buildFloorShape.ts
import { Shape } from "three";
// src/components/3D/utils/coorUtils.ts
import { Vector2, Vector3 as Vector34 } from "three";
var COORD_LOCAL_TO_METRES = 100;
function coordLocalToVector2(point) {
    return new Vector2(point.longitude * 100, -point.latitude * 100);
}
function coordLocalOutlineToVector2(outline) {
    return outline.map(function(point) {
        return coordLocalToVector2(point);
    });
}
function Vector2ToVector3(vec2, altitude) {
    return new Vector34(vec2.x, altitude, vec2.y);
}
function convertCoordLocalPoint(point) {
    var altitude = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return new Vector34(point.longitude * 100, altitude, -point.latitude * 100);
}
// src/components/3D/utils/outlineUtils.ts
import { Vector2 as Vector22, Vector3 as Vector35 } from "three";
var expandOutline = function(points, distance2) {
    var outerPoints = [];
    for(var i = 0; i < points.length; i++){
        var current = points[i];
        var prev = points[i === 0 ? points.length - 2 : i - 1];
        var next = points[i === points.length - 1 ? 1 : i + 1];
        var incomingDirection = new Vector22(current.x - prev.x, -(current.y - prev.y)).normalize();
        var outGoingDirection = new Vector35(next.x - current.x, -(next.y - current.y)).normalize();
        var combinedDirection = new Vector22().copy(incomingDirection).add(outGoingDirection);
        if (combinedDirection.x > 0 && combinedDirection.y > 0 || combinedDirection.x < 0 && combinedDirection.y < 0) {
            combinedDirection.negate();
        }
        combinedDirection.multiplyScalar(distance2);
        var outerPoint = new Vector22(current.x, current.y).sub(combinedDirection);
        outerPoints.push(new Vector22(outerPoint.x, -outerPoint.y));
    }
    return outerPoints;
};
// src/components/3D/utils/buildFloorShape.ts
var FLOOR_WALL_GAP = 0.05;
var buildFloorShape = function(boundingGeometry) {
    var _boundingGeometry_;
    var points = (_boundingGeometry_ = boundingGeometry[0]) === null || _boundingGeometry_ === void 0 ? void 0 : _boundingGeometry_.points;
    if (!points || points.length === 0) return new Shape();
    var worldSpaceOutline = coordLocalOutlineToVector2(points);
    var internalPoints = expandOutline(worldSpaceOutline, FLOOR_WALL_GAP);
    return new Shape(internalPoints);
};
// src/components/3D/helpers/DebugThreeGlInfo.tsx
import { useFrame as useFrame2, useThree as useThree2 } from "@react-three/fiber";
import { Fragment as Fragment40, jsx as jsx154 } from "react/jsx-runtime";
var DebugThreeGlInfo = function(param) {
    var infoRef = param.infoRef;
    var gl = useThree2().gl;
    gl.autoClear = false;
    gl.info.autoReset = false;
    useFrame2(function(state) {
        if (infoRef.current) {
            var _gl_info_render = gl.info.render, calls = _gl_info_render.calls, lines = _gl_info_render.lines, points = _gl_info_render.points, triangles = _gl_info_render.triangles;
            infoRef.current.innerHTML = "\n            calls: ".concat(calls.toLocaleString(), " :-\n            lines: ").concat(lines.toLocaleString(), " :-\n            points: ").concat(points.toLocaleString(), " :-\n            triangles: ").concat(triangles.toLocaleString(), "\n            ");
        }
        state.gl.info.reset();
    });
    return /* @__PURE__ */ jsx154(Fragment40, {});
};
var DebugGlInfoDiv = function(param) {
    var infoRef = param.infoRef;
    return /* @__PURE__ */ jsx154("div", {
        ref: infoRef,
        style: {
            // marginTop: -33,
            top: 10,
            left: 180,
            padding: 5,
            borderStyle: "solid",
            borderWidth: 2,
            borderColor: "#000000",
            position: "absolute",
            zIndex: 1e3,
            width: 400,
            height: 40,
            color: "#000000",
            backgroundColor: "#ffffff"
        }
    });
};
// src/components/3D/helpers/threeTypeGuards.ts
function isMesh(obj) {
    if (obj.isMesh) {
        return true;
    } else {
        return false;
    }
}
// src/components/3D/helpers/utils.ts
import { MathUtils, Mesh as Mesh3, MeshBasicMaterial, Quaternion, SphereGeometry, Vector3 as Vector36 } from "three";
var vec3ToFixed = function(param) {
    var x = param.x, y = param.y, z = param.z, decimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    return "".concat(x.toFixed(decimals), ", ").concat(y.toFixed(decimals), ", ").concat(z.toFixed(decimals));
};
var sizeToFixed = function(param) {
    var width = param.width, height2 = param.height, decimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    return "".concat(width.toFixed(decimals), " x ").concat(height2.toFixed(decimals));
};
var bbToFixed = function(box) {
    var decimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    return "min: (".concat(vec3ToFixed(box.min, decimals), ") max: (").concat(vec3ToFixed(box.max, decimals), ")");
};
var matrix4ToColumnMajorFixed = function(matrix) {
    var decimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    var ar = [
        "\n"
    ];
    for(var i = 0; i < 16; i += 4){
        ar.push("[".concat(i, "]: "));
        if (i < 12) {
            ar.push(" ");
        }
        for(var j = 0; j < 4; j++){
            ar.push(matrix.elements[i + j].toFixed(decimals));
            if (j < 3) {
                ar.push(" | ");
            }
        }
        ar.push("\n");
    }
    return ar.join("");
};
var matrix4ToRowMajorFixed = function(matrix) {
    var decimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    var ar = [
        "\n"
    ];
    for(var i = 0; i < 4; i += 1){
        ar.push("[".concat(i * 4, "]: "));
        if (i < 3) {
            ar.push(" ");
        }
        for(var j = 0; j < 16; j += 4){
            ar.push(matrix.elements[i + j].toFixed(decimals));
            if (Math.trunc(j / 4) < 3) {
                ar.push(" | ");
            }
        }
        ar.push("\n");
    }
    return ar.join("");
};
var quaternionToFixed = function(quaternion) {
    var decimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    quaternion.normalize();
    var axis = new Vector36();
    var radians = 2 * Math.acos(quaternion.w);
    if (radians < 1e-4) {
        return "No rotation (identity quaternion).";
    }
    var sinHalfAngle = Math.sin(radians / 2);
    axis.set(quaternion.x / sinHalfAngle, quaternion.y / sinHalfAngle, quaternion.z / sinHalfAngle).normalize();
    var degrees = MathUtils.radToDeg(radians);
    return "Rot: ".concat(degrees.toFixed(decimals), "\xb0 | axis (").concat(vec3ToFixed(axis, decimals), ")");
};
var explainMatrix4 = function(matrix) {
    var decimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    var ar = [
        matrix4ToColumnMajorFixed(matrix, decimals)
    ];
    var trans = new Vector36();
    var quat = new Quaternion();
    var scale = new Vector36();
    matrix.decompose(trans, quat, scale);
    ar.push("\ntrans: ".concat(vec3ToFixed(trans, decimals)));
    ar.push("\nquat:  ".concat(quaternionToFixed(quat, decimals)));
    ar.push("\nscale: ".concat(vec3ToFixed(scale, decimals)));
    return ar.join("");
};
var log = console.log;
var json = function(thing) {
    return JSON.stringify(thing, null, 2);
};
var drawPoint = function(param) {
    var point = param.point, scene = param.scene, color = param.color, tmp = param.radius, radius14 = tmp === void 0 ? 0.01 : tmp;
    var geometry = new SphereGeometry(radius14);
    var material3 = new MeshBasicMaterial({
        color: color
    });
    var mesh = new Mesh3(geometry, material3);
    mesh.position.copy(point);
    scene.add(mesh);
    return function() {
        scene.remove(mesh);
        mesh.geometry.dispose();
        material3.dispose();
    };
};
var CleanUp = /*#__PURE__*/ function() {
    "use strict";
    function CleanUp() {
        _class_call_check(this, CleanUp);
        this._cleanUpFuncs = [];
    }
    _create_class(CleanUp, [
        {
            key: "addCleanUp",
            value: function addCleanUp(cleanup) {
                this._cleanUpFuncs.push(cleanup);
            }
        },
        {
            key: "cleanUp",
            value: function cleanUp() {
                this._cleanUpFuncs.forEach(function(cleanup) {
                    return cleanup();
                });
                this._cleanUpFuncs.splice(0, this._cleanUpFuncs.length);
            }
        }
    ]);
    return CleanUp;
}();
function isMesh2(object6) {
    return object6.isMesh !== void 0;
}
var getMeshFromGltf = function(gltf) {
    var mesh;
    gltf.scene.traverse(function(object6) {
        if (isMesh2(object6)) {
            mesh = object6;
        }
    });
    return mesh;
};
// src/components/3D/utils/parseLatLong.ts
var parseLatLong = function(param) {
    var latitude = param.latitude, longitude = param.longitude;
    return {
        latitude: parseFloat(latitude),
        longitude: parseFloat(longitude)
    };
};
// src/components/3D/utils/parseOrientation.ts
var parseOrientation = function(value) {
    if (value == null) return null;
    var degrees = parseFloat(String(value).trim());
    return Number.isFinite(degrees) ? degrees : null;
};
// src/components/3D/utils/geometry.ts
var EARTH_RADIUS_METRES = 6378137;
function shiftLatLongByMetres(startingLocation, offset) {
    var newLatitude = startingLocation.latitude + offset.y / EARTH_RADIUS_METRES * (180 / Math.PI);
    var newLongitude = startingLocation.longitude + offset.x / EARTH_RADIUS_METRES * (180 / Math.PI) / Math.cos(startingLocation.latitude * Math.PI / 180);
    return {
        lat: newLatitude,
        lng: newLongitude
    };
}
function degreesToRadians(degrees) {
    return degrees * Math.PI / 180;
}
function getPolygonCentroid(pts) {
    if (!pts || pts.length === 0) {
        throw new Error("Cannot calculate centroid: empty point array");
    }
    if (pts.length === 1) {
        return {
            latitude: pts[0].latitude,
            longitude: pts[0].longitude
        };
    }
    if (pts.length === 2) {
        return {
            latitude: (pts[0].latitude + pts[1].latitude) / 2,
            longitude: (pts[0].longitude + pts[1].longitude) / 2
        };
    }
    var points = _to_consumable_array(pts);
    var first = points[0];
    var last = points[points.length - 1];
    if (first.latitude !== last.latitude || first.longitude !== last.longitude) {
        points.push({
            latitude: first.latitude,
            longitude: first.longitude
        });
    }
    var twicearea = 0;
    var x = 0;
    var y = 0;
    var nPts = points.length;
    var p1;
    var p2;
    var f;
    for(var i = 0, j = nPts - 1; i < nPts; j = i++){
        p1 = points[i];
        p2 = points[j];
        f = (p1.longitude - first.longitude) * (p2.latitude - first.latitude) - (p2.longitude - first.longitude) * (p1.latitude - first.latitude);
        twicearea += f;
        x += (p1.latitude + p2.latitude - 2 * first.latitude) * f;
        y += (p1.longitude + p2.longitude - 2 * first.longitude) * f;
    }
    var epsilon = 1e-10;
    if (Math.abs(twicearea) < epsilon) {
        var lengthForAverage = first.latitude === last.latitude && first.longitude === last.longitude ? points.length - 1 : points.length;
        var sumLat = points.slice(0, lengthForAverage).reduce(function(sum, p) {
            return sum + p.latitude;
        }, 0);
        var sumLng = points.slice(0, lengthForAverage).reduce(function(sum, p) {
            return sum + p.longitude;
        }, 0);
        return {
            latitude: sumLat / lengthForAverage,
            longitude: sumLng / lengthForAverage
        };
    }
    f = twicearea * 3;
    return {
        latitude: x / f + first.latitude,
        longitude: y / f + first.longitude
    };
}
function getCentre(polygons) {
    var lastPolygon = polygons[polygons.length - 1];
    return getPolygonCentroid(lastPolygon.coordinates[0].points);
}
// src/components/3D/utils/isNullOrUndefined.ts
var isNullOrUndefined = function(value) {
    return value === null || value === void 0;
};
// src/components/3D/utils/gltfConfig.ts
import { useGLTF } from "@react-three/drei";
import { MeshoptDecoder } from "three-stdlib";
function configureGLTFDecoders() {
    try {
        var gltf = useGLTF;
        gltf.setDecoderPath("https://www.gstatic.com/draco/v1/decoders/");
        gltf.setMeshoptDecoder(MeshoptDecoder);
    } catch (_) {}
}
// src/components/3D/utils/floorGroupTransform.ts
import { floorToWorld } from "@repo/front-end-utils";
var usable = function(n) {
    return typeof n === "number" && Number.isFinite(n);
};
function readPlacement(floor) {
    var location = floor.location, rotationY = floor.rotationY;
    var hasLocation = location !== null && location !== void 0;
    var hasRotation = rotationY !== null && rotationY !== void 0;
    if (!hasLocation && !hasRotation) return "none";
    if (hasLocation && !(usable(location.latitude) && usable(location.longitude)) || hasRotation && !usable(rotationY)) return "unusable";
    return {
        location: hasLocation ? location : null,
        rotationY: hasRotation ? rotationY : 0
    };
}
function floorGroupTransform(entity, altitude) {
    var unplaced = {
        position: [
            0,
            altitude,
            0
        ],
        rotation: [
            0,
            0,
            0
        ]
    };
    var placement = readPlacement(entity);
    if (placement === "none") return unplaced;
    if (placement === "unusable") {
        var _entity_bID;
        console.warn("Floor ".concat((_entity_bID = entity.bID) !== null && _entity_bID !== void 0 ? _entity_bID : "(no bID)", " has an unusable placement; drawn unplaced."));
        return unplaced;
    }
    var at = placement.location ? convertCoordLocalPoint(placement.location, altitude) : null;
    return {
        position: at ? [
            at.x,
            at.y,
            at.z
        ] : [
            0,
            altitude,
            0
        ],
        rotation: [
            0,
            degreesToRadians(placement.rotationY),
            0
        ]
    };
}
function placeOnFloor(point, floor) {
    var placement = floor ? readPlacement(floor) : "none";
    if (placement === "none" || placement === "unusable") return point;
    var location = placement.location, rotationY = placement.rotationY;
    var world = floorToWorld({
        x: point.longitude * COORD_LOCAL_TO_METRES,
        y: point.latitude * COORD_LOCAL_TO_METRES
    }, {
        x: location ? location.longitude * COORD_LOCAL_TO_METRES : 0,
        y: location ? location.latitude * COORD_LOCAL_TO_METRES : 0,
        rotation: rotationY
    });
    return _object_spread_props(_object_spread({}, point), {
        longitude: world.x / COORD_LOCAL_TO_METRES,
        latitude: world.y / COORD_LOCAL_TO_METRES
    });
}
// src/components/3D/utils/machinePlacement.ts
function machinePlacement(entity) {
    var _entity_boundaries;
    var centre;
    if ((_entity_boundaries = entity.boundaries) === null || _entity_boundaries === void 0 ? void 0 : _entity_boundaries.polygons) {
        centre = getCentre(entity.boundaries.polygons);
    } else if (entity.location) {
        centre = entity.location;
    } else {
        throw new Error("model has neither boundary or location. We dont know how to locate it without them");
    }
    var position = convertCoordLocalPoint(centre);
    var mirrorScaleX = 1;
    var mirrorScaleZ = 1;
    if (entity.definitions) {
        try {
            var decodedDefinitions = JSON.parse(atob(entity.definitions));
            if (decodedDefinitions.floorplanner_mirrored && Array.isArray(decodedDefinitions.floorplanner_mirrored)) {
                var _decodedDefinitions_floorplanner_mirrored = _sliced_to_array(decodedDefinitions.floorplanner_mirrored, 2), horizontalMirror = _decodedDefinitions_floorplanner_mirrored[0], verticalMirror = _decodedDefinitions_floorplanner_mirrored[1];
                var originalRotation = decodedDefinitions.floorplanner_original_rotation;
                var isQuarterTurn = typeof originalRotation === "number" && Math.abs(originalRotation % 180) === 90;
                if (isQuarterTurn) {
                    if (horizontalMirror === 1) mirrorScaleX = -1;
                    if (verticalMirror === 1) mirrorScaleZ = -1;
                } else {
                    if (horizontalMirror === 1) mirrorScaleZ = -1;
                    if (verticalMirror === 1) mirrorScaleX = -1;
                }
            }
        } catch (error) {
            console.error("Failed to parse entity.definitions for mirroring in entity ".concat(entity.bID || "unknown", ":"), error);
        }
    }
    var _entity_rotationY;
    var rotationY = degreesToRadians((_entity_rotationY = entity.rotationY) !== null && _entity_rotationY !== void 0 ? _entity_rotationY : 0);
    return {
        position: [
            position.x,
            position.y,
            position.z
        ],
        rotationY: rotationY,
        mirrorScale: [
            mirrorScaleX,
            1,
            mirrorScaleZ
        ]
    };
}
var keepNonFinite = function(_key, value) {
    return typeof value === "number" && !Number.isFinite(value) ? String(value) : value;
};
function machinePlacementKey(entity) {
    var _entity_boundaries;
    var _entity_bID, _entity_boundaries_polygons, _entity_location, _entity_rotationY, _entity_definitions, _entity_depth;
    return JSON.stringify([
        (_entity_bID = entity.bID) !== null && _entity_bID !== void 0 ? _entity_bID : null,
        (_entity_boundaries_polygons = (_entity_boundaries = entity.boundaries) === null || _entity_boundaries === void 0 ? void 0 : _entity_boundaries.polygons) !== null && _entity_boundaries_polygons !== void 0 ? _entity_boundaries_polygons : null,
        (_entity_location = entity.location) !== null && _entity_location !== void 0 ? _entity_location : null,
        (_entity_rotationY = entity.rotationY) !== null && _entity_rotationY !== void 0 ? _entity_rotationY : null,
        (_entity_definitions = entity.definitions) !== null && _entity_definitions !== void 0 ? _entity_definitions : null,
        (_entity_depth = entity.depth) !== null && _entity_depth !== void 0 ? _entity_depth : null
    ], keepNonFinite);
}
// src/components/3D/utils/machineGeometry.ts
import { BoxGeometry } from "three";
var BOX_PADDING = 0.02;
function machineMesh(nodes) {
    var geometry;
    Object.values(nodes).forEach(function(node) {
        if (isMesh(node)) {
            if (!node.geometry.boundingBox) {
                node.geometry.computeBoundingBox();
            }
            geometry = node.geometry;
        }
    });
    return geometry !== null && geometry !== void 0 ? geometry : null;
}
function machineBox(geometry, mirrorScale) {
    if (!geometry.boundingBox) {
        geometry.computeBoundingBox();
    }
    var _geometry_boundingBox = geometry.boundingBox, min = _geometry_boundingBox.min, max = _geometry_boundingBox.max;
    var box = new BoxGeometry(1, 1, 1);
    box.translate(0, 0.5, 0);
    box.scale(-(min.x - max.x) + BOX_PADDING, -(min.y - max.y) + BOX_PADDING, -(min.z - max.z) + BOX_PADDING);
    box.translate((min.x + max.x) / 2 * mirrorScale[0], 0, (min.z + max.z) / 2 * mirrorScale[2]);
    box.computeBoundingBox();
    return box;
}
// src/components/3D/utils/getAreaOutline.ts
import { ExtrudeGeometry, Shape as Shape2 } from "three";
// src/components/3D/utils/extrusionConfig.ts
var bevelSize = 0.04;
var extrudeSettingsInternalSiteBoundaryWall = {
    depth: 1.5,
    bevelEnabled: false,
    steps: 1,
    bevelOffset: -bevelSize,
    bevelSegments: 1,
    bevelSize: bevelSize,
    bevelThickness: bevelSize
};
var extrudeSettingsArea = {
    depth: 1,
    steps: 1,
    bevelEnabled: false,
    bevelOffset: -bevelSize,
    bevelSegments: 1,
    bevelSize: bevelSize,
    bevelThickness: bevelSize
};
var extrudeSettingsWall = {
    depth: 3,
    bevelEnabled: false,
    steps: 1,
    bevelOffset: -bevelSize,
    bevelSegments: 1,
    bevelSize: bevelSize,
    bevelThickness: bevelSize
};
// src/components/3D/utils/getAreaOutline.ts
function getAreaOutlineShape(polygons, depth) {
    var shapes = [];
    var centre = {
        latitude: 0,
        longitude: 0
    };
    polygons.forEach(function(polygon, idx) {
        if (idx === polygons.length - 1) {
            centre = getPolygonCentroid(polygon.coordinates[0].points);
        }
        var worldSpaceOutline = coordLocalOutlineToVector2(polygon.coordinates[0].points);
        var areaPoints = expandOutline(worldSpaceOutline, -0.06 - depth / 2e3);
        var areaShape = new Shape2(areaPoints);
        shapes.push(areaShape);
    });
    var areaBlock = new ExtrudeGeometry(shapes, _object_spread({}, extrudeSettingsArea, {
        depth: 3 - depth / 5
    }));
    areaBlock.computeBoundingBox();
    areaBlock.rotateX(-Math.PI / 2);
    return {
        centre: centre,
        areaBlock: areaBlock
    };
}
// src/components/3D/utils/filterUtils.ts
import { FilterType as FilterType7, TwinEntityType } from "@repo/frontend-types";
import { stringToTwinEntityType } from "@repo/front-end-utils";
var getMenuHovered = function(lineage, menuHoverSelection) {
    if (!menuHoverSelection) return false;
    return lineage[lineage.length - 1].id === menuHoverSelection.id;
};
var getRelevantFilters = function(filter) {
    return filter.filter(function(filterTags) {
        return filterTags.type === FilterType7.ASSET || filterTags.type === FilterType7.ENTITY;
    });
};
var isSelected = function(entity, entityFilters) {
    return entityFilters[entityFilters.length - 1].id === entity.id;
};
var siblingSelected = function(entity, parent, entityFilters) {
    return entityFilters.length > 1 && entityFilters[entityFilters.length - 2].id === parent.id && !isSelected(entity, entityFilters);
};
var hasChildren = function(entity) {
    if (entity.children === null || entity.children === void 0) {
        return false;
    } else {
        return entity.children.length > 0;
    }
};
var getSelectionCriteria = function(entity, parent, filter) {
    var filters = getRelevantFilters(filter);
    var filtersExist = filters.length > 0;
    var areaIsSelected = filtersExist && isSelected(entity, filters);
    var parentIsSelected = filtersExist && isSelected(parent, filters);
    var siblingIsSelected = filtersExist && siblingSelected(entity, parent, filters);
    return {
        filtersExist: filtersExist,
        areaIsSelected: areaIsSelected,
        parentIsSelected: parentIsSelected,
        siblingIsSelected: siblingIsSelected
    };
};
var deriveColorMode = function(criteria) {
    return criteria.filtersExist && !criteria.areaIsSelected && criteria.siblingIsSelected ? "greys" : "colors";
};
function determineVisibility(entity, filterState) {
    var visible = false;
    var areaHasChildren = hasChildren(entity);
    var filtersExist = filterState.filtersExist, areaIsSelected = filterState.areaIsSelected, parentIsSelected = filterState.parentIsSelected, siblingIsSelected = filterState.siblingIsSelected, isTopLevelArea = filterState.isTopLevelArea;
    if (filtersExist) {
        if (areaIsSelected) {
            if (!areaHasChildren) {
                visible = true;
            }
        } else if (parentIsSelected) {
            visible = true;
        } else if (siblingIsSelected) {
            visible = true;
        }
    } else {
        if (isTopLevelArea) {
            visible = true;
        }
    }
    return visible;
}
var topLevelTypeFor = function(shape) {
    return shape.hasFloorLevel ? TwinEntityType.FLOOR : TwinEntityType.SITE;
};
var isBoxRenderedType = function(type) {
    return type === TwinEntityType.AREA || type === TwinEntityType.ASSET;
};
var buildInScopeColorModes = function(root, filter, options) {
    var inScope = /* @__PURE__ */ new Map();
    var topLevelType = topLevelTypeFor(options);
    var visit = function(entity, parent) {
        var _entity_children;
        if (!entity) return;
        var bID = entity.bID;
        if (typeof bID === "string") {
            var _entity_type;
            var _entity_type_name;
            var entityType = stringToTwinEntityType((_entity_type_name = (_entity_type = entity.type) === null || _entity_type === void 0 ? void 0 : _entity_type.name) !== null && _entity_type_name !== void 0 ? _entity_type_name : "");
            if (options.arealess) {
                if (entityType === TwinEntityType.ASSET) {
                    var arealessSelectedIds = options.arealessSelectedIds;
                    var selected = !_instanceof(arealessSelectedIds, Set) || arealessSelectedIds.has(entity.id);
                    inScope.set(bID, selected ? "colors" : "greys");
                }
            } else if (isBoxRenderedType(entityType)) {
                var _parent_type;
                var criteria = getSelectionCriteria(entity, parent, filter);
                var _parent_type_name;
                var isTopLevelArea = stringToTwinEntityType((_parent_type_name = (_parent_type = parent.type) === null || _parent_type === void 0 ? void 0 : _parent_type.name) !== null && _parent_type_name !== void 0 ? _parent_type_name : "") === topLevelType;
                if (determineVisibility(entity, _object_spread_props(_object_spread({}, criteria), {
                    isTopLevelArea: isTopLevelArea
                }))) {
                    inScope.set(bID, deriveColorMode(criteria));
                }
            }
        }
        (_entity_children = entity.children) === null || _entity_children === void 0 ? void 0 : _entity_children.forEach(function(child) {
            return visit(child, entity);
        });
    };
    if (root) visit(root, root);
    return inScope;
};
// src/components/3D/utils/createFilterPath.ts
import { FilterType as FilterType8 } from "@repo/frontend-types";
var findAncestors = function(entityId, model) {
    var ancestors = [];
    var findEntity = function(node, path) {
        if (node.id === entityId) {
            var _ancestors;
            (_ancestors = ancestors).push.apply(_ancestors, _to_consumable_array(path).concat([
                node
            ]));
            return true;
        }
        if (node.children) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = node.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var child = _step.value;
                    if (findEntity(child, _to_consumable_array(path).concat([
                        node
                    ]))) {
                        return true;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        return false;
    };
    findEntity(model, []);
    return ancestors;
};
var createFilterPath4 = function(entityId, model) {
    var filterPaths = [];
    var ancestors = findAncestors(entityId, model);
    ancestors.forEach(function(anc) {
        var fp = {
            id: anc.id,
            bId: anc.bID,
            type: FilterType8.ENTITY,
            label: anc.name,
            display: true
        };
        filterPaths.push(fp);
    });
    return filterPaths;
};
var createFilterPathFromLineage = function(lineage) {
    var filterPaths = [];
    lineage.forEach(function(anc) {
        var fp = {
            id: anc.id,
            bId: anc.bID,
            type: FilterType8.ENTITY,
            label: anc.name,
            display: true
        };
        filterPaths.push(fp);
    });
    return filterPaths;
};
// src/components/3D/utils/cleanupGL.ts
function disposeMaterial(material3) {
    if (Array.isArray(material3)) {
        material3.forEach(function(individualMaterial) {
            return disposeMaterial(individualMaterial);
        });
    } else {
        material3.dispose();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.entries(material3)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = _sliced_to_array(_step.value, 2), value = _step_value[1];
                if (value && (typeof value === "undefined" ? "undefined" : _type_of(value)) === "object" && "minFilter" in value) {
                    value.dispose();
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
}
function disposeMesh(mesh) {
    var material3 = mesh.material;
    var geometry = mesh.geometry;
    geometry.dispose();
    disposeMaterial(material3);
}
function disposeScene(scene) {
    scene.traverse(function(object6) {
        if (isMesh(object6)) {
            disposeMesh(object6);
        }
    });
}
// src/components/3D/utils/modelExistenceChecker.ts
var modelExistenceCache = /* @__PURE__ */ new Map();
var inFlightChecks = /* @__PURE__ */ new Map();
var cacheGeneration = 0;
var MODEL_EXISTENCE_CHECK_TIMEOUT_MS = 3e4;
function extractModelFilename(modelURL) {
    var urlParts = modelURL.split("/");
    var filename = urlParts[urlParts.length - 1];
    var cleanFilename = filename.split("?")[0];
    return decodeURIComponent(cleanFilename);
}
function checkModelExists(modelURL) {
    return _checkModelExists.apply(this, arguments);
}
function _checkModelExists() {
    _checkModelExists = _async_to_generator(function(modelURL) {
        var inFlight, check;
        return _ts_generator(this, function(_state) {
            if (modelExistenceCache.has(modelURL)) {
                return [
                    2,
                    modelExistenceCache.get(modelURL)
                ];
            }
            inFlight = inFlightChecks.get(modelURL);
            if (inFlight) {
                return [
                    2,
                    inFlight
                ];
            }
            check = headModel(modelURL, cacheGeneration).finally(function() {
                if (inFlightChecks.get(modelURL) === check) inFlightChecks.delete(modelURL);
            });
            inFlightChecks.set(modelURL, check);
            return [
                2,
                check
            ];
        });
    });
    return _checkModelExists.apply(this, arguments);
}
function headModel(modelURL, generation) {
    return _headModel.apply(this, arguments);
}
function _headModel() {
    _headModel = _async_to_generator(function(modelURL, generation) {
        var controller, timer, response, _;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    controller = new AbortController();
                    timer = setTimeout(function() {
                        return controller.abort();
                    }, MODEL_EXISTENCE_CHECK_TIMEOUT_MS);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4,
                        fetch(modelURL, {
                            method: "HEAD",
                            signal: controller.signal
                        })
                    ];
                case 2:
                    response = _state.sent();
                    if (generation === cacheGeneration) modelExistenceCache.set(modelURL, response.ok);
                    return [
                        2,
                        response.ok
                    ];
                case 3:
                    _ = _state.sent();
                    return [
                        2,
                        false
                    ];
                case 4:
                    clearTimeout(timer);
                    return [
                        7
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return _headModel.apply(this, arguments);
}
function clearModelExistenceCache() {
    modelExistenceCache.clear();
    inFlightChecks.clear();
    cacheGeneration++;
}
function getCachedModelExistence(modelURL) {
    return modelExistenceCache.get(modelURL);
}
function isValidModelFilename(filename) {
    return !!filename;
}
function isValidModelURL(modelURL) {
    var filename = extractModelFilename(modelURL);
    return isValidModelFilename(filename);
}
// src/components/3D/utils/ModelManager.ts
import { InstancedMesh, Matrix4 as Matrix44, Quaternion as Quaternion2, Vector3 as Vector37 } from "three";
// src/components/3D/utils/placeholderGeometry.ts
import { BoxGeometry as BoxGeometry2, ExtrudeGeometry as ExtrudeGeometry2, Shape as Shape3 } from "three";
var size = 0.5;
var height = 1.2;
var createPlaceholderGeometry = function(directedPlaceholderGeometry) {
    if (directedPlaceholderGeometry) {
        var triangleShape = new Shape3();
        triangleShape.moveTo(0, size);
        triangleShape.lineTo(-size / 2, 0);
        triangleShape.lineTo(size / 2, 0);
        triangleShape.lineTo(0, size);
        var extrudeSettings = {
            depth: size,
            bevelEnabled: false
        };
        var placeHolderGeometry = new ExtrudeGeometry2(triangleShape, extrudeSettings);
        placeHolderGeometry.rotateX(Math.PI / 2);
        placeHolderGeometry.translate(0, size, -size / 2);
        placeHolderGeometry.computeBoundingBox();
        return placeHolderGeometry;
    } else {
        var placeHolderGeometry1 = new BoxGeometry2(size, height, size);
        placeHolderGeometry1.translate(0, height / 2, 0);
        placeHolderGeometry1.computeBoundingBox();
        return placeHolderGeometry1;
    }
};
var HIT_BOX_PADDING = 0.05;
var createPlaceholderHitBox = function() {
    var hitBox = new BoxGeometry2(size + HIT_BOX_PADDING, height + HIT_BOX_PADDING, size + HIT_BOX_PADDING);
    hitBox.translate(0, (height + HIT_BOX_PADDING) / 2, 0);
    hitBox.computeBoundingBox();
    return hitBox;
};
// src/components/3D/utils/ModelManager.ts
var TEMP_ASSET_MODEL_NAME = "placeholder_model";
var _ModelManager = /*#__PURE__*/ function() {
    "use strict";
    function _ModelManager() {
        _class_call_check(this, _ModelManager);
        this.assetCount = 0;
        this.instancedMeshRegistry = /* @__PURE__ */ new Map();
        this.modelRegistry = /* @__PURE__ */ new Map();
        // The app supplies its machines' address rule, so the preloader warms the exact URLs they load.
        // App configuration, not twin state: reinitialize does not clear it.
        this.resolveModelURL = null;
        this._isInitialized = false;
        this.suppressMissingModelWarnings = true;
    }
    _create_class(_ModelManager, [
        {
            key: "isInitialized",
            value: function isInitialized() {
                return this._isInitialized;
            }
        },
        {
            key: "setSuppressMissingModelWarnings",
            value: function setSuppressMissingModelWarnings(suppress) {
                this.suppressMissingModelWarnings = suppress;
            }
        },
        {
            key: "setModelURLResolver",
            value: function setModelURLResolver(resolve) {
                this.resolveModelURL = resolve;
            }
        },
        {
            key: "reinitialize",
            value: function reinitialize(param) {
                var twin = param.twin, authMetadata = param.authMetadata, directedPlaceholderGeometry = param.directedPlaceholderGeometry;
                this._isInitialized = false;
                this.instancedMeshRegistry.clear();
                this.modelRegistry.clear();
                this.initialize({
                    twin: twin,
                    authMetadata: authMetadata,
                    directedPlaceholderGeometry: directedPlaceholderGeometry
                });
            }
        },
        {
            key: "initialize",
            value: function initialize(param) {
                var twin = param.twin, directedPlaceholderGeometry = param.directedPlaceholderGeometry;
                if (this._isInitialized) {
                    return;
                }
                this._isInitialized = true;
                var modelStack = [
                    twin
                ];
                this.modelRegistry.clear();
                while(modelStack.length > 0){
                    var currentEntity = modelStack.pop();
                    if (currentEntity) {
                        var _currentEntity_type;
                        if ((currentEntity === null || currentEntity === void 0 ? void 0 : (_currentEntity_type = currentEntity.type) === null || _currentEntity_type === void 0 ? void 0 : _currentEntity_type.name) === "asset") {
                            this.assetCount++;
                        }
                        if (currentEntity.modelFile) {
                            var modelFileName = currentEntity.modelFile;
                            var entry = this.modelRegistry.get(modelFileName);
                            if (!entry) {
                                this.modelRegistry.set(modelFileName, {
                                    modelFile: modelFileName,
                                    twinInstances: 1
                                });
                            } else {
                                entry.twinInstances++;
                            }
                        } else {}
                        if (currentEntity.children && currentEntity.children.length > 0) {
                            var _modelStack;
                            (_modelStack = modelStack).push.apply(_modelStack, _to_consumable_array(currentEntity.children));
                        }
                    }
                }
                this.createPlaceholderGeometry(directedPlaceholderGeometry);
            }
        },
        {
            // Addresses are resolved when the list is read, so a token that arrives after initialize is used.
            key: "getPrioritizedPreloadList",
            value: function getPrioritizedPreloadList() {
                var resolve = this.resolveModelURL;
                if (!resolve) return [];
                var items = Array.from(this.modelRegistry.values()).map(function(entry) {
                    return {
                        url: resolve(entry.modelFile),
                        instances: entry.twinInstances
                    };
                }).filter(function(item) {
                    return item.url !== "";
                });
                items.sort(function(a, b) {
                    return b.instances - a.instances;
                });
                return items;
            }
        },
        {
            key: "createPlaceholderGeometry",
            value: function createPlaceholderGeometry1(directedPlaceholderGeometry) {
                var placeHolderGeometry = createPlaceholderGeometry(directedPlaceholderGeometry);
                var entry = this.getInstancedMesh(TEMP_ASSET_MODEL_NAME);
                if (entry) {
                    this.instancedMeshRegistry.delete(TEMP_ASSET_MODEL_NAME);
                }
                this.createInstancedMesh({
                    modelFile: TEMP_ASSET_MODEL_NAME,
                    geometry: placeHolderGeometry,
                    material: MACHINE_MATERIAL,
                    initialMaxInstances: this.assetCount
                });
            }
        },
        {
            key: "getInstancedMesh",
            value: function getInstancedMesh(modelFile) {
                return this.instancedMeshRegistry.get(modelFile);
            }
        },
        {
            key: "createInstancedMesh",
            value: function createInstancedMesh(param) {
                var modelFile = param.modelFile, geometry = param.geometry, material3 = param.material, initialMaxInstances = param.initialMaxInstances;
                var mesh = new InstancedMesh(geometry, material3, initialMaxInstances);
                mesh.castShadow = true;
                mesh.receiveShadow = true;
                mesh.frustumCulled = false;
                var entry = {
                    mesh: mesh,
                    instances: /* @__PURE__ */ new Map(),
                    maxInstances: initialMaxInstances
                };
                this.instancedMeshRegistry.set(modelFile, entry);
                return entry;
            }
        },
        {
            key: "resizeInstancedMesh",
            value: function resizeInstancedMesh(modelFileName, newMaxInstances) {
                var entry = this.instancedMeshRegistry.get(modelFileName);
                if (entry && newMaxInstances > entry.maxInstances) {
                    var oldMesh = entry.mesh;
                    var newMesh = new InstancedMesh(oldMesh.geometry, oldMesh.material, newMaxInstances);
                    newMesh.castShadow = oldMesh.castShadow;
                    newMesh.receiveShadow = oldMesh.receiveShadow;
                    entry.instances.forEach(function(param) {
                        var index = param.index, position = param.position, rotation = param.rotation, scale = param.scale;
                        var matrix = new Matrix44();
                        matrix.compose(position, new Quaternion2().setFromEuler(rotation), scale);
                        newMesh.setMatrixAt(index, matrix);
                    });
                    newMesh.instanceMatrix.needsUpdate = true;
                    entry.mesh = newMesh;
                    entry.maxInstances = newMaxInstances;
                    this.instancedMeshRegistry.set(modelFileName, entry);
                    oldMesh.dispose();
                    return newMesh;
                }
                return entry === null || entry === void 0 ? void 0 : entry.mesh;
            }
        },
        {
            key: "getInstanceCount",
            value: function getInstanceCount(modelFileName) {
                var entry = this.instancedMeshRegistry.get(modelFileName);
                return (entry === null || entry === void 0 ? void 0 : entry.instances.size) || 0;
            }
        },
        {
            key: "getInstance",
            value: function getInstance(modelFileName, entityId) {
                var entry = this.instancedMeshRegistry.get(modelFileName);
                if (entry) {
                    return entry.instances.get(entityId);
                }
                return void 0;
            }
        },
        {
            key: "createOrUpdateInstance",
            value: function createOrUpdateInstance(param) {
                var modelFile = param.modelFile, entityId = param.entityId, position = param.position, rotation = param.rotation, scale = param.scale;
                log("\uD83C\uDF44 createOrUpdateInstance({ modelFile: '".concat(modelFile, "', entityId: ").concat(entityId));
                var entry = this.getInstancedMesh(modelFile);
                if (!entry) {
                    throw new Error("InstancedMesh for ".concat(modelFile, " not found"));
                }
                var instance = entry.instances.get(entityId);
                var index = -1;
                if (instance) {
                    index = instance.index;
                } else {
                    index = entry.instances.size;
                    if (index >= entry.maxInstances) {
                        var newMaxInstances = this.maxInstancesGrowthFunc(entry.maxInstances);
                        console.log("\uD83C\uDF44\uD83C\uDF44 Resizing InstancedMesh for ".concat(modelFile, " (entityId: ").concat(entityId, ") from ").concat(entry.maxInstances, " to ").concat(newMaxInstances, " due to new instance at index ").concat(index));
                        this.resizeInstancedMesh(modelFile, newMaxInstances);
                    }
                    entry.instances.set(entityId, {
                        index: index,
                        position: position,
                        rotation: rotation,
                        scale: scale
                    });
                }
                var matrix = new Matrix44();
                matrix.compose(position, new Quaternion2().setFromEuler(rotation), scale);
                entry.mesh.setMatrixAt(index, matrix);
                entry.mesh.instanceMatrix.needsUpdate = true;
                entry.mesh.count = entry.instances.size;
                return entry.mesh;
            }
        },
        {
            key: "maxInstancesGrowthFunc",
            value: function maxInstancesGrowthFunc(oldMaxInstances) {
                var MINIMUM_INSTANCES = 10;
                var newMaxInstances = oldMaxInstances < MINIMUM_INSTANCES ? MINIMUM_INSTANCES : Math.max(oldMaxInstances * 2, MINIMUM_INSTANCES);
                return newMaxInstances;
            }
        },
        {
            key: "unregisterInstance",
            value: function unregisterInstance(param) {
                var modelFile = param.modelFile, entityId = param.entityId;
                var entry = this.getInstancedMesh(modelFile);
                if (entry) {
                    var instance = entry.instances.get(entityId);
                    if (instance) {
                        var indexToRemove = instance.index;
                        if (indexToRemove < entry.instances.size - 1) {
                            var matrix = new Matrix44();
                            entry.mesh.getMatrixAt(entry.instances.size - 1, matrix);
                            var pos = new Vector37();
                            var quat = new Quaternion2();
                            var scale = new Vector37();
                            matrix.decompose(pos, quat, scale);
                            matrix.compose(pos, quat, scale);
                            entry.mesh.setMatrixAt(indexToRemove, matrix);
                        }
                        entry.instances.delete(entityId);
                        entry.mesh.count = entry.instances.size;
                        entry.mesh.instanceMatrix.needsUpdate = true;
                        this.instancedMeshRegistry.set(modelFile, entry);
                    }
                }
            }
        },
        {
            key: "getAllInstancedMeshes",
            value: function getAllInstancedMeshes() {
                return Array.from(this.instancedMeshRegistry.values()).map(function(entry) {
                    return entry.mesh;
                });
            }
        }
    ], [
        {
            key: "getInstance",
            value: // Set to false to see all missing model warnings (default: suppressed)
            function getInstance() {
                if (!_ModelManager._instance) {
                    _ModelManager._instance = new _ModelManager();
                }
                return _ModelManager._instance;
            }
        }
    ]);
    return _ModelManager;
}();
_ModelManager._instance = null;
var ModelManager = _ModelManager;
var modelManager = ModelManager.getInstance();
// src/components/3D/utils/resolveMapLocationAndCamera.ts
import { DEFAULT_MAP_ORIGIN, DEFAULT_CAMERA_CONFIG as DEFAULT_CAMERA_CONFIG2 } from "@repo/frontend-types";
// src/components/3D/utils/readCameraStart.ts
import { DEFAULT_CAMERA_CONFIG } from "@repo/frontend-types";
function readCameraStart(raw) {
    var obj = raw;
    if (typeof raw === "string") {
        try {
            obj = JSON.parse(raw);
        } catch (e) {
            return null;
        }
    }
    if (!obj || (typeof obj === "undefined" ? "undefined" : _type_of(obj)) !== "object" || Array.isArray(obj)) return null;
    var record = obj;
    var lat = finite(record.lat);
    var lng = finite(record.lng);
    if (lat === null || lng === null) return null;
    var _finite, _finite1, _finite2;
    return {
        lat: lat,
        lng: lng,
        zoom: (_finite = finite(record.zoom)) !== null && _finite !== void 0 ? _finite : DEFAULT_CAMERA_CONFIG.zoom,
        bearing: (_finite1 = finite(record.bearing)) !== null && _finite1 !== void 0 ? _finite1 : DEFAULT_CAMERA_CONFIG.bearing,
        pitch: (_finite2 = finite(record.pitch)) !== null && _finite2 !== void 0 ? _finite2 : DEFAULT_CAMERA_CONFIG.pitch
    };
}
var finite = function(v) {
    if (typeof v === "number") return Number.isFinite(v) ? v : null;
    if (typeof v === "string" && v.trim() !== "") {
        var n = Number(v);
        return Number.isFinite(n) ? n : null;
    }
    return null;
};
// src/components/3D/utils/resolveMapLocationAndCamera.ts
function resolveMapLocationAndCamera(param) {
    var twin = param.twin, authMetadata = param.authMetadata;
    if (twin) {
        var _twin_adminTwin, _twin_adminTwin1, _twin_physicalModel, _twin_adminTwin2;
        var twinLocation = null;
        if (!isNullOrUndefined((_twin_adminTwin = twin.adminTwin) === null || _twin_adminTwin === void 0 ? void 0 : _twin_adminTwin.latitude) && !isNullOrUndefined((_twin_adminTwin1 = twin.adminTwin) === null || _twin_adminTwin1 === void 0 ? void 0 : _twin_adminTwin1.longitude)) {
            twinLocation = {
                latitude: parseFloat(String(twin.adminTwin.latitude)),
                longitude: parseFloat(String(twin.adminTwin.longitude))
            };
        } else if (((_twin_physicalModel = twin.physicalModel) === null || _twin_physicalModel === void 0 ? void 0 : _twin_physicalModel.mapOrigin) && !isNullOrUndefined(twin.physicalModel.mapOrigin.latitude) && !isNullOrUndefined(twin.physicalModel.mapOrigin.longitude)) {
            twinLocation = {
                latitude: twin.physicalModel.mapOrigin.latitude,
                longitude: twin.physicalModel.mapOrigin.longitude
            };
        }
        var cameraConfig = DEFAULT_CAMERA_CONFIG2;
        var viewLocation = twinLocation;
        var cameraStart = readCameraStart((_twin_adminTwin2 = twin.adminTwin) === null || _twin_adminTwin2 === void 0 ? void 0 : _twin_adminTwin2.camera_start_args);
        if (cameraStart) {
            cameraConfig = {
                zoom: cameraStart.zoom,
                bearing: cameraStart.bearing,
                pitch: cameraStart.pitch
            };
            viewLocation = {
                latitude: cameraStart.lat,
                longitude: cameraStart.lng
            };
        }
        if (viewLocation) {
            return {
                location: viewLocation,
                // Camera view position
                camera: cameraConfig,
                twinLocation: twinLocation || viewLocation
            };
        }
    }
    if (authMetadata && !isNullOrUndefined(authMetadata.orgLatitude) && !isNullOrUndefined(authMetadata.orgLongitude)) {
        var orgLocation = {
            latitude: parseFloat(authMetadata.orgLatitude),
            longitude: parseFloat(authMetadata.orgLongitude)
        };
        return {
            location: orgLocation,
            camera: DEFAULT_CAMERA_CONFIG2,
            twinLocation: orgLocation
        };
    }
    return {
        location: DEFAULT_MAP_ORIGIN,
        camera: DEFAULT_CAMERA_CONFIG2,
        twinLocation: DEFAULT_MAP_ORIGIN
    };
}
function toCameraPosition(resolved) {
    return {
        lat: resolved.location.latitude,
        lng: resolved.location.longitude,
        zoom: resolved.camera.zoom,
        bearing: resolved.camera.bearing,
        pitch: resolved.camera.pitch
    };
}
function toInitialViewState(resolved) {
    return {
        longitude: resolved.location.longitude,
        latitude: resolved.location.latitude,
        zoom: resolved.camera.zoom,
        bearing: resolved.camera.bearing,
        pitch: resolved.camera.pitch
    };
}
// src/components/3D/editing/floorplannerSchema.ts
import { Vector2 as Vector23 } from "three";
// src/components/3D/editing/utils/bid-validators.ts
var ORG_BID = "^[A-Z]{2,5}[A-Z0-9]{0,2}$";
var ORG_BID_REGEX = new RegExp(ORG_BID);
var TWIN_BID_SUFFIX = "[A-Z0-9]{3,5}$";
var TWIN_BID_SUFFIX_REGEX = new RegExp(TWIN_BID_SUFFIX);
var TWIN_BID_REGEX = new RegExp("^".concat(ORG_BID, "-").concat(TWIN_BID_SUFFIX, "$"));
var ENTITY_TYPES = {
    ZONE: "Z",
    SECTION: "S",
    AREA: "A",
    EQUIPMENT: "E"
};
var VALID_ENTITY_TYPES = Object.values(ENTITY_TYPES).join("");
var ENTITY_SUFFIX_BID = "[".concat(VALID_ENTITY_TYPES, "]\\d{3}$");
var ENTITY_SUFFIX_BID_REGEX = new RegExp(ENTITY_SUFFIX_BID);
var ENTITY_BID_REGEX = new RegExp("".concat(TWIN_BID_REGEX.source, "-").concat(ENTITY_SUFFIX_BID, "$"));
var _customNameRegexCache = /* @__PURE__ */ new Map();
var makeCustomNameRegex = function(hierarchyString) {
    var cacheKey = hierarchyString.toLowerCase();
    if (!_customNameRegexCache.has(cacheKey)) {
        _customNameRegexCache.set(cacheKey, new RegExp("^([".concat(hierarchyString, "][0-9]{3})[ ]*(?:,[ ]*([^,]*)[ ]*)?(?:,[ ]*([0-9]*)[ ]*)?(?:,[ ]*([01])[ ]*)?(?:,[ ]*([").concat(hierarchyString, "][0-9]{3})[ ]*)?$"), "i"));
    }
    return _customNameRegexCache.get(cacheKey);
};
var expandHierarchyString = function(hierarchyString) {
    return hierarchyString.split("").map(function(x) {
        return x.toUpperCase();
    }).join("/");
};
var parseCustomName = function(customName, hierarchyString) {
    var errors = [];
    var customNameRegex = makeCustomNameRegex(hierarchyString);
    var match = customNameRegex.exec(customName);
    if (!match) {
        return {
            errors: [
                {
                    message: "Invalid custom name format: '".concat(customName, "'.\n\n  Custom name should be: [code],[name?],[capacity?],[track?],[parentID?] where:\n  - code is a letter (").concat(expandHierarchyString(hierarchyString), ") followed by 3 digits (required)\n  - name is text without commas or hyphens (optional, defaults to entity code)\n  - capacity is a number (optional)\n  - track is 0 or 1 (optional)\n  - parentID matches another entity's code (optional)\n  \n  EntityCode is mandatory while other components are optional as the can be edited in the Google sheet."),
                    value: customName
                }
            ]
        };
    }
    var _match = _sliced_to_array(match, 6), rawEntityCode = _match[1], rawName = _match[2], rawCapacityStr = _match[3], rawTrackStr = _match[4], rawParentId = _match[5];
    var entityCode = (rawEntityCode === null || rawEntityCode === void 0 ? void 0 : rawEntityCode.trim()) || "";
    var name = (rawName === null || rawName === void 0 ? void 0 : rawName.trim()) || entityCode;
    var capacityStr = (rawCapacityStr === null || rawCapacityStr === void 0 ? void 0 : rawCapacityStr.trim()) || null;
    var trackStr = (rawTrackStr === null || rawTrackStr === void 0 ? void 0 : rawTrackStr.trim()) || null;
    var parentId = (rawParentId === null || rawParentId === void 0 ? void 0 : rawParentId.trim()) || null;
    if (!entityCode) {
        return {
            errors: [
                {
                    message: "Entity code is required",
                    value: customName
                }
            ]
        };
    }
    var capacity = capacityStr ? parseInt(capacityStr, 10) : 1;
    var track = trackStr === "0" ? false : true;
    var entityType = entityCode.charAt(0).toUpperCase();
    var parentType = parentId ? parentId.charAt(0).toUpperCase() : null;
    var entityIndex = VALID_ENTITY_TYPES.indexOf(entityType);
    var expectedParentCheck = entityType !== "E";
    if (expectedParentCheck) {
        var expectedParentType = entityType === "E" ? void 0 : entityIndex > 0 ? VALID_ENTITY_TYPES.charAt(entityIndex - 1) : void 0;
        if (expectedParentType === void 0 && parentId) {
            errors.push({
                message: "".concat(entityType, "-type entities should not have a parent ID"),
                value: customName
            });
        } else if (expectedParentType !== void 0 && !parentId) {
            errors.push({
                message: "".concat(entityType, "-type entities must have a parent ID starting with '").concat(expectedParentType, "'"),
                value: customName
            });
        } else if (parentId && expectedParentType !== parentType) {
            errors.push({
                message: "Invalid parent type for ".concat(entityType, "-type entity. Expected parent type: ").concat(expectedParentType),
                value: customName
            });
        }
    }
    if (errors.length > 0) {
        return {
            errors: errors
        };
    }
    return {
        entityCode: entityCode,
        name: name,
        capacity: capacity,
        track: track,
        parentID: parentId
    };
};
// src/components/3D/editing/floorplannerSchema.ts
function findLatestDesign(designs) {
    var _designs_find;
    return (_designs_find = designs.find(function(design) {
        return design.name.toLowerCase().includes("current");
    })) !== null && _designs_find !== void 0 ? _designs_find : designs[0];
}
var formatParsedCustomNameData = function(data) {
    var entityCode = data.entityCode, name = data.name, capacity = data.capacity, track = data.track, parentID = data.parentID;
    return {
        message: "".concat(entityCode, "-").concat(name, "-").concat(capacity, "-").concat(track, "-").concat(parentID)
    };
};
var formatCustomNameParsingError = function(error) {
    var message = error.message, value = error.value;
    return "".concat(message, ": ").concat(value);
};
var formatDuplicateIdError = function(error) {
    var _error_entityInfo = _sliced_to_array(error.entityInfo, 2), one = _error_entityInfo[0], two = _error_entityInfo[1];
    return "Duplicate ID: ".concat(error.id, "\n\nshared by:\n").concat(formatParsedCustomNameData(one), "\nand\n").concat(formatParsedCustomNameData(two), "\n");
};
var formatFmlValidationErrors = function(errors) {
    var formattedErrors = errors.reduce(function(acc, error, i) {
        if ("id" in error) {
            acc.push("(".concat(i + 1, ")\n").concat(formatDuplicateIdError(error)));
        } else {
            acc.push("(".concat(i + 1, ")\n").concat(formatCustomNameParsingError(error)));
        }
        return acc;
    }, []);
    return formattedErrors.join("\n\n".concat("=".repeat(58), "\n\n"));
};
function isValidResult(validationResult) {
    return !("errors" in (validationResult || {}));
}
var ERROR_MESSAGES = {
    AREA_MISSING_NAME: "Area missing Name data",
    EQUIPMENT_MISSING_NAME: "Equipment/Asset missing Name data",
    NON_EXISTENT_PARENT: "Area references non-existent parent area",
    A_WITH_Z_PARENT: "'A' type area cannot have 'Z' type area as parent",
    BID_MISMATCH: "Fml name"
};
var isEmptyOrWhitespace = function(value) {
    return value === null || value === void 0 || value.trim() === "";
};
var formatErrorValueWithRefid = function(floorName, refid, entityType, exampleFormat) {
    var refidInfo = refid ? ' with refid "'.concat(refid, '"') : "";
    var entityDescription = entityType === "Area" ? "Area (surface)" : "Equipment (item)";
    var customNameField = entityType === "Area" ? "customName" : "name";
    return "".concat(entityDescription, ' at floor "').concat(floorName, '"').concat(refidInfo, " has no ").concat(customNameField, ". ").concat(entityType, ' must have a name starting with a CODE (entity code is mandatory). Format: [CODE],[Name?],[capacity?],[track?],[parentID?]. Only CODE is required. Example: "').concat(exampleFormat, '"');
};
var processEntityName = function(nameSource, floorName, hierarchyString, entityType, exampleFormat) {
    var nameValue = nameSource.name;
    if (nameValue === void 0 || nameValue === null) {
        return {
            errors: [],
            entityData: null
        };
    }
    if (isEmptyOrWhitespace(nameValue)) {
        return {
            errors: [
                {
                    message: entityType === "Area" ? ERROR_MESSAGES.AREA_MISSING_NAME : ERROR_MESSAGES.EQUIPMENT_MISSING_NAME,
                    value: formatErrorValueWithRefid(floorName, nameSource.refid, entityType, exampleFormat)
                }
            ],
            entityData: null
        };
    }
    var result = parseCustomName(nameValue, hierarchyString);
    if ("errors" in result) {
        return {
            errors: result.errors,
            entityData: null
        };
    }
    return {
        errors: [],
        entityData: result
    };
};
var getEntityType = function(entityCode) {
    return entityCode.charAt(0).toUpperCase();
};
var findDuplicateEntityCodes = function(entities) {
    var entityMap = /* @__PURE__ */ new Map();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var entity = _step.value;
            var codeKey = entity.entityCode.toUpperCase();
            var existing = entityMap.get(codeKey) || [];
            existing.push(entity);
            entityMap.set(codeKey, existing);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var duplicateErrors = [];
    entityMap.forEach(function(entityList, code) {
        if (entityList.length > 1) {
            duplicateErrors.push({
                id: code,
                entityInfo: [
                    entityList[0],
                    entityList[1]
                ]
            });
        }
    });
    return duplicateErrors;
};
var validateFML = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(rawFML, hierarchyString, expected) {
        var _errors, errors, customEntityInfo, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, floorData, floorLayout, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, surfaceData, _errors1, _processEntityName, surfaceErrors, entityData, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, itemData, _errors2, _processEntityName1, itemErrors, entityData1, entityCodeMap, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, entity, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, entity1, parentCode, parentEntity, entityType, parentType, duplicateErrors;
        return _ts_generator(this, function(_state) {
            errors = [];
            customEntityInfo = [];
            if (expected && expected.bID !== rawFML.name) {
                errors.push({
                    message: "".concat(ERROR_MESSAGES.BID_MISMATCH, " ('").concat(rawFML.name, "')"),
                    value: "does not match expected bID ('".concat(expected.bID, "')")
                });
            }
            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(_iterator = rawFML.floors[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    floorData = _step.value;
                    floorLayout = findLatestDesign(floorData.designs);
                    _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(_iterator1 = floorLayout.surfaces[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            surfaceData = _step1.value;
                            ;
                            _processEntityName = processEntityName({
                                name: surfaceData.customName,
                                refid: surfaceData.refid
                            }, floorData.name, hierarchyString, "Area", "A001,Workout Area,10,1,S002"), surfaceErrors = _processEntityName.errors, entityData = _processEntityName.entityData;
                            (_errors1 = errors).push.apply(_errors1, _to_consumable_array(surfaceErrors));
                            if (entityData) {
                                customEntityInfo.push(entityData);
                            }
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                    try {
                        for(_iterator2 = floorLayout.items[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                            itemData = _step2.value;
                            ;
                            _processEntityName1 = processEntityName({
                                name: itemData.name,
                                refid: itemData.refid
                            }, floorData.name, hierarchyString, "Equipment", "E001,Treadmill 1,1,1,A003"), itemErrors = _processEntityName1.errors, entityData1 = _processEntityName1.entityData;
                            (_errors2 = errors).push.apply(_errors2, _to_consumable_array(itemErrors));
                            if (entityData1) {
                                customEntityInfo.push(entityData1);
                            }
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                _iterator2.return();
                            }
                        } finally{
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            entityCodeMap = /* @__PURE__ */ new Map();
            _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
            try {
                for(_iterator3 = customEntityInfo[Symbol.iterator](); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                    entity = _step3.value;
                    entityCodeMap.set(entity.entityCode.toUpperCase(), entity);
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                        _iterator3.return();
                    }
                } finally{
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }
            _iteratorNormalCompletion4 = true, _didIteratorError4 = false, _iteratorError4 = undefined;
            try {
                for(_iterator4 = customEntityInfo[Symbol.iterator](); !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true){
                    entity1 = _step4.value;
                    if (!entity1.parentID) {
                        continue;
                    }
                    parentCode = entity1.parentID.toUpperCase();
                    parentEntity = entityCodeMap.get(parentCode);
                    if (!parentEntity) {
                        errors.push({
                            message: ERROR_MESSAGES.NON_EXISTENT_PARENT,
                            value: 'Entity "'.concat(entity1.entityCode, '" (').concat(entity1.name, ') references parent "').concat(entity1.parentID, '" which does not exist in the FML file. Please ensure the parent entity "').concat(entity1.parentID, '" is defined with a matching entity code.')
                        });
                        continue;
                    }
                    entityType = getEntityType(entity1.entityCode);
                    parentType = getEntityType(parentEntity.entityCode);
                    if (entityType === "A" && parentType === "Z") {
                        errors.push({
                            message: ERROR_MESSAGES.A_WITH_Z_PARENT,
                            value: 'Entity "'.concat(entity1.entityCode, '" (').concat(entity1.name, ') is an Area type but has Zone type parent "').concat(parentEntity.entityCode, '" (').concat(parentEntity.name, "). Areas must have Section type (S) parents, not Zone type (Z).")
                        });
                    }
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                        _iterator4.return();
                    }
                } finally{
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }
            duplicateErrors = findDuplicateEntityCodes(customEntityInfo);
            (_errors = errors).push.apply(_errors, _to_consumable_array(duplicateErrors));
            return [
                2,
                errors.length > 0 ? {
                    errors: errors
                } : rawFML
            ];
        });
    });
    return function validateFML(rawFML, hierarchyString, expected) {
        return _ref.apply(this, arguments);
    };
}();
function splitWall(wall) {
    var doors = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = wall.openings[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var opening = _step.value;
            if (opening.type === "door") {
                doors.push(opening);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (doors.length === 0) {
        return [
            wall
        ];
    } else {
        var splits = [];
        var currentSplitStart = wall.a;
        var wallVector = new Vector23().subVectors(wall.b, wall.a);
        var wallLength = wallVector.length();
        doors.sort(function(a, b) {
            return a.t - b.t;
        });
        var wallStart = new Vector23(wall.a.x, wall.a.y);
        var wallEnd = new Vector23(wall.b.x, wall.b.y);
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = doors[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var door = _step1.value;
                var doorWidthWallPercentage = door.width / wallLength;
                var doorStartWallPercentage = door.t - doorWidthWallPercentage / 2;
                var doorStartPosition = wallStart.clone().lerp(wallEnd, doorStartWallPercentage);
                var split = {
                    a: currentSplitStart,
                    b: doorStartPosition,
                    thickness: wall.thickness,
                    openings: []
                };
                splits.push(split);
                var doorEndWallPercentage = door.t + doorWidthWallPercentage / 2;
                var doorEndPosition = wallStart.clone().lerp(wallEnd, doorEndWallPercentage);
                currentSplitStart = doorEndPosition;
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        var finalSplit = {
            a: currentSplitStart,
            b: wall.b,
            thickness: wall.thickness,
            openings: []
        };
        splits.push(finalSplit);
        return splits;
    }
}
// src/components/3D/editing/FloorplannerConverter.ts
import { floorElevationM } from "@repo/front-end-utils";
import { Vector2 as Vector25 } from "three";
// src/components/3D/editing/utils/updateProgressFactory.ts
var updateProgressFactory = function(progressCallback) {
    var progressInfo = {
        completed: 0,
        total: 0,
        messages: []
    };
    var updateProgress = function(updater) {
        updater(progressInfo);
        progressCallback === null || progressCallback === void 0 ? void 0 : progressCallback(progressInfo);
    };
    return updateProgress;
};
// src/components/3D/editing/utils/geometry.ts
import { Vector2 as Vector24 } from "three";
function cmToKm(centimeters) {
    return centimeters / 1e5;
}
function getPerpendicular(vector) {
    var isZero = vector.x === 0 || vector.x === -0;
    return new Vector24(vector.y, isZero ? vector.x : -vector.x);
}
// src/components/3D/editing/ReportService.ts
var ReportService = /*#__PURE__*/ function() {
    "use strict";
    function ReportService() {
        _class_call_check(this, ReportService);
        this.formatNewAssetReportItem = function(item) {
            var fullName = item.fullName, model = item.model;
            var suggestion = item.suggestedModelMatch;
            var _suggestion_confidence, _suggestion_description;
            var suggestionBlock = suggestion ? "Suggestion:\n        File name: ".concat(suggestion.fileName, "\n        Confidence: ").concat((_suggestion_confidence = suggestion.confidence) !== null && _suggestion_confidence !== void 0 ? _suggestion_confidence : "", "\n        Description: ").concat((_suggestion_description = suggestion.description) !== null && _suggestion_description !== void 0 ? _suggestion_description : "", "\n") : "Suggestion: \n";
            return "\n    Full name: ".concat(fullName, "\n        Model: ").concat(model, "\n").concat(suggestionBlock);
        };
        this.formatFoundAssetReportItem = function(item) {
            var fullName = item.fullName, model = item.model;
            return "\nFull name: ".concat(fullName, "\n    Model: ").concat(model, "\n");
        };
        this.formatAssetReportCollection = function(collection, formatter) {
            return Object.entries(collection).map(function(param, i) {
                var _param = _sliced_to_array(param, 2), k = _param[0], v = _param[1];
                return "\n(".concat(i + 1, ") ").concat(k, "\n").concat(formatter(v));
            }).join("\n".concat("-".repeat(58), "\n"));
        };
    }
    _create_class(ReportService, [
        {
            /**
   * Generate a complete parsed inventory report
   */ key: "generateReport",
            value: function generateReport(site, allEntities, productsList, itemRefids) {
                var refidToBid = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
                var sortedEntities = _to_consumable_array(allEntities).sort(function(a, b) {
                    return a.name.localeCompare(b.name);
                });
                var assetReport = this.categorizeAssets(itemRefids, productsList);
                return {
                    twin: site,
                    entities: sortedEntities,
                    refidToBid: refidToBid,
                    assetReport: assetReport
                };
            }
        },
        {
            /**
   * Categorize assets into new and found assets
   */ key: "categorizeAssets",
            value: function categorizeAssets(itemRefids, productsList) {
                var newAssets = {};
                var foundAssets = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Array.from(itemRefids)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var refid = _step.value;
                        var lookupValue = productsList[refid];
                        if (lookupValue === void 0) {
                            newAssets[refid] = {
                                model: "none",
                                fullName: "none"
                            };
                        } else if (lookupValue.isNew || !lookupValue.model) {
                            newAssets[refid] = lookupValue;
                        } else {
                            foundAssets[refid] = lookupValue;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    newAssets: newAssets,
                    foundAssets: foundAssets
                };
            }
        },
        {
            /**
   * Format asset report for display/export
   */ key: "formatAssetReport",
            value: function formatAssetReport(assetReport) {
                var newAssets = assetReport.newAssets, foundAssets = assetReport.foundAssets;
                var newAssetsSection = "";
                if (Object.keys(newAssets).length !== 0) {
                    newAssetsSection = "Assets without a model (need to be added to lookup table):\n=============================================\n".concat(this.formatAssetReportCollection(newAssets, this.formatNewAssetReportItem), "\n    \n");
                }
                return "".concat(newAssetsSection, "Assets with existing model (already in the lookup table):\n=============================================\n").concat(this.formatAssetReportCollection(foundAssets, this.formatFoundAssetReportItem), "\n");
            }
        }
    ]);
    return ReportService;
}();
// src/components/3D/editing/utils/getAreaMembership.ts
function pointInPolygon(point, polygon) {
    var maxIndex = polygon.length - 1;
    var x = point.x, y = point.y;
    var inside = false;
    polygon.forEach(function(vertex1, i) {
        var vertex2 = i < maxIndex ? polygon[i + 1] : polygon[0];
        if (y > Math.min(vertex1.y, vertex2.y)) {
            if (y <= Math.max(vertex1.y, vertex2.y)) {
                if (x <= Math.max(vertex1.x, vertex2.x)) {
                    var xIntersection = (y - vertex1.y) * (vertex2.x - vertex1.x) / (vertex2.x - vertex1.y) + vertex1.x;
                    if (vertex1.x === vertex2.x || x <= xIntersection) {
                        inside = !inside;
                    }
                }
            }
        }
    });
    return inside;
}
var regexLevel2BidExtractor = /^.*-([^-]+)$/;
var extractTrailingBidType = function(bid) {
    var match = bid.match(regexLevel2BidExtractor);
    if (!match) {
        throw new Error("Invalid bid: ".concat(bid));
    }
    var trailingBid = match[1];
    return trailingBid[0];
};
var findParentPolgyons = function(point, candidates, containerHierarchy) {
    var matches = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = candidates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var candidate = _step.value;
            if (pointInPolygon(point, candidate.points)) {
                matches.push(candidate.id);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    matches.sort(function(a, b) {
        var aBid = extractTrailingBidType(a);
        var bBid = extractTrailingBidType(b);
        if (!aBid || !bBid || aBid === bBid) {
            return 0;
        }
        var aIndex = containerHierarchy.indexOf(aBid);
        var bIndex = containerHierarchy.indexOf(bBid);
        return bIndex - aIndex;
    });
    return matches;
};
// src/components/3D/editing/HierarchyService.ts
var HierarchyService = /*#__PURE__*/ function() {
    "use strict";
    function HierarchyService() {
        _class_call_check(this, HierarchyService);
    }
    _create_class(HierarchyService, [
        {
            /**
   * Build hierarchy from flat list of entities using lookup map
   */ key: "buildHierarchy",
            value: function buildHierarchy(twinEntities, lookupMap) {
                var topLevelEntities = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = twinEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var entity = _step.value;
                        var _lookupMap_get;
                        var parentBid = (_lookupMap_get = lookupMap.get(entity.bID)) === null || _lookupMap_get === void 0 ? void 0 : _lookupMap_get.parentID;
                        if (parentBid) {
                            var parent = lookupMap.get(parentBid).entity;
                            parent.children.push(entity);
                        } else {
                            topLevelEntities.push(entity);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return topLevelEntities;
            }
        },
        {
            /**
   * Populate depth information for hierarchical entities
   */ key: "populateDepthFromHierarchy",
            value: function populateDepthFromHierarchy(flatLookup, areaHierarchy, currentDepth) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = areaHierarchy[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var entity = _step.value;
                        var addEntityWaitingForDepth = flatLookup.get(entity.bID);
                        if (addEntityWaitingForDepth) {
                            addEntityWaitingForDepth.depth = currentDepth;
                        }
                        if (entity.children) {
                            this.populateDepthFromHierarchy(flatLookup, entity.children, currentDepth + 1);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
   * Place an asset in the correct position within the entity hierarchy
   */ key: "placeAssetInHierarchy",
            value: function placeAssetInHierarchy(asset, assetEntityData, areaPolygons, areaEntitiesMap, children, basicPoint, prefixedTwinBid, allEntities) {
                if (assetEntityData.parentID) {
                    this.placeAssetWithExplicitParent(asset, assetEntityData.parentID, areaEntitiesMap, prefixedTwinBid, allEntities);
                } else {
                    this.placeAssetByPosition(asset, basicPoint, areaPolygons, areaEntitiesMap, children, allEntities);
                }
            }
        },
        {
            /**
   * Place asset with explicitly specified parent
   */ key: "placeAssetWithExplicitParent",
            value: function placeAssetWithExplicitParent(asset, parentID, areaEntitiesMap, prefixedTwinBid, allEntities) {
                var parentBid = "".concat(prefixedTwinBid, "-").concat(parentID);
                var parentEntity = areaEntitiesMap.get(parentBid);
                if (parentEntity) {
                    parentEntity.entity.children.push(asset);
                    allEntities.push(asset);
                } else {
                    console.warn("Parent entity with ID ".concat(parentBid, " not found for asset ").concat(asset.bID));
                    allEntities.push(asset);
                }
            }
        },
        {
            /**
   * Place asset based on spatial position within area polygons
   */ key: "placeAssetByPosition",
            value: function placeAssetByPosition(asset, basicPoint, areaPolygons, areaEntitiesMap, children, allEntities) {
                var parentBids = findParentPolgyons(basicPoint, areaPolygons, "ZSA");
                if (parentBids && parentBids.length > 0) {
                    var deepestParent = areaEntitiesMap.get(parentBids[0]);
                    if (deepestParent) {
                        deepestParent.entity.children.push(asset);
                        allEntities.push(asset);
                    } else {
                        children.push(asset);
                        allEntities.push(asset);
                    }
                } else {
                    children.push(asset);
                    allEntities.push(asset);
                }
            }
        },
        {
            /**
   * Calculate total capacity for a site based on top-level areas
   */ key: "calculateSiteCapacity",
            value: function calculateSiteCapacity(topLevelAreas) {
                var totalCapacity = 0;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = topLevelAreas[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var area = _step.value;
                        if (area.capacity) {
                            totalCapacity += area.capacity;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return totalCapacity;
            }
        }
    ]);
    return HierarchyService;
}();
// src/components/3D/editing/EntityFactoryService.ts
import { normaliseAssetUid } from "@repo/frontend-types";
import { floorLaunchBid, isEntityCapacity } from "@repo/front-end-utils";
// src/components/3D/editing/base64Definitions.ts
var encodeBase64Json = function(value) {
    var json2 = JSON.stringify(value);
    var binary = encodeURIComponent(json2).replace(/%([0-9A-Fa-f]{2})/g, function(_, hex) {
        return String.fromCharCode(parseInt(hex, 16));
    });
    return btoa(binary);
};
var decodeBase64Json = function(raw) {
    var binary = atob(raw);
    var percent = "";
    for(var i = 0; i < binary.length; i += 1){
        var hex = binary.charCodeAt(i).toString(16);
        percent += "%" + (hex.length === 1 ? "0" + hex : hex);
    }
    return JSON.parse(decodeURIComponent(percent));
};
// src/components/3D/editing/EntityFactoryService.ts
var siteType = {
    name: "site"
};
var floorType = {
    name: "floor"
};
var areaType = {
    name: "area"
};
var wallType = {
    name: "wall"
};
var assetType = {
    name: "asset"
};
var normaliseRotationDeg = function(deg) {
    return (deg % 360 + 360) % 360;
};
var EntityFactoryService = /*#__PURE__*/ function() {
    "use strict";
    function EntityFactoryService() {
        _class_call_check(this, EntityFactoryService);
    }
    _create_class(EntityFactoryService, [
        {
            /**
   * Create coordinate point for entity location
   */ key: "createCoordLocalPoint",
            value: function createCoordLocalPoint(cmPoint) {
                return {
                    latitude: cmToKm(cmPoint.x) * 10,
                    longitude: cmToKm(cmPoint.y) * 10
                };
            }
        },
        {
            /**
   * Create boundary from points for polygon entities
   */ key: "boundaryFromPoints",
            value: function boundaryFromPoints(points) {
                return {
                    polygons: [
                        {
                            coordinates: [
                                {
                                    points: points
                                }
                            ]
                        }
                    ]
                };
            }
        },
        {
            /**
   * Close polygon by adding first point to end
   */ key: "close",
            value: function close(list) {
                var newList = _to_consumable_array(list);
                newList.push(list[0]);
                return newList;
            }
        },
        {
            /**
   * Helper function to encode entity definitions as Base64 JSON.
   *
   * UTF-8-safe (see `encodeBase64Json`): a raw `btoa` threw on any name/notes value containing a
   * character outside Latin1 (em-dash, curly quote, accent, £, …), which broke Go Live conversion.
   */ key: "encodeDefinitions",
            value: function encodeDefinitions(definitions) {
                return encodeBase64Json(definitions);
            }
        },
        {
            /**
   * Create a site entity (root entity)
   */ key: "createSite",
            value: function createSite(siteName, mapOrigin, prefixedTwinBid) {
                return {
                    name: siteName,
                    type: siteType,
                    // @ts-ignore TODO get the import of the CoordinateSystem enum to work
                    coordinateSystem: "COORD_LOCAL",
                    mapOrigin: mapOrigin,
                    bID: prefixedTwinBid,
                    altitude: 10
                };
            }
        },
        {
            /**
   * Create a floor entity.
   *
   * `altitude` is metres above the twin's ground, written unchanged. The caller works it out with
   * `floorElevationM` (`@repo/front-end-utils`), the one place a floor's height is decided.
   */ key: "createFloor",
            value: function createFloor(floorName, altitude, prefixedTwinBid, floorId, placement, capacity) {
                var bID = floorId != null ? // The same function the Floor pop-up shows the BID with, so the two cannot disagree.
                floorLaunchBid(prefixedTwinBid, floorId) : "".concat(prefixedTwinBid, "-").concat(floorName);
                return _object_spread({
                    bID: bID,
                    name: floorName,
                    type: floorType,
                    altitude: altitude
                }, placement ? {
                    location: this.createCoordLocalPoint(placement.origin),
                    rotationY: normaliseRotationDeg(placement.rotation)
                } : {}, isEntityCapacity(capacity) ? {
                    capacity: capacity
                } : {});
            }
        },
        {
            /**
   * Create an area entity from surface data.
   *
   * ⚠ **`entityBID` is the entity's FULL BID, composed by the CALLER** — this method does not
   * prepend the twin BID, and must not be changed to (ruling R18, 2026-09-02).
   *
   * The composition moved out here because this factory serves two paths whose rules genuinely
   * differ, and neither can be expressed by the other:
   *
   *  - `PlannerConverter` reads a STORED identity that is itself the full BID, and passes it
   *    through unchanged. Prepending the twin BID here would mint `NPL-STN-NPL-STN-Z004` — a
   *    brand-new BID for an asset that already has one, on every entity of every plan.
   *  - `FloorplannerConverter` reads a SHORT code out of an FML `customName` and composes
   *    `<prefixedTwinBid>-<code>` itself. Passing that code straight through here would mint `Z004`
   *    with no twin in it at all.
   *
   * So the rule belongs to whoever knows where the value came from. `createSite`, `createFloor` and
   * `createWall` still take `prefixedTwinBid`, because their BIDs carry no entity code.
   *
   * ⚠ **`floorplannerRefid` is OPT-IN, and only the FML importer passes it** (`plan-entity-identity`,
   * FR10).
   *
   * The planner used to pass its surface's own plan identity here and it was written to
   * `definitions.floorplanner_refid` — a plan identity in a Floorplanner-named field, and never a
   * Floorplanner ID at all (measured on staging plan 11: `group-1784649505779`). That write is gone
   * for the planner.
   *
   * ⚠ **But it must NOT be gone for FML, and an earlier attempt at this spec removed it for both.**
   * On the FML path the value is the imported surface's real Floorplanner refid, and the Google
   * Sheets enrichment reads exactly this field to fill its `floorplanner_id` column
   * (`data-transformation.service.ts`). Deleting it unconditionally silently blanked that column for
   * every FML-imported twin — a spec that puts the FML path hard out of scope, changing it. A review
   * of this spec caught it. Opt-in keeps FR10's outcome (the planner stops writing an identity into
   * a reference field) without touching the path that is out of scope.
   */ key: "createArea",
            value: function createArea(areaEntityData, surfacePoints, entityBID, floorplannerRefid) {
                var _this = this;
                var dbFormatPoints = surfacePoints.map(function(point) {
                    return _this.createCoordLocalPoint(point);
                });
                var closedPoints = this.close(dbFormatPoints);
                var centre;
                try {
                    centre = getPolygonCentroid(closedPoints);
                } catch (error) {
                    console.error("Failed to calculate centroid for area", areaEntityData.name, error);
                    if (dbFormatPoints.length > 0) {
                        centre = dbFormatPoints[0];
                    } else {
                        throw new Error("Cannot create area ".concat(areaEntityData.name, ": no points provided"));
                    }
                }
                return _object_spread_props(_object_spread({
                    type: areaType,
                    bID: entityBID,
                    name: areaEntityData.name
                }, isEntityCapacity(areaEntityData.capacity) ? {
                    capacity: areaEntityData.capacity
                } : {}), {
                    tracked: areaEntityData.track,
                    geoType: {
                        name: "polygon"
                    },
                    children: [],
                    // make sure it has children, so we can append to them safely
                    boundaries: this.boundaryFromPoints(closedPoints),
                    centre: centre,
                    /*
       * `floorplanner_refid` **only when a caller supplies a real one** (`plan-entity-identity`,
       * FR10) — see the parameter above.
       *
       * The planner passes nothing, so its surface's plan identity is no longer written into a
       * Floorplanner-named field; the identity is on `bID`, where it belongs. FML passes its
       * imported refid, which is a genuine Floorplanner ID and is what the Google Sheets enrichment
       * reads.
       *
       * Spread conditionally rather than written as `undefined`: `encodeDefinitions` JSON-encodes
       * this object, and `JSON.stringify` drops an undefined value — so the two are equivalent on
       * the wire, and the explicit spread says the absence is intended rather than accidental.
       */ definitions: this.encodeDefinitions(_object_spread({
                        floorplanner_full_name: areaEntityData.name,
                        import_timestamp: /* @__PURE__ */ new Date().toISOString()
                    }, floorplannerRefid ? {
                        floorplanner_refid: floorplannerRefid
                    } : {}))
                });
            }
        },
        {
            /**
   * Create a wall entity from geometry points
   */ key: "createWall",
            value: function createWall(wallPoints, wallCounter, prefixedTwinBid, floorName, definitions) {
                var _this = this;
                var dbFormatPoints = wallPoints.map(function(point) {
                    return _this.createCoordLocalPoint(point);
                });
                var wallBID = "".concat(prefixedTwinBid, "-").concat(floorName, "-wall-").concat(wallCounter);
                return _object_spread({
                    type: wallType,
                    bID: wallBID,
                    name: wallBID,
                    geoType: {
                        name: "polygon"
                    },
                    boundaries: this.boundaryFromPoints(dbFormatPoints)
                }, definitions ? {
                    definitions: this.encodeDefinitions(definitions)
                } : {});
            }
        },
        {
            /**
   * Create an asset entity.
   *
   * ⚠ **`entityBID` is the entity's FULL BID, composed by the CALLER** — see `createArea` above for
   * why this method must not prepend the twin BID (ruling R18, 2026-09-02).
   */ key: "createAsset",
            value: function createAsset(assetData, assetEntityData, assetDetails, finalModelFile, entityBID, floorplannerRefid, equipmentId, importedAt) {
                var basicPoint = {
                    x: assetData.x,
                    y: assetData.y
                };
                var definitionsData = {
                    full_name: assetDetails.fullName,
                    import_timestamp: (importedAt !== null && importedAt !== void 0 ? importedAt : /* @__PURE__ */ new Date()).toISOString(),
                    original_rotation: assetData.rotation,
                    // Store original FML rotation
                    // legacy fields:
                    floorplanner_full_name: assetDetails.fullName,
                    floorplanner_original_rotation: assetData.rotation
                };
                if (assetData.mirrored && Array.isArray(assetData.mirrored)) {
                    definitionsData.mirrored = assetData.mirrored;
                    definitionsData.floorplanner_mirrored = assetData.mirrored;
                }
                if (floorplannerRefid) {
                    definitionsData.floorplanner_refid = floorplannerRefid;
                }
                var assetUid = normaliseAssetUid(assetData.assetUid);
                if (assetUid) {
                    definitionsData.asset_uid = assetUid;
                }
                var catalogueReference = equipmentId === null || equipmentId === void 0 ? void 0 : equipmentId.trim();
                if (catalogueReference) {
                    definitionsData.equipment_id = catalogueReference;
                }
                var _assetData_rotation;
                return _object_spread_props(_object_spread({
                    type: assetType,
                    modelFile: finalModelFile || void 0,
                    // Convert null to undefined for proper handling
                    altitude: assetData["z"],
                    location: this.createCoordLocalPoint(basicPoint),
                    rotationY: normaliseRotationDeg((_assetData_rotation = assetData.rotation) !== null && _assetData_rotation !== void 0 ? _assetData_rotation : 0),
                    bID: entityBID,
                    name: assetEntityData.name,
                    tracked: assetEntityData.track,
                    geoType: {
                        name: "point"
                    }
                }, isEntityCapacity(assetEntityData.capacity) ? {
                    capacity: assetEntityData.capacity
                } : {}), {
                    // Mirroring, rotation and the register back-reference, Base64-encoded JSON for later
                    // retrieval. **No `refid`, and no `floorplanner_refid` unless a caller passed a real one** —
                    // see `DefinitionsData` above: the identity is on `bID`, and writing it here as well put it
                    // into a manufacturer-named and a Floorplanner-named field that are not identity fields. What
                    // the planner fed the Google Sheets service was never a Floorplanner ID; what FML feeds it is,
                    // which is why that one write survives behind an explicit argument.
                    definitions: this.encodeDefinitions(definitionsData)
                });
            }
        },
        {
            /**
   * Create area polygon data for spatial calculations
   */ key: "createAreaPolygon",
            value: function createAreaPolygon(area, basicPoints) {
                return {
                    id: area.bID,
                    points: basicPoints
                };
            }
        },
        {
            /**
   * Create entity lookup data for hierarchy building
   */ key: "createEntityLookupData",
            value: function createEntityLookupData(area, parentId) {
                return {
                    parentID: parentId,
                    entity: area,
                    // note this is a placeholder, it is only accurate once populated
                    depth: 0
                };
            }
        },
        {
            /**
   * Initialize an entity with children array if needed
   */ key: "ensureEntityHasChildren",
            value: function ensureEntityHasChildren(entity) {
                if (!entity.children) {
                    entity.children = [];
                }
            }
        }
    ]);
    return EntityFactoryService;
}();
// src/components/3D/editing/FloorplannerConverter.ts
var close = function(list) {
    var newList = _to_consumable_array(list);
    newList.push(list[0]);
    return newList;
};
var constructWallGeometry = function(inputWall) {
    var thickness = inputWall.thickness;
    var start = inputWall.a;
    var end = inputWall.b;
    var vector = new Vector25().subVectors(end, start);
    var thicknessOffset = getPerpendicular(vector).normalize().multiplyScalar(thickness / 2);
    var thicknessOffsetOtherSide = thicknessOffset.clone().negate();
    var points = [
        new Vector25().addVectors(start, thicknessOffset),
        new Vector25().addVectors(end, thicknessOffset),
        new Vector25().addVectors(end, thicknessOffsetOtherSide),
        new Vector25().addVectors(start, thicknessOffsetOtherSide)
    ];
    return close(points);
};
var FloorplannerConverter = function FloorplannerConverter(fml, siteName, twinBID, mapOrigin, orgBID) {
    "use strict";
    var _this = this;
    var prefixBid = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false, hierarchyString = arguments.length > 6 ? arguments[6] : void 0, progressCallback = arguments.length > 7 ? arguments[7] : void 0;
    _class_call_check(this, FloorplannerConverter);
    var _this1 = this;
    this.fml = fml;
    this.siteName = siteName;
    this.twinBID = twinBID;
    this.mapOrigin = mapOrigin;
    this.orgBID = orgBID;
    this.prefixBid = prefixBid;
    this.allEntities = [];
    this.prefixedTwinBid = "";
    this.hierarchyString = "";
    this.convert = /*#__PURE__*/ _async_to_generator(function() {
        var site, _ref, floors, itemRefids;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    site = _this1.entityFactory.createSite(_this1.siteName, _this1.mapOrigin, _this1.prefixedTwinBid);
                    _this1.allEntities.push(site);
                    return [
                        4,
                        _this1.processFloors()
                    ];
                case 1:
                    _ref = _state.sent(), floors = _ref.floors, itemRefids = _ref.itemRefids;
                    if (floors.length > 1) {
                        site.children = floors;
                    } else {
                        site.children = floors[0].children;
                    }
                    return [
                        2,
                        _this1.generateReport(site, itemRefids)
                    ];
            }
        });
    });
    this.processFloors = /*#__PURE__*/ _async_to_generator(function() {
        var floorsData, multiFloor, floors, itemRefids, allTopLevelAreasForSite, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step, err, site;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    floorsData = _this1.fml.floors;
                    multiFloor = floorsData.length > 1 ? true : false;
                    floors = [];
                    itemRefids = /* @__PURE__ */ new Set();
                    allTopLevelAreasForSite = [];
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        8
                    ]);
                    _loop = function() {
                        var floorData, _children, _allTopLevelAreasForSite, floor, children, floorLayout, _ref, areas, areaPolygons, areaEntitiesMap, topLevelAreas, floorItemRefids;
                        return _ts_generator(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    floorData = _step.value;
                                    floor = _this1.entityFactory.createFloor(floorData.name, // An FML floor's `level` is its place in the stack (0 for the ground floor), so it is the
                                    // position `floorElevationM` takes. Its height no longer moves it.
                                    floorElevationM(floorData.level), _this1.prefixedTwinBid);
                                    _this1.updateProgress(function(pi) {
                                        pi.total += 1;
                                        pi.messages.push("Processing floor: ".concat(floorData.name));
                                    });
                                    if (multiFloor) {
                                        _this1.allEntities.push(floor);
                                    }
                                    children = [];
                                    floorLayout = findLatestDesign(floorData.designs);
                                    return [
                                        4,
                                        _this1.processAreas(floorLayout.surfaces, floorData.name)
                                    ];
                                case 1:
                                    _ref = _state.sent(), areas = _ref.areas, areaPolygons = _ref.areaPolygons, areaEntitiesMap = _ref.areaEntitiesMap;
                                    topLevelAreas = _this1.hierarchyService.buildHierarchy(areas, areaEntitiesMap);
                                    _this1.hierarchyService.populateDepthFromHierarchy(areaEntitiesMap, topLevelAreas, 0);
                                    (_children = children).push.apply(_children, _to_consumable_array(topLevelAreas));
                                    (_allTopLevelAreasForSite = allTopLevelAreasForSite).push.apply(_allTopLevelAreasForSite, _to_consumable_array(topLevelAreas));
                                    return [
                                        4,
                                        _this1.processWalls(floorLayout.walls, floorData.name, children)
                                    ];
                                case 2:
                                    _state.sent();
                                    return [
                                        4,
                                        _this1.processAssets(floorLayout.items, floorData.name, areaPolygons, areaEntitiesMap, children)
                                    ];
                                case 3:
                                    floorItemRefids = _state.sent();
                                    itemRefids = itemRefids.union(floorItemRefids);
                                    floor.children = children;
                                    floors.push(floor);
                                    _this1.updateProgress(function(pi) {
                                        pi.completed += 1;
                                        pi.messages.push("Completed processing floor: ".concat(floorData.name));
                                    });
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    _iterator = floorsData[Symbol.iterator]();
                    _state.label = 2;
                case 2:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        5
                    ];
                    return [
                        5,
                        _ts_values(_loop())
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        8
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        8
                    ];
                case 7:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 8:
                    site = _this1.allEntities[0];
                    site.capacity = _this1.hierarchyService.calculateSiteCapacity(allTopLevelAreasForSite);
                    return [
                        2,
                        {
                            floors: floors,
                            itemRefids: itemRefids
                        }
                    ];
            }
        });
    });
    this.processAreas = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(surfacesData, floorName) {
            var areaPolygons, areaEntitiesMap, areas, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step;
            return _ts_generator(this, function(_state) {
                areaPolygons = [];
                areaEntitiesMap = /* @__PURE__ */ new Map();
                _this1.updateProgress(function(pi) {
                    pi.total += surfacesData.length;
                    pi.messages.push("    Processing floor ".concat(floorName, " surfaces"));
                });
                areas = [];
                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    _loop = function() {
                        var surfaceData = _step.value;
                        var basicPoints = surfaceData["poly"];
                        var _surfaceData_customName;
                        var customName = (_surfaceData_customName = surfaceData.customName) !== null && _surfaceData_customName !== void 0 ? _surfaceData_customName : "";
                        _this1.updateProgress(function(pi) {
                            pi.messages.push("    Processing ".concat(customName));
                        });
                        var areaEntityData = parseCustomName(customName, _this1.hierarchyString);
                        if (!("errors" in areaEntityData)) {
                            var area = _this1.entityFactory.createArea(areaEntityData, surfaceData.poly, // The FML path composes the entity BID itself (ruling R18): its codes come from a
                            // `customName` and are short by construction, so the twin prefix has to be added here.
                            // The factory no longer does it — the planner path passes a stored identity that is
                            // already the full BID. See `EntityFactoryService.createArea`.
                            "".concat(_this1.prefixedTwinBid, "-").concat(areaEntityData.entityCode), // The imported surface's REAL Floorplanner refid. `plan-entity-identity` stopped the
                            // planner writing its own plan identity into this field and, in an earlier attempt,
                            // removed the write for this path too — which blanked the Google Sheets enrichment's
                            // `floorplanner_id` column for every FML-imported twin. It is opt-in now, and this is the
                            // caller that opts in.
                            surfaceData.refid);
                            var areaPolygon = _this1.entityFactory.createAreaPolygon(area, basicPoints);
                            areaPolygons.push(areaPolygon);
                            areas.push(area);
                            _this1.allEntities.push(area);
                            var parentId = areaEntityData.parentID ? "".concat(_this1.prefixedTwinBid, "-").concat(areaEntityData.parentID) : null;
                            var entityLookupData = _this1.entityFactory.createEntityLookupData(area, parentId);
                            areaEntitiesMap.set(area.bID, entityLookupData);
                        }
                        _this1.updateProgress(function(pi) {
                            pi.completed += 1;
                            pi.messages.push("    Completed processing ".concat(customName));
                        });
                    };
                    for(_iterator = surfacesData[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return [
                    2,
                    {
                        areas: areas,
                        areaPolygons: areaPolygons,
                        areaEntitiesMap: areaEntitiesMap
                    }
                ];
            });
        });
        return function(surfacesData, floorName) {
            return _ref.apply(this, arguments);
        };
    }();
    this.processWalls = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(wallsData, floorName, children) {
            var _loop, wallCounter, wi;
            return _ts_generator(this, function(_state) {
                _loop = function(wi) {
                    var wallData = wallsData[wi];
                    _this1.updateProgress(function(pi) {
                        pi.messages.push("    Processing floor ".concat(floorName, " wall ").concat(wi + 1));
                    });
                    var wallSplits = splitWall(wallData);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = wallSplits[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var split = _step.value;
                            var points = constructWallGeometry(split);
                            var wall = _this1.entityFactory.createWall(points, wallCounter, _this1.prefixedTwinBid, floorName);
                            wallCounter += 1;
                            children.push(wall);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    _this1.updateProgress(function(pi) {
                        pi.completed += 1;
                        pi.messages.push("    Completed processing floor ".concat(floorName, " wall ").concat(wi + 1));
                    });
                };
                _this1.updateProgress(function(pi) {
                    pi.total += wallsData.length;
                    pi.messages.push("    Processing floor ".concat(floorName, " walls"));
                });
                wallCounter = 0;
                for(wi = 0; wi < wallsData.length; wi++)_loop(wi);
                return [
                    2
                ];
            });
        });
        return function(wallsData, floorName, children) {
            return _ref.apply(this, arguments);
        };
    }();
    this.processAssets = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(assetsData, floorName, areaPolygons, areaEntitiesMap, children) {
            var _loop, allRefids, ai;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _loop = function(ai) {
                            var assetData, basicPoint, _assetData_name, customName, assetEntityData, asset;
                            return _ts_generator(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        assetData = assetsData[ai];
                                        allRefids.add(assetData.refid);
                                        basicPoint = new Vector25(assetData.x, assetData.y);
                                        customName = (_assetData_name = assetData.name) !== null && _assetData_name !== void 0 ? _assetData_name : "";
                                        _this1.updateProgress(function(pi) {
                                            pi.messages.push("    Processing asset ".concat(ai + 1, " - ").concat(customName));
                                        });
                                        assetEntityData = parseCustomName(customName, _this1.hierarchyString);
                                        if (!!("errors" in assetEntityData)) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            _this1.createAsset(assetData, assetEntityData, customName)
                                        ];
                                    case 1:
                                        asset = _state.sent();
                                        _this1.hierarchyService.placeAssetInHierarchy(asset, assetEntityData, areaPolygons, areaEntitiesMap, children, basicPoint, _this1.prefixedTwinBid, _this1.allEntities);
                                        _state.label = 2;
                                    case 2:
                                        _this1.updateProgress(function(pi) {
                                            pi.completed += 1;
                                            pi.messages.push("    Completed processing asset ".concat(ai + 1, " - ").concat(customName));
                                        });
                                        return [
                                            2
                                        ];
                                }
                            });
                        };
                        _this1.updateProgress(function(pi) {
                            pi.total += assetsData.length;
                            pi.messages.push("    Processing floor ".concat(floorName, " assets"));
                        });
                        allRefids = /* @__PURE__ */ new Set();
                        ai = 0;
                        _state.label = 1;
                    case 1:
                        if (!(ai < assetsData.length)) return [
                            3,
                            4
                        ];
                        return [
                            5,
                            _ts_values(_loop(ai))
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        ai++;
                        return [
                            3,
                            1
                        ];
                    case 4:
                        return [
                            2,
                            allRefids
                        ];
                }
            });
        });
        return function(assetsData, floorName, areaPolygons, areaEntitiesMap, children) {
            return _ref.apply(this, arguments);
        };
    }();
    this.createAsset = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(assetData, assetEntityData, customName) {
            var refid, assetDetails, finalModelFile;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        refid = assetData.refid;
                        return [
                            4,
                            _this1.resolveAssetDetails(refid, customName)
                        ];
                    case 1:
                        assetDetails = _state.sent();
                        finalModelFile = null;
                        return [
                            2,
                            _this1.entityFactory.createAsset(assetData, assetEntityData, assetDetails, finalModelFile, // Composed here, not in the factory — see the `createArea` call above (ruling R18).
                            "".concat(_this1.prefixedTwinBid, "-").concat(assetEntityData.entityCode), // The imported asset's REAL Floorplanner refid, which the Google Sheets enrichment reads.
                            // Opt-in; the planner passes nothing. See the `createArea` call above.
                            refid)
                        ];
                }
            });
        });
        return function(assetData, assetEntityData, customName) {
            return _ref.apply(this, arguments);
        };
    }();
    this.resolveAssetDetails = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(refid, customName) {
            var newAssetDetails;
            return _ts_generator(this, function(_state) {
                newAssetDetails = {
                    model: "",
                    // Use empty string to trigger placeholder cube instead of stairs model
                    fullName: "new-asset"
                };
                return [
                    2,
                    newAssetDetails
                ];
            });
        });
        return function(refid, customName) {
            return _ref.apply(this, arguments);
        };
    }();
    this.generateReport = function(site, itemRefids) {
        _this.updateProgress(function(pi) {
            pi.total += 1;
            pi.messages.push("Preparing report");
        });
        var productsList = {};
        var report = _this.reportService.generateReport(site, _this.allEntities, productsList, itemRefids);
        _this.updateProgress(function(pi) {
            pi.completed += 1;
            pi.messages.push("Completed report");
        });
        return report;
    };
    this.hierarchyString = hierarchyString;
    this.updateProgress = updateProgressFactory(progressCallback);
    this.prefixedTwinBid = prefixBid ? "".concat(orgBID, "-").concat(twinBID) : twinBID;
    this.reportService = new ReportService();
    this.hierarchyService = new HierarchyService();
    this.entityFactory = new EntityFactoryService();
};
var parseInventory = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(param) {
        var fml, siteName, twinBID, mapOrigin, orgBID, // productDetailsEndpoint,
        prefixBid, hierarchyString, progressCallback, converter;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    fml = param.fml, siteName = param.siteName, twinBID = param.twinBID, mapOrigin = param.mapOrigin, orgBID = param.orgBID, prefixBid = param.prefixBid, hierarchyString = param.hierarchyString, progressCallback = param.progressCallback;
                    converter = new FloorplannerConverter(fml, siteName, twinBID, mapOrigin, orgBID, prefixBid, hierarchyString, progressCallback);
                    return [
                        4,
                        converter.convert()
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function parseInventory(_) {
        return _ref.apply(this, arguments);
    };
}();
// src/components/3D/editing/PlannerConverter.ts
import { entityIdentityFor as entityIdentityFor2, entityIdentityKey as entityIdentityKey2, findLatestDesign as findLatestDesign2, MAX_ENTITY_SEQUENCE, describeEntityExhaustion, firstLiveSurfaces, KIND_LETTER, kindUnder, isEntityCapacity as isEntityCapacity2, resolveMachineCapacity, resolvePlanCapacity, resolvePlanHierarchy, resolvePlanParentage, spatialParentOfSurface } from "@repo/front-end-utils";
// src/components/3D/editing/planEntity.ts
import { isModelReference } from "@repo/frontend-types";
import { entityIdentityFor, entityIdentityKey, floorElevationM as floorElevationM2, isIdentityPlacement } from "@repo/front-end-utils";
var M_TO_CM = 100;
var scalePoint = function(p) {
    return {
        x: p.y * M_TO_CM,
        y: p.x * M_TO_CM
    };
};
var factory = new EntityFactoryService();
function planItemToMachineEntity(item, identity, options) {
    var _item_modelFile;
    var scaledItem = _object_spread({}, item, scalePoint(item));
    var trimmedModel = ((_item_modelFile = item.modelFile) === null || _item_modelFile === void 0 ? void 0 : _item_modelFile.trim()) || null;
    var modelFile = trimmedModel && isModelReference(trimmedModel) ? trimmedModel : null;
    return factory.createAsset(scaledItem, {
        entityCode: identity.entityCode,
        name: identity.name,
        capacity: identity.capacity,
        track: identity.track,
        parentID: null
    }, {
        model: modelFile !== null && modelFile !== void 0 ? modelFile : "",
        fullName: identity.name
    }, modelFile, // The stored identity IS the entity BID (R18).
    identity.entityCode, // No Floorplanner refid on the planner path (FR10).
    void 0, identity.equipmentId, options === null || options === void 0 ? void 0 : options.importedAt);
}
function planFloorToFloorEntity(floor, twinBID, position, capacity) {
    return factory.createFloor(floor.name, // Its place in the list — the one calculation (`floorElevationM`).
    floorElevationM2(position), twinBID, // Stable per-floor id → a rename-proof floor BID (`<twin>-floor-<id>`). Recovered on the
    // reverse trip (`convertTwinToPlan`) so re-activation reuses the same BID.
    floor.id, // The floor's placement (`floor-placement`): its origin through the SAME swap and scaling as
    // every point on it, so the 3D twin moves the floor's group exactly as Align floors drew it.
    floor.placement && !isIdentityPlacement(floor.placement) ? {
        origin: scalePoint(floor.placement),
        rotation: floor.placement.rotation
    } : void 0, capacity);
}
function planWallToWallEntity(wall, index, twinBID, floorName, outline) {
    var points = outline.map(scalePoint);
    return factory.createWall(points, index, twinBID, floorName, {
        plan_wall: {
            a: wall.a,
            b: wall.b,
            thickness: wall.thickness
        }
    });
}
var PLAN_IMPORTED_AT = /* @__PURE__ */ new Date(0);
var asEntity = function(input, id, depth) {
    return _object_spread_props(_object_spread({}, input), {
        id: id,
        depth: depth,
        children: []
    });
};
function planMachineEntity(item, context) {
    var _item_name;
    var _item_refid;
    var refid = (_item_refid = item.refid) !== null && _item_refid !== void 0 ? _item_refid : "";
    var identity = entityIdentityFor(context.twinBID, item.entityCode) || refid;
    var prefix = "".concat(entityIdentityKey(context.twinBID), "-");
    var tail = identity.startsWith(prefix) ? identity.slice(prefix.length) : identity;
    var entity = planItemToMachineEntity(item, {
        entityCode: identity,
        name: ((_item_name = item.name) === null || _item_name === void 0 ? void 0 : _item_name.trim()) || tail,
        capacity: null,
        track: false
    }, {
        importedAt: PLAN_IMPORTED_AT
    });
    return asEntity(entity, refid, context.depth);
}
function planFloorEntity(floor, context) {
    var entity = planFloorToFloorEntity(floor, context.twinBID, context.position);
    return asEntity(entity, entity.bID, 1);
}
function planWallEntity(wall, index, twinBID, floorName, outline) {
    var entity = planWallToWallEntity(wall, index, twinBID, floorName, outline);
    return asEntity(entity, entity.bID, 2);
}
// src/components/3D/editing/catalogueReference.ts
import { normaliseAssetUid as normaliseAssetUid2 } from "@repo/frontend-types";
var catalogueReferenceOf = function(item, referenceIdByAssetUid) {
    var assetUid = normaliseAssetUid2(item.assetUid);
    return assetUid ? referenceIdByAssetUid === null || referenceIdByAssetUid === void 0 ? void 0 : referenceIdByAssetUid.get(assetUid) : void 0;
};
// src/components/3D/editing/wallJoints.ts
var WALL_CORNER_RADIUS_M = 0.03;
var WALL_JOINT_TOLERANCE_M = 1e-3;
var WALL_IN_LINE_TOLERANCE_DEG = 1;
var WALL_SHARP_LIMIT = 2;
var WALL_ARC_STEP_DEG = 15;
var IN_LINE = WALL_IN_LINE_TOLERANCE_DEG * Math.PI / 180;
var ARC_STEP = WALL_ARC_STEP_DEG * Math.PI / 180;
var EPS = 1e-9;
var add = function(p, q) {
    return {
        x: p.x + q.x,
        y: p.y + q.y
    };
};
var sub = function(p, q) {
    return {
        x: p.x - q.x,
        y: p.y - q.y
    };
};
var mul = function(p, s) {
    return {
        x: p.x * s,
        y: p.y * s
    };
};
var dot = function(p, q) {
    return p.x * q.x + p.y * q.y;
};
var cross = function(p, q) {
    return p.x * q.y - p.y * q.x;
};
var len = function(p) {
    return Math.hypot(p.x, p.y);
};
var unit = function(p) {
    return mul(p, 1 / (len(p) || 1));
};
var left = function(d) {
    return {
        x: -d.y,
        y: d.x
    };
};
var angleOf = function(d) {
    return Math.atan2(d.y, d.x);
};
var ccw = function(from, to) {
    var a = (to - from) % (2 * Math.PI);
    return a < 0 ? a + 2 * Math.PI : a;
};
var meet = function(p, d, q, e) {
    var den = cross(d, e);
    if (Math.abs(den) < EPS) return null;
    return add(p, mul(d, cross(sub(q, p), e) / den));
};
var finitePoint = function(p) {
    return !!p && Number.isFinite(p.x) && Number.isFinite(p.y);
};
var shapedOf = function(wall) {
    if (!wall || !finitePoint(wall.a) || !finitePoint(wall.b)) return null;
    if (!Number.isFinite(wall.thickness) || wall.thickness <= 0) return null;
    var d = sub(wall.b, wall.a);
    var length = len(d);
    if (!(length > 0)) return null;
    return {
        a: wall.a,
        b: wall.b,
        u: mul(d, 1 / length),
        length: length,
        half: wall.thickness / 2,
        thickness: wall.thickness
    };
};
var arc = function(o, r, from, to) {
    var a0 = angleOf(sub(from, o));
    var sweep = angleOf(sub(to, o)) - a0;
    while(sweep > Math.PI)sweep -= 2 * Math.PI;
    while(sweep < -Math.PI)sweep += 2 * Math.PI;
    var steps = Math.max(1, Math.ceil(Math.abs(sweep) / ARC_STEP - 1e-9));
    var out = [
        from
    ];
    for(var i = 1; i < steps; i++){
        var a = a0 + sweep * i / steps;
        out.push({
            x: o.x + r * Math.cos(a),
            y: o.y + r * Math.sin(a)
        });
    }
    out.push(to);
    return out;
};
var curveAt = function(v, u1, u2, r, max1, max2) {
    var psi = Math.acos(Math.max(-1, Math.min(1, dot(u1, u2))));
    if (psi < EPS || Math.PI - psi < EPS) return null;
    var t = Math.tan(psi / 2);
    var tangent = Math.max(0, Math.min(r / t, max1, max2));
    var radius14 = tangent * t;
    if (radius14 < EPS) return null;
    var bis = unit(add(u1, u2));
    return {
        t1: add(v, mul(u1, tangent)),
        t2: add(v, mul(u2, tangent)),
        o: add(v, mul(bis, radius14 / Math.sin(psi / 2))),
        radius: radius14
    };
};
var crossing = function(p, x, o, r) {
    var d = unit(sub(x, p));
    var f = sub(p, o);
    var b = dot(f, d);
    var disc = b * b - (dot(f, f) - r * r);
    if (disc < 0) return null;
    var s = Math.sqrt(disc);
    var along = len(sub(x, p));
    var t = [
        -b - s,
        -b + s
    ].reduce(function(best, c) {
        return Math.abs(c - along) < Math.abs(best - along) ? c : best;
    });
    return add(p, mul(d, t));
};
var sectorCorner = function(p, a, b, theta) {
    var fa = add(a.at, mul(left(a.d), a.half));
    var fb = add(b.at, mul(left(b.d), -b.half));
    var flat = Math.abs(theta - Math.PI) < IN_LINE;
    var met = flat ? null : meet(fa, a.d, fb, b.d);
    var x = met && (dot(sub(met, a.at), a.d) > a.reach || dot(sub(met, b.at), b.d) > b.reach) ? null : met;
    if (!x) {
        var cut = left(unit(sub(a.d, b.d)));
        var _meet, _meet1;
        return {
            first: [
                (_meet = meet(fa, a.d, p, cut)) !== null && _meet !== void 0 ? _meet : add(p, mul(left(a.d), a.half))
            ],
            second: [
                (_meet1 = meet(fb, b.d, p, cut)) !== null && _meet1 !== void 0 ? _meet1 : add(p, mul(left(b.d), -b.half))
            ]
        };
    }
    var r = WALL_CORNER_RADIUS_M;
    var ta = dot(sub(x, a.at), a.d);
    var tb = dot(sub(x, b.at), b.d);
    var roomA = Math.max(0, (a.reach - Math.max(0, ta)) * 0.45);
    var roomB = Math.max(0, (b.reach - Math.max(0, tb)) * 0.45);
    var metFirst = a.end === null;
    var metSecond = b.end === null;
    if (theta < Math.PI) {
        var c2 = curveAt(x, a.d, b.d, r, roomA, roomB);
        if (!c2) return {
            first: [
                x
            ],
            second: [
                x
            ]
        };
        if (metFirst || metSecond) {
            var whole = arc(c2.o, c2.radius, c2.t1, c2.t2);
            return metFirst ? {
                first: [],
                second: whole
            } : {
                first: whole,
                second: []
            };
        }
        var _crossing;
        var k2 = (_crossing = crossing(p, x, c2.o, c2.radius)) !== null && _crossing !== void 0 ? _crossing : x;
        return {
            first: arc(c2.o, c2.radius, c2.t1, k2),
            second: arc(c2.o, c2.radius, k2, c2.t2)
        };
    }
    var out = sub(x, p);
    var reach = len(out);
    var limit = WALL_SHARP_LIMIT * Math.max(a.thickness, b.thickness);
    if (reach > limit) {
        var e = mul(out, 1 / reach);
        var m = add(p, mul(e, limit));
        var across = left(e);
        var ka = meet(fa, a.d, m, across);
        var kb = meet(fb, b.d, m, across);
        if (!ka || !kb) return {
            first: [
                m
            ],
            second: [
                m
            ]
        };
        var toM = function(k2) {
            return unit(sub(m, k2));
        };
        var ca = curveAt(ka, a.d, toM(ka), r, roomA, len(sub(m, ka)));
        var cb = curveAt(kb, toM(kb), b.d, r, len(sub(m, kb)), roomB);
        return {
            first: _to_consumable_array(ca ? arc(ca.o, ca.radius, ca.t1, ca.t2) : [
                ka
            ]).concat([
                m
            ]),
            second: [
                m
            ].concat(_to_consumable_array(cb ? arc(cb.o, cb.radius, cb.t1, cb.t2) : [
                kb
            ]))
        };
    }
    var c = curveAt(x, a.d, b.d, r, roomA + Math.max(0, -ta), roomB + Math.max(0, -tb));
    if (!c) return {
        first: [
            x
        ],
        second: [
            x
        ]
    };
    var _crossing1;
    var k = (_crossing1 = crossing(p, x, c.o, c.radius)) !== null && _crossing1 !== void 0 ? _crossing1 : x;
    return {
        first: arc(c.o, c.radius, c.t1, k),
        second: arc(c.o, c.radius, k, c.t2)
    };
};
var freeCap = function(at, d, half, reach) {
    var n = left(d);
    var r = Math.min(WALL_CORNER_RADIUS_M, half, reach * 0.45);
    var l = add(at, mul(n, half));
    var rt = add(at, mul(n, -half));
    var cl = curveAt(l, d, mul(n, -1), r, Infinity, Infinity);
    var cr = curveAt(rt, n, d, r, Infinity, Infinity);
    return _to_consumable_array(cl ? arc(cl.o, cl.radius, cl.t1, cl.t2) : [
        l
    ]).concat(_to_consumable_array(cr ? arc(cr.o, cr.radius, cr.t1, cr.t2) : [
        rt
    ]));
};
var clipToSide = function(poly, q, d, keep) {
    var side = Math.sign(cross(d, sub(keep, q))) || 1;
    var s = function(p) {
        return side * cross(d, sub(p, q));
    };
    var out = [];
    for(var i = 0; i < poly.length; i++){
        var cur = poly[i];
        var prev = poly[(i + poly.length - 1) % poly.length];
        var sc = s(cur);
        var sp = s(prev);
        if (sc >= -EPS) {
            if (sp < -EPS) out.push(add(prev, mul(sub(cur, prev), sp / (sp - sc))));
            out.push(cur);
        } else if (sp >= -EPS) {
            out.push(add(prev, mul(sub(cur, prev), sp / (sp - sc))));
        }
    }
    return out;
};
var dedupe = function(poly) {
    var out = [];
    poly.forEach(function(p) {
        var last = out[out.length - 1];
        if (!last || len(sub(p, last)) > 1e-7) out.push(p);
    });
    while(out.length > 1 && len(sub(out[0], out[out.length - 1])) <= 1e-7)out.pop();
    return out;
};
var segmentsCross = function(p1, p2, q1, q2) {
    var d1 = cross(sub(p2, p1), sub(q1, p1));
    var d2 = cross(sub(p2, p1), sub(q2, p1));
    var d3 = cross(sub(q2, q1), sub(p1, q1));
    var d4 = cross(sub(q2, q1), sub(p2, q1));
    return d1 * d2 < -EPS && d3 * d4 < -EPS;
};
var isSimple = function(poly) {
    if (poly.length < 3 || !poly.every(finitePoint)) return false;
    var n = poly.length;
    for(var i = 0; i < n; i++){
        for(var j = i + 2; j < n; j++){
            if (i === 0 && j === n - 1) continue;
            if (segmentsCross(poly[i], poly[(i + 1) % n], poly[j], poly[(j + 1) % n])) return false;
        }
    }
    return true;
};
var close2 = function(poly) {
    return _to_consumable_array(poly).concat([
        poly[0]
    ]);
};
var loneOutline = function(w) {
    return dedupe(_to_consumable_array(freeCap(w.b, mul(w.u, -1), w.half, w.length)).concat(_to_consumable_array(freeCap(w.a, w.u, w.half, w.length))));
};
function floorWallOutlines(walls) {
    var _loop = function() {
        var caps = capsWith(freed);
        var polys = walls.map(function(_, i) {
            var w = shaped[i];
            if (!w) return null;
            var capB = caps.get(keyOf(i, "b"));
            var capA = caps.get(keyOf(i, "a"));
            var poly = dedupe(_to_consumable_array(capB.points).concat(_to_consumable_array(capA.points)));
            var mid = mul(add(w.a, w.b), 0.5);
            _to_consumable_array(capB.clips).concat(_to_consumable_array(capA.clips)).forEach(function(c) {
                poly = clipToSide(poly, c.q, c.d, mid);
            });
            return dedupe(poly);
        });
        var before = freed.size;
        polys.forEach(function(poly, i) {
            if (!poly || isSimple(poly)) return;
            freed.add(jointOf.get(keyOf(i, "a")));
            freed.add(jointOf.get(keyOf(i, "b")));
        });
        if (freed.size === before) {
            return {
                v: walls.map(function(wall, i) {
                    var poly = polys[i];
                    if (poly && isSimple(poly)) return close2(poly);
                    var w = shaped[i];
                    var lone = w ? loneOutline(w) : null;
                    return lone && isSimple(lone) ? close2(lone) : constructWallGeometryPlain(wall);
                })
            };
        }
    };
    var shaped = walls.map(shapedOf);
    var ends = [];
    shaped.forEach(function(w, i) {
        if (!w) return;
        ends.push({
            wall: i,
            end: "a",
            at: w.a
        }, {
            wall: i,
            end: "b",
            at: w.b
        });
    });
    var group = ends.map(function(_, i) {
        return i;
    });
    var root = function(i) {
        return group[i] === i ? i : group[i] = root(group[i]);
    };
    for(var i = 0; i < ends.length; i++){
        for(var j = i + 1; j < ends.length; j++){
            if (ends[i].wall === ends[j].wall) continue;
            if (len(sub(ends[i].at, ends[j].at)) <= WALL_JOINT_TOLERANCE_M) group[root(j)] = root(i);
        }
    }
    var joints = /* @__PURE__ */ new Map();
    ends.forEach(function(e, i) {
        var k = root(i);
        var _joints_get;
        var list = (_joints_get = joints.get(k)) !== null && _joints_get !== void 0 ? _joints_get : [];
        list.push(e);
        joints.set(k, list);
    });
    var keyOf = function(wall, end) {
        return "".concat(wall, ":").concat(end);
    };
    var jointOf = /* @__PURE__ */ new Map();
    ends.forEach(function(e, i) {
        return jointOf.set(keyOf(e.wall, e.end), root(i));
    });
    var pointOf = function(list) {
        return mul(list.reduce(function(s, e) {
            return add(s, e.at);
        }, {
            x: 0,
            y: 0
        }), 1 / list.length);
    };
    var teeAlong = function(p, list, i) {
        var m = shaped[i];
        if (!m || list.some(function(e) {
            return e.wall === i;
        })) return null;
        var s = dot(sub(p, m.a), m.u);
        if (s <= WALL_JOINT_TOLERANCE_M || s >= m.length - WALL_JOINT_TOLERANCE_M) return null;
        if (Math.abs(cross(m.u, sub(p, m.a))) > WALL_JOINT_TOLERANCE_M) return null;
        return s;
    };
    var teesOn = /* @__PURE__ */ new Map();
    joints.forEach(function(list) {
        var p = pointOf(list);
        shaped.forEach(function(_, i) {
            var s = teeAlong(p, list, i);
            var _teesOn_get;
            if (s !== null) teesOn.set(i, _to_consumable_array((_teesOn_get = teesOn.get(i)) !== null && _teesOn_get !== void 0 ? _teesOn_get : []).concat([
                s
            ]));
        });
    });
    var teeRoom = function(i, s, ahead) {
        var _teesOn_get;
        return ((_teesOn_get = teesOn.get(i)) !== null && _teesOn_get !== void 0 ? _teesOn_get : []).reduce(function(room, t) {
            return (ahead ? t > s : t < s) ? Math.min(room, Math.abs(t - s) / 2) : room;
        }, ahead ? shaped[i].length - s : s);
    };
    var capsWith = function(freed2) {
        var caps = /* @__PURE__ */ new Map();
        joints.forEach(function(list, joint) {
            var p = pointOf(list);
            var members = list.map(function(e) {
                var w = shaped[e.wall];
                var d = e.end === "a" ? w.u : mul(w.u, -1);
                return {
                    wall: e.wall,
                    end: e.end,
                    d: d,
                    angle: angleOf(d),
                    half: w.half,
                    thickness: w.thickness,
                    at: e.at,
                    reach: w.length
                };
            });
            var clips = [];
            shaped.forEach(function(m, i) {
                var s = teeAlong(p, list, i);
                if (!m || s === null) return;
                if (members.some(function(e) {
                    return Math.abs(cross(e.d, m.u)) < Math.sin(IN_LINE);
                })) return;
                var foot = add(m.a, mul(m.u, s));
                [
                    m.u,
                    mul(m.u, -1)
                ].forEach(function(d) {
                    return members.push({
                        wall: i,
                        end: null,
                        d: d,
                        angle: angleOf(d),
                        half: m.half,
                        thickness: m.thickness,
                        at: foot,
                        reach: teeRoom(i, s, d === m.u)
                    });
                });
                members.filter(function(e) {
                    return e.end !== null;
                }).forEach(function(e) {
                    var side = Math.sign(cross(m.u, e.d)) || 1;
                    clips.push({
                        q: add(foot, mul(left(m.u), side * m.half)),
                        d: m.u
                    });
                });
            });
            members.sort(function(x, y) {
                return x.angle - y.angle;
            });
            var overlapping = /* @__PURE__ */ new Set();
            members.forEach(function(m, i) {
                var n = members[(i + 1) % members.length];
                if (members.length > 1 && m !== n && ccw(m.angle, n.angle) < IN_LINE) {
                    overlapping.add(i);
                    overlapping.add((i + 1) % members.length);
                }
            });
            var joined = members.filter(function(_, i) {
                return !overlapping.has(i);
            });
            var real = joined.filter(function(m) {
                return m.end !== null;
            });
            if (joined.length < 2 || real.length === 0 || freed2.has(joint)) {
                members.forEach(function(m) {
                    if (m.end) caps.set(keyOf(m.wall, m.end), {
                        points: freeCap(m.at, m.d, m.half, m.reach),
                        clips: []
                    });
                });
                return;
            }
            var corners = joined.map(function(m, i) {
                var n = joined[(i + 1) % joined.length];
                return sectorCorner(p, m, n, ccw(m.angle, n.angle) || 2 * Math.PI);
            });
            joined.forEach(function(m, i) {
                if (!m.end) return;
                var before = corners[(i + joined.length - 1) % joined.length];
                var after = corners[i];
                var through = clips.length > 0 && joined.some(function(j) {
                    return j.end === null;
                });
                caps.set(keyOf(m.wall, m.end), {
                    points: _to_consumable_array(after.first).concat([
                        p
                    ], _to_consumable_array(before.second)),
                    clips: through ? clips.filter(function(c) {
                        return Math.abs(cross(c.d, m.d)) >= Math.sin(IN_LINE);
                    }) : []
                });
            });
            members.forEach(function(m) {
                if (m.end && !caps.has(keyOf(m.wall, m.end))) {
                    caps.set(keyOf(m.wall, m.end), {
                        points: freeCap(m.at, m.d, m.half, m.reach),
                        clips: []
                    });
                }
            });
        });
        return caps;
    };
    var freed = /* @__PURE__ */ new Set();
    for(;;){
        var _ret = _loop();
        if (_type_of(_ret) === "object") return _ret.v;
    }
}
// src/components/3D/editing/PlannerConverter.ts
var scalePoly = function(poly) {
    return poly.map(scalePoint);
};
var constructWallGeometryPlain = function(wall) {
    var a = wall.a, b = wall.b, thickness = wall.thickness;
    var dx = b.x - a.x;
    var dy = b.y - a.y;
    var len2 = Math.hypot(dx, dy) || 1;
    var half = thickness / 2;
    var ox = dy / len2 * half;
    var oy = -dx / len2 * half;
    var pts = [
        {
            x: a.x + ox,
            y: a.y + oy
        },
        {
            x: b.x + ox,
            y: b.y + oy
        },
        {
            x: b.x - ox,
            y: b.y - oy
        },
        {
            x: a.x - ox,
            y: a.y - oy
        }
    ];
    pts.push(pts[0]);
    return pts;
};
var pad3 = function(n) {
    return String(n).padStart(3, "0");
};
var joinedItemLookup = function(fml, joined, capacities, registerCapacityOf) {
    if (!joined || joined === fml) return function(item) {
        return capacities.item(item);
    };
    var byRaw = /* @__PURE__ */ new Map();
    var _joined_floors;
    var joinedFloors = (_joined_floors = joined.floors) !== null && _joined_floors !== void 0 ? _joined_floors : [];
    var _fml_floors;
    ((_fml_floors = fml.floors) !== null && _fml_floors !== void 0 ? _fml_floors : []).forEach(function(floor, index) {
        var _joinedFloors_index;
        var copies = /* @__PURE__ */ new Map();
        var _joinedFloors_index_designs, _findLatestDesign2_items;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = ((_findLatestDesign2_items = findLatestDesign2((_joinedFloors_index_designs = (_joinedFloors_index = joinedFloors[index]) === null || _joinedFloors_index === void 0 ? void 0 : _joinedFloors_index.designs) !== null && _joinedFloors_index_designs !== void 0 ? _joinedFloors_index_designs : []).items) !== null && _findLatestDesign2_items !== void 0 ? _findLatestDesign2_items : [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var copy = _step.value;
                if (!copy || typeof copy.refid !== "string") continue;
                var queue = copies.get(copy.refid);
                if (queue) queue.push(copy);
                else copies.set(copy.refid, [
                    copy
                ]);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var _floor_designs, _findLatestDesign2_items1;
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = ((_findLatestDesign2_items1 = findLatestDesign2((_floor_designs = floor === null || floor === void 0 ? void 0 : floor.designs) !== null && _floor_designs !== void 0 ? _floor_designs : []).items) !== null && _findLatestDesign2_items1 !== void 0 ? _findLatestDesign2_items1 : [])[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var item = _step1.value;
                var _copies_get;
                var copy1 = item && typeof item.refid === "string" ? (_copies_get = copies.get(item.refid)) === null || _copies_get === void 0 ? void 0 : _copies_get.shift() : void 0;
                if (copy1) byRaw.set(item, copy1);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    });
    return function(item) {
        var copy = byRaw.get(item);
        return copy ? capacities.item(copy) : resolveMachineCapacity(item, registerCapacityOf);
    };
};
var convertPlanToTwin = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(param) {
        var _loop, fml, siteName, twinBID, mapOrigin, tracking2, reservedIdentities, referenceIdByAssetUid, registerCapacityOf, capacityLayout, factory2, hierarchy, capacities, capacityOf, itemCapacity, report, identityOf, twinIdentityPrefix, tailOf, trackFor, allEntities, refidToBid, refidToEntityCode, site, floors, itemRefids, seq, takenCodes, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, floorData, design, _design_surfaces, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, surface12, identity, _design_items, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, itemData, identity1, nextFreeCode, position, siteCapacity;
        return _ts_generator(this, function(_state) {
            _loop = function(position) {
                var _children;
                var floorData = fml.floors[position];
                var // The floor's resolved capacity: hand-set, or the sum of what sits directly on it.
                _capacityOf;
                var floor = planFloorToFloorEntity(floorData, twinBID, position, (_capacityOf = capacityOf(capacities.floor(floorData.id))) !== null && _capacityOf !== void 0 ? _capacityOf : void 0);
                var children = [];
                var design = findLatestDesign2(floorData.designs);
                var areas = [];
                var areaEntitiesMap = /* @__PURE__ */ new Map();
                var areaPolygons = [];
                var areaBidByRefid = /* @__PURE__ */ new Map();
                var minted = [];
                var _design_surfaces;
                var liveSurfaces = ((_design_surfaces = design.surfaces) !== null && _design_surfaces !== void 0 ? _design_surfaces : []).filter(function(s) {
                    return !s._deleted;
                });
                var spaceKinds = resolvePlanHierarchy(design);
                var candidates = firstLiveSurfaces(design.surfaces);
                var letterFor = function(surface12) {
                    var answer = surface12.refid && !areaBidByRefid.has(surface12.refid) ? spaceKinds.surface(surface12.refid) : void 0;
                    if (answer) return answer.letter;
                    var _kindUnder;
                    return KIND_LETTER[(_kindUnder = kindUnder(spaceKinds, spatialParentOfSurface(surface12, candidates))) !== null && _kindUnder !== void 0 ? _kindUnder : "area"];
                };
                var resolvedCopies = new Set(firstLiveSurfaces(design.surfaces));
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = liveSurfaces[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var surface12 = _step.value;
                        var _surface12_name;
                        var entityCode = identityOf(surface12.entityCode) || nextFreeCode(letterFor(surface12));
                        var areaEntityData = {
                            entityCode: entityCode,
                            name: ((_surface12_name = surface12.name) === null || _surface12_name === void 0 ? void 0 : _surface12_name.trim()) || tailOf(entityCode),
                            // This floor's own copy of the refid. A surface the resolver did not resolve (a later
                            // duplicate on this floor, or one with no refid) keeps its own stored number.
                            capacity: resolvedCopies.has(surface12) ? capacityOf(capacities.surface(surface12.refid, floorData.id)) : isEntityCapacity2(surface12.capacity) ? surface12.capacity : null,
                            track: trackFor("surface", surface12.refid),
                            parentID: null
                        };
                        var polyCm = scalePoly(surface12.poly);
                        var area = factory2.createArea(areaEntityData, polyCm, entityCode);
                        areas.push(area);
                        allEntities.push(area);
                        refidToBid[surface12.refid] = area.bID;
                        refidToEntityCode[surface12.refid] = entityCode;
                        areaPolygons.push(factory2.createAreaPolygon(area, polyCm));
                        if (!areaBidByRefid.has(surface12.refid)) areaBidByRefid.set(surface12.refid, area.bID);
                        minted.push({
                            surface: surface12,
                            bID: area.bID
                        });
                        areaEntitiesMap.set(area.bID, factory2.createEntityLookupData(area, null));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var parentage = resolvePlanParentage(design);
                var bidOfParent = function(refid) {
                    var _areaBidByRefid_get;
                    return refid === null ? null : (_areaBidByRefid_get = areaBidByRefid.get(refid)) !== null && _areaBidByRefid_get !== void 0 ? _areaBidByRefid_get : null;
                };
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = minted[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var _step_value = _step1.value, surface121 = _step_value.surface, bID = _step_value.bID;
                        var _parentage_surface;
                        var info = areaEntitiesMap.get(bID);
                        if (!info) continue;
                        var _parentage_surface_effectiveParent;
                        var parentRefid = areaBidByRefid.get(surface121.refid) === bID ? (_parentage_surface_effectiveParent = (_parentage_surface = parentage.surface(surface121.refid)) === null || _parentage_surface === void 0 ? void 0 : _parentage_surface.effectiveParent) !== null && _parentage_surface_effectiveParent !== void 0 ? _parentage_surface_effectiveParent : null : spatialParentOfSurface(surface121, candidates);
                        info.parentID = bidOfParent(parentRefid);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                var topLevelAreas = hierarchy.buildHierarchy(areas, areaEntitiesMap);
                hierarchy.populateDepthFromHierarchy(areaEntitiesMap, topLevelAreas, 0);
                (_children = children).push.apply(_children, _to_consumable_array(topLevelAreas));
                var _design_walls;
                var floorWalls = (_design_walls = design.walls) !== null && _design_walls !== void 0 ? _design_walls : [];
                var wallOutlines = floorWallOutlines(floorWalls);
                var wallCounter = 0;
                var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                try {
                    for(var _iterator2 = floorWalls[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                        var wallData = _step2.value;
                        var index = wallCounter++;
                        children.push(planWallToWallEntity(wallData, index, twinBID, floorData.name, wallOutlines[index]));
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                            _iterator2.return();
                        }
                    } finally{
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
                var _design_items;
                var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                try {
                    for(var _iterator3 = ((_design_items = design.items) !== null && _design_items !== void 0 ? _design_items : [])[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                        var itemData = _step3.value;
                        var _itemData_name, _parentage_item;
                        if (itemData._deleted) continue;
                        itemRefids.add(itemData.refid);
                        var entityCode1 = identityOf(itemData.entityCode) || nextFreeCode("E");
                        var asset = planItemToMachineEntity(itemData, {
                            entityCode: entityCode1,
                            name: ((_itemData_name = itemData.name) === null || _itemData_name === void 0 ? void 0 : _itemData_name.trim()) || tailOf(entityCode1),
                            capacity: capacityOf(itemCapacity(itemData)),
                            track: trackFor("item", itemData.refid),
                            equipmentId: catalogueReferenceOf(itemData, referenceIdByAssetUid)
                        });
                        allEntities.push(asset);
                        refidToBid[itemData.refid] = asset.bID;
                        refidToEntityCode[itemData.refid] = entityCode1;
                        var _parentage_item_effectiveParent;
                        var parentBID = bidOfParent((_parentage_item_effectiveParent = (_parentage_item = parentage.item(itemData)) === null || _parentage_item === void 0 ? void 0 : _parentage_item.effectiveParent) !== null && _parentage_item_effectiveParent !== void 0 ? _parentage_item_effectiveParent : null);
                        var parent = parentBID ? areaEntitiesMap.get(parentBID) : null;
                        if (parent) {
                            parent.entity.children.push(asset);
                        } else {
                            children.push(asset);
                        }
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                            _iterator3.return();
                        }
                    } finally{
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
                floor.children = children;
                floors.push(floor);
            };
            fml = param.fml, siteName = param.siteName, twinBID = param.twinBID, mapOrigin = param.mapOrigin, tracking2 = param.tracking, reservedIdentities = param.reservedIdentities, referenceIdByAssetUid = param.referenceIdByAssetUid, registerCapacityOf = param.registerCapacityOf, capacityLayout = param.capacityLayout;
            factory2 = new EntityFactoryService();
            hierarchy = new HierarchyService();
            capacities = resolvePlanCapacity(capacityLayout !== null && capacityLayout !== void 0 ? capacityLayout : fml, registerCapacityOf);
            capacityOf = function(resolved) {
                return typeof (resolved === null || resolved === void 0 ? void 0 : resolved.value) === "number" ? resolved.value : null;
            };
            itemCapacity = joinedItemLookup(fml, capacityLayout, capacities, registerCapacityOf);
            report = new ReportService();
            identityOf = function(raw) {
                return entityIdentityFor2(twinBID, raw);
            };
            twinIdentityPrefix = "".concat(entityIdentityKey2(twinBID), "-");
            tailOf = function(identity) {
                return identity.startsWith(twinIdentityPrefix) ? identity.slice(twinIdentityPrefix.length) : identity;
            };
            trackFor = function(kind, refid) {
                return (kind === "surface" ? tracking2.tracked.surfaces : tracking2.tracked.items).has(refid);
            };
            allEntities = [];
            refidToBid = /* @__PURE__ */ Object.create(null);
            refidToEntityCode = /* @__PURE__ */ Object.create(null);
            site = factory2.createSite(siteName, mapOrigin, twinBID);
            allEntities.push(site);
            floors = [];
            itemRefids = /* @__PURE__ */ new Set();
            seq = {
                Z: 0,
                S: 0,
                A: 0,
                E: 0
            };
            takenCodes = /* @__PURE__ */ new Set();
            reservedIdentities.forEach(function(reserved) {
                var identity = identityOf(reserved);
                if (identity) takenCodes.add(identity);
            });
            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(_iterator = fml.floors[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    floorData = _step.value;
                    design = findLatestDesign2(floorData.designs);
                    ;
                    _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(_iterator1 = ((_design_surfaces = design.surfaces) !== null && _design_surfaces !== void 0 ? _design_surfaces : [])[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            surface12 = _step1.value;
                            identity = identityOf(surface12 === null || surface12 === void 0 ? void 0 : surface12.entityCode);
                            if (identity && !surface12._deleted) takenCodes.add(identity);
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    ;
                    _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                    try {
                        for(_iterator2 = ((_design_items = design.items) !== null && _design_items !== void 0 ? _design_items : [])[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                            itemData = _step2.value;
                            identity1 = identityOf(itemData === null || itemData === void 0 ? void 0 : itemData.entityCode);
                            if (identity1 && !itemData._deleted) takenCodes.add(identity1);
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                _iterator2.return();
                            }
                        } finally{
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            nextFreeCode = function(prefix) {
                for(;;){
                    var next = ++seq[prefix];
                    if (next > MAX_ENTITY_SEQUENCE) {
                        throw new Error(describeEntityExhaustion(twinBID, prefix));
                    }
                    var identity = identityOf("".concat(prefix).concat(pad3(next)));
                    if (!takenCodes.has(identity)) {
                        takenCodes.add(identity);
                        return identity;
                    }
                }
            };
            for(position = 0; position < fml.floors.length; position++)_loop(position);
            siteCapacity = capacityOf(capacities.twin());
            if (isEntityCapacity2(siteCapacity)) site.capacity = siteCapacity;
            site.children = floors;
            return [
                2,
                _object_spread_props(_object_spread({}, report.generateReport(site, allEntities, {}, itemRefids, refidToBid)), {
                    refidToEntityCode: refidToEntityCode
                })
            ];
        });
    });
    return function convertPlanToTwin(_) {
        return _ref.apply(this, arguments);
    };
}();
// src/components/3D/editing/TwinToPlannerConverter.ts
import { TwinEntityType as TwinEntityType2, isModelReference as isModelReference2, normaliseAssetUid as normaliseAssetUid3 } from "@repo/frontend-types";
import { cleanPlacement, entityIdentityKey as entityIdentityKey3, isEntityCapacity as isEntityCapacity3, isIdentityPlacement as isIdentityPlacement2, stringToTwinEntityType as stringToTwinEntityType2, stripTwinBidPrefix } from "@repo/front-end-utils";
var readModelFile = function(value) {
    var name = value === null || value === void 0 ? void 0 : value.trim();
    if (!name) return null;
    return isModelReference2(name) ? name : null;
};
var EARTH_RADIUS_METRES2 = 6378137;
var COORD_LOCAL_TO_METRES2 = 100;
var finiteNumber = function(v) {
    return typeof v === "number" && Number.isFinite(v);
};
var planPointFrom = function(v) {
    if (!v || (typeof v === "undefined" ? "undefined" : _type_of(v)) !== "object") return null;
    var x = v.x, y = v.y;
    return finiteNumber(x) && finiteNumber(y) ? {
        x: x,
        y: y
    } : null;
};
var planWallFrom = function(defs) {
    var raw = defs && (typeof defs === "undefined" ? "undefined" : _type_of(defs)) === "object" ? defs.plan_wall : void 0;
    if (!raw || (typeof raw === "undefined" ? "undefined" : _type_of(raw)) !== "object") return null;
    var a = raw.a, b = raw.b, thickness = raw.thickness;
    var pa = planPointFrom(a);
    var pb = planPointFrom(b);
    if (!pa || !pb || !finiteNumber(thickness) || thickness <= 0) return null;
    return {
        a: pa,
        b: pb,
        thickness: thickness,
        openings: []
    };
};
var decodeDefinitions = function(raw) {
    if (!raw) return null;
    try {
        return decodeBase64Json(raw);
    } catch (e) {
        return null;
    }
};
var toMetres = function(p, ctx) {
    if (ctx.coordinateSystem === "COORD_WGS84" && ctx.mapOrigin) {
        var originLatRad = ctx.mapOrigin.latitude * Math.PI / 180;
        var dLat = (p.latitude - ctx.mapOrigin.latitude) * Math.PI / 180;
        var dLng = (p.longitude - ctx.mapOrigin.longitude) * Math.PI / 180;
        return {
            x: dLng * EARTH_RADIUS_METRES2 * Math.cos(originLatRad),
            y: dLat * EARTH_RADIUS_METRES2
        };
    }
    return {
        x: p.longitude * COORD_LOCAL_TO_METRES2,
        y: p.latitude * COORD_LOCAL_TO_METRES2
    };
};
var extractPolygon = function(node, ctx) {
    var _node_boundaries_polygons__coordinates_, _node_boundaries_polygons__coordinates, _node_boundaries_polygons_, _node_boundaries_polygons, _node_boundaries;
    var _node_boundaries_polygons__coordinates__points;
    var points = (_node_boundaries_polygons__coordinates__points = (_node_boundaries = node.boundaries) === null || _node_boundaries === void 0 ? void 0 : (_node_boundaries_polygons = _node_boundaries.polygons) === null || _node_boundaries_polygons === void 0 ? void 0 : (_node_boundaries_polygons_ = _node_boundaries_polygons[0]) === null || _node_boundaries_polygons_ === void 0 ? void 0 : (_node_boundaries_polygons__coordinates = _node_boundaries_polygons_.coordinates) === null || _node_boundaries_polygons__coordinates === void 0 ? void 0 : (_node_boundaries_polygons__coordinates_ = _node_boundaries_polygons__coordinates[0]) === null || _node_boundaries_polygons__coordinates_ === void 0 ? void 0 : _node_boundaries_polygons__coordinates_.points) !== null && _node_boundaries_polygons__coordinates__points !== void 0 ? _node_boundaries_polygons__coordinates__points : [];
    var poly = points.map(function(pt) {
        return toMetres(pt, ctx);
    });
    if (poly.length >= 2) {
        var first = poly[0];
        var last = poly[poly.length - 1];
        if (Math.abs(first.x - last.x) < 1e-6 && Math.abs(first.y - last.y) < 1e-6) {
            poly.pop();
        }
    }
    return poly;
};
var midpoint = function(a, b) {
    return {
        x: (a.x + b.x) / 2,
        y: (a.y + b.y) / 2
    };
};
var distance = function(a, b) {
    return Math.hypot(a.x - b.x, a.y - b.y);
};
var polygonToWall = function(poly) {
    var _Math, _Math1, _Math2, _Math3;
    if (poly.length === 4) {
        return {
            a: midpoint(poly[0], poly[3]),
            b: midpoint(poly[1], poly[2]),
            thickness: distance(poly[0], poly[3]),
            openings: []
        };
    }
    if (poly.length < 2) return null;
    var xs = poly.map(function(p) {
        return p.x;
    });
    var ys = poly.map(function(p) {
        return p.y;
    });
    var minX = (_Math = Math).min.apply(_Math, _to_consumable_array(xs));
    var maxX = (_Math1 = Math).max.apply(_Math1, _to_consumable_array(xs));
    var minY = (_Math2 = Math).min.apply(_Math2, _to_consumable_array(ys));
    var maxY = (_Math3 = Math).max.apply(_Math3, _to_consumable_array(ys));
    var width = maxX - minX;
    var height2 = maxY - minY;
    if (width >= height2) {
        var midY = (minY + maxY) / 2;
        return {
            a: {
                x: minX,
                y: midY
            },
            b: {
                x: maxX,
                y: midY
            },
            thickness: height2,
            openings: []
        };
    }
    var midX = (minX + maxX) / 2;
    return {
        a: {
            x: midX,
            y: minY
        },
        b: {
            x: midX,
            y: maxY
        },
        thickness: width,
        openings: []
    };
};
var floorPlacementFrom = function(node, ctx, report) {
    if (!node.location && (node.rotationY === null || node.rotationY === void 0)) return void 0;
    var origin = node.location ? toMetres(node.location, ctx) : {
        x: 0,
        y: 0
    };
    var _node_rotationY;
    var rotation = (_node_rotationY = node.rotationY) !== null && _node_rotationY !== void 0 ? _node_rotationY : 0;
    if (![
        origin.x,
        origin.y,
        rotation
    ].every(Number.isFinite)) {
        report("floor ".concat(node.bID, ": placement unreadable, loaded unplaced"), "anomaly");
        return void 0;
    }
    var placement = cleanPlacement({
        x: Math.round(origin.x * 1e3) / 1e3,
        y: Math.round(origin.y * 1e3) / 1e3,
        rotation: rotation
    });
    return isIdentityPlacement2(placement) ? void 0 : placement;
};
var decodeRotation = function(node, defs) {
    if (defs) {
        if (typeof defs.original_rotation === "number") return defs.original_rotation;
        if (typeof defs.floorplanner_original_rotation === "number") {
            return defs.floorplanner_original_rotation;
        }
    }
    var _node_rotationY, _ref;
    return (_ref = (_node_rotationY = node.rotationY) !== null && _node_rotationY !== void 0 ? _node_rotationY : node.rotationZ) !== null && _ref !== void 0 ? _ref : 0;
};
var decodeMirror = function(defs) {
    var _defs_mirrored;
    var m = (_defs_mirrored = defs === null || defs === void 0 ? void 0 : defs.mirrored) !== null && _defs_mirrored !== void 0 ? _defs_mirrored : defs === null || defs === void 0 ? void 0 : defs.floorplanner_mirrored;
    if (Array.isArray(m) && m.length >= 2) return [
        m[0],
        m[1]
    ];
    return void 0;
};
var decodeAssetUid = function(defs) {
    return normaliseAssetUid3(defs === null || defs === void 0 ? void 0 : defs.asset_uid);
};
var SURFACE_TYPES = /* @__PURE__ */ new Set([
    TwinEntityType2.AREA,
    TwinEntityType2.ZONE,
    TwinEntityType2.STATION,
    TwinEntityType2.CATEGORY,
    TwinEntityType2.STRUCTURE,
    TwinEntityType2.NFAREA
]);
var hasIdentity = function(entityIdentity, node, kind, opts) {
    if (entityIdentity !== "") return true;
    var _node_name;
    opts.report("[convertTwinToPlan] skipped a ".concat(kind, " on ").concat(opts.twinBID || "(unknown twin)", " with no entity BID, so it has no identity and cannot be placed on the plan (name: ").concat(JSON.stringify((_node_name = node.name) !== null && _node_name !== void 0 ? _node_name : null), "). A stored product reference is not an identity and is deliberately not substituted."), "skipped-no-identity");
    return false;
};
var collect = function(node, acc, opts, parentRefid) {
    var _node_type;
    var _node_type_name;
    var type = stringToTwinEntityType2((_node_type_name = (_node_type = node.type) === null || _node_type === void 0 ? void 0 : _node_type.name) !== null && _node_type_name !== void 0 ? _node_type_name : "");
    var defs = decodeDefinitions(node.definitions);
    var entityIdentity = entityIdentityKey3(node.bID);
    var shortCode = stripTwinBidPrefix(node.bID, opts.twinBID, opts.orgBID);
    var nextParentRefid = parentRefid;
    if (type === TwinEntityType2.WALL) {
        if (node.bID) acc.wallBids.push(node.bID);
        var _planWallFrom;
        var wall = (_planWallFrom = planWallFrom(defs)) !== null && _planWallFrom !== void 0 ? _planWallFrom : node.boundaries ? polygonToWall(extractPolygon(node, opts.ctx)) : null;
        if (wall) acc.walls.push(wall);
    } else if (type === TwinEntityType2.ASSET) {
        var _node_location;
        var loc = (_node_location = node.location) !== null && _node_location !== void 0 ? _node_location : node.centre;
        if (loc && hasIdentity(entityIdentity, node, "asset", opts)) {
            var pt = toMetres(loc, opts.ctx);
            var _node_name, _node_altitude, _node_capacity;
            acc.items.push({
                /*
         * **The identity is the entity's own BID, and nothing else** (FR1).
         *
         * This used to be `pickRefid(node.bID, defs?.refid, defs?.floorplanner_refid)`, which
         * preferred a stored PRODUCT reference and fell back to the BID. Measured on Finsbury Park:
         * 29 studio bikes on one key, 16 reformers on one key, 8 treadmills on one key — while
         * their own BIDs (`E056`–`E084`, `E135`–`E150`, `E099`–`E114`) sat unused on the same
         * records. `refid` is the plan's instance key and four things read it: click-to-select,
         * rotate, delete, and the observer→machine map. Each one therefore treated every instance
         * of a model as one machine.
         *
         * ⚠ **`entityIdentity`, not the raw `node.bID`.** The old fallback took the raw value, so
         * even on the one input that did reach the BID it reached an unnormalised copy —
         * `entityIdentityKey` trims and uppercases (R18's casing rule), so a mixed-case or
         * space-padded BID would leave `refid !== entityCode` and the middleware's agreement check
         * would warn about a plan this very converter had just produced.
         *
         * The product references are untouched, still in `definitions`, still answering the
         * question they were built to answer. Nothing about them moves or is rewritten; the plan
         * simply stops reading one as an instance identity.
         */ refid: entityIdentity,
                name: (_node_name = node.name) !== null && _node_name !== void 0 ? _node_name : shortCode,
                x: pt.x,
                y: pt.y,
                z: (_node_altitude = node.altitude) !== null && _node_altitude !== void 0 ? _node_altitude : 0,
                // `decodeRotation` prefers the stored `original_rotation`, which the factory keeps in the
                // planner's own frame (the viewer offset lives on `rotationY` only) — so the plan recovers
                // the planner's rotation verbatim and the round trip is identity.
                rotation: decodeRotation(node, defs),
                mirrored: decodeMirror(defs),
                // Screened through the SHARED rule (`register-create-hardening`, ledger row 59), the same
                // one the drag boundary and the register's write path apply. This is the dGraph → plan
                // crossing, and it is one of the two writers of `FloorPlannerItem.modelFile` that used to
                // bypass `flatShareFilename` — so a name that cannot address a file at the share root
                // reached persisted plan JSON, and from there the 3D scene, from an activated twin.
                // Coerced to `null` rather than refused: an unrenderable model must not cost the operator
                // the item. Measured 0 live effect (no plan `modelFile` on either database fails the
                // screens), which is what a hardening invariant should look like.
                modelFile: readModelFile(node.modelFile),
                parentSpaceBid: parentRefid,
                capacity: (_node_capacity = node.capacity) !== null && _node_capacity !== void 0 ? _node_capacity : void 0,
                entityCode: entityIdentity,
                assetUid: decodeAssetUid(defs)
            });
        }
    } else if (node.boundaries && SURFACE_TYPES.has(type)) {
        var poly = extractPolygon(node, opts.ctx);
        if (poly.length >= 3 && hasIdentity(entityIdentity, node, "surface", opts)) {
            var refid = entityIdentity;
            var _node_name1, _node_capacity1;
            acc.surfaces.push({
                refid: refid,
                name: (_node_name1 = node.name) !== null && _node_name1 !== void 0 ? _node_name1 : shortCode,
                poly: poly,
                capacity: (_node_capacity1 = node.capacity) !== null && _node_capacity1 !== void 0 ? _node_capacity1 : void 0,
                parentSurfaceBid: parentRefid,
                entityCode: entityIdentity
            });
            nextParentRefid = refid;
        } else if (poly.length >= 3 && entityIdentity === "") {
            var _node_children;
            var orphans = ((_node_children = node.children) !== null && _node_children !== void 0 ? _node_children : []).length;
            if (orphans > 0) {
                opts.report("[convertTwinToPlan] ".concat(orphans, " entit").concat(orphans === 1 ? "y" : "ies", " inside that skipped surface are now attached to its parent instead, so the plan's hierarchy is one level flatter there than the twin's."), "reparented");
            }
        }
    }
    var _node_children1;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = ((_node_children1 = node.children) !== null && _node_children1 !== void 0 ? _node_children1 : [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var child = _step.value;
            collect(child, acc, opts, nextParentRefid);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
};
var emptyCollected = function() {
    return {
        surfaces: [],
        items: [],
        walls: [],
        wallBids: []
    };
};
var COLLAPSE_FLOOR_FALLBACK_NAME = "Ground floor";
var WALL_SUFFIX = /^(.+)-wall-\d+$/;
var recoverCollapseFloorName = function(wallBids, opts) {
    var counts = /* @__PURE__ */ new Map();
    var unparsed = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = wallBids[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var bID = _step.value;
            var stripped = stripTwinBidPrefix(bID, opts.twinBID, opts.orgBID);
            var match = stripped === bID ? null : WALL_SUFFIX.exec(stripped);
            if (!match) {
                unparsed += 1;
                continue;
            }
            var _counts_get;
            counts.set(match[1], ((_counts_get = counts.get(match[1])) !== null && _counts_get !== void 0 ? _counts_get : 0) + 1);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (counts.size === 0) {
        if (wallBids.length === 0) return {
            name: null
        };
        return {
            name: null,
            diagnostic: "Could not recover the floor name from any of ".concat(wallBids.length, " wall BID(s) on ").concat(opts.twinBID, '; falling back to "').concat(COLLAPSE_FLOOR_FALLBACK_NAME, '". Re-activating will re-create these walls under new BIDs.')
        };
    }
    var ranked = Array.from(counts.entries()).sort(function(a, b) {
        return b[1] - a[1];
    });
    var name = ranked[0][0];
    if (ranked.length === 1 && unparsed === 0) return {
        name: name
    };
    var detail = ranked.map(function(param) {
        var _param = _sliced_to_array(param, 2), n = _param[0], c = _param[1];
        return '"'.concat(n, '" \xd7').concat(c);
    }).join(", ");
    return {
        name: name,
        diagnostic: "Wall BIDs on ".concat(opts.twinBID, " disagree about the floor name (").concat(detail).concat(unparsed > 0 ? ", plus ".concat(unparsed, " unrecognised") : "", '). Using "').concat(name, '"; walls named otherwise will be re-created under new BIDs on re-activation.')
    };
};
var designFrom = function(c) {
    return {
        name: "Current",
        areas: [],
        surfaces: c.surfaces,
        items: c.items,
        walls: c.walls,
        dimensions: [],
        labels: [],
        lines: []
    };
};
var convertTwinToPlan = function(twin, param) {
    var twinBID = param.twinBID, twinName = param.twinName, orgBID = param.orgBID, onDiagnostic = param.onDiagnostic;
    var root = twin;
    var _root_coordinateSystem, _root_mapOrigin;
    var ctx = {
        coordinateSystem: (_root_coordinateSystem = root.coordinateSystem) !== null && _root_coordinateSystem !== void 0 ? _root_coordinateSystem : "COORD_LOCAL",
        mapOrigin: (_root_mapOrigin = root.mapOrigin) !== null && _root_mapOrigin !== void 0 ? _root_mapOrigin : null
    };
    var report = onDiagnostic !== null && onDiagnostic !== void 0 ? onDiagnostic : console.warn;
    var opts = {
        twinBID: twinBID,
        orgBID: orgBID,
        ctx: ctx,
        report: report
    };
    var _root_children;
    var children = (_root_children = root.children) !== null && _root_children !== void 0 ? _root_children : [];
    var floorNodes = children.filter(function(c) {
        var _c_type;
        var _c_type_name;
        return stringToTwinEntityType2((_c_type_name = (_c_type = c.type) === null || _c_type === void 0 ? void 0 : _c_type.name) !== null && _c_type_name !== void 0 ? _c_type_name : "") === TwinEntityType2.FLOOR;
    }).slice().sort(function(a, b) {
        var _a_altitude, _b_altitude;
        return ((_a_altitude = a.altitude) !== null && _a_altitude !== void 0 ? _a_altitude : 0) - ((_b_altitude = b.altitude) !== null && _b_altitude !== void 0 ? _b_altitude : 0);
    });
    var floors;
    if (floorNodes.length > 0) {
        var takenIds = /* @__PURE__ */ new Set();
        var recoveredIds = floorNodes.map(function(param) {
            var bID = param.bID;
            var idMatch = /^floor-(\d+)$/.exec(bID ? stripTwinBidPrefix(bID, twinBID, orgBID) : "");
            var id = idMatch ? Number(idMatch[1]) : void 0;
            if (id === void 0 || takenIds.has(id)) return void 0;
            takenIds.add(id);
            return id;
        });
        floors = floorNodes.map(function(floorNode, index) {
            var _Math;
            var c = emptyCollected();
            var _floorNode_children;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = ((_floorNode_children = floorNode.children) !== null && _floorNode_children !== void 0 ? _floorNode_children : [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var child = _step.value;
                    collect(child, c, opts);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            var _recoveredIds_index;
            var id = (_recoveredIds_index = recoveredIds[index]) !== null && _recoveredIds_index !== void 0 ? _recoveredIds_index : takenIds.has(index + 1) ? (_Math = Math).max.apply(_Math, _to_consumable_array(Array.from(takenIds))) + 1 : index + 1;
            takenIds.add(id);
            var placement = floorPlacementFrom(floorNode, ctx, report);
            var _floorNode_name;
            return _object_spread({
                id: id,
                name: (_floorNode_name = floorNode.name) !== null && _floorNode_name !== void 0 ? _floorNode_name : "Floor ".concat(index + 1),
                level: index,
                height: 3,
                // dGraph encodes altitude, not floor height — planner default
                designs: [
                    designFrom(c)
                ]
            }, placement ? {
                placement: placement
            } : {}, isEntityCapacity3(floorNode.capacity) ? {
                capacity: floorNode.capacity
            } : {});
        });
    } else {
        var c = emptyCollected();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var child = _step.value;
                collect(child, c, opts);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var recovered = recoverCollapseFloorName(c.wallBids, {
            twinBID: twinBID,
            orgBID: orgBID
        });
        if (recovered.diagnostic) report(recovered.diagnostic);
        var _recovered_name;
        floors = [
            {
                id: 1,
                name: (_recovered_name = recovered.name) !== null && _recovered_name !== void 0 ? _recovered_name : COLLAPSE_FLOOR_FALLBACK_NAME,
                level: 0,
                height: 3,
                designs: [
                    designFrom(c)
                ]
            }
        ];
    }
    var total = floors.reduce(function(n, f) {
        var d = f.designs[0];
        return n + d.surfaces.length + d.items.length + d.walls.length;
    }, 0);
    if (total === 0) {
        throw new Error("Twin has no spatial geometry to import into a plan.");
    }
    return {
        name: twinName || root.name || twinBID,
        floors: floors
    };
};
// src/components/3D/editing/adoptionDiagnostics.ts
var collectAdoptionDiagnostics = function() {
    var messages = [];
    var counts = /* @__PURE__ */ new Map();
    var onDiagnostic = function(message) {
        var code = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "anomaly";
        messages.push(message);
        var _counts_get;
        counts.set(code, ((_counts_get = counts.get(code)) !== null && _counts_get !== void 0 ? _counts_get : 0) + 1);
        console.warn(message);
    };
    var summary = function() {
        var _counts_get;
        var skipped = (_counts_get = counts.get("skipped-no-identity")) !== null && _counts_get !== void 0 ? _counts_get : 0;
        if (skipped === 0) return void 0;
        var _counts_get1;
        var reparented = (_counts_get1 = counts.get("reparented")) !== null && _counts_get1 !== void 0 ? _counts_get1 : 0;
        var machines = skipped === 1 ? "1 entity" : "".concat(skipped, " entities");
        var flattened = reparented > 0 ? " Some equipment inside a skipped area has been attached to the area above it." : "";
        return "".concat(machines, " in this twin could not be imported, because ").concat(skipped === 1 ? "it has" : "they have", " no identity in the live model.").concat(flattened, " Going live from this plan would report them as removals, so check them before activating.");
    };
    var skippedCount = function() {
        var _counts_get;
        return (_counts_get = counts.get("skipped-no-identity")) !== null && _counts_get !== void 0 ? _counts_get : 0;
    };
    return {
        onDiagnostic: onDiagnostic,
        messages: messages,
        summary: summary,
        skippedCount: skippedCount
    };
};
// src/components/3D/editing/floorplannerApiQuery.ts
var FLOORPLANNER_SEARCH_ENDPOINT = "https://search.floorplanner.com/products/ids";
function lookupRefids(refids) {
    return _lookupRefids.apply(this, arguments);
}
function _lookupRefids() {
    _lookupRefids = _async_to_generator(function(refids) {
        var response, result, fullResult;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetch(FLOORPLANNER_SEARCH_ENDPOINT, {
                            method: "POST",
                            body: JSON.stringify({
                                ids: refids
                            }),
                            headers: {
                                "Content-Type": "application/json"
                            }
                        })
                    ];
                case 1:
                    response = _state.sent();
                    result = null;
                    if (!response.ok) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    fullResult = _state.sent();
                    result = fullResult.hits.hits.map(function(hit) {
                        return {
                            refid: hit["_id"],
                            name: hit["_source"]["name"],
                            model: hit["_source"]["model"],
                            isNew: true
                        };
                    });
                    _state.label = 3;
                case 3:
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return _lookupRefids.apply(this, arguments);
}
// src/components/3D/editing/ImportErrorsList.tsx
import { Fragment as Fragment41, jsx as jsx155, jsxs as jsxs108 } from "react/jsx-runtime";
function ImportErrorsList(param) {
    var errors = param.errors;
    return /* @__PURE__ */ jsxs108(Fragment41, {
        children: [
            /* @__PURE__ */ jsx155("h3", {
                children: "Errors"
            }),
            /* @__PURE__ */ jsx155("p", {
                style: {
                    overflow: "scroll",
                    height: "450px"
                },
                children: /* @__PURE__ */ jsx155("ul", {
                    children: errors.map(function(error, index) {
                        return /* @__PURE__ */ jsx155("li", {
                            style: {
                                margin: "20px"
                            },
                            children: /* @__PURE__ */ jsx155(ImportError, {
                                error: error
                            }, index)
                        });
                    })
                })
            })
        ]
    });
}
function ImportError(param) {
    var error = param.error;
    if ("id" in error) {
        var _error_entityInfo = _sliced_to_array(error.entityInfo, 2), firstEntity = _error_entityInfo[0], secondEntity = _error_entityInfo[1];
        return /* @__PURE__ */ jsxs108(Fragment41, {
            children: [
                /* @__PURE__ */ jsx155("h3", {
                    children: "Duplicate ID:"
                }),
                /* @__PURE__ */ jsxs108("p", {
                    children: [
                        error.id,
                        " - Duplicate names: ",
                        firstEntity.name,
                        ", ",
                        secondEntity.name
                    ]
                }),
                /* @__PURE__ */ jsx155("p", {
                    children: "\xA0"
                })
            ]
        });
    } else {
        return /* @__PURE__ */ jsxs108(Fragment41, {
            children: [
                /* @__PURE__ */ jsx155("h3", {
                    children: "Custom Name Format Error:"
                }),
                /* @__PURE__ */ jsx155("pre", {
                    children: error.message
                }),
                /* @__PURE__ */ jsxs108("pre", {
                    children: [
                        "Custom Name: ",
                        error.value
                    ]
                }),
                /* @__PURE__ */ jsx155("p", {
                    children: "\xA0"
                })
            ]
        });
    }
}
// src/components/3D/outlines/OutlineSolid.tsx
import { useMemo as useMemo33 } from "react";
import { DoubleSide as DoubleSide3 } from "three";
import { LineSegments2 } from "three/examples/jsm/lines/LineSegments2.js";
import { LineMaterial } from "three/examples/jsm/lines/LineMaterial.js";
// src/components/3D/outlines/utils.ts
import { EdgesGeometry } from "three";
import { LineSegmentsGeometry } from "three/examples/jsm/lines/LineSegmentsGeometry.js";
function makeLineGeometry(geometry) {
    var edgesGeometry = new EdgesGeometry(geometry);
    var lineGeometry = new LineSegmentsGeometry().fromEdgesGeometry(edgesGeometry);
    return lineGeometry;
}
// src/components/3D/outlines/OutlineSolid.tsx
import { jsx as jsx156 } from "react/jsx-runtime";
var OutlineSolid = function(param) {
    var geometry = param.geometry, color = param.color, lineWidth = param.lineWidth, _param_visible = param.visible, visible = _param_visible === void 0 ? true : _param_visible;
    var edgepoints = useMemo33(function() {
        var lineGeometry = makeLineGeometry(geometry);
        var material3 = new LineMaterial({
            side: DoubleSide3,
            color: color ? color : defaultColours.assetStates.default.bounds.color,
            linewidth: lineWidth,
            worldUnits: true
        });
        var line9 = new LineSegments2(lineGeometry, material3);
        return line9;
    }, [
        color,
        geometry,
        lineWidth
    ]);
    return /* @__PURE__ */ jsx156("group", {
        children: /* @__PURE__ */ jsx156("primitive", {
            visible: visible,
            object: edgepoints
        })
    });
};
// src/components/3D/behaviours/NotTracked.tsx
import { jsx as jsx157, jsxs as jsxs109 } from "react/jsx-runtime";
var material = new NotTrackedMaterial(DIRECTION_LIGHT_POSITION, DIRECTION_LIGHT_TARGET);
var NotTracked = function(param) {
    var geometry = param.geometry, visible = param.visible, showOutline = param.showOutline;
    return /* @__PURE__ */ jsxs109("group", {
        visible: visible,
        children: [
            /* @__PURE__ */ jsx157(OutlineSolid, {
                geometry: geometry,
                lineWidth: 0.03,
                color: 8421504,
                visible: showOutline
            }),
            /* @__PURE__ */ jsx157("mesh", {
                geometry: geometry,
                material: material
            })
        ]
    });
};
// src/components/3D/behaviours/Tracked.tsx
import { DoubleSide as DoubleSide4, Vector2 as Vector26 } from "three";
import { jsx as jsx158, jsxs as jsxs110 } from "react/jsx-runtime";
var NORMAL_SCALE = new Vector26(0.25, 0.25);
function Tracked(param) {
    var visible = param.visible, geometry = param.geometry, color = param.color, showOutline = param.showOutline, entity = param.entity;
    return /* @__PURE__ */ jsxs110("group", {
        visible: visible,
        children: [
            /* @__PURE__ */ jsx158(OutlineSolid, {
                geometry: geometry,
                lineWidth: 0.03,
                color: color,
                visible: showOutline
            }),
            /* @__PURE__ */ jsx158("mesh", {
                userData: entity,
                geometry: geometry,
                children: /* @__PURE__ */ jsx158("meshStandardMaterial", {
                    color: color,
                    forceSinglePass: true,
                    transparent: true,
                    opacity: 0.4,
                    roughness: 0.6,
                    metalness: 0.25,
                    side: DoubleSide4,
                    normalScale: NORMAL_SCALE,
                    depthWrite: false
                })
            })
        ]
    });
}
// src/components/3D/outlines/OutlineDashed.tsx
import { useMemo as useMemo34 } from "react";
import { Vector2 as Vector27 } from "three";
import { LineSegments2 as LineSegments22 } from "three/examples/jsm/lines/LineSegments2.js";
import { LineMaterial as LineMaterial2 } from "three/examples/jsm/lines/LineMaterial.js";
import { jsx as jsx159 } from "react/jsx-runtime";
var DASH = {
    dashSize: 0.125,
    gapSize: 0.125
};
var canvasSize = new Vector27();
var material2 = new LineMaterial2(_object_spread({
    color: FROSTED_CRYSTAL_GLOW,
    linewidth: 0.07,
    dashed: true,
    worldUnits: true
}, DASH));
var screenMaterials = /* @__PURE__ */ new Map();
var dashedOutlineMaterial = function(screenWidthPx) {
    if (screenWidthPx === void 0) return material2;
    var shared = screenMaterials.get(screenWidthPx);
    if (!shared) {
        shared = new LineMaterial2(_object_spread({
            color: FROSTED_CRYSTAL_GLOW,
            linewidth: screenWidthPx,
            dashed: true,
            worldUnits: false
        }, DASH));
        screenMaterials.set(screenWidthPx, shared);
    }
    return shared;
};
var OutlineDashed = function(param) {
    var geometry = param.geometry, _param_visible = param.visible, visible = _param_visible === void 0 ? true : _param_visible, screenWidthPx = param.screenWidthPx;
    var outlineObject = useMemo34(function() {
        var lineGeometry = makeLineGeometry(geometry);
        var lineMaterial = dashedOutlineMaterial(screenWidthPx);
        if (screenWidthPx === void 0) {
            lineMaterial.resolution.set(window.innerWidth, window.innerHeight);
        }
        var edges = new LineSegments22(lineGeometry, lineMaterial);
        edges.computeLineDistances();
        if (screenWidthPx !== void 0) {
            edges.onBeforeRender = function(renderer) {
                renderer.getSize(canvasSize);
                lineMaterial.resolution.copy(canvasSize);
            };
        }
        return edges;
    }, [
        geometry,
        screenWidthPx
    ]);
    return /* @__PURE__ */ jsx159("group", {
        children: /* @__PURE__ */ jsx159("primitive", {
            visible: visible,
            object: outlineObject
        })
    });
};
// src/components/3D/outlines/SelectionOutline.tsx
import { Fragment as Fragment42, jsx as jsx160, jsxs as jsxs111 } from "react/jsx-runtime";
var SelectionOutlines = function(param) {
    var geometry = param.geometry, showDashedOutline = param.showDashedOutline, showSolidOutline = param.showSolidOutline, dashedScreenWidthPx = param.dashedScreenWidthPx;
    return /* @__PURE__ */ jsxs111(Fragment42, {
        children: [
            /* @__PURE__ */ jsx160(OutlineSolid, {
                color: FROSTED_CRYSTAL_GLOW,
                lineWidth: 0.07,
                geometry: geometry,
                visible: showSolidOutline
            }),
            /* @__PURE__ */ jsx160(OutlineDashed, {
                geometry: geometry,
                visible: showDashedOutline,
                screenWidthPx: dashedScreenWidthPx
            })
        ]
    });
};
// src/components/3D/HeroDonut/HeroDonut.tsx
import { useEffect as useEffect54, useRef as useRef31, useState as useState80 } from "react";
import styled108, { css as css5 } from "styled-components";
import * as THREE from "three";
import { Canvas, useFrame as useFrame3 } from "@react-three/fiber";
import { jsx as jsx161, jsxs as jsxs112 } from "react/jsx-runtime";
var heroDonutStyle = css5(_templateObject237());
var DonutMesh = function(param) {
    var value = param.value, fillValue = param.fillValue, outerColor = param.outerColor, innerColor = param.innerColor, _param_torusRotation = param.torusRotation, torusRotation = _param_torusRotation === void 0 ? [
        0,
        0,
        0
    ] : _param_torusRotation;
    var meshRef = useRef31(null);
    var _useState80 = _sliced_to_array(useState80(null), 2), geometry = _useState80[0], setGeometry = _useState80[1];
    var _useState801 = _sliced_to_array(useState80(null), 2), material3 = _useState801[0], setMaterial = _useState801[1];
    var getTubeThickness = function(val) {
        if (val <= 100) return 0.18;
        if (val <= 125) return 0.22;
        return 0.26;
    };
    useEffect54(function() {
        var tubeThickness = getTubeThickness(value);
        var torusGeometry = new THREE.TorusGeometry(1, tubeThickness, 64, 256);
        setGeometry(torusGeometry);
        var shaderMaterial = new THREE.ShaderMaterial({
            uniforms: {
                color: {
                    value: new THREE.Color(outerColor)
                },
                innerColor: {
                    value: new THREE.Color(innerColor)
                },
                white: {
                    value: new THREE.Color("#ffffff")
                },
                value: {
                    value: fillValue
                },
                time: {
                    value: 0
                }
            },
            vertexShader: "\n                varying vec3 vPosition;\n                varying vec3 vNormal;\n                varying vec2 vUv;\n                varying vec3 vViewPosition;\n                void main() {\n                    vPosition = position;\n                    vNormal = normalize(normalMatrix * normal);\n                    vUv = uv;\n                    vec4 mvPosition = modelViewMatrix * vec4(position, 1.0);\n                    vViewPosition = -mvPosition.xyz;\n                    gl_Position = projectionMatrix * mvPosition;\n                }\n            ",
            fragmentShader: "\n                uniform vec3 color;\n                uniform vec3 innerColor;\n                uniform vec3 white;\n                uniform float value;\n                uniform float time;\n                varying vec3 vPosition;\n                varying vec3 vNormal;\n                varying vec2 vUv;\n                varying vec3 vViewPosition;\n\n                void main() {\n                    float angle = atan(vPosition.y, vPosition.x) + 1.57079632679;\n                    if (angle < 0.0) angle += 6.28318530718;\n                    float percent = value;\n                    float cutoff = 6.28318530718 * percent;\n                    \n                    // Fresnel effect for glow\n                    vec3 viewDirection = normalize(vViewPosition);\n                    float fresnel = 1.0 - abs(dot(vNormal, viewDirection));\n                    \n                    // Create soft lighting\n                    vec3 lightDir = normalize(vec3(0.5, 0.8, 1.0));\n                    float NdotL = max(dot(vNormal, lightDir), 0.3);\n                    \n                    // Enhanced color with depth\n                    float radialGradient = length(vUv - 0.5) * 1.5;\n                    vec3 lightColor = mix(color, vec3(1.0), 0.2); // Fine-tuned white mixing\n                    vec3 lightInnerColor = mix(innerColor, vec3(1.0), 0.2); // Fine-tuned white mixing\n                    vec3 gradientColor = mix(lightColor * 1.15, lightInnerColor * 0.95, radialGradient * 0.3);\n                    \n                    // Add subtle color variation - lighter\n                    float colorVariation = 1.0 + 0.1 * sin(angle * 2.0);\n                    gradientColor *= colorVariation;\n                    \n                    // Enhanced white background - brighter\n                    vec3 enhancedWhite = white * (1.0 + fresnel * 0.1);\n                    \n                    // Apply lighting - match tracked donut approach\n                    gradientColor *= (0.8 + NdotL * 0.4);\n                    enhancedWhite *= (1.0 + NdotL * 0.05);\n                    \n                    // Add proper torus inner shadow using 3D position\n                    float torusRadius = 1.0; // Major radius of torus\n                    float tubeRadius = 0.18; // Minor radius (tube thickness)\n                    \n                    // Calculate distance from torus center line in 3D space\n                    float distFromTorusCenter = length(vec2(vPosition.x, vPosition.y));\n                    float distFromTubeSurface = abs(distFromTorusCenter - torusRadius);\n                    \n                    // Create inner shadow focused more towards center\n                    float innerShadow = 1.0;\n                    \n                    // Focus shadow on inner part of torus tube\n                    if (distFromTorusCenter < torusRadius) {\n                        // Calculate how close we are to the inner edge\n                        float innerEdgeDist = torusRadius - distFromTorusCenter;\n                        float shadowRange = tubeRadius * 1.5; // More spread out\n                        \n                        if (innerEdgeDist <= shadowRange) {\n                            float shadowFactor = innerEdgeDist / shadowRange;\n                            // Light grey shadow covers entire inner area\n                            shadowFactor = smoothstep(0.0, 1.0, 1.0 - shadowFactor); \n                            innerShadow = 0.65 + shadowFactor * 0.35; // Balanced light grey shadow\n                        }\n                    }\n                    \n                    gradientColor *= innerShadow;\n                    enhancedWhite *= innerShadow;\n                    \n                    // Add rim glow effect\n                    float rimPower = 2.0;\n                    float rimIntensity = pow(fresnel, rimPower) * 0.8;\n                    vec3 rimColor = gradientColor * rimIntensity;\n                    \n                    // Add frosted white outer glow\n                    float outerGlow = 0.0;\n                    float distFromTorusEdge = abs(distFromTubeSurface);\n                    float glowRange = tubeRadius * 2.5; // Even more spread out\n                    \n                    if (distFromTorusCenter > torusRadius - tubeRadius * 0.2) { // Start glow closer to edge (back to original)\n                        float adjustedDist = max(0.0, distFromTorusEdge - tubeRadius * 0.1); // Start closer\n                        // Use double smoothstep for smoother falloff like the shadow\n                        float glowFactor = 1.0 - smoothstep(0.0, glowRange, adjustedDist);\n                        glowFactor = smoothstep(0.0, 1.0, glowFactor); // Second smoothstep for extra smoothness\n                        outerGlow = glowFactor * 0.15; // Reduced intensity\n                    }\n                    \n                    // Final color selection\n                    vec3 finalColor = (angle >= (6.28318530718 - cutoff)) \n                        ? gradientColor + rimColor \n                        : enhancedWhite;\n                    \n                    // Add frosted white glow to final color\n                    finalColor += vec3(1.0, 1.0, 1.0) * outerGlow;\n                    \n                    // Soft transparency with glow\n                    float alpha = 0.95;\n                    alpha += rimIntensity * 0.3;\n                    alpha = min(alpha, 1.0);\n                    \n                    gl_FragColor = vec4(finalColor, alpha);\n                }\n            ",
            transparent: true,
            depthWrite: false
        });
        setMaterial(shaderMaterial);
    }, [
        outerColor,
        innerColor,
        value,
        fillValue
    ]);
    useFrame3(function(state) {
        if (material3) {
            material3.uniforms.value.value = fillValue;
            material3.uniforms.time.value = state.clock.getElapsedTime();
        }
    });
    if (!geometry || !material3) return null;
    return /* @__PURE__ */ jsxs112("mesh", {
        ref: meshRef,
        rotation: torusRotation,
        children: [
            /* @__PURE__ */ jsx161("primitive", {
                object: geometry
            }),
            /* @__PURE__ */ jsx161("primitive", {
                object: material3
            })
        ]
    });
};
var StripedDonutMesh = function(param) {
    var _param_torusRotation = param.torusRotation, torusRotation = _param_torusRotation === void 0 ? [
        0,
        0,
        0
    ] : _param_torusRotation;
    var meshRef = useRef31(null);
    var _useState80 = _sliced_to_array(useState80(null), 2), geometry = _useState80[0], setGeometry = _useState80[1];
    var _useState801 = _sliced_to_array(useState80(null), 2), material3 = _useState801[0], setMaterial = _useState801[1];
    useEffect54(function() {
        var torusGeometry = new THREE.TorusGeometry(1, 0.18, 64, 256);
        setGeometry(torusGeometry);
        var shaderMaterial = new THREE.ShaderMaterial({
            uniforms: {
                baseColor: {
                    value: new THREE.Color("#D0D0D0")
                },
                stripeColor: {
                    value: new THREE.Color("#F0F0F0")
                },
                time: {
                    value: 0
                }
            },
            vertexShader: "\n                varying vec3 vPosition;\n                varying vec3 vNormal;\n                varying vec2 vUv;\n                varying vec3 vViewPosition;\n                void main() {\n                    vPosition = position;\n                    vNormal = normalize(normalMatrix * normal);\n                    vUv = uv;\n                    vec4 mvPosition = modelViewMatrix * vec4(position, 1.0);\n                    vViewPosition = -mvPosition.xyz;\n                    gl_Position = projectionMatrix * mvPosition;\n                }\n            ",
            fragmentShader: "\n                uniform vec3 baseColor;\n                uniform vec3 stripeColor;\n                uniform float time;\n                varying vec3 vPosition;\n                varying vec3 vNormal;\n                varying vec2 vUv;\n                varying vec3 vViewPosition;\n\n                void main() {\n                    // Calculate angle for radial positioning\n                    float angle = atan(vPosition.y, vPosition.x) + 1.57079632679;\n                    if (angle < 0.0) angle += 6.28318530718;\n                    \n                    // Create diagonal stripes using both radial and UV coordinates\n                    float stripePattern = sin((angle * 8.0) + (vUv.x * 20.0)) * 0.5 + 0.5;\n                    \n                    // Make stripes more defined\n                    stripePattern = step(0.5, stripePattern);\n                    \n                    // Fresnel effect for glow\n                    vec3 viewDirection = normalize(vViewPosition);\n                    float fresnel = 1.0 - abs(dot(vNormal, viewDirection));\n                    \n                    // Create soft lighting\n                    vec3 lightDir = normalize(vec3(0.5, 0.8, 1.0));\n                    float NdotL = max(dot(vNormal, lightDir), 0.3);\n                    \n                    // Mix base and stripe colors\n                    vec3 finalColor = mix(baseColor, stripeColor, stripePattern);\n                    \n                    // Apply lighting - softer like tracked donuts\n                    finalColor *= (0.8 + NdotL * 0.4);\n                    \n                    // Add proper torus inner shadow using 3D position (same as tracked donut)\n                    float torusRadius = 1.0; // Major radius of torus\n                    float tubeRadius = 0.18; // Minor radius (tube thickness)\n                    \n                    // Calculate distance from torus center line in 3D space\n                    float distFromTorusCenter = length(vec2(vPosition.x, vPosition.y));\n                    float distFromTubeSurface = abs(distFromTorusCenter - torusRadius);\n                    \n                    // Create inner shadow focused more towards center\n                    float innerShadow = 1.0;\n                    \n                    // Focus shadow on inner part of torus tube\n                    if (distFromTorusCenter < torusRadius) {\n                        // Calculate how close we are to the inner edge\n                        float innerEdgeDist = torusRadius - distFromTorusCenter;\n                        float shadowRange = tubeRadius * 1.5; // More spread out\n                        \n                        if (innerEdgeDist <= shadowRange) {\n                            float shadowFactor = innerEdgeDist / shadowRange;\n                            // Light grey shadow covers entire inner area\n                            shadowFactor = smoothstep(0.0, 1.0, 1.0 - shadowFactor); \n                            innerShadow = 0.65 + shadowFactor * 0.35; // Balanced light grey shadow\n                        }\n                    }\n                    \n                    finalColor *= innerShadow;\n                    \n                    // Add rim glow effect\n                    float rimPower = 2.0;\n                    float rimIntensity = pow(fresnel, rimPower) * 0.3;\n                    finalColor += rimIntensity;\n                    \n                    // Add frosted white outer glow\n                    float outerGlow = 0.0;\n                    float distFromTorusEdge = abs(distFromTubeSurface);\n                    float glowRange = tubeRadius * 2.5; // Even more spread out\n                    \n                    if (distFromTorusCenter > torusRadius - tubeRadius * 0.2) { // Start glow closer to edge (back to original)\n                        float adjustedDist = max(0.0, distFromTorusEdge - tubeRadius * 0.1); // Start closer\n                        // Use double smoothstep for smoother falloff like the shadow\n                        float glowFactor = 1.0 - smoothstep(0.0, glowRange, adjustedDist);\n                        glowFactor = smoothstep(0.0, 1.0, glowFactor); // Second smoothstep for extra smoothness\n                        outerGlow = glowFactor * 0.15; // Reduced intensity\n                    }\n                    \n                    // Add frosted white glow to final color\n                    finalColor += vec3(1.0, 1.0, 1.0) * outerGlow;\n                    \n                    // Soft transparency\n                    float alpha = 0.85 + rimIntensity * 0.15;\n                    alpha = min(alpha, 1.0);\n                    \n                    gl_FragColor = vec4(finalColor, alpha);\n                }\n            ",
            transparent: true,
            depthWrite: false
        });
        setMaterial(shaderMaterial);
    }, []);
    useFrame3(function(state) {
        if (material3) {
            material3.uniforms.time.value = state.clock.getElapsedTime();
        }
    });
    if (!geometry || !material3) return null;
    return /* @__PURE__ */ jsxs112("mesh", {
        ref: meshRef,
        rotation: torusRotation,
        children: [
            /* @__PURE__ */ jsx161("primitive", {
                object: geometry
            }),
            /* @__PURE__ */ jsx161("primitive", {
                object: material3
            })
        ]
    });
};
var UntrackedHeroDonut_ = function(param) {
    var className = param.className, _param_isUtilization = param.isUtilization, isUtilization = _param_isUtilization === void 0 ? false : _param_isUtilization;
    return /* @__PURE__ */ jsxs112("div", {
        className: className,
        style: {
            position: "relative",
            width: "110px",
            height: "110px"
        },
        children: [
            /* @__PURE__ */ jsxs112(Canvas, {
                camera: {
                    position: [
                        0,
                        0,
                        3
                    ],
                    fov: 50
                },
                style: {
                    width: "110px",
                    height: "110px"
                },
                children: [
                    /* @__PURE__ */ jsx161("ambientLight", {
                        intensity: 1
                    }),
                    /* @__PURE__ */ jsx161("directionalLight", {
                        position: [
                            2,
                            4,
                            6
                        ],
                        intensity: 0.35
                    }),
                    /* @__PURE__ */ jsx161("pointLight", {
                        position: [
                            0,
                            0,
                            4
                        ],
                        intensity: 0.25
                    }),
                    /* @__PURE__ */ jsx161(StripedDonutMesh, {
                        torusRotation: [
                            0,
                            0,
                            0
                        ]
                    })
                ]
            }),
            /* @__PURE__ */ jsx161("div", {
                style: {
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    pointerEvents: "none",
                    fontFamily: '"Inter", sans-serif',
                    fontWeight: 600,
                    fontSize: "0.9em",
                    color: "#242424",
                    textShadow: "0 1px 4px #fff, 0 0 2px #fff",
                    letterSpacing: "0.01em",
                    userSelect: "none",
                    whiteSpace: "nowrap"
                },
                children: "Untracked"
            })
        ]
    });
};
var UntrackedHeroDonut = styled108(UntrackedHeroDonut_)(_templateObject238(), heroDonutStyle);
var TrackedHeroDonut_ = function(param) {
    var className = param.className, zeroToOneValue = param.zeroToOneValue, text = param.text, percent = param.percent, outerColor = param.outerColor, innerColor = param.innerColor, indicatorValue = param.indicatorValue;
    var _useState80 = _sliced_to_array(useState80(false), 2), ready = _useState80[0], setReady = _useState80[1];
    useEffect54(function() {
        setReady(true);
    }, []);
    var torusRotation = [
        0,
        0,
        0
    ];
    return /* @__PURE__ */ jsxs112("div", {
        className: "".concat(className, " donut-3d-container").concat(!ready ? " undonut" : ""),
        style: {
            position: "relative",
            width: "110px",
            height: "110px"
        },
        children: [
            /* @__PURE__ */ jsxs112(Canvas, {
                camera: {
                    position: [
                        0,
                        0,
                        3
                    ],
                    fov: 50
                },
                style: {
                    width: "110px",
                    height: "110px"
                },
                children: [
                    /* @__PURE__ */ jsx161("ambientLight", {
                        intensity: 1
                    }),
                    /* @__PURE__ */ jsx161("directionalLight", {
                        position: [
                            2,
                            4,
                            6
                        ],
                        intensity: 0.35
                    }),
                    /* @__PURE__ */ jsx161("pointLight", {
                        position: [
                            0,
                            0,
                            4
                        ],
                        intensity: 0.25
                    }),
                    /* @__PURE__ */ jsx161(DonutMesh, {
                        value: indicatorValue,
                        fillValue: zeroToOneValue,
                        outerColor: outerColor,
                        innerColor: innerColor,
                        torusRotation: torusRotation
                    })
                ]
            }),
            /* @__PURE__ */ jsxs112("div", {
                style: {
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    pointerEvents: "none",
                    fontFamily: '"Inter", sans-serif',
                    fontWeight: 600,
                    fontSize: "1.3em",
                    color: "#242424",
                    textShadow: "0 1px 4px #fff, 0 0 2px #fff",
                    letterSpacing: "0.01em",
                    userSelect: "none",
                    whiteSpace: "nowrap"
                },
                children: [
                    text,
                    percent ? /* @__PURE__ */ jsx161("span", {
                        style: {
                            fontSize: "0.7em",
                            position: "relative",
                            top: "0.2em"
                        },
                        children: "%"
                    }) : ""
                ]
            })
        ]
    });
};
var TrackedHeroDonut = styled108(TrackedHeroDonut_)(_templateObject239(), heroDonutStyle);
// src/components/3D/Wall.tsx
import { useEffect as useEffect55, useMemo as useMemo35 } from "react";
import { DoubleSide as DoubleSide5, ExtrudeGeometry as ExtrudeGeometry3, MeshStandardMaterial as MeshStandardMaterial3, Shape as Shape4, Vector2 as Vector28 } from "three";
import { jsx as jsx162 } from "react/jsx-runtime";
var wallMaterial = new MeshStandardMaterial3({
    color: defaultColours.staticGray,
    transparent: true,
    opacity: 0.5,
    roughness: 0.45,
    metalness: 0.3,
    side: DoubleSide5,
    normalScale: new Vector28(0.11, 0.11),
    forceSinglePass: true
});
var isJoinedWall = function(entity) {
    var raw = entity.definitions;
    if (typeof raw !== "string" || !raw) return false;
    try {
        var defs = decodeBase64Json(raw);
        return !!defs && (typeof defs === "undefined" ? "undefined" : _type_of(defs)) === "object" && !!defs.plan_wall;
    } catch (e) {
        return false;
    }
};
var wallShapePoints = function(entity) {
    var _entity_boundaries;
    var joined = isJoinedWall(entity);
    var _entity_boundaries_polygons;
    return ((_entity_boundaries_polygons = (_entity_boundaries = entity.boundaries) === null || _entity_boundaries === void 0 ? void 0 : _entity_boundaries.polygons) !== null && _entity_boundaries_polygons !== void 0 ? _entity_boundaries_polygons : []).map(function(polygon) {
        var worldSpaceOutline = coordLocalOutlineToVector2(polygon.coordinates[0].points);
        return joined ? worldSpaceOutline.map(function(p) {
            return new Vector28(p.x, -p.y);
        }) : expandOutline(worldSpaceOutline, -1e-3);
    });
};
var Wall = function(param) {
    var entity = param.entity, depth = param.depth, tmp = param.material, material3 = tmp === void 0 ? wallMaterial : tmp;
    var areaGeometry = useMemo35(function() {
        var shapes = wallShapePoints(entity).map(function(areaPoints) {
            return new Shape4(areaPoints);
        });
        var areaGeo = new ExtrudeGeometry3(shapes, extrudeSettingsWall);
        areaGeo.rotateX(-Math.PI / 2);
        return areaGeo;
    }, [
        entity
    ]);
    useEffect55(function() {
        return function() {
            return areaGeometry.dispose();
        };
    }, [
        areaGeometry
    ]);
    return /* @__PURE__ */ jsx162("mesh", {
        geometry: areaGeometry,
        material: material3,
        position: [
            0,
            depth / 100 - 0.01,
            0
        ],
        castShadow: true,
        receiveShadow: true
    });
};
// src/components/3D/postprocessing/PostProcesses.tsx
import { Bloom, EffectComposer, N8AO, SMAA } from "@react-three/postprocessing";
import { useFrame as useFrame4 } from "@react-three/fiber";
// src/components/3D/postprocessing/PremultipliedOutputEffect.tsx
import { useEffect as useEffect56, useMemo as useMemo36 } from "react";
import { BlendFunction, Effect } from "postprocessing";
import { jsx as jsx163 } from "react/jsx-runtime";
var premultipliedOutputFrag = "\n    vec3 linearToSRGB(const in vec3 v) {\n        return mix(pow(v, vec3(0.41666)) * 1.055 - vec3(0.055), v * 12.92, vec3(lessThanEqual(v, vec3(0.0031308))));\n    }\n\n    void mainImage(const in vec4 inputColor, const in vec2 uv, out vec4 outputColor) {\n        float a = clamp(inputColor.a, 0.0, 1.0);\n        if (a <= 0.0) {\n            outputColor = vec4(0.0);\n            return;\n        }\n        vec3 encoded = linearToSRGB(max(inputColor.rgb / a, vec3(0.0))) * a;\n        outputColor = sRGBToLinear(vec4(encoded, a));\n    }\n";
var PremultipliedOutputEffect = /*#__PURE__*/ function(Effect) {
    "use strict";
    _inherits(PremultipliedOutputEffect, Effect);
    function PremultipliedOutputEffect() {
        _class_call_check(this, PremultipliedOutputEffect);
        return _call_super(this, PremultipliedOutputEffect, [
            "PremultipliedOutputEffect",
            premultipliedOutputFrag,
            {
                blendFunction: BlendFunction.SRC
            }
        ]);
    }
    return PremultipliedOutputEffect;
}(Effect);
var PremultipliedOutput = function() {
    var effect = useMemo36(function() {
        return new PremultipliedOutputEffect();
    }, []);
    useEffect56(function() {
        return function() {
            effect.dispose();
        };
    }, [
        effect
    ]);
    return /* @__PURE__ */ jsx163("primitive", {
        object: effect
    });
};
// src/components/3D/postprocessing/PostProcesses.tsx
import { Suspense, useEffect as useEffect57, useMemo as useMemo37, useRef as useRef32 } from "react";
import { jsx as jsx164 } from "react/jsx-runtime";
var readOcclusion = function(getOcclusion) {
    var _getOcclusion;
    var strength = (_getOcclusion = getOcclusion === null || getOcclusion === void 0 ? void 0 : getOcclusion()) !== null && _getOcclusion !== void 0 ? _getOcclusion : 1;
    return Number.isFinite(strength) ? Math.min(1, Math.max(0, strength)) : 1;
};
var disposePass = function(pass) {
    pass.dispose();
    Object.values(pass).forEach(function(value) {
        var quad = value;
        if (quad && quad._mesh && typeof quad.dispose === "function") quad.dispose();
    });
};
var PostProcessChain = function(param) {
    var _param_effects = param.effects, effects = _param_effects === void 0 ? {} : _param_effects, getOcclusion = param.getOcclusion, _param_stencil = param.stencil, stencil = _param_stencil === void 0 ? false : _param_stencil;
    var _effects_bloom = effects.bloom, bloom = _effects_bloom === void 0 ? true : _effects_bloom, _effects_n8ao = effects.n8ao, n8ao = _effects_n8ao === void 0 ? true : _effects_n8ao, _effects_smaa = effects.smaa, smaa = _effects_smaa === void 0 ? true : _effects_smaa;
    var composer = useRef32(null);
    var occlusionPass = useRef32(null);
    var occlusion = useRef32(getOcclusion);
    occlusion.current = getOcclusion;
    useFrame4(function() {
        var pass = occlusionPass.current;
        if (pass) pass.configuration.intensity = readOcclusion(occlusion.current);
    });
    var passesSeen = useRef32(/* @__PURE__ */ new Map());
    var setKey = "".concat(bloom, "-").concat(n8ao, "-").concat(smaa, "-").concat(stencil);
    useEffect57(function() {
        var mounted = composer.current;
        if (!mounted) return;
        var _passesSeen_current_get;
        var seen = (_passesSeen_current_get = passesSeen.current.get(mounted)) !== null && _passesSeen_current_get !== void 0 ? _passesSeen_current_get : /* @__PURE__ */ new Set();
        mounted.passes.forEach(function(pass) {
            return seen.add(pass);
        });
        passesSeen.current.set(mounted, seen);
    });
    useEffect57(function() {
        var mounted = composer.current;
        return function() {
            setTimeout(function() {
                var _passesSeen_current_get;
                if (!mounted || composer.current === mounted) return;
                (_passesSeen_current_get = passesSeen.current.get(mounted)) === null || _passesSeen_current_get === void 0 ? void 0 : _passesSeen_current_get.forEach(disposePass);
                passesSeen.current.delete(mounted);
                mounted.dispose();
            });
        };
    }, [
        setKey
    ]);
    var chain = useMemo37(function() {
        return [
            // Always first, never switchable: it corrects the scene before Bloom adds its glow as light.
            /* @__PURE__ */ jsx164(PremultipliedOutput, {}, "premultipliedOutput"),
            bloom && /* @__PURE__ */ jsx164(Bloom, {
                luminanceThreshold: 1,
                intensity: 0.5,
                radius: 0.5,
                mipmapBlur: true
            }, "bloom"),
            n8ao && /* @__PURE__ */ jsx164(N8AO, {
                ref: occlusionPass,
                aoRadius: 30,
                intensity: 1,
                screenSpaceRadius: true,
                halfRes: true,
                distanceFalloff: 0.2,
                quality: "performance"
            }, "n8ao"),
            smaa && /* @__PURE__ */ jsx164(SMAA, {}, "smaa")
        ].filter(Boolean);
    }, [
        bloom,
        n8ao,
        smaa
    ]);
    return /* @__PURE__ */ jsx164(Suspense, {
        fallback: null,
        children: /* @__PURE__ */ jsx164(EffectComposer, {
            ref: composer,
            multisampling: 0,
            stencilBuffer: stencil,
            children: chain
        }, setKey)
    });
};
var PostProcesses = function() {
    return /* @__PURE__ */ jsx164(PostProcessChain, {});
};
// src/components/3D/utils/DownloadManager.ts
import { DRACOLoader, GLTFLoader } from "three-stdlib";
var filenameRegex = /([^/?]+)(?:\?|$)/;
var _DownloadManager = /*#__PURE__*/ function() {
    "use strict";
    function _DownloadManager() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_concurrentDownloads = _ref.concurrentDownloads, concurrentDownloads = _ref_concurrentDownloads === void 0 ? 100 : _ref_concurrentDownloads, _ref_enableLogging = _ref.enableLogging, enableLogging = _ref_enableLogging === void 0 ? false : _ref_enableLogging;
        _class_call_check(this, _DownloadManager);
        this.downloadState = /* @__PURE__ */ new Map();
        this.totalDownloads = 0;
        this.completedDownloads = 0;
        this.abandonedDownloads = 0;
        this.isProcessing = false;
        this.loader = new GLTFLoader();
        this.maxRetries = 5;
        this.maxRetriesFor404 = 1;
        this.progressCallbacks = [];
        this.addedCallbacks = [];
        this.suppress404Logging = true;
        this.concurrentDownloads = concurrentDownloads;
        this.enableLogging = enableLogging;
        this.log = enableLogging ? console.log : function() {};
        var dracoLoader = new DRACOLoader();
        dracoLoader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.4.1/");
        dracoLoader.setDecoderConfig({
            type: "js"
        });
        this.loader.setDRACOLoader(dracoLoader);
    }
    _create_class(_DownloadManager, [
        {
            key: "setSuppress404Logging",
            value: function setSuppress404Logging(suppress) {
                this.suppress404Logging = suppress;
            }
        },
        {
            key: "isComplete",
            value: function isComplete() {
                return this.totalDownloads === this.completedDownloads + this.abandonedDownloads;
            }
        },
        {
            key: "updateProgress",
            value: function updateProgress() {
                var total = this.totalDownloads;
                var completed = this.completedDownloads + this.abandonedDownloads;
                var newProgress = total === 0 ? 1 : completed / total;
                this.progressCallbacks.forEach(function(callback) {
                    return callback(newProgress);
                });
            }
        },
        {
            key: "processDownloads",
            value: function processDownloads() {
                var _this = this;
                return _async_to_generator(function() {
                    var _loop, _ret;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _loop = function() {
                                    var urlsToProcess, downloadPromises, results;
                                    return _ts_generator(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                urlsToProcess = [];
                                                _this.downloadState.forEach(function(state, url) {
                                                    if ((state.status === "newly-added" || state.status === "errored") && urlsToProcess.length < _this.concurrentDownloads) {
                                                        urlsToProcess.push(url);
                                                    }
                                                });
                                                if (urlsToProcess.length === 0) return [
                                                    2,
                                                    "break"
                                                ];
                                                downloadPromises = urlsToProcess.map(function(url) {
                                                    var state = _this.downloadState.get(url);
                                                    if (!state) return Promise.resolve(null);
                                                    if (state.status !== "errored") {
                                                        _this.totalDownloads += 1;
                                                    }
                                                    state.status = "downloading";
                                                    _this.downloadState.set(url, state);
                                                    _this.log("Initiating download for model: ".concat(url));
                                                    if (!state.promise) {
                                                        state.promise = new Promise(function(resolve, reject) {
                                                            _this.loader.load(url, function(gltf) {
                                                                state.model = gltf;
                                                                state.status = "completed";
                                                                _this.downloadState.set(url, state);
                                                                _this.log("Successfully loaded model: ".concat(url));
                                                                resolve(gltf);
                                                            }, void 0, function(error) {
                                                                state.status = "errored";
                                                                state.retryCount += 1;
                                                                _this.downloadState.set(url, state);
                                                                var errorMessage = (error === null || error === void 0 ? void 0 : error.message) || (error === null || error === void 0 ? void 0 : error.toString()) || "";
                                                                var isNetworkError = errorMessage.includes("NetworkError") || errorMessage.includes("Failed to fetch") || errorMessage.includes("ERR_NETWORK");
                                                                var is404Error = errorMessage.includes("404") || errorMessage.includes("Not Found");
                                                                var isConditionHeaderError = errorMessage.includes("Condition headers are not supported") || errorMessage.includes("400");
                                                                var isUrlEncodingError = errorMessage.includes("400") && url.includes("%2B");
                                                                if (is404Error) {
                                                                    state.retryCount = _this.maxRetriesFor404;
                                                                    if (!_this.suppress404Logging) {
                                                                        _this.log("File missing for ".concat(url, " (unmapped floorplanner ID)"));
                                                                    }
                                                                } else if (isConditionHeaderError) {
                                                                    state.retryCount = _this.maxRetries;
                                                                    _this.log("Condition headers error for ".concat(url, ", skipping retries"));
                                                                } else if (isUrlEncodingError) {
                                                                    state.retryCount = _this.maxRetries;
                                                                    _this.log("URL encoding error for ".concat(url, ", skipping retries"));
                                                                } else {
                                                                    _this.log("Failed to load model from ".concat(url, ":"), error);
                                                                }
                                                                reject(error);
                                                            });
                                                        });
                                                        _this.downloadState.set(url, state);
                                                    }
                                                    var ret = state.promise.then(function(model) {
                                                        return {
                                                            url: url,
                                                            model: model,
                                                            success: true
                                                        };
                                                    }).catch(function(error) {
                                                        return {
                                                            url: url,
                                                            model: null,
                                                            success: false,
                                                            error: error
                                                        };
                                                    });
                                                    return ret;
                                                });
                                                return [
                                                    4,
                                                    Promise.all(downloadPromises)
                                                ];
                                            case 1:
                                                results = _state.sent();
                                                results.forEach(function(result) {
                                                    if (!result) return;
                                                    var url = result.url, success = result.success;
                                                    var state = _this.downloadState.get(url);
                                                    if (!state) return;
                                                    if (success) {
                                                        _this.completedDownloads += 1;
                                                        _this.updateProgress();
                                                    } else {
                                                        if (state.retryCount < _this.maxRetries) {
                                                            _this.log("Retrying download for ".concat(url, " (Attempt ").concat(state.retryCount + 1, "/").concat(_this.maxRetries, ")"));
                                                            var delay = Math.min(1e3 * Math.pow(2, state.retryCount), 1e4);
                                                            setTimeout(function() {
                                                                state.promise = null;
                                                                _this.processDownloads();
                                                            }, delay);
                                                        } else {
                                                            console.error("Max retries reached for ".concat(url, ". Giving up."));
                                                            state.status = "completed";
                                                            _this.downloadState.set(url, state);
                                                            _this.abandonedDownloads += 1;
                                                            _this.updateProgress();
                                                        }
                                                    }
                                                });
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                };
                                if (_this.isProcessing) return [
                                    2
                                ];
                                _this.isProcessing = true;
                                _state.label = 1;
                            case 1:
                                if (!true) return [
                                    3,
                                    3
                                ];
                                return [
                                    5,
                                    _ts_values(_loop())
                                ];
                            case 2:
                                _ret = _state.sent();
                                if (_ret === "break") return [
                                    3,
                                    3
                                ];
                                return [
                                    3,
                                    1
                                ];
                            case 3:
                                _this.isProcessing = false;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "grabFromCache",
            value: function grabFromCache(url) {
                var _this_downloadState_get;
                var _this_downloadState_get_model;
                return (_this_downloadState_get_model = (_this_downloadState_get = this.downloadState.get(url)) === null || _this_downloadState_get === void 0 ? void 0 : _this_downloadState_get.model) !== null && _this_downloadState_get_model !== void 0 ? _this_downloadState_get_model : null;
            }
        },
        {
            key: "requestModel",
            value: function requestModel(url) {
                var _this = this;
                return _async_to_generator(function() {
                    var state;
                    return _ts_generator(this, function(_state) {
                        _this.log("Request received for model: ".concat(url));
                        state = _this.downloadState.get(url);
                        _this.notifyAdded(url);
                        if (!state) {
                            state = {
                                status: "newly-added",
                                promise: null,
                                model: null,
                                retryCount: 0
                            };
                            _this.downloadState.set(url, state);
                            _this.processDownloads();
                        }
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                var checkState = function() {
                                    _this.log("checkState for ".concat(url));
                                    var currentState = _this.downloadState.get(url);
                                    if (!currentState) {
                                        reject(new Error("State for ".concat(url, " disappeared unexpectedly")));
                                        throw new Error("super not-good");
                                    }
                                    if (currentState.status === "completed" && currentState.model) {
                                        _this.log("Resolved with cached model: ".concat(url));
                                        var match = url.match(filenameRegex);
                                        var filename = match ? match[1] : url.split("/").pop() || url;
                                        currentState.model.scene.userData = _object_spread_props(_object_spread({}, currentState.model.scene.userData), {
                                            filename: filename
                                        });
                                        currentState.model.scene.traverse(function(child) {
                                            child.userData = _object_spread_props(_object_spread({}, child.userData), {
                                                filename: filename
                                            });
                                        });
                                        resolve(currentState.model);
                                    } else if (currentState.promise) {
                                        _this.log("Resolved with existing promise for: ".concat(url));
                                        currentState.promise.then(resolve).catch(reject);
                                    } else {
                                        setTimeout(checkState, 100);
                                    }
                                };
                                checkState();
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "subscribeToProgress",
            value: function subscribeToProgress(callback) {
                var _this = this;
                this.progressCallbacks.push(callback);
                callback(this.totalDownloads === 0 ? 1 : (this.completedDownloads + this.abandonedDownloads) / this.totalDownloads);
                return function() {
                    _this.progressCallbacks = _this.progressCallbacks.filter(function(cb) {
                        return cb !== callback;
                    });
                };
            }
        },
        {
            key: "subscribeToAdded",
            value: function subscribeToAdded(callback) {
                var _this = this;
                this.addedCallbacks.push(callback);
                return function() {
                    _this.addedCallbacks = _this.addedCallbacks.filter(function(cb) {
                        return cb !== callback;
                    });
                };
            }
        },
        {
            key: "notifyAdded",
            value: function notifyAdded(url) {
                var total = this.totalDownloads;
                var completed = this.completedDownloads;
                var abandoned = this.abandonedDownloads;
                var currentProgress = total === 0 ? 1 : (completed + abandoned) / total;
                var epochMs = Date.now();
                this.addedCallbacks.forEach(function(callback) {
                    return callback(url, currentProgress, epochMs);
                });
            }
        }
    ], [
        {
            key: "getInstance",
            value: function getInstance() {
                if (!_DownloadManager._instance) {
                    _DownloadManager._instance = new _DownloadManager();
                }
                return _DownloadManager._instance;
            }
        }
    ]);
    return _DownloadManager;
}();
_DownloadManager._instance = null;
var DownloadManager = _DownloadManager;
var downloadManager = DownloadManager.getInstance();
// src/components/3D/utils/allocateEntrances.ts
function sortMappings(mappings) {
    mappings.sort(function(entranceA, entranceB) {
        var _entranceA = _sliced_to_array(entranceA, 2), _A = _entranceA[0], stationsA = _entranceA[1];
        var _entranceB = _sliced_to_array(entranceB, 2), _B = _entranceB[0], stationsB = _entranceB[1];
        return stationsA.length - stationsB.length;
    });
    return mappings;
}
function allocateEntrances(stations, entrances) {
    var mapping = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entrances[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var entrance = _step.value;
            mapping[entrance] = [];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var unmappedStations = [];
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = stations[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var station = _step1.value;
            var mappingFound = false;
            var stationTags = station.tags;
            if (stationTags !== void 0 && stationTags !== null && stationTags.length > 0) {
                var stationEntranceMapping = stationTags.find(function(tag) {
                    return tag.includes("entrance-name-");
                });
                if (stationEntranceMapping) {
                    var entranceName = stationEntranceMapping.split("-")[2];
                    if (entranceName in mapping) {
                        mappingFound = true;
                        mapping[entranceName].push(station);
                    } else {
                        console.log("invalid entrance name found in tags. Bad name: ".concat(entranceName));
                    }
                }
            }
            if (!mappingFound) unmappedStations.push(station);
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    var entrancesLeastFirst = sortMappings(Object.entries(mapping));
    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
    try {
        for(var _iterator2 = unmappedStations[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var station1 = _step2.value;
            var _entrancesLeastFirst_ = _sliced_to_array(entrancesLeastFirst[0], 2), _ = _entrancesLeastFirst_[0], smallestStationCollection = _entrancesLeastFirst_[1];
            smallestStationCollection.push(station1);
            sortMappings(entrancesLeastFirst);
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
            }
        } finally{
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }
    var finalMapping = Object.fromEntries(entrancesLeastFirst);
    return finalMapping;
}
// src/components/3D/utils/secureRemoteFiles.ts
import { secureFileURL } from "@repo/front-end-utils";
var getSecureFileURL = function(path, authMetadata, modelBaseURL) {
    var _authMetadata_tokens, _process_env;
    return secureFileURL(path, {
        baseURL: modelBaseURL,
        contextToken: authMetadata === null || authMetadata === void 0 ? void 0 : (_authMetadata_tokens = authMetadata.tokens) === null || _authMetadata_tokens === void 0 ? void 0 : _authMetadata_tokens.modelUrlKey,
        fallbackToken: typeof process !== "undefined" ? ((_process_env = process.env) === null || _process_env === void 0 ? void 0 : _process_env.REACT_APP_MODEL_URL_TOKEN) || "" : ""
    });
};
// src/components/3D/AxisVisualiser.tsx
import { Line } from "@react-three/drei";
import { jsx as jsx165, jsxs as jsxs113 } from "react/jsx-runtime";
var AxisVisualiser = function(param) {
    var tmp = param.size, size2 = tmp === void 0 ? 5 : tmp;
    return /* @__PURE__ */ jsxs113("group", {
        children: [
            /* @__PURE__ */ jsx165(Line, {
                points: [
                    [
                        0,
                        0,
                        0
                    ],
                    [
                        size2,
                        0,
                        0
                    ]
                ],
                color: "red",
                lineWidth: 2
            }),
            /* @__PURE__ */ jsx165(Line, {
                points: [
                    [
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        size2,
                        0
                    ]
                ],
                color: "green",
                lineWidth: 2
            }),
            /* @__PURE__ */ jsx165(Line, {
                points: [
                    [
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        size2
                    ]
                ],
                color: "blue",
                lineWidth: 2
            })
        ]
    });
};
// src/components/3D/flyToTarget/flyToTarget.ts
import { useTwinModelStore as useTwinModelStore6 } from "@repo/front-end-state";
// src/components/3D/flyToTarget/decideStrategy.ts
import { useTwinModelStore as useTwinModelStore5, useUserStore as useUserStore28 } from "@repo/front-end-state";
// src/components/3D/flyToTarget/computePoses.ts
import { Box3 as Box33, Mesh as Mesh4 } from "three";
import { CoordinateSystem } from "@repo/backend-types";
import { TwinEntityType as TwinEntityType3 } from "@repo/frontend-types";
import { stringToTwinEntityType as stringToTwinEntityType3 } from "@repo/front-end-utils";
import { useTwinModelStore as useTwinModelStore4 } from "@repo/front-end-state";
// src/components/3D/flyToTarget/resolveTarget.ts
import { DEFAULT_CAMERA_CONFIG as DEFAULT_CAMERA_CONFIG3, DEFAULT_MAP_ORIGIN as DEFAULT_MAP_ORIGIN2 } from "@repo/frontend-types";
import { findEntityWithBID } from "@repo/front-end-utils";
import { useTwinModelStore as useTwinModelStore3, useUserStore as useUserStore27 } from "@repo/front-end-state";
function resolveTarget(bid) {
    var _twin_adminTwin, _twin_adminTwin1;
    var _useTwinModelStore3_getState = useTwinModelStore3.getState(), twin = _useTwinModelStore3_getState.twin, accessibleTwins = _useTwinModelStore3_getState.accessibleTwins;
    var authMetadata = useUserStore27.getState().authMetadata;
    if ((twin === null || twin === void 0 ? void 0 : (_twin_adminTwin = twin.adminTwin) === null || _twin_adminTwin === void 0 ? void 0 : _twin_adminTwin.bid) === bid) {
        var pose = readCameraStart(twin.adminTwin.camera_start_args);
        if (pose) return {
            kind: "twin",
            pose: pose,
            twinBId: bid
        };
        var fallback = twinPoseFromFallbackChain(twin, authMetadata);
        console.warn('[resolveTarget] twin "', bid, '" has no usable camera_start_args; falling back to derived pose', fallback);
        return {
            kind: "twin",
            pose: fallback,
            twinBId: bid
        };
    }
    if (accessibleTwins) {
        var candidate = accessibleTwins.find(function(t) {
            return t.bid === bid;
        });
        if (candidate) {
            var pose1 = readCameraStart(candidate.camera_start_args);
            if (pose1) {
                console.debug("[resolveTarget] cross-twin lookup via accessibleTwins for bid=", bid, "pose=", pose1);
                return {
                    kind: "twin",
                    pose: pose1,
                    twinBId: bid
                };
            }
            var fallback1 = crossTwinPoseFromFallbackChain(candidate, authMetadata);
            console.warn('[resolveTarget] cross-twin "', bid, '" has no usable camera_start_args; falling back to derived pose', fallback1);
            return {
                kind: "twin",
                pose: fallback1,
                twinBId: bid
            };
        }
    }
    if ((twin === null || twin === void 0 ? void 0 : twin.physicalModel) && ((_twin_adminTwin1 = twin.adminTwin) === null || _twin_adminTwin1 === void 0 ? void 0 : _twin_adminTwin1.bid)) {
        var entity = findEntityWithBID(twin.physicalModel, bid);
        if (entity) {
            var _entity_type_name, _entity_type;
            var typeName = (_entity_type = entity.type) === null || _entity_type === void 0 ? void 0 : (_entity_type_name = _entity_type.name) === null || _entity_type_name === void 0 ? void 0 : _entity_type_name.toLowerCase();
            if (typeName === "asset") {
                return {
                    kind: "asset",
                    entity: entity,
                    twinBId: twin.adminTwin.bid
                };
            }
            if (typeName === "area") {
                return {
                    kind: "area",
                    entity: entity,
                    twinBId: twin.adminTwin.bid
                };
            }
        }
    }
    if ((authMetadata === null || authMetadata === void 0 ? void 0 : authMetadata.orgBID) === bid) {
        if (!authMetadata.orgLatitude || !authMetadata.orgLongitude) {
            throw new IncompleteTargetData('Cannot fly to organisation "'.concat(bid, "\": authMetadata.orgLatitude and/or authMetadata.orgLongitude is missing. The organisation record is missing geographic coordinates — check the org's database row."));
        }
        var lat = parseFloat(authMetadata.orgLatitude);
        var lng = parseFloat(authMetadata.orgLongitude);
        if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
            throw new IncompleteTargetData('Cannot fly to organisation "'.concat(bid, '": authMetadata.orgLatitude / orgLongitude are not valid numbers (orgLatitude=').concat(authMetadata.orgLatitude, ", orgLongitude=").concat(authMetadata.orgLongitude, ")."));
        }
        return {
            kind: "organisation",
            pose: {
                lat: lat,
                lng: lng,
                zoom: ORG_POSE_DEFAULTS.zoom,
                bearing: ORG_POSE_DEFAULTS.bearing,
                pitch: ORG_POSE_DEFAULTS.pitch
            },
            orgBID: bid
        };
    }
    return null;
}
function twinPoseFromFallbackChain(twin, authMetadata) {
    var resolved = resolveMapLocationAndCamera({
        twin: twin,
        authMetadata: authMetadata
    });
    return {
        lat: resolved.location.latitude,
        lng: resolved.location.longitude,
        zoom: resolved.camera.zoom,
        bearing: resolved.camera.bearing,
        pitch: resolved.camera.pitch
    };
}
function crossTwinPoseFromFallbackChain(twinRow, authMetadata) {
    var lat;
    var lng;
    if (typeof twinRow.latitude === "number" && Number.isFinite(twinRow.latitude) && typeof twinRow.longitude === "number" && Number.isFinite(twinRow.longitude)) {
        lat = twinRow.latitude;
        lng = twinRow.longitude;
    } else if ((authMetadata === null || authMetadata === void 0 ? void 0 : authMetadata.orgLatitude) && (authMetadata === null || authMetadata === void 0 ? void 0 : authMetadata.orgLongitude)) {
        var orgLat = parseFloat(authMetadata.orgLatitude);
        var orgLng = parseFloat(authMetadata.orgLongitude);
        if (Number.isFinite(orgLat) && Number.isFinite(orgLng)) {
            lat = orgLat;
            lng = orgLng;
        }
    }
    if (lat == null || lng == null) {
        lat = DEFAULT_MAP_ORIGIN2.latitude;
        lng = DEFAULT_MAP_ORIGIN2.longitude;
    }
    return {
        lat: lat,
        lng: lng,
        zoom: DEFAULT_CAMERA_CONFIG3.zoom,
        bearing: DEFAULT_CAMERA_CONFIG3.bearing,
        pitch: DEFAULT_CAMERA_CONFIG3.pitch
    };
}
// src/components/3D/flyToTarget/computePoses.ts
function floorAncestorOf(entity, root) {
    var walk = function(node, floor) {
        var _node_type;
        var _node_type_name;
        var here = stringToTwinEntityType3((_node_type_name = (_node_type = node.type) === null || _node_type === void 0 ? void 0 : _node_type.name) !== null && _node_type_name !== void 0 ? _node_type_name : "") === TwinEntityType3.FLOOR ? node : floor;
        if (node.bID === entity.bID) return here;
        var _node_children;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = ((_node_children = node.children) !== null && _node_children !== void 0 ? _node_children : [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var child = _step.value;
                var found = walk(child, here);
                if (found !== void 0) return found;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return void 0;
    };
    var _walk;
    return root ? (_walk = walk(root, null)) !== null && _walk !== void 0 ? _walk : null : null;
}
var EARTH_RADIUS_METRES3 = 6378137;
var COORD_LOCAL_TO_METERS = COORD_LOCAL_TO_METRES;
var VIEWPORT_PADDING_FRACTION = 0.1;
function pointToLngLat(point, entity, twinCoordinateSystem, mapOrigin, floor) {
    var _entity_coordinateSystem, _ref;
    var coordSystem = (_ref = (_entity_coordinateSystem = entity.coordinateSystem) !== null && _entity_coordinateSystem !== void 0 ? _entity_coordinateSystem : twinCoordinateSystem) !== null && _ref !== void 0 ? _ref : CoordinateSystem.CoordWgs84;
    if (coordSystem === CoordinateSystem.CoordWgs84) {
        return {
            lng: point.longitude,
            lat: point.latitude
        };
    }
    if (!mapOrigin) {
        return null;
    }
    var placed = placeOnFloor(point, floor);
    var shifted = shiftLatLongByMetres(mapOrigin, {
        x: placed.longitude * COORD_LOCAL_TO_METERS,
        y: placed.latitude * COORD_LOCAL_TO_METERS
    });
    return {
        lng: shifted.lng,
        lat: shifted.lat
    };
}
function computeBearingTowardTarget(map, target) {
    var camPos = map.getFreeCameraOptions().position;
    if (!camPos) return map.getBearing();
    var camLngLat = camPos.toLngLat();
    var dLat = target.lat - camLngLat.lat;
    var dLng = target.lng - camLngLat.lng;
    if (Math.abs(dLat) < 1e-9 && Math.abs(dLng) < 1e-9) {
        return map.getBearing();
    }
    var φ1 = camLngLat.lat * Math.PI / 180;
    var φ2 = target.lat * Math.PI / 180;
    var Δλ = dLng * Math.PI / 180;
    var y = Math.sin(Δλ) * Math.cos(φ2);
    var x = Math.cos(φ1) * Math.sin(φ2) - Math.sin(φ1) * Math.cos(φ2) * Math.cos(Δλ);
    var θ = Math.atan2(y, x);
    return (θ * 180 / Math.PI + 360) % 360;
}
function inflateBox(box, factor) {
    var centreLng = (box.swLng + box.neLng) / 2;
    var centreLat = (box.swLat + box.neLat) / 2;
    var halfLng = (box.neLng - box.swLng) / 2 * factor;
    var halfLat = (box.neLat - box.swLat) / 2 * factor;
    return {
        swLng: centreLng - halfLng,
        swLat: centreLat - halfLat,
        neLng: centreLng + halfLng,
        neLat: centreLat + halfLat
    };
}
function virtualBoxAround(lng, lat, sizeM) {
    var halfM = sizeM / 2;
    var deltaLat = halfM / EARTH_RADIUS_METRES3 * (180 / Math.PI);
    var deltaLng = halfM / EARTH_RADIUS_METRES3 * (180 / Math.PI) / Math.cos(lat * Math.PI / 180);
    return {
        swLng: lng - deltaLng,
        swLat: lat - deltaLat,
        neLng: lng + deltaLng,
        neLat: lat + deltaLat
    };
}
function meshCentreGeographic(entity, mapOrigin, floor) {
    var _entity_boundaries;
    var modelCentre;
    var modelCentreSource;
    if (((_entity_boundaries = entity.boundaries) === null || _entity_boundaries === void 0 ? void 0 : _entity_boundaries.polygons) && entity.boundaries.polygons.length > 0) {
        try {
            var polyCentre = getCentre(entity.boundaries.polygons);
            modelCentre = {
                latitude: polyCentre.latitude,
                longitude: polyCentre.longitude
            };
            modelCentreSource = "boundaries";
        } catch (e) {}
    }
    if (!modelCentre && entity.location) {
        modelCentre = entity.location;
        modelCentreSource = "location";
    }
    if (!modelCentre && entity.centre) {
        modelCentre = entity.centre;
        modelCentreSource = "centre";
    }
    if (!modelCentre || !modelCentreSource) return null;
    if (!mapOrigin) return null;
    var localEast = modelCentre.longitude * COORD_LOCAL_TO_METERS;
    var localWorldZ = -modelCentre.latitude * COORD_LOCAL_TO_METERS;
    var placed = placeOnFloor({
        longitude: localEast / COORD_LOCAL_TO_METERS,
        latitude: -localWorldZ / COORD_LOCAL_TO_METERS
    }, floor);
    var east = placed.longitude * COORD_LOCAL_TO_METERS;
    var north = placed.latitude * COORD_LOCAL_TO_METERS;
    var shifted = shiftLatLongByMetres(mapOrigin, {
        x: east,
        y: north
    });
    return {
        lng: shifted.lng,
        lat: shifted.lat,
        modelCentreSource: modelCentreSource
    };
}
function entityCentre(entity, _twinCoordinateSystem, mapOrigin, floor) {
    var r = meshCentreGeographic(entity, mapOrigin, floor);
    return r ? {
        lng: r.lng,
        lat: r.lat
    } : null;
}
function worldXZtoLngLat(worldX, worldZ, mapOrigin) {
    var shifted = shiftLatLongByMetres(mapOrigin, {
        x: worldX,
        y: -worldZ
    });
    return {
        lng: shifted.lng,
        lat: shifted.lat
    };
}
function sceneSpaceMeshBox(scene, bID, mapOrigin) {
    if (!scene) return null;
    var found = null;
    scene.traverse(function(obj) {
        if (found) return;
        if (obj.userData && obj.userData.bID === bID) {
            found = obj;
        }
    });
    if (!found) return null;
    found.updateWorldMatrix(true, true);
    var worldBox = new Box33();
    var hasMesh = false;
    var tempBox = new Box33();
    var walk = function(obj, isRoot) {
        var _obj_userData;
        if (!isRoot && ((_obj_userData = obj.userData) === null || _obj_userData === void 0 ? void 0 : _obj_userData.bID) && obj.userData.bID !== bID) {
            return;
        }
        if (_instanceof(obj, Mesh4) && obj.geometry) {
            if (!obj.geometry.boundingBox) {
                obj.geometry.computeBoundingBox();
            }
            if (obj.geometry.boundingBox) {
                tempBox.copy(obj.geometry.boundingBox);
                tempBox.applyMatrix4(obj.matrixWorld);
                if (hasMesh) {
                    worldBox.union(tempBox);
                } else {
                    worldBox.copy(tempBox);
                    hasMesh = true;
                }
            }
        }
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = obj.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var child = _step.value;
                walk(child, false);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    walk(found, true);
    if (!hasMesh || worldBox.isEmpty()) return null;
    var sw = worldXZtoLngLat(worldBox.min.x, worldBox.max.z, mapOrigin);
    var ne = worldXZtoLngLat(worldBox.max.x, worldBox.min.z, mapOrigin);
    var centreX = (worldBox.min.x + worldBox.max.x) / 2;
    var centreZ = (worldBox.min.z + worldBox.max.z) / 2;
    var centre = worldXZtoLngLat(centreX, centreZ, mapOrigin);
    console.debug("[sceneSpaceMeshBox] bid=", bID, "world bbox (metres east/alt/south of mapOrigin) min=", {
        x: worldBox.min.x,
        y: worldBox.min.y,
        z: worldBox.min.z
    }, "max=", {
        x: worldBox.max.x,
        y: worldBox.max.y,
        z: worldBox.max.z
    }, "size=", {
        ew: worldBox.max.x - worldBox.min.x,
        ns: worldBox.max.z - worldBox.min.z,
        h: worldBox.max.y - worldBox.min.y
    });
    return {
        box: {
            swLng: sw.lng,
            swLat: sw.lat,
            neLng: ne.lng,
            neLat: ne.lat
        },
        centre: centre
    };
}
function getAssetBox(entity, twinCoordinateSystem, mapOrigin, floor) {
    var centre = entityCentre(entity, twinCoordinateSystem, mapOrigin, floor);
    if (!centre) {
        throw new IncompleteTargetData('Cannot frame asset "'.concat(entity.bID, '": no resolvable location/centre on the entity (checked location, centre).'));
    }
    return virtualBoxAround(centre.lng, centre.lat, ASSET_VIRTUAL_SIZE_M);
}
function getAreaBox(entity, twinCoordinateSystem, mapOrigin, floor) {
    var _entity_boundaries;
    var polygons = (_entity_boundaries = entity.boundaries) === null || _entity_boundaries === void 0 ? void 0 : _entity_boundaries.polygons;
    if (polygons && polygons.length > 0) {
        var swLng = Infinity;
        var swLat = Infinity;
        var neLng = -Infinity;
        var neLat = -Infinity;
        var totalPoints = 0;
        var perPolygonPointCounts = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = polygons[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var polygon = _step.value;
                var _polygon_coordinates_, _polygon_coordinates;
                var ring = (_polygon_coordinates = polygon.coordinates) === null || _polygon_coordinates === void 0 ? void 0 : (_polygon_coordinates_ = _polygon_coordinates[0]) === null || _polygon_coordinates_ === void 0 ? void 0 : _polygon_coordinates_.points;
                if (!ring) {
                    perPolygonPointCounts.push(0);
                    continue;
                }
                perPolygonPointCounts.push(ring.length);
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = ring[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var pt = _step1.value;
                        var ll = pointToLngLat(pt, entity, twinCoordinateSystem, mapOrigin, floor);
                        if (!ll) continue;
                        totalPoints++;
                        if (ll.lng < swLng) swLng = ll.lng;
                        if (ll.lat < swLat) swLat = ll.lat;
                        if (ll.lng > neLng) neLng = ll.lng;
                        if (ll.lat > neLat) neLat = ll.lat;
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var lngSpan = neLng - swLng;
        var latSpan = neLat - swLat;
        var DEGENERATE_THRESHOLD = 1e-9;
        if (Number.isFinite(swLng) && lngSpan > DEGENERATE_THRESHOLD && latSpan > DEGENERATE_THRESHOLD) {
            console.debug("[getAreaBox] bid=", entity.bID, "polygons=", polygons.length, "pointsPerPolygon=", perPolygonPointCounts, "totalPoints(WGS84-resolved)=", totalPoints, "bbox SW=", {
                lat: swLat,
                lng: swLng
            }, "NE=", {
                lat: neLat,
                lng: neLng
            }, "spanMetres=", {
                ns: latSpan * (Math.PI / 180) * EARTH_RADIUS_METRES3,
                ew: lngSpan * (Math.PI / 180) * EARTH_RADIUS_METRES3 * Math.cos((swLat + neLat) / 2 * (Math.PI / 180))
            });
            return {
                swLng: swLng,
                swLat: swLat,
                neLng: neLng,
                neLat: neLat
            };
        }
    }
    var centre = entityCentre(entity, twinCoordinateSystem, mapOrigin, floor);
    if (!centre) {
        throw new IncompleteTargetData('Cannot frame area "'.concat(entity.bID, '": no usable boundaries.polygons and no resolvable location/centre on the entity.'));
    }
    console.warn('[getAreaBox] area "', entity.bID, '" has degenerate or missing polygons; falling back to', ASSET_VIRTUAL_SIZE_M, "m virtual box around centre", centre);
    return virtualBoxAround(centre.lng, centre.lat, ASSET_VIRTUAL_SIZE_M);
}
var SCENE_READY_MAX_WAIT_MS = 500;
var SCENE_READY_POLL_INTERVAL_MS = 50;
function pollSceneSpaceMeshBox(scene, bID, mapOrigin) {
    return _pollSceneSpaceMeshBox.apply(this, arguments);
}
function _pollSceneSpaceMeshBox() {
    _pollSceneSpaceMeshBox = _async_to_generator(function(scene, bID, mapOrigin) {
        var deadline, attempts, result;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    deadline = performance.now() + SCENE_READY_MAX_WAIT_MS;
                    attempts = 0;
                    _state.label = 1;
                case 1:
                    attempts++;
                    result = sceneSpaceMeshBox(scene, bID, mapOrigin);
                    if (result) {
                        if (attempts > 1) {
                            console.debug("[pollSceneSpaceMeshBox] mesh resolved after", attempts, "attempts for bid=", bID);
                        }
                        return [
                            2,
                            result
                        ];
                    }
                    if (performance.now() >= deadline) {
                        console.warn("[pollSceneSpaceMeshBox] timed out waiting for mesh after", attempts, "attempts; falling back to polygon-derived bbox for bid=", bID);
                        return [
                            2,
                            null
                        ];
                    }
                    return [
                        4,
                        new Promise(function(resolve) {
                            return setTimeout(resolve, SCENE_READY_POLL_INTERVAL_MS);
                        })
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _pollSceneSpaceMeshBox.apply(this, arguments);
}
function computeEntityPose(target, map) {
    return _computeEntityPose.apply(this, arguments);
}
function _computeEntityPose() {
    _computeEntityPose = _async_to_generator(function(target, map) {
        var _twin_physicalModel, _twin_physicalModel1, _useTwinModelStore4_getState, twin, sceneRef, twinCoordinateSystem, mapOrigin, floor, rawBox, sceneSourcedCentre, fromScene, inflated, canvas, padding, centerLng, centerLat, modelCentreSource, flightPitch, flightBearing, cam, _cam_zoom, rawZoom, zoom, locationLngLat;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _useTwinModelStore4_getState = useTwinModelStore4.getState(), twin = _useTwinModelStore4_getState.twin, sceneRef = _useTwinModelStore4_getState.sceneRef;
                    twinCoordinateSystem = twin === null || twin === void 0 ? void 0 : (_twin_physicalModel = twin.physicalModel) === null || _twin_physicalModel === void 0 ? void 0 : _twin_physicalModel.coordinateSystem;
                    mapOrigin = twin === null || twin === void 0 ? void 0 : (_twin_physicalModel1 = twin.physicalModel) === null || _twin_physicalModel1 === void 0 ? void 0 : _twin_physicalModel1.mapOrigin;
                    floor = floorAncestorOf(target.entity, twin === null || twin === void 0 ? void 0 : twin.physicalModel);
                    sceneSourcedCentre = null;
                    if (!mapOrigin) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        pollSceneSpaceMeshBox(sceneRef.current, target.entity.bID, mapOrigin)
                    ];
                case 1:
                    fromScene = _state.sent();
                    if (fromScene) {
                        rawBox = fromScene.box;
                        sceneSourcedCentre = fromScene.centre;
                    } else {
                        rawBox = target.kind === "asset" ? getAssetBox(target.entity, twinCoordinateSystem, mapOrigin, floor) : getAreaBox(target.entity, twinCoordinateSystem, mapOrigin, floor);
                    }
                    return [
                        3,
                        3
                    ];
                case 2:
                    rawBox = target.kind === "asset" ? getAssetBox(target.entity, twinCoordinateSystem, mapOrigin, floor) : getAreaBox(target.entity, twinCoordinateSystem, mapOrigin, floor);
                    _state.label = 3;
                case 3:
                    inflated = inflateBox(rawBox, FILL_INFLATION[target.kind]);
                    canvas = map.getCanvas();
                    padding = {
                        top: canvas.clientHeight * VIEWPORT_PADDING_FRACTION,
                        bottom: canvas.clientHeight * VIEWPORT_PADDING_FRACTION,
                        left: canvas.clientWidth * VIEWPORT_PADDING_FRACTION,
                        right: canvas.clientWidth * VIEWPORT_PADDING_FRACTION
                    };
                    centerLng = (inflated.swLng + inflated.neLng) / 2;
                    centerLat = (inflated.swLat + inflated.neLat) / 2;
                    modelCentreSource = sceneSourcedCentre ? "scene" : "bbox";
                    flightPitch = target.kind === "area" ? PITCH_AREA : PITCH_DEFAULT;
                    flightBearing = computeBearingTowardTarget(map, {
                        lat: centerLat,
                        lng: centerLng
                    });
                    cam = map.cameraForBounds([
                        [
                            inflated.swLng,
                            inflated.swLat
                        ],
                        [
                            inflated.neLng,
                            inflated.neLat
                        ]
                    ], {
                        padding: padding,
                        bearing: flightBearing,
                        pitch: flightPitch
                    });
                    rawZoom = (_cam_zoom = cam === null || cam === void 0 ? void 0 : cam.zoom) !== null && _cam_zoom !== void 0 ? _cam_zoom : MAX_ZOOM;
                    zoom = Math.min(MAX_ZOOM, Math.max(MIN_ZOOM, rawZoom));
                    locationLngLat = target.entity.location ? pointToLngLat(target.entity.location, target.entity, twinCoordinateSystem, mapOrigin) : null;
                    console.debug("[computeEntityPose] kind=", target.kind, "bid=", target.entity.bID, "meshCentre=", {
                        lat: centerLat,
                        lng: centerLng
                    }, "modelCentreSource=", modelCentreSource, "location(WGS84)=", locationLngLat, "rotationY=", target.entity.rotationY, "rawZoom=", rawZoom, "finalZoom=", zoom);
                    return [
                        2,
                        {
                            pose: {
                                lat: centerLat,
                                lng: centerLng,
                                zoom: zoom,
                                bearing: flightBearing,
                                pitch: flightPitch
                            },
                            diagnosticBbox: inflated
                        }
                    ];
            }
        });
    });
    return _computeEntityPose.apply(this, arguments);
}
function decideStrategy(target, map) {
    return _decideStrategy.apply(this, arguments);
}
function _decideStrategy() {
    _decideStrategy = // src/components/3D/flyToTarget/decideStrategy.ts
    _async_to_generator(function(target, map) {
        var _ref, entityPose, diagnosticBbox, twinPose, currentCentre, distanceKm, sameTwin, inRange, _exhaustive;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (target.kind === "twin" || target.kind === "organisation") {
                        return [
                            2,
                            {
                                phases: "single",
                                mode: "pose-only",
                                finalPose: target.pose,
                                duration: MAPBOX_FLIGHT_DURATION
                            }
                        ];
                    }
                    if (!(target.kind === "asset" || target.kind === "area")) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        computeEntityPose(target, map)
                    ];
                case 1:
                    _ref = _state.sent(), entityPose = _ref.pose, diagnosticBbox = _ref.diagnosticBbox;
                    twinPose = loadedTwinPose();
                    currentCentre = map.getCenter();
                    distanceKm = twinPose ? haversineKm({
                        lat: currentCentre.lat,
                        lng: currentCentre.lng
                    }, twinPose) : null;
                    sameTwin = !!twinPose && twinPose.twinBId === target.twinBId;
                    inRange = distanceKm !== null && distanceKm <= THRESHOLD_KM;
                    console.debug("[decideStrategy] entity kind=", target.kind, "bid=", target.entity.bID, "twinBId=", target.twinBId, "loadedTwinPose=", twinPose, "currentCentre=", {
                        lat: currentCentre.lat,
                        lng: currentCentre.lng
                    }, "distanceKm=", distanceKm, "sameTwin=", sameTwin, "inRange=", inRange, "THRESHOLD_KM=", THRESHOLD_KM);
                    if (sameTwin && inRange) {
                        return [
                            2,
                            {
                                phases: "single",
                                mode: "entity",
                                finalPose: entityPose,
                                duration: LOCAL_FLIGHT_DURATION,
                                diagnosticBbox: diagnosticBbox
                            }
                        ];
                    }
                    if (!twinPose) {
                        console.warn("[decideStrategy] no usable twin camera_start_args; degrading two-phase \u2192 single-phase for", target.entity.bID);
                        return [
                            2,
                            {
                                phases: "single",
                                mode: "entity",
                                finalPose: entityPose,
                                duration: LOCAL_FLIGHT_DURATION,
                                diagnosticBbox: diagnosticBbox
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            phases: "two",
                            intermediatePose: {
                                lat: twinPose.lat,
                                lng: twinPose.lng,
                                zoom: twinPose.zoom,
                                bearing: twinPose.bearing,
                                pitch: twinPose.pitch
                            },
                            finalPose: entityPose,
                            phaseDurations: [
                                MAPBOX_FLIGHT_DURATION,
                                LOCAL_FLIGHT_DURATION
                            ],
                            diagnosticBbox: diagnosticBbox
                        }
                    ];
                case 2:
                    _exhaustive = target;
                    throw new Error("decideStrategy: unhandled target kind");
            }
        });
    });
    return _decideStrategy.apply(this, arguments);
}
function loadedTwinPose() {
    var _twin_adminTwin, _twin_adminTwin1;
    var twin = useTwinModelStore5.getState().twin;
    var authMetadata = useUserStore28.getState().authMetadata;
    var twinBId = twin === null || twin === void 0 ? void 0 : (_twin_adminTwin = twin.adminTwin) === null || _twin_adminTwin === void 0 ? void 0 : _twin_adminTwin.bid;
    if (!twin || !twinBId) return null;
    var saved = readCameraStart((_twin_adminTwin1 = twin.adminTwin) === null || _twin_adminTwin1 === void 0 ? void 0 : _twin_adminTwin1.camera_start_args);
    if (saved) return _object_spread_props(_object_spread({}, saved), {
        twinBId: twinBId
    });
    var resolved = resolveMapLocationAndCamera({
        twin: twin,
        authMetadata: authMetadata
    });
    return {
        lat: resolved.location.latitude,
        lng: resolved.location.longitude,
        zoom: resolved.camera.zoom,
        bearing: resolved.camera.bearing,
        pitch: resolved.camera.pitch,
        twinBId: twinBId
    };
}
// src/components/3D/flyToTarget/flyToTarget.ts
var currentFlightController = null;
var currentFlightMap = null;
var mapReadyCached = false;
function flyToTarget(bidOrPosition, opts) {
    return _flyToTarget.apply(this, arguments);
}
function _flyToTarget() {
    _flyToTarget = _async_to_generator(function(bidOrPosition, opts) {
        var bid, _opts_map, map, claim, slowFactor, target, strategy, phaseLabel, totalMs, controller, signal, clearControllerIfCurrent, _opts_duration, duration, _strategy_finalPose, lat, lng, zoom, bearing, pitch, flyOptions, _opts_duration1, duration1, startPose, velocityStart, _strategy_phaseDurations, d1, d2, totalRequested, baseDurations, phaseDurations, startPose1, _exhaustive;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof bidOrPosition !== "string") {
                        return [
                            2,
                            flyToPosition(bidOrPosition, opts)
                        ];
                    }
                    bid = bidOrPosition;
                    console.debug("[flyToTarget] entered with bid=", bid);
                    if (!bid) {
                        throw new NoOrgContext("flyToTarget called with empty bid \u2014 typically means authMetadata.orgBID is null");
                    }
                    map = (_opts_map = opts === null || opts === void 0 ? void 0 : opts.map) !== null && _opts_map !== void 0 ? _opts_map : useTwinModelStore6.getState().mapRef.current;
                    if (!map) {
                        console.warn("[flyToTarget] map not ready, throwing");
                        throw new Error("flyToTarget: map not ready (TwinModelStore.mapRef.current is null)");
                    }
                    claim = claimMap(map);
                    return [
                        4,
                        waitForMapReady(map)
                    ];
                case 1:
                    _state.sent();
                    if (!holdsMap(map, claim)) throw new FlightInterrupted();
                    slowFactor = getSlowFlightFactor();
                    if (slowFactor !== 1) {
                        console.debug("[flyToTarget] slowFlight active, factor=", slowFactor);
                    }
                    target = resolveTarget(bid);
                    if (!target) {
                        console.warn("[flyToTarget] resolveTarget returned null for bid=", bid);
                        throw new UnknownBid(bid);
                    }
                    console.debug("[flyToTarget] resolved target kind=", target.kind);
                    return [
                        4,
                        decideStrategy(target, map)
                    ];
                case 2:
                    strategy = _state.sent();
                    if (!holdsMap(map, claim)) throw new FlightInterrupted();
                    phaseLabel = strategy.phases === "two" ? "two-phase" : "single-".concat(strategy.mode);
                    totalMs = strategy.phases === "two" ? strategy.phaseDurations[0] + strategy.phaseDurations[1] : strategy.duration;
                    console.log("[flyToTarget] bid=".concat(bid, " kind=").concat(target.kind, " phase=").concat(phaseLabel, " duration=").concat(totalMs, "ms"));
                    console.debug("[flyToTarget] strategy=", strategy);
                    if (currentFlightController) {
                        currentFlightController.abort();
                    }
                    controller = new AbortController();
                    currentFlightController = controller;
                    currentFlightMap = map;
                    signal = controller.signal;
                    map.stop();
                    map.setMaxBounds(null);
                    clearControllerIfCurrent = function() {
                        if (currentFlightController === controller) {
                            currentFlightController = null;
                            currentFlightMap = null;
                        }
                    };
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        ,
                        10,
                        11
                    ]);
                    if (!(strategy.phases === "single" && strategy.mode === "pose-only")) return [
                        3,
                        5
                    ];
                    duration = ((_opts_duration = opts === null || opts === void 0 ? void 0 : opts.duration) !== null && _opts_duration !== void 0 ? _opts_duration : strategy.duration) * slowFactor;
                    _strategy_finalPose = strategy.finalPose, lat = _strategy_finalPose.lat, lng = _strategy_finalPose.lng, zoom = _strategy_finalPose.zoom, bearing = _strategy_finalPose.bearing, pitch = _strategy_finalPose.pitch;
                    console.debug("[flyToTarget] starting Mapbox flyTo (pose-only), duration=", duration, "ms, chainHandoff=", opts === null || opts === void 0 ? void 0 : opts.chainHandoff);
                    flyOptions = {
                        center: [
                            lng,
                            lat
                        ],
                        zoom: zoom,
                        bearing: bearing,
                        pitch: pitch,
                        duration: duration,
                        essential: true
                    };
                    if ((opts === null || opts === void 0 ? void 0 : opts.chainHandoff) === "before-phase2") {
                        flyOptions.easing = function(t) {
                            return hermiteEase(0, PHASE_2_START_SLOPE_HERMITE, t);
                        };
                    } else {
                        flyOptions.easing = function(t) {
                            return hermiteEase(FLIGHT_DEFAULT_START_SLOPE, 0, t);
                        };
                    }
                    map.flyTo(flyOptions);
                    return [
                        4,
                        new Promise(function(resolve, reject) {
                            var settled = false;
                            var cleanup = function() {
                                map.off("moveend", onMoveEnd);
                                signal.removeEventListener("abort", onAbort);
                            };
                            var settle = function() {
                                if (settled) return;
                                settled = true;
                                cleanup();
                                if (!map.getCanvas()) {
                                    console.warn("[flyToTarget] settle fired on disposed map; skipping diagnostics");
                                    resolve();
                                    return;
                                }
                                logSettleDiagnostics(map, {
                                    lat: lat,
                                    lng: lng
                                });
                                resolve();
                            };
                            var onMoveEnd = function() {
                                return settle();
                            };
                            var onAbort = function() {
                                if (settled) return;
                                settled = true;
                                cleanup();
                                reject(new FlightInterrupted());
                            };
                            map.on("moveend", onMoveEnd);
                            signal.addEventListener("abort", onAbort);
                            setTimeout(settle, duration + 500);
                        })
                    ];
                case 4:
                    _state.sent();
                    return [
                        2
                    ];
                case 5:
                    if (!(strategy.phases === "single" && strategy.mode === "entity")) return [
                        3,
                        7
                    ];
                    duration1 = ((_opts_duration1 = opts === null || opts === void 0 ? void 0 : opts.duration) !== null && _opts_duration1 !== void 0 ? _opts_duration1 : strategy.duration) * slowFactor;
                    startPose = currentCameraPose(map);
                    velocityStart = (opts === null || opts === void 0 ? void 0 : opts.chainHandoff) === "after-phase1" ? PHASE_2_START_SLOPE_HERMITE : 0;
                    console.debug("[flyToTarget] starting entity single-phase animator, duration=", duration1, "ms, startPose=", startPose, "finalPose=", strategy.finalPose, "chainHandoff=", opts === null || opts === void 0 ? void 0 : opts.chainHandoff);
                    return [
                        4,
                        animateSinglePhase(map, startPose, strategy.finalPose, duration1, {
                            velocityStart: velocityStart,
                            signal: signal
                        })
                    ];
                case 6:
                    _state.sent();
                    logSettleDiagnostics(map, {
                        lat: strategy.finalPose.lat,
                        lng: strategy.finalPose.lng
                    }, strategy.diagnosticBbox);
                    return [
                        2
                    ];
                case 7:
                    if (!(strategy.phases === "two")) return [
                        3,
                        9
                    ];
                    _strategy_phaseDurations = _sliced_to_array(strategy.phaseDurations, 2), d1 = _strategy_phaseDurations[0], d2 = _strategy_phaseDurations[1];
                    totalRequested = opts === null || opts === void 0 ? void 0 : opts.duration;
                    baseDurations = totalRequested ? [
                        d1 * totalRequested / (d1 + d2),
                        d2 * totalRequested / (d1 + d2)
                    ] : [
                        d1,
                        d2
                    ];
                    phaseDurations = [
                        baseDurations[0] * slowFactor,
                        baseDurations[1] * slowFactor
                    ];
                    startPose1 = currentCameraPose(map);
                    console.debug("[flyToTarget] starting two-phase animation, phaseDurations=", phaseDurations, "startPose=", startPose1, "intermediatePose=", strategy.intermediatePose, "finalPose=", strategy.finalPose);
                    return [
                        4,
                        animateTwoPhase(map, startPose1, strategy.intermediatePose, strategy.finalPose, phaseDurations, {
                            signal: signal
                        })
                    ];
                case 8:
                    _state.sent();
                    logSettleDiagnostics(map, {
                        lat: strategy.finalPose.lat,
                        lng: strategy.finalPose.lng
                    }, strategy.diagnosticBbox);
                    return [
                        2
                    ];
                case 9:
                    _exhaustive = strategy;
                    throw new Error("flyToTarget: unhandled strategy ".concat(String(_exhaustive)));
                case 10:
                    clearControllerIfCurrent();
                    return [
                        7
                    ];
                case 11:
                    return [
                        2
                    ];
            }
        });
    });
    return _flyToTarget.apply(this, arguments);
}
function isFiniteIn(value, min, max) {
    return typeof value === "number" && Number.isFinite(value) && value >= min && value <= max;
}
function isAbsentOrFinite(value) {
    return value === void 0 || typeof value === "number" && Number.isFinite(value);
}
function prefersReducedMotion2() {
    return typeof window !== "undefined" && typeof window.matchMedia === "function" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}
function flyToPosition(target, opts) {
    return _flyToPosition.apply(this, arguments);
}
function _flyToPosition() {
    _flyToPosition = _async_to_generator(function(target, opts) {
        var _opts_signal, valid, _opts_map, map, call, _target_zoom, _target_bearing, _target_pitch, pose, jump, _opts_duration, duration;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    valid = isFiniteIn(target.longitude, -180, 180) && isFiniteIn(target.latitude, -90, 90) && isAbsentOrFinite(target.zoom) && isAbsentOrFinite(target.bearing) && isAbsentOrFinite(target.pitch);
                    if (!valid) {
                        console.warn("[flyToTarget] invalid position target", {
                            longitude: target.longitude,
                            latitude: target.latitude,
                            zoom: target.zoom,
                            bearing: target.bearing,
                            pitch: target.pitch
                        });
                        return [
                            2
                        ];
                    }
                    map = (_opts_map = opts === null || opts === void 0 ? void 0 : opts.map) !== null && _opts_map !== void 0 ? _opts_map : useTwinModelStore6.getState().mapRef.current;
                    if (!map) {
                        console.warn("[flyToTarget] no map to fly to the position");
                        return [
                            2
                        ];
                    }
                    call = claimMap(map);
                    return [
                        4,
                        waitForStyle(map)
                    ];
                case 1:
                    _state.sent();
                    if (!holdsMap(map, call) || (opts === null || opts === void 0 ? void 0 : (_opts_signal = opts.signal) === null || _opts_signal === void 0 ? void 0 : _opts_signal.aborted)) return [
                        2
                    ];
                    pose = {
                        center: [
                            target.longitude,
                            target.latitude
                        ],
                        zoom: (_target_zoom = target.zoom) !== null && _target_zoom !== void 0 ? _target_zoom : map.getZoom(),
                        bearing: (_target_bearing = target.bearing) !== null && _target_bearing !== void 0 ? _target_bearing : map.getBearing(),
                        pitch: (_target_pitch = target.pitch) !== null && _target_pitch !== void 0 ? _target_pitch : map.getPitch()
                    };
                    jump = prefersReducedMotion2();
                    console.log("[flyToTarget] position lng=".concat(target.longitude, " lat=").concat(target.latitude, " zoom=").concat(pose.zoom, " mode=").concat(jump ? "jump" : "fly"));
                    if (currentFlightController && currentFlightMap === map) {
                        currentFlightController.abort();
                        currentFlightController = null;
                        currentFlightMap = null;
                    }
                    map.stop();
                    if (jump) {
                        map.jumpTo(pose);
                        return [
                            2
                        ];
                    }
                    duration = ((_opts_duration = opts === null || opts === void 0 ? void 0 : opts.duration) !== null && _opts_duration !== void 0 ? _opts_duration : MAPBOX_FLIGHT_DURATION) * getSlowFlightFactor();
                    return [
                        4,
                        new Promise(function(resolve) {
                            var settled = false;
                            var timer;
                            var settle = function() {
                                if (settled) return;
                                settled = true;
                                clearTimeout(timer);
                                map.off("moveend", settle);
                                resolve();
                            };
                            map.on("moveend", settle);
                            timer = setTimeout(settle, duration + 500);
                            map.flyTo(_object_spread_props(_object_spread({}, pose), {
                                duration: duration,
                                essential: true,
                                easing: function(t) {
                                    return hermiteEase(FLIGHT_DEFAULT_START_SLOPE, 0, t);
                                }
                            }));
                        })
                    ];
                case 2:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return _flyToPosition.apply(this, arguments);
}
var mapClaims = /* @__PURE__ */ new WeakMap();
var claimMap = function(map) {
    var _mapClaims_get;
    var claim = ((_mapClaims_get = mapClaims.get(map)) !== null && _mapClaims_get !== void 0 ? _mapClaims_get : 0) + 1;
    mapClaims.set(map, claim);
    return claim;
};
var holdsMap = function(map, claim) {
    return mapClaims.get(map) === claim;
};
var loadedMaps = /* @__PURE__ */ new WeakSet();
function waitForStyle(map) {
    return _waitForStyle.apply(this, arguments);
}
function _waitForStyle() {
    _waitForStyle = _async_to_generator(function(map) {
        var start;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (loadedMaps.has(map)) return [
                        2
                    ];
                    start = performance.now();
                    _state.label = 1;
                case 1:
                    if (!(!map.isStyleLoaded() && performance.now() - start < 3e3)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        new Promise(function(resolve) {
                            return setTimeout(resolve, 30);
                        })
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        1
                    ];
                case 3:
                    if (map.isStyleLoaded()) loadedMaps.add(map);
                    return [
                        2
                    ];
            }
        });
    });
    return _waitForStyle.apply(this, arguments);
}
function waitForMapReady(map) {
    return _waitForMapReady.apply(this, arguments);
}
function _waitForMapReady() {
    _waitForMapReady = _async_to_generator(function(map) {
        var start, MAX_WAIT_MS, POLL_MS;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (mapReadyCached) return [
                        2
                    ];
                    if (map.isStyleLoaded()) {
                        mapReadyCached = true;
                        return [
                            2
                        ];
                    }
                    start = performance.now();
                    MAX_WAIT_MS = 3e3;
                    POLL_MS = 30;
                    _state.label = 1;
                case 1:
                    if (!(performance.now() - start < MAX_WAIT_MS)) return [
                        3,
                        3
                    ];
                    if (map.isStyleLoaded()) {
                        mapReadyCached = true;
                        console.debug("[flyToTarget] map style ready after", Math.round(performance.now() - start), "ms");
                        return [
                            2
                        ];
                    }
                    return [
                        4,
                        new Promise(function(resolve) {
                            return setTimeout(resolve, POLL_MS);
                        })
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        1
                    ];
                case 3:
                    console.warn("[flyToTarget] map style not loaded after", MAX_WAIT_MS, "ms \u2014 proceeding anyway");
                    mapReadyCached = true;
                    return [
                        2
                    ];
            }
        });
    });
    return _waitForMapReady.apply(this, arguments);
}
function currentCameraPose(map) {
    var c = map.getCenter();
    return {
        lng: c.lng,
        lat: c.lat,
        zoom: map.getZoom(),
        pitch: map.getPitch(),
        bearing: map.getBearing()
    };
}
function getSlowFlightFactor() {
    if (typeof window === "undefined") return 1;
    var raw = new URLSearchParams(window.location.search).get("slowFlight");
    if (!raw) return 1;
    var n = Number(raw);
    return Number.isFinite(n) && n > 0 ? n : 1;
}
function logSettleDiagnostics(map, requestedCentre, diagnosticBbox) {
    var canvas = map.getCanvas();
    if (!canvas) {
        console.warn("[flyToTarget] logSettleDiagnostics called on disposed map; skipping");
        return;
    }
    var actualCentre = map.getCenter();
    var projected = map.project([
        requestedCentre.lng,
        requestedCentre.lat
    ]);
    console.debug("[flyToTarget] flight settled \u2014 requested centre=", requestedCentre, "actual centre=", {
        lat: actualCentre.lat,
        lng: actualCentre.lng
    }, "zoom=", map.getZoom(), "pitch=", map.getPitch(), "bearing=", map.getBearing());
    console.debug("[flyToTarget] target lat/lng projects to canvas pixel=", {
        x: projected.x,
        y: projected.y
    }, "canvas size=", {
        w: canvas.clientWidth,
        h: canvas.clientHeight
    }, "\u2192 normalised=", {
        x: projected.x / canvas.clientWidth,
        y: projected.y / canvas.clientHeight
    });
    if (diagnosticBbox) {
        var norm = function(px) {
            return {
                x: +(px.x / canvas.clientWidth).toFixed(3),
                y: +(px.y / canvas.clientHeight).toFixed(3)
            };
        };
        var sw = map.project([
            diagnosticBbox.swLng,
            diagnosticBbox.swLat
        ]);
        var ne = map.project([
            diagnosticBbox.neLng,
            diagnosticBbox.neLat
        ]);
        var nw = map.project([
            diagnosticBbox.swLng,
            diagnosticBbox.neLat
        ]);
        var se = map.project([
            diagnosticBbox.neLng,
            diagnosticBbox.swLat
        ]);
        console.debug("[flyToTarget] diagnostic bbox corners (normalised, 0..1 of canvas):", "SW=", norm(sw), "NW=", norm(nw), "NE=", norm(ne), "SE=", norm(se));
    }
}
export { AI_default as AI, AIConversation_default as AIConversation, AIPrompt_default as AIPrompt, AITypingMessage_default as AITypingMessage, ALL_LINES, ALL_MANUFACTURERS, ARRIVED_MS, ASSET_COLOR, About_default as About, AccountMenu, AddUserForm_default as AddUserForm, AdminForm_default as AdminForm, AssetEditDialog_default as AssetEditDialog, AssetItem_default as AssetItem, AssetRegisterList_default as AssetRegisterList, Assets_default as Assets, AssetsAndAnalytics_default as AssetsAndAnalytics, AutoLookupSheetButton, AxisVisualiser, BEST_GUESS, BEST_MATCH, BIDashboard_default as BIDashboard, BIDashboardSelect_default as BIDashboardSelect, BRAND_MIX_EMPTY, BRAND_MIX_ERROR, BRAND_MIX_OTHER_TWINS_SHOWN, BRAND_MIX_SHOWN, BaseDropdown_default as BaseDropdown, BrandMixCard, CAMERA_WALL_FILTER_LABELS, CAMERA_WALL_STATE_ROLE, COLUMN_MAP_ROW_COLOURS, COLUMN_MAP_ROW_GRID, KIND_ICON2 as COMPOSITE_KIND_ICON, CURRENT_MANIFEST_VERSION, Calendar_default as Calendar, CalendarMonthView_default as CalendarMonthView, CalendarSelectionOverlay_default as CalendarSelectionOverlay, CalendarWeekView_default as CalendarWeekView, CameraPicture, CameraPictureDialog, CameraPictureModal, CameraWall, CameraWallTile, CapacityTag, CardHeader_default as CardHeader, ChangePasswordForm_default as ChangePasswordForm, CheckCard, CleanUp, ColumnMapCaptions, ColumnMapRow, CompositeMeasureEditor_default as CompositeMeasureEditor, CompositeMeasuresPanel_default as CompositeMeasuresPanel, ConfirmDialog, ConnectedTLFilter_default as ConnectedTLFilter, CopyToClipboard_default as CopyToClipboard, CustomDropdown_default as CustomDropdown, DASHBOARD_PANEL_MANIFEST, DIRECTION_LIGHT_POSITION, DIRECTION_LIGHT_TARGET, DashboardRenderer, DataTable_default as DataTable, DayStepper_default as DayStepper, DebugGlInfoDiv, DebugThreeGlInfo, DeleteUser_default as DeleteUser, DialogForm_default as DialogForm, DialogRenderer_default as DialogRenderer, DraggablePanel_default as DraggablePanel, EMPTY_TOTAL_WARNING, EQUIPMENT_SUGGESTION_LIMIT, EditUserForm_default as EditUserForm, EditableFieldRow_default as EditableFieldRow, EditorForm_default as EditorForm, EntityAccordion_default as EntityAccordion, EntityAccordionItem_default as EntityAccordionItem, EntityAccordionItemWithContext_default as EntityAccordionItemWithContext, EntityIndicator_default as EntityIndicator, EntityRow_default as EntityRow, EquipmentFilterTab_default as EquipmentFilterTab, EquipmentPanel_default as EquipmentPanel, ErrorBoundary, FLOOR_WALL_GAP, FROSTED_CRYSTAL_GLOW, Facts, FlightInterrupted, FormField_default as FormField, Frame_default as Frame, FrameRegionOverlay, GenerateButton, GlassButton_default as GlassButton, HealthStrip_default as HealthStrip, HeatmapFloorView, HeatmapTuningPanel, HeroMetricDropdown_default as HeroMetricDropdown, HierarchyEntityRow, HierarchyTreeRows, HoverTip, IDENTIFIED_SCORE_FOOTNOTE, IDENTIFIED_SCORE_NOTHING, IDENTIFY_ANSWERS, IDENTIFY_NAMES_NOTE, INTER_FONT_FAMILY, IconDisc, IdentifiedScoreCard, IdentifyCard, IdentifyPlanPicker, IdentifyProductField, ImportErrorsList, IncompleteTargetData, Indicator_default as Indicator, KindGlyph, LINK_FLASH_MS, LIST_ROW_STATUS_LOOK, LOCAL_FLIGHT_DURATION, LabelHeader_default as LabelHeader, LabeledThing, Labels_default as Labels, LegalDocumentBody_default as LegalDocumentBody, LegalDocumentView_default as LegalDocumentView, LegalLayout_default as LegalLayout, LightsAndShadows, ListGroup_default as ListGroup, LogOut_default as LogOut, LookupSheetButton, MACHINE_LOOK_PROGRAM_KEY, MACHINE_MATERIAL, MAKERS_IN_TWIN, MAKER_VALUE_PREFIX, MAPBOX_FLIGHT_DURATION, MATCHES, MODEL_PICKER_EXACT_MATCH, MODEL_PICKER_FILTER, MainNav_default as MainNav, ManageUsers_default as ManageUsers, Maria_default as Maria, MariaHeader_default as MariaHeader, MessageBar_default as MessageBar, ModeDropdown_default as ModeDropdown, ModelSquare, MonthStepper_default as MonthStepper, NONE_GIVEN, NOT_TRACKED_NOTE, NOT_TRACKED_OPTION_LABEL, NOT_TRACKED_VALUE, NO_CAPACITY, NO_SUGGESTIONS, NoOrgContext, NotTracked, NotTrackedMaterial, NotificationPanel_default as NotificationPanel, NotificationsHeader_default as NotificationsHeader, NotificationsTable_default as NotificationsTable, NotificationsWindow_default as NotificationsWindow, OnboardingPanel_default as OnboardingPanel, OnboardingWrapper_default as OnboardingWrapper, OutlineDashed, OutlineSolid, PANEL_REGISTRY, PARTLY_MEASURED_SUMMARY, PICKER_GROUP, Pagination_default as Pagination, Panel_default as Panel, PanelCard_default as PanelCard, PanelFallback, PasswordRequirements_default as PasswordRequirements, Permissioned_default as Permissioned, PlatformHealthTree_default as PlatformHealthTree, PostProcessChain, PostProcesses, PrimaryButton_default as PrimaryButton, ProfileForm_default as ProfileForm, REFUSED_SAVE_TITLE, ROW_MOTION_ARRIVED_ATTR, ROW_MOTION_ARRIVED_MS, ROW_MOTION_GAP_CLASS, ROW_MOTION_KEY_ATTR, ROW_STATE_LOOK, RegisterDriftLines, RegisterWriteBanners, RemoveAllAssetsDialog_default as RemoveAllAssetsDialog, RemoveAllButton, RowGrip, RowNote, KIND_ICON as SPACE_KIND_ICON, STATE_CHIP, SUB_LOOK, SUPPORTED_SCHEMA_VERSIONS, SecondaryButton_default as SecondaryButton, SectionHeader_default as SectionHeader, SelectionOutlines, Sidebar_default as Sidebar, SinglePanelLayout_default as SinglePanelLayout, StatPanel, StatusBadge_default as StatusBadge, StepGuide, StepHint, Steps_default as Steps, Subtitle_default as Subtitle, TEMP_ASSET_MODEL_NAME, TLAccordion_default as TLAccordion, TLAdminData_default as TLAdminData, TLAdminInput_default as TLAdminInput, TLAdminSelect_default as TLAdminSelect, TLAdminSwitch_default as TLAdminSwitch, TLAvatar_default as TLAvatar, TLCard_default as TLCard, TLDialog_default as TLDialog, TLFilter_default as TLFilter, TLFilterClearPill_default as TLFilterClearPill, TLFilterPill_default as TLFilterPill, TLInput_default as TLInput, TLLink_default as TLLink, TLPromptInput_default as TLPromptInput, TLSearch_default as TLSearch, TLSpinner_default as TLSpinner, TLSpinnerPage_default as TLSpinnerPage, TLSwitcher_default as TLSwitcher, TLTabList_default as TLTabList, TYPE_A_MANUFACTURER, TableActions_default as TableActions, TableActionsMenu_default as TableActionsMenu, TagSwitcher_default as TagSwitcher, TextPanel, ThresholdAlertIndividualView_default as ThresholdAlertIndividualView, Timeline_default as Timeline, TimelineIndicator_default as TimelineIndicator, Tooltip, Tracked, TrackedHeroDonut, TwinMarkers_default as TwinMarkers, TwinSelector_default as TwinSelector, UNCONFIRMED_SAVE_TITLE, UnknownBid, UnknownTargetKind, UntrackedHeroDonut, UsersTable_default as UsersTable, ValidationPipeline_default as ValidationPipeline, Vector2ToVector3, VideoIcon, Wall, WeekStepper_default as WeekStepper, WindMaterial, allocateEntrances, batchTitle, bbToFixed, bindingIdentity, brandMixRows, buildFloorShape, buildHeatmapValues, buildHierarchyTree, buildInScopeColorModes, buildPatch, cameraWallFeedMatches, cameraWallInPlacement, cameraWallShownFeeds, catalogueReferenceOf, checkModelExists, chunkIds, clearModelExistenceCache, collectAdoptionDiagnostics, compareCameraWallFeeds, configureGLTFDecoders, convertCoordLocalPoint, convertPlanToTwin, convertTwinToPlan, coordLocalOutlineToVector2, coordLocalToVector2, createFilterPath4 as createFilterPath, createFilterPathFromLineage, createFixtureDataProvider, createPlaceholderGeometry, createPlaceholderHitBox, dataFor, defaultColours, degreesToRadians, deriveColorMode, determineVisibility, disposeMaterial, disposeMesh, disposeScene, downloadManager, drawPoint, dropTargetLook, expandOutline, explainMatrix4, extrudeSettingsArea, extrudeSettingsInternalSiteBoundaryWall, extrudeSettingsWall, findLatestDesign, fixtureDataProvider, floorGroupTransform, floorWallOutlines, flyToTarget, formatFmlValidationErrors, formatIndicatorValue, getAreaOutlineShape, getCachedModelExistence, getCentre, getMenuHovered, getMeshFromGltf, getPanelComponent, getPolygonCentroid, getRelevantFilters, getSecureFileURL, getSelectionCriteria, groupCaption, groupedOptions, guessedMaker, rowPropsEqual as hierarchyRowPropsEqual, identifiedScoreLine, identifiedTitle, identifyTitle, isMesh, isNullOrUndefined, isThumbnailRunActive, isValidModelFilename, isValidModelURL, isValidResult, json, legacyRankedOptions, listRowLook, log, lookupRefids, machineBox, machineLook, machineMesh, machinePlacement, machinePlacementKey, makeLineGeometry, makerOptions, makersOnOtherTwinsCaption, matrix4ToColumnMajorFixed, matrix4ToRowMajorFixed, modelManager, modelPickerEmptyText, newIdempotencyKey, notTrackedDetail, nothingMeasuredNote, otherTwinsCaption, ownCamerasReason, parseCustomName, parseInventory, parseLatLong, parseOrientation, partlyMeasuredLaunchNote, patchMachineLook, planFloorEntity, planIdentifyNote, planIdentifyProducts, planIdentifySub, planIdentifyTitle, planIdentifyToastSub, planMachineEntity, planProductMeta, planWallEntity, prefersReducedMotion, productLinesOf, quaternionToFixed, rankManufacturers, readCameraStart, listOf as removeAllListOf, plural3 as removeAllPlural, removeAllReturnFocus, resolveBinding, resolveControlRef, resolveMapLocationAndCamera, resolvePanelComponent, rowArrivedLook, rowMotionGapLook, rowState, rowStateLookOf, scrollWithin, seedControlState, seedText, shiftLatLongByMetres, sizeToFixed, sortMappings, withArticle as spaceKindWithArticle, splitWall, toCameraPosition, toCatalogueQuery, toInitialViewState, topLevelTypeFor, twinSetupPath, undoneTitle, updateProgressFactory, useCameraWallFeeds, useClickOutside, useConfirm, useDataWarning, useDragPosition, useFrameZoom, useHeroIndicator, useIdentifyGroup, useIdentifyPicker, useKeepFocusAcrossMove, useLastUrlSegment, useModelPickerOptions, useNotTrackedAction, useOpenTwin, usePlanIdentifyPicker, usePresence, useQueryParams, useReloadOnCapture, useRequireAuthMetadata, useRowMotion, useRowMotionAnnouncement, useRowProductChange, useStepValidation, useTableSort, useThumbnailRun, validateCompositeForm, validateFML, vec3ToFixed, visuallyHidden, wallMaterial, warnCompositeForm };
